/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * API Árvore
 * OpenAPI spec version: 1.0
 */
import { customInstance } from './lib/api-instance'
export interface HealthCheckResponseDto {
  /** Health check message */
  message: string
  /** Current timestamp */
  timestamp: string
  /** Service status */
  status: string
}

/**
 * Always null for now (no social_name column in the users table yet).
 * @nullable
 */
export type ProfileResponseDtoSocialName = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoCpf = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoBirthDate = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoAccessToken = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoGender = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoZipCode = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoState = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoAddress = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoNeighborhood = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ProfileResponseDtoCity = { [key: string]: unknown } | null

export interface ProfileResponseDto {
  name: string
  /**
   * Always null for now (no social_name column in the users table yet).
   * @nullable
   */
  socialName: ProfileResponseDtoSocialName
  email: string
  /** @nullable */
  cpf: ProfileResponseDtoCpf
  /** @nullable */
  birthDate: ProfileResponseDtoBirthDate
  canLoginWithToken: boolean
  /** @nullable */
  accessToken: ProfileResponseDtoAccessToken
  /** @nullable */
  gender: ProfileResponseDtoGender
  /** @nullable */
  zipCode: ProfileResponseDtoZipCode
  /** @nullable */
  state: ProfileResponseDtoState
  /** @nullable */
  address: ProfileResponseDtoAddress
  /** @nullable */
  neighborhood: ProfileResponseDtoNeighborhood
  /** @nullable */
  city: ProfileResponseDtoCity
}

export interface UpdateProfileDto {
  /** User full name */
  name?: string
  /** Social name. Accepted by the API but not persisted yet (no social_name column in the users table). See backend notes. */
  socialName?: string
  /** Phone number */
  phone?: string
  /** WhatsApp number */
  whatsappNumber?: string
  /** Gender */
  gender?: string
  /** ZIP code (CEP) */
  zipCode?: string
  /** State (UF) */
  state?: string
  /** Street address */
  address?: string
  /** Neighborhood */
  neighborhood?: string
  /** City */
  city?: string
}

/**
 * @nullable
 */
export type UpdateProfileResponseDtoName = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type UpdateProfileResponseDtoPhone = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type UpdateProfileResponseDtoCity = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type UpdateProfileResponseDtoState = { [key: string]: unknown } | null

export interface UpdateProfileResponseDto {
  id: number
  /** @nullable */
  name: UpdateProfileResponseDtoName
  email: string
  /** @nullable */
  phone: UpdateProfileResponseDtoPhone
  /** @nullable */
  city: UpdateProfileResponseDtoCity
  /** @nullable */
  state: UpdateProfileResponseDtoState
}

export interface ChangePasswordDto {
  /** The user current password (for verification) */
  currentPassword: string
  /**
   * The new password
   * @minLength 8
   */
  newPassword: string
}

export interface ChangePasswordResponseDto {
  ok: boolean
}

export type JobDescriptionResponseDtoJobPositionsItem =
  typeof JobDescriptionResponseDtoJobPositionsItem[keyof typeof JobDescriptionResponseDtoJobPositionsItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobDescriptionResponseDtoJobPositionsItem = {
  TEACHER: 'TEACHER',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  PRINCIPAL: 'PRINCIPAL',
  ASSISTANT_OR_INTERN: 'ASSISTANT_OR_INTERN',
  FINANCIAL: 'FINANCIAL',
  LIBRARIAN: 'LIBRARIAN',
  EDUCATIONAL_TECHNOLOGY: 'EDUCATIONAL_TECHNOLOGY',
  SCHOOL_SUPPORT: 'SCHOOL_SUPPORT',
  PEDAGOGICAL_ADVISOR: 'PEDAGOGICAL_ADVISOR',
  IT: 'IT',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  COORDINATOR: 'COORDINATOR'
} as const

export type JobDescriptionResponseDtoJobAreasItem =
  typeof JobDescriptionResponseDtoJobAreasItem[keyof typeof JobDescriptionResponseDtoJobAreasItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobDescriptionResponseDtoJobAreasItem = {
  LANGUAGES_AND_COMMUNICATION: 'LANGUAGES_AND_COMMUNICATION',
  TECHNOLOGY_AND_INNOVATION: 'TECHNOLOGY_AND_INNOVATION',
  EXPRESSIONS_AND_BODY: 'EXPRESSIONS_AND_BODY',
  HUMAN_SCIENCES: 'HUMAN_SCIENCES',
  FOREIGN_LANGUAGE: 'FOREIGN_LANGUAGE',
  PERSONAL_DEVELOPMENT: 'PERSONAL_DEVELOPMENT',
  MATHEMATICS_AND_TECHNOLOGIES: 'MATHEMATICS_AND_TECHNOLOGIES',
  NATURAL_SCIENCES: 'NATURAL_SCIENCES'
} as const

export interface JobDescriptionResponseDto {
  /** User job positions. Roles/permissions are exposed via GET /users/me. */
  jobPositions: JobDescriptionResponseDtoJobPositionsItem[]
  /** User job areas */
  jobAreas: JobDescriptionResponseDtoJobAreasItem[]
}

export type QualifyJobDescriptionDtoJobPositionsItem =
  typeof QualifyJobDescriptionDtoJobPositionsItem[keyof typeof QualifyJobDescriptionDtoJobPositionsItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyJobDescriptionDtoJobPositionsItem = {
  TEACHER: 'TEACHER',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  PRINCIPAL: 'PRINCIPAL',
  ASSISTANT_OR_INTERN: 'ASSISTANT_OR_INTERN',
  FINANCIAL: 'FINANCIAL',
  LIBRARIAN: 'LIBRARIAN',
  EDUCATIONAL_TECHNOLOGY: 'EDUCATIONAL_TECHNOLOGY',
  SCHOOL_SUPPORT: 'SCHOOL_SUPPORT',
  PEDAGOGICAL_ADVISOR: 'PEDAGOGICAL_ADVISOR',
  IT: 'IT',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  COORDINATOR: 'COORDINATOR'
} as const

export type QualifyJobDescriptionDtoJobAreasItem =
  typeof QualifyJobDescriptionDtoJobAreasItem[keyof typeof QualifyJobDescriptionDtoJobAreasItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyJobDescriptionDtoJobAreasItem = {
  LANGUAGES_AND_COMMUNICATION: 'LANGUAGES_AND_COMMUNICATION',
  TECHNOLOGY_AND_INNOVATION: 'TECHNOLOGY_AND_INNOVATION',
  EXPRESSIONS_AND_BODY: 'EXPRESSIONS_AND_BODY',
  HUMAN_SCIENCES: 'HUMAN_SCIENCES',
  FOREIGN_LANGUAGE: 'FOREIGN_LANGUAGE',
  PERSONAL_DEVELOPMENT: 'PERSONAL_DEVELOPMENT',
  MATHEMATICS_AND_TECHNOLOGIES: 'MATHEMATICS_AND_TECHNOLOGIES',
  NATURAL_SCIENCES: 'NATURAL_SCIENCES'
} as const

export interface QualifyJobDescriptionDto {
  /** Job positions array */
  jobPositions: QualifyJobDescriptionDtoJobPositionsItem[]
  /** Job areas array (optional) */
  jobAreas?: QualifyJobDescriptionDtoJobAreasItem[]
}

export interface NotificationPreferencesResponseDto {
  /** Whether the user receives the weekly reading report email */
  weeklyReadingReport: boolean
}

/**
 * The notification preference to toggle
 */
export type ToggleNotificationPreferenceDtoType =
  typeof ToggleNotificationPreferenceDtoType[keyof typeof ToggleNotificationPreferenceDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ToggleNotificationPreferenceDtoType = {
  WEEKLY_READING_REPORT: 'WEEKLY_READING_REPORT'
} as const

export interface ToggleNotificationPreferenceDto {
  /** The notification preference to toggle */
  type: ToggleNotificationPreferenceDtoType
}

export interface TokenBodyDto {
  /** Grant type */
  grant_type: string
  /** Authorization code */
  code: string
  /** Client ID */
  client_id: string
  /** Client secret (optional for public clients using PKCE) */
  client_secret?: string
  /** Redirect URI */
  redirect_uri: string
  /** PKCE code verifier */
  code_verifier?: string
  /** Resource indicator (RFC 8707) - target audience for the token */
  resource?: string
}

export interface TokenResponseDto {
  /** Access token (JWT) */
  access_token: string
  /** ID token (JWT) */
  id_token: string
  /** Token type */
  token_type: string
  /** Token expiration in seconds */
  expires_in: number
}

export interface ExchangeTokenBodyDto {
  /** Fixed value per RFC 8693 */
  grant_type: string
  /** The identity access_token or id_token to exchange */
  subject_token: string
  /** Type of the subject token */
  subject_token_type?: string
}

export interface ExchangeTokenResponseDto {
  /** Árvore legacy JWT for GraphQL API */
  access_token: string
  /** Type of the issued token */
  issued_token_type: string
  /** Token type */
  token_type: string
  /** Token expiration in seconds */
  expires_in: number
}

export interface LoginBodyDto {
  /** User login (email, phone, or username) */
  login: string
  /** User password */
  password: string
  /** OAuth client ID for brand routing (superautor or arvore) */
  clientId: string
}

export interface LoginResponseDto {
  /** Login success status */
  ok: boolean
}

export interface SessionResponseDto {
  /** Whether user is authenticated */
  authenticated: boolean
  /** User global ID */
  user_id?: string
  /** User email */
  email?: string
  /** User name */
  name?: string
}

export interface AccessTokenLoginBodyDto {
  /** User access token or super_codigo for passwordless login */
  token: string
  /** OAuth client ID for brand routing (superautor or arvore) */
  clientId: string
}

export interface ForgotPasswordBodyDto {
  /** User email or phone number */
  emailOrPhone: string
  /** OAuth client ID to determine brand */
  clientId?: string
  /** URL to redirect after password reset (appended to reset link) */
  redirectUrl?: string
}

export interface ForgotPasswordResponseDto {
  /** Request success status */
  ok: boolean
  /** Method used: email or sms */
  method?: string
}

export interface ResetPasswordBodyDto {
  /** Password reset token (for email reset) */
  token?: string
  /** SMS code (for SMS reset) */
  code?: string
  /** Phone number (required for SMS reset) */
  phone?: string
  /**
   * New password
   * @minLength 8
   */
  password: string
}

export interface ResetPasswordResponseDto {
  /** Password reset success status */
  ok: boolean
}

export interface TokenExchangeBodyDto {
  /** User token (api_token for Árvore users). Identifier type is inferred from the authenticated OAuth client. */
  token?: string
  /** Identity user ID for Super clients. Identifier type is inferred from the authenticated OAuth client. */
  identityId?: string
  /** User ID from the source system. */
  userId?: number
  /** OAuth callback URL of the calling system. Must match one of the registered redirect URIs for the OAuth client. */
  redirectUri: string
  /** Path to redirect the user after login */
  redirectPath?: string
}

export interface TokenExchangeResponseDto {
  /** Grant URL to redirect the user to. Sets Identity session cookie and redirects to the OAuth callback. */
  grantUrl: string
}

export interface GoogleOneTapBodyDto {
  /** Google ID token (JWT credential from One Tap) */
  credential: string
  /** OAuth client ID for brand routing */
  clientId: string
}

export type TeacherClassItemDtoDegree = { [key: string]: unknown }

export type TeacherClassItemDtoIdentityId = { [key: string]: unknown }

export interface TeacherClassItemDto {
  entity_id: number
  name: string
  degree?: TeacherClassItemDtoDegree
  identity_id?: TeacherClassItemDtoIdentityId
}

export interface TeacherClassesResponseDto {
  classes: TeacherClassItemDto[]
}

export type ClassStudentItemDtoIdentityId = { [key: string]: unknown }

export interface ClassStudentItemDto {
  name: string
  email: string
  identity_id?: ClassStudentItemDtoIdentityId
  active: boolean
}

export interface ClassStudentsResponseDto {
  students: ClassStudentItemDto[]
}

export interface ClassSyncResponseDto {
  synced: number
}

export type SearchEntitySyncItemDtoEntityType =
  typeof SearchEntitySyncItemDtoEntityType[keyof typeof SearchEntitySyncItemDtoEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchEntitySyncItemDtoEntityType = {
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type SearchEntitySyncItemDtoSource = { [key: string]: unknown }

export type SearchEntitySyncItemDtoIdentityId = { [key: string]: unknown }

export type SearchEntitySyncItemDtoDegree = { [key: string]: unknown }

export interface SearchEntitySyncItemDto {
  id: number
  name: string
  entity_type: SearchEntitySyncItemDtoEntityType
  source: SearchEntitySyncItemDtoSource
  identity_id?: SearchEntitySyncItemDtoIdentityId
  degree?: SearchEntitySyncItemDtoDegree
}

export interface SearchEntitySyncResponseDto {
  items: SearchEntitySyncItemDto[]
}

export type SchoolClassItemDtoDegree = { [key: string]: unknown }

export type SchoolClassItemDtoIdentityId = { [key: string]: unknown }

export interface SchoolClassItemDto {
  entity_id: number
  name: string
  degree?: SchoolClassItemDtoDegree
  identity_id?: SchoolClassItemDtoIdentityId
}

export interface ListSchoolClassesResponseDto {
  classes: SchoolClassItemDto[]
}

export type GetEntitySyncItemDtoEntityType =
  typeof GetEntitySyncItemDtoEntityType[keyof typeof GetEntitySyncItemDtoEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEntitySyncItemDtoEntityType = {
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type GetEntitySyncItemDtoIdentityId = { [key: string]: unknown }

export type GetEntitySyncItemDtoDegree = { [key: string]: unknown }

export type GetEntitySyncItemDtoOrigin = { [key: string]: unknown }

export interface GetEntitySyncItemDto {
  id: number
  name: string
  entity_type: GetEntitySyncItemDtoEntityType
  identity_id?: GetEntitySyncItemDtoIdentityId
  degree?: GetEntitySyncItemDtoDegree
  origin?: GetEntitySyncItemDtoOrigin
}

export interface GetEntitySyncResponseDto {
  item?: GetEntitySyncItemDto
}

export type SyncEntityBidirectionalBodyDtoEntityType =
  typeof SyncEntityBidirectionalBodyDtoEntityType[keyof typeof SyncEntityBidirectionalBodyDtoEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncEntityBidirectionalBodyDtoEntityType = {
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type SyncEntityBidirectionalBodyDtoSource =
  typeof SyncEntityBidirectionalBodyDtoSource[keyof typeof SyncEntityBidirectionalBodyDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncEntityBidirectionalBodyDtoSource = {
  arvore: 'arvore',
  super: 'super'
} as const

export interface SyncEntityBidirectionalBodyDto {
  entity_type: SyncEntityBidirectionalBodyDtoEntityType
  source: SyncEntityBidirectionalBodyDtoSource
}

export interface SyncEntityResponseDto {
  queued: boolean
}

export interface EmailHealthDetailsDto {
  /** Whether SendGrid is configured */
  sendgridConfigured: boolean
  /** Whether test email was sent successfully */
  testEmailSent: boolean
  /** SendGrid message ID */
  messageId?: string
  /** Error message if health check failed */
  error?: string
  /** Response time in milliseconds */
  responseTime: number
}

/**
 * Health check status
 */
export type EmailHealthResponseDtoStatus =
  typeof EmailHealthResponseDtoStatus[keyof typeof EmailHealthResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailHealthResponseDtoStatus = {
  healthy: 'healthy',
  unhealthy: 'unhealthy'
} as const

export interface EmailHealthResponseDto {
  /** Health check status */
  status: EmailHealthResponseDtoStatus
  /** Timestamp of health check */
  timestamp: string
  /** Detailed health check information */
  details: EmailHealthDetailsDto
}

export interface ProvisionDemoLoginsBodyDto {
  premiumQuantity?: number
  plusQuantity?: number
  restritoQuantity?: number
  adventistaQuantity?: number
  protestanteQuantity?: number
  dryRun?: boolean
}

export interface ProvisionDemoLoginsResponseDto {
  fileName: string
  csvContent: string
  total: number
  premium: number
  plus: number
  restrito: number
  adventista: number
  protestante: number
  dryRun: boolean
}

export interface ServiceProvisionDemoLoginsBodyDto {
  quantity?: number
  dryRun?: boolean
}

export interface CreateDebugSessionBodyDto {
  /** Target app URL where the debug session will run */
  targetUrl: string
}

/**
 * Stream type
 */
export type ChunkUrlBodyDtoStream =
  typeof ChunkUrlBodyDtoStream[keyof typeof ChunkUrlBodyDtoStream]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChunkUrlBodyDtoStream = {
  data: 'data',
  video: 'video'
} as const

export interface ChunkUrlBodyDto {
  /** Unique page identifier within the session */
  pageId: string
  /** Stream type */
  stream: ChunkUrlBodyDtoStream
  /**
   * Sequence number of the chunk
   * @minimum 0
   */
  seq: number
}

/**
 * Page metadata (url, title, environment, etc.)
 */
export type SaveMetaBodyDtoMeta = { [key: string]: unknown }

export interface SaveMetaBodyDto {
  /** Unique page identifier within the session */
  pageId: string
  /** Page metadata (url, title, environment, etc.) */
  meta: SaveMetaBodyDtoMeta
}

/**
 * Conteúdo completo do relatório da Experiência EBR (KPIs, funis, unidades, etc.)
 */
export type GetReportResponseDtoPayload = { [key: string]: unknown }

export interface GetReportResponseDto {
  /** ID da escola (entidade) */
  schoolId: number
  /** Nome da escola */
  schoolName: string
  /** Data de referência do relatório */
  referenceDate: string
  /** Conteúdo completo do relatório da Experiência EBR (KPIs, funis, unidades, etc.) */
  payload: GetReportResponseDtoPayload
}

/**
 * Frequência ideal de uso
 */
export type CreateFeedbackRequestDtoFrequency =
  typeof CreateFeedbackRequestDtoFrequency[keyof typeof CreateFeedbackRequestDtoFrequency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateFeedbackRequestDtoFrequency = {
  semanal: 'semanal',
  quinzenal: 'quinzenal',
  mensal: 'mensal',
  professor: 'professor'
} as const

/**
 * Contribuição para os objetivos pedagógicos
 */
export type CreateFeedbackRequestDtoPedagogicalGoals =
  typeof CreateFeedbackRequestDtoPedagogicalGoals[keyof typeof CreateFeedbackRequestDtoPedagogicalGoals]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateFeedbackRequestDtoPedagogicalGoals = {
  muito: 'muito',
  parcial: 'parcial',
  pouco: 'pouco',
  nao: 'nao'
} as const

export interface CreateFeedbackRequestDto {
  /** ID da escola (entidade) avaliada */
  schoolId: number
  /** Frequência ideal de uso */
  frequency?: CreateFeedbackRequestDtoFrequency
  /**
   * NPS de 0 a 10
   * @minimum 0
   * @maximum 10
   */
  nps?: number
  /** Resposta aberta exibida quando o NPS é até 7 */
  npsComment?: string
  /** Contribuição para os objetivos pedagógicos */
  pedagogicalGoals?: CreateFeedbackRequestDtoPedagogicalGoals
  /** Resposta aberta exibida quando a contribuição é baixa */
  pedagogicalGoalsComment?: string
}

export interface CreateFeedbackResponseDto {
  /** ID da resposta de feedback registrada */
  id: number
}

export interface CreateRenewalInterestsRequestDto {
  /** ID da escola (entidade) avaliada */
  schoolId: number
  /** Interesses de renovação selecionados, com o texto exato de cada opção escolhida */
  interests: string[]
}

export interface CreateRenewalInterestsResponseDto {
  /** ID do registro de interesses de renovação */
  id: number
}

export interface AuditActorDto {
  userId?: string
  username?: string
  isAdmin?: boolean
  identifier?: string
}

export interface AuditRequestContextDto {
  ip: string
  userAgent: string
  referer?: string
  origin?: string
  sessionId?: string
}

/**
 * @nullable
 */
export type AuditEventDtoRequestBody = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type AuditEventDtoResponseBody = { [key: string]: unknown } | null

export interface AuditEventDto {
  pk: string
  sk: string
  eventId: string
  eventName: string
  category: string
  method: string
  path: string
  statusCode: number
  timestamp: number
  yearMonth: string
  durationMs: number
  actor: AuditActorDto
  requestContext: AuditRequestContextDto
  /** @nullable */
  requestBody?: AuditEventDtoRequestBody
  /** @nullable */
  responseBody?: AuditEventDtoResponseBody
}

export interface ListAuditEventsResponseDto {
  items: AuditEventDto[]
  /** @nullable */
  nextCursor: string | null
  count: number
}

export interface CategoryCountDto {
  category: string
  count: number
}

export interface AuditStatsResponseDto {
  totalEvents: number
  uniqueUsers: number
  errorCount: number
  topCategories: CategoryCountDto[]
}

/**
 * @nullable
 */
export type IpInfoResponseDtoCity = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type IpInfoResponseDtoRegion = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type IpInfoResponseDtoCountry = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type IpInfoResponseDtoTimezone = { [key: string]: unknown } | null

export interface IpInfoResponseDto {
  ip: string
  found: boolean
  /** @nullable */
  city?: IpInfoResponseDtoCity
  /** @nullable */
  region?: IpInfoResponseDtoRegion
  /** @nullable */
  country?: IpInfoResponseDtoCountry
  /** @nullable */
  timezone?: IpInfoResponseDtoTimezone
}

export interface CreateFeatureBodyDto {
  /** Unique key for the feature */
  key: string
  /** Display name of the feature */
  name: string
  /** Feature description */
  description?: string
}

export interface AddTeamToFeatureBodyDto {
  /** Team ID to link to the feature */
  teamId: number
}

export interface PublisherItemDto {
  /** Publisher ID */
  id: number
  /**
   * Publisher name
   * @nullable
   */
  name: string | null
  /**
   * Discount percentage (e.g. 0.10 = 10%)
   * @nullable
   */
  discount: string | null
}

export interface ListPublishersResponseDto {
  /** List of publishers */
  publishers: PublisherItemDto[]
  /** Total number of publishers */
  total: number
}

export interface QueueBooksResponseDto {
  /** Publisher ID */
  publisherId: number
  /** Publisher name */
  publisherName: string
  /** Total books queued for processing */
  totalQueued: number
  /** Number of rows skipped (empty ISBN) */
  skipped: number
  /** List of skipped ISBNs */
  skippedIsbns: string[]
}

export interface CreatePublisherDto {
  [key: string]: unknown
}

export interface UploadUrlRequestDto {
  [key: string]: unknown
}

export interface ConfirmUploadDto {
  [key: string]: unknown
}

/**
 * Device platform
 */
export type RegisterPushTokenBodyDtoPlatform =
  typeof RegisterPushTokenBodyDtoPlatform[keyof typeof RegisterPushTokenBodyDtoPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterPushTokenBodyDtoPlatform = {
  ios: 'ios',
  android: 'android'
} as const

export interface RegisterPushTokenBodyDto {
  /** Expo push token */
  token: string
  /** Device platform */
  platform: RegisterPushTokenBodyDtoPlatform
  /** Optional device identifier */
  deviceId?: string
}

/**
 * Device platform
 */
export type RegisterPushTokenResponseDtoPlatform =
  typeof RegisterPushTokenResponseDtoPlatform[keyof typeof RegisterPushTokenResponseDtoPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterPushTokenResponseDtoPlatform = {
  ios: 'ios',
  android: 'android'
} as const

export interface RegisterPushTokenResponseDto {
  /** Push token ID */
  id: string
  /** User ID */
  userId: number
  /** Expo push token */
  expoToken: string
  /** Device platform */
  platform: RegisterPushTokenResponseDtoPlatform
  /** Whether the token is active */
  isActive: boolean
  /** Creation timestamp */
  createdAt: string
}

export interface HasActivePushTokenResponseDto {
  /** Whether the current user has an active push token registered */
  hasActivePushToken: boolean
}

export type PushNotificationFiltersDtoUserType =
  typeof PushNotificationFiltersDtoUserType[keyof typeof PushNotificationFiltersDtoUserType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PushNotificationFiltersDtoUserType = {
  student: 'student',
  teacher: 'teacher',
  all: 'all'
} as const

export interface PushNotificationFiltersDto {
  includedRootIds?: number[]
  excludedRootIds?: number[]
  includedEntityIds?: number[]
  excludedEntityIds?: number[]
  includedUserIds?: number[]
  userType?: PushNotificationFiltersDtoUserType
  grades?: string[]
  collections?: string[]
  segments?: string[]
}

/**
 * Extra data for deep linking
 */
export type SendPushNotificationBodyDtoData = { [key: string]: unknown }

/**
 * Notification channel
 */
export type SendPushNotificationBodyDtoChannels =
  typeof SendPushNotificationBodyDtoChannels[keyof typeof SendPushNotificationBodyDtoChannels]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendPushNotificationBodyDtoChannels = {
  push_only: 'push_only',
  in_app_only: 'in_app_only',
  both: 'both'
} as const

export interface SendPushNotificationBodyDto {
  /**
   * Notification title
   * @maxLength 100
   */
  title: string
  /**
   * Notification body
   * @maxLength 500
   */
  body: string
  /** Extra data for deep linking */
  data?: SendPushNotificationBodyDtoData
  /** User filters */
  filters?: PushNotificationFiltersDto
  /** Notification channel */
  channels?: SendPushNotificationBodyDtoChannels
  /** Schedule notification for a specific time */
  scheduledAt?: string
}

export interface SendPushNotificationResponseDto {
  /** Notification ID */
  id: string
  /** Success message */
  message: string
  /** Number of targeted users */
  targetedUsers: number
  /** Number of successful deliveries */
  success: number
  /** Number of failed deliveries */
  failed: number
}

export interface SentByDto {
  /** Admin user ID */
  id: string
  /** Admin user name */
  name: string
}

/**
 * User filters applied
 */
export type PushNotificationItemDtoFilters = { [key: string]: unknown }

/**
 * Notification status
 */
export type PushNotificationItemDtoStatus =
  typeof PushNotificationItemDtoStatus[keyof typeof PushNotificationItemDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PushNotificationItemDtoStatus = {
  pending: 'pending',
  sending: 'sending',
  completed: 'completed',
  failed: 'failed'
} as const

/**
 * When the notification was sent
 */
export type PushNotificationItemDtoSentAt = { [key: string]: unknown }

export interface PushNotificationItemDto {
  /** Notification ID */
  id: string
  /** Notification title */
  title: string
  /** Notification body */
  body: string
  /** User filters applied */
  filters?: PushNotificationItemDtoFilters
  /** Total users targeted */
  totalTargeted: number
  /** Total successful deliveries */
  totalSuccess: number
  /** Total failed deliveries */
  totalFailed: number
  /** Notification status */
  status: PushNotificationItemDtoStatus
  /** Admin who sent the notification */
  sentBy?: SentByDto
  /** When the notification was sent */
  sentAt?: PushNotificationItemDtoSentAt
  /** When the notification was created */
  createdAt: string
}

export interface PaginationMetaDto {
  /** Total number of items */
  total: number
  /** Current page */
  page: number
  /** Items per page */
  limit: number
  /** Total number of pages */
  totalPages: number
}

export interface ListPushNotificationsResponseDto {
  /** List of notifications */
  data: PushNotificationItemDto[]
  /** Pagination metadata */
  meta: PaginationMetaDto
}

/**
 * Extra data for deep linking
 */
export type PushNotificationDetailsResponseDtoData = { [key: string]: unknown }

/**
 * User filters applied
 */
export type PushNotificationDetailsResponseDtoFilters = {
  [key: string]: unknown
}

/**
 * Notification status
 */
export type PushNotificationDetailsResponseDtoStatus =
  typeof PushNotificationDetailsResponseDtoStatus[keyof typeof PushNotificationDetailsResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PushNotificationDetailsResponseDtoStatus = {
  pending: 'pending',
  sending: 'sending',
  completed: 'completed',
  failed: 'failed'
} as const

/**
 * Scheduled send time
 */
export type PushNotificationDetailsResponseDtoScheduledAt = {
  [key: string]: unknown
}

/**
 * When the notification was sent
 */
export type PushNotificationDetailsResponseDtoSentAt = {
  [key: string]: unknown
}

export interface PushNotificationDetailsResponseDto {
  /** Notification ID */
  id: string
  /** Notification title */
  title: string
  /** Notification body */
  body: string
  /** Extra data for deep linking */
  data?: PushNotificationDetailsResponseDtoData
  /** User filters applied */
  filters?: PushNotificationDetailsResponseDtoFilters
  /** Total users targeted */
  totalTargeted: number
  /** Total successful deliveries */
  totalSuccess: number
  /** Total failed deliveries */
  totalFailed: number
  /** Notification status */
  status: PushNotificationDetailsResponseDtoStatus
  /** Admin who sent the notification */
  sentBy?: SentByDto
  /** Scheduled send time */
  scheduledAt?: PushNotificationDetailsResponseDtoScheduledAt
  /** When the notification was sent */
  sentAt?: PushNotificationDetailsResponseDtoSentAt
  /** When the notification was created */
  createdAt: string
  /** When the notification was last updated */
  updatedAt: string
}

export type CreateNotificationRulesDtoUserType =
  typeof CreateNotificationRulesDtoUserType[keyof typeof CreateNotificationRulesDtoUserType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationRulesDtoUserType = {
  student: 'student',
  teacher: 'teacher',
  all: 'all'
} as const

export interface CreateNotificationRulesDto {
  includedRootIds?: number[]
  excludedRootIds?: number[]
  includedEntityIds?: number[]
  excludedEntityIds?: number[]
  includedUserIds?: number[]
  userType?: CreateNotificationRulesDtoUserType
  grades?: string[]
  collections?: string[]
  segments?: string[]
}

export type CreateNotificationConditionDtoLogicalOperator =
  typeof CreateNotificationConditionDtoLogicalOperator[keyof typeof CreateNotificationConditionDtoLogicalOperator]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationConditionDtoLogicalOperator = {
  AND: 'AND',
  OR: 'OR'
} as const

export type CreateNotificationConditionDtoConditionType =
  typeof CreateNotificationConditionDtoConditionType[keyof typeof CreateNotificationConditionDtoConditionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationConditionDtoConditionType = {
  group: 'group',
  rule: 'rule'
} as const

export type CreateNotificationConditionDtoValue = { [key: string]: unknown }

export interface CreateNotificationConditionDto {
  id?: string
  parentId?: string
  logicalOperator?: CreateNotificationConditionDtoLogicalOperator
  conditionType: CreateNotificationConditionDtoConditionType
  field?: string
  operator?: string
  value?: CreateNotificationConditionDtoValue
  positionX?: number
  positionY?: number
  sortOrder?: number
}

export type CreateNotificationActionDtoActionType =
  typeof CreateNotificationActionDtoActionType[keyof typeof CreateNotificationActionDtoActionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationActionDtoActionType = {
  push_notification: 'push_notification',
  in_app_notification: 'in_app_notification'
} as const

export type CreateNotificationActionDtoDataTemplate = { [key: string]: unknown }

export interface CreateNotificationActionDto {
  id?: string
  actionType: CreateNotificationActionDtoActionType
  titleTemplate?: string
  bodyTemplate?: string
  dataTemplate?: CreateNotificationActionDtoDataTemplate
  positionX?: number
  positionY?: number
  sortOrder?: number
}

export type CreateNotificationEdgeDtoSourceNodeType =
  typeof CreateNotificationEdgeDtoSourceNodeType[keyof typeof CreateNotificationEdgeDtoSourceNodeType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationEdgeDtoSourceNodeType = {
  condition: 'condition',
  action: 'action'
} as const

export type CreateNotificationEdgeDtoTargetNodeType =
  typeof CreateNotificationEdgeDtoTargetNodeType[keyof typeof CreateNotificationEdgeDtoTargetNodeType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationEdgeDtoTargetNodeType = {
  condition: 'condition',
  action: 'action'
} as const

export interface CreateNotificationEdgeDto {
  id?: string
  sourceNodeId: string
  sourceNodeType: CreateNotificationEdgeDtoSourceNodeType
  targetNodeId: string
  targetNodeType: CreateNotificationEdgeDtoTargetNodeType
  label?: string
}

export type CreateNotificationDtoTriggerType =
  typeof CreateNotificationDtoTriggerType[keyof typeof CreateNotificationDtoTriggerType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationDtoTriggerType = {
  scheduled: 'scheduled',
  manual: 'manual'
} as const

export interface CreateNotificationDto {
  /** Workflow name */
  name: string
  /** Workflow description */
  description?: string
  triggerType?: CreateNotificationDtoTriggerType
  /** Cron expression */
  cronExpression?: string
  /** Cooldown in days */
  cooldownDays?: number
  rules?: CreateNotificationRulesDto
  conditions?: CreateNotificationConditionDto[]
  actions?: CreateNotificationActionDto[]
  edges?: CreateNotificationEdgeDto[]
}

export type UpdateNotificationDtoTriggerType =
  typeof UpdateNotificationDtoTriggerType[keyof typeof UpdateNotificationDtoTriggerType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNotificationDtoTriggerType = {
  scheduled: 'scheduled',
  manual: 'manual'
} as const

export interface UpdateNotificationDto {
  /** Workflow name */
  name?: string
  /** Workflow description */
  description?: string
  triggerType?: UpdateNotificationDtoTriggerType
  /** Cron expression */
  cronExpression?: string
  /** Cooldown in days */
  cooldownDays?: number
  rules?: CreateNotificationRulesDto
  conditions?: CreateNotificationConditionDto[]
  actions?: CreateNotificationActionDto[]
  edges?: CreateNotificationEdgeDto[]
}

export type RecommendedBookByLevelDtoName = { [key: string]: unknown }

export type RecommendedBookByLevelDtoAuthor = { [key: string]: unknown }

export type RecommendedBookByLevelDtoSlug = { [key: string]: unknown }

export type RecommendedBookByLevelDtoDegree = { [key: string]: unknown }

export type RecommendedBookByLevelDtoImageUrlThumb = { [key: string]: unknown }

export type RecommendedBookByLevelDtoLanguage = { [key: string]: unknown }

export type RecommendedBookByLevelDtoHasAudioBook = { [key: string]: unknown }

export type RecommendedBookByLevelDtoHasEbook = { [key: string]: unknown }

export interface RecommendedBookByLevelDto {
  name: RecommendedBookByLevelDtoName
  author: RecommendedBookByLevelDtoAuthor
  slug: RecommendedBookByLevelDtoSlug
  degree: RecommendedBookByLevelDtoDegree
  imageUrlThumb: RecommendedBookByLevelDtoImageUrlThumb
  language: RecommendedBookByLevelDtoLanguage
  hasAudioBook: RecommendedBookByLevelDtoHasAudioBook
  hasEbook: RecommendedBookByLevelDtoHasEbook
}

export interface GetRecommendedBooksByLevelResponseDto {
  books: RecommendedBookByLevelDto[]
}

export interface StartReadingFluencyAssessmentDto {
  /** Book snippet ID selected by the teacher */
  snippetId: number
  /** Class entity IDs that will participate in the assessment */
  entitiesIds: number[]
}

export interface StartReadingFluencyAssessmentResponseDto {
  /** Indicates if the assessment was started successfully */
  success: boolean
}

export interface CreateImpersonatedSessionDto {
  /** The ID of the user (student) that will perform the assessment on this device */
  userId: number
}

export interface ImpersonatedSessionUserDto {
  /** User ID */
  id: number
  /** User display name */
  name: string
}

export interface CreateImpersonatedSessionResponseDto {
  /** JWT scoped to the reading fluency student flow, issued for the student */
  token: string
  /** ISO timestamp of when the impersonated session token expires */
  expiresAt: string
  student: ImpersonatedSessionUserDto
  applicator: ImpersonatedSessionUserDto
}

export interface CreateReadingFluencyDto {
  /** Book snippet ID */
  snippetId: number
  /** Class IDs to apply bulk reading fluency */
  entitiesIds: number[]
  /** When true, invalidates previous comprehension quiz answers, results and levels for affected users */
  cancelPreviousAnswers?: boolean
}

export interface CreateReadingFluencyResponseDto {
  /** Created application ID */
  assessmentId: number
  /** Success message */
  message: string
}

export interface ReapplyReadingFluencyDto {
  /** User IDs to reapply reading fluency */
  userIds: number[]
  /** When true, cancels existing audio results and reprocesses audio via SQS */
  reprocessAudio?: boolean
}

export interface CheckReadingFluencyAssessmentAvailableResponseDto {
  /** Indicates if a reading fluency assessment is available */
  available: boolean
  /** Indicates if this is the first assessment of the current year for the user */
  first: boolean
}

export interface BookSnippetBookDto {
  /**
   * Book name
   * @nullable
   */
  name: string | null
  /**
   * Book description
   * @nullable
   */
  description: string | null
  /**
   * Book slug
   * @nullable
   */
  slug: string | null
  /**
   * Book author
   * @nullable
   */
  author: string | null
  /**
   * Book image URL thumbnail
   * @nullable
   */
  imageUrlThumb: string | null
}

export interface QuestionAlternativeDto {
  /** Alternative ID */
  id: number
  /** Alternative letter (A, B, C, etc.) */
  letter: string
  /** Alternative text */
  text: string
  /** Whether this alternative is correct */
  isCorrect: boolean
}

export interface QuestionDto {
  /** Question ID */
  id: number
  /**
   * Question type (LOC, INF, REL, COM)
   * @nullable
   */
  questionType: string | null
  /** Question score */
  score: number
  /** Question text */
  text: string
  /** Question alternatives */
  alternatives: QuestionAlternativeDto[]
}

export interface BookSnippetDto {
  /** Book snippet ID */
  id: number
  /**
   * Raw text content
   * @nullable
   */
  rawText: string | null
  /**
   * Text formatted in HTML
   * @nullable
   */
  textInHtml: string | null
  /**
   * Word count
   * @nullable
   */
  wordCount: number | null
  /**
   * Degree (grade level)
   * @nullable
   */
  degree: string | null
  /** Associated book information */
  book: BookSnippetBookDto
  /**
   * Questions associated with this snippet
   * @nullable
   */
  questions: QuestionDto[] | null
}

export interface ClassReadingFluencyAssessmentDto {
  /** ID of the class entity */
  id: number
  /** Name of the class */
  name: string
}

export interface GetClassesWithReadingFluencyAssessmentResponseDto {
  /** List of classes with reading fluency assessment in progress */
  classes: ClassReadingFluencyAssessmentDto[]
}

export interface ShouldShowForestInfoCardResponseDto {
  /** Whether the forest info card should be displayed */
  shouldShow: boolean
}

export interface HasStudentsWithReadingFluencyResultsResponseDto {
  /** Indicates if teacher has 5 or more students with reading fluency results in current year */
  hasStudentsWithReadingFluencyResults: boolean
}

export interface QuizQuestionAlternativeDto {
  /** Alternative ID */
  id: number
  /** Alternative letter */
  letter: string
  /** Alternative text */
  text: string
}

/**
 * User selected answer (if already answered)
 * @nullable
 */
export type QuizQuestionDtoSelectedAnswer = { [key: string]: unknown } | null

export interface QuizQuestionDto {
  /** Question ID */
  id: number
  /** Question position in the quiz */
  position: number
  /** Question text */
  text: string
  /** List of alternatives */
  alternatives: QuizQuestionAlternativeDto[]
  /**
   * User selected answer (if already answered)
   * @nullable
   */
  selectedAnswer: QuizQuestionDtoSelectedAnswer
}

/**
 * Task status
 */
export type GetQuizResponseDtoStatus =
  typeof GetQuizResponseDtoStatus[keyof typeof GetQuizResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuizResponseDtoStatus = {
  pending: 'pending',
  started: 'started',
  completed: 'completed'
} as const

export interface GetQuizResponseDto {
  /** Task ID */
  id: number
  /** Task title (book name) */
  title: string
  /** Task status */
  status: GetQuizResponseDtoStatus
  /** List of questions */
  questions: QuizQuestionDto[]
}

export interface ReadingFluencyBookInfoDto {
  /**
   * Book title
   * @nullable
   */
  title: string | null
  /**
   * Book author
   * @nullable
   */
  author: string | null
}

/**
 * Quiz data related to reading fluency assessment
 * @nullable
 */
export type GetReadingFluencyResponseDtoQuiz = GetQuizResponseDto | null

/**
 * Book information for the reading fluency snippet
 * @nullable
 */
export type GetReadingFluencyResponseDtoBook = ReadingFluencyBookInfoDto | null

export interface GetReadingFluencyResponseDto {
  /** Reading fluency assessment ID */
  assessmentId: number
  /**
   * Raw text content
   * @nullable
   */
  rawText: string | null
  /**
   * Number of words in the snippet, used for client-side reading completeness validation
   * @nullable
   */
  wordCount: number | null
  /**
   * Quiz data related to reading fluency assessment
   * @nullable
   */
  quiz: GetReadingFluencyResponseDtoQuiz
  /**
   * Book information for the reading fluency snippet
   * @nullable
   */
  book: GetReadingFluencyResponseDtoBook
  /** Whether the user has a non-canceled audio result for this assessment */
  hasAudioResult: boolean
}

export interface LinkAppliedActivityDto {
  /** The ID of the applied activity to link to the reading fluency result */
  appliedActivityId: number
  /** The ID of the reading fluency assessment result */
  fluencyResultId: number
}

export interface LinkAppliedActivityResponseDto {
  /** Success message indicating the link was created successfully */
  message: string
}

export interface SetReadingFluencyLevelResponseDto {
  /** Calculated reading fluency comprehension level */
  level: number
}

export interface EducatorAlternativeDto {
  /** Alternative ID */
  id: number
  /** Alternative letter */
  letter: string
  /** Alternative text */
  text: string
  /** Whether this alternative is correct */
  isCorrect: boolean
}

export interface EducatorStudentAnswerDto {
  /** Selected option ID */
  optionId: number
  /** Selected option letter */
  letter: string
  /** Selected option text */
  text: string
  /** Whether the answer is correct */
  isCorrect: boolean
}

/**
 * Student answer (null if not answered)
 * @nullable
 */
export type EducatorQuestionDtoStudentAnswer = EducatorStudentAnswerDto | null

export interface EducatorQuestionDto {
  /** Question ID */
  id: number
  /** Question position in the quiz */
  position: number
  /** Question text */
  text: string
  /** List of all alternatives */
  alternatives: EducatorAlternativeDto[]
  /**
   * Student answer (null if not answered)
   * @nullable
   */
  studentAnswer: EducatorQuestionDtoStudentAnswer
}

export interface GetEducatorReportResponseDto {
  /** Reading fluency comprehension level */
  level: number
  /** Percentage of correct answers */
  correctAnswersPercentage: number
  /** List of questions with student answers */
  questions: EducatorQuestionDto[]
}

export interface ActiveAssessmentEntityDto {
  id: number
  name: string
}

export type ActiveAssessmentDtoAppliedBy = { [key: string]: unknown }

export type ActiveAssessmentDtoStartDate = { [key: string]: unknown }

export type ActiveAssessmentDtoEndDate = { [key: string]: unknown }

export interface ActiveAssessmentDto {
  id: number
  name: string
  isAutomatic: boolean
  appliedBy?: ActiveAssessmentDtoAppliedBy
  startDate?: ActiveAssessmentDtoStartDate
  endDate?: ActiveAssessmentDtoEndDate
  createdAt: string
  entities: ActiveAssessmentEntityDto[]
  totalStudents: number
  completedStudents: number
  pendingStudents: number
  existingResults: number
}

export interface ListActiveAssessmentsResponseDto {
  assessments: ActiveAssessmentDto[]
}

export interface CancelAssessmentDto {
  /** The ID of the assessment to cancel */
  assessmentId: number
}

export interface CancelAssessmentResponseDto {
  assessmentId: number
  studentsCancelled: number
  resultsPreserved: number
}

export interface CancelAssessmentsBulkDto {
  /** List of assessment IDs to cancel */
  assessmentIds: number[]
  /** Whether to also delete comprehension level records for the cancelled assessments */
  deleteComprehension?: boolean
}

export interface CancelledAssessmentItemDto {
  assessmentId: number
  studentsCancelled: number
  comprehensionDeleted: number
}

export interface SkippedAssessmentItemDto {
  assessmentId: number
  reason: string
}

export interface CancelAssessmentsBulkResponseDto {
  cancelled: CancelledAssessmentItemDto[]
  skipped: SkippedAssessmentItemDto[]
}

export interface AssessmentInfoDto {
  id: number
  name: string
  isAutomatic: boolean
  disabled: boolean
}

export type AssessmentResultItemDtoResultId = { [key: string]: unknown }

export type AssessmentResultItemDtoComprehensionId = { [key: string]: unknown }

export type AssessmentResultItemDtoUserName = { [key: string]: unknown }

export type AssessmentResultItemDtoCorrectWordsPerMinute = {
  [key: string]: unknown
}

export type AssessmentResultItemDtoSuccessRate = { [key: string]: unknown }

export type AssessmentResultItemDtoComprehensionLevel = {
  [key: string]: unknown
}

export type AssessmentResultItemDtoCanceledAt = { [key: string]: unknown }

export type AssessmentResultItemDtoEntityName = { [key: string]: unknown }

export interface AssessmentResultItemDto {
  resultId?: AssessmentResultItemDtoResultId
  comprehensionId?: AssessmentResultItemDtoComprehensionId
  userId: number
  userName?: AssessmentResultItemDtoUserName
  assessmentId: number
  correctWordsPerMinute?: AssessmentResultItemDtoCorrectWordsPerMinute
  successRate?: AssessmentResultItemDtoSuccessRate
  comprehensionLevel?: AssessmentResultItemDtoComprehensionLevel
  createdAt: string
  canceledAt?: AssessmentResultItemDtoCanceledAt
  entityName?: AssessmentResultItemDtoEntityName
}

export interface ListAssessmentResultsResponseDto {
  assessment?: AssessmentInfoDto
  assessments: AssessmentInfoDto[]
  results: AssessmentResultItemDto[]
  totalResults: number
  totalActiveResults: number
}

export interface DeleteAssessmentResultsDto {
  /** Array of result IDs to delete */
  resultIds: number[]
  /** Array of comprehension-only record IDs to delete */
  comprehensionIds?: number[]
}

export type DeleteResultDetailDtoStatus =
  typeof DeleteResultDetailDtoStatus[keyof typeof DeleteResultDetailDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteResultDetailDtoStatus = {
  deleted: 'deleted',
  already_canceled: 'already_canceled'
} as const

export interface DeleteResultDetailDto {
  resultId: number
  userId: number
  status: DeleteResultDetailDtoStatus
}

export interface DeleteAssessmentResultsResponseDto {
  deletedCount: number
  studentsAffected: number
  details: DeleteResultDetailDto[]
}

export interface DeleteAssessmentResultsByAssessmentDto {
  /** The assessment ID whose results will be deleted */
  assessmentId: number
}

export interface DeleteAssessmentResultsByAssessmentResponseDto {
  assessmentId: number
  deletedCount: number
  studentsAffected: number
}

export interface CancelLastReadingFluencyAssessmentDto {
  /** The ID of the user (student) whose assessment result will be canceled */
  userId: number
}

export interface CancelLastReadingFluencyAssessmentResponseDto {
  /** Success message indicating the result was canceled */
  message: string
}

export interface DisableAutomaticAssessmentsDto {
  /** The entity ID (school or class) to exclude from automatic assessments */
  entityId: number
  /** Whether to cancel existing automatic assessment results for this entity */
  cancelExistingResults: boolean
}

export interface DisableAutomaticAssessmentsResponseDto {
  /** The ID of the created exclusion record */
  exclusionId: number
  /** Number of assessments that were disabled */
  assessmentsDisabled: number
  /** Number of results that were canceled */
  resultsCanceled: number
  /** Number of students affected by the operation */
  studentsAffected: number
}

/**
 * Date when the entity was excluded
 * @nullable
 */
export type CheckAutomaticExclusionResponseDtoExcludedAt = {
  [key: string]: unknown
} | null

/**
 * ID of the user who excluded the entity
 * @nullable
 */
export type CheckAutomaticExclusionResponseDtoExcludedBy = {
  [key: string]: unknown
} | null

export interface CheckAutomaticExclusionResponseDto {
  /** Whether the entity is excluded from automatic assessments */
  isExcluded: boolean
  /**
   * Date when the entity was excluded
   * @nullable
   */
  excludedAt?: CheckAutomaticExclusionResponseDtoExcludedAt
  /**
   * ID of the user who excluded the entity
   * @nullable
   */
  excludedBy?: CheckAutomaticExclusionResponseDtoExcludedBy
}

/**
 * @nullable
 */
export type AutomaticAssessmentItemDtoCycle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type AutomaticAssessmentItemDtoYear = { [key: string]: unknown } | null

export interface AutomaticAssessmentItemDto {
  id: number
  name: string
  /** @nullable */
  cycle: AutomaticAssessmentItemDtoCycle
  /** @nullable */
  year: AutomaticAssessmentItemDtoYear
  disabled: boolean
  studentsCount: number
  completedCount: number
  resultsCount: number
}

export interface ListAutomaticAssessmentsResponseDto {
  assessments: AutomaticAssessmentItemDto[]
  totalStudents: number
  totalResults: number
}

/**
 * Data agendada para a etapa (null para remover)
 * @nullable
 */
export type UpdateStepDtoScheduledDate = { [key: string]: unknown } | null

/**
 * Marco de leitura da etapa (null para remover)
 * @nullable
 */
export type UpdateStepDtoReadingMilestone = { [key: string]: unknown } | null

export interface UpdateStepDto {
  /**
   * Data agendada para a etapa (null para remover)
   * @nullable
   */
  scheduledDate?: UpdateStepDtoScheduledDate
  /**
   * Marco de leitura da etapa (null para remover)
   * @nullable
   */
  readingMilestone?: UpdateStepDtoReadingMilestone
}

export interface CreatePostDto {
  /** Conteúdo do post (máximo 5000 caracteres) */
  content: string
}

export interface AssignTrailDto {
  /** ID da turma para vincular a trilha */
  classEntityId: number
}

/**
 * Assessment ID
 */
export type SendToAssessmentResponseDtoAssessmentId = { [key: string]: unknown }

export interface SendToAssessmentResponseDto {
  /** Success message */
  message: string
  /** User ID */
  userId: number
  /** Assessment ID */
  assessmentId: SendToAssessmentResponseDtoAssessmentId
  /** Book snippet ID */
  bookSnippetId: number
  /** S3 audio path */
  s3AudioPath: string
}

/**
 * Assessment result
 */
export type RegisterAssessmentResultBodyDtoAssessmentResult =
  typeof RegisterAssessmentResultBodyDtoAssessmentResult[keyof typeof RegisterAssessmentResultBodyDtoAssessmentResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterAssessmentResultBodyDtoAssessmentResult = {
  adequate: 'adequate',
  inadequate: 'inadequate',
  above_expected: 'above_expected'
} as const

export interface RegisterAssessmentResultBodyDto {
  /** User ID */
  userId: number
  /** Source partner leveling ID */
  sourcePartnerLevelingId: number
  /** Assessment result */
  assessmentResult: RegisterAssessmentResultBodyDtoAssessmentResult
}

export interface RegisterAssessmentResultResponseDto {
  /** Success message */
  message: string
  /** Assessment ID */
  assessmentId: number
  /** Assessment result ID */
  assessmentResultId: number
}

/**
 * New assessment result
 */
export type EditAssessmentBodyDtoAssessmentResult =
  typeof EditAssessmentBodyDtoAssessmentResult[keyof typeof EditAssessmentBodyDtoAssessmentResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditAssessmentBodyDtoAssessmentResult = {
  adequate: 'adequate',
  inadequate: 'inadequate',
  above_expected: 'above_expected'
} as const

export interface EditAssessmentBodyDto {
  /** New source partner leveling ID */
  sourcePartnerLevelingId: number
  /** New assessment result */
  assessmentResult: EditAssessmentBodyDtoAssessmentResult
}

export interface EditAssessmentResponseDto {
  /** Success message */
  message: string
  /** Assessment ID */
  assessmentId: number
  /** Assessment result ID */
  assessmentResultId: number
}

export interface DeleteAssessmentResponseDto {
  /** Success message */
  message: string
  /** Assessment result ID */
  assessmentResultId: number
}

/**
 * @nullable
 */
export type FluencyAudioReviewBookSnippetOptionDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookSnippetOptionDtoBookTitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookSnippetOptionDtoRawTextPreview = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewBookSnippetOptionDto {
  id: number
  /** @nullable */
  degree?: FluencyAudioReviewBookSnippetOptionDtoDegree
  /** Slug da Linhagem do Trecho */
  slug: string
  /** Versão do Trecho dentro da Linhagem */
  version: number
  /** Se é a Versão ativa da Linhagem */
  isActive: boolean
  /** @nullable */
  bookTitle?: FluencyAudioReviewBookSnippetOptionDtoBookTitle
  /** @nullable */
  rawTextPreview?: FluencyAudioReviewBookSnippetOptionDtoRawTextPreview
}

/**
 * @nullable
 */
export type FluencyAudioReviewEntityOptionDtoName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewEntityOptionDtoEntityType = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewEntityOptionDtoAncestry = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewEntityOptionDto {
  id: number
  /** @nullable */
  name?: FluencyAudioReviewEntityOptionDtoName
  /** @nullable */
  entityType?: FluencyAudioReviewEntityOptionDtoEntityType
  /** @nullable */
  ancestry?: FluencyAudioReviewEntityOptionDtoAncestry
}

export interface FluencyAudioReviewFilterOptionsResponseDto {
  /** Degrees disponíveis (ex: "1", "2", "3") */
  degrees: string[]
  bookSnippets: FluencyAudioReviewBookSnippetOptionDto[]
  entities: FluencyAudioReviewEntityOptionDto[]
}

/**
 * @nullable
 */
export type FluencyAudioReviewResultEntityHierarchyDtoName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultEntityHierarchyDtoEntityType = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewResultEntityHierarchyDto {
  id: number
  /** @nullable */
  name?: FluencyAudioReviewResultEntityHierarchyDtoName
  /** @nullable */
  entityType?: FluencyAudioReviewResultEntityHierarchyDtoEntityType
}

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoUserName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoUserLogin = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoEntityId = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoEntityName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoBookSnippetId = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoBookSnippetDegree = {
  [key: string]: unknown
} | null

/**
 * Slug da Linhagem do Trecho
 * @nullable
 */
export type FluencyAudioReviewResultDtoBookSnippetSlug = {
  [key: string]: unknown
} | null

/**
 * Versão do Trecho lida pelo aluno
 * @nullable
 */
export type FluencyAudioReviewResultDtoBookSnippetVersion = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoBookTitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoCorrectWordsPerMinute = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoSuccessRate = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoComprehensionLevel = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoComprehensionTotalQuestions = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoComprehensionCorrectAnswers = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoCanceledAt = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDtoAttributedBy = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewResultDto {
  resultId: number
  userId: number
  /** @nullable */
  userName?: FluencyAudioReviewResultDtoUserName
  /** @nullable */
  userLogin?: FluencyAudioReviewResultDtoUserLogin
  /** @nullable */
  entityId?: FluencyAudioReviewResultDtoEntityId
  /** @nullable */
  entityName?: FluencyAudioReviewResultDtoEntityName
  assessmentId: number
  /** @nullable */
  bookSnippetId?: FluencyAudioReviewResultDtoBookSnippetId
  /** @nullable */
  bookSnippetDegree?: FluencyAudioReviewResultDtoBookSnippetDegree
  /**
   * Slug da Linhagem do Trecho
   * @nullable
   */
  bookSnippetSlug?: FluencyAudioReviewResultDtoBookSnippetSlug
  /**
   * Versão do Trecho lida pelo aluno
   * @nullable
   */
  bookSnippetVersion?: FluencyAudioReviewResultDtoBookSnippetVersion
  /** @nullable */
  bookTitle?: FluencyAudioReviewResultDtoBookTitle
  /** @nullable */
  correctWordsPerMinute?: FluencyAudioReviewResultDtoCorrectWordsPerMinute
  /** @nullable */
  successRate?: FluencyAudioReviewResultDtoSuccessRate
  /** @nullable */
  comprehensionLevel?: FluencyAudioReviewResultDtoComprehensionLevel
  /** @nullable */
  comprehensionTotalQuestions?: FluencyAudioReviewResultDtoComprehensionTotalQuestions
  /** @nullable */
  comprehensionCorrectAnswers?: FluencyAudioReviewResultDtoComprehensionCorrectAnswers
  hasAudio: boolean
  createdAt: string
  /** @nullable */
  canceledAt?: FluencyAudioReviewResultDtoCanceledAt
  /** @nullable */
  attributedBy?: FluencyAudioReviewResultDtoAttributedBy
  /** Se algum reviewer já ouviu o áudio */
  hasListens: boolean
  /** Quantidade de reviewers que já ouviram */
  listensCount: number
  /** Se a avaliação tem algum comentário */
  hasComments: boolean
  /** Quantidade de comentários na avaliação */
  commentsCount: number
  /** Hierarquia de entidades do aluno (top-down, ex: rede → escola → turma) */
  entityHierarchy: FluencyAudioReviewResultEntityHierarchyDto[]
}

/**
 * @nullable
 */
export type FluencyAudioReviewStudentDtoUserName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewStudentDtoUserLogin = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewStudentDtoEntityId = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewStudentDtoEntityName = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewStudentDto {
  userId: number
  /** @nullable */
  userName?: FluencyAudioReviewStudentDtoUserName
  /** @nullable */
  userLogin?: FluencyAudioReviewStudentDtoUserLogin
  /** @nullable */
  entityId?: FluencyAudioReviewStudentDtoEntityId
  /** @nullable */
  entityName?: FluencyAudioReviewStudentDtoEntityName
  results: FluencyAudioReviewResultDto[]
}

export interface ListFluencyAudioReviewResultsResponseDto {
  results?: FluencyAudioReviewResultDto[]
  students?: FluencyAudioReviewStudentDto[]
  total: number
  page: number
  pageSize: number
  totalPages: number
}

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailStudentDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailStudentDtoLogin = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewResultDetailStudentDto {
  id: number
  name: string
  /** @nullable */
  degree?: FluencyAudioReviewResultDetailStudentDtoDegree
  /** @nullable */
  login?: FluencyAudioReviewResultDetailStudentDtoLogin
}

/**
 * @nullable
 */
export type FluencyAudioReviewEntityDtoId = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type FluencyAudioReviewEntityDtoName = { [key: string]: unknown } | null

export interface FluencyAudioReviewEntityDto {
  /** @nullable */
  id?: FluencyAudioReviewEntityDtoId
  /** @nullable */
  name?: FluencyAudioReviewEntityDtoName
}

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoSnippetId = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoSnippetText = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoSnippetDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewBookDtoWordCount = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewBookDto {
  /** @nullable */
  title?: FluencyAudioReviewBookDtoTitle
  /** @nullable */
  author?: FluencyAudioReviewBookDtoAuthor
  /** @nullable */
  image?: FluencyAudioReviewBookDtoImage
  /** @nullable */
  snippetId?: FluencyAudioReviewBookDtoSnippetId
  /** @nullable */
  snippetText?: FluencyAudioReviewBookDtoSnippetText
  /** @nullable */
  snippetDegree?: FluencyAudioReviewBookDtoSnippetDegree
  /** @nullable */
  wordCount?: FluencyAudioReviewBookDtoWordCount
}

/**
 * Comprehension level number
 * @nullable
 */
export type ComprehensionDataDtoLevel = { [key: string]: unknown } | null

/**
 * Comprehension level name
 * @nullable
 */
export type ComprehensionDataDtoLevelName = { [key: string]: unknown } | null

export interface ComprehensionDataDto {
  /**
   * Comprehension level number
   * @nullable
   */
  level?: ComprehensionDataDtoLevel
  /**
   * Comprehension level name
   * @nullable
   */
  levelName?: ComprehensionDataDtoLevelName
  /** Final score calculated from correct answers */
  finalScore: number
  /** List of questions with student answers */
  questions: QuestionDto[]
}

/**
 * Error type
 */
export type HighlightedWordDtoErrorType =
  typeof HighlightedWordDtoErrorType[keyof typeof HighlightedWordDtoErrorType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HighlightedWordDtoErrorType = {
  insertion: 'insertion',
  omission: 'omission',
  mispronunciation: 'mispronunciation',
  none: 'none'
} as const

export interface HighlightedWordDto {
  /** Word index in the text */
  index: number
  /** Expected word */
  word: string
  /** Error type */
  errorType: HighlightedWordDtoErrorType
}

export interface TranscriptionDto {
  /** Original reference text */
  text: string
  /** List of words with error highlights */
  words: HighlightedWordDto[]
}

/**
 * Correct words per minute
 * @nullable
 */
export type OralReadingDataDtoCorrectWordsPerMinute = {
  [key: string]: unknown
} | null

/**
 * Proficiency level slug
 * @nullable
 */
export type OralReadingDataDtoProficiencyLevel = {
  [key: string]: unknown
} | null

/**
 * Proficiency level name
 * @nullable
 */
export type OralReadingDataDtoProficiencyName = {
  [key: string]: unknown
} | null

/**
 * Accuracy rate percentage
 * @nullable
 */
export type OralReadingDataDtoAccuracyRate = { [key: string]: unknown } | null

/**
 * Reading time formatted
 * @nullable
 */
export type OralReadingDataDtoReadingTime = { [key: string]: unknown } | null

/**
 * Audio URL (signed S3 URL)
 * @nullable
 */
export type OralReadingDataDtoAudioUrl = { [key: string]: unknown } | null

/**
 * Audio duration in seconds
 * @nullable
 */
export type OralReadingDataDtoAudioDurationSeconds = {
  [key: string]: unknown
} | null

export interface OralReadingDataDto {
  /**
   * Correct words per minute
   * @nullable
   */
  correctWordsPerMinute?: OralReadingDataDtoCorrectWordsPerMinute
  /**
   * Proficiency level slug
   * @nullable
   */
  proficiencyLevel?: OralReadingDataDtoProficiencyLevel
  /**
   * Proficiency level name
   * @nullable
   */
  proficiencyName?: OralReadingDataDtoProficiencyName
  /**
   * Accuracy rate percentage
   * @nullable
   */
  accuracyRate?: OralReadingDataDtoAccuracyRate
  /**
   * Reading time formatted
   * @nullable
   */
  readingTime?: OralReadingDataDtoReadingTime
  /** Number of insertions */
  insertionsCount: number
  /** Number of omissions */
  omissionsCount: number
  /** Number of mispronunciations */
  mispronunciationsCount: number
  /** Transcription with highlighted errors */
  transcription: TranscriptionDto
  /**
   * Audio URL (signed S3 URL)
   * @nullable
   */
  audioUrl?: OralReadingDataDtoAudioUrl
  /**
   * Audio duration in seconds
   * @nullable
   */
  audioDurationSeconds?: OralReadingDataDtoAudioDurationSeconds
}

export interface FluencyAudioReviewResultDetailListenDto {
  userId: number
  userName: string
  listenedAt: string
}

export type FluencyAudioReviewResultDetailVoteDtoVote =
  typeof FluencyAudioReviewResultDetailVoteDtoVote[keyof typeof FluencyAudioReviewResultDetailVoteDtoVote]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewResultDetailVoteDtoVote = {
  up: 'up',
  down: 'down'
} as const

export interface FluencyAudioReviewResultDetailVoteDto {
  userId: number
  userName: string
  vote: FluencyAudioReviewResultDetailVoteDtoVote
  votedAt: string
}

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailVoteSummaryDtoMyVote =
  | typeof FluencyAudioReviewResultDetailVoteSummaryDtoMyVote[keyof typeof FluencyAudioReviewResultDetailVoteSummaryDtoMyVote]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewResultDetailVoteSummaryDtoMyVote = {
  up: 'up',
  down: 'down'
} as const

export interface FluencyAudioReviewResultDetailVoteSummaryDto {
  up: number
  down: number
  /** @nullable */
  myVote?: FluencyAudioReviewResultDetailVoteSummaryDtoMyVote
  votes: FluencyAudioReviewResultDetailVoteDto[]
}

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailDtoAssessmentName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailDtoAppliedBy = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type FluencyAudioReviewResultDetailDtoCanceledAt = {
  [key: string]: unknown
} | null

export interface FluencyAudioReviewResultDetailDto {
  resultId: number
  assessmentId: number
  /** @nullable */
  assessmentName?: FluencyAudioReviewResultDetailDtoAssessmentName
  student: FluencyAudioReviewResultDetailStudentDto
  entity: FluencyAudioReviewEntityDto
  book: FluencyAudioReviewBookDto
  /** @nullable */
  appliedBy?: FluencyAudioReviewResultDetailDtoAppliedBy
  date: string
  comprehension: ComprehensionDataDto
  oralReading: OralReadingDataDto
  hasAudio: boolean
  createdAt: string
  /** @nullable */
  canceledAt?: FluencyAudioReviewResultDetailDtoCanceledAt
  listens: FluencyAudioReviewResultDetailListenDto[]
  transcriptionVotes: FluencyAudioReviewResultDetailVoteSummaryDto
}

export interface FluencyAudioReviewAudioUrlResponseDto {
  url: string
  /** Expiração da URL em segundos */
  expiresIn: number
}

export interface FluencyAudioReviewCommentDto {
  id: number
  resultId: number
  reviewerUserId: number
  reviewerName: string
  comment: string
  createdAt: string
}

export interface ListFluencyAudioReviewCommentsResponseDto {
  comments: FluencyAudioReviewCommentDto[]
  total: number
}

export interface CreateFluencyAudioReviewCommentDto {
  /**
   * Texto da observação
   * @maxLength 5000
   */
  comment: string
}

export interface FluencyAudioReviewListenDto {
  id: number
  resultId: number
  userId: number
  userName: string
  listenedAt: string
}

/**
 * Voto do reviewer; null remove o voto
 * @nullable
 */
export type SetFluencyAudioReviewTranscriptionVoteDtoVote =
  | typeof SetFluencyAudioReviewTranscriptionVoteDtoVote[keyof typeof SetFluencyAudioReviewTranscriptionVoteDtoVote]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetFluencyAudioReviewTranscriptionVoteDtoVote = {
  up: 'up',
  down: 'down'
} as const

export interface SetFluencyAudioReviewTranscriptionVoteDto {
  /**
   * Voto do reviewer; null remove o voto
   * @nullable
   */
  vote?: SetFluencyAudioReviewTranscriptionVoteDtoVote
}

export type FluencyAudioReviewTranscriptionVoteEntryDtoVote =
  typeof FluencyAudioReviewTranscriptionVoteEntryDtoVote[keyof typeof FluencyAudioReviewTranscriptionVoteEntryDtoVote]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewTranscriptionVoteEntryDtoVote = {
  up: 'up',
  down: 'down'
} as const

export interface FluencyAudioReviewTranscriptionVoteEntryDto {
  userId: number
  userName: string
  vote: FluencyAudioReviewTranscriptionVoteEntryDtoVote
  votedAt: string
}

/**
 * @nullable
 */
export type FluencyAudioReviewTranscriptionVoteSummaryDtoMyVote =
  | typeof FluencyAudioReviewTranscriptionVoteSummaryDtoMyVote[keyof typeof FluencyAudioReviewTranscriptionVoteSummaryDtoMyVote]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewTranscriptionVoteSummaryDtoMyVote = {
  up: 'up',
  down: 'down'
} as const

export interface FluencyAudioReviewTranscriptionVoteSummaryDto {
  resultId: number
  up: number
  down: number
  /** @nullable */
  myVote?: FluencyAudioReviewTranscriptionVoteSummaryDtoMyVote
  votes: FluencyAudioReviewTranscriptionVoteEntryDto[]
}

export interface DataDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /** Active students percentage (0-100) */
  activeStudentsPercentage: number
  /** Number of active students */
  activeStudents: number
  /** Total number of students */
  totalStudents: number
  /** Average access time in seconds */
  averageAccessTime: number
  /** Online time in seconds */
  onlineTime: number
}

export interface AccessReportSummaryDto {
  /** Number of active students */
  activeStudents: number
  /** Total number of students */
  totalStudents: number
  /** Average access time */
  averageAccessTime: number
}

export interface AccessReportResponseDto {
  /** Report data */
  data: DataDto[]
  /** Report summary */
  summary: AccessReportSummaryDto
}

export interface DataV2Dto {
  /** Number of active students */
  activeStudents: number
  /** Total number of students */
  totalStudents: number
  /** Average access time in seconds */
  averageAccessTime: number
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /** Active students percentage (0-100) */
  activeStudentsPercentage: number
  /** Online time in seconds */
  onlineTime: number
}

export interface AccessReportV2SummaryDto {
  /** Number of active students */
  activeStudents: number
  /** Total number of students */
  totalStudents: number
  /** Average access time in seconds */
  averageAccessTime: number
}

export interface AccessReportV2ResponseDto {
  /** Report data. IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.) */
  data: DataV2Dto[]
  /** Report summary */
  summary: AccessReportV2SummaryDto
}

export interface SummaryMetricsDto {
  /** Percentage of active users */
  activeUsersPercentage: number
  /** Total number of users */
  totalUsers: number
  /** Number of active users */
  activeUsers: number
  /** Average reading time per user in minutes */
  averageReadingTimeByUser: number
  /** Average correct answers per user */
  averageCorrectAnswersByUser: number
  /** Total books read */
  totalBooksRead: number
  /** Total articles read */
  totalArticlesRead: number
}

/**
 * Entity ancestry
 * @nullable
 */
export type CurrentEntityDtoEntityAncestry = { [key: string]: unknown } | null

export interface CurrentEntityDto {
  /** Entity ID */
  entityId: number
  /** Entity name */
  entityName: string
  /** Entity type */
  entityType: string
  /**
   * Entity ancestry
   * @nullable
   */
  entityAncestry: CurrentEntityDtoEntityAncestry
}

/**
 * Current entity information
 * @nullable
 */
export type GeneralVisionSummaryResponseDtoCurrentEntity =
  CurrentEntityDto | null

export interface GeneralVisionSummaryResponseDto {
  /** Summary metrics */
  summary: SummaryMetricsDto
  /**
   * Current entity information
   * @nullable
   */
  currentEntity: GeneralVisionSummaryResponseDtoCurrentEntity
}

export interface EntityBasicDto {
  /** Entity ID */
  id: number
  /** Entity name */
  entityName: string
}

export interface PaginationDto {
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
  /** Total count of items */
  totalCount: number
  /** Total number of pages */
  totalPages: number
}

/**
 * Current entity information
 * @nullable
 */
export type GeneralVisionEntitiesResponseDtoCurrentEntity =
  CurrentEntityDto | null

export interface GeneralVisionEntitiesResponseDto {
  /** List of entities */
  entities: EntityBasicDto[]
  /** Pagination information */
  pagination: PaginationDto
  /**
   * Current entity information
   * @nullable
   */
  currentEntity: GeneralVisionEntitiesResponseDtoCurrentEntity
}

export interface EntityMetricsDto {
  /** Entity ID */
  id: number
  /** Entity name */
  entityName: string
  /** Percentage of active users */
  activeUsersPercentage: number
  /** Total number of users */
  totalUsers: number
  /** Number of active users */
  activeUsers: number
  /** Average reading time in minutes */
  averageReadingTime: number
  /** Percentage of correct answers */
  correctAnswersPercentage: number
  /** Total number of answers */
  totalAnswers: number
  /** Number of correct answers */
  correctAnswers: number
  /** Average correct answers per user */
  averageCorrectAnswersByUser: number
  /** Total books read */
  totalBooksRead: number
  /** Total articles read */
  totalArticlesRead: number
}

/**
 * Current entity information
 * @nullable
 */
export type GeneralVisionReportResponseDtoCurrentEntity =
  CurrentEntityDto | null

export interface GeneralVisionReportResponseDto {
  /** Summary metrics */
  summary: SummaryMetricsDto
  /** List of entities with their metrics */
  entities: EntityMetricsDto[]
  /**
   * Current entity information
   * @nullable
   */
  currentEntity: GeneralVisionReportResponseDtoCurrentEntity
  /** Pagination information */
  pagination: PaginationDto
}

export interface GeneralVisionClassCurrentEntityDto {
  /** Entity ID */
  entityId: number
  /** Entity name */
  entityName: string
}

export interface GeneralVisionClassSummaryDataDto {
  /** Number of active students */
  activeUsers: number
  /** Total number of students */
  totalUsers: number
  /** Percentage of active students */
  activeUsersPercentage: number
  /** Average reading time per student in seconds */
  averageReadingTimeByUser: number
  /** Average correct answers per student */
  averageCorrectAnswersByUser: number
  /** Total books read */
  totalBooksRead: number
  /** Total articles read */
  totalArticlesRead: number
}

export interface GeneralVisionClassStudentDataDto {
  /** User ID */
  id: number
  /** Student name */
  studentName: string
  /**
   * Last access date
   * @nullable
   */
  lastAccessDate: string | null
  /** Reading time in seconds */
  readingTime: number
  /** Percentage of correct answers */
  correctAnswersPercentage: number
  /** Average correct answers per activity */
  averageCorrectAnswersByActivity: number
  /** Books read */
  booksRead: number
  /** Articles read */
  articlesRead: number
}

/**
 * Current class entity information
 * @nullable
 */
export type GeneralVisionClassReportResponseDtoCurrentEntity =
  GeneralVisionClassCurrentEntityDto | null

export interface GeneralVisionClassReportResponseDto {
  /**
   * Current class entity information
   * @nullable
   */
  currentEntity: GeneralVisionClassReportResponseDtoCurrentEntity
  /** Summary metrics for the class */
  summaryData: GeneralVisionClassSummaryDataDto
  /** Per-student metrics */
  data: GeneralVisionClassStudentDataDto[]
}

export interface GeneralVisionUserSummaryDataDto {
  /** Total reading time in seconds */
  readingTime: number
  /** Percentage of correct answers */
  correctAnswersPercentage: number
  /** Average correct answers per activity */
  averageCorrectAnswersByActivity: number
  /** Total books read */
  totalBooksRead: number
}

export interface GeneralVisionUserBookDataDto {
  /** Book ID */
  id: number
  /** Book title */
  title: string
  /**
   * Book author
   * @nullable
   */
  author: string | null
  /** Reading time in seconds */
  readingTime: number
  /** Percentage of correct answers */
  correctAnswersPercentage: number
  /** Number of correct answers */
  correctAnswers: number
  /** Total number of answers */
  totalAnswers: number
  /**
   * Book cover URL
   * @nullable
   */
  coverUrl: string | null
  /** Effective reading percentage of the book */
  effectiveReadingPercentage: number
  /** Whether the reading is shared */
  isSharedReading: boolean
  /** Whether the reading is a default reading */
  isDefaultReading: boolean
}

export interface GeneralVisionUserReportResponseDto {
  /** Summary metrics for the user */
  summaryData: GeneralVisionUserSummaryDataDto
  /** Per-book metrics */
  data: GeneralVisionUserBookDataDto[]
}

export interface ReadingReportUserDto {
  /** Student name */
  name: string
  /** Total reading time in seconds */
  timeSpent: number
  /** Total valid reading time in seconds */
  validTimeSpent: number
  /**
   * Total correct objective answers in the period
   * @nullable
   */
  finalGrade: string | null
  /** Reader profile ID */
  readerId: number
}

export interface ReadingReportAggregateDto {
  /** Sum of reading time across all students in seconds */
  totalReadingTime: number
  /** Sum of valid reading time across all students in seconds */
  totalValidReadingTime: number
  /** Sum of correct objective answers across all students */
  totalCorrectQuestions: number
  /** Total number of students in the class */
  totalUsers: number
}

export interface ReadingReportResponseDto {
  /** Reading report data per student */
  users: ReadingReportUserDto[]
  /** Aggregated reading report data */
  aggregate: ReadingReportAggregateDto
}

export interface ReadingReportReadingDataDto {
  /** Book name */
  name: string
  /**
   * Book thumbnail URL
   * @nullable
   */
  thumbnailUrl: string | null
  /**
   * Book slug
   * @nullable
   */
  slug: string | null
  /** Total reading time in seconds */
  timeSpent: number
  /** Total valid reading time in seconds */
  validTimeSpent: number
  /**
   * Total correct objective answers for the book in the period
   * @nullable
   */
  finalGrade: string | null
}

export interface ReadingReportByReaderResponseDto {
  /** Student name */
  userName: string
  /** Reading report data per book */
  readingData: ReadingReportReadingDataDto[]
}

/**
 * Entity name
 * @nullable
 */
export type BooksReportCurrentEntityDtoEntityName = {
  [key: string]: unknown
} | null

export interface BooksReportCurrentEntityDto {
  /** Entity ID */
  entityId: number
  /**
   * Entity name
   * @nullable
   */
  entityName: BooksReportCurrentEntityDtoEntityName
}

export interface BooksReportSummaryDataDto {
  /** Total books read in the period */
  totalBooksRead: number
  /** Total articles fully read in the period */
  totalArticlesRead: number
  /** Total effective reading time in seconds */
  totalEffectiveReadingTime: number
  /** Average effective reading time per user in seconds */
  averageReadingTimeByUser: number
}

/**
 * Book title
 * @nullable
 */
export type BooksReportBookDataDtoTitle = { [key: string]: unknown } | null

/**
 * Book author
 * @nullable
 */
export type BooksReportBookDataDtoAuthor = { [key: string]: unknown } | null

/**
 * Book cover URL
 * @nullable
 */
export type BooksReportBookDataDtoCoverUrl = { [key: string]: unknown } | null

/**
 * Book slug
 * @nullable
 */
export type BooksReportBookDataDtoSlug = { [key: string]: unknown } | null

export interface BooksReportBookDataDto {
  /** Book ID */
  id: number
  /**
   * Book title
   * @nullable
   */
  title: BooksReportBookDataDtoTitle
  /**
   * Book author
   * @nullable
   */
  author: BooksReportBookDataDtoAuthor
  /** Total distinct readers of the book */
  totalUsersRead: number
  /** Total effective reading time for the book in seconds */
  totalEffectiveReadingTime: number
  /** Average effective reading time per reader in seconds */
  averageReadingTimeByUser: number
  /**
   * Book cover URL
   * @nullable
   */
  coverUrl: BooksReportBookDataDtoCoverUrl
  /**
   * Book slug
   * @nullable
   */
  slug: BooksReportBookDataDtoSlug
}

/**
 * @nullable
 */
export type BooksReportResponseDtoCurrentEntity =
  BooksReportCurrentEntityDto | null

export interface BooksReportResponseDto {
  /** @nullable */
  currentEntity: BooksReportResponseDtoCurrentEntity
  summaryData: BooksReportSummaryDataDto
  data: BooksReportBookDataDto[]
}

export interface BooksUserReportSummaryDataDto {
  /** Total distinct books read in the period */
  totalBooksRead: number
  /** Total articles fully read in the period */
  totalArticlesRead: number
  /** Average effective reading time per day in seconds */
  averageReadingByDay: number
  /** Total effective reading time in seconds */
  totalEffectiveReadingTime: number
}

/**
 * Book title
 * @nullable
 */
export type BooksUserReportBookDataDtoTitle = { [key: string]: unknown } | null

/**
 * Book author
 * @nullable
 */
export type BooksUserReportBookDataDtoAuthor = { [key: string]: unknown } | null

/**
 * Book slug
 * @nullable
 */
export type BooksUserReportBookDataDtoSlug = { [key: string]: unknown } | null

/**
 * Book cover URL
 * @nullable
 */
export type BooksUserReportBookDataDtoCoverUrl = {
  [key: string]: unknown
} | null

/**
 * Last reading date (YYYY-MM-DD)
 * @nullable
 */
export type BooksUserReportBookDataDtoLastReadingDate = {
  [key: string]: unknown
} | null

export interface BooksUserReportBookDataDto {
  /** Book ID */
  id: number
  /**
   * Book title
   * @nullable
   */
  title: BooksUserReportBookDataDtoTitle
  /**
   * Book author
   * @nullable
   */
  author: BooksUserReportBookDataDtoAuthor
  /**
   * Book slug
   * @nullable
   */
  slug: BooksUserReportBookDataDtoSlug
  /**
   * Book cover URL
   * @nullable
   */
  coverUrl: BooksUserReportBookDataDtoCoverUrl
  /**
   * Last reading date (YYYY-MM-DD)
   * @nullable
   */
  lastReadingDate: BooksUserReportBookDataDtoLastReadingDate
  /** Total reading time in seconds */
  totalReadingTime: number
  /** Total effective reading time in seconds */
  totalEffectiveReadingTime: number
  /** Effective reading percentage of the book */
  effectiveReadingPercentage: number
  /** Whether the user recorded audio for the book */
  hasAudioRecording: boolean
  /** Whether the reading is a shared reading */
  isSharedReading: boolean
  /** Whether the reading is the default reading */
  isDefaultReading: boolean
}

export interface BooksUserReportResponseDto {
  summaryData: BooksUserReportSummaryDataDto
  data: BooksUserReportBookDataDto[]
}

/**
 * Student name
 * @nullable
 */
export type BookDetailReportStudentDataDtoName = {
  [key: string]: unknown
} | null

/**
 * Last read date (YYYY-MM-DD)
 * @nullable
 */
export type BookDetailReportStudentDataDtoLastReadDate = {
  [key: string]: unknown
} | null

export interface BookDetailReportStudentDataDto {
  /** User ID of the student */
  id: number
  /**
   * Student name
   * @nullable
   */
  name: BookDetailReportStudentDataDtoName
  /**
   * Last read date (YYYY-MM-DD)
   * @nullable
   */
  lastReadDate: BookDetailReportStudentDataDtoLastReadDate
  /** Total reading time in seconds */
  readingTime: number
  /** Total effective reading time in seconds */
  effectiveReadingTime: number
  /** Effective reading percentage of the book */
  effectiveReadingPercentage: number
  /** Whether the student recorded audio for the book */
  hasAudioRecording: boolean
}

export interface BookDetailReportResponseDto {
  data: BookDetailReportStudentDataDto[]
}

export interface ReadingGoalDto {
  /** Weekly reading goal in minutes */
  goal: number
  /** ISO date when the goal became effective */
  startDate: string
}

export interface ReadingGoalsReportUserDto {
  /** Student name */
  name: string
  /** Reading time in minutes (truncated) within the period */
  readingTime: number
}

/**
 * Reading goal valid for the period, null when the entity has no goal
 * @nullable
 */
export type ReadingGoalsReportResponseDtoReadingGoal = ReadingGoalDto | null

export interface ReadingGoalsReportResponseDto {
  /**
   * Reading goal valid for the period, null when the entity has no goal
   * @nullable
   */
  readingGoal: ReadingGoalsReportResponseDtoReadingGoal
  /** Total number of reader profiles in the entity (not filtered by date range) */
  totalCount: number
  /** Paginated list of students with their reading time in the period */
  users: ReadingGoalsReportUserDto[]
}

export interface EvaluationPeriodDto {
  /**
   * Start date
   * @nullable
   */
  startDate: string | null
  /**
   * End date
   * @nullable
   */
  endDate: string | null
}

/**
 * Applied activity ID for this entity
 * @nullable
 */
export type ActivityEntityDtoAppliedActivityId = {
  [key: string]: unknown
} | null

export interface ActivityEntityDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /**
   * Applied activity ID for this entity
   * @nullable
   */
  appliedActivityId: ActivityEntityDtoAppliedActivityId
}

/**
 * Date when the book was created (book_creation only)
 * @nullable
 */
export type ActivityStudentDtoBookCreatedAt = { [key: string]: unknown } | null

export interface ActivityStudentDto {
  /** Student user ID */
  userId: number
  /** Student name */
  studentName: string
  /** Whether student completed the activity */
  completed: boolean
  /**
   * Date when the book was created (book_creation only)
   * @nullable
   */
  bookCreatedAt?: ActivityStudentDtoBookCreatedAt
}

/**
 * Activity type
 */
export type ActivityReportItemDtoType =
  typeof ActivityReportItemDtoType[keyof typeof ActivityReportItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityReportItemDtoType = {
  applied_activity: 'applied_activity',
  reading_indication: 'reading_indication',
  fluency_assessment: 'fluency_assessment',
  book_creation: 'book_creation'
} as const

/**
 * Activity ID from the activities table
 * @nullable
 */
export type ActivityReportItemDtoActivityId = { [key: string]: unknown } | null

/**
 * Book name linked to activity
 * @nullable
 */
export type ActivityReportItemDtoBookName = { [key: string]: unknown } | null

/**
 * Article name linked to activity
 * @nullable
 */
export type ActivityReportItemDtoArticleName = { [key: string]: unknown } | null

/**
 * Evaluation period
 * @nullable
 */
export type ActivityReportItemDtoEvaluationPeriod = EvaluationPeriodDto | null

export interface ActivityReportItemDto {
  /** Activity type */
  type: ActivityReportItemDtoType
  /** Activity ID (depends on type) */
  id: number
  /**
   * Activity ID from the activities table
   * @nullable
   */
  activityId: ActivityReportItemDtoActivityId
  /** Activity name */
  name: string
  /** Whether the activity was self-applied */
  selfApplied: boolean
  /**
   * Book name linked to activity
   * @nullable
   */
  bookName: ActivityReportItemDtoBookName
  /**
   * Article name linked to activity
   * @nullable
   */
  articleName: ActivityReportItemDtoArticleName
  /**
   * Evaluation period
   * @nullable
   */
  evaluationPeriod: ActivityReportItemDtoEvaluationPeriod
  /** Entities associated with this activity */
  entities: ActivityEntityDto[]
  /** List of students who received the activity */
  students: ActivityStudentDto[]
  /** Total number of students who received the activity */
  totalStudents: number
  /** Number of students who completed the activity */
  completedStudents: number
  /** Completion rate (0-100) */
  completionRate: number
}

export interface ActivitiesEntityReportResponseDto {
  /** List of activities */
  activities: ActivityReportItemDto[]
}

/**
 * Activity type
 */
export type StudentActivityItemDtoType =
  typeof StudentActivityItemDtoType[keyof typeof StudentActivityItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentActivityItemDtoType = {
  applied_activity: 'applied_activity',
  reading_indication: 'reading_indication',
  fluency_assessment: 'fluency_assessment'
} as const

/**
 * Book name linked to activity
 * @nullable
 */
export type StudentActivityItemDtoBookName = { [key: string]: unknown } | null

/**
 * Evaluation period
 * @nullable
 */
export type StudentActivityItemDtoEvaluationPeriod = EvaluationPeriodDto | null

/**
 * Activity status
 */
export type StudentActivityItemDtoStatus =
  typeof StudentActivityItemDtoStatus[keyof typeof StudentActivityItemDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentActivityItemDtoStatus = {
  not_started: 'not_started',
  answering_questions: 'answering_questions',
  reading_started: 'reading_started',
  waiting_correction: 'waiting_correction',
  completed: 'completed'
} as const

/**
 * Accuracy percentage (0-100)
 * @nullable
 */
export type StudentActivityItemDtoAccuracyPercentage = {
  [key: string]: unknown
} | null

export interface StudentActivityItemDto {
  /** Activity type */
  type: StudentActivityItemDtoType
  /** Activity ID (depends on type) */
  id: number
  /** Activity name */
  name: string
  /**
   * Book name linked to activity
   * @nullable
   */
  bookName: StudentActivityItemDtoBookName
  /**
   * Evaluation period
   * @nullable
   */
  evaluationPeriod: StudentActivityItemDtoEvaluationPeriod
  /** Activity status */
  status: StudentActivityItemDtoStatus
  /**
   * Accuracy percentage (0-100)
   * @nullable
   */
  accuracyPercentage: StudentActivityItemDtoAccuracyPercentage
}

export interface ActivitiesStudentReportResponseDto {
  /** List of activities for the student */
  activities: StudentActivityItemDto[]
}

export interface QuestionAnswerDto {
  /** Question number (Q1, Q2, Q3...) */
  questionNumber: string
  /** Exam Question ID */
  examQuestionId: number
  /**
   * Whether the answer is correct
   * @nullable
   */
  isCorrect: boolean | null
}

/**
 * Reader ID
 * @nullable
 */
export type StudentActivityDetailsDtoReaderId = {
  [key: string]: unknown
} | null

/**
 * Activity status
 */
export type StudentActivityDetailsDtoStatus =
  typeof StudentActivityDetailsDtoStatus[keyof typeof StudentActivityDetailsDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentActivityDetailsDtoStatus = {
  not_started: 'not_started',
  answering_questions: 'answering_questions',
  waiting_correction: 'waiting_correction',
  completed: 'completed',
  not_completed: 'not_completed'
} as const

/**
 * Execution time in seconds
 * @nullable
 */
export type StudentActivityDetailsDtoExecutionTimeInSeconds = {
  [key: string]: unknown
} | null

/**
 * Accuracy percentage (0-100)
 * @minimum 0
 * @maximum 100
 * @nullable
 */
export type StudentActivityDetailsDtoAccuracyPercentage = {
  [key: string]: unknown
} | null

export interface StudentActivityDetailsDto {
  /** Student user ID */
  userId: number
  /**
   * Reader ID
   * @nullable
   */
  readerId: StudentActivityDetailsDtoReaderId
  /** Applied Activity ID for this student */
  appliedActivityId: number
  /** Student name */
  studentName: string
  /** Activity status */
  status: StudentActivityDetailsDtoStatus
  /**
   * Completion percentage (0-100)
   * @minimum 0
   * @maximum 100
   */
  completionPercentage: number
  /**
   * Execution time in seconds
   * @nullable
   */
  executionTimeInSeconds: StudentActivityDetailsDtoExecutionTimeInSeconds
  /** Number of correct answers */
  correctAnswers: number
  /** Total number of questions */
  totalQuestions: number
  /**
   * Accuracy percentage (0-100)
   * @minimum 0
   * @maximum 100
   * @nullable
   */
  accuracyPercentage: StudentActivityDetailsDtoAccuracyPercentage
  /** Answers for each question */
  questions: QuestionAnswerDto[]
}

/**
 * Reading details for the linked book
 * @nullable
 */
export type ActivityQuestionsDetailsResponseDtoReading = {
  [key: string]: unknown
} | null

export interface ActivityQuestionsDetailsResponseDto {
  /** Activity ID */
  activityId: number
  /** Activity name */
  activityName: string
  /** Applied Activity ID */
  appliedActivityId: number
  /** Student details with their answers */
  students: StudentActivityDetailsDto[]
  /**
   * Reading details for the linked book
   * @nullable
   */
  reading: ActivityQuestionsDetailsResponseDtoReading
}

/**
 * Activity status
 */
export type StudentReadingDetailsDtoStatus =
  typeof StudentReadingDetailsDtoStatus[keyof typeof StudentReadingDetailsDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentReadingDetailsDtoStatus = {
  not_started: 'not_started',
  reading_started: 'reading_started',
  completed: 'completed',
  not_completed: 'not_completed'
} as const

/**
 * Time with content open in seconds
 * @nullable
 */
export type StudentReadingDetailsDtoTimeWithContentOpenInSeconds = {
  [key: string]: unknown
} | null

/**
 * Effective reading time in seconds
 * @nullable
 */
export type StudentReadingDetailsDtoEffectiveReadingTimeInSeconds = {
  [key: string]: unknown
} | null

export interface StudentReadingDetailsDto {
  /** Student user ID */
  userId: number
  /** Student name */
  studentName: string
  /**
   * Last time the student read
   * @nullable
   */
  lastReadAt: string | null
  /** Activity status */
  status: StudentReadingDetailsDtoStatus
  /**
   * Time with content open in seconds
   * @nullable
   */
  timeWithContentOpenInSeconds: StudentReadingDetailsDtoTimeWithContentOpenInSeconds
  /**
   * Effective reading time in seconds
   * @nullable
   */
  effectiveReadingTimeInSeconds: StudentReadingDetailsDtoEffectiveReadingTimeInSeconds
}

export interface ActivityReadingDetailsResponseDto {
  /** Content Indication ID */
  contentIndicationId: number
  /** Book ID */
  bookId: number
  /** Book title */
  bookTitle: string
  /**
   * Book slug, used to navigate to the book intermediate page
   * @nullable
   */
  bookSlug: string | null
  /** Student reading details */
  students: StudentReadingDetailsDto[]
}

export interface ArticleContentDto {
  /** Article ID */
  articleId: string
  /** Article thumbnail URL */
  thumbUrl: string
  /** Article title */
  title: string
  /** Article author name */
  authorName: string
  /** Number of students who opened the article */
  openedStudentsCount: number
  /** Number of students who read the article */
  readStudentsCount: number
}

export interface ArticlesReportResponseDto {
  /** Array of articles with engagement metrics */
  articlesContent: ArticleContentDto[]
}

/**
 * URL of the article cover image
 * @nullable
 */
export type UserArticlesResponseDtoImage = { [key: string]: unknown } | null

/**
 * Name of the article author
 * @nullable
 */
export type UserArticlesResponseDtoAuthor = { [key: string]: unknown } | null

/**
 * Current reading status of the article by the user
 */
export type UserArticlesResponseDtoReadingStatus =
  typeof UserArticlesResponseDtoReadingStatus[keyof typeof UserArticlesResponseDtoReadingStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserArticlesResponseDtoReadingStatus = {
  opened: 'opened',
  fully_consumed: 'fully_consumed'
} as const

export interface UserArticlesResponseDto {
  /** Unique identifier of the article */
  id: number
  /** Title of the article */
  title: string
  /**
   * URL of the article cover image
   * @nullable
   */
  image: UserArticlesResponseDtoImage
  /**
   * Name of the article author
   * @nullable
   */
  author: UserArticlesResponseDtoAuthor
  /** Timestamp of when the user last accessed this article */
  lastReadAt: string
  /** Current reading status of the article by the user */
  readingStatus: UserArticlesResponseDtoReadingStatus
}

export interface ArticleInfoDto {
  /** Article name */
  articleName: string
  /**
   * Article image URL
   * @nullable
   */
  articleImage: string | null
  /**
   * Article author name
   * @nullable
   */
  authorName: string | null
}

/**
 * Reading status
 */
export type StudentReadingDtoReadingStatus =
  typeof StudentReadingDtoReadingStatus[keyof typeof StudentReadingDtoReadingStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentReadingDtoReadingStatus = {
  Não_Lido: 'Não Lido',
  Aberto: 'Aberto',
  Lido: 'Lido'
} as const

export interface StudentReadingDto {
  /** Student name */
  studentName: string
  /**
   * Last read date
   * @nullable
   */
  lastReadDate: string | null
  /** Reading status */
  readingStatus: StudentReadingDtoReadingStatus
}

export interface ArticleDetailsResponseDto {
  /** Article information */
  article: ArticleInfoDto
  /** Array of students with article reading details */
  students: StudentReadingDto[]
}

export interface StudentDataDto {
  /** Student ID */
  id: number
  /** Student name */
  name: string
  /** Last access date */
  lastAccess: string
  /** Total accesses */
  totalAccesses: number
  /** Online time in seconds */
  onlineTime: number
  /** Average access time in seconds */
  averageAccessTime: number
}

export interface StudentAccessReportResponseDto {
  /** Report data */
  students: StudentDataDto[]
}

export interface StudentDataV2Dto {
  /** Student ID */
  id: number
  /** Student name */
  name: string
  /** Last access date */
  lastAccess: string
  /** Total access days */
  totalAccessDays: number
  /** Online time in seconds */
  onlineTime: number
  /** Average access time in seconds */
  averageAccessTime: number
}

export interface StudentAccessReportV2SummaryDto {
  /** Active students percentage (0-100) */
  activeStudentsPercentage: number
  /** Number of active students */
  activeStudents: number
  /** Total number of students */
  totalStudents: number
  /** Average access time in seconds */
  averageAccessTime: number
  /** Number of students currently online */
  onlineNow: number
}

export interface StudentAccessReportV2ResponseDto {
  /** Report data. IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.) */
  students: StudentDataV2Dto[]
  /** Report summary */
  summary: StudentAccessReportV2SummaryDto
}

export interface TaskDataDto {
  /** Task ID */
  id: string
  /** Task title */
  title: string
  /** Task start date */
  startDate: string
  /** Task due date */
  dueDate: string
  /**
   * Task completion rate (0-1)
   * @minimum 0
   * @maximum 1
   */
  taskCompletionRate: number
  /** Number of questions in task */
  questionsCount: number
}

export interface TaskReportResponseDto {
  /** Task report data */
  data: TaskDataDto[]
}

/**
 * Number of questions answered in this month (null if month is outside the requested range)
 * @nullable
 */
export type ActivityStatsByMonthResponseDtoQuestionsAnsweredCount = {
  [key: string]: unknown
} | null

/**
 * Number of correct answers in this month (null if month is outside the requested range)
 * @nullable
 */
export type ActivityStatsByMonthResponseDtoCorrectAnswersCount = {
  [key: string]: unknown
} | null

export interface ActivityStatsByMonthResponseDto {
  /** Reference month (1-12) */
  referenceMonth: number
  /**
   * Number of questions answered in this month (null if month is outside the requested range)
   * @nullable
   */
  questionsAnsweredCount: ActivityStatsByMonthResponseDtoQuestionsAnsweredCount
  /**
   * Number of correct answers in this month (null if month is outside the requested range)
   * @nullable
   */
  correctAnswersCount: ActivityStatsByMonthResponseDtoCorrectAnswersCount
}

/**
 * Task status
 */
export type TaskReportByUserResponseDtoStatus =
  typeof TaskReportByUserResponseDtoStatus[keyof typeof TaskReportByUserResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskReportByUserResponseDtoStatus = {
  pending: 'pending',
  started: 'started',
  waiting_for_correction: 'waiting_for_correction',
  recently_corrected: 'recently_corrected',
  ended: 'ended'
} as const

export interface TaskReportByUserResponseDto {
  /** Task ID */
  id: string
  /** Task due date */
  dueDate: string
  /** Task start date */
  startDate: string
  /** Task title */
  title: string
  /** Number of questions in task */
  questionsCount: number
  /**
   * Activity completion rate (0-100)
   * @minimum 0
   * @maximum 100
   */
  activityCompletionRate: string
  /** Task status */
  status: TaskReportByUserResponseDtoStatus
}

export interface TaskActivityDto {
  /** Activity ID */
  id: number
  /** Activity title */
  title: string
  /** Activity description */
  description: string
  /** Activity difficulty level */
  difficultyLevel: string
  /** Activity degree range */
  degreeRange: string
  /** Estimated completion time in seconds */
  estimatedCompletionTimeInSeconds: number
  /** Is activity ready */
  isReady: boolean
  /** Is BNCC activity */
  isBncc: boolean
  /** Activity created at */
  createdAt: string
  /** Activity updated at */
  updatedAt: string
}

export interface AppliedActivityDto {
  /** Applied activity ID */
  id: number
  /** Activity ID */
  activityId: number
  /** Class ID */
  classId: number
  /** Reader ID */
  readerId: number
  /** Applied activity created at */
  createdAt: string
  /** Applied activity updated at */
  updatedAt: string
  /** Activity details */
  activity: TaskActivityDto
}

export interface AppliedActivityAssignmentDto {
  /** Applied activity assignment ID */
  id: number
  /** Applied activity ID */
  appliedActivityId: number
  /** Assignment ID */
  assignmentId: number
  /** Applied activity assignment created at */
  createdAt: string
  /** Applied activity assignment updated at */
  updatedAt: string
  /** Applied activity details */
  appliedActivity: AppliedActivityDto
}

export interface TaskDetailsResponseDto {
  /** Task ID */
  id: number
  /** Task name */
  name: string
  /** Task start date */
  startDate: string
  /** Task due date */
  dueDate: string
  /** Task location */
  taskLocation: string
  /** Task created at */
  createdAt: string
  /** Task updated at */
  updatedAt: string
  /** Applied activity assignments for this task */
  appliedActivityAssignments: AppliedActivityAssignmentDto[]
}

/**
 * Student status
 */
export type CustomAppliedActivityAnswerStatus =
  typeof CustomAppliedActivityAnswerStatus[keyof typeof CustomAppliedActivityAnswerStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomAppliedActivityAnswerStatus = {
  CANCELLED: 'CANCELLED',
  CORRECTED: 'CORRECTED',
  DOING: 'DOING',
  DONE: 'DONE',
  NOT_STARTED: 'NOT_STARTED',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  PARTIALLY_CORRECT: 'PARTIALLY_CORRECT'
} as const

/**
 * Question type
 */
export type AppliedActivityQuestionDtoType =
  typeof AppliedActivityQuestionDtoType[keyof typeof AppliedActivityQuestionDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppliedActivityQuestionDtoType = {
  discursive: 'discursive',
  objective: 'objective',
  matching_pair: 'matching_pair'
} as const

export interface AppliedActivityQuestionDto {
  /** Exam question ID */
  examQuestionId: number
  /** Question status */
  status: CustomAppliedActivityAnswerStatus
  /** Question type */
  type: AppliedActivityQuestionDtoType
  /** Question tries */
  tries: number
}

/**
 * Applied activity answer ID
 */
export type AppliedActivityReportsDetailsResponseDtoAppliedActivityAnswerId = {
  [key: string]: unknown
}

/**
 * Assignment type - whether activity is assigned to class or individual student
 */
export type AppliedActivityReportsDetailsResponseDtoAssignmentType =
  typeof AppliedActivityReportsDetailsResponseDtoAssignmentType[keyof typeof AppliedActivityReportsDetailsResponseDtoAssignmentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppliedActivityReportsDetailsResponseDtoAssignmentType = {
  class: 'class',
  student: 'student'
} as const

export interface AppliedActivityReportsDetailsResponseDto {
  /** Applied activity ID */
  id: number
  /** Reader ID */
  readerId: number
  /** Applied activity answer ID */
  appliedActivityAnswerId: AppliedActivityReportsDetailsResponseDtoAppliedActivityAnswerId
  /** Student name */
  name: string
  /** Student status */
  status: CustomAppliedActivityAnswerStatus
  /** Student questions */
  questions: AppliedActivityQuestionDto[]
  /** Assignment type - whether activity is assigned to class or individual student */
  assignmentType: AppliedActivityReportsDetailsResponseDtoAssignmentType
  /** Class ID if activity is assigned to a class */
  assignedToClassId?: number
}

export interface TeacherReportDataDto {
  /** Teacher ID */
  id: number
  /** Teacher name */
  name: string
  /** Entity name */
  entity: string
  /** Last access date */
  lastAccess: string
  /** Total access count */
  accessCount: number
  /** Total online time */
  onlineTime: number
  /** Average access time */
  averageAccessTime: number
  /** Total tasks applied */
  tasksApplied: number
}

export interface TeachersSummaryDataDto {
  /** Number of active teachers */
  activeTeachers: number
  /** Average access time across all teachers */
  averageAccessTime: number
  /** Total tasks applied by all teachers */
  totalTasksApplied: number
}

export interface TeachersReportResponseDto {
  /** Teachers report data */
  data: TeacherReportDataDto[]
  /** Summary data */
  summaryData: TeachersSummaryDataDto
}

export interface EducatorDataDto {
  /** Educator ID */
  id: number
  /** Educator name */
  name: string
  /** Entity name */
  entity: string
  /** Current entity name */
  currentEntity: string
  /** Last access date */
  lastAccess: string
  /** Total unique days accessed */
  accessCount: number
  /** Total online time */
  onlineTime: number
  /** Average access time */
  averageAccessTime: number
  /** User role/position */
  role: string
}

export interface EducatorsSummaryDataDto {
  /** Number of active educators */
  activeEducators: number
  /** Average access time across all educators */
  averageAccessTime: number
}

export interface EducatorsByRootResponseDto {
  /** Educators report data */
  data: EducatorDataDto[]
  /** Summary data */
  summaryData: EducatorsSummaryDataDto
}

export interface StudentJourneyDto {
  /** Student ID */
  id: number
  /** Student name */
  name: string
  /**
   * Current reading level
   * @nullable
   */
  currentLevel: string | null
  /**
   * Journey completion percentage
   * @minimum 0
   * @maximum 100
   * @nullable
   */
  progressPercentage: number | null
  /**
   * Start date
   * @nullable
   */
  startedOn: string | null
  /**
   * Listening activities completed
   * @nullable
   */
  listenCount: number | null
  /**
   * Reading activities completed
   * @nullable
   */
  readCount: number | null
  /**
   * Quizzes completed
   * @nullable
   */
  quizCount: number | null
}

export interface JourneysReportResponseDto {
  /** Array of students with journey data */
  students: StudentJourneyDto[]
}

/**
 * Current reading level
 * @nullable
 */
export type StudentRunningRecordSummaryDtoCurrentLevel = {
  [key: string]: unknown
} | null

/**
 * Last assessment date
 * @nullable
 */
export type StudentRunningRecordSummaryDtoLastAssessmentDate = {
  [key: string]: unknown
} | null

export interface StudentRunningRecordSummaryDto {
  /** Student ID */
  userId: number
  /** Student name */
  studentName: string
  /**
   * Current reading level
   * @nullable
   */
  currentLevel?: StudentRunningRecordSummaryDtoCurrentLevel
  /**
   * Last assessment date
   * @nullable
   */
  lastAssessmentDate?: StudentRunningRecordSummaryDtoLastAssessmentDate
}

export interface RunningRecordsClassReportResponseDto {
  /** Class name */
  className: string
  /** List of students with their running records summary */
  students: StudentRunningRecordSummaryDto[]
}

/**
 * Book or passage name
 * @nullable
 */
export type StudentAssessmentRecordDtoPassageName = {
  [key: string]: unknown
} | null

/**
 * Author name
 * @nullable
 */
export type StudentAssessmentRecordDtoAuthor = { [key: string]: unknown } | null

/**
 * Assessment result status
 */
export type StudentAssessmentRecordDtoResult =
  typeof StudentAssessmentRecordDtoResult[keyof typeof StudentAssessmentRecordDtoResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssessmentRecordDtoResult = {
  adequate: 'adequate',
  inadequate: 'inadequate',
  above_expected: 'above_expected'
} as const

export interface StudentAssessmentRecordDto {
  /** Assessment result ID */
  assessmentResultId: number
  /**
   * Book or passage name
   * @nullable
   */
  passageName?: StudentAssessmentRecordDtoPassageName
  /**
   * Author name
   * @nullable
   */
  author?: StudentAssessmentRecordDtoAuthor
  /** Assessment level */
  assessmentLevel: string
  /** Assessment result status */
  result: StudentAssessmentRecordDtoResult
  /** Assessment date */
  assessmentDate: string
}

/**
 * Current reading level
 * @nullable
 */
export type RunningRecordsStudentReportResponseDtoCurrentLevel = {
  [key: string]: unknown
} | null

/**
 * Progress percentage (0-100)
 * @nullable
 */
export type RunningRecordsStudentReportResponseDtoProgressPercentage = {
  [key: string]: unknown
} | null

export interface RunningRecordsStudentReportResponseDto {
  /** Student ID */
  userId: number
  /** Student name */
  studentName: string
  /**
   * Current reading level
   * @nullable
   */
  currentLevel?: RunningRecordsStudentReportResponseDtoCurrentLevel
  /**
   * Progress percentage (0-100)
   * @nullable
   */
  progressPercentage?: RunningRecordsStudentReportResponseDtoProgressPercentage
  /** List of assessment records */
  assessments: StudentAssessmentRecordDto[]
}

export interface ReadingMetricsDto {
  /** Accuracy rate percentage */
  accuracyRate: number
  /** Words per minute */
  wpm: number
  /** Reading time in minutes and seconds */
  readingTime: string
}

export interface ErrorBreakdownDto {
  /** Total word count in passage */
  totalWords: number
  /** Number of word insertions */
  insertions: number
  /** Number of word omissions */
  omissions: number
  /** Number of substitutions/mispronunciations */
  poorPronunciation: number
}

/**
 * Error type
 */
export type RunningRecordsHighlightedWordDtoErrorType =
  typeof RunningRecordsHighlightedWordDtoErrorType[keyof typeof RunningRecordsHighlightedWordDtoErrorType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunningRecordsHighlightedWordDtoErrorType = {
  insertion: 'insertion',
  omission: 'omission',
  substitution: 'substitution',
  none: 'none'
} as const

/**
 * Spoken word (for substitutions)
 * @nullable
 */
export type RunningRecordsHighlightedWordDtoSpokenWord = {
  [key: string]: unknown
} | null

export interface RunningRecordsHighlightedWordDto {
  /** Word text */
  word: string
  /** Error type */
  errorType: RunningRecordsHighlightedWordDtoErrorType
  /**
   * Spoken word (for substitutions)
   * @nullable
   */
  spokenWord?: RunningRecordsHighlightedWordDtoSpokenWord
}

/**
 * Assessment result status
 */
export type RunningRecordsAssessmentDetailResponseDtoResult =
  typeof RunningRecordsAssessmentDetailResponseDtoResult[keyof typeof RunningRecordsAssessmentDetailResponseDtoResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunningRecordsAssessmentDetailResponseDtoResult = {
  adequate: 'adequate',
  inadequate: 'inadequate',
  above_expected: 'above_expected'
} as const

/**
 * Assessment type
 */
export type RunningRecordsAssessmentDetailResponseDtoType =
  typeof RunningRecordsAssessmentDetailResponseDtoType[keyof typeof RunningRecordsAssessmentDetailResponseDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunningRecordsAssessmentDetailResponseDtoType = {
  manual: 'manual',
  automated: 'automated'
} as const

/**
 * Audio recording URL
 * @nullable
 */
export type RunningRecordsAssessmentDetailResponseDtoAudioUrl = {
  [key: string]: unknown
} | null

export interface RunningRecordsAssessmentDetailResponseDto {
  /** Assessment result ID */
  assessmentResultId: number
  /** Student ID */
  userId: number
  /** Student name */
  studentName: string
  /** Assessment level */
  assessmentLevel: string
  /** Assessment result status */
  result: RunningRecordsAssessmentDetailResponseDtoResult
  /** Assessment type */
  type: RunningRecordsAssessmentDetailResponseDtoType
  /** Reading metrics */
  metrics: ReadingMetricsDto
  /** Error breakdown */
  errorBreakdown: ErrorBreakdownDto
  /** Passage text with highlighted errors */
  passage: RunningRecordsHighlightedWordDto[]
  /**
   * Audio recording URL
   * @nullable
   */
  audioUrl?: RunningRecordsAssessmentDetailResponseDtoAudioUrl
  /** Assessment date */
  assessmentDate: string
}

/**
 * How the level was assigned
 */
export type StudentJourneyInfoDtoAssignedBy =
  typeof StudentJourneyInfoDtoAssignedBy[keyof typeof StudentJourneyInfoDtoAssignedBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentJourneyInfoDtoAssignedBy = {
  Automatically: 'Automatically',
  By_teacher: 'By teacher'
} as const

export interface StudentJourneyInfoDto {
  /** Student ID */
  studentId: number
  /** Student name */
  studentName: string
  /**
   * Current reading level
   * @nullable
   */
  currentLevel: string | null
  /**
   * Journey completion percentage
   * @minimum 0
   * @maximum 100
   * @nullable
   */
  progressPercentage: number | null
  /**
   * Journey start date
   * @nullable
   */
  startedOn: string | null
  /** How the level was assigned */
  assignedBy: StudentJourneyInfoDtoAssignedBy
  /**
   * Student class name
   * @nullable
   */
  className: string | null
}

/**
 * How the level was assigned
 */
export type LevelHistoryDtoAssignedBy =
  typeof LevelHistoryDtoAssignedBy[keyof typeof LevelHistoryDtoAssignedBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LevelHistoryDtoAssignedBy = {
  Automatically: 'Automatically',
  By_teacher: 'By teacher'
} as const

export interface LevelHistoryDto {
  /** Reading level name */
  level: string
  /** Level start date */
  startedOn: string
  /**
   * Level completion date
   * @nullable
   */
  completedOn: string | null
  /** How the level was assigned */
  assignedBy: LevelHistoryDtoAssignedBy
}

export interface JourneyMetricsDto {
  /** Number of completed listen assignments */
  completeListenAssignments: number
  /** Number of completed read assignments */
  completeReadAssignments: number
  /** Number of correct quiz answers */
  correctQuizAnswers: number
}

/**
 * Task type
 */
export type JourneyTaskDtoTaskType =
  typeof JourneyTaskDtoTaskType[keyof typeof JourneyTaskDtoTaskType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyTaskDtoTaskType = {
  listening: 'listening',
  reading: 'reading',
  quiz: 'quiz'
} as const

export interface JourneyTaskDto {
  /** Task ID */
  taskId: number
  /** Task type */
  taskType: JourneyTaskDtoTaskType
  /** Whether the task is completed */
  completed: boolean
  /**
   * Quiz score (e.g., "5/5", "18/20")
   * @nullable
   */
  quizScore: string | null
}

/**
 * Overall book status
 */
export type JourneyBookDtoStatus =
  typeof JourneyBookDtoStatus[keyof typeof JourneyBookDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyBookDtoStatus = {
  Complete: 'Complete',
  Started: 'Started',
  Pending: 'Pending'
} as const

export interface JourneyBookDto {
  /** Book ID */
  bookId: number
  /** Book title */
  bookTitle: string
  /** Overall book status */
  status: JourneyBookDtoStatus
  /** Tasks for this book */
  tasks: JourneyTaskDto[]
}

export interface JourneyDetailsByUserResponseDto {
  studentInfo: StudentJourneyInfoDto
  /** Level history */
  levelHistory: LevelHistoryDto[]
  metrics: JourneyMetricsDto
  /** Books with their tasks */
  books: JourneyBookDto[]
}

export interface PaymentEntityDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /** Total number of students */
  totalStudents: number
  /** Number of students with payment */
  paidStudents: number
  /** Whether this is a family paying class */
  isFamilyPaying: boolean
}

export interface PaymentPaginationDto {
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
  /** Total count of items */
  totalCount: number
  /** Total number of pages */
  totalPages: number
}

export interface PaymentReportResponseDto {
  /** List of child entities with payment metrics */
  entities: PaymentEntityDto[]
  /** Pagination metadata */
  pagination: PaymentPaginationDto
}

export interface PaymentStudentDto {
  /** Reader ID */
  id: number
  /** Student name */
  name: string
  /** Entity name */
  entity_name: string
  /** Whether the student has paid */
  paid: boolean
  /** Date when the payment was made (ISO 8601) */
  paidAt?: string
}

export interface PaymentClassReportResponseDto {
  /** Whether the root entity requires payment */
  requirePayment: boolean
  /** List of students with payment status */
  students: PaymentStudentDto[]
}

export interface LevelDistributionDto {
  /** Level name */
  name: string
  /** Level slug identifier */
  slug: string
  /** Color for chart display */
  color: string
  /** Number of students at this level */
  value: number
}

export interface ReadingFluencyClassSummaryDto {
  /** Distribution of comprehension levels */
  comprehension: LevelDistributionDto[]
  /** Distribution of oral reading levels (precision and speed) */
  oralReading: LevelDistributionDto[]
  /** Total number of students in the class */
  totalStudents: number
  /** Number of students with at least one assessment result */
  studentsWithResults: number
}

/**
 * Comprehension trend compared to first assessment of the year (improved, declined, stable)
 * @nullable
 */
export type ReadingFluencyStudentDtoComprehensionTrend =
  | typeof ReadingFluencyStudentDtoComprehensionTrend[keyof typeof ReadingFluencyStudentDtoComprehensionTrend]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadingFluencyStudentDtoComprehensionTrend = {
  improved: 'improved',
  declined: 'declined',
  stable: 'stable'
} as const

/**
 * Oral reading trend compared to first assessment of the year (improved, declined, stable)
 * @nullable
 */
export type ReadingFluencyStudentDtoOralReadingTrend =
  | typeof ReadingFluencyStudentDtoOralReadingTrend[keyof typeof ReadingFluencyStudentDtoOralReadingTrend]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadingFluencyStudentDtoOralReadingTrend = {
  improved: 'improved',
  declined: 'declined',
  stable: 'stable'
} as const

export interface ReadingFluencyStudentDto {
  /** Student user ID */
  userId: number
  /** Student name */
  studentName: string
  /**
   * Comprehension level name
   * @nullable
   */
  comprehensionLevel?: string | null
  /**
   * Comprehension trend compared to first assessment of the year (improved, declined, stable)
   * @nullable
   */
  comprehensionTrend?: ReadingFluencyStudentDtoComprehensionTrend
  /**
   * Oral reading level name (precision and speed)
   * @nullable
   */
  oralReadingLevel?: string | null
  /**
   * Oral reading trend compared to first assessment of the year (improved, declined, stable)
   * @nullable
   */
  oralReadingTrend?: ReadingFluencyStudentDtoOralReadingTrend
  /**
   * Last assessment date
   * @nullable
   */
  lastAssessmentDate?: string | null
  /** Indicates if the student has at least one applied assessment */
  hasAppliedAssessment: boolean
}

export interface EvolutionComparisonDto {
  /** Distribution of levels in the first assessment of the year */
  firstAssessment: LevelDistributionDto[]
  /** Distribution of levels in the last assessment of the year */
  lastAssessment: LevelDistributionDto[]
}

export interface ReadingFluencyEvolutionDto {
  /** Evolution of comprehension levels */
  comprehension: EvolutionComparisonDto
  /** Evolution of oral reading levels (precision and speed) */
  oralReading: EvolutionComparisonDto
}

export interface ReadingFluencyClassReportResponseDto {
  /** Class name */
  className: string
  /** Indicates if there is an active assessment for this class */
  hasActiveAssessment: boolean
  /** Summary with level distributions for charts */
  summary: ReadingFluencyClassSummaryDto
  /** List of students with their reading fluency results */
  students: ReadingFluencyStudentDto[]
  /** Evolution data comparing first and last assessments of the year */
  evolution: ReadingFluencyEvolutionDto
}

/**
 * Student degree/grade
 * @nullable
 */
export type StudentInfoDtoDegree = { [key: string]: unknown } | null

export interface StudentInfoDto {
  /** Student user ID */
  id: number
  /** Student name */
  name: string
  /** Class name */
  className: string
  /**
   * Student degree/grade
   * @nullable
   */
  degree?: StudentInfoDtoDegree
}

/**
 * Level number
 * @nullable
 */
export type LevelResultDtoLevel = { [key: string]: unknown } | null

/**
 * Level name
 * @nullable
 */
export type LevelResultDtoLevelName = { [key: string]: unknown } | null

/**
 * Trend compared to first assessment (improved, declined, stable)
 * @nullable
 */
export type LevelResultDtoTrend =
  | typeof LevelResultDtoTrend[keyof typeof LevelResultDtoTrend]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LevelResultDtoTrend = {
  improved: 'improved',
  declined: 'declined',
  stable: 'stable'
} as const

/**
 * Number of levels changed from first assessment (positive = improved, negative = declined)
 * @nullable
 */
export type LevelResultDtoLevelsChanged = { [key: string]: unknown } | null

export interface LevelResultDto {
  /**
   * Level number
   * @nullable
   */
  level?: LevelResultDtoLevel
  /**
   * Level name
   * @nullable
   */
  levelName?: LevelResultDtoLevelName
  /**
   * Trend compared to first assessment (improved, declined, stable)
   * @nullable
   */
  trend?: LevelResultDtoTrend
  /**
   * Number of levels changed from first assessment (positive = improved, negative = declined)
   * @nullable
   */
  levelsChanged?: LevelResultDtoLevelsChanged
}

/**
 * Date of the latest assessment
 * @nullable
 */
export type LatestResultsDtoDate = { [key: string]: unknown } | null

export interface LatestResultsDto {
  /**
   * Date of the latest assessment
   * @nullable
   */
  date?: LatestResultsDtoDate
  /** Comprehension results */
  comprehension: LevelResultDto
  /** Oral reading (precision and speed) results */
  oralReading: LevelResultDto
}

/**
 * Comprehension level
 * @nullable
 */
export type EvolutionPointDtoComprehensionLevel = {
  [key: string]: unknown
} | null

/**
 * Oral reading level name
 * @nullable
 */
export type EvolutionPointDtoOralReadingLevel = {
  [key: string]: unknown
} | null

export interface EvolutionPointDto {
  /** Assessment ID */
  assessmentId: number
  /** Assessment name */
  assessmentName: string
  /** Assessment date */
  date: string
  /**
   * Comprehension level
   * @nullable
   */
  comprehensionLevel?: EvolutionPointDtoComprehensionLevel
  /**
   * Oral reading level name
   * @nullable
   */
  oralReadingLevel?: EvolutionPointDtoOralReadingLevel
}

/**
 * Book title
 * @nullable
 */
export type StudentAssessmentDtoBookTitle = { [key: string]: unknown } | null

/**
 * Book author
 * @nullable
 */
export type StudentAssessmentDtoBookAuthor = { [key: string]: unknown } | null

/**
 * Comprehension level name
 * @nullable
 */
export type StudentAssessmentDtoComprehensionLevel = {
  [key: string]: unknown
} | null

/**
 * Oral reading level name
 * @nullable
 */
export type StudentAssessmentDtoOralReadingLevel = {
  [key: string]: unknown
} | null

/**
 * Name of who applied the assessment
 * @nullable
 */
export type StudentAssessmentDtoAppliedBy = { [key: string]: unknown } | null

export interface StudentAssessmentDto {
  /** Assessment ID */
  id: number
  /** Assessment name */
  name: string
  /** Assessment date */
  date: string
  /**
   * Book title
   * @nullable
   */
  bookTitle?: StudentAssessmentDtoBookTitle
  /**
   * Book author
   * @nullable
   */
  bookAuthor?: StudentAssessmentDtoBookAuthor
  /**
   * Comprehension level name
   * @nullable
   */
  comprehensionLevel?: StudentAssessmentDtoComprehensionLevel
  /**
   * Oral reading level name
   * @nullable
   */
  oralReadingLevel?: StudentAssessmentDtoOralReadingLevel
  /**
   * Name of who applied the assessment
   * @nullable
   */
  appliedBy?: StudentAssessmentDtoAppliedBy
}

/**
 * Date the assessment was applied to the student (YYYY-MM-DD)
 * @nullable
 */
export type PendingAssessmentDtoAppliedAt = { [key: string]: unknown } | null

export interface PendingAssessmentDto {
  /** Assessment ID */
  id: number
  /** Assessment name */
  name: string
  /**
   * Date the assessment was applied to the student (YYYY-MM-DD)
   * @nullable
   */
  appliedAt?: PendingAssessmentDtoAppliedAt
  /** Name of who applied the assessment */
  appliedBy: string
}

export interface ReadingFluencyStudentReportResponseDto {
  /** Student information */
  student: StudentInfoDto
  /** Latest assessment results with trend information */
  latestResults: LatestResultsDto
  /** Evolution data points for chart - each point represents an assessment */
  evolution: EvolutionPointDto[]
  /** List of all assessments for the student */
  assessments: StudentAssessmentDto[]
  /** Reading fluency assessments applied to the student and not yet performed */
  pendingAssessments: PendingAssessmentDto[]
}

/**
 * Student degree/grade
 * @nullable
 */
export type AssessmentStudentInfoDtoDegree = { [key: string]: unknown } | null

export interface AssessmentStudentInfoDto {
  /** Student user ID */
  id: number
  /** Student name */
  name: string
  /**
   * Student degree/grade
   * @nullable
   */
  degree?: AssessmentStudentInfoDtoDegree
}

/**
 * Book title
 * @nullable
 */
export type BookInfoDtoTitle = { [key: string]: unknown } | null

/**
 * Book author
 * @nullable
 */
export type BookInfoDtoAuthor = { [key: string]: unknown } | null

/**
 * Book cover image URL
 * @nullable
 */
export type BookInfoDtoImage = { [key: string]: unknown } | null

/**
 * Book snippet ID
 * @nullable
 */
export type BookInfoDtoSnippetId = { [key: string]: unknown } | null

/**
 * Snippet word count
 * @nullable
 */
export type BookInfoDtoSnippetWordCount = { [key: string]: unknown } | null

export interface BookInfoDto {
  /**
   * Book title
   * @nullable
   */
  title?: BookInfoDtoTitle
  /**
   * Book author
   * @nullable
   */
  author?: BookInfoDtoAuthor
  /**
   * Book cover image URL
   * @nullable
   */
  image?: BookInfoDtoImage
  /**
   * Book snippet ID
   * @nullable
   */
  snippetId?: BookInfoDtoSnippetId
  /**
   * Snippet word count
   * @nullable
   */
  snippetWordCount?: BookInfoDtoSnippetWordCount
}

/**
 * Name of who applied the assessment
 * @nullable
 */
export type ReadingFluencyStudentAssessmentDetailResponseDtoAppliedBy = {
  [key: string]: unknown
} | null

export interface ReadingFluencyStudentAssessmentDetailResponseDto {
  /** Student information */
  student: AssessmentStudentInfoDto
  /** Assessment date */
  date: string
  /** Book information */
  book: BookInfoDto
  /**
   * Name of who applied the assessment
   * @nullable
   */
  appliedBy?: ReadingFluencyStudentAssessmentDetailResponseDtoAppliedBy
  /** Comprehension data (questions tab) */
  comprehension: ComprehensionDataDto
  /** Oral reading data (reading aloud tab) */
  oralReading: OralReadingDataDto
}

export interface SummaryCardsResponseDto {
  /** Total number of readings/book openings */
  totalReadings: number
  /** Total number of book openings */
  totalBookOpenings: number
  /** Total number of article readings (fully consumed) */
  totalArticleReadings: number
  /** Total number of article openings */
  totalArticleOpenings: number
  /** Total accessed contents (totalArticleReadings + totalBookOpenings + totalArticleOpenings) */
  totalAccessedContents: number
  /** Total effective reading time in seconds */
  totalEffectiveReadingTime: number
  /** Total number of registered students (not filtered by date range) */
  totalRegisteredStudents: number
}

export interface EffectiveReadingByMonthDto {
  /** First day of the month (YYYY-MM-DD) */
  date: string
  /** Total effective reading time in seconds for this month */
  totalTime: number
  /** Total contents read (>50% effective percentage) for this month */
  totalContents: number
}

export interface SummaryEffectiveReadingChartResponseDto {
  /** Effective reading data grouped by month */
  data: EffectiveReadingByMonthDto[]
}

export interface TopReadingClassDto {
  /** Class ID */
  classId: number
  /** Class name */
  className: string
  /** School name (parent entity) */
  schoolName?: string
  /** Total effective reading time in seconds */
  totalReadingTime: number
}

export interface SummaryTopReadingClassesResponseDto {
  /** List of top reading classes */
  data: TopReadingClassDto[]
  /** Total number of classes */
  total: number
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
}

export interface TopReadingStudentDto {
  /** Student user ID */
  userId: number
  /** Student name */
  studentName: string
  /** Total effective reading time in seconds */
  totalReadingTime: number
  /** School name */
  schoolName: string
  /** Class name */
  className: string
}

export interface SummaryTopReadingStudentsResponseDto {
  /** List of top reading students */
  data: TopReadingStudentDto[]
  /** Total number of students */
  total: number
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
}

/**
 * Content type (book or article)
 */
export type TopContentDtoContentType =
  typeof TopContentDtoContentType[keyof typeof TopContentDtoContentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopContentDtoContentType = {
  book: 'book',
  article: 'article'
} as const

/**
 * Cover image URL
 * @nullable
 */
export type TopContentDtoCoverImage = { [key: string]: unknown } | null

/**
 * Content slug
 * @nullable
 */
export type TopContentDtoSlug = { [key: string]: unknown } | null

/**
 * Author name
 * @nullable
 */
export type TopContentDtoAuthor = { [key: string]: unknown } | null

export interface TopContentDto {
  /** Content ID */
  contentId: number
  /** Content title */
  title: string
  /** Content type (book or article) */
  contentType: TopContentDtoContentType
  /**
   * Cover image URL
   * @nullable
   */
  coverImage: TopContentDtoCoverImage
  /**
   * Content slug
   * @nullable
   */
  slug: TopContentDtoSlug
  /**
   * Author name
   * @nullable
   */
  author: TopContentDtoAuthor
  /** Total number of readers */
  totalReaders: number
}

export interface SummaryTopContentsResponseDto {
  /** List of top read contents */
  data: TopContentDto[]
}

export interface ActivitiesByMonthDto {
  /** First day of the month (YYYY-MM-DD) */
  date: string
  /** Total questions answered */
  totalQuestionsAnswered: number
  /** Total correct answers */
  totalCorrectAnswers: number
}

export interface SummaryActivitiesChartResponseDto {
  /** Activities data grouped by month */
  data: ActivitiesByMonthDto[]
}

/**
 * Format type
 */
export type ReadingsByFormatDtoFormat =
  typeof ReadingsByFormatDtoFormat[keyof typeof ReadingsByFormatDtoFormat]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadingsByFormatDtoFormat = {
  books: 'books',
  audiobooks: 'audiobooks',
  articles: 'articles'
} as const

export interface ReadingsByFormatDto {
  /** Format type */
  format: ReadingsByFormatDtoFormat
  /** Total number of readings in this format */
  totalReadings: number
}

export interface SummaryReadingsByFormatResponseDto {
  /** Distribution of readings by format */
  formats: ReadingsByFormatDto[]
  /** Total number of readings across all formats */
  totalReadings: number
}

export interface StudentDto {
  /** Student user ID */
  userId: number
  /**
   * Student name
   * @nullable
   */
  name: string | null
}

export interface BookIndicationDto {
  /** Indication ID */
  id: number
  /** Content ID */
  contentId: number
  /** Created at date */
  createdAt: string
  /**
   * Entity name (class name)
   * @nullable
   */
  entityName: string | null
  /**
   * Book slug
   * @nullable
   */
  bookSlug: string | null
  /**
   * Book author
   * @nullable
   */
  bookAuthor: string | null
  /**
   * Book name
   * @nullable
   */
  bookName: string | null
  /** Target type (entity or user) */
  targetType: string
  /** Teacher user ID */
  teacherUserId: number
  /**
   * Teacher name
   * @nullable
   */
  teacherName: string | null
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /**
   * Book thumbnail URL
   * @nullable
   */
  thumbUrl: string | null
  /** Students who received the indication */
  students: StudentDto[]
}

export interface ArticleIndicationDto {
  /** Indication ID */
  id: number
  /** Content ID */
  contentId: number
  /** Created at date */
  createdAt: string
  /**
   * Entity name (class name)
   * @nullable
   */
  entityName: string | null
  /** Target type (entity or user) */
  targetType: string
  /** Teacher user ID */
  teacherUserId: number
  /**
   * Teacher name
   * @nullable
   */
  teacherName: string | null
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /**
   * Article thumbnail URL
   * @nullable
   */
  thumbUrl: string | null
  /** Article ID */
  articleId: number
  /**
   * Article author
   * @nullable
   */
  articleAuthor: string | null
  /**
   * Article title
   * @nullable
   */
  articleTitle: string | null
  /** Students who received the indication */
  students: StudentDto[]
}

export interface IndicationsReportResponseDto {
  /** Book indications without due date */
  books: BookIndicationDto[]
  /** Article indications without due date */
  articles: ArticleIndicationDto[]
}

export type UserByAncestryDtoProfile =
  typeof UserByAncestryDtoProfile[keyof typeof UserByAncestryDtoProfile]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserByAncestryDtoProfile = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER'
} as const

export interface UserByAncestryDto {
  readerId: number
  userId: number
  userName: string
  className: string
  schoolName: string
  profile: UserByAncestryDtoProfile
}

export type SearchBookResultDtoSlug = { [key: string]: unknown }

export type SearchBookResultDtoAuthor = { [key: string]: unknown }

export type SearchBookResultDtoIsbn = { [key: string]: unknown }

export type SearchBookResultDtoImage = { [key: string]: unknown }

export interface SearchBookResultDto {
  id: number
  name: string
  slug: SearchBookResultDtoSlug
  author: SearchBookResultDtoAuthor
  isbn: SearchBookResultDtoIsbn
  image: SearchBookResultDtoImage
}

export interface SearchBooksResponseDto {
  books: SearchBookResultDto[]
}

/**
 * @nullable
 */
export type SnippetVersionSummaryDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type SnippetVersionSummaryDtoApplicationPeriod =
  | typeof SnippetVersionSummaryDtoApplicationPeriod[keyof typeof SnippetVersionSummaryDtoApplicationPeriod]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SnippetVersionSummaryDtoApplicationPeriod = {
  S1: 'S1',
  S2: 'S2'
} as const

/**
 * @nullable
 */
export type SnippetVersionSummaryDtoWordCount = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionSummaryDtoBookTitle = {
  [key: string]: unknown
} | null

export interface SnippetVersionSummaryDto {
  id: number
  version: number
  /** Se é a Versão ativa (disabled = false) */
  isActive: boolean
  /** @nullable */
  degree?: SnippetVersionSummaryDtoDegree
  /** @nullable */
  applicationPeriod?: SnippetVersionSummaryDtoApplicationPeriod
  /** @nullable */
  wordCount?: SnippetVersionSummaryDtoWordCount
  bookId: number
  /** @nullable */
  bookTitle?: SnippetVersionSummaryDtoBookTitle
  createdAt: string
}

/**
 * ID da Versão ativa, se houver
 * @nullable
 */
export type SnippetLineageDtoActiveVersionId = { [key: string]: unknown } | null

export interface SnippetLineageDto {
  /** Slug estável que identifica a Linhagem */
  slug: string
  /**
   * ID da Versão ativa, se houver
   * @nullable
   */
  activeVersionId?: SnippetLineageDtoActiveVersionId
  /** Versões (mais nova primeiro) */
  versions: SnippetVersionSummaryDto[]
}

export interface ListSnippetLineagesResponseDto {
  lineages: SnippetLineageDto[]
}

/**
 * @nullable
 */
export type SnippetVersionQuestionOptionDtoExplanation = {
  [key: string]: unknown
} | null

export interface SnippetVersionQuestionOptionDto {
  id: number
  position: number
  option: string
  isCorrect: boolean
  /** @nullable */
  explanation?: SnippetVersionQuestionOptionDtoExplanation
}

/**
 * @nullable
 */
export type SnippetVersionQuestionDtoQuestionType = {
  [key: string]: unknown
} | null

export interface SnippetVersionQuestionDto {
  id: number
  position: number
  /** @nullable */
  questionType?: SnippetVersionQuestionDtoQuestionType
  question: string
  options: SnippetVersionQuestionOptionDto[]
}

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoApplicationPeriod =
  | typeof SnippetVersionDetailResponseDtoApplicationPeriod[keyof typeof SnippetVersionDetailResponseDtoApplicationPeriod]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SnippetVersionDetailResponseDtoApplicationPeriod = {
  S1: 'S1',
  S2: 'S2'
} as const

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoWordCount = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoRawText = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoTextInHtml = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoBookTitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type SnippetVersionDetailResponseDtoTaskId = {
  [key: string]: unknown
} | null

export interface SnippetVersionDetailResponseDto {
  id: number
  slug: string
  version: number
  isActive: boolean
  /** @nullable */
  degree?: SnippetVersionDetailResponseDtoDegree
  /** @nullable */
  applicationPeriod?: SnippetVersionDetailResponseDtoApplicationPeriod
  /** @nullable */
  wordCount?: SnippetVersionDetailResponseDtoWordCount
  /** @nullable */
  rawText?: SnippetVersionDetailResponseDtoRawText
  /** @nullable */
  textInHtml?: SnippetVersionDetailResponseDtoTextInHtml
  bookId: number
  /** @nullable */
  bookTitle?: SnippetVersionDetailResponseDtoBookTitle
  /** @nullable */
  taskId?: SnippetVersionDetailResponseDtoTaskId
  createdAt: string
  questions: SnippetVersionQuestionDto[]
}

export interface PublishQuestionOptionDto {
  /** Texto da alternativa */
  option: string
  /** Se é a alternativa correta (exatamente 1 por questão) */
  isCorrect: boolean
  /** Explicação opcional exibida no feedback do quiz */
  explanation?: string
}

/**
 * Tipo da questão, travado por posição (LOC, INF, REL, COM)
 */
export type PublishQuestionDtoQuestionType =
  typeof PublishQuestionDtoQuestionType[keyof typeof PublishQuestionDtoQuestionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublishQuestionDtoQuestionType = {
  LOC: 'LOC',
  INF: 'INF',
  REL: 'REL',
  COM: 'COM'
} as const

export interface PublishQuestionDto {
  /** Posição da questão (1=LOC, 2=INF, 3=REL, 4=COM) */
  position: number
  /** Tipo da questão, travado por posição (LOC, INF, REL, COM) */
  questionType: PublishQuestionDtoQuestionType
  /** Enunciado da questão */
  question: string
  /** 2 a 4 alternativas, exatamente 1 correta */
  options: PublishQuestionOptionDto[]
}

/**
 * Período de aplicação
 */
export type PublishSnippetVersionDtoApplicationPeriod =
  typeof PublishSnippetVersionDtoApplicationPeriod[keyof typeof PublishSnippetVersionDtoApplicationPeriod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublishSnippetVersionDtoApplicationPeriod = {
  S1: 'S1',
  S2: 'S2'
} as const

export interface PublishSnippetVersionDto {
  /** Slug da Linhagem existente (Versão nova). Mutuamente exclusivo com lineageName. */
  slug?: string
  /** Nome legível para Linhagem nova (gera o slug). Mutuamente exclusivo com slug. */
  lineageName?: string
  /** ID do livro ao qual o Trecho pertence */
  bookId: number
  /** Série (degree) do Trecho, ex: "3" */
  degree: string
  /** Período de aplicação */
  applicationPeriod?: PublishSnippetVersionDtoApplicationPeriod
  /** Texto de leitura (word_count é calculado no servidor) */
  rawText: string
  /** Texto de leitura em HTML */
  textInHtml?: string
  /** Exatamente 4 questões, uma por posição/tipo */
  questions: PublishQuestionDto[]
}

export interface PublishSnippetVersionResponseDto {
  snippetId: number
  taskId: number
  slug: string
  version: number
}

export interface DeactivateSnippetVersionResponseDto {
  snippetId: number
  slug: string
  version: number
}

export interface BookDto {
  /** Book ID */
  id: number
  /** Book name */
  name: string
  /** Book image filename */
  image: string
  /** Book slug */
  slug: string
  /** Book author */
  author: string
}

export interface ActivityBookDto {
  /** Book information */
  books: BookDto
}

export interface ArticleDto {
  /** Article ID */
  id: number
  /** Article name */
  name: string
  /** Article image filename */
  image: string
  /** Article author */
  author: string
}

export interface ActivityArticleDto {
  /** Article information */
  articles: ArticleDto
}

export interface QuestionTypeDto {
  /** Objective question */
  objective: boolean
  /** Discursive question */
  discursive: boolean
  /** Matching pair question */
  matching_pair: boolean
}

export interface BnccDto {
  /** BNCC code */
  code: string
  /** BNCC description */
  description: string
}

export interface ActivityDto {
  /** Activity ID */
  id: number
  /** Activity books */
  activityBooks: ActivityBookDto[]
  /** Activity articles */
  activityArticles: ActivityArticleDto[]
  /** Activity degree range */
  degreeRange: string[]
  /** Activity name */
  title: string
  /** Activity difficulty level */
  difficultyLevel: string
  /** Estimated completion time in seconds */
  estimatedCompletionTimeInSeconds: number
  /** Question types */
  questionTypes: QuestionTypeDto
  /** BNCC codes */
  bnccCodes: BnccDto[]
  /** Activity themes */
  themes: string[]
  /** Whether this is a public activity */
  publicActivity: boolean
}

export interface ActivitiesResponseDto {
  /** List of activities */
  data: ActivityDto[]
  /** Pagination information */
  pagination: PaginationDto
}

export interface ActivityFilterBookDto {
  /** Book ID */
  id: number
  /** Book name */
  name: string
  /** Book slug */
  slug: string
}

export interface TimeRangeDto {
  /** Time range identifier */
  value: string
  /** Time range label */
  label: string
}

export interface DegreeRangeDto {
  /** Degree range value */
  value: string
  /** Degree range label */
  label: string
}

export interface ModuleDto {
  /** Module ID */
  id: number
  /** Module name */
  name: string
}

export interface TextualGenreDto {
  /** Textual genre ID */
  id: number
  /** Textual genre name */
  name: string
}

export interface ActivityFiltersResponseDto {
  /** Available books */
  books: ActivityFilterBookDto[]
  /** Available time ranges for filtering */
  timeRanges: TimeRangeDto[]
  /** Available difficulty levels */
  difficultyLevel: string[]
  /** Available degree ranges */
  degreeRange: DegreeRangeDto[]
  /** Available activity types */
  activityType: string[]
  /** Available BNCC codes */
  bnccCodes: string[]
  /** Available themes */
  themes: string[]
  /** Available modules */
  modules: ModuleDto[]
  /** Available textual genres */
  textualGenres: TextualGenreDto[]
}

export type AdminActivityBookDtoBooks = { [key: string]: unknown }

export interface AdminActivityBookDto {
  books: AdminActivityBookDtoBooks
}

export type AdminActivityArticleDtoArticles = { [key: string]: unknown }

export interface AdminActivityArticleDto {
  articles: AdminActivityArticleDtoArticles
}

export type AdminActivityItemDtoTitle = { [key: string]: unknown }

export type AdminActivityItemDtoApprovedForPublic = { [key: string]: unknown }

export type AdminActivityItemDtoDeleted = { [key: string]: unknown }

export type AdminActivityItemDtoTeacherId = { [key: string]: unknown }

/**
 * Creator (teacher) display name
 * @nullable
 */
export type AdminActivityItemDtoCreatorName = { [key: string]: unknown } | null

/**
 * Curation status from PublicDataActivities
 * @nullable
 */
export type AdminActivityItemDtoCurationStatus = {
  [key: string]: unknown
} | null

export interface AdminActivityItemDto {
  id: number
  title: AdminActivityItemDtoTitle
  approvedForPublic: AdminActivityItemDtoApprovedForPublic
  deleted: AdminActivityItemDtoDeleted
  teacherId: AdminActivityItemDtoTeacherId
  createdAt: string
  activityBooks: AdminActivityBookDto[]
  activityArticles: AdminActivityArticleDto[]
  /**
   * Creator (teacher) display name
   * @nullable
   */
  creatorName: AdminActivityItemDtoCreatorName
  /**
   * Curation status from PublicDataActivities
   * @nullable
   */
  curationStatus: AdminActivityItemDtoCurationStatus
}

export interface AdminActivitiesPaginationDto {
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export interface AdminActivitiesResponseDto {
  data: AdminActivityItemDto[]
  pagination: AdminActivitiesPaginationDto
}

/**
 * Whether activity is embedded in book
 * @nullable
 */
export type ActivityItemDtoEmbeddedInBook = { [key: string]: unknown } | null

/**
 * Teacher name who applied the activity
 * @nullable
 */
export type ActivityItemDtoAppliedBy = { [key: string]: unknown } | null

/**
 * Book slug if activity is embedded in book
 * @nullable
 */
export type ActivityItemDtoBookSlug = { [key: string]: unknown } | null

/**
 * Whether the book related to this activity was marked as read by the student
 * @nullable
 */
export type ActivityItemDtoBookIsRead = { [key: string]: unknown } | null

/**
 * Message left by the teacher when applying the activity
 * @nullable
 */
export type ActivityItemDtoMessage = { [key: string]: unknown } | null

/**
 * Article ID if activity is embedded in article
 * @nullable
 */
export type ActivityItemDtoArticleId = { [key: string]: unknown } | null

/**
 * Article image if activity is embedded in article
 * @nullable
 */
export type ActivityItemDtoArticleImage = { [key: string]: unknown } | null

/**
 * Article title if activity is embedded in article
 * @nullable
 */
export type ActivityItemDtoArticleTitle = { [key: string]: unknown } | null

/**
 * Whether the article related to this activity was consumed by the student
 * @nullable
 */
export type ActivityItemDtoArticleIsRead = { [key: string]: unknown } | null

export interface ActivityItemDto {
  /** Activity ID */
  id: number
  /** Applied activity ID */
  appliedActivityId: number
  /** Activity title */
  title: string
  /** Activity description */
  description: string
  /**
   * Activity due date
   * @nullable
   */
  dueDate: string | null
  /** Activity difficulty level */
  difficultyLevel: string
  /** Estimated completion time in seconds */
  estimatedCompletionTimeInSeconds: number
  /** Temporary image URL */
  tempImage: string
  /**
   * Whether activity is embedded in book
   * @nullable
   */
  embeddedInBook: ActivityItemDtoEmbeddedInBook
  /** Activity themes */
  activityThemes: string[]
  /** Activity status */
  status: string
  /** Question types */
  questionTypes: string[]
  /** Total coins */
  totalCoins: number
  /** BNCC abilities */
  bnccs: BnccDto[]
  /** Language practices */
  languagePractices: string[]
  /**
   * Teacher name who applied the activity
   * @nullable
   */
  appliedBy: ActivityItemDtoAppliedBy
  /**
   * Book slug if activity is embedded in book
   * @nullable
   */
  bookSlug: ActivityItemDtoBookSlug
  /**
   * Whether the book related to this activity was marked as read by the student
   * @nullable
   */
  bookIsRead: ActivityItemDtoBookIsRead
  /**
   * Whether the book related to this activity has an ebook version
   * @nullable
   */
  bookHasEbook: boolean | null
  /**
   * Whether the book related to this activity has an audiobook version
   * @nullable
   */
  bookHasAudioBook: boolean | null
  /**
   * Message left by the teacher when applying the activity
   * @nullable
   */
  message: ActivityItemDtoMessage
  /**
   * Article ID if activity is embedded in article
   * @nullable
   */
  articleId: ActivityItemDtoArticleId
  /**
   * Article image if activity is embedded in article
   * @nullable
   */
  articleImage: ActivityItemDtoArticleImage
  /**
   * Article title if activity is embedded in article
   * @nullable
   */
  articleTitle: ActivityItemDtoArticleTitle
  /**
   * Whether the article related to this activity was consumed by the student
   * @nullable
   */
  articleIsRead: ActivityItemDtoArticleIsRead
  /**
   * Date when the activity was corrected
   * @nullable
   */
  correctedAt: string | null
}

export interface AssignmentDto {
  /** Assignment name */
  name: string
  /** Assignment ID */
  id: number
  /** Assignment due date */
  dueDate: string
  /** Assignment start date */
  startDate: string
  /** Assignment task location */
  taskLocation: string
  /** Assignment order restricted */
  orderRestricted: boolean
  /** Assignment message */
  message: string
  /** Activities in this assignment */
  activities: ActivityItemDto[]
  /** Total coins from all activities in this assignment */
  totalCoins: number
}

export interface StatusGroupDto {
  /** Assignments in this status group */
  assignments: AssignmentDto[]
  /** Activities in this status group */
  activities: ActivityItemDto[]
}

export interface StudentActivitiesResponseDto {
  /** Pending status group */
  pending: StatusGroupDto
  /** Started status group */
  started: StatusGroupDto
  /** Waiting for correction status group */
  waiting_for_correction: StatusGroupDto
  /** Recently corrected status group */
  recently_corrected: StatusGroupDto
  /** Ended status group */
  ended: StatusGroupDto
}

export interface FluencyActivityDto {
  /** Assessment ID */
  assessmentId: number
  /** Activity title */
  title: string
  /** Teacher name who applied the assessment */
  appliedBy: string
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /** Activity status */
  status: string
}

export interface IndicationActivityDto {
  /** Indication ID */
  id: number
  /** Activity title */
  title: string
  /** Teacher name who made the indication */
  teacherName: string
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /** Content ID */
  contentId: number
  /** Content type */
  contentType: string
  /**
   * Book slug
   * @nullable
   */
  bookSlug: string | null
  /**
   * Whether the indicated book has an ebook version
   * @nullable
   */
  bookHasEbook: boolean | null
  /**
   * Whether the indicated book has an audiobook version
   * @nullable
   */
  bookHasAudioBook: boolean | null
  /** Whether the content was marked as read */
  isRead: boolean
  /** Activity status */
  status: string
}

export interface BookCreationActivityDto {
  /** Applied activity ID */
  id: number
  /** Application group ID */
  applicationGroupId: string
  /** Activity title (book theme) */
  title: string
  /** Teacher name who applied the activity */
  appliedBy: string
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /**
   * Start date
   * @nullable
   */
  startDate: string | null
  /**
   * Complementary message from teacher
   * @nullable
   */
  message: string | null
  /** Activity status */
  status: string
}

export interface StudentActivitiesV2StatusGroupDto {
  /** Assignments in this status group */
  assignments: AssignmentDto[]
  /** Activities in this status group */
  activities: ActivityItemDto[]
  /** Fluency activities in this status group */
  fluencyActivities: FluencyActivityDto[]
  /** Indication activities in this status group */
  indicationActivities: IndicationActivityDto[]
  /** Book creation activities in this status group */
  bookCreationActivities: BookCreationActivityDto[]
}

export interface StudentActivitiesV2ResponseDto {
  /** Pending status group */
  pending: StudentActivitiesV2StatusGroupDto
  /** Started status group */
  started: StudentActivitiesV2StatusGroupDto
  /** Waiting for correction status group */
  waiting_for_correction: StudentActivitiesV2StatusGroupDto
  /** Recently corrected status group */
  recently_corrected: StudentActivitiesV2StatusGroupDto
  /** Ended status group */
  ended: StudentActivitiesV2StatusGroupDto
}

export interface PendingActivitiesCountResponseDto {
  /** Total count of pending activities */
  count: number
}

export interface LanguagePracticeWithActivitiesDto {
  /** ID da prática de linguagem */
  id: number
  /** Nome da prática de linguagem */
  name: string
  /** Descrição da prática de linguagem */
  description: string
  /** Atividades associadas a esta prática de linguagem */
  activities: ActivityItemDto[]
}

export interface UpdateApprovedForPublicDto {
  /** Whether the activity is approved for public catalog */
  approvedForPublic: boolean
}

export interface PracticeObjectDto {
  /** Practice object ID */
  id: number
  /** Practice object name */
  name: string
  /** Practice object description */
  description: string
}

export interface ActivityResponseDto {
  /** Activity ID */
  id: number
  /** Activity books */
  activityBooks: ActivityBookDto[]
  /** Activity articles */
  activityArticles: ActivityArticleDto[]
  /** Activity degree range */
  degreeRange: string[]
  /** Activity name */
  title: string
  /** Activity difficulty level */
  difficultyLevel: string
  /** Estimated completion time in seconds */
  estimatedCompletionTimeInSeconds: number
  /** Question types */
  questionTypes: QuestionTypeDto
  /** BNCC codes */
  bnccCodes: BnccDto[]
  /** Activity themes */
  themes: string[]
  /** Whether activity is approved for public */
  approvedForPublic: boolean
  /** Whether activity is embedded in book */
  embeddedInBook: boolean
  /** Activity years */
  years: string[]
  /** Minutes to complete */
  minutesToComplete: string
  /** Practice objects */
  practiceObjects: PracticeObjectDto[]
  /** Activity questions */
  questions: QuestionDto[]
  /** Summary BNCC abilities */
  summaryBnccAbilities: string[]
  /** Pedagogical axes */
  pedagogicalAxes: string[]
  /** Distinct question types */
  distinctQuestionTypes: string[]
}

export interface CreateActivityQuestionAlternativeDto {
  /** Alternative text */
  text: string
  /** Alternative image URL */
  image?: string
  /** Indicates if the alternative is correct */
  isCorrect: boolean
}

export interface CreateActivityQuestionMatchingPairDto {
  /** Matching pair text */
  text: string
  /** Matching pair image URL */
  image: string
}

/**
 * Activity type
 */
export type CreateActivityQuestionDtoType =
  typeof CreateActivityQuestionDtoType[keyof typeof CreateActivityQuestionDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateActivityQuestionDtoType = {
  discursive: 'discursive',
  objective: 'objective',
  matching_pair: 'matching_pair'
} as const

export interface CreateActivityQuestionDto {
  /** Page reference */
  pageReference?: string
  /** Question text */
  question?: string
  /** List of alternatives for objective questions */
  alternatives?: CreateActivityQuestionAlternativeDto[]
  /** Expected answer for discursive questions */
  expectedAnswer?: string
  /** Question image URL */
  image?: string
  /** Question unique ID */
  id: string
  /** Pairs for matching questions */
  matchingPairs?: CreateActivityQuestionMatchingPairDto[]
  /** Activity type */
  type: CreateActivityQuestionDtoType
  /** Activity BNCC ability code */
  bnccAbilityCode?: string
}

/**
 * Activity display mode
 */
export type CreateActivityDtoDisplay =
  typeof CreateActivityDtoDisplay[keyof typeof CreateActivityDtoDisplay]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateActivityDtoDisplay = {
  'inside-book': 'inside-book',
  'outside-book': 'outside-book'
} as const

/**
 * Content type (book or article)
 */
export type CreateActivityDtoContentType =
  typeof CreateActivityDtoContentType[keyof typeof CreateActivityDtoContentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateActivityDtoContentType = {
  book: 'book',
  article: 'article'
} as const

export interface CreateActivityDto {
  /** Activity name */
  name: string
  /** Activity display mode */
  display: CreateActivityDtoDisplay
  /** Content type (book or article) */
  contentType: CreateActivityDtoContentType
  /** List of related article slugs */
  articleSlugs: string[]
  /** List of related book slugs */
  bookSlugs: string[]
  /** Article ID (required when contentType is "article") */
  articleId?: number
  /**
   * List of activity questions
   * @minItems 1
   */
  questions: CreateActivityQuestionDto[]
  /** Activity themes */
  themes?: string[]
  /** Activity difficulty level */
  difficultyLevel?: string
  /** Estimated time to complete the activity (in minutes) */
  estimatedTime: number
  /**
   * Activity degrees
   * @minItems 1
   */
  degrees: string[]
}

export interface CreateActivityResponseDto {
  /** Activity ID */
  id: number
}

export interface UpdateActivityQuestionsDto {
  /**
   * Updated list of activity questions
   * @minItems 1
   */
  questions: CreateActivityQuestionDto[]
}

export interface UpdateActivityTitleDto {
  /**
   * Activity title
   * @maxLength 255
   */
  title: string
}

export interface GenerateAiQuestionsDto {
  /** Education degrees */
  degrees: string[]
  /** Pedagogical axis */
  pedagogicalAxis: string[]
  /**
   * Number of discursive questions
   * @minimum 0
   */
  numberOfDiscursiveQuestions: number
  /**
   * Number of objective questions
   * @minimum 0
   */
  numberOfObjectiveQuestions: number
  /**
   * Number of matching pair questions
   * @minimum 0
   */
  numberOfMatchingPairQuestions: number
  /** List of books */
  books: string[]
}

export interface ActivityQuestionAlternativeResponseDto {
  /** Alternative text */
  text: string
  /** Alternative image URL */
  image?: string
  /** Indicates if the alternative is correct */
  isCorrect: boolean
}

export interface ActivityQuestionMatchingPairResponseDto {
  /** Matching pair text */
  text: string
  /** Matching pair image URL */
  image: string
}

/**
 * Activity type
 */
export type ActivityQuestionResponseDtoType =
  typeof ActivityQuestionResponseDtoType[keyof typeof ActivityQuestionResponseDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityQuestionResponseDtoType = {
  discursive: 'discursive',
  objective: 'objective',
  matching_pair: 'matching_pair'
} as const

export interface ActivityQuestionResponseDto {
  /** Question unique ID */
  id: string
  /** Page reference */
  pageReference?: string
  /** Question text */
  question?: string
  /** List of alternatives for objective questions */
  alternatives?: ActivityQuestionAlternativeResponseDto[]
  /** Expected answer for discursive questions */
  expectedAnswer?: string
  /** Question image URL */
  image?: string
  /** Pairs for matching questions */
  matchingPairs?: ActivityQuestionMatchingPairResponseDto[]
  /** Activity type */
  type: ActivityQuestionResponseDtoType
  /** BNCC ability code */
  bnccAbilityCode?: string
}

export interface UploadImageResponseDto {
  /** Uploaded image URL */
  url: string
  /** Uploaded image key */
  key: string
}

export interface ReaderDto {
  /** User ID of the student */
  userId: number
  /** Reader ID of the student */
  readerId: number
}

/**
 * Type of activity application
 */
export type ApplyActivityDtoType =
  typeof ApplyActivityDtoType[keyof typeof ApplyActivityDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplyActivityDtoType = {
  questions: 'questions',
  reading: 'reading',
  book_creation: 'book_creation'
} as const

/**
 * Content type (required for reading type)
 */
export type ApplyActivityDtoContentType =
  typeof ApplyActivityDtoContentType[keyof typeof ApplyActivityDtoContentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplyActivityDtoContentType = {
  book: 'book',
  article: 'article'
} as const

export interface ApplyActivityDto {
  /** Type of activity application */
  type: ApplyActivityDtoType
  /** List of students with userId and readerId */
  readers: ReaderDto[]
  /** End date for the activity */
  endDate: string
  /** Activity ID (required for questions type) */
  activityId?: number
  /** Start date (required for questions and book_creation types) */
  startDate?: string
  /** Message/observation (optional for questions and book_creation types) */
  message?: string
  /** Title for the book creation activity (required for book_creation type) */
  title?: string
  /** Content identifier - slug for book, id for article (required for reading type) */
  content?: string
  /** Content type (required for reading type) */
  contentType?: ApplyActivityDtoContentType
}

export interface ApplyActivityResponseDto {
  /** Success message */
  message: string
  /** Number of applied activities created */
  count: number
}

export interface SetChoiceAnswerDto {
  /** ID of the applied activity answer */
  appliedActivityAnswerId: number
  /** ID of the exam question */
  examQuestionId: number
  /** ID of the exam question choice (selected answer) */
  examQuestionChoiceId: number
  /** Whether automatic correction is enabled */
  isCorrectionAutomatic?: boolean
}

/**
 * Grade given by teacher
 * @nullable
 */
export type SetChoiceAnswerResponseDtoGrade = { [key: string]: unknown } | null

/**
 * Comments from teacher
 * @nullable
 */
export type SetChoiceAnswerResponseDtoTeacherComments = {
  [key: string]: unknown
} | null

export interface SetChoiceAnswerResponseDto {
  /** Answer ID */
  id: number
  /** Applied activity answer ID */
  appliedActivityAnswerId: number
  /** Exam question ID */
  examQuestionId: number
  /** Selected choice ID */
  answerChoiceId: number
  /** Whether the answer is correct */
  isCorrect: boolean
  /** ID of the correct answer choice */
  correctAnswerId: number
  /** Number of attempts (retry count) */
  retryCount: number
  /**
   * Grade given by teacher
   * @nullable
   */
  grade: SetChoiceAnswerResponseDtoGrade
  /**
   * Comments from teacher
   * @nullable
   */
  teacherComments: SetChoiceAnswerResponseDtoTeacherComments
  /** Answer creation date */
  createdAt: string
  /** Answer last update date */
  updatedAt: string
}

export interface BiblionLibraryDto {
  /** Library (school) entity id */
  id: number
  /** Library name */
  name: string
}

export interface ListLibrariesResponseDto {
  libraries: BiblionLibraryDto[]
}

export type EmailAvailabilityResponseDtoMissingFieldsItem =
  typeof EmailAvailabilityResponseDtoMissingFieldsItem[keyof typeof EmailAvailabilityResponseDtoMissingFieldsItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailAvailabilityResponseDtoMissingFieldsItem = {
  cpf: 'cpf',
  gender: 'gender',
  address: 'address',
  bornDate: 'bornDate'
} as const

export interface EmailAvailabilityResponseDto {
  /** Whether the email is available for registration */
  available: boolean
  /** Whether the email belongs to an existing account that can be linked to BibliON via the registration flow */
  requiresAccountLink: boolean
  /** Whether the email belongs to a migrated account that has no password yet and must define one before logging in */
  requiresPasswordSetup: boolean
  /** Whether the email already has active BibliON access; registration is blocked and the user should just log in */
  biblionAccountExists: boolean
  /** Name of the existing account, used to greet the user on the login screen */
  name?: string
  /** Profile fields that are still empty for this account and may be requested later */
  missingFields: EmailAvailabilityResponseDtoMissingFieldsItem[]
}

/**
 * Document type
 */
export type RegisterBiblionBodyDtoDocumentType =
  typeof RegisterBiblionBodyDtoDocumentType[keyof typeof RegisterBiblionBodyDtoDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterBiblionBodyDtoDocumentType = {
  CPF: 'CPF',
  CRNM: 'CRNM'
} as const

export interface RegisterBiblionBodyDto {
  /** Full name */
  name: string
  /** Email address */
  email: string
  /** Password (min 8 characters) */
  password: string
  /** Birth date in ISO format (YYYY-MM-DD) */
  bornDate: string
  /** Library (school) entity id to register into */
  libraryId?: number
  /** Document number (CPF or CRNM) */
  documentNumber?: string
  /** Document type */
  documentType?: RegisterBiblionBodyDtoDocumentType
  /** Gender (free text, max 20 chars) */
  gender?: string
  /** Phone number */
  phone?: string
  /** ZIP code (CEP) - Brazilian format only */
  zipCode?: string
  /** State (UF) */
  state?: string
  /** City */
  city?: string
}

export interface RegisterBiblionResponseDto {
  /** Registration status */
  status: string
  /** Email the confirmation was sent to */
  email: string
}

export interface ConfirmBiblionBodyDto {
  /** Email confirmation token */
  token: string
}

export interface ConfirmBiblionResponseDto {
  /** Confirmation status */
  status: string
  /** Library name the user was registered into */
  libraryName: string
  /** Age group class name */
  className: string
}

export interface ResendConfirmationBodyDto {
  /** Email to resend the confirmation to */
  email: string
}

/**
 * Resend status
 */
export type ResendConfirmationResponseDtoStatus =
  typeof ResendConfirmationResponseDtoStatus[keyof typeof ResendConfirmationResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResendConfirmationResponseDtoStatus = {
  sent: 'sent',
  already_confirmed: 'already_confirmed',
  not_found: 'not_found',
  send_failed: 'send_failed'
} as const

export interface ResendConfirmationResponseDto {
  /** Resend status */
  status: ResendConfirmationResponseDtoStatus
}

export interface RequestPasswordSetupBodyDto {
  /** Email of the migrated account that needs to define a password */
  email: string
}

export interface RequestPasswordSetupResponseDto {
  /** Always true to avoid leaking account existence */
  ok: boolean
}

export type BiblionProfileStatusResponseDtoMissingFieldsItem =
  typeof BiblionProfileStatusResponseDtoMissingFieldsItem[keyof typeof BiblionProfileStatusResponseDtoMissingFieldsItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiblionProfileStatusResponseDtoMissingFieldsItem = {
  cpf: 'cpf',
  gender: 'gender',
  address: 'address',
  bornDate: 'bornDate'
} as const

export interface BiblionProfileStatusResponseDto {
  /** Profile fields that are still empty and must be completed */
  missingFields: BiblionProfileStatusResponseDtoMissingFieldsItem[]
}

/**
 * Document type
 */
export type CompleteBiblionProfileBodyDtoDocumentType =
  typeof CompleteBiblionProfileBodyDtoDocumentType[keyof typeof CompleteBiblionProfileBodyDtoDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteBiblionProfileBodyDtoDocumentType = {
  CPF: 'CPF',
  CRNM: 'CRNM'
} as const

export interface CompleteBiblionProfileBodyDto {
  /** Document number (CPF or CRNM) */
  documentNumber?: string
  /** Document type */
  documentType?: CompleteBiblionProfileBodyDtoDocumentType
  /** Gender (free text, max 20 chars) */
  gender?: string
  /** Phone number */
  phone?: string
  /** ZIP code (CEP) */
  zipCode?: string
  /** State (UF) */
  state?: string
  /** City */
  city?: string
  /** Birth date in ISO format (YYYY-MM-DD) */
  bornDate?: string
}

export interface SescEntityDto {
  /** Entity id */
  id: number
  /** Entity name */
  name: string
}

export interface ListSescNetworksResponseDto {
  /** Available networks (units) for the SESC RS root */
  networks: SescEntityDto[]
}

export interface ListSescUserTypesResponseDto {
  /** Available user types (schools) under the selected network */
  userTypes: SescEntityDto[]
}

export interface SescEmailAvailabilityResponseDto {
  /** Whether the email is available for registration */
  available: boolean
}

export interface RegisterSescBodyDto {
  /** Full name */
  name: string
  /** Email address */
  email: string
  /** Password (min 8 characters) */
  password: string
  /** Birth date in ISO format (YYYY-MM-DD) */
  bornDate: string
  /** Selected network (unit) entity id */
  networkId: number
  /** Selected user type (school) entity id */
  schoolId: number
}

export interface RegisterSescResponseDto {
  /** Registration status */
  status: string
  /** Email of the registered user */
  email: string
}

export interface CreateShelfBodyDto {
  name: string
  description?: string
  image?: string
}

export interface ReorderShelfItemDto {
  id: number
  order: number
}

export interface ReorderShelvesBodyDto {
  items: ReorderShelfItemDto[]
}

export interface UpdateShelfBodyDto {
  name?: string
  description?: string
  image?: string
}

export interface ToggleShelfBodyDto {
  enabled: boolean
}

export interface UpdateShelfItemsBodyDto {
  articleIds: number[]
}

/**
 * @nullable
 */
export type ArticleItemDtoTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoSubtitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoSchoolSegment = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoPublishDate = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoDisabled = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleItemDtoIsHighlighted = { [key: string]: unknown } | null

export type ArticleItemDtoPublisher =
  typeof ArticleItemDtoPublisher[keyof typeof ArticleItemDtoPublisher]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleItemDtoPublisher = {
  arvore: 'arvore',
  nexo: 'nexo'
} as const

export interface ArticleItemDto {
  id: number
  /** @nullable */
  title: ArticleItemDtoTitle
  /** @nullable */
  subtitle: ArticleItemDtoSubtitle
  /** @nullable */
  author: ArticleItemDtoAuthor
  /** @nullable */
  image: ArticleItemDtoImage
  /** @nullable */
  degree: ArticleItemDtoDegree
  /** @nullable */
  schoolSegment: ArticleItemDtoSchoolSegment
  /** @nullable */
  publishDate: ArticleItemDtoPublishDate
  /** @nullable */
  disabled: ArticleItemDtoDisabled
  /** @nullable */
  isHighlighted: ArticleItemDtoIsHighlighted
  createdAt: string
  publisher: ArticleItemDtoPublisher
  hasActivity: boolean
}

export interface ArticlesPaginationDto {
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export interface ListArticlesResponseDto {
  data: ArticleItemDto[]
  pagination: ArticlesPaginationDto
}

export interface SchoolSegmentResponseDto {
  value: string
  label: string
  abbreviation: string
  recommendedDegrees: string[]
}

/**
 * @nullable
 */
export type ArticleCategoryDtoName = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleCategoryDtoSlug = { [key: string]: unknown } | null

export interface ArticleCategoryDto {
  id: number
  /** @nullable */
  name: ArticleCategoryDtoName
  /** @nullable */
  slug: ArticleCategoryDtoSlug
}

/**
 * @nullable
 */
export type ArticleResponseDtoTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoSubtitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoPublishDate = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoHtmlContent = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoHtmlRaw = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoDescription = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoCoverTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoCoverSubtitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoDisabled = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoImageAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoIsHighlighted = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoSchoolSegment = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ArticleResponseDtoRecommendedDegrees = {
  [key: string]: unknown
} | null

export interface ArticleResponseDto {
  id: number
  /** @nullable */
  title: ArticleResponseDtoTitle
  /** @nullable */
  subtitle: ArticleResponseDtoSubtitle
  /** @nullable */
  degree: ArticleResponseDtoDegree
  /** @nullable */
  image: ArticleResponseDtoImage
  /** @nullable */
  publishDate: ArticleResponseDtoPublishDate
  /** @nullable */
  htmlContent: ArticleResponseDtoHtmlContent
  /** @nullable */
  htmlRaw: ArticleResponseDtoHtmlRaw
  /** @nullable */
  author: ArticleResponseDtoAuthor
  /** @nullable */
  description: ArticleResponseDtoDescription
  /** @nullable */
  coverTitle: ArticleResponseDtoCoverTitle
  /** @nullable */
  coverSubtitle: ArticleResponseDtoCoverSubtitle
  /** @nullable */
  disabled: ArticleResponseDtoDisabled
  createdAt: string
  updatedAt: string
  /** @nullable */
  imageAuthor: ArticleResponseDtoImageAuthor
  /** @nullable */
  isHighlighted: ArticleResponseDtoIsHighlighted
  /** @nullable */
  schoolSegment: ArticleResponseDtoSchoolSegment
  /** @nullable */
  recommendedDegrees: ArticleResponseDtoRecommendedDegrees
  categories: ArticleCategoryDto[]
}

export type CreateArticleDtoSchoolSegment =
  typeof CreateArticleDtoSchoolSegment[keyof typeof CreateArticleDtoSchoolSegment]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateArticleDtoSchoolSegment = {
  EI: 'EI',
  EF1: 'EF1',
  EF2: 'EF2',
  EM: 'EM',
  G: 'G'
} as const

export interface CreateArticleDto {
  title: string
  subtitle: string
  coverTitle: string
  coverSubtitle: string
  schoolSegment: CreateArticleDtoSchoolSegment
  htmlContent: string
  author?: string
  imageAuthor?: string
  image?: string
  description?: string
  isHighlighted?: boolean
  publishDate?: string
  htmlRaw?: string
  categorySlug?: string
}

export type UpdateArticleDtoSchoolSegment =
  typeof UpdateArticleDtoSchoolSegment[keyof typeof UpdateArticleDtoSchoolSegment]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateArticleDtoSchoolSegment = {
  EI: 'EI',
  EF1: 'EF1',
  EF2: 'EF2',
  EM: 'EM',
  G: 'G'
} as const

export interface UpdateArticleDto {
  title?: string
  subtitle?: string
  coverTitle?: string
  coverSubtitle?: string
  schoolSegment?: UpdateArticleDtoSchoolSegment
  htmlContent?: string
  author?: string
  imageAuthor?: string
  image?: string
  description?: string
  isHighlighted?: boolean
  publishDate?: string
  htmlRaw?: string
  categorySlug?: string
}

export interface SchoolSegmentDto {
  label: string
  abbreviation: string
  value: string
  recommendedDegrees: string[]
}

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoTitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoSubtitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoCoverTitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoCoverSubtitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoPublishDate = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoHtmlContent = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoHtmlRaw = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoDescription = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoImageAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoPublisher = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ReaderArticleDetailsResponseDtoSchoolSegment =
  SchoolSegmentDto | null

export interface ReaderArticleDetailsResponseDto {
  id: number
  /** @nullable */
  title: ReaderArticleDetailsResponseDtoTitle
  /** @nullable */
  subtitle: ReaderArticleDetailsResponseDtoSubtitle
  /** @nullable */
  coverTitle: ReaderArticleDetailsResponseDtoCoverTitle
  /** @nullable */
  coverSubtitle: ReaderArticleDetailsResponseDtoCoverSubtitle
  /** @nullable */
  degree: ReaderArticleDetailsResponseDtoDegree
  /** @nullable */
  image: ReaderArticleDetailsResponseDtoImage
  /** @nullable */
  publishDate: ReaderArticleDetailsResponseDtoPublishDate
  /** @nullable */
  htmlContent: ReaderArticleDetailsResponseDtoHtmlContent
  /** @nullable */
  htmlRaw: ReaderArticleDetailsResponseDtoHtmlRaw
  /** @nullable */
  author: ReaderArticleDetailsResponseDtoAuthor
  /** @nullable */
  description: ReaderArticleDetailsResponseDtoDescription
  /** @nullable */
  imageAuthor: ReaderArticleDetailsResponseDtoImageAuthor
  /** @nullable */
  publisher: ReaderArticleDetailsResponseDtoPublisher
  /** @nullable */
  schoolSegment: ReaderArticleDetailsResponseDtoSchoolSegment
  activities: ActivityDto[]
}

export interface AdoptionListThemeItemDto {
  /** Item label */
  label: string
  /** Item slug */
  slug: string
}

export interface AdoptionListThemeGroupDto {
  /** Group label */
  label: string
  /** Group slug */
  slug: string
  /** Group items */
  items: AdoptionListThemeItemDto[]
}

export interface AdoptionListSensitiveThemesDto {
  /** Primary sensitive themes */
  primary: AdoptionListThemeItemDto[]
  /** Context sensitive themes */
  context: AdoptionListThemeItemDto[]
  /** Institutional sensitive themes */
  institutional: AdoptionListThemeItemDto[]
}

export interface AdoptionListFiltersResponseDto {
  /** Available degree options */
  degree: string[]
  /** Available genres */
  genres: AdoptionListThemeItemDto[]
  /** General themes */
  generalThemes: AdoptionListThemeGroupDto[]
  /** Sensitive themes */
  sensitiveThemes: AdoptionListSensitiveThemesDto
  /** Available awards */
  awards: AdoptionListThemeItemDto[]
}

/**
 * User origin from Identity (arvore, super, identity). Null when type is entity.
 * @nullable
 */
export type CheckAppAvailabilityResponseDtoOrigin = {
  [key: string]: unknown
} | null

/**
 * Whether the super_autor feature flag is enabled. Null when type is entity.
 * @nullable
 */
export type CheckAppAvailabilityResponseDtoHasSuperAutorFlag = {
  [key: string]: unknown
} | null

export interface CheckAppAvailabilityResponseDto {
  /** Whether the app is enabled for this identity */
  enabled: boolean
  /**
   * User origin from Identity (arvore, super, identity). Null when type is entity.
   * @nullable
   */
  origin: CheckAppAvailabilityResponseDtoOrigin
  /** Active module names for the entity (e.g. LER, CRIAR, LIVROS) */
  modules: string[]
  /**
   * Whether the super_autor feature flag is enabled. Null when type is entity.
   * @nullable
   */
  has_super_autor_flag: CheckAppAvailabilityResponseDtoHasSuperAutorFlag
}

export type FavoriteBookDtoDegree = { [key: string]: unknown }

export type FavoriteBookDtoLanguage = { [key: string]: unknown }

export interface FavoriteBookDto {
  id: number
  name: string
  slug: string
  author: string
  degree?: FavoriteBookDtoDegree
  language?: FavoriteBookDtoLanguage
  imageUrlThumb: string
  imageUrlThumbLow: string
  hasEbook: boolean
  hasAudioBook: boolean
  favoritedAt: string
}

export interface FavoriteBooksResponseDto {
  data: FavoriteBookDto[]
  total: number
  page: number
  pageSize: number
  hasNextPage: boolean
}

export type FavoriteItemDtoType =
  typeof FavoriteItemDtoType[keyof typeof FavoriteItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FavoriteItemDtoType = {
  book: 'book',
  video: 'video',
  podcast: 'podcast'
} as const

/**
 * @nullable
 */
export type FavoriteItemDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type FavoriteItemDtoLanguage = { [key: string]: unknown } | null

/**
 * Duração em segundos (vídeo)
 * @nullable
 */
export type FavoriteItemDtoDuration = { [key: string]: unknown } | null

export interface FavoriteItemDto {
  id: number
  type: FavoriteItemDtoType
  name: string
  slug: string
  author: string
  /** @nullable */
  degree?: FavoriteItemDtoDegree
  /** @nullable */
  language?: FavoriteItemDtoLanguage
  imageUrlThumb: string
  imageUrlThumbLow: string
  hasEbook: boolean
  hasAudioBook: boolean
  /**
   * Duração em segundos (vídeo)
   * @nullable
   */
  duration?: FavoriteItemDtoDuration
  favoritedAt: string
}

export interface FavoriteItemsResponseDto {
  data: FavoriteItemDto[]
  total: number
  page: number
  pageSize: number
  hasNextPage: boolean
}

export interface CheckFavoriteResponseDto {
  isFavorite: boolean
}

export interface ToggleFavoriteDto {
  /** Slug do livro */
  slug: string
}

export interface AnswerDto {
  /**
   * Is correct answer
   * @nullable
   */
  isCorrect: boolean | null
  /**
   * Activity estimated time in seconds
   * @nullable
   */
  activityEstimatedTimeInSeconds: number | null
  /**
   * Teacher user ID
   * @nullable
   */
  teacherUserId: number | null
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * User ID
   * @nullable
   */
  userId: number | null
  /**
   * Retry count
   * @nullable
   */
  retryCount: number | null
  /**
   * Activity article IDs
   * @nullable
   */
  activityArticleIds: string | null
  /**
   * Activity book IDs
   * @nullable
   */
  activityBookIds: string | null
  /**
   * Didactic sequence title
   * @nullable
   */
  didacticSequenceTitle: string | null
  /**
   * Activity degree range
   * @nullable
   */
  activityDegreeRange: string | null
  /**
   * Activity difficulty level
   * @nullable
   */
  activityDifficultyLevel: string | null
  /**
   * Activity title
   * @nullable
   */
  activityTitle: string | null
  /**
   * Activity description
   * @nullable
   */
  activityDescription: string | null
  /**
   * Page reference
   * @nullable
   */
  pageReference: string | null
  /**
   * Expected answer
   * @nullable
   */
  expectedAnswer: string | null
  /**
   * Question type
   * @nullable
   */
  questionType: string | null
  /**
   * Message
   * @nullable
   */
  message: string | null
  /**
   * Final comment
   * @nullable
   */
  finalComment: string | null
  /**
   * Final grade
   * @nullable
   */
  finalGrade: string | null
  /**
   * Answer status
   * @nullable
   */
  answerStatus: string | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Entity degree
   * @nullable
   */
  entityDegree: string | null
  /**
   * Entity ancestry
   * @nullable
   */
  entityAncestry: string | null
  /**
   * Grade
   * @nullable
   */
  grade: string | null
  /**
   * AI comment
   * @nullable
   */
  aiComment: string | null
  /**
   * AI grade
   * @nullable
   */
  aiGrade: string | null
  /**
   * Answer discursive
   * @nullable
   */
  answerDiscursive: string | null
  /**
   * End date
   * @nullable
   */
  endDate: string | null
  /**
   * Start date
   * @nullable
   */
  startDate: string | null
}

export interface GetAnswersResponseDto {
  /** Total number of results returned */
  total: number
  /** List of answers */
  data: AnswerDto[]
}

export interface BookPageViewDto {
  /**
   * Time read in seconds
   * @nullable
   */
  timeRead: string | null
  /**
   * Effective status
   * @nullable
   */
  isEffective: boolean | null
  /**
   * Offline status
   * @nullable
   */
  isOffline: boolean | null
  /**
   * Percentage read
   * @nullable
   */
  percentageRead: string | null
  /**
   * User ID
   * @nullable
   */
  userId: number | null
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * Book ID
   * @nullable
   */
  bookId: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Entity degree
   * @nullable
   */
  entityDegree: string | null
  /**
   * Entity ancestry
   * @nullable
   */
  entityAncestry: string | null
  /**
   * Created at
   * @nullable
   */
  createdAt: string | null
  /**
   * Created month
   * @nullable
   */
  createdMonth: number | null
  /**
   * Created year
   * @nullable
   */
  createdYear: number | null
  /**
   * Created hour
   * @nullable
   */
  createdHour: number | null
  /**
   * Created day
   * @nullable
   */
  createdDay: number | null
}

export interface GetBookPageViewsResponseDto {
  /** List of book page views records */
  data: BookPageViewDto[]
  /** Total number of results returned */
  total: number
}

export interface IndicationDto {
  /**
   * Target entity ID
   * @nullable
   */
  targetEntityId: number | null
  /**
   * Target user ID
   * @nullable
   */
  targetUserId: number | null
  /**
   * Content ID
   * @nullable
   */
  contentId: number | null
  /**
   * Source user ID
   * @nullable
   */
  sourceUserId: number | null
  /**
   * Source entity ID
   * @nullable
   */
  sourceEntityId: number | null
  /**
   * Target entity type
   * @nullable
   */
  targetEntityType: string | null
  /**
   * Target entity degree
   * @nullable
   */
  targetEntityDegree: string | null
  /**
   * Target entity ancestry
   * @nullable
   */
  targetEntityAncestry: string | null
  /**
   * Content type
   * @nullable
   */
  contentType: string | null
  /**
   * Source entity type
   * @nullable
   */
  sourceEntityType: string | null
  /**
   * Source entity degree
   * @nullable
   */
  sourceEntityDegree: string | null
  /**
   * Source entity ancestry
   * @nullable
   */
  sourceEntityAncestry: string | null
  /**
   * Due date
   * @nullable
   */
  dueDate: string | null
  /**
   * Indicated at date
   * @nullable
   */
  indicatedAt: string | null
  /**
   * Created at
   * @nullable
   */
  createdAt: string | null
  /**
   * Created month
   * @nullable
   */
  createdMonth: number | null
  /**
   * Created year
   * @nullable
   */
  createdYear: number | null
  /**
   * Created hour
   * @nullable
   */
  createdHour: number | null
  /**
   * Created day
   * @nullable
   */
  createdDay: number | null
}

export interface GetIndicationsResponseDto {
  /** List of indications */
  data: IndicationDto[]
  /** Total number of results returned */
  total: number
}

export interface LeagueRankingDto {
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * Rank position
   * @nullable
   */
  rankPosition: number | null
  /**
   * Points
   * @nullable
   */
  points: number | null
  /**
   * Month
   * @nullable
   */
  month: number | null
  /**
   * Year
   * @nullable
   */
  year: number | null
  /**
   * User ID
   * @nullable
   */
  userId: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Entity degree
   * @nullable
   */
  entityDegree: string | null
  /**
   * Entity ancestry
   * @nullable
   */
  entityAncestry: string | null
  /**
   * Tier
   * @nullable
   */
  tier: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
}

export interface GetLeagueRankingsResponseDto {
  /** List of league rankings */
  data: LeagueRankingDto[]
  /** Total number of results returned */
  total: number
}

export interface UserDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * Email
   * @nullable
   */
  email: string | null
  /**
   * User type
   * @nullable
   */
  userType: string | null
  /**
   * Job positions
   * @nullable
   */
  jobPositions: string | null
  /**
   * Created at
   * @nullable
   */
  createdAt: string | null
  /**
   * Created month
   * @nullable
   */
  createdMonth: number | null
  /**
   * Created year
   * @nullable
   */
  createdYear: number | null
  /**
   * Created hour
   * @nullable
   */
  createdHour: number | null
  /**
   * Created day
   * @nullable
   */
  createdDay: number | null
  /**
   * Last sign in at
   * @nullable
   */
  lastSignInAt: string | null
  /**
   * Last sign in month
   * @nullable
   */
  lastSignInMonth: number | null
  /**
   * Last sign in year
   * @nullable
   */
  lastSignInYear: number | null
  /**
   * Last sign in hour
   * @nullable
   */
  lastSignInHour: number | null
  /**
   * Last sign in day
   * @nullable
   */
  lastSignInDay: number | null
}

export interface GetUsersResponseDto {
  /** Total number of results returned */
  total: number
  /** List of users */
  data: UserDto[]
}

export interface ClassDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
}

export interface GetClassesResponseDto {
  /** Total number of results returned */
  total: number
  /** List of classes */
  data: ClassDto[]
}

export interface SchoolDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
}

export interface GetSchoolsResponseDto {
  /** Total number of results returned */
  total: number
  /** List of schools */
  data: SchoolDto[]
}

export interface NetworkDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
}

export interface GetNetworksResponseDto {
  /** Total number of results returned */
  total: number
  /** Array of network data */
  data: NetworkDto[]
}

export interface TrademarkDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
}

export interface GetTrademarksResponseDto {
  /** Total number of results returned */
  total: number
  /** Array of trademark data */
  data: TrademarkDto[]
}

export interface HoldingDto {
  /**
   * ID
   * @nullable
   */
  id: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Name
   * @nullable
   */
  name: string | null
}

export interface GetHoldingsResponseDto {
  /** Total number of results returned */
  total: number
  /** Holdings data */
  data: HoldingDto[]
}

export interface SessionDto {
  /**
   * Session ID
   * @nullable
   */
  sessionId: string | null
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Entity degree
   * @nullable
   */
  entityDegree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Idle seconds
   * @nullable
   */
  idleSeconds: string | null
  /**
   * Engaged seconds
   * @nullable
   */
  engagedSeconds: string | null
  /**
   * Last ping at
   * @nullable
   */
  lastPingAt: string | null
  /**
   * Last ping day
   * @nullable
   */
  lastPingDay: number | null
  /**
   * Last ping month
   * @nullable
   */
  lastPingMonth: number | null
  /**
   * Last ping year
   * @nullable
   */
  lastPingYear: number | null
  /**
   * Last ping hour
   * @nullable
   */
  lastPingHour: number | null
  /**
   * Started at
   * @nullable
   */
  startedAt: string | null
  /**
   * Started day
   * @nullable
   */
  startedDay: number | null
  /**
   * Started month
   * @nullable
   */
  startedMonth: number | null
  /**
   * Started year
   * @nullable
   */
  startedYear: number | null
  /**
   * Started hour
   * @nullable
   */
  startedHour: number | null
  /**
   * User ID
   * @nullable
   */
  userId: string | null
}

export interface GetSessionsResponseDto {
  /** Total number of results returned */
  total: number
  /** List of sessions. IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.) */
  data: SessionDto[]
}

export interface ReadingsFluencyDto {
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * User ID
   * @nullable
   */
  userId: number | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Degree
   * @nullable
   */
  degree: string | null
  /**
   * Ancestry
   * @nullable
   */
  ancestry: string | null
  /**
   * Book snippet
   * @nullable
   */
  bookSnippet: string | null
  /**
   * Partner leveling
   * @nullable
   */
  partnerLeveling: string | null
  /**
   * Assessment provider
   * @nullable
   */
  assessmentProvider: string | null
  /**
   * Success rate
   * @nullable
   */
  successRate: string | null
  /**
   * Correct words per minute
   * @nullable
   */
  correctWordsPerMinute: string | null
  /**
   * Created at
   * @nullable
   */
  createdAt: string | null
  /**
   * Created month
   * @nullable
   */
  createdMonth: number | null
  /**
   * Created year
   * @nullable
   */
  createdYear: number | null
  /**
   * Created hour
   * @nullable
   */
  createdHour: number | null
  /**
   * Created day
   * @nullable
   */
  createdDay: number | null
}

export interface GetReadingsFluencyResponseDto {
  /** List of readings fluency records */
  data: ReadingsFluencyDto[]
  /** Total number of results returned */
  total: number
}

export interface ReadingDto {
  /**
   * Book ID
   * @nullable
   */
  bookId: number | null
  /**
   * Effective percentage
   * @nullable
   */
  effectivePercentage: string | null
  /**
   * User ID
   * @nullable
   */
  userId: number | null
  /**
   * Total time spent in seconds
   * @nullable
   */
  totalTimeSpent: number | null
  /**
   * Entity ID
   * @nullable
   */
  entityId: number | null
  /**
   * Entity ancestry
   * @nullable
   */
  entityAncestry: string | null
  /**
   * Entity degree
   * @nullable
   */
  entityDegree: string | null
  /**
   * Entity type
   * @nullable
   */
  entityType: string | null
  /**
   * Achieved 10% at
   * @nullable
   */
  achieved10At: string | null
  /**
   * Achieved 10% month
   * @nullable
   */
  achieved10Month: number | null
  /**
   * Achieved 10% year
   * @nullable
   */
  achieved10Year: number | null
  /**
   * Achieved 10% hour
   * @nullable
   */
  achieved10Hour: number | null
  /**
   * Achieved 10% day
   * @nullable
   */
  achieved10Day: number | null
  /**
   * Achieved 50% at
   * @nullable
   */
  achieved50At: string | null
  /**
   * Achieved 50% month
   * @nullable
   */
  achieved50Month: number | null
  /**
   * Achieved 50% year
   * @nullable
   */
  achieved50Year: number | null
  /**
   * Achieved 50% hour
   * @nullable
   */
  achieved50Hour: number | null
  /**
   * Achieved 50% day
   * @nullable
   */
  achieved50Day: number | null
  /**
   * Created at
   * @nullable
   */
  createdAt: string | null
  /**
   * Created month
   * @nullable
   */
  createdMonth: number | null
  /**
   * Created year
   * @nullable
   */
  createdYear: number | null
  /**
   * Created hour
   * @nullable
   */
  createdHour: number | null
  /**
   * Created day
   * @nullable
   */
  createdDay: number | null
}

export interface GetReadingsResponseDto {
  /** List of readings records */
  data: ReadingDto[]
  /** Total number of results returned */
  total: number
}

export interface ChatSummaryDto {
  /** Unique chat ID */
  id: string
  /** Chat title */
  title: string
  /** Creation date */
  createdAt: string
  /** Update date */
  updatedAt: string
  /** Number of messages in chat */
  messageCount: number
}

export interface ListChatsResponseDto {
  /** User chat list */
  chats: ChatSummaryDto[]
  /** Total user chats */
  total: number
  /** Applied limit */
  limit: number
  /** Applied offset */
  offset: number
}

export interface CreateChatRequestDto {
  /**
   * Chat title
   * @minLength 1
   * @maxLength 255
   */
  title?: string
}

export interface CreateChatResponseDto {
  /** Unique chat ID */
  id: string
  /** Chat title */
  title: string
  /** Creation date */
  createdAt: string
  /** Update date */
  updatedAt: string
  /** Number of messages in chat */
  messageCount: number
}

export type ChatMessageDtoRole =
  typeof ChatMessageDtoRole[keyof typeof ChatMessageDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageDtoRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system'
} as const

export type ChatMessageDtoPartsItem = { [key: string]: unknown }

export interface ChatMessageDto {
  id: string
  role: ChatMessageDtoRole
  parts: ChatMessageDtoPartsItem[]
  createdAt?: string
}

export interface ChatRequestDto {
  id: string
  messages: ChatMessageDto[]
  trigger: string
}

export interface UpdateChatTitleRequestDto {
  /**
   * New chat title
   * @minLength 1
   * @maxLength 255
   */
  title: string
}

export interface UpdateChatTitleResponseDto {
  /** Unique chat ID */
  id: string
  /** New chat title */
  title: string
  /** Update date */
  updatedAt: string
}

export interface GenerateChatTitleBodyDto {
  /** First user message */
  userMessage: string
}

export interface GenerateChatTitleResponseDto {
  /** Generated chat title */
  title: string
}

/**
 * Message role
 */
export type MessageInputDtoRole =
  typeof MessageInputDtoRole[keyof typeof MessageInputDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageInputDtoRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system'
} as const

export type MessageInputDtoPartsItem = { [key: string]: unknown }

/**
 * Additional metadata (tool calls, attachments, etc.)
 */
export type MessageInputDtoMetadata = { [key: string]: unknown }

export interface MessageInputDto {
  /** Assistant Message ID */
  id?: string
  /** Message role */
  role: MessageInputDtoRole
  /** Message parts */
  parts: MessageInputDtoPartsItem[]
  /** Additional metadata (tool calls, attachments, etc.) */
  metadata?: MessageInputDtoMetadata
}

export interface SaveMessagesRequestDto {
  /**
   * List of messages to be saved
   * @minItems 1
   * @maxItems 100
   */
  messages: MessageInputDto[]
}

export interface SaveMessagesResponseDto {
  /** Number of saved messages */
  saved: number
  /** Saved message IDs */
  messageIds: string[]
}

/**
 * Message part type
 */
export type MessagePartDtoType =
  typeof MessagePartDtoType[keyof typeof MessagePartDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagePartDtoType = {
  text: 'text',
  'step-start': 'step-start',
  'dynamic-tool': 'dynamic-tool'
} as const

/**
 * Input data
 */
export type MessagePartDtoInput = { [key: string]: unknown }

/**
 * Output data
 */
export type MessagePartDtoOutput = { [key: string]: unknown }

/**
 * Provider metadata
 */
export type MessagePartDtoCallProviderMetadata = { [key: string]: unknown }

export interface MessagePartDto {
  /** Message part type */
  type: MessagePartDtoType
  /** Text content (for text type) */
  text?: string
  /** Tool name (for dynamic-tool type) */
  toolName?: string
  /** Tool call ID */
  toolCallId?: string
  /** State */
  state?: string
  /** Input data */
  input?: MessagePartDtoInput
  /** Output data */
  output?: MessagePartDtoOutput
  /** Provider metadata */
  callProviderMetadata?: MessagePartDtoCallProviderMetadata
}

/**
 * Feedback type
 */
export type MessageFeedbackDtoType =
  typeof MessageFeedbackDtoType[keyof typeof MessageFeedbackDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageFeedbackDtoType = {
  like: 'like',
  dislike: 'dislike'
} as const

export interface MessageFeedbackDto {
  /** Feedback type */
  type: MessageFeedbackDtoType
  /** Feedback creation date */
  createdAt: string
}

/**
 * Message role
 */
export type MessageDtoRole = typeof MessageDtoRole[keyof typeof MessageDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageDtoRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system'
} as const

/**
 * Additional metadata (tool calls, attachments, etc.)
 * @nullable
 */
export type MessageDtoMetadata = { [key: string]: unknown } | null

export interface MessageDto {
  /** Unique message ID */
  id: string
  /** Message role */
  role: MessageDtoRole
  /** Message parts */
  parts: MessagePartDto[]
  /**
   * Additional metadata (tool calls, attachments, etc.)
   * @nullable
   */
  metadata: MessageDtoMetadata
  /** Creation date */
  createdAt: string
  /** User feedback for this message (like/dislike) */
  feedback?: MessageFeedbackDto
}

export interface GetChatResponseDto {
  /** Unique chat ID */
  id: string
  /** Chat title */
  title: string
  /** Creation date */
  createdAt: string
  /** Update date */
  updatedAt: string
  /** Chat messages */
  messages: MessageDto[]
}

/**
 * Class degree
 * @nullable
 */
export type ListClassesByAncestryResponseDtoDegree = {
  [key: string]: unknown
} | null

/**
 * Creation date
 */
export type ListClassesByAncestryResponseDtoCreatedAt = {
  [key: string]: unknown
}

/**
 * Last update date
 */
export type ListClassesByAncestryResponseDtoUpdatedAt = {
  [key: string]: unknown
}

export interface ListClassesByAncestryResponseDto {
  /** Entity ID */
  id: number
  /** Class name */
  name: string
  /**
   * Class degree
   * @nullable
   */
  degree: ListClassesByAncestryResponseDtoDegree
  /** Creation date */
  createdAt: ListClassesByAncestryResponseDtoCreatedAt
  /** Last update date */
  updatedAt: ListClassesByAncestryResponseDtoUpdatedAt
}

/**
 * Reader profile ID
 * @nullable
 */
export type EntityUserReaderId = { [key: string]: unknown } | null

export interface EntityUser {
  /** User ID */
  user_id: string
  /** User name */
  name: string
  /**
   * Reader profile ID
   * @nullable
   */
  reader_id: EntityUserReaderId
  /** Whether the user is a teacher */
  is_teacher: boolean
}

/**
 * Entity degree
 * @nullable
 */
export type EntitySubtreeItemDegree = { [key: string]: unknown } | null

export interface EntitySubtreeItem {
  /** Entity ID */
  id: string
  /** Entity name */
  name: string
  /** Entity type */
  entity_type: string
  /**
   * Entity degree
   * @nullable
   */
  degree: EntitySubtreeItemDegree
  /** Users associated with this entity */
  users?: EntityUser[]
}

export interface GetEntitySubtreeResponseDto {
  /** Root entity ID */
  root_id: string
  /** List of entities in the subtree */
  items: EntitySubtreeItem[]
}

export interface EntityDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /** Entity type */
  entityType: string
}

/**
 * Class degree
 */
export type EntityClassDtoDegree = { [key: string]: unknown }

export interface EntityClassDto {
  /** Class ID */
  id: number
  /** Class name */
  name: string
  /** Class degree */
  degree: EntityClassDtoDegree
  /** Indicates if the class has reading fluency assessment in progress */
  hasReadingFluencyInProgress: boolean
}

export interface ClassesByEntityResponseDto {
  /** Entity information */
  entity: EntityDto
  /** List of classes */
  classes: EntityClassDto[]
}

export interface SearchEntitiesResponseDto {
  results: EntityDto[]
  total: number
}

/**
 * Entity degree (grade)
 * @nullable
 */
export type EntityChildDtoDegree = { [key: string]: unknown } | null

/**
 * Entity type
 */
export type EntityChildDtoType =
  typeof EntityChildDtoType[keyof typeof EntityChildDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityChildDtoType = {
  holding: 'holding',
  network: 'network',
  trademark: 'trademark',
  school: 'school',
  class: 'class'
} as const

export interface EntityChildDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /**
   * Entity degree (grade)
   * @nullable
   */
  degree: EntityChildDtoDegree
  /** Entity type */
  type: EntityChildDtoType
  /** Number of active users in this entity */
  usersCount: number
}

/**
 * Parent entity degree
 * @nullable
 */
export type GetEntityChildrenResponseDtoDegree = {
  [key: string]: unknown
} | null

export interface GetEntityChildrenResponseDto {
  /** Parent entity ID */
  id: number
  /**
   * Parent entity degree
   * @nullable
   */
  degree: GetEntityChildrenResponseDtoDegree
  /** List of direct children entities (paginated) */
  children: EntityChildDto[]
}

/**
 * Entity degree
 * @nullable
 */
export type RootEntityDtoDegree = { [key: string]: unknown } | null

export interface RootEntityDto {
  /** Entity ID */
  id: number
  /** Entity name */
  name: string
  /** Entity type */
  entity_type: string
  /**
   * Entity degree
   * @nullable
   */
  degree: RootEntityDtoDegree
}

export interface GetRootEntitiesResponseDto {
  /** List of root entities */
  roots: RootEntityDto[]
  /** Total number of root entities */
  total: number
}

/**
 * Entity degree
 * @nullable
 */
export type AdminRootEntityDtoDegree = { [key: string]: unknown } | null

export interface AdminRootEntityDto {
  /** Entity ID (UUID) */
  id: string
  /** Entity name */
  name: string
  /** Entity type */
  entity_type: string
  /**
   * Entity degree
   * @nullable
   */
  degree: AdminRootEntityDtoDegree
}

/**
 * Entity degree
 * @nullable
 */
export type EntityTreeNodeDegree = { [key: string]: unknown } | null

/**
 * Parent entity ID
 * @nullable
 */
export type EntityTreeNodeParentId = { [key: string]: unknown } | null

export interface EntityTreeNode {
  /** Entity ID */
  id: string
  /** Entity name */
  name: string
  /** Entity type */
  entity_type: string
  /**
   * Entity degree
   * @nullable
   */
  degree: EntityTreeNodeDegree
  /**
   * Parent entity ID
   * @nullable
   */
  parent_id: EntityTreeNodeParentId
  /** Users associated with this entity */
  users?: EntityUser[]
  /** Child entities */
  children?: EntityTreeNode[]
}

export interface RootWithTreeDto {
  /** Root entity basic info */
  root: AdminRootEntityDto
  /** Complete tree starting from this root */
  tree: EntityTreeNode
}

export interface GetRootEntitiesWithTreesAdminResponseDto {
  /** List of root entities with their complete trees */
  roots: RootWithTreeDto[]
  /** Total number of roots returned */
  total: number
}

export interface GetEntityTreeResponseDto {
  /** Root entity node with full subtree */
  root: EntityTreeNode
}

/**
 * Entity type
 * @nullable
 */
export type EntitySearchResultDtoEntityType =
  | typeof EntitySearchResultDtoEntityType[keyof typeof EntitySearchResultDtoEntityType]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitySearchResultDtoEntityType = {
  holding: 'holding',
  network: 'network',
  trademark: 'trademark',
  school: 'school',
  class: 'class'
} as const

export interface EntitySearchResultDto {
  /** Entity ID */
  id: number
  /**
   * Entity name
   * @nullable
   */
  name: string | null
  /**
   * Entity type
   * @nullable
   */
  entityType: EntitySearchResultDtoEntityType
  /**
   * Entity degree
   * @nullable
   */
  degree: string | null
  /**
   * Entity ancestry path
   * @nullable
   */
  ancestry: string | null
}

export interface SearchEntitiesAdminResponseDto {
  /** List of entities matching the search */
  results: EntitySearchResultDto[]
  /** Total number of matching entities */
  total: number
}

export interface RecentIntegrationItemDto {
  entityId: number
  /** @nullable */
  entityName: string | null
  /** @nullable */
  entityType: string | null
  hasIntegration: boolean
  integrationId: number
  /** @nullable */
  segment: string | null
  accessKeyCount: number
  createdAt: string
}

export interface GetRecentIntegrationsResponseDto {
  integrations: RecentIntegrationItemDto[]
}

export interface IntegrationDto {
  id: number
  /** @nullable */
  segment: string | null
  deactivated: boolean
  createdAt: string
  updatedAt: string
}

/**
 * @nullable
 */
export type GetEntityIntegrationResponseDtoIntegration = IntegrationDto | null

export interface GetEntityIntegrationResponseDto {
  entityId: number
  /** @nullable */
  entityName: string | null
  /** @nullable */
  legacyId: string | null
  hasIntegration: boolean
  hasB2bAccount: boolean
  accessKeyCount: number
  /** @nullable */
  integration: GetEntityIntegrationResponseDtoIntegration
}

export interface UpdateLegacyIdBodyDto {
  /** Legacy ID in UUID format */
  legacyId: string
}

export interface UpdateLegacyIdResponseDto {
  entityId: number
  legacyId: string
}

export interface GenerateAccessKeyResponseDto {
  accessToken: string
  secretToken: string
  createdAt: string
}

export interface DeactivateIntegrationResponseDto {
  success: boolean
  deactivatedAt: string
}

export interface DeleteAccessKeyBodyDto {
  /** The access token (key) to delete */
  accessToken: string
}

export interface DeleteAccessKeyResponseDto {
  /** Whether the access key was deleted */
  deleted: boolean
}

export interface CreateShareLinkBodyDto {
  /** Recipient email that will be allowed to view the credentials */
  recipientEmail: string
  /** Expiration in hours (1-72, default 24) */
  expirationHours?: number
}

export interface CreateShareLinkResponseDto {
  token: string
  shareUrl: string
  expiresAt: string
  recipientEmail: string
}

/**
 * @nullable
 */
export type EntityUserDtoAccessToken = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type EntityUserDtoPermissions = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type EntityUserDtoTeacherId = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type EntityUserDtoTeacherPermissions = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type EntityUserDtoAccessExpireDate = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type EntityUserDtoRoleName = { [key: string]: unknown } | null

export interface EntityUserDto {
  id: number
  userId: number
  name: string
  email: string
  /** @nullable */
  accessToken: EntityUserDtoAccessToken
  /** @nullable */
  permissions: EntityUserDtoPermissions
  /** @nullable */
  teacherId: EntityUserDtoTeacherId
  /** @nullable */
  teacherPermissions: EntityUserDtoTeacherPermissions
  /** @nullable */
  accessExpireDate: EntityUserDtoAccessExpireDate
  isTeacher: boolean
  /** @nullable */
  roleName: EntityUserDtoRoleName
  /** @nullable */
  roleId: number | null
  /** @nullable */
  gender: string | null
  /** @nullable */
  bornDate: string | null
  /** @nullable */
  documentNumber: string | null
  /** @nullable */
  documentType: string | null
  /** @nullable */
  zipCode: string | null
  /** @nullable */
  state: string | null
  /** @nullable */
  address: string | null
  /** @nullable */
  neighborhood: string | null
  /** @nullable */
  city: string | null
}

export interface GetEntityUsersResponseDto {
  entityId: number
  totalCount: number
  users: EntityUserDto[]
}

export type CreateEntityUserBodyDtoDocumentType =
  typeof CreateEntityUserBodyDtoDocumentType[keyof typeof CreateEntityUserBodyDtoDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateEntityUserBodyDtoDocumentType = {
  CPF: 'CPF',
  CRNM: 'CRNM'
} as const

export interface CreateEntityUserBodyDto {
  name: string
  email?: string
  roleId?: number
  /** Library ID for age-group class resolution */
  libraryId?: number
  gender?: string
  bornDate?: string
  documentNumber?: string
  documentType?: CreateEntityUserBodyDtoDocumentType
  zipCode?: string
  state?: string
  address?: string
  neighborhood?: string
  city?: string
}

/**
 * @nullable
 */
export type CreateEntityUserResponseDtoAccessToken = {
  [key: string]: unknown
} | null

export interface CreateEntityUserResponseDto {
  id: number
  userId: number
  /** @nullable */
  accessToken: CreateEntityUserResponseDtoAccessToken
}

export type UpdateEntityUserBodyDtoDocumentType =
  typeof UpdateEntityUserBodyDtoDocumentType[keyof typeof UpdateEntityUserBodyDtoDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEntityUserBodyDtoDocumentType = {
  CPF: 'CPF',
  CRNM: 'CRNM'
} as const

export interface UpdateEntityUserBodyDto {
  name?: string
  email?: string
  roleId?: number
  gender?: string
  bornDate?: string
  documentNumber?: string
  documentType?: UpdateEntityUserBodyDtoDocumentType
  zipCode?: string
  state?: string
  address?: string
  neighborhood?: string
  city?: string
}

export interface EntityUserActionResponseDto {
  success: boolean
  newPassword?: string
}

export interface MoveEntityUserBodyDto {
  targetEntityId: number
}

export interface RoleDto {
  id: number
  name: string
}

export interface ListRolesResponseDto {
  roles: RoleDto[]
}

export interface ChangeUserRoleBodyDto {
  roleId: number
}

export interface ChangeUserRoleResponseDto {
  success: boolean
}

/**
 * Entity type
 * @nullable
 */
export type GetEntityByIdResponseDtoEntityType =
  | typeof GetEntityByIdResponseDtoEntityType[keyof typeof GetEntityByIdResponseDtoEntityType]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEntityByIdResponseDtoEntityType = {
  holding: 'holding',
  network: 'network',
  trademark: 'trademark',
  school: 'school',
  class: 'class'
} as const

export interface GetEntityByIdResponseDto {
  /** Entity ID */
  id: number
  /**
   * Entity name
   * @nullable
   */
  name: string | null
  /**
   * Entity type
   * @nullable
   */
  entityType: GetEntityByIdResponseDtoEntityType
  /**
   * Entity degree
   * @nullable
   */
  degree: string | null
  /**
   * Entity city
   * @nullable
   */
  city: string | null
  /**
   * Entity state
   * @nullable
   */
  state: string | null
  /**
   * Entity ancestry
   * @nullable
   */
  ancestry: string | null
}

/**
 * Entity type
 */
export type SyncEntityBodyDtoEntityType =
  typeof SyncEntityBodyDtoEntityType[keyof typeof SyncEntityBodyDtoEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncEntityBodyDtoEntityType = {
  holding: 'holding',
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export interface SyncEntityBodyDto {
  /** Entity ID (Identity UUID or Arvore numeric id) */
  entity_id: string
  /** Entity type */
  entity_type: SyncEntityBodyDtoEntityType
}

export interface EntityTokenDto {
  /** Access token key */
  accessToken: string
  /** Secret token (UUID from access key ID) */
  secretToken: string
  /** Token creation date */
  createdAt: string
}

export interface GetEntityTokensResponseDto {
  /** Entity ID */
  entityId: number
  /**
   * Entity name
   * @nullable
   */
  entityName: string | null
  /** List of access tokens for this entity */
  tokens: EntityTokenDto[]
}

export interface ShareLinkInfoResponseDto {
  entityName: string
  requiresEmail: boolean
  expiresAt: string
}

export interface SendVerificationCodeBodyDto {
  /** Email to send verification code to */
  email: string
}

export interface SendVerificationCodeResponseDto {
  sent: boolean
}

export interface VerifyCodeBodyDto {
  /** Email used to request the code */
  email: string
  /** 6-digit verification code */
  code: string
}

export interface VerifyCodeResponseDto {
  entityName: string
  accessToken: string
  secretToken: string
}

export interface SuperAutorEligibilityDto {
  /** Whether the entity has the CRIAR module with an active contract */
  has_criar_module: boolean
  /** Whether the super_autor feature flag is enabled for this user */
  has_super_autor_flag: boolean
  /** Whether the user identity origin is from SuperAutor */
  is_from_super_autor_origin: boolean
  /** Whether all three conditions are met */
  eligible: boolean
}

export interface ReadingFluencyLevelDto {
  /**
   * Comprehension level name
   * @nullable
   */
  comprehension_level: string | null
  /**
   * Comprehension level slug
   * @nullable
   */
  comprehension_level_slug: string | null
  /**
   * Oral reading level name
   * @nullable
   */
  oral_reading_level: string | null
  /**
   * Oral reading level slug
   * @nullable
   */
  oral_reading_level_slug: string | null
}

export interface ReaderEntityDto {
  /** Class entity ID the reader is associated with */
  entity_id: number
  /** Class entity name */
  entity_name: string
}

/**
 * Otto AI access level
 */
export type OttoPermissionAccess =
  typeof OttoPermissionAccess[keyof typeof OttoPermissionAccess]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OttoPermissionAccess = {
  premium: 'premium',
  disabled: 'disabled'
} as const

export interface OttoPermission {
  /** Otto AI access level */
  access: OttoPermissionAccess
}

export interface ContractFeaturesDto {
  /** Can access reader */
  canAccessReader: boolean
  /** Can access Pressreader content */
  canAccessPressreaderContent: boolean
  /** Can access book progress bar */
  canAccessBookProgressBar: boolean
  /** Can access indications */
  canAccessIndications: boolean
  /** Can access my readings */
  canAccessMyReadings: boolean
  /** Can access favorites */
  canAccessFavorites: boolean
  /** Can access activities */
  canAccessActivities: boolean
  /** Can access related content */
  canAccessRelatedContent: boolean
  /** Can access search */
  canAccessSearch: boolean
  /** Can access categories */
  canAccessCategories: boolean
  /** Can access forest */
  canAccessForest: boolean
  /** Can access league content */
  canAccessLeagueContent: boolean
  /** Can access usage reports */
  canAccessUsageReports: boolean
  /** Can access custom collections */
  canAccessCustomCollections: boolean
  /** Can access didactic sequences */
  canAccessDidacticSequences: boolean
  /** Can access entity users management */
  canAccessEntityUsersManagement: boolean
  /** Can access admin panel */
  canAccessAdminPanel: boolean
  /** Can access reader v2 */
  canAccessReaderV2: boolean
  /** Can access running records */
  canAccessRunningRecords: boolean
  /** Can access reading fluency */
  canAccessReadingFluency: boolean
  /** Can access apply new fluency activity */
  canAccessApplyNewFluencyActivity: boolean
  /** Can manage activity */
  canManageActivity: boolean
  /** Is context non educational */
  isContextNonEducational: boolean
  /** Is disable weekly reading report notification */
  isDisableWeeklyReadingReportNotification: boolean
  /** Can manage applied activity */
  canManageAppliedActivity: boolean
}

/**
 * Feature toggles for the user - dynamic object with all LaunchDarkly flags in camelCase
 */
export type PermissionsFeatureToggles = { [key: string]: boolean }

export interface Permissions {
  /** Otto AI permissions */
  otto: OttoPermission
  /** Contract features permissions */
  contract_features: ContractFeaturesDto
  /** Feature toggles for the user - dynamic object with all LaunchDarkly flags in camelCase */
  feature_toggles: PermissionsFeatureToggles
}

/**
 * Entity type
 * @nullable
 */
export type GetUserInfoResponseDtoEntityType =
  | typeof GetUserInfoResponseDtoEntityType[keyof typeof GetUserInfoResponseDtoEntityType]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserInfoResponseDtoEntityType = {
  class: 'class',
  holding: 'holding',
  network: 'network',
  school: 'school',
  trademark: 'trademark'
} as const

/**
 * Reading fluency levels for the current year
 * @nullable
 */
export type GetUserInfoResponseDtoReadingFluency = ReadingFluencyLevelDto | null

export interface GetUserInfoResponseDto {
  /** User ID */
  user_id: number
  /** User full name */
  name: string
  /** User email address */
  email: string
  /** Whether the user is an admin */
  is_admin: boolean
  /**
   * Reader ID
   * @nullable
   */
  reader_id: number | null
  /**
   * Teacher ID
   * @nullable
   */
  teacher_id: number | null
  /**
   * Root organization ID
   * @nullable
   */
  root_id: number | null
  /**
   * Root organization name
   * @nullable
   */
  root_name: string | null
  /** Whether the root organization requires payment */
  root_require_payment: boolean
  /** Whether the user can log in with an access token (false when the root blocks token access) */
  can_login_with_token: boolean
  /**
   * Entity ID
   * @nullable
   */
  entity_id: number | null
  /**
   * Entity name
   * @nullable
   */
  entity_name: string | null
  /**
   * Entity type
   * @nullable
   */
  entity_type: GetUserInfoResponseDtoEntityType
  /**
   * Entity degree
   * @nullable
   */
  entity_degree: string | null
  /**
   * User role
   * @nullable
   */
  role: string | null
  /** User role-based permissions (e.g. can_manage_collections, can_manage_permissions) */
  role_permissions: string[]
  /**
   * User job positions (educator role in school)
   * @nullable
   */
  job_positions: string[] | null
  /**
   * User job areas (educator knowledge area)
   * @nullable
   */
  job_areas: string[] | null
  /**
   * Collection names associated with the entity
   * @nullable
   */
  collection_names: string[] | null
  /**
   * Module names associated with the entity (e.g. LIVROS, LER, CRIAR, SENTIR)
   * @nullable
   */
  module_names: string[] | null
  /** SuperAutor eligibility check results */
  super_autor_eligibility: SuperAutorEligibilityDto
  /**
   * Reading fluency levels for the current year
   * @nullable
   */
  reading_fluency: GetUserInfoResponseDtoReadingFluency
  /** Classes the reader is associated with (from user_entities) */
  reader_entities: ReaderEntityDto[]
  /** Whether the reader is associated with more than one class entity */
  multiple_entities: boolean
  /** User permissions */
  permission: Permissions
}

export interface DeactivateMyAccountResponseDto {
  deactivated: boolean
}

export interface BackofficeFeatureDto {
  /** Feature key */
  key: string
  /** Feature name */
  name: string
}

export interface GetBackofficeFeaturesResponseDto {
  /** Whether the user is a backoffice employee */
  is_employee: boolean
  /** List of backoffice features the employee can access */
  features: BackofficeFeatureDto[]
}

export interface GetOmsAccessResponseDto {
  /** Whether the user can access the OMS operation app */
  has_access: boolean
  /** OMS feature keys the employee can access */
  features: string[]
}

/**
 * @nullable
 */
export type MeClassItemDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type MeClassItemDtoIdentityId = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type MeClassItemDtoSchoolId = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type MeClassItemDtoSchoolName = { [key: string]: unknown } | null

export interface MeClassItemDto {
  entity_id: number
  name: string
  /** @nullable */
  degree: MeClassItemDtoDegree
  /** @nullable */
  identity_id: MeClassItemDtoIdentityId
  /** @nullable */
  school_id: MeClassItemDtoSchoolId
  /** @nullable */
  school_name: MeClassItemDtoSchoolName
}

export interface MeClassesResponseDto {
  classes: MeClassItemDto[]
}

/**
 * @nullable
 */
export type MeClassStudentItemDtoEmail = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type MeClassStudentItemDtoIdentityId = { [key: string]: unknown } | null

export interface MeClassStudentItemDto {
  user_id: number
  name: string
  /** @nullable */
  email: MeClassStudentItemDtoEmail
  /** @nullable */
  identity_id: MeClassStudentItemDtoIdentityId
  active: boolean
}

export interface MeClassStudentsResponseDto {
  students: MeClassStudentItemDto[]
}

export interface ListUsersByAncestryResponseDto {
  /** Class name */
  className: string
  /** User profile */
  profile: string
  /** Reader ID */
  readerId: number
  /** School name */
  schoolName: string
  /** User ID */
  userId: number
  /** User name */
  userName: string
}

export interface UserWithRolesDto {
  /** User ID */
  id: number
  /** User name */
  name: string
  /** Job positions (uppercase enum keys) */
  jobPositions: string[]
  /** Permission levels (uppercase enum keys) */
  roles: string[]
  /** Teacher profile ID when the user is staff */
  teacherId?: number
}

export interface ListUsersWithRolesResponseDto {
  /** Total users matching the filter */
  totalCount: number
  /** Users page */
  users: UserWithRolesDto[]
}

export interface SearchUsersResponseDto {
  results: UserDto[]
  total: number
}

/**
 * @nullable
 */
export type LookupUserResultDtoUserName = { [key: string]: unknown } | null

/**
 * User access token
 * @nullable
 */
export type LookupUserResultDtoAccessToken = { [key: string]: unknown } | null

/**
 * Class entity
 * @nullable
 */
export type LookupUserResultDtoClass = { [key: string]: unknown } | null

/**
 * School entity
 * @nullable
 */
export type LookupUserResultDtoSchool = { [key: string]: unknown } | null

/**
 * Network entity
 * @nullable
 */
export type LookupUserResultDtoNetwork = { [key: string]: unknown } | null

export interface LookupUserResultDto {
  userId: number
  /** @nullable */
  userName: LookupUserResultDtoUserName
  userEmail: string
  /**
   * User access token
   * @nullable
   */
  accessToken: LookupUserResultDtoAccessToken
  /** Whether user is educator (teacher/admin profile) */
  isEducator: boolean
  /**
   * Class entity
   * @nullable
   */
  class: LookupUserResultDtoClass
  /**
   * School entity
   * @nullable
   */
  school: LookupUserResultDtoSchool
  /**
   * Network entity
   * @nullable
   */
  network: LookupUserResultDtoNetwork
}

export interface LookupUserResponseDto {
  results: LookupUserResultDto[]
  total: number
}

export interface LookupUsersBatchItemDto {
  /** Email to look up */
  email?: string
  /** Access token to look up */
  accessToken?: string
}

export interface LookupUsersBatchRequestDto {
  /** List of users to look up by email and/or access token */
  items: LookupUsersBatchItemDto[]
}

/**
 * Email provided in the request
 * @nullable
 */
export type LookupUsersBatchResultItemDtoInputEmail = {
  [key: string]: unknown
} | null

/**
 * Access token provided in the request
 * @nullable
 */
export type LookupUsersBatchResultItemDtoInputAccessToken = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type LookupUsersBatchResultItemDtoUserId = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type LookupUsersBatchResultItemDtoUserName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type LookupUsersBatchResultItemDtoUserEmail = {
  [key: string]: unknown
} | null

/**
 * User access token
 * @nullable
 */
export type LookupUsersBatchResultItemDtoAccessToken = {
  [key: string]: unknown
} | null

/**
 * Class entity
 * @nullable
 */
export type LookupUsersBatchResultItemDtoClass = {
  [key: string]: unknown
} | null

/**
 * School entity
 * @nullable
 */
export type LookupUsersBatchResultItemDtoSchool = {
  [key: string]: unknown
} | null

/**
 * Network entity
 * @nullable
 */
export type LookupUsersBatchResultItemDtoNetwork = {
  [key: string]: unknown
} | null

export interface LookupUsersBatchResultItemDto {
  /**
   * Email provided in the request
   * @nullable
   */
  inputEmail: LookupUsersBatchResultItemDtoInputEmail
  /**
   * Access token provided in the request
   * @nullable
   */
  inputAccessToken: LookupUsersBatchResultItemDtoInputAccessToken
  /** Whether a matching user was found */
  found: boolean
  /** Whether the user is linked to an entity (class, school or network) */
  linked: boolean
  /** @nullable */
  userId: LookupUsersBatchResultItemDtoUserId
  /** @nullable */
  userName: LookupUsersBatchResultItemDtoUserName
  /** @nullable */
  userEmail: LookupUsersBatchResultItemDtoUserEmail
  /**
   * User access token
   * @nullable
   */
  accessToken: LookupUsersBatchResultItemDtoAccessToken
  /** Whether user is educator (teacher/admin profile) */
  isEducator: boolean
  /**
   * Class entity
   * @nullable
   */
  class: LookupUsersBatchResultItemDtoClass
  /**
   * School entity
   * @nullable
   */
  school: LookupUsersBatchResultItemDtoSchool
  /**
   * Network entity
   * @nullable
   */
  network: LookupUsersBatchResultItemDtoNetwork
}

export interface LookupUsersBatchResponseDto {
  results: LookupUsersBatchResultItemDto[]
  total: number
  /** Number of input rows with a matching user */
  foundCount: number
  /** Number of input rows without a matching user */
  notFoundCount: number
  /** Number of input rows whose user is linked to an entity */
  linkedCount: number
}

/**
 * Which platform profile to match against: 'student' (reader profiles in classes) or 'educator' (teachers/coordinators bound to the entity). Defaults to 'student'.
 */
export type NormalizeNamesRequestDtoProfileType =
  typeof NormalizeNamesRequestDtoProfileType[keyof typeof NormalizeNamesRequestDtoProfileType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NormalizeNamesRequestDtoProfileType = {
  student: 'student',
  educator: 'educator'
} as const

export interface NormalizeNamesRequestDto {
  /** Entity (class, school or network) to scope the search. When a school or network is provided, all readers of its descendant classes are considered. */
  entityId: number
  /** List of names (as written in the school spreadsheet) to normalize against the platform base */
  names: string[]
  /**
   * Minimum similarity score (0-1) for a name to be considered a match. Defaults to 0.72.
   * @minimum 0
   * @maximum 1
   */
  threshold?: number
  /** Which platform profile to match against: 'student' (reader profiles in classes) or 'educator' (teachers/coordinators bound to the entity). Defaults to 'student'. */
  profileType?: NormalizeNamesRequestDtoProfileType
}

/**
 * User access token
 * @nullable
 */
export type NormalizeNameMatchDtoAccessToken = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type NormalizeNameMatchDtoEmail = { [key: string]: unknown } | null

/**
 * Class entity id the reader belongs to
 * @nullable
 */
export type NormalizeNameMatchDtoClassId = { [key: string]: unknown } | null

/**
 * Class name the reader belongs to
 * @nullable
 */
export type NormalizeNameMatchDtoClassName = { [key: string]: unknown } | null

export interface NormalizeNameMatchDto {
  userId: number
  /** Canonical name as registered in the platform */
  userName: string
  /**
   * User access token
   * @nullable
   */
  accessToken: NormalizeNameMatchDtoAccessToken
  /** @nullable */
  email: NormalizeNameMatchDtoEmail
  /**
   * Class entity id the reader belongs to
   * @nullable
   */
  classId: NormalizeNameMatchDtoClassId
  /**
   * Class name the reader belongs to
   * @nullable
   */
  className: NormalizeNameMatchDtoClassName
  /** Similarity score (0-1) between the input name and this candidate */
  score: number
}

/**
 * @nullable
 */
export type NormalizeNameResultItemDtoBestMatch = NormalizeNameMatchDto | null

export interface NormalizeNameResultItemDto {
  /** Name provided in the request */
  inputName: string
  /** Whether a candidate above the threshold was found */
  matched: boolean
  /** @nullable */
  bestMatch: NormalizeNameResultItemDtoBestMatch
  /** Other close candidates, useful for manual disambiguation */
  alternatives: NormalizeNameMatchDto[]
}

export interface NormalizeNamesResponseDto {
  /** Entity used to scope the search */
  entityId: number
  /** Number of readers considered in the scope */
  candidateCount: number
  results: NormalizeNameResultItemDto[]
  /** Number of input names matched to a candidate */
  matchedCount: number
  /** Number of input names without a match above the threshold */
  unmatchedCount: number
}

/**
 * Feedback type
 */
export type UpsertFeedbackRequestDtoFeedbackType =
  typeof UpsertFeedbackRequestDtoFeedbackType[keyof typeof UpsertFeedbackRequestDtoFeedbackType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertFeedbackRequestDtoFeedbackType = {
  like: 'like',
  dislike: 'dislike'
} as const

export interface UpsertFeedbackRequestDto {
  /** Feedback type */
  feedbackType: UpsertFeedbackRequestDtoFeedbackType
}

/**
 * Feedback type
 */
export type UpsertFeedbackResponseDtoFeedbackType =
  typeof UpsertFeedbackResponseDtoFeedbackType[keyof typeof UpsertFeedbackResponseDtoFeedbackType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertFeedbackResponseDtoFeedbackType = {
  like: 'like',
  dislike: 'dislike'
} as const

export interface UpsertFeedbackResponseDto {
  /** Feedback ID */
  id: string
  /** User ID */
  userId: number
  /** Chat ID */
  chatId: string
  /** Message ID */
  messageId: string
  /** Feedback type */
  feedbackType: UpsertFeedbackResponseDtoFeedbackType
  /** Created at */
  createdAt: string
  /** Updated at */
  updatedAt: string
}

export interface AddCoinsResponseDto {
  /** Success message */
  message: string
  /** Number of coins added */
  coinsAdded: number
}

/**
 * @nullable
 */
export type AudiobookChapterResponseDtoArtwork = {
  [key: string]: unknown
} | null

export interface AudiobookChapterResponseDto {
  id: number
  title: string
  url: string
  /** @nullable */
  artwork: AudiobookChapterResponseDtoArtwork
  duration: number
  listenedTimestamp: number
  active: boolean
  hasListened: boolean
}

/**
 * @nullable
 */
export type AudiobookDetailsResponseDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type AudiobookDetailsResponseDtoSubtitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type AudiobookDetailsResponseDtoImageUrl = {
  [key: string]: unknown
} | null

export interface AudiobookDetailsResponseDto {
  slug: string
  name: string
  /** @nullable */
  author: AudiobookDetailsResponseDtoAuthor
  authors: string[]
  /** @nullable */
  subtitle: AudiobookDetailsResponseDtoSubtitle
  /** @nullable */
  imageUrl: AudiobookDetailsResponseDtoImageUrl
  audioBooks: AudiobookChapterResponseDto[]
}

export interface RegisterAudiobookProgressDto {
  /** Slug do livro */
  book_slug: string
  /** ID do audiobook (capítulo) */
  audio_book_id: number
  /** Timestamp inicial em segundos */
  initial_timestamp: number
  /** Timestamp final em segundos */
  final_timestamp: number
}

/**
 * @nullable
 */
export type VideoCollectionItemDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoCollectionItemDtoCoverImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoCollectionItemDtoDuration = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoCollectionItemDtoDegree = { [key: string]: unknown } | null

export interface VideoCollectionItemDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  author: VideoCollectionItemDtoAuthor
  /** @nullable */
  coverImage: VideoCollectionItemDtoCoverImage
  /** @nullable */
  duration: VideoCollectionItemDtoDuration
  /** @nullable */
  degree: VideoCollectionItemDtoDegree
}

/**
 * @nullable
 */
export type VideoCollectionDtoDescription = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoCollectionDtoCoverImage = { [key: string]: unknown } | null

export interface VideoCollectionDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: VideoCollectionDtoDescription
  /** @nullable */
  coverImage: VideoCollectionDtoCoverImage
  videos: VideoCollectionItemDto[]
}

export interface ListVideoCollectionsResponseDto {
  collections: VideoCollectionDto[]
}

/**
 * @nullable
 */
export type VideoDetailsResponseDtoDescription = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type VideoDetailsResponseDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoDetailsResponseDtoPublisher = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type VideoDetailsResponseDtoCoverImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type VideoDetailsResponseDtoDegree = { [key: string]: unknown } | null

export interface VideoDetailsResponseDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: VideoDetailsResponseDtoDescription
  /** @nullable */
  author: VideoDetailsResponseDtoAuthor
  /** @nullable */
  publisher: VideoDetailsResponseDtoPublisher
  /** @nullable */
  coverImage: VideoDetailsResponseDtoCoverImage
  /** @nullable */
  degree: VideoDetailsResponseDtoDegree
  url: string
  duration: number
  watchedTimestamp: number
  hasWatched: boolean
  hasActiveLoan: boolean
  previewMode: boolean
}

export interface RegisterVideoProgressDto {
  /** Slug do vídeo */
  video_slug: string
  /** Timestamp atual em segundos */
  current_timestamp: number
}

/**
 * @nullable
 */
export type LearningTrailItemDtoDescription = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LearningTrailItemDtoCoverImageUrl = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type LearningTrailItemDtoEstimatedDurationHours = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type LearningTrailItemDtoProgress = { [key: string]: unknown } | null

export interface LearningTrailItemDto {
  id: number
  title: string
  /** @nullable */
  description: LearningTrailItemDtoDescription
  /** @nullable */
  coverImageUrl: LearningTrailItemDtoCoverImageUrl
  experienceType: string
  /** @nullable */
  estimatedDurationHours: LearningTrailItemDtoEstimatedDurationHours
  /** @nullable */
  progress: LearningTrailItemDtoProgress
  totalActivities: number
}

export interface ListLearningTrailsResponseDto {
  trails: LearningTrailItemDto[]
}

export interface UserTrailProgressDto {
  trailId: number
  title: string
  /** @nullable */
  coverImageUrl: string | null
  status: string
  progress: number
  completedActivities: number
  totalActivities: number
}

export interface GetUserProgressResponseDto {
  trails: UserTrailProgressDto[]
}

export interface TrailActivityDto {
  id: number
  title: string
  activityType: string
  /** @nullable */
  estimatedDurationSeconds: number | null
  /** @nullable */
  difficultyLevel: string | null
  scoreReward: number
  status: string
}

export interface TrailSectionDto {
  id: number
  title: string
  position: number
  activities: TrailActivityDto[]
}

export interface GetTrailDetailResponseDto {
  id: number
  title: string
  /** @nullable */
  description: string | null
  /** @nullable */
  welcomeDescription: string | null
  /** @nullable */
  coverImageUrl: string | null
  experienceType: string
  /** @nullable */
  estimatedDurationHours: number | null
  /** @nullable */
  certificateDescription: string | null
  /** @nullable */
  learningObjectives: string[] | null
  /** @nullable */
  progress: number | null
  /** @nullable */
  status: string | null
  sections: TrailSectionDto[]
}

export interface StartTrailResponseDto {
  status: string
  startedAt: string
}

export interface CompleteActivityResponseDto {
  activityId: number
  status: string
  scoreEarned: number
  /** @nullable */
  nextActivityId: number | null
  trailCompleted: boolean
}

/**
 * @nullable
 */
export type TrailQuestionDtoOptions = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type TrailQuestionDtoUserAnswer = { [key: string]: unknown } | null

export interface TrailQuestionDto {
  id: number
  questionType: string
  prompt: string
  /** @nullable */
  options: TrailQuestionDtoOptions
  isGradable: number
  position: number
  /** @nullable */
  userAnswer: TrailQuestionDtoUserAnswer
}

export interface GetActivityContentResponseDto {
  id: number
  title: string
  activityType: string
  /** @nullable */
  contentBody: string | null
  /** @nullable */
  contentUrl: string | null
  /** @nullable */
  bookId: number | null
  /** @nullable */
  thumbnailUrl: string | null
  status: string
  /** @nullable */
  nextActivityId: number | null
  mediaPosition: number
  /** @nullable */
  suspendData: string | null
  /** @nullable */
  estimatedDurationSeconds: number | null
  /** @nullable */
  passingScore: number | null
  /** @nullable */
  questions: TrailQuestionDto[] | null
}

export interface SaveActivityProgressDto {
  mediaPosition: number
  suspendData?: string
}

export interface SaveActivityProgressResponseDto {
  saved: boolean
}

export type QuizAnswerDtoAnswer = { [key: string]: unknown }

export interface QuizAnswerDto {
  questionId: number
  answer: QuizAnswerDtoAnswer
}

export interface SubmitQuizDto {
  answers: QuizAnswerDto[]
}

export interface SubmitQuizResponseDto {
  score: number
  passed: boolean
  correctCount: number
  gradableCount: number
  attempt: number
}

export interface ImportScormDto {
  entityId: number
  title?: string
  categoryId?: number
}

export interface ImportScormResponseDto {
  trailId: number
  title: string
  sectionsCreated: number
  activitiesCreated: number
}

export interface BorrowVideoDto {
  /** Video ID to borrow */
  videoId: number
}

export interface ReserveVideoDto {
  /** Video ID to reserve */
  videoId: number
}

export interface BorrowBookDto {
  /** Book ID to borrow */
  bookId: number
}

/**
 * @nullable
 */
export type LoanHistoryBookDtoName = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryBookDtoSlug = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryBookDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryBookDtoAuthor = { [key: string]: unknown } | null

export interface LoanHistoryBookDto {
  id: number
  /** @nullable */
  name?: LoanHistoryBookDtoName
  /** @nullable */
  slug?: LoanHistoryBookDtoSlug
  /** @nullable */
  image?: LoanHistoryBookDtoImage
  /** @nullable */
  author?: LoanHistoryBookDtoAuthor
}

export type LoanHistoryItemDtoType =
  typeof LoanHistoryItemDtoType[keyof typeof LoanHistoryItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoanHistoryItemDtoType = {
  book: 'book',
  video: 'video',
  podcast: 'podcast'
} as const

export type LoanHistoryItemDtoStatus =
  typeof LoanHistoryItemDtoStatus[keyof typeof LoanHistoryItemDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoanHistoryItemDtoStatus = {
  returned: 'returned',
  expired: 'expired'
} as const

/**
 * @nullable
 */
export type LoanHistoryItemDtoReturnedAt = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryItemDtoTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryItemDtoSlug = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryItemDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type LoanHistoryItemDtoCoverImage = { [key: string]: unknown } | null

export interface LoanHistoryItemDto {
  id: number
  type: LoanHistoryItemDtoType
  bookId: number
  status: LoanHistoryItemDtoStatus
  borrowedAt: string
  dueAt: string
  /** @nullable */
  returnedAt?: LoanHistoryItemDtoReturnedAt
  renewalsCount: number
  /** @nullable */
  title?: LoanHistoryItemDtoTitle
  /** @nullable */
  slug?: LoanHistoryItemDtoSlug
  /** @nullable */
  author?: LoanHistoryItemDtoAuthor
  /** @nullable */
  coverImage?: LoanHistoryItemDtoCoverImage
  book: LoanHistoryBookDto
}

export interface LoanHistoryResponseDto {
  data: LoanHistoryItemDto[]
  total: number
  page: number
  limit: number
}

export interface ConfirmLoanInternalDto {
  /** User ID to confirm the loan for */
  userId: number
  /** Book ID to confirm the loan for */
  bookId: number
}

export interface ReserveBookDto {
  /** Book ID to reserve */
  bookId: number
}

export interface CheckVideoFavoriteResponseDto {
  isFavorite: boolean
}

export interface ToggleVideoFavoriteDto {
  /** Slug do vídeo */
  slug: string
}

export interface VideoSearchFacetBucketDto {
  parameter_value: string
  count: number
}

export interface VideoSearchRequestDto {
  /** @nullable */
  search_term?: string | null
  page?: number
  per_page?: number
  /** JSON URL-encoded com os filtros aplicáveis ao vídeo. Aceita as mesmas chaves do book-search (`language`, `indicated_year`, `imprint_or_publisher`, `book_authors`, `collections`). */
  opts?: string
  imprint_or_publisher?: string[]
}

export interface VideoSearchPublisherDto {
  id: number
  name: string
}

/**
 * @nullable
 */
export type VideoSearchItemDtoPublisher = VideoSearchPublisherDto | null

export interface VideoSearchItemDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  author?: string | null
  /** @nullable */
  description?: string | null
  /** @nullable */
  cover_image?: string | null
  /**
   * Duração total do vídeo em segundos
   * @nullable
   */
  duration?: number | null
  /** @nullable */
  degree?: string | null
  /** @nullable */
  language?: string | null
  /** @nullable */
  indicated_year?: string | null
  /** @nullable */
  publisher?: VideoSearchItemDtoPublisher
}

/**
 * Buckets de facets (degree, language, indicated_year, imprint_or_publisher, video_authors, collections)
 */
export type VideoSearchResponseDtoFacets = {
  [key: string]: VideoSearchFacetBucketDto[]
}

export interface VideoSearchResponseDto {
  videos: VideoSearchItemDto[]
  total: number
  page: number
  per_page: number
  /** Buckets de facets (degree, language, indicated_year, imprint_or_publisher, video_authors, collections) */
  facets: VideoSearchResponseDtoFacets
}

/**
 * @nullable
 */
export type PodcastEpisodeListItemDtoDescription = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeListItemDtoDurationSeconds = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeListItemDtoEpisodeNumber = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeListItemDtoSeasonNumber = {
  [key: string]: unknown
} | null

export interface PodcastEpisodeListItemDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: PodcastEpisodeListItemDtoDescription
  /** @nullable */
  durationSeconds: PodcastEpisodeListItemDtoDurationSeconds
  /** @nullable */
  episodeNumber: PodcastEpisodeListItemDtoEpisodeNumber
  /** @nullable */
  seasonNumber: PodcastEpisodeListItemDtoSeasonNumber
  /** @nullable */
  publishedAt: string | null
  listenedSeconds: number
  completed: boolean
}

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoDescription = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoPublisher = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoCoverImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastShowDetailsResponseDtoLanguage = {
  [key: string]: unknown
} | null

export interface PodcastShowDetailsResponseDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: PodcastShowDetailsResponseDtoDescription
  /** @nullable */
  author: PodcastShowDetailsResponseDtoAuthor
  /** @nullable */
  publisher: PodcastShowDetailsResponseDtoPublisher
  /** @nullable */
  coverImage: PodcastShowDetailsResponseDtoCoverImage
  /** @nullable */
  degree: PodcastShowDetailsResponseDtoDegree
  /** @nullable */
  language: PodcastShowDetailsResponseDtoLanguage
  hasActiveLoan: boolean
  episodes: PodcastEpisodeListItemDto[]
  totalEpisodes: number
  page: number
  perPage: number
}

/**
 * @nullable
 */
export type PodcastEpisodeDetailsResponseDtoDescription = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeDetailsResponseDtoDurationSeconds = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeDetailsResponseDtoEpisodeNumber = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeDetailsResponseDtoSeasonNumber = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type PodcastEpisodeDetailsResponseDtoShowCoverImage = {
  [key: string]: unknown
} | null

export interface PodcastEpisodeDetailsResponseDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: PodcastEpisodeDetailsResponseDtoDescription
  /** @nullable */
  durationSeconds: PodcastEpisodeDetailsResponseDtoDurationSeconds
  /** @nullable */
  episodeNumber: PodcastEpisodeDetailsResponseDtoEpisodeNumber
  /** @nullable */
  seasonNumber: PodcastEpisodeDetailsResponseDtoSeasonNumber
  /** @nullable */
  publishedAt: string | null
  listenedSeconds: number
  completed: boolean
  showId: number
  showSlug: string
  showTitle: string
  /** @nullable */
  showCoverImage: PodcastEpisodeDetailsResponseDtoShowCoverImage
  hasActiveLoan: boolean
}

export interface PodcastEpisodePlayResponseDto {
  /** URL assinada do MP3 */
  signedUrl: string
  /** Expiration ISO 8601 */
  expiresAt: string
  listenedSeconds: number
  previewMode: boolean
}

/**
 * @nullable
 */
export type PodcastShowItemDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type PodcastShowItemDtoCoverImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type PodcastShowItemDtoDegree = { [key: string]: unknown } | null

export interface PodcastShowItemDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  author: PodcastShowItemDtoAuthor
  /** @nullable */
  coverImage: PodcastShowItemDtoCoverImage
  /** @nullable */
  degree: PodcastShowItemDtoDegree
}

/**
 * @nullable
 */
export type PodcastCollectionDtoDescription = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type PodcastCollectionDtoCoverImage = { [key: string]: unknown } | null

export interface PodcastCollectionDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  description: PodcastCollectionDtoDescription
  /** @nullable */
  coverImage: PodcastCollectionDtoCoverImage
  podcastShows: PodcastShowItemDto[]
}

export interface ListPodcastCollectionsResponseDto {
  collections: PodcastCollectionDto[]
}

export interface RegisterPodcastProgressDto {
  /** Slug do episódio */
  episode_slug: string
  /** Segundos escutados */
  listened_seconds: number
  /** Se o episódio foi concluído */
  completed?: boolean
}

export interface BorrowPodcastDto {
  /** Podcast show ID to borrow */
  podcastShowId: number
}

export interface ReservePodcastDto {
  /** Podcast show ID to reserve */
  podcastShowId: number
}

export interface CheckPodcastFavoriteResponseDto {
  isFavorite: boolean
}

export interface TogglePodcastFavoriteDto {
  /** Slug do podcast show */
  slug: string
}

export interface PodcastSearchFacetBucketDto {
  parameter_value: string
  count: number
}

export interface PodcastSearchRequestDto {
  /** @nullable */
  search_term?: string | null
  page?: number
  per_page?: number
  /** JSON URL-encoded com os filtros aplicáveis ao podcast. Aceita as mesmas chaves do book-search (`language`, `indicated_year`, `imprint_or_publisher`, `podcast_authors`, `collections`). */
  opts?: string
  imprint_or_publisher?: string[]
}

export interface PodcastSearchPublisherDto {
  id: number
  name: string
}

/**
 * @nullable
 */
export type PodcastSearchItemDtoPublisher = PodcastSearchPublisherDto | null

export interface PodcastSearchItemDto {
  id: number
  slug: string
  title: string
  /** @nullable */
  author?: string | null
  /** @nullable */
  description?: string | null
  /** @nullable */
  cover_image?: string | null
  /** @nullable */
  degree?: string | null
  /** @nullable */
  language?: string | null
  /** @nullable */
  indicated_year?: string | null
  /** @nullable */
  publisher?: PodcastSearchItemDtoPublisher
}

/**
 * Buckets de facets (degree, language, indicated_year, imprint_or_publisher, podcast_authors, collections)
 */
export type PodcastSearchResponseDtoFacets = {
  [key: string]: PodcastSearchFacetBucketDto[]
}

export interface PodcastSearchResponseDto {
  shows: PodcastSearchItemDto[]
  total: number
  page: number
  per_page: number
  /** Buckets de facets (degree, language, indicated_year, imprint_or_publisher, podcast_authors, collections) */
  facets: PodcastSearchResponseDtoFacets
}

export interface BnccAbilityResponseDto {
  /** BNCC ability ID */
  id: number
  /** BNCC ability code */
  code: string
  /** BNCC ability description */
  description: string
  /** BNCC ability degree range */
  degreeRange: string
}

export type BookChatMessageDtoRole =
  typeof BookChatMessageDtoRole[keyof typeof BookChatMessageDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookChatMessageDtoRole = {
  user: 'user',
  assistant: 'assistant'
} as const

export interface BookChatMessageDto {
  role: BookChatMessageDtoRole
  /** @maxLength 2000 */
  content: string
}

export type StreamChatBodyDtoSource =
  typeof StreamChatBodyDtoSource[keyof typeof StreamChatBodyDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StreamChatBodyDtoSource = {
  'hybrid-offer': 'hybrid-offer',
  'adoption-list': 'adoption-list',
  'book-details': 'book-details'
} as const

export interface StreamChatBodyDto {
  book_slug: string
  messages: BookChatMessageDto[]
  source?: StreamChatBodyDtoSource
}

export type UpdateSessionBodyDtoSource =
  typeof UpdateSessionBodyDtoSource[keyof typeof UpdateSessionBodyDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSessionBodyDtoSource = {
  'hybrid-offer': 'hybrid-offer',
  'adoption-list': 'adoption-list',
  'book-details': 'book-details'
} as const

export interface UpdateSessionBodyDto {
  book_slug: string
  messages: BookChatMessageDto[]
  source?: UpdateSessionBodyDtoSource
}

export interface BookChatFeedbackBodyDto {
  book_id?: number
  book_slug?: string
  like: boolean
  dislike: boolean
}

export interface BookChatFeedbackTextBodyDto {
  book_id?: number
  book_slug?: string
  feedback: string
}

export interface EnqueueBookLevellingBodyDto {
  isbns: string[]
}

/**
 * Book name
 */
export type AdminCatalogedBookSummaryDtoName = { [key: string]: unknown }

/**
 * Book author
 */
export type AdminCatalogedBookSummaryDtoAuthor = { [key: string]: unknown }

/**
 * Book slug
 */
export type AdminCatalogedBookSummaryDtoSlug = { [key: string]: unknown }

/**
 * Thumbnail image URL (183x268)
 */
export type AdminCatalogedBookSummaryDtoThumbnailUrl = {
  [key: string]: unknown
}

/**
 * Degree/série da catalogação
 */
export type AdminCatalogedBookSummaryDtoDegree = { [key: string]: unknown }

export interface AdminCatalogedBookSummaryDto {
  /** Book ID */
  bookId: number
  /** Book name */
  name?: AdminCatalogedBookSummaryDtoName
  /** Book author */
  author?: AdminCatalogedBookSummaryDtoAuthor
  /** Book slug */
  slug?: AdminCatalogedBookSummaryDtoSlug
  /** Thumbnail image URL (183x268) */
  thumbnailUrl?: AdminCatalogedBookSummaryDtoThumbnailUrl
  /** Degree/série da catalogação */
  degree?: AdminCatalogedBookSummaryDtoDegree
  /** Confidence score da catalogação (0-1) */
  confidenceScore: number
  /** Total de temas de sensibilidade detectados pelo abismal (qualquer score) */
  sensitivityTotal: number
  /** Temas de sensibilidade exibidos ao usuário (score >= threshold) */
  sensitivityDisplayed: number
  /** Data da última catalogação (ISO) */
  updatedAt: string
}

export interface AdminCatalogedBooksPaginationDto {
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
  /** Total count of matching books */
  totalCount: number
  /** Total number of pages */
  totalPages: number
}

export interface AdminListCatalogedBooksResponseDto {
  /** Lista de livros catalogados pelo abismal (visão admin) */
  data: AdminCatalogedBookSummaryDto[]
  /** Pagination metadata */
  pagination: AdminCatalogedBooksPaginationDto
}

export interface CatalogedBookThemeDto {
  /** Theme name */
  name: string
  /** Theme items */
  items: string[]
}

export interface SensitivityEvidenceDto {
  /** Evidence text excerpt or image description */
  text: string
  /** Page number where the sensitive content was found (image analysis only) */
  pageNumber?: number
  /** URL of the image where the sensitive content was detected (image analysis only) */
  imageUrl?: string
}

export interface AdminCatalogedBookSensitivityDto {
  /** ID da linha de sensibilidade */
  id?: number
  /** Sensitivity type */
  type: string
  /** Sensitive topic label (slug) */
  label: string
  /** Confidence score (0-1) */
  score: number
  /** Detection status */
  status: string
  /** Evidence excerpts */
  evidenceExcerpts: SensitivityEvidenceDto[]
  /** Image URLs (image analysis only) */
  imageUrls?: string[]
  /** Se o score atinge o threshold de exibição (>= 0.8) */
  meetsScoreThreshold: boolean
  /** Se o tema é restrito a coleções institucionais (ex: adventista) */
  isInstitutionalRestricted: boolean
  /** Se o tema é efetivamente exibido ao usuário final */
  displayedToUser: boolean
}

/**
 * Book name
 */
export type AdminCatalogedBookDetailDtoName = { [key: string]: unknown }

/**
 * Book description
 */
export type AdminCatalogedBookDetailDtoDescription = { [key: string]: unknown }

/**
 * Cover image URL (283x418)
 */
export type AdminCatalogedBookDetailDtoImageUrl = { [key: string]: unknown }

/**
 * Thumbnail image URL (183x268)
 */
export type AdminCatalogedBookDetailDtoThumbnailUrl = { [key: string]: unknown }

/**
 * Book author
 */
export type AdminCatalogedBookDetailDtoAuthor = { [key: string]: unknown }

/**
 * Book publisher
 */
export type AdminCatalogedBookDetailDtoPublisher = { [key: string]: unknown }

/**
 * Degree/série da catalogação
 */
export type AdminCatalogedBookDetailDtoDegree = { [key: string]: unknown }

/**
 * Book slug
 */
export type AdminCatalogedBookDetailDtoSlug = { [key: string]: unknown }

export interface AdminCatalogedBookDetailDto {
  /** Book ID */
  bookId: number
  /** Book name */
  name?: AdminCatalogedBookDetailDtoName
  /** Book description */
  description?: AdminCatalogedBookDetailDtoDescription
  /** Cover image URL (283x418) */
  imageUrl?: AdminCatalogedBookDetailDtoImageUrl
  /** Thumbnail image URL (183x268) */
  thumbnailUrl?: AdminCatalogedBookDetailDtoThumbnailUrl
  /** Book author */
  author?: AdminCatalogedBookDetailDtoAuthor
  /** Book publisher */
  publisher?: AdminCatalogedBookDetailDtoPublisher
  /** Degree/série da catalogação */
  degree?: AdminCatalogedBookDetailDtoDegree
  /** Book slug */
  slug?: AdminCatalogedBookDetailDtoSlug
  /** Confidence score da catalogação (0-1) */
  confidenceScore: number
  /** ID da catalogação no DynamoDB */
  catalogationDynamoId: string
  /** Book genres */
  genres: string[]
  /** Cataloged book themes */
  themes: CatalogedBookThemeDto[]
  /** Todos os temas de sensibilidade detectados (crus, sem filtro de exibição) */
  sensitivity: AdminCatalogedBookSensitivityDto[]
}

export interface AdminGetCatalogedBookDetailResponseDto {
  /** Detalhe admin da catalogação */
  data: AdminCatalogedBookDetailDto
}

/**
 * Tipo de sensibilidade
 */
export type AddManualSensitivityBodyDtoType =
  typeof AddManualSensitivityBodyDtoType[keyof typeof AddManualSensitivityBodyDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddManualSensitivityBodyDtoType = {
  sensitive: 'sensitive',
  contextual: 'contextual',
  institutional: 'institutional'
} as const

export interface AddManualSensitivityBodyDto {
  /** Tipo de sensibilidade */
  type: AddManualSensitivityBodyDtoType
  /** Rótulo do tema (slug) */
  label: string
  /** Score de confiança (0-1) */
  score: number
  /** Status da detecção */
  status: string
  /** Trechos de evidência do livro */
  excerpts: string[]
}

export interface AddManualSensitivityResponseDto {
  /** ID da linha de sensibilidade criada */
  id: number
}

export interface CatalogedBookSummarySensitivityDto {
  /** Sensitivity type */
  type: string
  /** Sensitive topic label (slug) */
  label: string
  /** Confidence score */
  score: number
  /** Detection status */
  status: string
}

export interface CatalogedBookAwardDto {
  /** Award type */
  type: string
  /** Award year */
  year: string
}

/**
 * Book name
 */
export type CatalogedBookSummaryDtoName = { [key: string]: unknown }

/**
 * Book description
 */
export type CatalogedBookSummaryDtoDescription = { [key: string]: unknown }

/**
 * Cover image URL (283x418)
 */
export type CatalogedBookSummaryDtoImageUrl = { [key: string]: unknown }

/**
 * Thumbnail image URL (183x268)
 */
export type CatalogedBookSummaryDtoThumbnailUrl = { [key: string]: unknown }

/**
 * Book author
 */
export type CatalogedBookSummaryDtoAuthor = { [key: string]: unknown }

/**
 * Book publisher
 */
export type CatalogedBookSummaryDtoPublisher = { [key: string]: unknown }

/**
 * School grade
 */
export type CatalogedBookSummaryDtoDegree = { [key: string]: unknown }

/**
 * Book slug
 */
export type CatalogedBookSummaryDtoSlug = { [key: string]: unknown }

export interface CatalogedBookSummaryDto {
  /** Book ID */
  bookId: number
  /** Book name */
  name?: CatalogedBookSummaryDtoName
  /** Book description */
  description?: CatalogedBookSummaryDtoDescription
  /** Cover image URL (283x418) */
  imageUrl?: CatalogedBookSummaryDtoImageUrl
  /** Thumbnail image URL (183x268) */
  thumbnailUrl?: CatalogedBookSummaryDtoThumbnailUrl
  /** Book author */
  author?: CatalogedBookSummaryDtoAuthor
  /** Book publisher */
  publisher?: CatalogedBookSummaryDtoPublisher
  /** School grade */
  degree?: CatalogedBookSummaryDtoDegree
  /** Book slug */
  slug?: CatalogedBookSummaryDtoSlug
  /** Book genres */
  genres: string[]
  /** Cataloged book themes */
  themes: CatalogedBookThemeDto[]
  /** Sensitive topics identified in the book (without evidence excerpts; use the detail endpoint for full evidence). */
  sensitivity: CatalogedBookSummarySensitivityDto[]
  /** Book awards */
  awards: CatalogedBookAwardDto[]
  /** Whether the book is in the top 100 most read of the previous year */
  isTopRead: boolean
  /** Whether the book is frequently chosen by schools */
  isMostChosen: boolean
}

export interface CatalogedBooksPaginationDto {
  /** Current page */
  page: number
  /** Page size */
  pageSize: number
  /** Total count of matching books */
  totalCount: number
  /** Total number of pages */
  totalPages: number
}

export interface ListCatalogedBooksResponseDto {
  /** List of cataloged books (summary shape, without evidence excerpts) */
  data: CatalogedBookSummaryDto[]
  /** Pagination metadata */
  pagination: CatalogedBooksPaginationDto
}

export interface CatalogedBookSensitivityDto {
  /** Sensitivity type */
  type: string
  /** Sensitive topic label */
  label: string
  /** Confidence score */
  score: number
  /** Detection status */
  status: string
  /** Evidence excerpts extracted from the book (text or image analysis) */
  evidenceExcerpts: SensitivityEvidenceDto[]
  /** Image URLs associated with this sensitivity label (image analysis only) */
  imageUrls?: string[]
}

export interface GetBookSensitivitySentencesResponseDto {
  /** Sensitivity data filtered by label with evidence excerpts */
  data: CatalogedBookSensitivityDto[]
}

/**
 * Book name
 */
export type CatalogedBookDtoName = { [key: string]: unknown }

/**
 * Book description
 */
export type CatalogedBookDtoDescription = { [key: string]: unknown }

/**
 * Cover image URL (high resolution, 283x418)
 */
export type CatalogedBookDtoImageUrl = { [key: string]: unknown }

/**
 * Thumbnail image URL (low resolution, 183x268)
 */
export type CatalogedBookDtoThumbnailUrl = { [key: string]: unknown }

/**
 * Book author
 */
export type CatalogedBookDtoAuthor = { [key: string]: unknown }

/**
 * Book publisher
 */
export type CatalogedBookDtoPublisher = { [key: string]: unknown }

/**
 * School grade
 */
export type CatalogedBookDtoDegree = { [key: string]: unknown }

/**
 * Book slug
 */
export type CatalogedBookDtoSlug = { [key: string]: unknown }

export interface CatalogedBookDto {
  /** Book ID */
  bookId: number
  /** Book name */
  name?: CatalogedBookDtoName
  /** Book description */
  description?: CatalogedBookDtoDescription
  /** Cover image URL (high resolution, 283x418) */
  imageUrl?: CatalogedBookDtoImageUrl
  /** Thumbnail image URL (low resolution, 183x268) */
  thumbnailUrl?: CatalogedBookDtoThumbnailUrl
  /** Book author */
  author?: CatalogedBookDtoAuthor
  /** Book publisher */
  publisher?: CatalogedBookDtoPublisher
  /** School grade */
  degree?: CatalogedBookDtoDegree
  /** Book slug */
  slug?: CatalogedBookDtoSlug
  /** Book genres */
  genres: string[]
  /** Cataloged book themes */
  themes: CatalogedBookThemeDto[]
  /** Sensitive topics identified in the book */
  sensitivity: CatalogedBookSensitivityDto[]
  /** Book awards */
  awards: CatalogedBookAwardDto[]
  /** Whether the book is in the top 100 most read of the previous year */
  isTopRead: boolean
  /** Whether the book is frequently chosen by schools */
  isMostChosen: boolean
}

export interface GetCatalogedBookDetailResponseDto {
  /** Cataloged book detail with evidence excerpts */
  data: CatalogedBookDto
}

/**
 * List name
 */
export type CatalogationListDtoName = { [key: string]: unknown }

/**
 * List description (can be null)
 * @nullable
 */
export type CatalogationListDtoDescription = { [key: string]: unknown } | null

export interface CatalogationListDto {
  /** List ID */
  id: number
  /** Educator user ID */
  userId: number
  /** School grade */
  degree: string
  /** List name */
  name: CatalogationListDtoName
  /**
   * List description (can be null)
   * @nullable
   */
  description: CatalogationListDtoDescription
  /** Books associated with the list including full details */
  books: CatalogedBookDto[]
}

export interface GetCatalogationListsResponseDto {
  /** Educator adoption lists */
  data: CatalogationListDto[]
}

/**
 * Tipo do destinatário
 */
export type ContentIndicationTargetDtoTargetType =
  typeof ContentIndicationTargetDtoTargetType[keyof typeof ContentIndicationTargetDtoTargetType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentIndicationTargetDtoTargetType = {
  user: 'user',
  entity: 'entity'
} as const

export interface ContentIndicationTargetDto {
  /** ID do destinatário (userId ou entityId) */
  targetId: number
  /** Tipo do destinatário */
  targetType: ContentIndicationTargetDtoTargetType
}

export interface CreateContentIndicationsFromAdoptionListBodyDto {
  /** Destinatários da indicação (alunos ou turmas) */
  targets: ContentIndicationTargetDto[]
  /** Data limite para leitura (YYYY-MM-DD). Não pode ser no passado */
  dueDate?: string
}

export interface CreateContentIndicationsFromAdoptionListResponseDto {
  /** Quantidade de indicações criadas */
  count: number
  /** Mensagem de sucesso */
  message: string
}

export interface CreateCatalogationListBodyDto {
  /** ID da lista existente para adicionar novos livros */
  bookListId?: number
  /** ID do educador */
  userId: number
  /** Ano escolar selecionado */
  degree?: string
  /** IDs dos livros selecionados */
  bookIds: number[]
}

/**
 * List description (can be null)
 * @nullable
 */
export type CreateCatalogationListResponseDtoDescription = {
  [key: string]: unknown
} | null

export interface CreateCatalogationListResponseDto {
  /** List ID */
  id: number
  /** Educator user ID */
  userId: number
  /** School grade */
  degree: string
  /** List name */
  name: string
  /**
   * List description (can be null)
   * @nullable
   */
  description: CreateCatalogationListResponseDtoDescription
  /** Book IDs sent in the request */
  bookIds: number[]
}

export interface UpdateCatalogationListBodyDto {
  /** New list name */
  name?: string
  /** New list description */
  description?: string
}

/**
 * Updated list name
 * @nullable
 */
export type UpdateCatalogationListResponseDtoName = {
  [key: string]: unknown
} | null

/**
 * Updated list description
 * @nullable
 */
export type UpdateCatalogationListResponseDtoDescription = {
  [key: string]: unknown
} | null

export interface UpdateCatalogationListResponseDto {
  /** List ID */
  id: number
  /**
   * Updated list name
   * @nullable
   */
  name: UpdateCatalogationListResponseDtoName
  /**
   * Updated list description
   * @nullable
   */
  description: UpdateCatalogationListResponseDtoDescription
}

export interface GenerateListDescriptionResponseDto {
  /** Descricao gerada por IA para a lista de livros */
  description: string
}

export interface CreateConverseComLivroFeedbackBodyDto {
  /** Book ID */
  bookId: number
  /** Whether the user liked the conversation */
  like: boolean
  /** Whether the user disliked the conversation */
  dislike: boolean
}

export interface ReprocessAudiobookBodyDto {
  /** Book identifier to reprocess. Accepts id, ISBN or slug. */
  bookIdentifier: string
  /** Optional audiobook duplicate identifier. Accepts id, ISBN or slug. When omitted, the backend tries to infer it from the ebook metadata. */
  audioBookIdentifier?: string
}

export interface ReprocessAudiobookResponseDto {
  /** Target ebook id */
  bookId: number
  /** Audiobook duplicate book id used as the source of the relink */
  audioBookBookId?: number
  /** Number of audio tracks relinked to the ebook */
  audioTracksRelinked: number
  /** Whether the duplicate audiobook book record was removed */
  duplicateAudioBookRemoved: boolean
  /** Whether the ebook was already correctly linked before the operation */
  alreadyLinked: boolean
  /** User-facing summary of the result */
  message: string
}

export interface SetTakedownDateDto {
  slug: string
  deactivation_date: string
}

export interface SetTakedownDateBatchDto {
  entries: SetTakedownDateDto[]
}

/**
 * License modality (default simultaneous)
 */
export type UploadCatalogBookBodyDtoModality =
  typeof UploadCatalogBookBodyDtoModality[keyof typeof UploadCatalogBookBodyDtoModality]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadCatalogBookBodyDtoModality = {
  perpetual: 'perpetual',
  metered: 'metered',
  simultaneous: 'simultaneous',
  hybrid: 'hybrid'
} as const

export interface UploadCatalogBookBodyDto {
  /** Book title */
  title: string
  /** Subtitle */
  subtitle?: string
  /** Author name */
  author: string
  /** ISBN */
  isbn: string
  /** Publisher name */
  publisher?: string
  /** Language code (pt, en, es...) */
  language?: string
  /** Edition */
  edition?: string
  /** Imprint */
  imprint?: string
  /** Description / synopsis */
  description?: string
  /** Minimum age */
  minimumAge?: number
  /** Recommended grade (degree) */
  degree?: string
  /** Audiobook ISBN (if including audio tracks) */
  audioBookIsbn?: string
  /** Max simultaneous accesses (default 20 for simultaneous/hybrid modality) */
  maxSimultaneous?: number
  /** License modality (default simultaneous) */
  modality?: UploadCatalogBookBodyDtoModality
  /** Number of copies (required for metered and hybrid) */
  copies?: number
  /** License expiration date (ISO 8601) */
  expiresAt?: string
}

export interface UploadCatalogVideoBodyDto {
  /** Video title */
  title: string
  /** Description */
  description?: string
  /** Author / producer */
  author?: string
  /** Degree/grade (EI, EF1, EF2, EM) */
  degree?: string
  /** Max simultaneous accesses (default 20) */
  maxSimultaneous?: number
}

export interface UploadCatalogPodcastBodyDto {
  /** Podcast title */
  title: string
  /** Description */
  description?: string
  /** Author / producer */
  author?: string
  /** Language (pt, en, es) */
  language?: string
  /** Degree/grade (EI, EF1, EF2, EM) */
  degree?: string
  /** Max simultaneous accesses (default 20) */
  maxSimultaneous?: number
  /** Episode titles, ordered to match the uploaded episodeAudios files */
  episodeTitles: string[]
}

export interface UpsertCartItemBodyDto {
  /**
   * Number of copies (loans per copy defined per book/publisher)
   * @minimum 1
   */
  copies: number
  /**
   * Maximum simultaneous loans
   * @minimum 1
   */
  maxSimultaneous: number
  /** Auto renew the license after expiration */
  autoRenew?: boolean
}

export interface UpdateDigitalCatalogItemBodyDto {
  /**
   * Max simultaneous accesses for this book. Use null to clear.
   * @nullable
   */
  maxSimultaneous?: number | null
}

export interface UpsertLicenseAlertPreferencesDto {
  license_acquired: boolean
  license_expiring: boolean
  expiring_days: number
  license_usage_limit: boolean
  usage_limit_percent: number
  marketplace_receipt?: boolean
  marketplace_auto_renew_default?: boolean
}

export type CreateCampanhaFluenciaLeadBodyDtoSchoolType =
  typeof CreateCampanhaFluenciaLeadBodyDtoSchoolType[keyof typeof CreateCampanhaFluenciaLeadBodyDtoSchoolType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCampanhaFluenciaLeadBodyDtoSchoolType = {
  publica: 'publica',
  privada: 'privada'
} as const

export interface CreateCampanhaFluenciaLeadBodyDto {
  name: string
  email?: string
  phone: string
  schoolName?: string
  schoolType?: CreateCampanhaFluenciaLeadBodyDtoSchoolType
  gradeLevel?: string
  studentCount?: string
  /** Lead attribution source */
  source?: string
}

export interface GenerateBookUploadUrlDto {
  bookId: number
}

export interface ProcessBookDto {
  isbn: string
}

export interface ProcessBookBatchDto {
  isbns: string[]
}

export interface CreateBookRequestDto {
  /**
   * Title of the requested book
   * @maxLength 500
   */
  title: string
  /**
   * Author of the requested book
   * @maxLength 500
   */
  author?: string
  /**
   * Publisher of the requested book
   * @maxLength 500
   */
  publisher?: string
  /**
   * The search term that originated this request
   * @maxLength 500
   */
  searchTerm?: string
}

export interface BookRequestResponseDto {
  /** ID of the created book request */
  id: number
}

export interface BookSearchRequestDto {
  /** @nullable */
  search_term?: string | null
  page?: number
  per_page?: number
  fixed_categories?: string[]
  imprint_or_publisher?: string[]
  /** JSON URL-encoded com book_type, language, indicated_year, etc. */
  opts?: string
}

export interface BookSearchPublisherDto {
  id: number
  name: string
}

/**
 * @nullable
 */
export type BookSearchBookDtoPublisher = BookSearchPublisherDto | null

export type BookSearchBookDtoThemasItem = { [key: string]: unknown }

export interface BookSearchBookDto {
  /** @nullable */
  author?: string | null
  /** @nullable */
  name?: string | null
  /** @nullable */
  publisher?: BookSearchBookDtoPublisher
  /** @nullable */
  slug?: string | null
  /** @nullable */
  layout?: string | null
  /** @nullable */
  manual_info_checked?: boolean | null
  /** @nullable */
  degree?: string | null
  /** @nullable */
  image?: string | null
  /**
   * URL absoluta no CDN para o thumb (versão thumb_home_).
   * @nullable
   */
  image_url_thumb?: string | null
  /**
   * URL absoluta no CDN para o thumb_low_.
   * @nullable
   */
  image_url_thumb_low?: string | null
  /**
   * URL absoluta no CDN para a versão intermediaria_.
   * @nullable
   */
  image_url_intermediaria?: string | null
  /** @nullable */
  v2ready?: boolean | null
  /** @nullable */
  max_uses?: number | null
  /** @nullable */
  bookwire?: boolean | null
  /** @nullable */
  description?: string | null
  /** @nullable */
  subtitle?: string | null
  /** @nullable */
  freemium?: boolean | null
  /** @nullable */
  price?: number | null
  /** @nullable */
  english_level?: string | null
  /** @nullable */
  has_ebook?: boolean | null
  /** @nullable */
  has_audio_book?: boolean | null
  themas?: BookSearchBookDtoThemasItem[]
  /** @nullable */
  language?: string | null
}

export interface BookSearchFilterItemDto {
  label: string
  parameter_value: string
  /** @nullable */
  count?: number | null
  order?: number
}

export interface BookSearchFilterDto {
  title: string
  parameter_name: string
  list: BookSearchFilterItemDto[]
}

export interface BookSearchResponseDto {
  books: BookSearchBookDto[]
  search_filters: BookSearchFilterDto[]
}

export type ListBooksByIdentifiersDtoQueryType =
  typeof ListBooksByIdentifiersDtoQueryType[keyof typeof ListBooksByIdentifiersDtoQueryType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBooksByIdentifiersDtoQueryType = {
  id: 'id',
  slug: 'slug'
} as const

export interface ListBooksByIdentifiersDto {
  identifiers: string[]
  queryType: ListBooksByIdentifiersDtoQueryType
}

export interface AddBooksToCollectionEntryDto {
  collectionName: string
  bookIds: string[]
}

export interface AddBooksToCollectionDto {
  entries: AddBooksToCollectionEntryDto[]
}

export interface RemoveBooksFromCollectionEntryDto {
  collectionName: string
  bookIds: string[]
}

export interface RemoveBooksFromCollectionDto {
  entries: RemoveBooksFromCollectionEntryDto[]
}

/**
 * Tipo do conteúdo
 */
export type MostBorrowedItemDtoType =
  typeof MostBorrowedItemDtoType[keyof typeof MostBorrowedItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MostBorrowedItemDtoType = {
  book: 'book',
  podcast: 'podcast',
  video: 'video'
} as const

export interface MostBorrowedItemDto {
  /** Tipo do conteúdo */
  type: MostBorrowedItemDtoType
  /**
   * Modalidade de licenciamento
   * @nullable
   */
  modality: string | null
  /** ID do conteúdo */
  id: number
  /** Slug para URL */
  slug: string
  /** Título */
  title: string
  /**
   * Autor
   * @nullable
   */
  author: string | null
  /**
   * URL da capa
   * @nullable
   */
  imageUrlThumb: string | null
  /** Indica se possui audiolivro */
  hasAudioBook: boolean
  /**
   * Duração em segundos (apenas vídeos)
   * @nullable
   */
  duration: number | null
  /** Número de empréstimos na janela considerada */
  loanCount: number
}

export interface MostBorrowedShelfResponseDto {
  /** Itens mais emprestados */
  items: MostBorrowedItemDto[]
  /** Total de itens retornados */
  total: number
  /** Limite aplicado */
  limit: number
}

/**
 * Target type
 */
export type IndicationTargetDtoTargetType =
  typeof IndicationTargetDtoTargetType[keyof typeof IndicationTargetDtoTargetType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndicationTargetDtoTargetType = {
  user: 'user',
  entity: 'entity'
} as const

export interface IndicationTargetDto {
  /** Target ID (userId or entityId) */
  targetId: number
  /** Target type */
  targetType: IndicationTargetDtoTargetType
}

export interface CreateBookIndicationDto {
  /** Book slug to indicate */
  bookSlug: string
  /** List of targets to indicate the book to */
  targets: IndicationTargetDto[]
  /** Due date (ISO format) */
  dueDate?: string
}

export interface GetOnboardingRecommendationsDto {
  /**
   * IDs dos temas selecionados pelo usuário no onboarding
   * @minItems 1
   * @maxItems 10
   */
  selectedThemes: number[]
  /**
   * Número de livros a retornar
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export interface BookThemaDto {
  id: number
  name: string
  code: string
}

export interface BookCollectionDto {
  id: number
  name: string
}

export interface OnboardingBookDto {
  /** ID do livro */
  id: number
  /** Nome do livro */
  name: string
  /** Slug para URL */
  slug: string
  /** Autor principal */
  author: string
  /** Todos os autores */
  authors: string[]
  /** URL da imagem */
  imageUrl: string
  /** Temas do livro */
  themas: BookThemaDto[]
  /** Grau/série recomendado */
  degree: string
  /** Idioma */
  language: string
  /** Score de similaridade (0-2) */
  score: number
  /** Número de visualizações */
  viewedCount: number
  /** Coleções/acervos do livro */
  collections: BookCollectionDto[]
  /** Indica se o livro possui audiolivro */
  hasAudioBook: boolean
}

export interface OnboardingRecommendationsResponseDto {
  /** Livros recomendados */
  books: OnboardingBookDto[]
  /** Total de livros encontrados */
  total: number
  /** Limite aplicado */
  limit: number
}

export interface SaveBookReactionDto {
  /** ID do livro */
  bookId: number
  /** Se o usuário gostou (true) ou não gostou (false) do livro */
  liked: boolean
}

/**
 * @nullable
 */
export type ViewedBookRelayBookResponseDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ViewedBookRelayBookResponseDtoLanguage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ViewedBookRelayBookResponseDtoDegree = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ViewedBookRelayBookResponseDtoLastInteraction = {
  [key: string]: unknown
} | null

export interface ViewedBookRelayBookResponseDto {
  id: number
  slug: string
  name: string
  /** @nullable */
  author: ViewedBookRelayBookResponseDtoAuthor
  imageUrlThumb: string
  imageUrlThumbLow: string
  hasEbook: boolean
  hasAudioBook: boolean
  /** @nullable */
  language: ViewedBookRelayBookResponseDtoLanguage
  /** @nullable */
  degree: ViewedBookRelayBookResponseDtoDegree
  /** @nullable */
  lastInteraction: ViewedBookRelayBookResponseDtoLastInteraction
}

/**
 * @nullable
 */
export type ViewedBookRelayNodeResponseDtoLastInteraction = {
  [key: string]: unknown
} | null

export interface ViewedBookRelayNodeResponseDto {
  id: number
  book: ViewedBookRelayBookResponseDto
  percentage: number
  isDefaultReading: boolean
  isSharedReading: boolean
  isRead: boolean
  isHidden: boolean
  /** @nullable */
  lastInteraction: ViewedBookRelayNodeResponseDtoLastInteraction
}

export interface ViewedBookRelayEdgeResponseDto {
  node: ViewedBookRelayNodeResponseDto
  cursor: string
}

/**
 * @nullable
 */
export type ViewedBookRelayPageInfoResponseDtoStartCursor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ViewedBookRelayPageInfoResponseDtoEndCursor = {
  [key: string]: unknown
} | null

export interface ViewedBookRelayPageInfoResponseDto {
  hasNextPage: boolean
  hasPreviousPage: boolean
  /** @nullable */
  startCursor: ViewedBookRelayPageInfoResponseDtoStartCursor
  /** @nullable */
  endCursor: ViewedBookRelayPageInfoResponseDtoEndCursor
}

export interface ViewedBooksRelayResponseDto {
  edges: ViewedBookRelayEdgeResponseDto[]
  pageInfo: ViewedBookRelayPageInfoResponseDto
}

export interface GetCardResponseDto {
  /** Reader profile ID */
  id: number
  /** Reader name */
  name: string
  /** Formatted entity name with parent hierarchy */
  entityName: string
  /** Full entity breadcrumb from root to leaf */
  entityBreadcrumb: string
  /** User access token */
  accessToken: string
}

export interface GetCardPermissionErrorDto {
  /** Error status */
  status: string
  /** Error info message */
  info: string
}

export interface ClassUserDto {
  /** User ID */
  user_id: number
  /** User name */
  name: string
  /**
   * Reader ID
   * @nullable
   */
  reader_id: number | null
  /** Whether the user is a teacher */
  is_teacher: boolean
}

export interface GetClassUsersResponseDto {
  /** Class ID */
  class_id: number
  /**
   * Class degree
   * @nullable
   */
  degree: string | null
  /** Total number of users in the class */
  total: number
  /** List of users in the class */
  users: ClassUserDto[]
}

export type ContinueReadingBookItemDtoType =
  typeof ContinueReadingBookItemDtoType[keyof typeof ContinueReadingBookItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingBookItemDtoType = {
  book: 'book'
} as const

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoImageUrlThumb = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoImageUrlThumbLow = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoDegree = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoLanguage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingBookItemDtoLoanStatus =
  | typeof ContinueReadingBookItemDtoLoanStatus[keyof typeof ContinueReadingBookItemDtoLoanStatus]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingBookItemDtoLoanStatus = {
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

/**
 * ID do empréstimo ativo
 * @nullable
 */
export type ContinueReadingBookItemDtoLoanId = { [key: string]: unknown } | null

/**
 * Quantidade de renovações já feitas
 * @nullable
 */
export type ContinueReadingBookItemDtoRenewalsCount = {
  [key: string]: unknown
} | null

/**
 * Data de expiração do empréstimo (ISO)
 * @nullable
 */
export type ContinueReadingBookItemDtoDueAt = { [key: string]: unknown } | null

export interface ContinueReadingBookItemDto {
  type: ContinueReadingBookItemDtoType
  id: number
  slug: string
  title: string
  /** @nullable */
  author: ContinueReadingBookItemDtoAuthor
  /** @nullable */
  imageUrlThumb: ContinueReadingBookItemDtoImageUrlThumb
  /** @nullable */
  imageUrlThumbLow: ContinueReadingBookItemDtoImageUrlThumbLow
  /** @nullable */
  degree: ContinueReadingBookItemDtoDegree
  /** @nullable */
  language: ContinueReadingBookItemDtoLanguage
  hasEbook: boolean
  hasAudioBook: boolean
  percentage: number
  lastInteractionAt: string
  /** @nullable */
  loanStatus: ContinueReadingBookItemDtoLoanStatus
  /**
   * ID do empréstimo ativo
   * @nullable
   */
  loanId: ContinueReadingBookItemDtoLoanId
  /**
   * Quantidade de renovações já feitas
   * @nullable
   */
  renewalsCount: ContinueReadingBookItemDtoRenewalsCount
  /**
   * Data de expiração do empréstimo (ISO)
   * @nullable
   */
  dueAt: ContinueReadingBookItemDtoDueAt
}

export type ContinueReadingVideoItemDtoType =
  typeof ContinueReadingVideoItemDtoType[keyof typeof ContinueReadingVideoItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingVideoItemDtoType = {
  video: 'video'
} as const

/**
 * @nullable
 */
export type ContinueReadingVideoItemDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingVideoItemDtoCoverImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingVideoItemDtoDegree = {
  [key: string]: unknown
} | null

/**
 * Duração total do vídeo em segundos
 * @nullable
 */
export type ContinueReadingVideoItemDtoDuration = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingVideoItemDtoLoanStatus =
  | typeof ContinueReadingVideoItemDtoLoanStatus[keyof typeof ContinueReadingVideoItemDtoLoanStatus]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingVideoItemDtoLoanStatus = {
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

/**
 * ID do empréstimo ativo
 * @nullable
 */
export type ContinueReadingVideoItemDtoLoanId = {
  [key: string]: unknown
} | null

/**
 * Quantidade de renovações já feitas
 * @nullable
 */
export type ContinueReadingVideoItemDtoRenewalsCount = {
  [key: string]: unknown
} | null

/**
 * Data de expiração do empréstimo (ISO)
 * @nullable
 */
export type ContinueReadingVideoItemDtoDueAt = { [key: string]: unknown } | null

export interface ContinueReadingVideoItemDto {
  type: ContinueReadingVideoItemDtoType
  id: number
  slug: string
  title: string
  /** @nullable */
  author: ContinueReadingVideoItemDtoAuthor
  /** @nullable */
  coverImage: ContinueReadingVideoItemDtoCoverImage
  /** @nullable */
  degree: ContinueReadingVideoItemDtoDegree
  /**
   * Duração total do vídeo em segundos
   * @nullable
   */
  duration: ContinueReadingVideoItemDtoDuration
  /** Timestamp atual de visualização em segundos */
  watchedTimestamp: number
  /** Percentual assistido (0-100) */
  percentage: number
  lastInteractionAt: string
  /** @nullable */
  loanStatus: ContinueReadingVideoItemDtoLoanStatus
  /**
   * ID do empréstimo ativo
   * @nullable
   */
  loanId: ContinueReadingVideoItemDtoLoanId
  /**
   * Quantidade de renovações já feitas
   * @nullable
   */
  renewalsCount: ContinueReadingVideoItemDtoRenewalsCount
  /**
   * Data de expiração do empréstimo (ISO)
   * @nullable
   */
  dueAt: ContinueReadingVideoItemDtoDueAt
}

export type ContinueReadingPodcastItemDtoType =
  typeof ContinueReadingPodcastItemDtoType[keyof typeof ContinueReadingPodcastItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingPodcastItemDtoType = {
  podcast: 'podcast'
} as const

/**
 * Autor do show
 * @nullable
 */
export type ContinueReadingPodcastItemDtoAuthor = {
  [key: string]: unknown
} | null

/**
 * Capa do show
 * @nullable
 */
export type ContinueReadingPodcastItemDtoCoverImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingPodcastItemDtoDegree = {
  [key: string]: unknown
} | null

/**
 * Duração total do episódio em segundos
 * @nullable
 */
export type ContinueReadingPodcastItemDtoDuration = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type ContinueReadingPodcastItemDtoLoanStatus =
  | typeof ContinueReadingPodcastItemDtoLoanStatus[keyof typeof ContinueReadingPodcastItemDtoLoanStatus]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContinueReadingPodcastItemDtoLoanStatus = {
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

/**
 * ID do empréstimo ativo
 * @nullable
 */
export type ContinueReadingPodcastItemDtoLoanId = {
  [key: string]: unknown
} | null

/**
 * Quantidade de renovações já feitas
 * @nullable
 */
export type ContinueReadingPodcastItemDtoRenewalsCount = {
  [key: string]: unknown
} | null

/**
 * Data de expiração do empréstimo (ISO)
 * @nullable
 */
export type ContinueReadingPodcastItemDtoDueAt = {
  [key: string]: unknown
} | null

export interface ContinueReadingPodcastItemDto {
  type: ContinueReadingPodcastItemDtoType
  /** ID do episódio */
  id: number
  /** Slug do episódio */
  slug: string
  /** Título do episódio */
  title: string
  /**
   * Autor do show
   * @nullable
   */
  author: ContinueReadingPodcastItemDtoAuthor
  /**
   * Capa do show
   * @nullable
   */
  coverImage: ContinueReadingPodcastItemDtoCoverImage
  /** @nullable */
  degree: ContinueReadingPodcastItemDtoDegree
  /**
   * Duração total do episódio em segundos
   * @nullable
   */
  duration: ContinueReadingPodcastItemDtoDuration
  /** Segundos escutados */
  listenedSeconds: number
  completed: boolean
  /** Percentual escutado (0-100) */
  percentage: number
  /** ID do show */
  showId: number
  /** Slug do show */
  showSlug: string
  /** Título do show */
  showTitle: string
  lastInteractionAt: string
  /** @nullable */
  loanStatus: ContinueReadingPodcastItemDtoLoanStatus
  /**
   * ID do empréstimo ativo
   * @nullable
   */
  loanId: ContinueReadingPodcastItemDtoLoanId
  /**
   * Quantidade de renovações já feitas
   * @nullable
   */
  renewalsCount: ContinueReadingPodcastItemDtoRenewalsCount
  /**
   * Data de expiração do empréstimo (ISO)
   * @nullable
   */
  dueAt: ContinueReadingPodcastItemDtoDueAt
}

export type ContinueReadingResponseDtoItemsItem =
  | ContinueReadingBookItemDto
  | ContinueReadingVideoItemDto
  | ContinueReadingPodcastItemDto

export interface ContinueReadingResponseDto {
  items: ContinueReadingResponseDtoItemsItem[]
}

export interface OffboardUserBodyDto {
  /** E-mail corporativo atual do usuário */
  email: string
  /** Novo e-mail pessoal do usuário */
  newEmail: string
}

/**
 * @nullable
 */
export type OffboardUserResponseDtoUserName = { [key: string]: unknown } | null

export interface OffboardUserResponseDto {
  userId: number
  /** @nullable */
  userName: OffboardUserResponseDtoUserName
  userEmail: string
  newEmail: string
  targetEntityId: number
  targetEntityName: string
  movedReaderProfiles: number
  movedTeacherProfiles: number
  message: string
}

export type CreateOlympicsShelfBodyDtoDegreesItem =
  typeof CreateOlympicsShelfBodyDtoDegreesItem[keyof typeof CreateOlympicsShelfBodyDtoDegreesItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOlympicsShelfBodyDtoDegreesItem = {
  EF1: 'EF1',
  EF2: 'EF2',
  EM: 'EM',
  PROFESSORES: 'PROFESSORES'
} as const

export interface CreateOlympicsShelfBodyDto {
  name: string
  subtitle?: string
  internalDescription?: string
  degrees: CreateOlympicsShelfBodyDtoDegreesItem[]
  startDate?: string
  endDate?: string
  /** Comma-separated root ids, e.g. "123,456" */
  allowedRootIds?: string
  /** Comma-separated root ids, e.g. "123,456" */
  blockedRootIds?: string
}

export interface ReorderOlympicsShelvesItemDto {
  id: number
  order: number
}

export interface ReorderOlympicsShelvesBodyDto {
  items: ReorderOlympicsShelvesItemDto[]
}

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoSubtitle = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoInternalDescription = {
  [key: string]: unknown
} | null

export type UpdateOlympicsShelfBodyDtoDegreesItem =
  typeof UpdateOlympicsShelfBodyDtoDegreesItem[keyof typeof UpdateOlympicsShelfBodyDtoDegreesItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOlympicsShelfBodyDtoDegreesItem = {
  EF1: 'EF1',
  EF2: 'EF2',
  EM: 'EM',
  PROFESSORES: 'PROFESSORES'
} as const

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoStartDate = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoEndDate = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoAllowedRootIds = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type UpdateOlympicsShelfBodyDtoBlockedRootIds = {
  [key: string]: unknown
} | null

export interface UpdateOlympicsShelfBodyDto {
  name?: string
  /** @nullable */
  subtitle?: UpdateOlympicsShelfBodyDtoSubtitle
  /** @nullable */
  internalDescription?: UpdateOlympicsShelfBodyDtoInternalDescription
  degrees?: UpdateOlympicsShelfBodyDtoDegreesItem[]
  /** @nullable */
  startDate?: UpdateOlympicsShelfBodyDtoStartDate
  /** @nullable */
  endDate?: UpdateOlympicsShelfBodyDtoEndDate
  /** @nullable */
  allowedRootIds?: UpdateOlympicsShelfBodyDtoAllowedRootIds
  /** @nullable */
  blockedRootIds?: UpdateOlympicsShelfBodyDtoBlockedRootIds
}

export interface ToggleOlympicsShelfBodyDto {
  enabled: boolean
}

/**
 * @nullable
 */
export type UpdateOlympicsShelfBookItemDtoStartDate = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type UpdateOlympicsShelfBookItemDtoEndDate = {
  [key: string]: unknown
} | null

export interface UpdateOlympicsShelfBookItemDto {
  bookId: number
  /** @nullable */
  startDate?: UpdateOlympicsShelfBookItemDtoStartDate
  /** @nullable */
  endDate?: UpdateOlympicsShelfBookItemDtoEndDate
}

export interface UpdateOlympicsShelfBooksBodyDto {
  books: UpdateOlympicsShelfBookItemDto[]
}

export interface FindOrCreateTutorialDto {
  /** Tutorial name */
  name: string
}

/**
 * Estado do tutorial
 */
export type TutorialResponseDtoState =
  typeof TutorialResponseDtoState[keyof typeof TutorialResponseDtoState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TutorialResponseDtoState = {
  pending: 'pending',
  consumed: 'consumed',
  dismissed: 'dismissed',
  completed: 'completed'
} as const

export interface TutorialResponseDto {
  /** ID do tutorial */
  id: number
  /** Nome do tutorial */
  name: string
  /** Estado do tutorial */
  state: TutorialResponseDtoState
  /** Número de interações */
  interactions: number
  /** ID do usuário */
  userId: number
  /** Data de criação */
  insertedAt: string
  /** Data de atualização */
  updatedAt: string
}

/**
 * Action to execute on tutorial
 */
export type UpdateTutorialDtoAction =
  typeof UpdateTutorialDtoAction[keyof typeof UpdateTutorialDtoAction]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTutorialDtoAction = {
  CONSUME: 'CONSUME',
  DISMISS: 'DISMISS',
  COMPLETE: 'COMPLETE'
} as const

export interface UpdateTutorialDto {
  /** Tutorial ID */
  id: number
  /** Action to execute on tutorial */
  action: UpdateTutorialDtoAction
}

export interface ChecklistStatusResponseDto {
  /** Indicates if the user completed their first reading (percentage > 3) */
  firstReading: boolean
  /** Indicates if the user visited the achievements area */
  achievementArea: boolean
  /** Indicates if the user planted a tree */
  plantTree: boolean
  /** Reading percentage completed by the user (0-100). If percentage is 1 or greater, returns 100 */
  readingPercentage: number
  /** Number of pages read by the user. Calculated as percentage * 5 pages per percentage */
  readingPages: number
}

export interface GiveRewardsDto {
  /** User ID */
  userId: number
  /** Coins to add */
  coins: number
  /** Water drops to add */
  waterDrops: number
  /** Points to add */
  points: number
}

export type QualifyJobDescriptionResponseDtoJobPositionsItem =
  typeof QualifyJobDescriptionResponseDtoJobPositionsItem[keyof typeof QualifyJobDescriptionResponseDtoJobPositionsItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyJobDescriptionResponseDtoJobPositionsItem = {
  TEACHER: 'TEACHER',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  PRINCIPAL: 'PRINCIPAL',
  ASSISTANT_OR_INTERN: 'ASSISTANT_OR_INTERN',
  FINANCIAL: 'FINANCIAL',
  LIBRARIAN: 'LIBRARIAN',
  EDUCATIONAL_TECHNOLOGY: 'EDUCATIONAL_TECHNOLOGY',
  SCHOOL_SUPPORT: 'SCHOOL_SUPPORT',
  PEDAGOGICAL_ADVISOR: 'PEDAGOGICAL_ADVISOR',
  IT: 'IT',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  COORDINATOR: 'COORDINATOR'
} as const

export type QualifyJobDescriptionResponseDtoJobAreasItem =
  typeof QualifyJobDescriptionResponseDtoJobAreasItem[keyof typeof QualifyJobDescriptionResponseDtoJobAreasItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyJobDescriptionResponseDtoJobAreasItem = {
  LANGUAGES_AND_COMMUNICATION: 'LANGUAGES_AND_COMMUNICATION',
  TECHNOLOGY_AND_INNOVATION: 'TECHNOLOGY_AND_INNOVATION',
  EXPRESSIONS_AND_BODY: 'EXPRESSIONS_AND_BODY',
  HUMAN_SCIENCES: 'HUMAN_SCIENCES',
  FOREIGN_LANGUAGE: 'FOREIGN_LANGUAGE',
  PERSONAL_DEVELOPMENT: 'PERSONAL_DEVELOPMENT',
  MATHEMATICS_AND_TECHNOLOGIES: 'MATHEMATICS_AND_TECHNOLOGIES',
  NATURAL_SCIENCES: 'NATURAL_SCIENCES'
} as const

export interface QualifyJobDescriptionResponseDto {
  /** User ID */
  id: number
  /** Job positions */
  jobPositions: QualifyJobDescriptionResponseDtoJobPositionsItem[]
  /** Job areas */
  jobAreas: QualifyJobDescriptionResponseDtoJobAreasItem[]
}

export interface SeedResponseDto {
  /** Seed unique identifier */
  id: number
  /** Seed name */
  name: string
  /** Price in coins */
  price: number
  /** Species name */
  species: string
  /** Scientific name */
  scientificName: string
  /** Seed description */
  description: string
  /** Image URL from CDN */
  image: string
  /** Growth time in days/hours */
  growthTime: string
  /** Whether the seed is locked */
  locked: boolean
  /** Text explaining why the seed is locked */
  lockedText: string
  /** Seed slug */
  slug: string
}

export interface SeedsResponseDto {
  seeds: SeedResponseDto[]
}

/**
 * Tree state for the user forest
 */
export type CopaTreeDtoStatus =
  typeof CopaTreeDtoStatus[keyof typeof CopaTreeDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CopaTreeDtoStatus = {
  locked: 'locked',
  available: 'available',
  planted: 'planted'
} as const

export interface CopaTreeDto {
  /** Seed unique identifier */
  id: number
  /** Seed name */
  name: string
  /** Price in coins */
  price: number
  /** Species name */
  species: string
  /** Scientific name */
  scientificName: string
  /** Seed description */
  description: string
  /** Image URL from CDN */
  image: string
  /** Growth time in days */
  growthTime: string
  /** Seed slug */
  slug: string
  /** Tree state for the user forest */
  status: CopaTreeDtoStatus
  /** Whether the tree is locked by an unmet prerequisite */
  locked: boolean
  /** Text explaining the unlock criteria when locked */
  lockedText: string
}

export interface CopaResponseDto {
  /** Whether the Copa action is active for this user */
  active: boolean
  /**
   * Date when the Copa action ends (null when inactive)
   * @nullable
   */
  endsAt: string | null
  trees: CopaTreeDto[]
}

export type CampaignTreeDtoStatus =
  typeof CampaignTreeDtoStatus[keyof typeof CampaignTreeDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignTreeDtoStatus = {
  locked: 'locked',
  available: 'available',
  planted: 'planted'
} as const

export interface CampaignTreeDto {
  /** Seed unique identifier */
  id: number
  /** Seed name */
  name: string
  /** Price in coins */
  price: number
  /** Species name */
  species: string
  /** Scientific name */
  scientificName: string
  /** Seed description */
  description: string
  /** Image URL from CDN */
  image: string
  /** Growth time in days */
  growthTime: string
  /** Seed slug */
  slug: string
  /** Tree state for the user forest */
  status: CampaignTreeDtoStatus
  /** Whether the tree is locked by an unmet prerequisite */
  locked: boolean
  /** Text explaining the unlock criteria when locked */
  lockedText: string
}

/**
 * Which campaign identity the reader sees: the Portuguese Gincana or the English Reading Challenge
 */
export type GincanaResponseDtoCampaign =
  typeof GincanaResponseDtoCampaign[keyof typeof GincanaResponseDtoCampaign]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GincanaResponseDtoCampaign = {
  gincana: 'gincana',
  reading_challenge: 'reading_challenge'
} as const

export interface GincanaResponseDto {
  /** Whether the Gincana card is active for this user */
  active: boolean
  /**
   * Date when the reading window of the Gincana ends (null when inactive)
   * @nullable
   */
  endsAt: string | null
  /** Which campaign identity the reader sees: the Portuguese Gincana or the English Reading Challenge */
  campaign: GincanaResponseDtoCampaign
  trees: CampaignTreeDto[]
}

export interface ForestTreeDto {
  id: number
  specialItemUsed: boolean
  stage: number
  agePercentage: number
  /** @nullable */
  description: string | null
  growthTime: number
  image: string
  /** @nullable */
  name: string | null
  /** @nullable */
  position: number | null
  /** @nullable */
  scientificName: string | null
  /** @nullable */
  species: string | null
  ageStatusText: string
}

export interface ForestSeedDto {
  id: number
  image: string
  /** @nullable */
  name: string | null
  /** @nullable */
  description: string | null
  locked: boolean
  lockedText: string
  /** @nullable */
  scientificName: string | null
  /** @nullable */
  species: string | null
  /** @nullable */
  growthTime: string | null
  /** @nullable */
  price: number | null
}

export interface ForestSpecialItemDto {
  id: number
  /** @nullable */
  name: string | null
  /** @nullable */
  description: string | null
  /** @nullable */
  price: number | null
  action: string
  image: string
  /** @nullable */
  type: string | null
}

export interface ForestWaterDropDetailsDto {
  maxDrops: number
  currentDrops: number
  minimumLevel: number
  dropsPerLevel: number
  percentage: number
  image: string
  raining: boolean
  statusText: string
  description: string
  /** Dias restantes de chuva. 0 quando não está chovendo. */
  rainDaysLeft: number
}

export interface GetMainForestScreenResponseDto {
  id: number
  coins: number
  trees: ForestTreeDto[]
  seeds: ForestSeedDto[]
  specialItems: ForestSpecialItemDto[]
  waterDropDetails: ForestWaterDropDetailsDto
}

export interface BuySeedDto {
  /** ID do item (semente) a ser comprado */
  itemId: number
  /** Posição na floresta onde a árvore será plantada */
  position: number
}

export interface BuySeedResponseDto {
  status: boolean
  /** @nullable */
  reason: string | null
  /** @nullable */
  message: string | null
}

export interface BuySpecialItemDto {
  /** ID do item especial (adubo, super adubo ou dias de chuva) */
  itemId: number
  /**
   * ID da árvore alvo (obrigatório para adubo, ignorado para chuva)
   * @nullable
   */
  treeId?: number | null
}

export interface BuySpecialItemResponseDto {
  status: boolean
}

export interface JoinGameResponseDto {
  status: boolean
}

export interface ForestFriendDto {
  /** @nullable */
  name: string | null
  readerId: number
}

export type ForestFriendForAdminDtoType =
  typeof ForestFriendForAdminDtoType[keyof typeof ForestFriendForAdminDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForestFriendForAdminDtoType = {
  entity: 'entity',
  reader: 'reader'
} as const

export interface ForestFriendForAdminDto {
  id: number
  /** @nullable */
  name: string | null
  type: ForestFriendForAdminDtoType
}

export interface ForestTreeListingDto {
  id: number
  image: string
  /** @nullable */
  position: number | null
}

export interface CreateLeadBodyDto {
  name: string
  email: string
  phone: string
  school: string
}

export interface CreateBookSelectionBodyDto {
  entityId: number
  schoolId: number
  grade: string
  booksPerGrade: number
  studentCount: number
  classesStartDate: string
}

export interface PreviewSelectionItemsBodyDto {
  /** Physical edition IDs to preview */
  physicalEditionIds: number[]
}

export interface ApproveCoordinatorSelectionsBodyDto {
  classesStartDate?: string
}

export interface UpdateBookSelectionBodyDto {
  booksPerGrade?: number
  classesStartDate?: string
  teacherCount?: number
  studentCount?: number
}

export interface CreateAdditionalOrderBodyDto {
  additionalStudents: number
  additionalTeachers: number
}

export type UpdateBookSelectionStatusBodyDtoStatus =
  typeof UpdateBookSelectionStatusBodyDtoStatus[keyof typeof UpdateBookSelectionStatusBodyDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBookSelectionStatusBodyDtoStatus = {
  approved: 'approved',
  rejected: 'rejected'
} as const

export interface UpdateBookSelectionStatusBodyDto {
  status: UpdateBookSelectionStatusBodyDtoStatus
  rejectionReason?: string
}

export interface CreateCatalogItemBodyDto {
  bookIdArvore?: number
  title?: string
  author?: string
  coverUrl?: string
  genre?: string
  synopsis?: string
  grade: string
  isFeatured?: boolean
  displayOrder?: number
}

export interface UpdateCatalogItemBodyDto {
  bookIdArvore?: number
  title?: string
  author?: string
  coverUrl?: string
  genre?: string
  synopsis?: string
  grade?: string
  isFeatured?: boolean
  displayOrder?: number
  active?: boolean
}

export interface CreatePhysicalEditionBodyDto {
  catalogId: number
  isbnPhysical: string
  isbnDigital?: string
  bookId?: number
  publisher?: string
  pageCount?: number
  physicalPrice?: string
  maxStock?: number
  currentStock?: number
  minPrintRun?: number
  isDiscountedBulk?: boolean
  bulkDiscountThreshold?: number
}

export interface UpdatePhysicalEditionBodyDto {
  isbnPhysical?: string
  isbnDigital?: string
  bookId?: number
  publisher?: string
  pageCount?: number
  physicalPrice?: string
  maxStock?: number
  currentStock?: number
  minPrintRun?: number
  isDiscountedBulk?: boolean
  bulkDiscountThreshold?: number
  active?: boolean
}

export interface GenerateCoverUploadUrlBodyDto {
  /** Book slug for folder path */
  slug: string
  /** File content type */
  contentType: string
  /** File name */
  fileName: string
}

/**
 * Publisher that will own the trail book. 1494 = Árvore - interno (default for PT-BR trails), 1805 = Árvore - Inglês.
 */
export type CreateCatalogTrailBodyDtoPublisherId =
  typeof CreateCatalogTrailBodyDtoPublisherId[keyof typeof CreateCatalogTrailBodyDtoPublisherId]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCatalogTrailBodyDtoPublisherId = {
  NUMBER_1494: 1494,
  NUMBER_1805: 1805
} as const

export interface CreateCatalogTrailBodyDto {
  /** Publisher that will own the trail book. 1494 = Árvore - interno (default for PT-BR trails), 1805 = Árvore - Inglês. */
  publisherId: CreateCatalogTrailBodyDtoPublisherId
  /** Trail synopsis. When omitted, falls back to the parent book description or the catalog item synopsis. */
  description?: string
  /** Trail ISBN. When omitted, falls back to the parent book ISBN or an auto-generated synthetic ISBN. */
  isbn?: string
  /** Trail author. When omitted, falls back to the parent book author, the catalog item author, or "Árvore". */
  author?: string
  /** Minimum recommended age. When omitted, falls back to the parent book minimum age. */
  minimumAge?: number
}

/**
 * Publisher to move the trail book to. 1494 = Árvore - interno, 1805 = Árvore - Inglês.
 */
export type UpdateCatalogTrailBodyDtoPublisherId =
  typeof UpdateCatalogTrailBodyDtoPublisherId[keyof typeof UpdateCatalogTrailBodyDtoPublisherId]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCatalogTrailBodyDtoPublisherId = {
  NUMBER_1494: 1494,
  NUMBER_1805: 1805
} as const

export interface UpdateCatalogTrailBodyDto {
  /** Publisher to move the trail book to. 1494 = Árvore - interno, 1805 = Árvore - Inglês. */
  publisherId?: UpdateCatalogTrailBodyDtoPublisherId
}

export interface CreateOrderBodyDto {
  entityId: number
  booksPerGrade: number
  grades: string[]
  classesStartDate?: string
}

export interface CreateOrderDeadlineBodyDto {
  year: number
  entityId?: number
  baseOrderDeadline: string
  baseOrderEarlyCutoff: string
  baseOrderDefaultDelivery: string
  additionalOrderDeadline: string
  additionalOrderLeadDays: number
  reason?: string
}

export interface UpdateOrderDeadlineBodyDto {
  baseOrderDeadline?: string
  baseOrderEarlyCutoff?: string
  baseOrderDefaultDelivery?: string
  additionalOrderDeadline?: string
  additionalOrderLeadDays?: number
  active?: boolean
  reason?: string
}

export interface AddSelectionItemBodyDto {
  physicalEditionId: number
}

export type HubspotWebhookBodyDtoHsTicketId = string | number

export type HubspotWebhookBodyDtoEntityId = string | number

export interface HubspotWebhookBodyDto {
  hs_ticket_id: HubspotWebhookBodyDtoHsTicketId
  entity_id: HubspotWebhookBodyDtoEntityId
  books_per_grade: string
  grades: string
  classes_start_date?: string
}

export interface EmailLogItemDto {
  id: string
  template: string
  phase: string
  day: number
  sentAt: string
  /** @nullable */
  recipients: string[] | null
  /** @nullable */
  messageIds: string[] | null
  /** @nullable */
  status: string | null
  /** @nullable */
  opensCount: number | null
}

export interface EmailLogsResponseDto {
  data: EmailLogItemDto[]
}

export interface EmailRecipientDto {
  email: string
  name: string
}

export interface EmailRecipientsResponseDto {
  data: EmailRecipientDto[]
}

/**
 * @nullable
 */
export type AdminProfileDtoUserId = { [key: string]: unknown } | null

export interface AdminProfileDto {
  id: number
  /** @nullable */
  userId: AdminProfileDtoUserId
  name: string
  email: string
  /** @nullable */
  role: string | null
}

export interface AdminProfilesResponseDto {
  data: AdminProfileDto[]
}

export type UpdateRoleBodyDtoRole =
  typeof UpdateRoleBodyDtoRole[keyof typeof UpdateRoleBodyDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRoleBodyDtoRole = {
  Diretor: 'Diretor',
  Coordenador: 'Coordenador'
} as const

export interface UpdateRoleBodyDto {
  role: UpdateRoleBodyDtoRole
}

export interface UpdateRoleResponseDto {
  updated: boolean
}

export interface ResendSelectionReleasedBodyDto {
  emails: string[]
}

export interface ResendSelectionReleasedResponseDto {
  sent: boolean
}

export type OmsOrderKitSummarySkuDtoCoverage =
  typeof OmsOrderKitSummarySkuDtoCoverage[keyof typeof OmsOrderKitSummarySkuDtoCoverage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderKitSummarySkuDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface OmsOrderKitSummarySkuDto {
  omsSkuId: number
  skuQuantity: number
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
  onHand: number
  shortageQty: number
  requiredQty: number
  onHandAllocated: number
  inTransitAllocated: number
  coverage: OmsOrderKitSummarySkuDtoCoverage
}

export type OmsOrderKitSummaryDtoType =
  typeof OmsOrderKitSummaryDtoType[keyof typeof OmsOrderKitSummaryDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderKitSummaryDtoType = {
  student: 'student',
  teacher: 'teacher'
} as const

export type OmsOrderKitSummaryDtoCoverage =
  typeof OmsOrderKitSummaryDtoCoverage[keyof typeof OmsOrderKitSummaryDtoCoverage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderKitSummaryDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface OmsOrderKitSummaryDto {
  id: number
  type: OmsOrderKitSummaryDtoType
  grade: string
  quantity: number
  coverage: OmsOrderKitSummaryDtoCoverage
  shortageQty: number
  skus: OmsOrderKitSummarySkuDto[]
}

export type AssemblyStatusDurationDtoStatus =
  typeof AssemblyStatusDurationDtoStatus[keyof typeof AssemblyStatusDurationDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssemblyStatusDurationDtoStatus = {
  queued: 'queued',
  picking: 'picking',
  assembling: 'assembling',
  shipping: 'shipping',
  in_transit: 'in_transit',
  received: 'received',
  cancelled: 'cancelled'
} as const

export interface AssemblyStatusDurationDto {
  status: AssemblyStatusDurationDtoStatus
  enteredAt: string
  /** @nullable */
  leftAt: string | null
  durationMs: number
}

export type AssemblyOrderListItemDtoType =
  typeof AssemblyOrderListItemDtoType[keyof typeof AssemblyOrderListItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssemblyOrderListItemDtoType = {
  base: 'base',
  additional: 'additional',
  standalone: 'standalone'
} as const

export type AssemblyOrderListItemDtoAssemblyStatus =
  typeof AssemblyOrderListItemDtoAssemblyStatus[keyof typeof AssemblyOrderListItemDtoAssemblyStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssemblyOrderListItemDtoAssemblyStatus = {
  queued: 'queued',
  picking: 'picking',
  assembling: 'assembling',
  shipping: 'shipping',
  in_transit: 'in_transit',
  received: 'received',
  cancelled: 'cancelled'
} as const

/**
 * @nullable
 */
export type AssemblyOrderListItemDtoCoverage =
  | typeof AssemblyOrderListItemDtoCoverage[keyof typeof AssemblyOrderListItemDtoCoverage]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssemblyOrderListItemDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface AssemblyOrderListItemDto {
  id: number
  schoolRef: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  type: AssemblyOrderListItemDtoType
  /** @nullable */
  priority: number | null
  assemblyStatus: AssemblyOrderListItemDtoAssemblyStatus
  /** @nullable */
  assemblyEnteredAt: string | null
  /** @nullable */
  currentStatusSince: string | null
  timeInCurrentStatusMs: number
  /** @nullable */
  coverage: AssemblyOrderListItemDtoCoverage
  /** @nullable */
  completionPct: number | null
  kits: OmsOrderKitSummaryDto[]
  statusDurations: AssemblyStatusDurationDto[]
}

export interface AssemblyOrderListResponseDto {
  data: AssemblyOrderListItemDto[]
  total: number
}

export interface ResolveKitCodeResponseDto {
  orderId: number
  /** @nullable */
  assemblyStatus: string | null
}

export interface PickingOrderDto {
  orderId: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  /** @nullable */
  assemblyStatus: string | null
  /** @nullable */
  priority: number | null
  kitCount: number
  assembledKits: number
  /** @nullable */
  queuedAt: string | null
  /** @nullable */
  pickingAt: string | null
}

export interface PickingOrdersResponseDto {
  data: PickingOrderDto[]
}

export interface PreviewAssemblyBodyDto {
  orderIds: number[]
}

export interface SplitMissingSkuDto {
  omsSkuId: number
  qty: number
}

export interface OrderSplitPreviewDto {
  orderId: number
  coveredKitIds: number[]
  backorderKitIds: number[]
  missingBySku: SplitMissingSkuDto[]
}

export interface PreviewAssemblyResponseDto {
  hasSplit: boolean
  previews: OrderSplitPreviewDto[]
}

export interface SendToAssemblyBodyDto {
  orderIds: number[]
  confirmSplit?: boolean
}

export interface SendToAssemblyResponseDto {
  sent: number
  createdBackorderOrderIds: number[]
  requiresSplitConfirmation: boolean
  previews?: OrderSplitPreviewDto[]
}

export interface CancelAssemblyOrderResponseDto {
  cancelled: boolean
}

export interface StartPickingResponseDto {
  started: boolean
}

export interface AssemblyKitSkuDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  shelfAddress: string | null
  expectedQty: number
  scannedQty: number
}

export type AssemblyGroupDtoStatus =
  typeof AssemblyGroupDtoStatus[keyof typeof AssemblyGroupDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssemblyGroupDtoStatus = {
  free: 'free',
  locked: 'locked',
  completed: 'completed'
} as const

export interface AssemblyGroupDto {
  omsKitId: number
  type: string
  grade: string
  quantity: number
  completedCount: number
  status: AssemblyGroupDtoStatus
  /** @nullable */
  lockedByActorId: string | null
  /** @nullable */
  lockedByActorName: string | null
  skus: AssemblyKitSkuDto[]
}

export interface AssemblySessionResponseDto {
  orderId: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  /** @nullable */
  assemblyStatus: string | null
  assembledKits: number
  totalKits: number
  /** @nullable */
  activeKitId: number | null
  /** @nullable */
  queuedAt: string | null
  /** @nullable */
  pickingAt: string | null
  groups: AssemblyGroupDto[]
}

/**
 * @nullable
 */
export type ClaimGroupResponseDtoGroup = AssemblyGroupDto | null

export interface ClaimGroupResponseDto {
  /** @nullable */
  group: ClaimGroupResponseDtoGroup
  /** @nullable */
  assemblyId: number | null
  /** true when no free group is available in the order */
  allBusy: boolean
}

export interface ScanBodyDto {
  isbn: string
}

export type ScanResponseDtoResult =
  typeof ScanResponseDtoResult[keyof typeof ScanResponseDtoResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScanResponseDtoResult = {
  valid: 'valid',
  invalid: 'invalid',
  exceeded: 'exceeded',
  locked: 'locked',
  label_required: 'label_required',
  label_opened: 'label_opened',
  already_completed: 'already_completed'
} as const

export interface ScanResponseDto {
  result: ScanResponseDtoResult
  /** @nullable */
  omsSkuId: number | null
  /** @nullable */
  omsKitId: number | null
  kitCompleted: boolean
  groupCompleted: boolean
  orderCompleted: boolean
  completedCount: number
  groupQuantity: number
}

export interface UndoLastScanResponseDto {
  undone: boolean
  /** @nullable */
  omsSkuId: number | null
}

export interface DiscardActiveUnitResponseDto {
  discarded: boolean
}

export interface OmsPrintSkuDto {
  omsSkuId: number
  /** @nullable */
  title: string | null
  /** @nullable */
  isbn: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  publisher: string | null
  /** @nullable */
  publisherGroup: string | null
  /** @nullable */
  shelfAddress: string | null
  quantity: number
}

export interface OmsSeparationGradeDto {
  grade: string
  skus: OmsPrintSkuDto[]
}

export interface OmsPrintKitDto {
  kitId: number
  type: string
  grade: string
  quantity: number
  skus: OmsPrintSkuDto[]
}

export interface OmsAssemblyMapGradeDto {
  grade: string
  kits: OmsPrintKitDto[]
}

export interface OmsOrderPrintResponseDto {
  orderId: number
  /** @nullable */
  schoolRef: number | null
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  type: string
  /** @nullable */
  assemblyStatus: string | null
  /** @nullable */
  deliveryDate: string | null
  separation: OmsSeparationGradeDto[]
  assemblyMap: OmsAssemblyMapGradeDto[]
}

export type OmsPrintLogItemDtoDocumentType =
  typeof OmsPrintLogItemDtoDocumentType[keyof typeof OmsPrintLogItemDtoDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsPrintLogItemDtoDocumentType = {
  separation: 'separation',
  assembly_map: 'assembly_map',
  box_assembly: 'box_assembly',
  kit_label: 'kit_label',
  box_label: 'box_label'
} as const

export interface OmsPrintLogItemDto {
  id: number
  documentType: OmsPrintLogItemDtoDocumentType
  /** @nullable */
  fileUrl: string | null
  /** @nullable */
  actorId: string | null
  /** @nullable */
  actorName: string | null
  /** @nullable */
  createdAt: string | null
}

export interface OmsPrintLogListResponseDto {
  data: OmsPrintLogItemDto[]
}

export interface OmsPrintDownloadResponseDto {
  url: string
}

export type OmsOrderListItemDtoType =
  typeof OmsOrderListItemDtoType[keyof typeof OmsOrderListItemDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderListItemDtoType = {
  base: 'base',
  additional: 'additional',
  standalone: 'standalone'
} as const

export type OmsOrderListItemDtoStatus =
  typeof OmsOrderListItemDtoStatus[keyof typeof OmsOrderListItemDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderListItemDtoStatus = {
  submitted: 'submitted'
} as const

/**
 * @nullable
 */
export type OmsOrderListItemDtoAssemblyStatus =
  | typeof OmsOrderListItemDtoAssemblyStatus[keyof typeof OmsOrderListItemDtoAssemblyStatus]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderListItemDtoAssemblyStatus = {
  queued: 'queued',
  picking: 'picking',
  assembling: 'assembling',
  shipping: 'shipping',
  in_transit: 'in_transit',
  received: 'received',
  cancelled: 'cancelled'
} as const

/**
 * @nullable
 */
export type OmsOrderListItemDtoCoverage =
  | typeof OmsOrderListItemDtoCoverage[keyof typeof OmsOrderListItemDtoCoverage]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderListItemDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface OmsOrderListItemDto {
  id: number
  schoolRef: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  type: OmsOrderListItemDtoType
  status: OmsOrderListItemDtoStatus
  /** @nullable */
  assemblyStatus: OmsOrderListItemDtoAssemblyStatus
  /** @nullable */
  priority: number | null
  /** @nullable */
  coverage: OmsOrderListItemDtoCoverage
  /** @nullable */
  completionPct: number | null
  /** @nullable */
  inStockQty: number | null
  /** @nullable */
  requiredQty: number | null
  /** @nullable */
  projectedStudentCount: number | null
  /** @nullable */
  studentCount: number | null
  /** @nullable */
  teacherCount: number | null
  /** @nullable */
  deliveryDate: string | null
  /** @nullable */
  submittedAt: string | null
  /** @nullable */
  createdAt: string | null
  kits: OmsOrderKitSummaryDto[]
}

export interface OmsOrderListResponseDto {
  data: OmsOrderListItemDto[]
  total: number
}

export type OmsOrderDtoType =
  typeof OmsOrderDtoType[keyof typeof OmsOrderDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderDtoType = {
  base: 'base',
  additional: 'additional',
  standalone: 'standalone'
} as const

export type OmsOrderDtoStatus =
  typeof OmsOrderDtoStatus[keyof typeof OmsOrderDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderDtoStatus = {
  submitted: 'submitted'
} as const

/**
 * @nullable
 */
export type OmsOrderDtoAssemblyStatus =
  | typeof OmsOrderDtoAssemblyStatus[keyof typeof OmsOrderDtoAssemblyStatus]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderDtoAssemblyStatus = {
  queued: 'queued',
  picking: 'picking',
  assembling: 'assembling',
  shipping: 'shipping',
  in_transit: 'in_transit',
  received: 'received',
  cancelled: 'cancelled'
} as const

/**
 * @nullable
 */
export type OmsOrderDtoCoverage =
  | typeof OmsOrderDtoCoverage[keyof typeof OmsOrderDtoCoverage]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface OmsOrderDto {
  id: number
  schoolRef: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  type: OmsOrderDtoType
  status: OmsOrderDtoStatus
  /** @nullable */
  assemblyStatus: OmsOrderDtoAssemblyStatus
  /** @nullable */
  priority: number | null
  /** @nullable */
  coverage: OmsOrderDtoCoverage
  /** @nullable */
  completionPct: number | null
  /** @nullable */
  inStockQty: number | null
  /** @nullable */
  requiredQty: number | null
  /** @nullable */
  projectedStudentCount: number | null
  /** @nullable */
  studentCount: number | null
  /** @nullable */
  teacherCount: number | null
  /** @nullable */
  deliveryDate: string | null
  /** @nullable */
  submittedAt: string | null
  /** @nullable */
  createdAt: string | null
}

export type OmsKitSkuDtoCoverage =
  typeof OmsKitSkuDtoCoverage[keyof typeof OmsKitSkuDtoCoverage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsKitSkuDtoCoverage = {
  ok: 'ok',
  partial: 'partial',
  none: 'none'
} as const

export interface OmsKitSkuDto {
  omsSkuId: number
  quantity: number
  /** @nullable */
  title: string | null
  /** @nullable */
  isbn: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
  requiredQty: number
  onHand: number
  onHandAllocated: number
  inTransitAllocated: number
  coverage: OmsKitSkuDtoCoverage
  /** @nullable */
  skuType: string | null
}

export type OmsKitDtoType = typeof OmsKitDtoType[keyof typeof OmsKitDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsKitDtoType = {
  student: 'student',
  teacher: 'teacher'
} as const

export interface OmsKitDto {
  id: number
  type: OmsKitDtoType
  grade: string
  quantity: number
  skus: OmsKitSkuDto[]
}

export interface OmsOrderContractDto {
  id: number
  /** @nullable */
  contractedStudentCount: number | null
  /** @nullable */
  acv: string | null
  /** @nullable */
  observation: string | null
}

export interface OmsAddressDto {
  id: number
  entityId: number
  schoolYear: number
  /** @nullable */
  recipientName: string | null
  zipCode: string
  street: string
  /** @nullable */
  number: string | null
  /** @nullable */
  complement: string | null
  /** @nullable */
  neighborhood: string | null
  city: string
  state: string
  /** @nullable */
  reference: string | null
}

export type OmsOrderEventDtoType =
  typeof OmsOrderEventDtoType[keyof typeof OmsOrderEventDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrderEventDtoType = {
  created: 'created',
  submitted: 'submitted',
  priority_changed: 'priority_changed',
  assembly_status_changed: 'assembly_status_changed'
} as const

/**
 * @nullable
 */
export type OmsOrderEventDtoMetadata = { [key: string]: unknown } | null

export interface OmsOrderEventDto {
  id: number
  type: OmsOrderEventDtoType
  /** @nullable */
  actorId: string | null
  /** @nullable */
  actorName: string | null
  /** @nullable */
  metadata: OmsOrderEventDtoMetadata
  /** @nullable */
  createdAt: string | null
}

/**
 * @nullable
 */
export type OmsOrderDetailResponseDtoContract = OmsOrderContractDto | null

/**
 * @nullable
 */
export type OmsOrderDetailResponseDtoAddress = OmsAddressDto | null

export interface OmsOrderDetailResponseDto {
  order: OmsOrderDto
  kits: OmsKitDto[]
  /** @nullable */
  contract: OmsOrderDetailResponseDtoContract
  /** @nullable */
  address: OmsOrderDetailResponseDtoAddress
  events: OmsOrderEventDto[]
}

export interface CreateKitItemDto {
  omsSkuId: number
  quantity: number
}

export type CreateKitDtoType =
  typeof CreateKitDtoType[keyof typeof CreateKitDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateKitDtoType = {
  student: 'student',
  teacher: 'teacher'
} as const

export interface CreateKitDto {
  type: CreateKitDtoType
  grade: string
  quantity: number
  items: CreateKitItemDto[]
}

export interface CreateStandaloneOrderBodyDto {
  schoolRef: number
  schoolYear: number
  deliveryDate?: string
  kits: CreateKitDto[]
}

export interface OmsCreateOrderResponseDto {
  id: number
}

export interface OmsDeleteOrderResponseDto {
  deleted: boolean
}

export interface OmsSubmitOrderResponseDto {
  submitted: boolean
  kitsCreated: number
  /** @nullable */
  alert: string | null
}

export interface ReorderOrdersBodyDto {
  orderedIds: number[]
}

export interface ReorderOrdersResponseDto {
  reordered: boolean
}

export interface OmsPurchaseInvoiceSummaryDto {
  id: number
  /** @nullable */
  number: string | null
}

/**
 * @nullable
 */
export type OmsPurchaseDtoSource =
  | typeof OmsPurchaseDtoSource[keyof typeof OmsPurchaseDtoSource]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsPurchaseDtoSource = {
  publisher: 'publisher',
  retail: 'retail'
} as const

export type OmsPurchaseDtoStatus =
  typeof OmsPurchaseDtoStatus[keyof typeof OmsPurchaseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsPurchaseDtoStatus = {
  pending: 'pending',
  in_transit: 'in_transit',
  conciliated: 'conciliated',
  cancelled: 'cancelled'
} as const

export interface OmsPurchaseDto {
  id: number
  /** @nullable */
  supplier: string | null
  /** @nullable */
  source: OmsPurchaseDtoSource
  status: OmsPurchaseDtoStatus
  /** @nullable */
  originPurchaseId: number | null
  /** @nullable */
  purchasedAt: string | null
  /** @nullable */
  createdAt: string | null
  itemsCount: number
  totalQty: number
  /** @nullable */
  totalAmount: string | null
  /** @nullable */
  notes: string | null
  /** @nullable */
  purchaseOrderNumber: string | null
  /** @nullable */
  expectedArrivalAt: string | null
  /** @nullable */
  createdById: string | null
  /** @nullable */
  createdByName: string | null
  invoices: OmsPurchaseInvoiceSummaryDto[]
}

export interface OmsPurchaseListResponseDto {
  data: OmsPurchaseDto[]
  total: number
}

export interface OmsPurchaseItemDto {
  omsSkuId: number
  quantity: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
}

export interface OmsPurchaseItemsResponseDto {
  data: OmsPurchaseItemDto[]
}

export type OmsPurchaseEventDtoType =
  typeof OmsPurchaseEventDtoType[keyof typeof OmsPurchaseEventDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsPurchaseEventDtoType = {
  created: 'created',
  conciliated: 'conciliated',
  cancelled: 'cancelled',
  invoice_added: 'invoice_added'
} as const

/**
 * @nullable
 */
export type OmsPurchaseEventDtoMetadata = { [key: string]: unknown } | null

export interface OmsPurchaseEventDto {
  id: number
  type: OmsPurchaseEventDtoType
  /** @nullable */
  actorId: string | null
  /** @nullable */
  actorName: string | null
  /** @nullable */
  metadata: OmsPurchaseEventDtoMetadata
  /** @nullable */
  createdAt: string | null
}

export interface OmsPurchaseEventsResponseDto {
  data: OmsPurchaseEventDto[]
}

export interface OmsStockRowDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  publisher: string | null
  /** @nullable */
  publisherGroup: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  shelfAddress: string | null
  onHand: number
  inTransit: number
  handling: number
  dispatched: number
  buying: number
  manualEntries: number
  purchasedTotal: number
}

export interface OmsStockListResponseDto {
  data: OmsStockRowDto[]
}

export interface OmsDemandRowDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  publisher: string | null
  /** @nullable */
  publisherGroup: string | null
  /** @nullable */
  coverUrl: string | null
  demandQty: number
  safetyQty: number
  buyingQty: number
  inTransitQty: number
  inFlowQty: number
  onHandQty: number
  handlingQty: number
  toBuyQty: number
}

export interface OmsDemandResponseDto {
  data: OmsDemandRowDto[]
  safetyMarginPct: number
}

export interface OmsStockKardexSkuDto {
  id: number
  /** @nullable */
  title: string | null
  /** @nullable */
  isbn: string | null
}

export interface OmsStockKardexSummaryDto {
  totalIn: number
  totalOut: number
  currentBalance: number
}

export interface OmsStockMovementDto {
  id: number
  /** @nullable */
  createdAt: string | null
  type: string
  /** @nullable */
  fromBucket: string | null
  /** @nullable */
  toBucket: string | null
  qty: number
  qtySigned: number
  saldoAcumulado: number
  /** @nullable */
  refType: string | null
  /** @nullable */
  refId: number | null
  /** @nullable */
  actorName: string | null
}

export interface OmsStockKardexPaginationDto {
  hasMore: boolean
  /** @nullable */
  nextCursor: number | null
}

/**
 * @nullable
 */
export type OmsStockMovementsResponseDtoSku = OmsStockKardexSkuDto | null

export interface OmsStockMovementsResponseDto {
  /** @nullable */
  sku: OmsStockMovementsResponseDtoSku
  summary: OmsStockKardexSummaryDto
  data: OmsStockMovementDto[]
  pagination: OmsStockKardexPaginationDto
}

export interface PurchaseItemDto {
  omsSkuId: number
  quantity: number
}

export type CreatePurchaseBodyDtoSource =
  typeof CreatePurchaseBodyDtoSource[keyof typeof CreatePurchaseBodyDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePurchaseBodyDtoSource = {
  publisher: 'publisher',
  retail: 'retail'
} as const

export interface CreatePurchaseBodyDto {
  supplier?: string
  source?: CreatePurchaseBodyDtoSource
  notes?: string
  /** @nullable */
  expectedArrivalAt?: string | null
  items: PurchaseItemDto[]
}

export interface OmsCreatePurchaseResponseDto {
  id: number
}

export interface OmsCancelPurchaseResponseDto {
  cancelled: boolean
}

export interface UpdatePurchaseNotesBodyDto {
  /** @nullable */
  notes?: string | null
}

export interface OmsUpdatePurchaseNotesResponseDto {
  /** @nullable */
  notes?: string | null
}

export interface UpdatePurchaseOrderNumberBodyDto {
  /** @nullable */
  purchaseOrderNumber?: string | null
}

export interface UpdatePurchaseExpectedArrivalBodyDto {
  /** @nullable */
  expectedArrivalAt?: string | null
}

export interface OmsInvoicePreviewItemDto {
  isbn: string
  description: string
  quantity: number
  unitPrice: number
  totalPrice: number
  matched: boolean
  /** @nullable */
  omsSkuId: number | null
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  publisher: string | null
  /** @nullable */
  publisherGroup: string | null
}

export interface OmsInvoicePreviewResponseDto {
  /** @nullable */
  supplier: string | null
  /** @nullable */
  invoiceNumber: string | null
  items: OmsInvoicePreviewItemDto[]
  matchedCount: number
  unmatchedCount: number
  invoiceNumberTaken: boolean
}

export interface OmsInvoiceMatchItemDto {
  isbn: string
  description: string
  quantity: number
  unitPrice: number
  /** @nullable */
  omsSkuId: number | null
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  matchedPurchaseId: number | null
  inOtherPendingPurchase: boolean
}

export interface OmsInvoiceMatchPreviewResponseDto {
  /** @nullable */
  supplier: string | null
  /** @nullable */
  invoiceNumber: string | null
  invoiceNumberTaken: boolean
  items: OmsInvoiceMatchItemDto[]
  matchedCount: number
  unmatchedCount: number
  /** @nullable */
  suggestedPurchaseId: number | null
}

export interface OmsConfirmInvoiceMatchResponseDto {
  /** @nullable */
  conciliatedPurchaseId: number | null
  /** @nullable */
  backorderPurchaseId: number | null
  /** @nullable */
  createdPurchaseId: number | null
}

export interface ConfirmInvoiceItemDto {
  omsSkuId: number
  quantity: number
  unitPrice?: number
}

export type ConfirmInvoiceBodyDtoSource =
  typeof ConfirmInvoiceBodyDtoSource[keyof typeof ConfirmInvoiceBodyDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmInvoiceBodyDtoSource = {
  publisher: 'publisher',
  retail: 'retail'
} as const

export interface ConfirmInvoiceBodyDto {
  supplier?: string
  source?: ConfirmInvoiceBodyDtoSource
  invoiceNumber?: string
  items: ConfirmInvoiceItemDto[]
}

export interface OmsInvoiceResponseDto {
  id: number
  /** @nullable */
  backorderPurchaseId?: number | null
  /** @nullable */
  conciliatedPurchaseId?: number | null
}

export interface OmsInvoiceFileUrlResponseDto {
  url: string
}

export interface CreateInvoiceBodyDto {
  number?: string
  fileUrl?: string
  issuedAt?: string
  receivedAt?: string
}

export interface InvoiceReceivePreviewItemDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
  expectedQty: number
  receivedQty: number
}

export interface InvoiceReceivePreviewResponseDto {
  purchaseId: number
  invoiceId: number
  /** @nullable */
  invoiceNumber: string | null
  /** @nullable */
  supplier: string | null
  items: InvoiceReceivePreviewItemDto[]
}

export interface ReceiveFromInvoiceBodyDto {
  purchaseId: number
  isbn: string
  qty?: number
}

export interface ReceiveFromInvoiceResponseDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  receivedQty: number
  expectedQty: number
  itemFullyReceived: boolean
  purchaseFullyReceived: boolean
}

export interface ScanReceiveBodyDto {
  isbn: string
  qty: number
}

export interface OmsScanReceiveResponseDto {
  omsSkuId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  coverUrl: string | null
  qty: number
  fromTransit: number
  fromDirect: number
}

export interface ReceiveStockBodyDto {
  omsSkuId: number
  qty: number
}

export interface OmsReceiveStockResponseDto {
  received: boolean
  omsSkuId: number
  qty: number
}

export interface ReceiveTransitBodyDto {
  omsSkuId: number
  qty: number
}

export interface OmsOrderDeliveryDto {
  type: string
  /** @nullable */
  deliveryDate: string | null
}

export interface OmsSelectionDto {
  id: number
  grade: string
  status: string
  /** @nullable */
  studentCount: number | null
  /** @nullable */
  teacherCount: number | null
  /** @nullable */
  booksPerGrade: number | null
  itemsCount: number
  additionalStudents: number
  additionalTeachers: number
  hasAdditional: boolean
}

export type OmsContractDtoSource =
  typeof OmsContractDtoSource[keyof typeof OmsContractDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsContractDtoSource = {
  hubspot: 'hubspot',
  manual: 'manual'
} as const

export type OmsContractDtoPipelineStatus =
  typeof OmsContractDtoPipelineStatus[keyof typeof OmsContractDtoPipelineStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsContractDtoPipelineStatus = {
  negotiating: 'negotiating',
  signed_pending: 'signed_pending',
  selecting: 'selecting',
  submitted: 'submitted'
} as const

/**
 * @nullable
 */
export type OmsContractDtoAddress = OmsAddressDto | null

export interface OmsContractDto {
  id: string
  source: OmsContractDtoSource
  /** @nullable */
  dealId: string | null
  schoolName: string
  /** @nullable */
  rootName: string | null
  /** @nullable */
  entityId: number | null
  /** @nullable */
  acv: string | null
  /** @nullable */
  studentCount: number | null
  /** @nullable */
  booksPerStudent: number | null
  /** @nullable */
  grades: string | null
  /** @nullable */
  observation: string | null
  pendencies: string[]
  pipelineStatus: OmsContractDtoPipelineStatus
  /** @nullable */
  submittedAt: string | null
  /** @nullable */
  deliveryDate: string | null
  /**
   * Total de kits do pedido base materializado. Null quando ainda não há pedido base.
   * @nullable
   */
  baseKitCount: number | null
  orderDeliveries: OmsOrderDeliveryDto[]
  /** @nullable */
  address: OmsContractDtoAddress
  selections: OmsSelectionDto[]
  /** @nullable */
  dealOwnerId: string | null
  /** @nullable */
  dealOwnerName: string | null
  /** @nullable */
  companyOwnerId: string | null
  /** @nullable */
  companyOwnerName: string | null
}

export interface OmsContractsListResponseDto {
  data: OmsContractDto[]
  total: number
}

export interface OmsSelectionDetailRowDto {
  id: number
  grade: string
  /** @nullable */
  status: string | null
  /** @nullable */
  studentCount: number | null
  /** @nullable */
  teacherCount: number | null
  /** @nullable */
  booksPerGrade: number | null
  itemsCount: number
}

export interface OmsSelectionBookDto {
  physicalEditionId: number
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
}

export interface SetContractDeliveryDateBodyDto {
  entityId: number
  schoolYear: number
  /** @nullable */
  deliveryDate: string | null
}

export interface OmsContractDeliveryDateResponseDto {
  entityId: number
  schoolYear: number
  /** @nullable */
  deliveryDate: string | null
}

export interface UpsertOmsAddressBodyDto {
  schoolYear: number
  zipCode: string
  street: string
  number?: string
  complement?: string
  neighborhood?: string
  city: string
  state: string
  recipientName?: string
  reference?: string
}

export type OmsSkuDtoType = typeof OmsSkuDtoType[keyof typeof OmsSkuDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsSkuDtoType = {
  literary: 'literary',
  didactic: 'didactic',
  teacher_material: 'teacher_material',
  addon: 'addon'
} as const

export interface OmsSkuDto {
  id: number
  /** @nullable */
  sourceEditionId: number | null
  type: OmsSkuDtoType
  /** @nullable */
  isbn: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  grade: string | null
  /** @nullable */
  publisher: string | null
  /** @nullable */
  publisherGroup: string | null
  /** @nullable */
  negotiatedPrice: string | null
  /** @nullable */
  shelfAddress: string | null
  /** @nullable */
  weightGrams: number | null
  /** @nullable */
  heightMm: number | null
  /** @nullable */
  widthMm: number | null
  /** @nullable */
  depthMm: number | null
  /** @nullable */
  onHand: number | null
  /** @nullable */
  handling: number | null
}

export interface OmsSkusListResponseDto {
  data: OmsSkuDto[]
  total: number
}

export interface OmsEditionOptionDto {
  editionId: number
  catalogId: number
  /** @nullable */
  isbnPhysical: string | null
  /** @nullable */
  title: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  grade: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  linkedSkuId: number | null
}

export type CreateSkuBodyDtoType =
  typeof CreateSkuBodyDtoType[keyof typeof CreateSkuBodyDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSkuBodyDtoType = {
  literary: 'literary',
  didactic: 'didactic',
  teacher_material: 'teacher_material',
  addon: 'addon'
} as const

export interface CreateSkuBodyDto {
  sourceEditionId?: number
  type: CreateSkuBodyDtoType
  title?: string
  isbn?: string
  author?: string
  coverUrl?: string
  grade?: string
  publisher?: string
  publisherGroup?: string
  weightGrams?: number
  heightMm?: number
  widthMm?: number
  depthMm?: number
  shelfAddress?: string
  negotiatedPrice?: number
}

export type UpdateSkuBodyDtoType =
  typeof UpdateSkuBodyDtoType[keyof typeof UpdateSkuBodyDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSkuBodyDtoType = {
  literary: 'literary',
  didactic: 'didactic',
  teacher_material: 'teacher_material',
  addon: 'addon'
} as const

export interface UpdateSkuBodyDto {
  type?: UpdateSkuBodyDtoType
  /**
   * Edição física vinculada ao SKU (hybrid_offer_physical_edition.id). null desvincula.
   * @nullable
   */
  sourceEditionId?: number | null
  grade?: string
  isbn?: string
  weightGrams?: number
  heightMm?: number
  widthMm?: number
  depthMm?: number
  coverUrl?: string
  shelfAddress?: string
  publisherGroup?: string
  negotiatedPrice?: number
  active?: number
}

export interface OmsSkuOriginDto {
  skuId: number
  /** @nullable */
  sourceEditionId: number | null
  editionId: number
  isbnPhysical: string
  /** @nullable */
  isbnDigital: string | null
  /** @nullable */
  physicalPrice: string | null
  /** @nullable */
  editionPublisher: string | null
  /** @nullable */
  pageCount: number | null
  catalogId: number
  /** @nullable */
  bookId: number | null
  /** @nullable */
  title: string | null
  /** @nullable */
  author: string | null
  /** @nullable */
  coverUrl: string | null
  /** @nullable */
  genre: string | null
  /** @nullable */
  catalogPublisher: string | null
  grade: string
  /** @nullable */
  synopsis: string | null
}

/**
 * @nullable
 */
export type OmsSkuOriginResponseDtoData = OmsSkuOriginDto | null

export interface OmsSkuOriginResponseDto {
  /** @nullable */
  data: OmsSkuOriginResponseDtoData
}

export interface OmsSchoolDto {
  entityId: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  grades: string[]
}

export interface GenerateOrderBodyDto {
  entityId: number
  schoolYear: number
}

export interface OmsGenerateOrderResponseDto {
  orderId: number
  kitsCreated: number
  warnings: string[]
  alreadyExists: boolean
}

export interface OmsLeaderOrderDocumentsDto {
  /** @nullable */
  separation: string | null
  /** @nullable */
  assemblyMap: string | null
  /** @nullable */
  boxAssembly: string | null
  /** @nullable */
  kitLabel: string | null
  /** @nullable */
  boxLabel: string | null
}

export interface OmsLeaderOrderDto {
  orderId: number
  schoolRef: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  type: string
  /** @nullable */
  assemblyStatus: string | null
  /** @nullable */
  priority: number | null
  /** @nullable */
  queuedAt: string | null
  kitsAssembled: number
  kitsTotal: number
  boxesClosed: number
  boxesTotal: number
  /** True quando todas as caixas estao fechadas e com etiqueta liberada (peso validado) */
  boxLabelsReleased: boolean
  documents: OmsLeaderOrderDocumentsDto
}

export interface OmsLeaderMetricsDto {
  ordersInProgress: number
  kitsAssembledToday: number
  kitsAssembledTotalActive: number
}

export interface OmsLeaderOverviewResponseDto {
  queueCount: number
  pickingCount: number
  assemblingCount: number
  shippingCount: number
  orders: OmsLeaderOrderDto[]
  metrics: OmsLeaderMetricsDto
}

export type OmsLeaderEventDtoKind =
  typeof OmsLeaderEventDtoKind[keyof typeof OmsLeaderEventDtoKind]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsLeaderEventDtoKind = {
  kit_assembled: 'kit_assembled',
  box_kit_scanned: 'box_kit_scanned'
} as const

export interface OmsLeaderEventDto {
  id: string
  kind: OmsLeaderEventDtoKind
  orderId: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  progress: number
  total: number
  /** @nullable */
  actorId: string | null
  /** @nullable */
  actorName: string | null
  occurredAt: string
}

export interface OmsLeaderEventsResponseDto {
  events: OmsLeaderEventDto[]
}

export interface BoxTypeDto {
  id: number
  label: string
  heightMm: number
  widthMm: number
  depthMm: number
  maxWeightGrams: number
  tareWeightGrams: number
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface BoxTypeListResponseDto {
  data: BoxTypeDto[]
}

export interface CreateBoxTypeBodyDto {
  label: string
  heightMm: number
  widthMm: number
  depthMm: number
  maxWeightGrams: number
  tareWeightGrams?: number
  active?: boolean
}

export interface BoxTypeResponseDto {
  data: BoxTypeDto
}

export interface UpdateBoxTypeBodyDto {
  label?: string
  heightMm?: number
  widthMm?: number
  depthMm?: number
  maxWeightGrams?: number
  tareWeightGrams?: number
  active?: boolean
}

export interface BoxAssignmentKitDto {
  type: string
  grade: string
  quantity: number
}

export interface BoxAssignmentDto {
  boxNumber: number
  omsBoxId: number
  kitCount: number
  kits: BoxAssignmentKitDto[]
}

export interface CalculateBoxesResponseDto {
  omsOrderId: number
  totalKits: number
  boxes: BoxAssignmentDto[]
}

export interface ResolveKitOrderResponseDto {
  /** @nullable */
  orderId: number | null
}

export interface BoxSessionGroupDto {
  type: string
  grade: string
  expected: number
  scanned: number
}

export type BoxSessionBoxDtoStatus =
  typeof BoxSessionBoxDtoStatus[keyof typeof BoxSessionBoxDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoxSessionBoxDtoStatus = {
  open: 'open',
  closed: 'closed'
} as const

export interface BoxSessionBoxDto {
  boxNumber: number
  omsBoxId: number
  /** @nullable */
  boxLabel: string | null
  kitCount: number
  scannedCount: number
  status: BoxSessionBoxDtoStatus
  /** @nullable */
  closedAt: string | null
  /**
   * Peso projetado da caixa em gramas (calculado pelo packing)
   * @nullable
   */
  projectedWeightGrams: number | null
  /** @nullable */
  measuredWeightGrams: number | null
  /** True quando a etiqueta da caixa esta liberada para impressao (peso bateu) */
  labelReleased: boolean
  groups: BoxSessionGroupDto[]
}

export interface BoxSessionResponseDto {
  orderId: number
  /** @nullable */
  schoolName: string | null
  schoolYear: number
  totalKits: number
  closedBoxes: number
  totalBoxes: number
  boxes: BoxSessionBoxDto[]
}

export interface ScanKitBodyDto {
  /** Codigo cru da etiqueta de kit bipada (ex: OMS-KIT-12) */
  code: string
}

export type ScanKitResponseDtoResult =
  typeof ScanKitResponseDtoResult[keyof typeof ScanKitResponseDtoResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScanKitResponseDtoResult = {
  valid: 'valid',
  kit_not_found: 'kit_not_found',
  wrong_order: 'wrong_order',
  box_full: 'box_full',
  not_in_box: 'not_in_box',
  already_closed: 'already_closed',
  already_scanned: 'already_scanned',
  invalid_code: 'invalid_code'
} as const

export interface ScanKitResponseDto {
  result: ScanKitResponseDtoResult
  /** @nullable */
  boxNumber: number | null
  scannedCount: number
  kitCount: number
  boxCompleted: boolean
}

export interface CloseBoxBodyDto {
  /** Peso medido na balanca em gramas */
  measuredWeightGrams: number
}

export interface CloseBoxResponseDto {
  closed: boolean
  /** True quando a etiqueta da caixa foi liberada (peso dentro da tolerancia) */
  labelReleased: boolean
  /** True quando esta era a ultima caixa e o pedido avancou para expedicao */
  orderShipping: boolean
}

export interface BoxUndoScanResponseDto {
  undone: boolean
  /** @nullable */
  omsKitId: number | null
}

export type ShipmentDtoStatus =
  typeof ShipmentDtoStatus[keyof typeof ShipmentDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoStatus = {
  quoting: 'quoting',
  quoted: 'quoted',
  invoiced: 'invoiced',
  in_transit: 'in_transit',
  delivered: 'delivered',
  returned: 'returned',
  error: 'error'
} as const

export interface ShipmentDto {
  id: number
  omsOrderId: number
  status: ShipmentDtoStatus
  /** @nullable */
  originCep?: string | null
  /** @nullable */
  declaredValue?: string | null
  /** @nullable */
  totalWeightGrams?: number | null
  /** @nullable */
  boxCount?: number | null
  /** @nullable */
  selectedQuoteId?: number | null
  /** @nullable */
  invoiceNumber?: string | null
  /** @nullable */
  trackingCode?: string | null
  /** @nullable */
  trackingStatus?: string | null
}

export interface ShipmentQuoteDto {
  id: number
  /** @nullable */
  cotacaoId?: string | null
  price: string
  /** @nullable */
  deadlineDays?: number | null
  expired: boolean
}

/**
 * @nullable
 */
export type ShipmentEventDtoMetadata = { [key: string]: unknown } | null

export interface ShipmentEventDto {
  id: number
  type: string
  /** @nullable */
  actorName?: string | null
  /** @nullable */
  metadata?: ShipmentEventDtoMetadata
  /** @nullable */
  createdAt?: string | null
}

export interface NfeDto {
  id: number
  /** @nullable */
  number?: string | null
  /** @nullable */
  serie?: string | null
  /** @nullable */
  chave?: string | null
  /** @nullable */
  fileUrl?: string | null
}

/**
 * @nullable
 */
export type ShipmentResponseDtoShipment = ShipmentDto | null

export interface ShipmentResponseDto {
  /** @nullable */
  shipment?: ShipmentResponseDtoShipment
  quotes: ShipmentQuoteDto[]
  events: ShipmentEventDto[]
  nfes: NfeDto[]
}

export interface SetTrackingNumberBodyDto {
  /** Numero da NF despachada usada no rastreio Braspress */
  invoiceNumber: string
}

export interface RegisterNfeBodyDto {
  number: string
  serie?: string
  /** Chave de acesso (44 digitos) */
  chave?: string
  /** Data de emissao (ISO ou yyyy-mm-dd) */
  issuedAt?: string
}

export interface GenerateImageJobResponseDto {
  /** Job ID to poll for result */
  jobId: string
}

/**
 * Job status
 */
export type ImageJobStatusResponseDtoStatus =
  typeof ImageJobStatusResponseDtoStatus[keyof typeof ImageJobStatusResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageJobStatusResponseDtoStatus = {
  pending: 'pending',
  completed: 'completed',
  failed: 'failed'
} as const

export interface ImageJobStatusResponseDto {
  /** Job ID */
  jobId: string
  /** Job status */
  status: ImageJobStatusResponseDtoStatus
  /** CDN URL of the generated image (only when completed) */
  imageUrl?: string
  /** Format used */
  format?: string
  /** Full prompt sent to OpenAI */
  prompt?: string
  /** Error message (only when failed) */
  error?: string
}

export interface CreateConnectionDto {
  /** Apelido do número */
  label?: string
  /** ID do membro dono da conexão */
  ownerMemberId?: string
}

export interface SetClientRefDto {
  /** Identidade do cliente para o contato */
  clientRef: string
}

export type ClientDtoName = { [key: string]: unknown }

export type ClientDtoEntityType = { [key: string]: unknown }

export type ClientDtoCity = { [key: string]: unknown }

export type ClientDtoState = { [key: string]: unknown }

export interface ClientDto {
  id: number
  name?: ClientDtoName
  entityType?: ClientDtoEntityType
  city?: ClientDtoCity
  state?: ClientDtoState
}

/**
 * Data source to query
 */
export type RawQueryDtoSource =
  typeof RawQueryDtoSource[keyof typeof RawQueryDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RawQueryDtoSource = {
  analytics: 'analytics',
  super: 'super',
  core: 'core'
} as const

export interface RawQueryDto {
  /** Data source to query */
  source: RawQueryDtoSource
  /** Read-only SELECT/WITH SQL statement (single statement, no writes) */
  sql: string
}

export type ClientSourceLinkDtoSourceName = { [key: string]: unknown }

export type ClientSourceLinkDtoSourceIdentifier = { [key: string]: unknown }

export type ClientSourceLinkDtoSourceRole = { [key: string]: unknown }

export type ClientSourceLinkDtoCreatedAt = { [key: string]: unknown }

export type ClientSourceLinkDtoUpdatedAt = { [key: string]: unknown }

export interface ClientSourceLinkDto {
  id: number
  clientId: number
  clientName: string
  source: string
  sourceRef: string
  sourceName?: ClientSourceLinkDtoSourceName
  sourceIdentifier?: ClientSourceLinkDtoSourceIdentifier
  sourceRole?: ClientSourceLinkDtoSourceRole
  linkedBy: string
  createdAt?: ClientSourceLinkDtoCreatedAt
  updatedAt?: ClientSourceLinkDtoUpdatedAt
}

export interface CreateLinkDto {
  [key: string]: unknown
}

export interface CreateLinkResponseDto {
  id: number
}

export interface CreateLinksDto {
  links: CreateLinkDto[]
}

export interface CreateLinksResponseDto {
  created: number
}

export interface DeleteLinkResponseDto {
  deleted: boolean
}

export type WaContactDtoPushName = { [key: string]: unknown }

export type WaContactDtoPhone = { [key: string]: unknown }

export type WaContactDtoAvatarUrl = { [key: string]: unknown }

export type WaContactDtoClientRef = { [key: string]: unknown }

export interface WaContactDto {
  connectionId: string
  jid: string
  pushName?: WaContactDtoPushName
  phone?: WaContactDtoPhone
  avatarUrl?: WaContactDtoAvatarUrl
  clientRef?: WaContactDtoClientRef
}

export type ElephanUserDtoName = { [key: string]: unknown }

export type ElephanUserDtoEmail = { [key: string]: unknown }

export type ElephanUserDtoType = { [key: string]: unknown }

export interface ElephanUserDto {
  id: string
  name?: ElephanUserDtoName
  email?: ElephanUserDtoEmail
  type?: ElephanUserDtoType
}

export type PipedriveOrganizationDtoName = { [key: string]: unknown }

export interface PipedriveOrganizationDto {
  id: string
  name?: PipedriveOrganizationDtoName
}

export type ElephanDealDtoCrmUrl = { [key: string]: unknown }

export type ElephanDealDtoTitle = { [key: string]: unknown }

export type ElephanDealDtoLastDate = { [key: string]: unknown }

export interface ElephanDealDto {
  dealId: string
  crmUrl?: ElephanDealDtoCrmUrl
  title?: ElephanDealDtoTitle
  lastDate?: ElephanDealDtoLastDate
  transcribeCount: number
}

export type ElephanTranscribeDtoTitle = { [key: string]: unknown }

export type ElephanTranscribeDtoDateIncluded = { [key: string]: unknown }

export type ElephanTranscribeDtoStatus = { [key: string]: unknown }

export type ElephanTranscribeDtoDuration = { [key: string]: unknown }

export type ElephanTranscribeDtoSummary = { [key: string]: unknown }

export type ElephanTranscribeDtoSentimentAnalysis = { [key: string]: unknown }

export type ElephanTranscribeDtoTranscript = { [key: string]: unknown }

export type ElephanTranscribeDtoAudioUrl = { [key: string]: unknown }

export type ElephanTranscribeDtoUser = { [key: string]: unknown }

export type ElephanTranscribeDtoDealId = { [key: string]: unknown }

export type ElephanTranscribeDtoCrmUrl = { [key: string]: unknown }

export interface ElephanTranscribeDto {
  id: string
  title?: ElephanTranscribeDtoTitle
  dateIncluded?: ElephanTranscribeDtoDateIncluded
  status?: ElephanTranscribeDtoStatus
  duration?: ElephanTranscribeDtoDuration
  summary?: ElephanTranscribeDtoSummary
  keywords: string[]
  importantPoints: string[]
  competitors: string[]
  tags: string[]
  sentimentAnalysis?: ElephanTranscribeDtoSentimentAnalysis
  transcript?: ElephanTranscribeDtoTranscript
  audioUrl?: ElephanTranscribeDtoAudioUrl
  user?: ElephanTranscribeDtoUser
  dealId?: ElephanTranscribeDtoDealId
  crmUrl?: ElephanTranscribeDtoCrmUrl
}

export type ForticsContactDtoName = { [key: string]: unknown }

export type ForticsContactDtoEmail = { [key: string]: unknown }

export type ForticsContactDtoPhone = { [key: string]: unknown }

export interface ForticsContactDto {
  id: string
  name?: ForticsContactDtoName
  email?: ForticsContactDtoEmail
  phone?: ForticsContactDtoPhone
  channels: string[]
}

export interface ForticsContactsPageDto {
  data: ForticsContactDto[]
  page: number
  lastPage: number
  perPage: number
  total: number
}

export type OctadeskContactDtoName = { [key: string]: unknown }

export type OctadeskContactDtoEmail = { [key: string]: unknown }

export type OctadeskContactDtoPhone = { [key: string]: unknown }

export type OctadeskContactDtoOrganization = { [key: string]: unknown }

export interface OctadeskContactDto {
  id: string
  name?: OctadeskContactDtoName
  email?: OctadeskContactDtoEmail
  phone?: OctadeskContactDtoPhone
  organization?: OctadeskContactDtoOrganization
}

export interface OctadeskContactsPageDto {
  data: OctadeskContactDto[]
  page: number
  lastPage: number
  perPage: number
  total: number
}

export type UnifiedEntityArvoreDtoCode = { [key: string]: unknown }

export type UnifiedEntityArvoreDtoLegacyId = { [key: string]: unknown }

export type UnifiedEntityArvoreDtoInep = { [key: string]: unknown }

export interface UnifiedEntityArvoreDto {
  id: number
  code?: UnifiedEntityArvoreDtoCode
  legacyId?: UnifiedEntityArvoreDtoLegacyId
  inep?: UnifiedEntityArvoreDtoInep
}

export type UnifiedEntitySuperDtoId = { [key: string]: unknown }

export type UnifiedEntitySuperDtoOrigem = { [key: string]: unknown }

export type UnifiedEntitySuperDtoProjectId = { [key: string]: unknown }

export type UnifiedEntitySuperDtoProjectName = { [key: string]: unknown }

export interface UnifiedEntitySuperDto {
  id?: UnifiedEntitySuperDtoId
  origem?: UnifiedEntitySuperDtoOrigem
  projectId?: UnifiedEntitySuperDtoProjectId
  projectName?: UnifiedEntitySuperDtoProjectName
}

export type UnifiedEntityDtoIdentityId = { [key: string]: unknown }

export type UnifiedEntityDtoType =
  typeof UnifiedEntityDtoType[keyof typeof UnifiedEntityDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnifiedEntityDtoType = {
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type UnifiedEntityDtoParentId = { [key: string]: unknown }

export type UnifiedEntityDtoCnpj = { [key: string]: unknown }

export type UnifiedEntityDtoSyncStatus =
  typeof UnifiedEntityDtoSyncStatus[keyof typeof UnifiedEntityDtoSyncStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnifiedEntityDtoSyncStatus = {
  synced: 'synced',
  synced_discarded: 'synced_discarded',
  arvore_only: 'arvore_only',
  superautor_only: 'superautor_only'
} as const

export type UnifiedEntityDtoSource =
  typeof UnifiedEntityDtoSource[keyof typeof UnifiedEntityDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnifiedEntityDtoSource = {
  arvore: 'arvore',
  super: 'super',
  both: 'both'
} as const

export type UnifiedEntityDtoRootName = { [key: string]: unknown }

export type UnifiedEntityDtoDegree = { [key: string]: unknown }

export interface UnifiedEntityDto {
  id: number
  /** Universal entity reference (e.g. "arvore:123" or "super:school:456") */
  ref: string
  identityId?: UnifiedEntityDtoIdentityId
  name: string
  type: UnifiedEntityDtoType
  parentId?: UnifiedEntityDtoParentId
  cnpj?: UnifiedEntityDtoCnpj
  arvore?: UnifiedEntityArvoreDto
  super?: UnifiedEntitySuperDto
  syncStatus: UnifiedEntityDtoSyncStatus
  source: UnifiedEntityDtoSource
  platforms: string[]
  childrenCount: number
  rootName?: UnifiedEntityDtoRootName
  degree?: UnifiedEntityDtoDegree
}

export interface ListUnifiedEntitiesResponseDto {
  entities: UnifiedEntityDto[]
  total: number
  page: number
  perPage: number
}

export type UnifiedUserArvoreDtoProfileId = { [key: string]: unknown }

export type UnifiedUserArvoreDtoEntityId = { [key: string]: unknown }

export type UnifiedUserArvoreDtoEntityName = { [key: string]: unknown }

export type UnifiedUserArvoreDtoEntityPath = { [key: string]: unknown }

export type UnifiedUserArvoreDtoAccessToken = { [key: string]: unknown }

export interface UnifiedUserArvoreDto {
  userId: number
  profileId?: UnifiedUserArvoreDtoProfileId
  entityId?: UnifiedUserArvoreDtoEntityId
  entityName?: UnifiedUserArvoreDtoEntityName
  entityPath?: UnifiedUserArvoreDtoEntityPath
  accessToken?: UnifiedUserArvoreDtoAccessToken
}

export type UnifiedUserSuperDtoUserId = { [key: string]: unknown }

export type UnifiedUserSuperDtoStudentId = { [key: string]: unknown }

export type UnifiedUserSuperDtoAccessLevel = { [key: string]: unknown }

export type UnifiedUserSuperDtoSchoolId = { [key: string]: unknown }

export type UnifiedUserSuperDtoSchoolName = { [key: string]: unknown }

export type UnifiedUserSuperDtoClassName = { [key: string]: unknown }

export type UnifiedUserSuperDtoSuperCodigo = { [key: string]: unknown }

export interface UnifiedUserSuperDto {
  userId?: UnifiedUserSuperDtoUserId
  studentId?: UnifiedUserSuperDtoStudentId
  accessLevel?: UnifiedUserSuperDtoAccessLevel
  schoolId?: UnifiedUserSuperDtoSchoolId
  schoolName?: UnifiedUserSuperDtoSchoolName
  className?: UnifiedUserSuperDtoClassName
  superCodigo?: UnifiedUserSuperDtoSuperCodigo
}

export type UnifiedUserDtoIdentityId = { [key: string]: unknown }

export type UnifiedUserDtoEmail = { [key: string]: unknown }

export type UnifiedUserDtoPhone = { [key: string]: unknown }

export type UnifiedUserDtoSource =
  typeof UnifiedUserDtoSource[keyof typeof UnifiedUserDtoSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnifiedUserDtoSource = {
  arvore: 'arvore',
  super: 'super',
  both: 'both'
} as const

export interface UnifiedUserDto {
  id: number
  ref: string
  identityId?: UnifiedUserDtoIdentityId
  name: string
  email?: UnifiedUserDtoEmail
  phone?: UnifiedUserDtoPhone
  role: string
  arvore?: UnifiedUserArvoreDto
  super?: UnifiedUserSuperDto
  syncStatus: string
  source: UnifiedUserDtoSource
}

export interface ListEntityUsersResponseDto {
  users: UnifiedUserDto[]
  total: number
  page: number
  perPage: number
}

export interface EntityModuleDto {
  moduleId: number
  moduleName: string
  contractModuleId: number
  contractId: number
}

export interface ListEntityModulesResponseDto {
  modules: EntityModuleDto[]
}

export type CreateUnifiedEntityBodyDtoType =
  typeof CreateUnifiedEntityBodyDtoType[keyof typeof CreateUnifiedEntityBodyDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUnifiedEntityBodyDtoType = {
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export interface CreateUnifiedEntityBodyDto {
  type: CreateUnifiedEntityBodyDtoType
  name: string
  parentId?: string
  isFree?: boolean
  responsibleName?: string
  responsibleEmail?: string
  cnpj?: string
  razaoSocial?: string
  phone?: string
  structureType?: string
  segment?: string
  whoPays?: string
  loginEducator?: string
  loginStudent?: string
  blockTokenAccess?: boolean
  cep?: string
  state?: string
  city?: string
  neighborhood?: string
  address?: string
  addressNumber?: string
  complement?: string
  instagram?: string
  facebook?: string
  site?: string
  infoResponsibleName?: string
  infoEmail?: string
  infoPhone?: string
  infoCargo?: string
  estimatedStudents?: string
  tipoInstituicao?: string
  modeloEnsino?: string
  degree?: string
}

export type CreateUnifiedEntityResponseDtoIdentityId = {
  [key: string]: unknown
}

export type CreateUnifiedEntityResponseDtoArvoreId = { [key: string]: unknown }

export type CreateUnifiedEntityResponseDtoSuperId = { [key: string]: unknown }

export interface CreateUnifiedEntityResponseDto {
  id: number
  identityId?: CreateUnifiedEntityResponseDtoIdentityId
  name: string
  type: string
  arvoreId?: CreateUnifiedEntityResponseDtoArvoreId
  superId?: CreateUnifiedEntityResponseDtoSuperId
}

export interface CreateUserItemDto {
  name: string
  email?: string
  phone?: string
  password?: string
}

export interface CreateUserBodyDto {
  entityId: string
  role: string
  users: CreateUserItemDto[]
}

export interface CreatedUserDto {
  id: number
  name: string
  accessToken?: string
  generatedPassword?: string
}

export interface CreateUserResponseDto {
  success: boolean
  created: CreatedUserDto[]
}

export type EntityDetailResponseDtoIdentityId = { [key: string]: unknown }

export type EntityDetailResponseDtoPhone = { [key: string]: unknown }

export type EntityDetailResponseDtoAddress = { [key: string]: unknown }

export type EntityDetailResponseDtoCity = { [key: string]: unknown }

export type EntityDetailResponseDtoState = { [key: string]: unknown }

export type EntityDetailResponseDtoCnpj = { [key: string]: unknown }

export type EntityDetailResponseDtoRazaoSocial = { [key: string]: unknown }

export type EntityDetailResponseDtoResponsibleName = { [key: string]: unknown }

export type EntityDetailResponseDtoResponsibleEmail = { [key: string]: unknown }

export type EntityDetailResponseDtoZipCode = { [key: string]: unknown }

export type EntityDetailResponseDtoNeighborhood = { [key: string]: unknown }

export type EntityDetailResponseDtoAncestry = { [key: string]: unknown }

export type EntityDetailResponseDtoInep = { [key: string]: unknown }

export type EntityDetailResponseDtoSite = { [key: string]: unknown }

export type EntityDetailResponseDtoInstagram = { [key: string]: unknown }

export type EntityDetailResponseDtoFacebook = { [key: string]: unknown }

export type EntityDetailResponseDtoSegment = { [key: string]: unknown }

export type EntityDetailResponseDtoLoginEducator = { [key: string]: unknown }

export type EntityDetailResponseDtoLoginStudent = { [key: string]: unknown }

export type EntityDetailResponseDtoLoginPrefix = { [key: string]: unknown }

export type EntityDetailResponseDtoSuperId = { [key: string]: unknown }

export type EntityDetailResponseDtoDegree = { [key: string]: unknown }

export interface EntityDetailResponseDto {
  id: number
  ref: string
  name: string
  type: string
  identityId?: EntityDetailResponseDtoIdentityId
  phone?: EntityDetailResponseDtoPhone
  address?: EntityDetailResponseDtoAddress
  city?: EntityDetailResponseDtoCity
  state?: EntityDetailResponseDtoState
  cnpj?: EntityDetailResponseDtoCnpj
  razaoSocial?: EntityDetailResponseDtoRazaoSocial
  responsibleName?: EntityDetailResponseDtoResponsibleName
  responsibleEmail?: EntityDetailResponseDtoResponsibleEmail
  zipCode?: EntityDetailResponseDtoZipCode
  neighborhood?: EntityDetailResponseDtoNeighborhood
  ancestry?: EntityDetailResponseDtoAncestry
  inep?: EntityDetailResponseDtoInep
  site?: EntityDetailResponseDtoSite
  instagram?: EntityDetailResponseDtoInstagram
  facebook?: EntityDetailResponseDtoFacebook
  segment?: EntityDetailResponseDtoSegment
  loginEducator?: EntityDetailResponseDtoLoginEducator
  loginStudent?: EntityDetailResponseDtoLoginStudent
  loginPrefix?: EntityDetailResponseDtoLoginPrefix
  blockTokenAccess: boolean
  superId?: EntityDetailResponseDtoSuperId
  degree?: EntityDetailResponseDtoDegree
}

export interface UpdateUnifiedEntityBodyDto {
  name?: string
  phone?: string
  address?: string
  city?: string
  state?: string
  cnpj?: string
  razaoSocial?: string
  zipCode?: string
  neighborhood?: string
  site?: string
  degree?: string
  /** Block login via access token. When set, the value cascades to every descendant entity that has its own b2b subscription account. */
  blockTokenAccess?: boolean
}

export interface UpdateUnifiedEntityResponseDto {
  success: boolean
  id: number
}

export type TogglePlatformBodyDtoPlatform =
  typeof TogglePlatformBodyDtoPlatform[keyof typeof TogglePlatformBodyDtoPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TogglePlatformBodyDtoPlatform = {
  Escrita: 'Escrita'
} as const

export interface TogglePlatformBodyDto {
  entityId: number
  platform: TogglePlatformBodyDtoPlatform
  enabled: boolean
}

export interface TogglePlatformResponseDto {
  success: boolean
  entityId: number
  platform: string
  enabled: boolean
}

export interface MoveUserBodyDto {
  userId: string
  targetEntityId: string
}

export interface MoveUserResponseDto {
  success: boolean
  userId: string
  targetEntityId: string
}

export interface ActivateUserBodyDto {
  email: string
  rootId: number
  entityId: number
}

export interface ActivateUserResponseDto {
  success: boolean
  userId: number
  email: string
  entityId: number
  rootId: number
}

export interface ActivateUsersBulkRowDto {
  email: string
  rootId: number
  entityId: number
}

export interface ActivateUsersBulkBodyDto {
  rows: ActivateUsersBulkRowDto[]
}

export interface ActivateUsersBulkActivatedItemDto {
  email: string
  userId: number
  rootId: number
  entityId: number
}

export type ActivateUsersBulkSkippedItemDtoReason =
  typeof ActivateUsersBulkSkippedItemDtoReason[keyof typeof ActivateUsersBulkSkippedItemDtoReason]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivateUsersBulkSkippedItemDtoReason = {
  user_not_found: 'user_not_found',
  entity_not_found: 'entity_not_found',
  entity_not_in_root: 'entity_not_in_root',
  internal_error: 'internal_error'
} as const

export interface ActivateUsersBulkSkippedItemDto {
  email: string
  rootId: number
  entityId: number
  reason: ActivateUsersBulkSkippedItemDtoReason
}

export interface ActivateUsersBulkResponseDto {
  total: number
  activated: ActivateUsersBulkActivatedItemDto[]
  skipped: ActivateUsersBulkSkippedItemDto[]
}

export interface UpdateUserBodyDto {
  name?: string
  email?: string
  phone?: string
  role?: string
}

export interface UpdateUserResponseDto {
  success: boolean
  id: number
}

export interface SoftDeleteEntityResponseDto {
  success: boolean
  entityId: number
  deactivatedAccounts: number
  deactivatedProfiles: number
}

export interface RemoveUserProfileResponseDto {
  success: boolean
  userId: number
}

export interface ContractModuleItemDto {
  id: number
  moduleId: number
  moduleName: string
}

export interface ContractListItemDto {
  contractId: number
  clientName: string
  clientId: number
  contractType: string
  active: boolean
  modules: ContractModuleItemDto[]
}

export interface ListContractsResponseDto {
  contracts: ContractListItemDto[]
}

export type ContractDetailModuleDtoInfo = { [key: string]: unknown }

export interface ContractDetailModuleDto {
  id: number
  moduleId: number
  moduleName: string
  info?: ContractDetailModuleDtoInfo
}

export type ContractDetailFeatureDtoInfo = { [key: string]: unknown }

export interface ContractDetailFeatureDto {
  id: number
  featureId: number
  featureName: string
  info?: ContractDetailFeatureDtoInfo
}

export type EntityTreeNodeDtoEntityType = { [key: string]: unknown }

export type EntityTreeNodeDtoDegree = { [key: string]: unknown }

export type EntityTreeNodeDtoAncestry = { [key: string]: unknown }

export interface EntityTreeNodeDto {
  id: number
  name: string
  entityType?: EntityTreeNodeDtoEntityType
  degree?: EntityTreeNodeDtoDegree
  ancestry?: EntityTreeNodeDtoAncestry
}

export type ContractDetailResponseDtoClientId = { [key: string]: unknown }

export type ContractDetailResponseDtoType = { [key: string]: unknown }

export type ContractDetailResponseDtoCompanyName = { [key: string]: unknown }

export type ContractDetailResponseDtoTradingName = { [key: string]: unknown }

export type ContractDetailResponseDtoCnpj = { [key: string]: unknown }

export type ContractDetailResponseDtoStateRegistration = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoSignatureDate = { [key: string]: unknown }

export type ContractDetailResponseDtoStartDate = { [key: string]: unknown }

export type ContractDetailResponseDtoEndDate = { [key: string]: unknown }

export type ContractDetailResponseDtoExpirationWarningDays = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoFinanceContactName = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoFinanceContactEmail = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoFinanceContactPhone = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoObservation = { [key: string]: unknown }

export type ContractDetailResponseDtoFirstChargeDate = {
  [key: string]: unknown
}

export type ContractDetailResponseDtoMunicipalRegistration = {
  [key: string]: unknown
}

export interface ContractDetailResponseDto {
  id: number
  clientId?: ContractDetailResponseDtoClientId
  type?: ContractDetailResponseDtoType
  active: boolean
  companyName?: ContractDetailResponseDtoCompanyName
  tradingName?: ContractDetailResponseDtoTradingName
  cnpj?: ContractDetailResponseDtoCnpj
  stateRegistration?: ContractDetailResponseDtoStateRegistration
  signatureDate?: ContractDetailResponseDtoSignatureDate
  startDate?: ContractDetailResponseDtoStartDate
  endDate?: ContractDetailResponseDtoEndDate
  expirationWarningDays?: ContractDetailResponseDtoExpirationWarningDays
  disableContractAfterExpiration: boolean
  financeContactName?: ContractDetailResponseDtoFinanceContactName
  financeContactEmail?: ContractDetailResponseDtoFinanceContactEmail
  financeContactPhone?: ContractDetailResponseDtoFinanceContactPhone
  observation?: ContractDetailResponseDtoObservation
  firstChargeDate?: ContractDetailResponseDtoFirstChargeDate
  municipalRegistration?: ContractDetailResponseDtoMunicipalRegistration
  createdAt: string
  updatedAt: string
  modules: ContractDetailModuleDto[]
  features: ContractDetailFeatureDto[]
  entityTree: EntityTreeNodeDto[]
}

export interface CreateContractBodyDto {
  type: string
  clientId: number
  companyName?: string
  tradingName?: string
  cnpj?: string
  observation?: string
}

export interface CreateContractResponseDto {
  id: number
}

export interface UpdateContractBodyDto {
  type?: string
  companyName?: string
  tradingName?: string
  cnpj?: string
  stateRegistration?: string
  signatureDate?: string
  startDate?: string
  endDate?: string
  expirationWarningDays?: number
  disableContractAfterExpiration?: boolean
  financeContactName?: string
  financeContactEmail?: string
  financeContactPhone?: string
  observation?: string
  firstChargeDate?: string
  municipalRegistration?: string
}

export interface UpdateContractResponseDto {
  success: boolean
}

export interface ToggleContractActiveBodyDto {
  active: boolean
}

export interface ToggleContractActiveResponseDto {
  success: boolean
  active: boolean
}

export type ContractModuleInputDtoInfo = { [key: string]: unknown }

export interface ContractModuleInputDto {
  name: string
  info?: ContractModuleInputDtoInfo
}

export interface UpsertContractModulesBodyDto {
  observation?: string
  contractModules: ContractModuleInputDto[]
}

export interface UpsertContractModulesResponseDto {
  success: boolean
}

export interface AssignModuleToEntitiesBodyDto {
  entityId: number
  entityAndSubtree: boolean
  degrees?: string[]
}

export interface AssignModuleToEntitiesResponseDto {
  success: boolean
  appliedDegrees?: string[]
  notFoundDegrees?: string[]
}

export interface RemoveModuleFromEntitiesBodyDto {
  entityId: number
  entityAndSubtree: boolean
  degrees?: string[]
}

export interface RemoveModuleFromEntitiesResponseDto {
  success: boolean
}

export interface ToggleFeatureInputDto {
  name: string
  enabled: boolean
}

export interface ToggleContractFeaturesBodyDto {
  features: ToggleFeatureInputDto[]
}

export interface ToggleContractFeaturesResponseDto {
  success: boolean
}

export type ModuleListItemDtoIconUri = { [key: string]: unknown }

export interface ModuleListItemDto {
  id: number
  name: string
  iconUri?: ModuleListItemDtoIconUri
}

export interface ListModulesResponseDto {
  modules: ModuleListItemDto[]
}

export interface FeatureListItemDto {
  id: number
  name: string
}

export interface ListFeaturesResponseDto {
  features: FeatureListItemDto[]
}

export interface ContractEntityTreeResponseDto {
  entities: EntityTreeNodeDto[]
}

export type CreateImportationDtoPlatformType =
  typeof CreateImportationDtoPlatformType[keyof typeof CreateImportationDtoPlatformType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateImportationDtoPlatformType = {
  arvore: 'arvore',
  superautor: 'superautor'
} as const

export type CreateImportationDtoReaderType =
  typeof CreateImportationDtoReaderType[keyof typeof CreateImportationDtoReaderType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateImportationDtoReaderType = {
  student: 'student',
  teacher: 'teacher',
  guardian: 'guardian'
} as const

export type CreateImportationDtoNavigationContextType =
  typeof CreateImportationDtoNavigationContextType[keyof typeof CreateImportationDtoNavigationContextType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateImportationDtoNavigationContextType = {
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export interface CreateImportationDto {
  platformType: CreateImportationDtoPlatformType
  readerType: CreateImportationDtoReaderType
  navigationContextType: CreateImportationDtoNavigationContextType
  navigationContextId: string
  rootEntityId?: number
}

export interface ColumnMappingItemDto {
  columnIndex: number
  /** @nullable */
  targetField: string | null
  included: boolean
}

export interface ConfirmMappingDto {
  mapping: ColumnMappingItemDto[]
}

export interface SelectSheetDto {
  [key: string]: unknown
}

export type UpdateImportationLineDtoData = { [key: string]: unknown }

export type UpdateImportationLineDtoReviewFlagsItem = { [key: string]: unknown }

export type UpdateImportationLineDtoStatus =
  typeof UpdateImportationLineDtoStatus[keyof typeof UpdateImportationLineDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateImportationLineDtoStatus = {
  pending: 'pending',
  reviewed: 'reviewed',
  processing: 'processing',
  done: 'done',
  error: 'error'
} as const

export interface UpdateImportationLineDto {
  data?: UpdateImportationLineDtoData
  selected?: boolean
  reviewFlags?: UpdateImportationLineDtoReviewFlagsItem[]
  status?: UpdateImportationLineDtoStatus
}

export type JourneyStatusItemDtoStatus =
  typeof JourneyStatusItemDtoStatus[keyof typeof JourneyStatusItemDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyStatusItemDtoStatus = {
  completed: 'completed',
  in_progress: 'in_progress',
  locked: 'locked'
} as const

export interface JourneyStatusItemDto {
  journeyId: number
  title: string
  slug: string
  position: number
  lexilePoints: number
  status: JourneyStatusItemDtoStatus
  totalItems: number
  completedItems: number
}

export interface GetJourneysStatusResponseDto {
  journeys: JourneyStatusItemDto[]
  grade: string
  /** Whether all journeys of the grade are completed */
  allCompleted: boolean
  /** Whether the grade completion bonus has already been claimed */
  gradeBonusClaimed: boolean
}

export type UserTaskDtoTaskType =
  typeof UserTaskDtoTaskType[keyof typeof UserTaskDtoTaskType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTaskDtoTaskType = {
  listening: 'listening',
  reading: 'reading',
  quiz: 'quiz'
} as const

export type UserTaskDtoStatus =
  typeof UserTaskDtoStatus[keyof typeof UserTaskDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTaskDtoStatus = {
  pending: 'pending',
  started: 'started',
  completed: 'completed'
} as const

/**
 * @nullable
 */
export type UserTaskDtoCompletedAt = { [key: string]: unknown } | null

export interface UserTaskDto {
  id: number
  taskType: UserTaskDtoTaskType
  status: UserTaskDtoStatus
  /** @nullable */
  completedAt: UserTaskDtoCompletedAt
}

/**
 * @nullable
 */
export type BookWithTasksDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type BookWithTasksDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type BookWithTasksDtoSlug = { [key: string]: unknown } | null

export interface BookWithTasksDto {
  id: number
  name: string
  /** @nullable */
  author: BookWithTasksDtoAuthor
  /** @nullable */
  image: BookWithTasksDtoImage
  /** @nullable */
  slug: BookWithTasksDtoSlug
  tasks: UserTaskDto[]
}

/**
 * @nullable
 */
export type GetMyJourneyResponseDtoNextLevel = { [key: string]: unknown } | null

export type GetMyJourneyResponseDtoAssignmentType =
  typeof GetMyJourneyResponseDtoAssignmentType[keyof typeof GetMyJourneyResponseDtoAssignmentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyJourneyResponseDtoAssignmentType = {
  automatically: 'automatically',
  manual: 'manual'
} as const

export interface GetMyJourneyResponseDto {
  userId: number
  journeyId: number
  level: string
  /** @nullable */
  nextLevel: GetMyJourneyResponseDtoNextLevel
  assignmentType: GetMyJourneyResponseDtoAssignmentType
  /** Total de tarefas na jornada */
  totalTasks: number
  /** Tarefas completadas pelo usuário */
  completedTasks: number
  books: BookWithTasksDto[]
  /** Moedas do usuário */
  coins: number
  createdAt: string
  updatedAt: string
}

export interface UpdateStudentJourneyDto {
  /** Journey ID to assign to the student */
  journeyId: number
}

export interface UpdateStudentJourneyResponseDto {
  /** User ID */
  userId: number
  /** Journey ID */
  journeyId: number
  /** Journey level */
  level: string
  /** Timestamp when the journey was updated */
  updatedAt: string
}

export type JourneyItemActivitiesDtoReading =
  typeof JourneyItemActivitiesDtoReading[keyof typeof JourneyItemActivitiesDtoReading]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyItemActivitiesDtoReading = {
  completed: 'completed',
  pending: 'pending',
  locked: 'locked'
} as const

export type JourneyItemActivitiesDtoFluency =
  typeof JourneyItemActivitiesDtoFluency[keyof typeof JourneyItemActivitiesDtoFluency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyItemActivitiesDtoFluency = {
  completed: 'completed',
  pending: 'pending',
  locked: 'locked'
} as const

export type JourneyItemActivitiesDtoQuiz =
  typeof JourneyItemActivitiesDtoQuiz[keyof typeof JourneyItemActivitiesDtoQuiz]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JourneyItemActivitiesDtoQuiz = {
  completed: 'completed',
  pending: 'pending',
  locked: 'locked'
} as const

export interface JourneyItemActivitiesDto {
  reading: JourneyItemActivitiesDtoReading
  fluency: JourneyItemActivitiesDtoFluency
  quiz: JourneyItemActivitiesDtoQuiz
}

/**
 * @nullable
 */
export type JourneyItemBookDtoSlug = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type JourneyItemBookDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type JourneyItemBookDtoImage = { [key: string]: unknown } | null

export interface JourneyItemBookDto {
  id: number
  name: string
  /** @nullable */
  slug: JourneyItemBookDtoSlug
  /** @nullable */
  author: JourneyItemBookDtoAuthor
  /** @nullable */
  image: JourneyItemBookDtoImage
  hasEbook: boolean
  hasAudioBook: boolean
}

export interface JourneyItemDto {
  id: number
  order: number
  completed: boolean
  activities: JourneyItemActivitiesDto
  book: JourneyItemBookDto
}

export interface GetJourneyItemsResponseDto {
  journeyId: number
  title: string
  slug: string
  totalItems: number
  completedItems: number
  items: JourneyItemDto[]
}

export interface StartJourneyResponseDto {
  journeyId: number
  slug: string
  status: string
}

/**
 * @nullable
 */
export type GetJourneyReadingExcerptResponseDtoBookAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type GetJourneyReadingExcerptResponseDtoBookImage = {
  [key: string]: unknown
} | null

export interface GetJourneyReadingExcerptResponseDto {
  journeyItemId: number
  journeyId: number
  journeySlug: string
  bookId: number
  bookSlug: string
  bookName: string
  /** @nullable */
  bookAuthor: GetJourneyReadingExcerptResponseDtoBookAuthor
  /** @nullable */
  bookImage: GetJourneyReadingExcerptResponseDtoBookImage
  excerptStart: string
  excerptEnd: string
  readingCompleted: boolean
}

export interface CompleteJourneyReadingDto {
  journeyItemId: number
}

export interface CompleteJourneyReadingResponseDto {
  success: boolean
  journeyItemId: number
}

/**
 * Activity type
 */
export type CompleteBookTaskDtoActivityType =
  typeof CompleteBookTaskDtoActivityType[keyof typeof CompleteBookTaskDtoActivityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteBookTaskDtoActivityType = {
  listening: 'listening',
  reading: 'reading',
  quiz: 'quiz'
} as const

export interface CompleteBookTaskDto {
  /** Book ID */
  bookId: number
  /** Activity type */
  activityType: CompleteBookTaskDtoActivityType
}

export type BookTaskDtoTaskType =
  typeof BookTaskDtoTaskType[keyof typeof BookTaskDtoTaskType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookTaskDtoTaskType = {
  listening: 'listening',
  reading: 'reading',
  quiz: 'quiz'
} as const

export type BookTaskDtoStatus =
  typeof BookTaskDtoStatus[keyof typeof BookTaskDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookTaskDtoStatus = {
  pending: 'pending',
  started: 'started',
  completed: 'completed'
} as const

export interface BookTaskDto {
  id: number
  taskType: BookTaskDtoTaskType
  bookId: number
  status: BookTaskDtoStatus
}

export interface CompleteBookTaskResponseDto {
  tasks: BookTaskDto[]
}

/**
 * @nullable
 */
export type GetJourneyRunningRecordResponseDtoBookAuthor = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type GetJourneyRunningRecordResponseDtoBookImage = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type GetJourneyRunningRecordResponseDtoTextInHtml = {
  [key: string]: unknown
} | null

export interface GetJourneyRunningRecordResponseDto {
  journeyItemId: number
  snippetId: number
  journeySlug: string
  bookName: string
  /** @nullable */
  bookAuthor: GetJourneyRunningRecordResponseDtoBookAuthor
  /** @nullable */
  bookImage: GetJourneyRunningRecordResponseDtoBookImage
  wordCount: number
  rawText: string
  /** @nullable */
  textInHtml: GetJourneyRunningRecordResponseDtoTextInHtml
}

export interface CompleteJourneyRunningRecordResponseDto {
  success: boolean
  coinsEarned: number
  journeySlug: string
  journeyItemId: number
}

export interface ActivityOptionDto {
  id: number
  optionText: string
  isCorrect: boolean
}

export interface ActivityQuestionDto {
  id: number
  title: string
  order: number
  answered: boolean
  wrongAttempts: number
  attemptedOptionIds: number[]
  options: ActivityOptionDto[]
}

export type GetJourneyActivityResponseDtoJourneySlug = {
  [key: string]: unknown
}

export interface GetJourneyActivityResponseDto {
  journeyItemId: number
  journeySlug: GetJourneyActivityResponseDtoJourneySlug
  totalQuestions: number
  book: ActivityBookDto
  questions: ActivityQuestionDto[]
}

export interface AnswerJourneyQuestionDto {
  questionId: number
  optionId: number
}

export interface AnswerJourneyQuestionResponseDto {
  alreadyAnswered: boolean
  isCorrect: boolean
  wrongAttempts: number
  attemptedOptionIds: number[]
}

export interface CompleteJourneyActivityResponseDto {
  alreadyCompleted: boolean
  coinsAwarded: number
}

export interface CompleteJourneyResponseDto {
  alreadyCompleted: boolean
  completed: boolean
  coinsAwarded: number
  lexilePointsAwarded: number
}

export interface ClaimGradeCompletionResponseDto {
  /** Whether the bonus was awarded in this request */
  awarded: boolean
  /** Whether the bonus had already been claimed */
  alreadyClaimed: boolean
  /** Coins awarded in this request */
  coinsAwarded: number
}

export interface AccuracyDistributionDto {
  basic: number
  intermediate: number
  proficient: number
  advanced: number
  noResults: number
}

export interface ComprehensionDistributionDto {
  heavilySupported: number
  moderatelySupported: number
  lightlySupported: number
  independent: number
  noResults: number
}

export interface ClassSnapshotDto {
  totalStudents: number
  accuracyDistribution: AccuracyDistributionDto
  comprehensionDistribution: ComprehensionDistributionDto
}

export type StudentRowDtoEstimatedLexile = { [key: string]: unknown }

export type StudentRowDtoCurrentJourney = { [key: string]: unknown }

export type StudentRowDtoAccuracyAndSpeed = { [key: string]: unknown }

export type StudentRowDtoComprehension = { [key: string]: unknown }

export interface StudentRowDto {
  id: number
  name: string
  estimatedLexile?: StudentRowDtoEstimatedLexile
  currentJourney?: StudentRowDtoCurrentJourney
  accuracyAndSpeed?: StudentRowDtoAccuracyAndSpeed
  comprehension?: StudentRowDtoComprehension
}

export interface GetClassJourneyReportResponseDto {
  snapshot: ClassSnapshotDto
  students: StudentRowDto[]
  total: number
  page: number
  pageSize: number
}

export type JourneyItemReportDtoLastActivityAt = { [key: string]: unknown }

export type JourneyItemReportDtoStartedAt = { [key: string]: unknown }

export type JourneyItemReportDtoAccuracyAndSpeed = { [key: string]: unknown }

export type JourneyItemReportDtoComprehension = { [key: string]: unknown }

export interface JourneyItemReportDto {
  id: number
  order: number
  book: BookDto
  status: string
  lastActivityAt?: JourneyItemReportDtoLastActivityAt
  startedAt?: JourneyItemReportDtoStartedAt
  listenStatus: string
  accuracyAndSpeed?: JourneyItemReportDtoAccuracyAndSpeed
  comprehension?: JourneyItemReportDtoComprehension
}

export type JourneyReportDtoLexileRange = { [key: string]: unknown }

export type JourneyReportDtoStartedAt = { [key: string]: unknown }

export interface JourneyReportDto {
  id: number
  title: string
  slug: string
  status: string
  lexileRange?: JourneyReportDtoLexileRange
  startedAt?: JourneyReportDtoStartedAt
  totalItems: number
  completedItems: number
  items: JourneyItemReportDto[]
}

export interface GetStudentJourneyReportResponseDto {
  student: StudentInfoDto
  journeys: JourneyReportDto[]
}

export type JourneyDtoGrade = { [key: string]: unknown }

export type JourneyDtoLexileMaxLevel = { [key: string]: unknown }

export interface JourneyDto {
  id: number
  level: string
  title: string
  slug: string
  grade: JourneyDtoGrade
  position: number
  lexileMaxLevel: JourneyDtoLexileMaxLevel
  lexilePoints: number
  itemsCount: number
}

export interface ListJourneysResponseDto {
  journeys: JourneyDto[]
}

export interface JourneyItemSummaryDto {
  id: number
  order: number
  book: JourneyItemBookDto
  hasReading: boolean
  hasRunningRecord: boolean
  questionsCount: number
}

export interface ListJourneyItemsResponseDto {
  journeyId: number
  journeyTitle: string
  items: JourneyItemSummaryDto[]
}

export interface CreateJourneyItemDto {
  bookId: number
  order: number
}

export interface RunningRecordDto {
  id: number
  rawText: string
  textInHtml: string
  wordCount: number
  disabled: boolean
}

export interface GetJourneyItemDetailResponseDto {
  id: number
  order: number
  book: BookDto
  reading?: ReadingDto
  questions: QuestionDto[]
  runningRecord?: RunningRecordDto
}

export interface UpsertReadingDto {
  /** Short excerpt marking the start of the reading passage (must be exact match) */
  excerptStart: string
  /** Short excerpt marking the end of the reading passage (must be exact match) */
  excerptEnd: string
}

export interface QuestionOptionInputDto {
  optionText: string
  isCorrect: boolean
}

export interface CreateQuestionDto {
  /** Question text (supports HTML from Quill editor) */
  title: string
  order: number
  /** Skill tag slug (e.g. literary-analysis, poetry, reading-across-genres) */
  skillTag?: string
  /** Max 4 options, exactly 1 must be correct */
  options: QuestionOptionInputDto[]
}

export interface QuestionOptionUpdateDto {
  id?: number
  optionText: string
  isCorrect: boolean
}

export interface UpdateQuestionDto {
  /** Question text (supports HTML from Quill editor) */
  title: string
  order: number
  /** Skill tag slug (e.g. literary-analysis, poetry, reading-across-genres) */
  skillTag?: string
  /** Max 4 options, exactly 1 must be correct */
  options: QuestionOptionUpdateDto[]
}

export interface UpsertRunningRecordDto {
  /** Plain text content for the running record snippet */
  rawText: string
  /** HTML formatted text (created via editor in frontend) */
  textInHtml: string
  /** Total word count of the snippet */
  wordCount: number
}

export interface RankingEntryDto {
  /** Position in the class ranking */
  classRankingPosition: number
  /** Student name */
  studentName: string
  /** Class/grade information */
  classes: string
  /** Degree/grade level */
  degree: string
  /** Student level/tier */
  elo: string
  /** National ranking position */
  nationalRankingPosition: number
  /** Total points earned */
  points: number
  /** School/unit name */
  schoolName?: string
}

export interface LeagueReportResponseDto {
  /** List of students in the league ranking for current page */
  ranking: RankingEntryDto[]
  /** Pagination metadata */
  meta: PaginationMetaDto
  /** Filter applied - year */
  year: number
  /** Filter applied - month */
  month: number
  /** Filter applied - class/grade */
  degree?: string
}

export interface SuspendReadersBodyDto {
  readerIds: number[]
}

export interface ReconsolidateLeagueBodyDto {
  closeAnalysis?: boolean
}

/**
 * Machine-readable key of the matched fraud criterion
 */
export type FraudCriterionMatchDtoKey =
  typeof FraudCriterionMatchDtoKey[keyof typeof FraudCriterionMatchDtoKey]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FraudCriterionMatchDtoKey = {
  highVolume: 'highVolume',
  robotic: 'robotic',
  fastReading: 'fastReading',
  nightOwl: 'nightOwl',
  manyBooksFast: 'manyBooksFast'
} as const

export interface FraudCriterionMatchDto {
  /** Machine-readable key of the matched fraud criterion */
  key: FraudCriterionMatchDtoKey
  /** Short human-readable label for the criterion */
  label: string
  /** Human-readable detail with the values that triggered the match */
  detail: string
}

export interface FraudSuspectEntryDto {
  /** Reader profile id */
  readerId: number
  /** User id */
  userId: number
  /**
   * Reader name
   * @nullable
   */
  name: string | null
  /**
   * School/entity name
   * @nullable
   */
  entityName: string | null
  /**
   * League tier
   * @nullable
   */
  tier: string | null
  /** Number of reading sessions in the month */
  sessions: number
  /** Total hours read in the month */
  hours: string
  /** Standard deviation of session duration, in seconds */
  stdSessionSec: number
  /** Average session duration, in seconds */
  avgSessionSec: number
  /** Percentage of sessions shorter than 5 seconds */
  pctFastSessions: number
  /** Percentage of sessions between 0h-5h59 (America/Sao_Paulo) */
  pctNightSessions: number
  /** Distinct books read in the month */
  booksCount: number
  /** Fraud criteria matched by this reader, in evaluation order */
  matchedCriteria: FraudCriterionMatchDto[]
}

export interface ListFraudSuspectsResponseDto {
  data: FraudSuspectEntryDto[]
  /** Total number of fraud suspects matching the filters */
  total: number
  /** Current page number */
  page: number
  /** Items per page */
  perPage: number
}

export interface LogicalOperatorDto {
  operator: string
  enabled: boolean
}

export interface TextOperatorDto {
  operator: string
  enabled: boolean
}

export interface FieldDto {
  key: string
  label: string
  enabled: boolean
  sort_order: number
}

export interface FacetDto {
  key: string
  label: string
  enabled: boolean
  sort_order: number
}

export interface DisabledFacetValueDto {
  facet_key: string
  value: string
}

export interface UpsertSearchConfigDto {
  advanced_search_enabled: boolean
  max_criteria: number
  logical_operators: LogicalOperatorDto[]
  text_operators: TextOperatorDto[]
  fields: FieldDto[]
  facets: FacetDto[]
  disabled_facet_values?: DisabledFacetValueDto[]
}

export interface OpenSessionResponseDto {
  /** Session ID */
  sessionId: string
}

export interface HeartbeatSessionDto {
  /** Session ID */
  sessionId: string
  /** Time delta in seconds */
  dt_seconds: number
  /** Whether the session is active */
  active: boolean
}

export interface ConfirmCreateSharedPageDto {
  /** Upload id returned by the upload-url endpoint */
  uploadId: string
  /** Title of the shared page */
  title: string
  /** Short description of the page */
  description?: string
  /** Original file name of the uploaded HTML */
  fileName: string
}

export interface ConfirmUpdateSharedPageDto {
  /** New title of the shared page */
  title?: string
  /** New description of the page */
  description?: string
  /** New file name when a new HTML was uploaded */
  fileName?: string
  /** Whether a new HTML file was uploaded to S3 */
  fileUploaded?: boolean
}

/**
 * Type of identifier
 */
export type CreateAccessGrantDtoIdentifierType =
  typeof CreateAccessGrantDtoIdentifierType[keyof typeof CreateAccessGrantDtoIdentifierType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAccessGrantDtoIdentifierType = {
  email: 'email',
  access_token: 'access_token'
} as const

export interface CreateAccessGrantDto {
  /** Email or access_token of the user to grant access */
  identifier: string
  /** Type of identifier */
  identifierType: CreateAccessGrantDtoIdentifierType
  /** Expiration date in ISO 8601 format */
  expiresAt: string
}

export interface PublicAccessSendCodeDto {
  /** Email autorizado para a página */
  email: string
}

export interface PublicAccessVerifyDto {
  /** Email autorizado para a página */
  email: string
  /** Código de 6 dígitos enviado por email */
  code: string
}

/**
 * @nullable
 */
export type StoryTreeLibraryDtoSlug = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeLibraryDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeLibraryDtoImage = { [key: string]: unknown } | null

export interface StoryTreeLibraryDto {
  bookId: number
  /** @nullable */
  slug: StoryTreeLibraryDtoSlug
  title: string
  /** @nullable */
  author: StoryTreeLibraryDtoAuthor
  /** @nullable */
  image: StoryTreeLibraryDtoImage
  progress: number
  hasAudiobook: boolean
}

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoId = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoTeacherName = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoBookTitle = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoDueDate = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoContentType = {
  [key: string]: unknown
} | null

/**
 * @nullable
 */
export type StoryTreeAssignmentDtoBookSlug = { [key: string]: unknown } | null

export interface StoryTreeAssignmentDto {
  /** @nullable */
  id: StoryTreeAssignmentDtoId
  /** @nullable */
  teacherName: StoryTreeAssignmentDtoTeacherName
  /** @nullable */
  bookTitle: StoryTreeAssignmentDtoBookTitle
  /** @nullable */
  dueDate: StoryTreeAssignmentDtoDueDate
  /** @nullable */
  contentType: StoryTreeAssignmentDtoContentType
  /** @nullable */
  bookSlug: StoryTreeAssignmentDtoBookSlug
  isRead: boolean
}

/**
 * @nullable
 */
export type StoryTreeTreeDtoImage = { [key: string]: unknown } | null

export interface StoryTreeTreeDto {
  id: number
  position: number
  age: number
  /** @nullable */
  image: StoryTreeTreeDtoImage
}

export interface StoryTreeForestDto {
  trees: StoryTreeTreeDto[]
}

/**
 * @nullable
 */
export type StoryTreeHomeResponseDtoLibrary = StoryTreeLibraryDto | null

/**
 * @nullable
 */
export type StoryTreeHomeResponseDtoAssignment = StoryTreeAssignmentDto | null

/**
 * @nullable
 */
export type StoryTreeHomeResponseDtoForest = StoryTreeForestDto | null

export interface StoryTreeHomeResponseDto {
  /** @nullable */
  library: StoryTreeHomeResponseDtoLibrary
  /** @nullable */
  assignment: StoryTreeHomeResponseDtoAssignment
  /** @nullable */
  forest: StoryTreeHomeResponseDtoForest
  coins: number
  drops: number
}

/**
 * @nullable
 */
export type StoryTreeViewedBookDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeViewedBookDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeViewedBookDtoLexileLevel = {
  [key: string]: unknown
} | null

export interface StoryTreeViewedBookDto {
  bookId: number
  title: string
  /** @nullable */
  author: StoryTreeViewedBookDtoAuthor
  /** @nullable */
  image: StoryTreeViewedBookDtoImage
  slug: string
  progress: number
  hasAudiobook: boolean
  /** @nullable */
  lexileLevel: StoryTreeViewedBookDtoLexileLevel
}

export interface StoryTreeViewedBooksResponseDto {
  books: StoryTreeViewedBookDto[]
}

/**
 * @nullable
 */
export type StoryTreeRecommendationDtoAuthor = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeRecommendationDtoImage = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type StoryTreeRecommendationDtoLexileLevel = {
  [key: string]: unknown
} | null

export interface StoryTreeRecommendationDto {
  bookId: number
  title: string
  /** @nullable */
  author: StoryTreeRecommendationDtoAuthor
  /** @nullable */
  image: StoryTreeRecommendationDtoImage
  slug: string
  /** @nullable */
  lexileLevel: StoryTreeRecommendationDtoLexileLevel
  hasAudiobook: boolean
}

export interface StoryTreeRecommendationsResponseDto {
  books: StoryTreeRecommendationDto[]
}

/**
 * Task type
 */
export type TaskInfoDtoType =
  typeof TaskInfoDtoType[keyof typeof TaskInfoDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskInfoDtoType = {
  quiz: 'quiz'
} as const

export interface TaskInfoDto {
  /** Task ID */
  id: number
  /** Task title (book name) */
  title: string
  /** Task type */
  type: TaskInfoDtoType
}

/**
 * Alternative letter
 */
export type TaskAlternativeDtoLetter =
  typeof TaskAlternativeDtoLetter[keyof typeof TaskAlternativeDtoLetter]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskAlternativeDtoLetter = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D'
} as const

export interface TaskAlternativeDto {
  /** Alternative letter */
  letter: TaskAlternativeDtoLetter
  /** Alternative text */
  text: string
}

/**
 * Student selected answer
 * @nullable
 */
export type TaskQuestionDtoStudentAnswer =
  | typeof TaskQuestionDtoStudentAnswer[keyof typeof TaskQuestionDtoStudentAnswer]
  | null

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskQuestionDtoStudentAnswer = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D'
} as const

/**
 * Correct answer
 */
export type TaskQuestionDtoCorrectAnswer =
  typeof TaskQuestionDtoCorrectAnswer[keyof typeof TaskQuestionDtoCorrectAnswer]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskQuestionDtoCorrectAnswer = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D'
} as const

export interface TaskQuestionDto {
  /** Question ID */
  id: number
  /** Question position in the quiz */
  position: number
  /** Question text */
  text: string
  /** List of alternatives */
  alternatives: TaskAlternativeDto[]
  /**
   * Student selected answer
   * @nullable
   */
  studentAnswer: TaskQuestionDtoStudentAnswer
  /** Correct answer */
  correctAnswer: TaskQuestionDtoCorrectAnswer
  /** Whether student answer is correct */
  isCorrect: boolean
}

export interface TaskDetailsByStudentResponseDto {
  student: StudentInfoDto
  task: TaskInfoDto
  /** List of questions */
  questions: TaskQuestionDto[]
}

export interface AnswerQuizBodyDto {
  /** Question ID */
  questionId: number
  /** Selected option ID */
  optionId: number
  /** Whether this is the last question of the quiz */
  isLastQuestion: boolean
}

export interface CorrectAlternativeDto {
  /** Correct option ID */
  id: number
  /** Correct option letter */
  letter: string
  /** Correct option text */
  text: string
}

/**
 * Explanation for the selected answer
 * @nullable
 */
export type AnswerQuizResponseDtoExplanation = { [key: string]: unknown } | null

export interface AnswerQuizResponseDto {
  /** Whether the answer was correct */
  isCorrect: boolean
  /** The correct alternative */
  correctAlternative: CorrectAlternativeDto
  /**
   * Explanation for the selected answer
   * @nullable
   */
  explanation: AnswerQuizResponseDtoExplanation
}

export interface AssociateTeacherEntitiesBodyDto {
  /** ID do usuário, token de acesso ou e-mail */
  userIdentifier: string
  /** Lista de IDs, legacy IDs ou nomes exatos das unidades (escola) */
  unitIdentifiers: string[]
}

export interface TeacherLookupDto {
  userId: number
  /** @nullable */
  userName: string | null
  /** @nullable */
  userEmail: string | null
  /** @nullable */
  userAccessToken: string | null
  teacherId: number
  rootId: number
}

export interface TeacherEntityItemDto {
  id: number
  /** @nullable */
  name: string | null
  /** @nullable */
  legacyId: string | null
}

export interface AmbiguousIdentifierDto {
  identifier: string
  candidateIds: number[]
}

export interface AssociateTeacherEntitiesResponseDto {
  teacher: TeacherLookupDto
  currentEntities: TeacherEntityItemDto[]
  addedEntities: TeacherEntityItemDto[]
  notFoundIdentifiers: string[]
  ambiguousIdentifiers: AmbiguousIdentifierDto[]
  invalidRootIdentifiers: string[]
  message: string
}

export interface AssociateTeacherEntitiesBatchItemDto {
  /** ID do usuário, token de acesso ou e-mail */
  userIdentifier: string
  /** Lista de IDs, legacy IDs ou nomes exatos das unidades (escola) */
  unitIdentifiers: string[]
}

export interface AssociateTeacherEntitiesBatchBodyDto {
  items: AssociateTeacherEntitiesBatchItemDto[]
}

/**
 * @nullable
 */
export type AssociateTeacherEntitiesBatchRowResultDtoResult =
  AssociateTeacherEntitiesResponseDto | null

export interface AssociateTeacherEntitiesBatchRowResultDto {
  index: number
  userIdentifier: string
  success: boolean
  /** @nullable */
  result: AssociateTeacherEntitiesBatchRowResultDtoResult
  /** @nullable */
  error: string | null
}

export interface TeacherEntitiesBatchResponseDto {
  total: number
  succeeded: number
  failed: number
  results: AssociateTeacherEntitiesBatchRowResultDto[]
  message: string
}

export interface DissociateTeacherEntitiesBodyDto {
  /** ID do perfil de professor (teacher_id) */
  teacherId: number
  /** Lista de IDs das unidades a desvincular */
  entityIds: number[]
}

export interface DissociateTeacherEntitiesResponseDto {
  teacher: TeacherLookupDto
  removedEntities: TeacherEntityItemDto[]
  currentEntities: TeacherEntityItemDto[]
  message: string
}

export type SearchUserResponseDtoName = { [key: string]: unknown }

export interface SearchUserResponseDto {
  id: number
  name: SearchUserResponseDtoName
  email: string
  isAdmin: boolean
}

export interface ToggleAdminBodyDto {
  /** ID do usuário */
  userId: number
  /** Novo status de admin */
  isAdmin: boolean
}

export type ToggleAdminResponseDtoName = { [key: string]: unknown }

export interface ToggleAdminResponseDto {
  id: number
  name: ToggleAdminResponseDtoName
  email: string
  isAdmin: boolean
  message: string
}

export type ViewedBookDtoDegree = { [key: string]: unknown }

export type ViewedBookDtoLanguage = { [key: string]: unknown }

export interface ViewedBookDto {
  id: number
  name: string
  slug: string
  author: string
  degree?: ViewedBookDtoDegree
  language?: ViewedBookDtoLanguage
  imageUrlThumb: string
  imageUrlThumbLow: string
  hasEbook: boolean
  hasAudioBook: boolean
  percentage: number
  lastReadAt: string
}

export interface ViewedBooksResponseDto {
  data: ViewedBookDto[]
  total: number
  page: number
  pageSize: number
  hasNextPage: boolean
}

export interface ChangeTeacherEntityDto {
  /** Target entity ID to switch to */
  entityId: number
}

export interface ChangeTeacherEntityResponseDto {
  /** Updated entity ID */
  entityId: number
  /** Resolved root entity ID */
  rootId: number
}

export interface AssignClassToTeacherDto {
  /** Array of class entity IDs to assign to the teacher */
  classIds: number[]
}

export interface AssignClassToTeacherResponseDto {
  /** Teacher ID */
  teacherId: number
  /** Array of class entity IDs assigned to the teacher */
  classIds: number[]
  /** Operation result message */
  message: string
}

export interface TeacherClassDto {
  /** Assignment ID */
  id: number
  /** Class entity ID */
  classId: number
  /** Class name */
  className: string
  /** Class code */
  classCode: string
}

export interface GetTeacherClassesResponseDto {
  /** List of teacher classes */
  classes: TeacherClassDto[]
  /** Total number of classes */
  total: number
}

/**
 * Book status for this teacher
 */
export type TeacherBookDtoStatus =
  typeof TeacherBookDtoStatus[keyof typeof TeacherBookDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherBookDtoStatus = {
  enabled: 'enabled',
  disabled: 'disabled'
} as const

export interface TeacherBookDto {
  /**
   * Book name
   * @nullable
   */
  name: string | null
  /**
   * Book slug
   * @nullable
   */
  slug: string | null
  /**
   * Book author
   * @nullable
   */
  author: string | null
  /**
   * Book image URL thumbnail
   * @nullable
   */
  imageUrlThumb: string | null
  /**
   * Book degree
   * @nullable
   */
  degree: string | null
  /** Book status for this teacher */
  status: TeacherBookDtoStatus
}

export interface GetBooksResponseDto {
  /** List of books */
  data: TeacherBookDto[]
  /** Pagination information */
  pagination: PaginationDto
}

export interface ToggleBookStatusDto {
  /** Book slug */
  slug: string
  /** Enable or disable the book */
  enabled: boolean
}

export interface ReaderClassDto {
  /** Class entity ID */
  entityId: number
  /** Class name */
  entityName: string
}

export interface GetReaderClassesResponseDto {
  /** List of classes the reader is associated with */
  classes: ReaderClassDto[]
  /** Total number of classes */
  total: number
}

export interface ChangeReaderEntityDto {
  /** Target class entity ID to switch to */
  entityId: number
}

export interface ChangeReaderEntityResponseDto {
  /** Updated entity ID */
  entityId: number
  /** Resolved root entity ID */
  rootId: number
}

export interface TransformTeacherToReaderBodyDto {
  /** E-mail do usuário educador que será transformado em leitor */
  email: string
  /** ID da turma (entity) para restringir a transformação a um único vínculo. Quando omitido, todos os perfis de educador do usuário são removidos. */
  entityId?: number
}

/**
 * @nullable
 */
export type TransformTeacherToReaderResponseDtoUserName = {
  [key: string]: unknown
} | null

export interface TransformTeacherToReaderResponseDto {
  userId: number
  /** @nullable */
  userName: TransformTeacherToReaderResponseDtoUserName
  userEmail: string
  removedTeacherProfiles: number
  message: string
}

/**
 * Override the TTS provider. Defaults to the feature-flag resolution.
 */
export type GenerateTtsRequestDtoProvider =
  typeof GenerateTtsRequestDtoProvider[keyof typeof GenerateTtsRequestDtoProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTtsRequestDtoProvider = {
  kokoro: 'kokoro',
  elevenlabs: 'elevenlabs'
} as const

export interface GenerateTtsRequestDto {
  /**
   * Text to convert to speech
   * @maxLength 5000
   */
  text: string
  /** ElevenLabs voice ID */
  voiceId?: string
  /** Model ID (eleven_multilingual_v2, eleven_flash_v2_5) */
  modelId?: string
  /** Book slug being read */
  slug?: string
  /** Override the TTS provider. Defaults to the feature-flag resolution. */
  provider?: GenerateTtsRequestDtoProvider
}

export interface GenerateTtsResponseDto {
  /** Signed URL for the audio file in S3 */
  audioUrl: string
  /** Whether the audio was retrieved from cache */
  cached: boolean
  /** SHA256 hash of the input text */
  textHash: string
}

export interface CharacterAlignmentDto {
  /** Array of characters */
  characters: string[]
  /** Start time in seconds for each character */
  characterStartTimesSeconds: string[]
  /** End time in seconds for each character */
  characterEndTimesSeconds: string[]
}

export interface GenerateTtsWithTimestampsResponseDto {
  /** Signed URL for the audio file in S3 */
  audioUrl: string
  /** Whether the audio was retrieved from cache */
  cached: boolean
  /** SHA256 hash of the input text */
  textHash: string
  /** Character-level timing data for the original text */
  alignment?: CharacterAlignmentDto
  /** Character-level timing data for the normalized text */
  normalizedAlignment?: CharacterAlignmentDto
}

export interface TranscribeSttRequestDto {
  /** Book ISBN to fetch audio from S3 */
  isbn: string
  /** ElevenLabs STT model ID (scribe_v1, scribe_v1_experimental) */
  modelId?: string
  /** ISO-639-1 or ISO-639-3 language code */
  languageCode?: string
}

export interface SpeakerDto {
  /** Speaker ID */
  id: string
  /** Speaker name */
  name: string
}

export interface TranscribedWordDto {
  /** Transcribed word */
  text: string
  /** Start time in seconds */
  start_time: number
  /** End time in seconds */
  end_time: number
}

export interface SegmentDto {
  /** Segment text */
  text: string
  /** Start time in seconds */
  start_time: number
  /** End time in seconds */
  end_time: number
  /** Speaker info */
  speaker: SpeakerDto
  /** Words with timestamps */
  words: TranscribedWordDto[]
}

export interface TranscribeSttResponseDto {
  /** Detected language code */
  language_code: string
  /** Transcription segments */
  segments: SegmentDto[]
}

export interface CreateScribeRealtimeTokenResponseDto {
  /** Single-use ElevenLabs token to authenticate the realtime Scribe WebSocket */
  token: string
}

export type IngestMessageDtoRole =
  typeof IngestMessageDtoRole[keyof typeof IngestMessageDtoRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IngestMessageDtoRole = {
  user: 'user',
  assistant: 'assistant'
} as const

export interface IngestMessageDto {
  role: IngestMessageDtoRole
  text: string
  turn_index: number
}

export interface IngestDto {
  session_id: string
  messages: IngestMessageDto[]
  final?: boolean
}

export interface SearchDto {
  query: string
  repo?: string
  lang?: string
  limit?: number
}

export interface FeedbackDto {
  id: string
  useful: boolean
}

export type CuratedDtoCategory =
  typeof CuratedDtoCategory[keyof typeof CuratedDtoCategory]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CuratedDtoCategory = {
  decisions: 'decisions',
  conventions: 'conventions',
  incidents: 'incidents',
  domain: 'domain',
  gotchas: 'gotchas'
} as const

export interface CuratedDto {
  title: string
  category: CuratedDtoCategory
  content: string
  tags?: string[]
  created_at?: number
}

export type PromoteDtoCategory =
  typeof PromoteDtoCategory[keyof typeof PromoteDtoCategory]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoteDtoCategory = {
  decisions: 'decisions',
  conventions: 'conventions',
  incidents: 'incidents',
  domain: 'domain',
  gotchas: 'gotchas'
} as const

export interface PromoteDto {
  raw_ids: string[]
  title?: string
  category?: PromoteDtoCategory
  tags?: string[]
}

export interface FileHashDto {
  path: string
  hash: string
}

export interface RepoSyncDto {
  name: string
  rootHash: string
  files?: FileHashDto[]
}

export interface SyncDto {
  repos: RepoSyncDto[]
}

export interface ChunkDto {
  repo: string
  path: string
  symbol: string
  lang: string
  gitSha?: string
  lineStart?: number
  lineEnd?: number
  content: string
  fileHash?: string
}

export interface RemoveDto {
  repo: string
  path: string
}

export interface IndexDto {
  chunks: ChunkDto[]
  remove?: RemoveDto[]
}

export type WidgetInitDtoMetadata = { [key: string]: unknown }

export interface WidgetInitDto {
  token: string
  externalUserId?: string
  metadata?: WidgetInitDtoMetadata
}

export interface PageDto {
  sequence: number
  content: string
}

export interface PreviousPageDto {
  sequence: number
  content: string
}

export interface ChapterContextDto {
  name: string
  sequence: number
  description?: string
  promptDescription?: string
}

export interface ActivityContextDto {
  title: string
  description: string
}

export type AiReviewDtoBookLanguage =
  typeof AiReviewDtoBookLanguage[keyof typeof AiReviewDtoBookLanguage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiReviewDtoBookLanguage = {
  pt_BR: 'pt_BR',
  en_US: 'en_US',
  en_GB: 'en_GB',
  es_ES: 'es_ES'
} as const

export interface AiReviewDto {
  bookTitle: string
  bookLanguage: AiReviewDtoBookLanguage
  currentPage: PageDto
  previousPages?: PreviousPageDto[]
  studentName?: string
  templateName?: string
  currentChapter?: ChapterContextDto
  activity?: ActivityContextDto
}

export type AiHintDtoBookLanguage =
  typeof AiHintDtoBookLanguage[keyof typeof AiHintDtoBookLanguage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiHintDtoBookLanguage = {
  pt_BR: 'pt_BR',
  en_US: 'en_US',
  en_GB: 'en_GB',
  es_ES: 'es_ES'
} as const

export interface AiHintDto {
  bookTitle: string
  bookLanguage: AiHintDtoBookLanguage
  previousPages?: PreviousPageDto[]
  studentName?: string
  templateName?: string
  currentChapter?: ChapterContextDto
  activity?: ActivityContextDto
}

export type AiActionDtoBookLanguage =
  typeof AiActionDtoBookLanguage[keyof typeof AiActionDtoBookLanguage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiActionDtoBookLanguage = {
  pt_BR: 'pt_BR',
  en_US: 'en_US',
  en_GB: 'en_GB',
  es_ES: 'es_ES'
} as const

export interface AiActionDto {
  actionId: string
  bookTitle: string
  bookLanguage: AiActionDtoBookLanguage
  currentPage: PageDto
  currentAiOutput?: string
  templateName?: string
  currentChapter?: ChapterContextDto
  previousPages?: PreviousPageDto[]
  studentName?: string
  activity?: ActivityContextDto
}

export interface MostReadBookDto {
  /** Book ID */
  bookId: number
  /** Book name */
  bookName: string
  /** Book author */
  authorName: string
  /** Total time spent reading this book in seconds */
  timeSpentSeconds: number
  /** Thumbnail URL for the most read book */
  thumbUrl: string
  /** Book slug */
  slug: string
  /** Main text for the most read book */
  mainText: string
  /** Comment variation based on reading time */
  commentVariation: string
}

export interface MostReadGenreDto {
  /** Custom category name */
  customCategoryName: string
  /** Emoji related to the genre */
  genreEmoji: string
  /** Description text based on the genre */
  genreDescription: string
}

export interface TreesDto {
  /** Number of trees planted in 2025 */
  count: number
}

export interface ReaderProfileDto {
  /** Reader profile type */
  type: string
  /** Reader profile description text */
  description: string
  /**
   * Top reader percentage
   * @nullable
   */
  topReaderPercentage: number | null
}

export interface OpenedBooksDto {
  /** Total number of distinct books opened */
  count: number
}

export interface RecommendedBookDto {
  /** Book name */
  bookName: string
  /** Book author */
  authorName: string
  /** Book slug */
  bookSlug: string
  /** Thumbnail URL for the recommended book */
  thumbUrl: string
}

/**
 * Most read book information
 * @nullable
 */
export type RewindResponseDtoMostReadBook = MostReadBookDto | null

/**
 * Most read genre/custom category information
 * @nullable
 */
export type RewindResponseDtoMostReadGenre = MostReadGenreDto | null

export interface RewindResponseDto {
  /** Total time spent reading in seconds */
  totalTimeSpentSeconds: number
  /**
   * Most read book information
   * @nullable
   */
  mostReadBook: RewindResponseDtoMostReadBook
  /**
   * Most read genre/custom category information
   * @nullable
   */
  mostReadGenre: RewindResponseDtoMostReadGenre
  /** Trees planted information */
  trees: TreesDto
  /** Reader profile information */
  readerProfile: ReaderProfileDto
  /** Opened books information */
  openedBooks: OpenedBooksDto
  /** Recommended books information */
  recommendedBooks: RecommendedBookDto[]
}

export interface CreateBookReviewDto {
  /** Book ID to review */
  bookId: number
  /**
   * Star rating (0-5)
   * @minimum 0
   * @maximum 5
   */
  stars: number
  /** Optional review comment */
  comment?: string
}

/**
 * Review comment
 * @nullable
 */
export type BookReviewResponseDtoComment = { [key: string]: unknown } | null

export interface BookReviewResponseDto {
  /** Review ID */
  id: number
  /** Reader ID */
  readerId: number
  /** Book ID */
  bookId: number
  /** Star rating (0-5) */
  stars: number
  /**
   * Review comment
   * @nullable
   */
  comment: BookReviewResponseDtoComment
  /** Created at timestamp */
  createdAt: string
  /** Updated at timestamp */
  updatedAt: string
}

/**
 * Publication type
 */
export type PublicationDtoType =
  typeof PublicationDtoType[keyof typeof PublicationDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicationDtoType = {
  Newspaper: 'Newspaper',
  Magazine: 'Magazine'
} as const

export interface PublicationDto {
  /** Publication unique identifier */
  cid: string
  /** Publication name */
  name: string
  /** Display name of the publication */
  displayName: string
  /** Publication type */
  type: PublicationDtoType
  /** Publication cover image URL */
  image: string
  /** Redirect URL for accessing the publication */
  redirectUrl: string
  /** Latest issue date */
  issueDate: string
}

export interface ListPublicationsResponseDto {
  /** List of publications */
  items: PublicationDto[]
  /** Total number of publications */
  totalItems: number
}

export interface FilterDto {
  /** Filter unique identifier */
  id: number
  /** Filter name */
  name: string
  /** Display name of the filter */
  displayName: string
  /** URL-friendly slug */
  slug: string
  /** Child filters */
  children?: FilterDto[]
}

export interface ListFiltersResponseDto {
  /** List of navigation filters */
  items: FilterDto[]
  /** Total number of filters */
  totalItems: number
}

export interface PublicationShelfDto {
  /** Publication unique identifier */
  cid: string
  /** Publication name */
  name: string
  /** Publication cover image URL */
  image: string
  /** Formatted date in Portuguese */
  date: string
  /** Redirect URL for accessing the publication */
  redirectUrl: string
}

export interface ListPublicationsShelfResponseDto {
  /** List of publications for shelf display */
  items: PublicationShelfDto[]
}

export interface RunSchoolsSyncBodyDto {
  /** List of school legacy IDs to sync */
  schoolLegacyIds: string[]
}

export interface RunLexSyncBodyDto {
  /** List of LEX tenant IDs to sync */
  tenantIds: string[]
}

export interface GetDefinitionBodyDto {
  /** Word to look up */
  word: string
  /** Idioma do livro */
  language?: string
  /** Idioma alvo da tradução (locale do usuário) */
  targetLanguage?: string
}

/**
 * @nullable
 */
export type WordDefinitionDtoExample = { [key: string]: unknown } | null

export interface WordDefinitionDto {
  definition: string
  /** @nullable */
  example: WordDefinitionDtoExample
  lexical_category: string
}

export interface GetDefinitionResponseDto {
  data: WordDefinitionDto[]
  dictionary_name: string
}

export type AssetRequestResponseDtoStatus =
  typeof AssetRequestResponseDtoStatus[keyof typeof AssetRequestResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetRequestResponseDtoStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected'
} as const

export interface AssetRequestResponseDto {
  id: string
  userId: number
  userEmail: string
  userName: string
  role: string
  area: string
  photoS3Key: string
  signatureS3Key: string
  status: AssetRequestResponseDtoStatus
  reviewedBy?: number
  rejectionReason?: string
  createdAt: string
  updatedAt: string
}

export interface PaginatedAssetRequestsResponseDto {
  data: AssetRequestResponseDto[]
  total: number
  page: number
  limit: number
}

export interface RejectAssetRequestDto {
  reason?: string
}

export interface AssetDownloadUrlsResponseDto {
  photoUrl: string
  signatureUrl: string
}

export type UpdatePriceEntryDtoType =
  typeof UpdatePriceEntryDtoType[keyof typeof UpdatePriceEntryDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePriceEntryDtoType = {
  book: 'book',
  audiobook: 'audiobook'
} as const

export interface UpdatePriceEntryDto {
  isbn: string
  price: number
  type: UpdatePriceEntryDtoType
}

export interface UpdatePriceBatchDto {
  entries: UpdatePriceEntryDto[]
}

export type GenerateTextDtoUrgency =
  typeof GenerateTextDtoUrgency[keyof typeof GenerateTextDtoUrgency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTextDtoUrgency = {
  green: 'green',
  yellow: 'yellow',
  red: 'red'
} as const

export type GenerateTextDtoType =
  typeof GenerateTextDtoType[keyof typeof GenerateTextDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTextDtoType = {
  feature: 'feature',
  improvement: 'improvement',
  fix: 'fix',
  experiment: 'experiment',
  infra: 'infra'
} as const

export interface GenerateTextDto {
  title: string
  description: string
  urgency: GenerateTextDtoUrgency
  type: GenerateTextDtoType
  platform?: string
  impactedUser?: string
  prUrl?: string
  imageUrls?: string[]
}

export type CreateAnnouncementDtoUrgency =
  typeof CreateAnnouncementDtoUrgency[keyof typeof CreateAnnouncementDtoUrgency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAnnouncementDtoUrgency = {
  green: 'green',
  yellow: 'yellow',
  red: 'red'
} as const

export type CreateAnnouncementDtoType =
  typeof CreateAnnouncementDtoType[keyof typeof CreateAnnouncementDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAnnouncementDtoType = {
  feature: 'feature',
  improvement: 'improvement',
  fix: 'fix',
  experiment: 'experiment',
  infra: 'infra'
} as const

export interface CreateAnnouncementDto {
  title: string
  description: string
  generatedText?: string
  editedText?: string
  urgency: CreateAnnouncementDtoUrgency
  type: CreateAnnouncementDtoType
  mediaUrls?: string[]
  mentions?: string[]
  platform?: string
  impactedUser?: string
  prUrl?: string
}

export type UpdateAnnouncementDtoUrgency =
  typeof UpdateAnnouncementDtoUrgency[keyof typeof UpdateAnnouncementDtoUrgency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAnnouncementDtoUrgency = {
  green: 'green',
  yellow: 'yellow',
  red: 'red'
} as const

export type UpdateAnnouncementDtoType =
  typeof UpdateAnnouncementDtoType[keyof typeof UpdateAnnouncementDtoType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAnnouncementDtoType = {
  feature: 'feature',
  improvement: 'improvement',
  fix: 'fix',
  experiment: 'experiment',
  infra: 'infra'
} as const

export interface UpdateAnnouncementDto {
  title?: string
  description?: string
  editedText?: string
  urgency?: UpdateAnnouncementDtoUrgency
  type?: UpdateAnnouncementDtoType
  mediaUrls?: string[]
  mentions?: string[]
  platform?: string
  impactedUser?: string
  prUrl?: string
}

export interface LtiLoginQueryDto {
  /** Issuer URL of the LMS Platform */
  iss: string
  /** OIDC login_hint provided by the LMS */
  login_hint: string
  /** Target link URI from the LMS launch link */
  target_link_uri: string
  /** Optional message hint passed by the LMS */
  lti_message_hint?: string
  /** OIDC client_id (required when multiple deployments share an issuer) */
  client_id?: string
  /** Optional deployment ID */
  lti_deployment_id?: string
}

export interface LtiLaunchBodyDto {
  /** JWT id_token issued by the LMS Platform */
  id_token: string
  /** State value originally produced by the OIDC login initiation */
  state: string
}

export interface LtiPlatformResponseDto {
  id: number
  name: string
  issuer: string
  clientId: string
  deploymentId: string
  authLoginUrl: string
  /** @nullable */
  authTokenUrl?: string | null
  jwksUrl: string
  /** @nullable */
  b2bSubscriptionAccountId?: number | null
  /** @nullable */
  schoolEntityId?: number | null
  desativated: boolean
}

export interface CreateLtiPlatformDto {
  /** Display name (used as the school entity name on first launch) */
  name: string
  /** OIDC issuer of the LMS (no trailing slash) */
  issuer: string
  /** Client ID issued by the LMS */
  clientId: string
  /** Deployment ID issued by the LMS for this tool */
  deploymentId: string
  /** OIDC auth URL of the LMS */
  authLoginUrl: string
  /** OAuth2 token URL (required for NRPS) */
  authTokenUrl?: string
  /** JWKS URL of the LMS */
  jwksUrl: string
  /** B2B account ID linking the platform to a contract */
  b2bSubscriptionAccountId?: number
  /** Optional pre-mapped school entity ID. If provided, the auto-creation on first launch is skipped */
  schoolEntityId?: number
}

export interface UpdateLtiPlatformDto {
  name?: string
  authLoginUrl?: string
  authTokenUrl?: string
  jwksUrl?: string
  b2bSubscriptionAccountId?: number
  schoolEntityId?: number
  desativated?: boolean
}

export interface ImportLtiPlatformsDto {
  /** CSV content. Header row required: name,issuer,client_id,deployment_id,auth_login_url,auth_token_url,jwks_url,b2b_subscription_account_id,school_entity_id */
  csv: string
}

export interface ImportLtiPlatformsSkippedRow {
  line: number
  reason: string
}

export interface ImportLtiPlatformsResultDto {
  inserted: number
  skipped: ImportLtiPlatformsSkippedRow[]
}

export interface VerifyCodeDto {
  [key: string]: unknown
}

export interface SetupDeviceDto {
  [key: string]: unknown
}

export interface ConfirmDeviceDto {
  [key: string]: unknown
}

export interface MoveProfileBodyDto {
  /** ID do usuário */
  user_id: number
  /** ID da entidade destino */
  target_entity_id: number
}

/**
 * Tipo de perfil
 */
export type ReactivateProfileBodyDtoProfileType =
  typeof ReactivateProfileBodyDtoProfileType[keyof typeof ReactivateProfileBodyDtoProfileType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReactivateProfileBodyDtoProfileType = {
  reader: 'reader',
  educator: 'educator'
} as const

export interface ReactivateProfileBodyDto {
  /** ID do usuário */
  user_id: number
  /** ID da entidade */
  entity_id: number
  /** Tipo de perfil */
  profile_type: ReactivateProfileBodyDtoProfileType
}

export interface FixEmailBodyDto {
  /** ID do usuário */
  user_id: number
  /** Novo email */
  new_email: string
}

export interface PasswordResetBodyDto {
  /** ID do usuário */
  user_id?: number
  /** Email do usuário */
  email?: string
}

export interface TriggerIdentitySyncBodyDto {
  /** ID do usuário */
  user_id: number
}

export type ElasticsearchAdminControllerReindexEntitiesV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexUsersV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexVideosV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexPodcastShowsV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexArvoreUsersV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexArvoreActivitiesV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexArvoreActivitiesSyncV1Params = {
  limit: number
}

export type ElasticsearchAdminControllerReindexArvoreUsersSyncV1Params = {
  limit: number
}

export type Oauth2ControllerAuthorizeParams = {
  /**
   * Response type
   */
  response_type: string
  /**
   * Client ID
   */
  client_id: string
  /**
   * Redirect URI
   */
  redirect_uri: string
  /**
   * Requested scopes
   */
  scope?: string
  /**
   * State parameter for CSRF protection
   */
  state?: string
  /**
   * PKCE code challenge
   */
  code_challenge?: string
  /**
   * PKCE code challenge method
   */
  code_challenge_method?: string
  /**
   * Resource indicator (RFC 8707) - target audience for the token
   */
  resource?: string
  /**
   * Locale for the login page (e.g. en-US, pt-BR)
   */
  locale?: string
}

export type SocialControllerGoogleStartParams = {
  /**
   * OAuth client ID for brand routing (superautor or arvore)
   */
  client_id: string
  /**
   * Path to redirect the user after login (final destination)
   */
  redirect_path?: string
  /**
   * OAuth2 redirect URI (callback URL for code exchange)
   */
  redirect_uri?: string
  /**
   * OAuth2 state parameter (passed through to authorize)
   */
  state?: string
  /**
   * PKCE code challenge
   */
  code_challenge?: string
  /**
   * PKCE code challenge method (S256)
   */
  code_challenge_method?: string
  /**
   * Resource indicator (RFC 8707) - target audience for the token
   */
  resource?: string
  /**
   * Platform identifier. Use "mobile" for mobile app WebView flows.
   */
  platform?: string
}

export type SocialControllerGoogleCallbackParams = {
  code: string
  state: string
  error: string
}

export type SocialControllerMicrosoftStartParams = {
  /**
   * OAuth client ID for brand routing (superautor or arvore)
   */
  client_id: string
  /**
   * Path to redirect the user after login (final destination)
   */
  redirect_path?: string
  /**
   * OAuth2 redirect URI (callback URL for code exchange)
   */
  redirect_uri?: string
  /**
   * OAuth2 state parameter (passed through to authorize)
   */
  state?: string
  /**
   * PKCE code challenge
   */
  code_challenge?: string
  /**
   * PKCE code challenge method (S256)
   */
  code_challenge_method?: string
  /**
   * Resource indicator (RFC 8707) - target audience for the token
   */
  resource?: string
  /**
   * Platform identifier. Use "mobile" for mobile app WebView flows.
   */
  platform?: string
}

export type SocialControllerMicrosoftCallbackParams = {
  code: string
  state: string
  error: string
}

export type SocialControllerLexStartParams = {
  /**
   * OAuth client ID for brand routing (superautor or arvore)
   */
  client_id: string
  /**
   * Path to redirect the user after login (final destination)
   */
  redirect_path?: string
  /**
   * OAuth2 redirect URI (callback URL for code exchange)
   */
  redirect_uri?: string
  /**
   * OAuth2 state parameter (passed through to authorize)
   */
  state?: string
  /**
   * PKCE code challenge
   */
  code_challenge?: string
  /**
   * PKCE code challenge method (S256)
   */
  code_challenge_method?: string
  /**
   * Resource indicator (RFC 8707) - target audience for the token
   */
  resource?: string
  /**
   * Platform identifier. Use "mobile" for mobile app WebView flows.
   */
  platform?: string
}

export type SocialControllerLexCallbackParams = {
  code: string
  state: string
  error: string
}

export type SocialControllerClasslinkStartParams = {
  /**
   * OAuth client ID for brand routing (superautor or arvore)
   */
  client_id: string
  /**
   * Path to redirect the user after login (final destination)
   */
  redirect_path?: string
  /**
   * OAuth2 redirect URI (callback URL for code exchange)
   */
  redirect_uri?: string
  /**
   * OAuth2 state parameter (passed through to authorize)
   */
  state?: string
  /**
   * PKCE code challenge
   */
  code_challenge?: string
  /**
   * PKCE code challenge method (S256)
   */
  code_challenge_method?: string
  /**
   * Resource indicator (RFC 8707) - target audience for the token
   */
  resource?: string
  /**
   * Platform identifier. Use "mobile" for mobile app WebView flows.
   */
  platform?: string
}

export type SocialControllerClasslinkCallbackParams = {
  code: string
  state: string
  error: string
}

export type EntitySyncControllerSearchEntitiesParams = {
  query?: string
  entity_type: EntitySyncControllerSearchEntitiesEntityType
  source: EntitySyncControllerSearchEntitiesSource
}

export type EntitySyncControllerSearchEntitiesEntityType =
  typeof EntitySyncControllerSearchEntitiesEntityType[keyof typeof EntitySyncControllerSearchEntitiesEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitySyncControllerSearchEntitiesEntityType = {
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type EntitySyncControllerSearchEntitiesSource =
  typeof EntitySyncControllerSearchEntitiesSource[keyof typeof EntitySyncControllerSearchEntitiesSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitySyncControllerSearchEntitiesSource = {
  arvore: 'arvore',
  super: 'super'
} as const

export type DebugSessionPublicControllerDownloadParams = {
  bytes: string
}

export type AuditEventsControllerListParams = {
  search?: string
  yearMonth?: string
  userId?: string
  eventName?: string
  category?: string
  method?: AuditEventsControllerListMethod
  statusCode?: string
  startDate?: number
  endDate?: number
  limit?: number
  cursor?: string
}

export type AuditEventsControllerListMethod =
  typeof AuditEventsControllerListMethod[keyof typeof AuditEventsControllerListMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuditEventsControllerListMethod = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const

export type AuditEventsControllerDetailParams = {
  userId: string
  sk: string
}

export type AuditEventsControllerStatsParams = {
  yearMonth?: string
}

export type AuditEventsControllerIpInfoParams = {
  ip: string
}

export type PublisherSettlementControllerListV1Params = {
  year?: number
  month?: number
}

export type PushNotificationsControllerRemovePushTokenParams = {
  /**
   * Specific token to remove (if not provided, removes all tokens for the user)
   */
  token?: string
}

export type PushNotificationsControllerListPushNotificationsParams = {
  /**
   * Page number
   */
  page?: number
  /**
   * Items per page
   * @maximum 100
   */
  limit?: number
  /**
   * Filter by status
   */
  status?: PushNotificationsControllerListPushNotificationsStatus
}

export type PushNotificationsControllerListPushNotificationsStatus =
  typeof PushNotificationsControllerListPushNotificationsStatus[keyof typeof PushNotificationsControllerListPushNotificationsStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PushNotificationsControllerListPushNotificationsStatus = {
  pending: 'pending',
  sending: 'sending',
  completed: 'completed',
  failed: 'failed'
} as const

export type CustomNotificationsControllerListNotificationsParams = {
  page?: number
  /**
   * @maximum 100
   */
  limit?: number
  status?: CustomNotificationsControllerListNotificationsStatus
}

export type CustomNotificationsControllerListNotificationsStatus =
  typeof CustomNotificationsControllerListNotificationsStatus[keyof typeof CustomNotificationsControllerListNotificationsStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomNotificationsControllerListNotificationsStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type CustomNotificationsControllerListNotifications200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerCreateNotification201 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerGetAvailableConditions200Item = {
  [key: string]: unknown
}

export type CustomNotificationsControllerGetAvailableVariables200Item = {
  [key: string]: unknown
}

export type CustomNotificationsControllerGetConditionOptions200Item = {
  [key: string]: unknown
}

export type CustomNotificationsControllerListAuditLogsParams = {
  page?: number
  /**
   * @maximum 100
   */
  limit?: number
  notificationId?: string
}

export type CustomNotificationsControllerListAuditLogs200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerGetExecutionDetails200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerGetNotification200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerUpdateNotification200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerToggleNotification200 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerExecuteNotification201 = {
  [key: string]: unknown
}

export type CustomNotificationsControllerListExecutionsParams = {
  page: number
  limit: number
}

export type CustomNotificationsControllerListExecutions200 = {
  [key: string]: unknown
}

export type UserNotificationsControllerListNotificationsParams = {
  page?: number
  /**
   * @maximum 100
   */
  limit?: number
}

export type UserNotificationsControllerListNotifications200 = {
  [key: string]: unknown
}

export type UserNotificationsControllerGetUnreadCount200 = {
  [key: string]: unknown
}

export type ReadingFluencyControllerGetBookSnippetsByDegreeParams = {
  /**
   * Class entity IDs to filter out already used snippets
   */
  entitiesIds?: number[]
}

export type ReadingFluencyControllerUploadAudioBody = {
  file?: Blob
  /** Audio duration in seconds measured by the client */
  duration?: number
  /** Assessment the client displayed and recorded against */
  assessmentId?: number
}

export type ReadingFluencyControllerListActiveAssessmentsParams = {
  /**
   * Entity ID to filter assessments by
   */
  entityId?: number
  /**
   * Assessment ID to find a specific assessment
   */
  assessmentId?: number
}

export type ReadingFluencyControllerListAssessmentResultsParams = {
  /**
   * Filter by assessment ID
   */
  assessmentId?: number
  /**
   * Filter by user ID
   */
  userId?: number
  /**
   * Filter by entity ID
   */
  entityId?: number
}

export type ReadingFluencyControllerListAutomaticAssessmentsParams = {
  /**
   * Entity ID to list automatic assessments for
   */
  entityId: number
}

export type RunningRecordsControllerSendToAssessmentBody = {
  audio: Blob
  assessmentId?: number
  bookSnippetId: number
}

export type FluencyAudioReviewControllerListResultsV1Params = {
  /**
   * Degree do snippet (ex: "1", "2", "3")
   */
  degree?: string
  /**
   * ID do book_snippet
   */
  bookSnippetId?: number
  /**
   * Slug da Linhagem do Trecho (ex: "trecho-1")
   */
  bookSnippetSlug?: string
  /**
   * Versão do Trecho dentro da Linhagem (ex: 2)
   */
  bookSnippetVersion?: number
  /**
   * Data inicial (ISO 8601)
   */
  createdFrom?: string
  /**
   * Data final (ISO 8601)
   */
  createdTo?: string
  /**
   * PCPM mínimo
   */
  pcpmMin?: number
  /**
   * PCPM máximo
   */
  pcpmMax?: number
  /**
   * Filtro agregado de compreensão
   */
  comprehensionFilter?: FluencyAudioReviewControllerListResultsV1ComprehensionFilter
  /**
   * Filtro de questões específicas no formato "position:isCorrect", separado por vírgula. Ex: "1:true,2:false"
   */
  comprehensionByPosition?: string
  /**
   * ID da entidade (escola, rede, turma)
   */
  entityId?: number
  /**
   * Login (token) do aluno (ex: ATC3798)
   */
  userLogin?: string
  /**
   * Modo de agrupamento da listagem
   */
  groupBy?: FluencyAudioReviewControllerListResultsV1GroupBy
  page?: number
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number
  /**
   * Se deve incluir avaliações canceladas (default false)
   */
  includeCanceled?: string
  /**
   * Filtra apenas resultados sem comentários
   */
  noComment?: string
  /**
   * Filtra apenas resultados que ainda não foram ouvidos por nenhum reviewer
   */
  notListened?: string
  /**
   * Nível de compreensão (1=Básico, 2=Intermediário, 3=Adequado, 4/5=Avançado). Pode ser múltiplos separados por vírgula.
   */
  comprehensionLevel?: string
  /**
   * Slug do nível de proficiencia (ex: advanced_reader, adequate_reader). Múltiplos separados por vírgula.
   */
  oralReadingLevel?: string
}

export type FluencyAudioReviewControllerListResultsV1ComprehensionFilter =
  typeof FluencyAudioReviewControllerListResultsV1ComprehensionFilter[keyof typeof FluencyAudioReviewControllerListResultsV1ComprehensionFilter]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewControllerListResultsV1ComprehensionFilter = {
  all_correct: 'all_correct',
  any_wrong: 'any_wrong',
  not_answered: 'not_answered'
} as const

export type FluencyAudioReviewControllerListResultsV1GroupBy =
  typeof FluencyAudioReviewControllerListResultsV1GroupBy[keyof typeof FluencyAudioReviewControllerListResultsV1GroupBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyAudioReviewControllerListResultsV1GroupBy = {
  result: 'result',
  student: 'student'
} as const

export type ReportsControllerGetAccessReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetAccessReportV2V2Params = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetGeneralVisionSummaryParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
}

export type ReportsControllerGetGeneralVisionEntitiesParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
}

export type ReportsControllerGetGeneralVisionEntityMetricsStreamParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
}

export type ReportsControllerGetGeneralVisionReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
}

export type ReportsControllerGetGeneralVisionClassReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Class ID
   */
  classId: number
}

export type ReportsControllerGetGeneralVisionUserReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * User ID
   */
  userId: number
}

export type ReportsControllerGetReadingReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * School ID
   */
  schoolId: number
  /**
   * Class ID
   */
  classId: number
  /**
   * Trademark ID
   */
  trademarkId: number
  /**
   * Network ID
   */
  networkId: number
}

export type ReportsControllerGetReadingReportByReaderParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetBooksReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetBooksUserReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetBookDetailReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Class ID
   */
  classId: string
  /**
   * Book ID
   */
  bookId: string
}

export type ReportsControllerGetReadingGoalsReportParams = {
  /**
   * Class entity ID
   */
  entityId: number
  /**
   * Page number (values lower than 1 are treated as 1)
   */
  page?: number
  /**
   * Number of users per page (values lower than 1 are treated as 1)
   */
  limit?: number
  /**
   * Reference date inside the desired weekly period (Monday to Sunday). Defaults to today in America/Sao_Paulo
   */
  referenceDate?: string
  /**
   * Users list ordering
   */
  orderBy?: ReportsControllerGetReadingGoalsReportOrderBy
}

export type ReportsControllerGetReadingGoalsReportOrderBy =
  typeof ReportsControllerGetReadingGoalsReportOrderBy[keyof typeof ReportsControllerGetReadingGoalsReportOrderBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsControllerGetReadingGoalsReportOrderBy = {
  BY_NAME: 'BY_NAME',
  BY_READING_TIME: 'BY_READING_TIME'
} as const

export type ReportsControllerGetActivitiesReportParams = {
  /**
   * Entity ID
   */
  entityId: number
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Filter activities applied by the logged-in teacher
   */
  appliedByMe?: boolean
}

export type ReportsControllerGetActivitiesStudentReportParams = {
  /**
   * User ID
   */
  userId: number
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Filter activities applied by the logged-in teacher
   */
  appliedByMe?: boolean
}

export type ReportsControllerGetActivityQuestionsDetailsParams = {
  /**
   * Applied Activity ID
   */
  appliedActivityId: number
}

export type ReportsControllerGetActivityReadingDetailsParams = {
  /**
   * Content Indication ID
   */
  contentIndicationId: number
  /**
   * Entity ID (turma/classe) for filtering results to specific classroom
   */
  entityId?: number
}

export type ReportsControllerGetArticlesReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetArticlesReportByUserParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetArticleDetailsParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Class ID
   */
  classId: number
  /**
   * Article ID
   */
  articleId: number
}

export type ReportsControllerGetStudentAccessReportParams = {
  /**
   * Class ID
   */
  classId: number
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetStudentAccessReportV2V2Params = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Class ID
   */
  classId: number
}

export type ReportsControllerGetTaskReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetActivityStatsByMonthParams = {
  /**
   * Start date in YYYY-MM-DD format
   */
  startDate: string
  /**
   * End date in YYYY-MM-DD format
   */
  endDate: string
  /**
   * User ID
   */
  userId: number
}

export type ReportsControllerGetTaskReportByUserParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetTaskDetailsParams = {
  /**
   * Class ID to filter activities by class (only for class-based activities)
   */
  classId?: string
}

export type ReportsControllerGetAppliedActivityDetailsParams = {
  /**
   * Class ID to filter results
   */
  classId?: string
}

export type ReportsControllerGetManagersByEntityTypeParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetTeachersByEntityTypeParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetEducatorsByEntityParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
}

export type ReportsControllerGetJourneysReportParams = {
  /**
   * Class ID
   */
  classId: string
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetJourneyDetailsByUserParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
}

export type ReportsControllerGetPaymentReportParams = {
  /**
   * Entity ID (holding, trademark, network, school, or class)
   */
  entityId: string
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
}

export type ReportsControllerGetSummaryCardsParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryEffectiveReadingChartParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryTopReadingClassesParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryTopReadingStudentsParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryTopContentsParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryActivitiesChartParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetSummaryReadingsByFormatParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Optional class IDs to filter by specific classes
   */
  classIds?: number[]
}

export type ReportsControllerGetIndicationsReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * User ID (student)
   */
  userId?: number
}

export type ReportsControllerGetUsersByAncestryParams = {
  classId: number
  userProfile?: ReportsControllerGetUsersByAncestryUserProfile
}

export type ReportsControllerGetUsersByAncestryUserProfile =
  typeof ReportsControllerGetUsersByAncestryUserProfile[keyof typeof ReportsControllerGetUsersByAncestryUserProfile]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsControllerGetUsersByAncestryUserProfile = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER'
} as const

export type FluencyAuthoringControllerSearchBooksV1Params = {
  q: string
}

export type ActivitiesControllerFindAllParams = {
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
  /**
   * Filter by book slug
   */
  bookSlug?: string
  /**
   * Filter by estimated completion time range. Options: up_to_5, up_to_10, up_to_15, up_to_30, up_to_60, more_than_60
   */
  timeRange?: string
  /**
   * Filter by difficulty level
   */
  difficultyLevel?: string
  /**
   * Filter by degree range
   */
  degreeRange?: string
  /**
   * Filter by activity type
   */
  activityType?: string
  /**
   * Filter by BNCC code
   */
  bnccCodes?: string
  /**
   * Filter by article ID
   */
  articleId?: number
  /**
   * Filter by module ID
   */
  moduleId?: number
  /**
   * Filter by textual genre ID
   */
  textualGenreId?: number
  /**
   * Search by activity title
   */
  search?: string
}

export type ActivitiesControllerFindAllAdminParams = {
  /**
   * Page number for pagination
   */
  page?: number
  /**
   * Number of items per page
   */
  pageSize?: number
  /**
   * Search by activity title (LIKE)
   */
  search?: string
  /**
   * Filter by book slug
   */
  bookSlug?: string
  /**
   * Filter by creator (teacherId)
   */
  teacherId?: number
  /**
   * Include deleted activities (true = all, false/omit = only active)
   */
  includeDeleted?: boolean
}

export type ActivitiesControllerGetReadersWithPendingBookCreationParams = {
  readerIds: string
}

export type ActivitiesControllerUploadImageBody = {
  images?: Blob[]
}

export type ActivitiesControllerUploadActivityImageBody = {
  image?: Blob
}

export type BiblionRegistrationControllerCheckEmailParams = {
  /**
   * Email to check availability for
   */
  email: string
}

export type SescRegistrationControllerCheckEmailParams = {
  /**
   * Email to check availability for
   */
  email: string
}

export type ReaderArticleShelvesControllerListParams = {
  page?: number
  perPage?: number
}

export type ReaderArticleShelvesControllerListArticlesParams = {
  page?: number
  perPage?: number
}

export type ArticlesControllerListParams = {
  page?: number
  pageSize?: number
  search?: string
  status?: ArticlesControllerListStatus
  /**
   * Filter articles from this date (YYYY-MM-DD)
   */
  date?: string
  publisher?: ArticlesControllerListPublisher
}

export type ArticlesControllerListStatus =
  typeof ArticlesControllerListStatus[keyof typeof ArticlesControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticlesControllerListStatus = {
  published: 'published',
  unpublished: 'unpublished'
} as const

export type ArticlesControllerListPublisher =
  typeof ArticlesControllerListPublisher[keyof typeof ArticlesControllerListPublisher]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticlesControllerListPublisher = {
  arvore: 'arvore',
  nexo: 'nexo'
} as const

export type ArticlesControllerUploadImageBody = {
  image?: Blob
}

export type EntitlementsControllerCheckAvailabilityParams = {
  /**
   * Identity ID (UUID) of the user or entity
   */
  identityId: string
  /**
   * Type of identity
   */
  type: EntitlementsControllerCheckAvailabilityType
}

export type EntitlementsControllerCheckAvailabilityType =
  typeof EntitlementsControllerCheckAvailabilityType[keyof typeof EntitlementsControllerCheckAvailabilityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitlementsControllerCheckAvailabilityType = {
  user: 'user',
  entity: 'entity'
} as const

export type FavoritesControllerListParams = {
  page?: number
  pageSize?: number
}

export type FavoritesControllerListLibraryParams = {
  page?: number
  pageSize?: number
}

export type AnalyticsControllerGetAnswersParams = {
  /**
   * Filter by correct/incorrect answer
   */
  isCorrect?: boolean
  /**
   * Filter by teacher user ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  teacherUserId?: string
  /**
   * Filter by entity ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  entityId?: string
  /**
   * Filter by user ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  userId?: string
  /**
   * Filter by retry count. Supports operators: exact (1), gt:0, lt:5, gte:1, lte:3, neq:0, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  retryCount?: string
  /**
   * Filter by activity degree range
   */
  activityDegreeRange?: string
  /**
   * Filter by activity difficulty level
   */
  activityDifficultyLevel?: string
  /**
   * Filter by activity title (partial match)
   */
  activityTitle?: string
  /**
   * Filter by question type
   */
  questionType?: string
  /**
   * Filter by answer status
   */
  answerStatus?: string
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by entity degree
   */
  entityDegree?: string
  /**
   * Filter by grade
   */
  grade?: string
  /**
   * Filter by AI grade
   */
  aiGrade?: string
  /**
   * Filter by start date
   */
  startDate?: string
  /**
   * Filter by end date
   */
  endDate?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., user.user_type, book.name)
   */
  groupBy?: AnalyticsControllerGetAnswersGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetAnswersOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., entityId:count,retryCount:avg). For multi-column count_distinct, use pipe separator: userId|activityId:count_distinct (counts unique combinations of user+activity)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10", "score:avg:gte:80"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity, user. Format: entity,user
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: userId,entityId,entity.name,user.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Entidade,user.name:Nome do usuário
   */
  alias?: string
}

export type AnalyticsControllerGetAnswersGroupByItem =
  typeof AnalyticsControllerGetAnswersGroupByItem[keyof typeof AnalyticsControllerGetAnswersGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetAnswersGroupByItem = {
  isCorrect: 'isCorrect',
  activityEstimatedTimeInSeconds: 'activityEstimatedTimeInSeconds',
  teacherUserId: 'teacherUserId',
  entityId: 'entityId',
  userId: 'userId',
  retryCount: 'retryCount',
  activityArticleIds: 'activityArticleIds',
  activityBookIds: 'activityBookIds',
  didacticSequenceTitle: 'didacticSequenceTitle',
  activityDegreeRange: 'activityDegreeRange',
  activityDifficultyLevel: 'activityDifficultyLevel',
  activityTitle: 'activityTitle',
  activityDescription: 'activityDescription',
  pageReference: 'pageReference',
  expectedAnswer: 'expectedAnswer',
  questionType: 'questionType',
  message: 'message',
  finalComment: 'finalComment',
  finalGrade: 'finalGrade',
  answerStatus: 'answerStatus',
  entityType: 'entityType',
  entityDegree: 'entityDegree',
  entityAncestry: 'entityAncestry',
  grade: 'grade',
  aiComment: 'aiComment',
  aiGrade: 'aiGrade',
  answerDiscursive: 'answerDiscursive',
  endDate: 'endDate',
  startDate: 'startDate'
} as const

export type AnalyticsControllerGetAnswersOrderDirection =
  typeof AnalyticsControllerGetAnswersOrderDirection[keyof typeof AnalyticsControllerGetAnswersOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetAnswersOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetBookPageViewsParams = {
  /**
   * Filter by offline status
   */
  isOffline?: boolean
  /**
   * Filter by effective status
   */
  isEffective?: boolean
  /**
   * Filter by book ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  bookId?: string
  /**
   * Filter by entity ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  entityId?: string
  /**
   * Filter by user ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  userId?: string
  /**
   * Filter by entity degree. Supports operators: exact ('1ano'), neq:2ano, in:1ano,2ano, notin:3ano,4ano, isnull, isnotnull
   */
  entityDegree?: string
  /**
   * Filter by entity type. Supports operators: exact ('turma'), neq:escola, in:turma,rede, notin:holding, isnull, isnotnull
   */
  entityType?: string
  /**
   * Filter by created month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  createdMonth?: string
  /**
   * Filter by created year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  createdYear?: string
  /**
   * Filter by created hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  createdHour?: string
  /**
   * Filter by created day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  createdDay?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., user.user_type, book.name)
   */
  groupBy?: AnalyticsControllerGetBookPageViewsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format. Supports multi-column with pipe separator (e.g., userId|bookId:count_distinct)
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetBookPageViewsOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., entityId:count,percentageRead:avg). For multi-column count_distinct, use pipe separator: userId|bookId:count_distinct (counts unique combinations of user+book)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10" (more than 10 records), "timeRead:sum:gte:1000" (total time >= 1000)
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity, user, book. Format: entity,user,book
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: bookId,userId,entity.name,user.name,book.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Escola,user.name:Aluno,book.name:Livro
   */
  alias?: string
}

export type AnalyticsControllerGetBookPageViewsGroupByItem =
  typeof AnalyticsControllerGetBookPageViewsGroupByItem[keyof typeof AnalyticsControllerGetBookPageViewsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetBookPageViewsGroupByItem = {
  timeRead: 'timeRead',
  isEffective: 'isEffective',
  isOffline: 'isOffline',
  percentageRead: 'percentageRead',
  userId: 'userId',
  entityId: 'entityId',
  bookId: 'bookId',
  entityType: 'entityType',
  entityDegree: 'entityDegree',
  entityAncestry: 'entityAncestry',
  createdAt: 'createdAt',
  createdMonth: 'createdMonth',
  createdYear: 'createdYear',
  createdHour: 'createdHour',
  createdDay: 'createdDay'
} as const

export type AnalyticsControllerGetBookPageViewsOrderDirection =
  typeof AnalyticsControllerGetBookPageViewsOrderDirection[keyof typeof AnalyticsControllerGetBookPageViewsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetBookPageViewsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetIndicationsParams = {
  /**
   * Filter by target entity ID
   */
  targetEntityId?: number
  /**
   * Filter by target user ID
   */
  targetUserId?: number
  /**
   * Filter by content ID
   */
  contentId?: number
  /**
   * Filter by source user ID
   */
  sourceUserId?: number
  /**
   * Filter by source entity ID
   */
  sourceEntityId?: number
  /**
   * Filter by target entity type
   */
  targetEntityType?: string
  /**
   * Filter by target entity degree
   */
  targetEntityDegree?: string
  /**
   * Filter by content type
   */
  contentType?: string
  /**
   * Filter by source entity type
   */
  sourceEntityType?: string
  /**
   * Filter by source entity degree
   */
  sourceEntityDegree?: string
  /**
   * Filter by due date
   */
  dueDate?: string
  /**
   * Filter by indicated at date
   */
  indicatedAt?: string
  /**
   * Filter by created month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  createdMonth?: number
  /**
   * Filter by created year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  createdYear?: number
  /**
   * Filter by created hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  createdHour?: number
  /**
   * Filter by created day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  createdDay?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., sourceEntity.name, targetEntity.name)
   */
  groupBy?: AnalyticsControllerGetIndicationsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format (e.g., contentId:count, dueDate:max)
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetIndicationsOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., contentId:count,targetUserId:sum). For multi-column count_distinct, use pipe separator: targetEntityId|contentId:count_distinct (counts unique combinations of targetEntity+content)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10", "contentId:count_distinct:gte:5"
   */
  having?: string
  /**
   * Expand relations through joins. Available: sourceEntity, targetEntity, user, book. Format: sourceEntity,targetEntity,user,book
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: contentId,sourceEntity.name,targetEntity.name,user.name,book.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: sourceEntity.name:Origem,targetEntity.name:Destino
   */
  alias?: string
}

export type AnalyticsControllerGetIndicationsGroupByItem =
  typeof AnalyticsControllerGetIndicationsGroupByItem[keyof typeof AnalyticsControllerGetIndicationsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetIndicationsGroupByItem = {
  targetEntityId: 'targetEntityId',
  targetUserId: 'targetUserId',
  contentId: 'contentId',
  sourceUserId: 'sourceUserId',
  sourceEntityId: 'sourceEntityId',
  targetEntityType: 'targetEntityType',
  targetEntityDegree: 'targetEntityDegree',
  targetEntityAncestry: 'targetEntityAncestry',
  contentType: 'contentType',
  sourceEntityType: 'sourceEntityType',
  sourceEntityDegree: 'sourceEntityDegree',
  sourceEntityAncestry: 'sourceEntityAncestry',
  dueDate: 'dueDate',
  indicatedAt: 'indicatedAt',
  createdAt: 'createdAt',
  createdMonth: 'createdMonth',
  createdYear: 'createdYear',
  createdHour: 'createdHour',
  createdDay: 'createdDay'
} as const

export type AnalyticsControllerGetIndicationsOrderDirection =
  typeof AnalyticsControllerGetIndicationsOrderDirection[keyof typeof AnalyticsControllerGetIndicationsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetIndicationsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetLeagueRankingsParams = {
  /**
   * Filter by entity ID
   */
  entityId?: string
  /**
   * Filter by rank position
   */
  rankPosition?: string
  /**
   * Filter by points
   */
  points?: string
  /**
   * Filter by month
   */
  month?: string
  /**
   * Filter by year
   */
  year?: string
  /**
   * Filter by user ID
   */
  userId?: string
  /**
   * Filter by entity degree
   */
  entityDegree?: string
  /**
   * Filter by tier
   */
  tier?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by user type. Available values: student, teacher. Use this to filter rankings by user type.
   */
  userType?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name, user.user_type)
   */
  groupBy?: AnalyticsControllerGetLeagueRankingsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetLeagueRankingsOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., points:sum,rankPosition:avg). For multi-column count_distinct, use pipe separator: entityId|userId:count_distinct (counts unique combinations of entity+user)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10", "points:sum:gte:1000"
   */
  having?: string
  /**
   * Filter by specific class IDs. If provided, only shows rankings for these classes.
   */
  teacherClasses?: number[]
  /**
   * Expand relations through joins. Available: entity, user. Format: entity,user
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: userId,entityId,entity.name,user.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Entidade,user.name:Usuário
   */
  alias?: string
}

export type AnalyticsControllerGetLeagueRankingsGroupByItem =
  typeof AnalyticsControllerGetLeagueRankingsGroupByItem[keyof typeof AnalyticsControllerGetLeagueRankingsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetLeagueRankingsGroupByItem = {
  entityId: 'entityId',
  rankPosition: 'rankPosition',
  points: 'points',
  month: 'month',
  year: 'year',
  userId: 'userId',
  entityType: 'entityType',
  entityDegree: 'entityDegree',
  entityAncestry: 'entityAncestry',
  tier: 'tier',
  degree: 'degree'
} as const

export type AnalyticsControllerGetLeagueRankingsOrderDirection =
  typeof AnalyticsControllerGetLeagueRankingsOrderDirection[keyof typeof AnalyticsControllerGetLeagueRankingsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetLeagueRankingsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetUsersParams = {
  /**
   * Filter by user ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Filter by entity ID
   */
  entityId?: number
  /**
   * Filter by email (partial match)
   */
  email?: string
  /**
   * Filter by user type
   */
  userType?: string
  /**
   * Filter by job positions
   */
  jobPositions?: string
  /**
   * Filter by created month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  createdMonth?: string
  /**
   * Filter by created year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  createdYear?: string
  /**
   * Filter by created hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  createdHour?: string
  /**
   * Filter by created day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  createdDay?: string
  /**
   * Filter by last sign in month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6
   */
  lastSignInMonth?: string
  /**
   * Filter by last sign in year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024
   */
  lastSignInYear?: string
  /**
   * Filter by last sign in hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17
   */
  lastSignInHour?: string
  /**
   * Filter by last sign in day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31
   */
  lastSignInDay?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name, class.name)
   */
  groupBy?: AnalyticsControllerGetUsersGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetUsersOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,entityType:sum). For multi-column count_distinct, use pipe separator: entityId|entityType:count_distinct (counts unique combinations of entity+entityType)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: userId,entityId,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Escola
   */
  alias?: string
}

export type AnalyticsControllerGetUsersGroupByItem =
  typeof AnalyticsControllerGetUsersGroupByItem[keyof typeof AnalyticsControllerGetUsersGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetUsersGroupByItem = {
  entityId: 'entityId',
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name',
  email: 'email',
  userType: 'userType',
  jobPositions: 'jobPositions',
  createdAt: 'createdAt',
  createdMonth: 'createdMonth',
  createdYear: 'createdYear',
  createdHour: 'createdHour',
  createdDay: 'createdDay',
  lastSignInAt: 'lastSignInAt',
  lastSignInMonth: 'lastSignInMonth',
  lastSignInYear: 'lastSignInYear',
  lastSignInHour: 'lastSignInHour',
  lastSignInDay: 'lastSignInDay'
} as const

export type AnalyticsControllerGetUsersOrderDirection =
  typeof AnalyticsControllerGetUsersOrderDirection[keyof typeof AnalyticsControllerGetUsersOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetUsersOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetClassesParams = {
  /**
   * Filter by class ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name)
   */
  groupBy?: AnalyticsControllerGetClassesGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetClassesOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,degree:sum). For multi-column count_distinct, use pipe separator: entityType|degree:count_distinct (counts unique combinations of entityType+degree)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: id,name,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Entidade
   */
  alias?: string
}

export type AnalyticsControllerGetClassesGroupByItem =
  typeof AnalyticsControllerGetClassesGroupByItem[keyof typeof AnalyticsControllerGetClassesGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetClassesGroupByItem = {
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name'
} as const

export type AnalyticsControllerGetClassesOrderDirection =
  typeof AnalyticsControllerGetClassesOrderDirection[keyof typeof AnalyticsControllerGetClassesOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetClassesOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetSchoolsParams = {
  /**
   * Filter by school ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name)
   */
  groupBy?: AnalyticsControllerGetSchoolsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetSchoolsOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,degree:sum). For multi-column count_distinct, use pipe separator: entityType|degree:count_distinct (counts unique combinations of entityType+degree)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: id,name,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Escola
   */
  alias?: string
}

export type AnalyticsControllerGetSchoolsGroupByItem =
  typeof AnalyticsControllerGetSchoolsGroupByItem[keyof typeof AnalyticsControllerGetSchoolsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetSchoolsGroupByItem = {
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name'
} as const

export type AnalyticsControllerGetSchoolsOrderDirection =
  typeof AnalyticsControllerGetSchoolsOrderDirection[keyof typeof AnalyticsControllerGetSchoolsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetSchoolsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetNetworksParams = {
  /**
   * Filter by network ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name)
   */
  groupBy?: AnalyticsControllerGetNetworksGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetNetworksOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,degree:sum). For multi-column count_distinct, use pipe separator: entityType|degree:count_distinct (counts unique combinations of entityType+degree)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: id,name,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Entidade
   */
  alias?: string
}

export type AnalyticsControllerGetNetworksGroupByItem =
  typeof AnalyticsControllerGetNetworksGroupByItem[keyof typeof AnalyticsControllerGetNetworksGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetNetworksGroupByItem = {
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name'
} as const

export type AnalyticsControllerGetNetworksOrderDirection =
  typeof AnalyticsControllerGetNetworksOrderDirection[keyof typeof AnalyticsControllerGetNetworksOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetNetworksOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetTrademarksParams = {
  /**
   * Filter by trademark ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name)
   */
  groupBy?: AnalyticsControllerGetTrademarksGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetTrademarksOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,degree:sum). For multi-column count_distinct, use pipe separator: entityType|degree:count_distinct (counts unique combinations of entityType+degree)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: id,name,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Marca
   */
  alias?: string
}

export type AnalyticsControllerGetTrademarksGroupByItem =
  typeof AnalyticsControllerGetTrademarksGroupByItem[keyof typeof AnalyticsControllerGetTrademarksGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetTrademarksGroupByItem = {
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name'
} as const

export type AnalyticsControllerGetTrademarksOrderDirection =
  typeof AnalyticsControllerGetTrademarksOrderDirection[keyof typeof AnalyticsControllerGetTrademarksOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetTrademarksOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetHoldingsParams = {
  /**
   * Filter by holding ID
   */
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name)
   */
  groupBy?: AnalyticsControllerGetHoldingsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetHoldingsOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., id:count,degree:sum). For multi-column count_distinct, use pipe separator: entityType|degree:count_distinct (counts unique combinations of entityType+degree)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity. Format: entity
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: id,name,entity.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Nome da Entidade
   */
  alias?: string
}

export type AnalyticsControllerGetHoldingsGroupByItem =
  typeof AnalyticsControllerGetHoldingsGroupByItem[keyof typeof AnalyticsControllerGetHoldingsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetHoldingsGroupByItem = {
  id: 'id',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  name: 'name'
} as const

export type AnalyticsControllerGetHoldingsOrderDirection =
  typeof AnalyticsControllerGetHoldingsOrderDirection[keyof typeof AnalyticsControllerGetHoldingsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetHoldingsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetSessionsParams = {
  id?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by ancestry
   */
  ancestry?: string
  /**
   * Filter by name (partial match)
   */
  name?: string
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Filter by entity ID
   */
  entityId?: string
  /**
   * Filter by entity degree
   */
  entityDegree?: string
  /**
   * Filter by user ID
   */
  userId?: string
  /**
   * Filter by user type (e.g., student, teacher). When specified, overrides the default student filter when grouping by userId with user expand.
   */
  userType?: string
  /**
   * Filter by started month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  startedMonth?: string
  /**
   * Filter by started year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  startedYear?: string
  /**
   * Filter by started hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  startedHour?: string
  /**
   * Filter by started day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  startedDay?: string
  /**
   * Filter by last ping month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6
   */
  lastPingMonth?: string
  /**
   * Filter by last ping year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024
   */
  lastPingYear?: string
  /**
   * Filter by last ping hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17
   */
  lastPingHour?: string
  /**
   * Filter by last ping day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31
   */
  lastPingDay?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name, user.user_type)
   */
  groupBy?: AnalyticsControllerGetSessionsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetSessionsOrderDirection
  /**
   * Aggregations to apply. Format: column:function (e.g., entityId:count,sessionTime:sum). For multi-column count_distinct, use pipe separator: userId|entityId:count_distinct (counts unique combinations of user+entity)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10", "engagedSeconds:sum:gte:3600"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity, user. Format: entity,user
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: userId,entityId,entity.name,user.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Escola,user.name:Usuário
   */
  alias?: string
}

export type AnalyticsControllerGetSessionsGroupByItem =
  typeof AnalyticsControllerGetSessionsGroupByItem[keyof typeof AnalyticsControllerGetSessionsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetSessionsGroupByItem = {
  entityId: 'entityId',
  entityType: 'entityType',
  entityDegree: 'entityDegree',
  entityAncestry: 'entityAncestry',
  ancestry: 'ancestry',
  idleSeconds: 'idleSeconds',
  engagedSeconds: 'engagedSeconds',
  lastPingAt: 'lastPingAt',
  lastPingDay: 'lastPingDay',
  lastPingMonth: 'lastPingMonth',
  lastPingYear: 'lastPingYear',
  lastPingHour: 'lastPingHour',
  startedAt: 'startedAt',
  startedDay: 'startedDay',
  startedMonth: 'startedMonth',
  startedYear: 'startedYear',
  startedHour: 'startedHour',
  sessionId: 'sessionId',
  userId: 'userId'
} as const

export type AnalyticsControllerGetSessionsOrderDirection =
  typeof AnalyticsControllerGetSessionsOrderDirection[keyof typeof AnalyticsControllerGetSessionsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetSessionsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetReadingsFluencyParams = {
  /**
   * Filter by entity ID
   */
  entityId?: number
  /**
   * Filter by user ID
   */
  userId?: number
  /**
   * Filter by entity type
   */
  entityType?: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by book snippet
   */
  bookSnippet?: string
  /**
   * Filter by partner leveling
   */
  partnerLeveling?: string
  /**
   * Filter by assessment provider
   */
  assessmentProvider?: string
  /**
   * Filter by created month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  createdMonth?: string
  /**
   * Filter by created year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  createdYear?: string
  /**
   * Filter by created hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  createdHour?: string
  /**
   * Filter by created day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  createdDay?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., entity.name, user.user_type, book.name)
   */
  groupBy?: AnalyticsControllerGetReadingsFluencyGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetReadingsFluencyOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., entityId:count,userId:sum). For multi-column count_distinct, use pipe separator: userId|bookSnippet:count_distinct (counts unique combinations of user+bookSnippet)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10", "correctWordsPerMinute:avg:gte:100", "successRate:avg:gte:80"
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity, user, book. Format: entity,user,book
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: bookId,userId,entity.name,user.name,book.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Escola,user.name:Aluno,book.name:Livro
   */
  alias?: string
}

export type AnalyticsControllerGetReadingsFluencyGroupByItem =
  typeof AnalyticsControllerGetReadingsFluencyGroupByItem[keyof typeof AnalyticsControllerGetReadingsFluencyGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetReadingsFluencyGroupByItem = {
  entityId: 'entityId',
  userId: 'userId',
  entityType: 'entityType',
  degree: 'degree',
  ancestry: 'ancestry',
  bookSnippet: 'bookSnippet',
  partnerLeveling: 'partnerLeveling',
  assessmentProvider: 'assessmentProvider',
  successRate: 'successRate',
  correctWordsPerMinute: 'correctWordsPerMinute',
  createdAt: 'createdAt',
  createdMonth: 'createdMonth',
  createdYear: 'createdYear',
  createdHour: 'createdHour',
  createdDay: 'createdDay'
} as const

export type AnalyticsControllerGetReadingsFluencyOrderDirection =
  typeof AnalyticsControllerGetReadingsFluencyOrderDirection[keyof typeof AnalyticsControllerGetReadingsFluencyOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetReadingsFluencyOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type AnalyticsControllerGetReadingsParams = {
  /**
   * Filter by book ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  bookId?: string
  /**
   * Filter by entity ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  entityId?: string
  /**
   * Filter by user ID. Supports operators: exact (123), gt:10, lt:100, gte:10, lte:100, neq:5, in:1,2,3, notin:4,5, isnull, isnotnull
   */
  userId?: string
  /**
   * Filter by entity degree. Supports operators: exact ('1ano'), neq:2ano, in:1ano,2ano, notin:3ano,4ano, isnull, isnotnull
   */
  entityDegree?: string
  /**
   * Filter by entity type. Supports operators: exact ('turma'), neq:escola, in:turma,rede, notin:holding, isnull, isnotnull
   */
  entityType?: string
  /**
   * Filter by effective percentage. Supports operators: exact (10.5), gt:10, lt:100, gte:10, lte:100, neq:5, isnull, isnotnull
   */
  effectivePercentage?: string
  /**
   * Filter by total time spent. Supports operators: exact (300), gt:100, lt:1000, gte:100, lte:1000, neq:500, isnull, isnotnull
   */
  totalTimeSpent?: string
  /**
   * Filter by created month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6, in:1,2,3, notin:7,8,9
   */
  createdMonth?: string
  /**
   * Filter by created year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024, neq:2022, in:2023,2024
   */
  createdYear?: string
  /**
   * Filter by created hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17, neq:12
   */
  createdHour?: string
  /**
   * Filter by created day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31, neq:5
   */
  createdDay?: string
  /**
   * Filter by achieved 10% month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6
   */
  achieved10Month?: string
  /**
   * Filter by achieved 10% year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024
   */
  achieved10Year?: string
  /**
   * Filter by achieved 10% hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17
   */
  achieved10Hour?: string
  /**
   * Filter by achieved 10% day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31
   */
  achieved10Day?: string
  /**
   * Filter by achieved 50% month (1-12). Supports operators: exact (5), gt:3, lt:10, gte:1, lte:12, neq:6
   */
  achieved50Month?: string
  /**
   * Filter by achieved 50% year. Supports operators: exact (2024), gt:2023, lt:2025, gte:2020, lte:2024
   */
  achieved50Year?: string
  /**
   * Filter by achieved 50% hour (0-23). Supports operators: exact (14), gt:9, lt:18, gte:8, lte:17
   */
  achieved50Hour?: string
  /**
   * Filter by achieved 50% day (1-31). Supports operators: exact (15), gt:10, lt:20, gte:1, lte:31
   */
  achieved50Day?: string
  /**
   * Columns to group by. Supports both direct columns and expanded fields (e.g., user.user_type, entity.name)
   */
  groupBy?: AnalyticsControllerGetReadingsGroupByItem[]
  /**
   * Column to order by. Can be a column name, "count", or "column:function" format. Supports multi-column with pipe separator (e.g., userId|bookId:count_distinct)
   */
  orderBy?: string
  /**
   * Order direction
   */
  orderDirection?: AnalyticsControllerGetReadingsOrderDirection
  /**
   * Maximum number of results to return
   * @maximum 1000
   */
  limit?: number
  /**
   * Aggregations to apply. Format: column:function (e.g., entityId:count,effectivePercentage:avg). For multi-column count_distinct, use pipe separator: userId|bookId:count_distinct (counts unique combinations of user+book)
   */
  aggregations?: string
  /**
   * Filter aggregated results (use with groupBy). Format: "column:function:operator:value" or "count:operator:value". Operators: gt (>), gte (>=), lt (<), lte (<=), eq (=). Examples: "count:gt:10" (more than 10 records), "totalTimeSpent:sum:gte:1000" (total time >= 1000)
   */
  having?: string
  /**
   * Expand relations through joins. Available: entity, user, book. Format: entity,user,book
   */
  expand?: string
  /**
   * Select specific fields to return. Supports nested fields from expanded relations. Format: bookId,userId,entity.name,user.name,book.name
   */
  select?: string
  /**
   * Rename columns in the response. Format: column:alias,column2:alias2. Example: entity.name:Escola,user.name:Aluno,book.name:Livro
   */
  alias?: string
}

export type AnalyticsControllerGetReadingsGroupByItem =
  typeof AnalyticsControllerGetReadingsGroupByItem[keyof typeof AnalyticsControllerGetReadingsGroupByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetReadingsGroupByItem = {
  bookId: 'bookId',
  effectivePercentage: 'effectivePercentage',
  userId: 'userId',
  totalTimeSpent: 'totalTimeSpent',
  entityId: 'entityId',
  entityAncestry: 'entityAncestry',
  entityDegree: 'entityDegree',
  entityType: 'entityType',
  achieved10At: 'achieved10At',
  achieved10Month: 'achieved10Month',
  achieved10Year: 'achieved10Year',
  achieved10Hour: 'achieved10Hour',
  achieved10Day: 'achieved10Day',
  achieved50At: 'achieved50At',
  achieved50Month: 'achieved50Month',
  achieved50Year: 'achieved50Year',
  achieved50Hour: 'achieved50Hour',
  achieved50Day: 'achieved50Day',
  createdAt: 'createdAt',
  createdMonth: 'createdMonth',
  createdYear: 'createdYear',
  createdHour: 'createdHour',
  createdDay: 'createdDay',
  month: 'month'
} as const

export type AnalyticsControllerGetReadingsOrderDirection =
  typeof AnalyticsControllerGetReadingsOrderDirection[keyof typeof AnalyticsControllerGetReadingsOrderDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsControllerGetReadingsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ChatsControllerListChatsParams = {
  /**
   * Maximum number of chats to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * Number of chats to skip (pagination)
   * @minimum 0
   */
  offset?: number
}

export type ChatsControllerGetChat404 = {
  error?: string
  message?: string
}

export type EntitiesControllerListClassesParams = {
  /**
   * Filter by entity name
   */
  name?: string
}

export type EntitiesControllerGetSubtreeParams = {
  /**
   * Filter entities by type
   */
  entity_type?: EntitiesControllerGetSubtreeEntityType
  /**
   * Include users in the response
   */
  include_users?: boolean
}

export type EntitiesControllerGetSubtreeEntityType =
  typeof EntitiesControllerGetSubtreeEntityType[keyof typeof EntitiesControllerGetSubtreeEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerGetSubtreeEntityType = {
  class: 'class',
  school: 'school',
  network: 'network',
  trademark: 'trademark',
  holding: 'holding'
} as const

export type EntitiesControllerGetClassesByEntityParams = {
  /**
   * Entity ID to search classes for
   */
  entityId: number
  /**
   * Filter classes by degree
   */
  degree?: string
}

export type EntitiesControllerSearchEntitiesParams = {
  /**
   * Search query (name, type, degree)
   */
  query: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by entity type
   */
  entityType?: EntitiesControllerSearchEntitiesEntityType
  /**
   * Maximum number of results
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export type EntitiesControllerSearchEntitiesEntityType =
  typeof EntitiesControllerSearchEntitiesEntityType[keyof typeof EntitiesControllerSearchEntitiesEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerSearchEntitiesEntityType = {
  class: 'class',
  school: 'school',
  network: 'network',
  trademark: 'trademark',
  holding: 'holding'
} as const

export type EntitiesControllerGetEntityChildrenParams = {
  /**
   * Entity ID to get children from
   */
  entityId: number
  /**
   * Number of children per page
   */
  perPage: number
  /**
   * Page number (starts at 1)
   */
  page: number
}

export type EntitiesControllerGetRootEntitiesParams = {
  /**
   * Filter by entity type
   */
  entity_type?: EntitiesControllerGetRootEntitiesEntityType
}

export type EntitiesControllerGetRootEntitiesEntityType =
  typeof EntitiesControllerGetRootEntitiesEntityType[keyof typeof EntitiesControllerGetRootEntitiesEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerGetRootEntitiesEntityType = {
  holding: 'holding',
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type EntitiesControllerGetRootEntitiesWithTreesParams = {
  /**
   * Filter by entity type
   */
  entity_type?: EntitiesControllerGetRootEntitiesWithTreesEntityType
  /**
   * Maximum number of roots to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export type EntitiesControllerGetRootEntitiesWithTreesEntityType =
  typeof EntitiesControllerGetRootEntitiesWithTreesEntityType[keyof typeof EntitiesControllerGetRootEntitiesWithTreesEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerGetRootEntitiesWithTreesEntityType = {
  holding: 'holding',
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type EntitiesControllerGetEntityTreeParams = {
  /**
   * Root entity ID to get the tree from
   */
  root_id?: number
  /**
   * Filter entities by type
   */
  entity_type?: EntitiesControllerGetEntityTreeEntityType
  /**
   * Include users in the response
   */
  include_users?: boolean
}

export type EntitiesControllerGetEntityTreeEntityType =
  typeof EntitiesControllerGetEntityTreeEntityType[keyof typeof EntitiesControllerGetEntityTreeEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerGetEntityTreeEntityType = {
  class: 'class',
  school: 'school',
  network: 'network',
  trademark: 'trademark',
  holding: 'holding'
} as const

export type EntitiesControllerSearchEntitiesAdminParams = {
  /**
   * Search query (entity name)
   */
  query: string
  /**
   * Filter by entity type
   */
  entityType?: EntitiesControllerSearchEntitiesAdminEntityType
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Maximum number of results
   */
  limit?: number
}

export type EntitiesControllerSearchEntitiesAdminEntityType =
  typeof EntitiesControllerSearchEntitiesAdminEntityType[keyof typeof EntitiesControllerSearchEntitiesAdminEntityType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesControllerSearchEntitiesAdminEntityType = {
  holding: 'holding',
  network: 'network',
  trademark: 'trademark',
  school: 'school',
  class: 'class'
} as const

export type EntitiesControllerGetEntityUsersParams = {
  /**
   * Entity ID to get users from
   */
  entityId: number
  /**
   * Number of users per page
   */
  perPage: number
  /**
   * Page number (starts at 1)
   */
  page: number
  /**
   * Search by user name
   */
  search?: string
}

export type EntitiesControllerCreateEntityUserParams = {
  entityId: number
}

export type EntitiesControllerExportEntityUsersParams = {
  entityId: number
}

export type EntitiesControllerImportEntityUsersParams = {
  entityId: number
}

export type UsersControllerListUsersByAncestryParams = {
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * User profile type
   */
  userProfile?: UsersControllerListUsersByAncestryUserProfile
}

export type UsersControllerListUsersByAncestryUserProfile =
  typeof UsersControllerListUsersByAncestryUserProfile[keyof typeof UsersControllerListUsersByAncestryUserProfile]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersControllerListUsersByAncestryUserProfile = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER'
} as const

export type UsersControllerListUsersWithRolesParams = {
  /**
   * Entity ID to scope users to (entity + descendants)
   */
  entityId: number
  /**
   * Page number (1-based)
   */
  page?: number
  /**
   * Items per page (max 100)
   */
  perPage?: number
  /**
   * Search term for user name
   */
  searchTerm?: string
  /**
   * Permission level filter
   */
  role?: UsersControllerListUsersWithRolesRole
}

export type UsersControllerListUsersWithRolesRole =
  typeof UsersControllerListUsersWithRolesRole[keyof typeof UsersControllerListUsersWithRolesRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersControllerListUsersWithRolesRole = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
  ADMIN: 'ADMIN'
} as const

export type UsersControllerSearchUsersParams = {
  /**
   * Search query (name or email)
   */
  query: string
  /**
   * Filter by degree
   */
  degree?: string
  /**
   * Filter by admin status
   */
  admin?: boolean
  /**
   * Filter by specific entity ID
   */
  entityId?: number
  /**
   * Maximum number of results
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export type UsersControllerLookupUsersParams = {
  /**
   * Search by email
   */
  email?: string
  /**
   * Search by access token
   */
  accessToken?: string
  /**
   * Search by user ID
   */
  userId?: number
  /**
   * Maximum number of results
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export type VideoLoansControllerListParams = {
  status?: VideoLoansControllerListStatus
}

export type VideoLoansControllerListStatus =
  typeof VideoLoansControllerListStatus[keyof typeof VideoLoansControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoLoansControllerListStatus = {
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

export type LoansControllerListParams = {
  status?: LoansControllerListStatus
}

export type LoansControllerListStatus =
  typeof LoansControllerListStatus[keyof typeof LoansControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoansControllerListStatus = {
  pending: 'pending',
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

export type LoansControllerHistoryParams = {
  /**
   * @minimum 1
   */
  page?: number
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number
}

export type PodcastShowsControllerGetShowParams = {
  page?: number
  per_page?: number
}

export type PodcastLoansControllerListParams = {
  status?: PodcastLoansControllerListStatus
}

export type PodcastLoansControllerListStatus =
  typeof PodcastLoansControllerListStatus[keyof typeof PodcastLoansControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PodcastLoansControllerListStatus = {
  active: 'active',
  returned: 'returned',
  expired: 'expired'
} as const

export type BookChatControllerGetStatusParams = {
  book_slug: string
}

export type BookChatControllerGetSessionParams = {
  book_slug: string
}

export type BookLevellingControllerListScoresV1Params = {
  page?: number
  limit?: number
}

export type BookLevellingControllerSearchBooksV1Params = {
  q: string
}

export type CatalogationControllerAdminListCatalogedBooksParams = {
  /**
   * Busca textual por nome ou autor (LIKE case-insensitive).
   */
  search?: string
  /**
   * Grau/série para filtrar. Aceita múltiplos valores separados por vírgula.
   */
  degrees?: string[]
  /**
   * Página (1-based).
   */
  page?: number
  /**
   * Quantidade de itens por página.
   */
  pageSize?: number
}

export type CatalogationControllerListCatalogedBooksParams = {
  /**
   * Grau/série para filtrar livros. Aceita múltiplos valores. Se não enviado, retorna todos.
   */
  degrees?: string[]
  /**
   * Gêneros textuais (book_genres.name) para filtrar.
   */
  genres?: string[]
  /**
   * Itens de temas gerais (catalogation_theme_items.item) para filtrar. Valores são os itens folha, não os grupos.
   */
  themes?: string[]
  /**
   * Slugs de temas de mediação (book_sensitivity.label) para filtrar. Usa score >= 0.8.
   */
  mediations?: string[]
  /**
   * Se true, retorna apenas livros SEM nenhum tema de mediação com score >= 0.8. Ignora o filtro `mediations` quando ativo.
   */
  hideMediation?: boolean
  /**
   * Busca textual por nome ou autor (LIKE case-insensitive).
   */
  search?: string
  /**
   * Página (1-based).
   */
  page?: number
  /**
   * Quantidade de itens por página.
   */
  pageSize?: number
}

export type CatalogationControllerGetBookSensitivitySentencesParams = {
  /**
   * Slug do livro
   */
  slug: string
  /**
   * Label da sensibilidade (ex: animais_personificados)
   */
  label: string
}

export type CatalogationControllerDeleteListParams = {
  /**
   * ID of the book to remove from the list. If not provided, the entire list will be deleted.
   */
  bookId?: number
}

export type DigitalCatalogControllerListParams = {
  page?: number
  pageSize?: number
  search?: string
  modality?: DigitalCatalogControllerListModality
  origin?: DigitalCatalogControllerListOrigin
  license?: DigitalCatalogControllerListLicense
  language?: string
  publisherId?: number
  tagId?: number
  audiobook?: DigitalCatalogControllerListAudiobook
}

export type DigitalCatalogControllerListModality =
  typeof DigitalCatalogControllerListModality[keyof typeof DigitalCatalogControllerListModality]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListModality = {
  perpetual: 'perpetual',
  metered: 'metered',
  simultaneous: 'simultaneous',
  hybrid: 'hybrid'
} as const

export type DigitalCatalogControllerListOrigin =
  typeof DigitalCatalogControllerListOrigin[keyof typeof DigitalCatalogControllerListOrigin]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListOrigin = {
  platform: 'platform',
  additional: 'additional',
  manual: 'manual',
  marketplace: 'marketplace'
} as const

export type DigitalCatalogControllerListLicense =
  typeof DigitalCatalogControllerListLicense[keyof typeof DigitalCatalogControllerListLicense]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListLicense = {
  active: 'active',
  expiring_soon: 'expiring_soon',
  expired: 'expired'
} as const

export type DigitalCatalogControllerListAudiobook =
  typeof DigitalCatalogControllerListAudiobook[keyof typeof DigitalCatalogControllerListAudiobook]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListAudiobook = {
  all: 'all',
  audiobook_only: 'audiobook_only',
  text_only: 'text_only'
} as const

export type DigitalCatalogControllerReindexMarketplaceParams = {
  limit: number
}

export type DigitalCatalogControllerFiltersParams = {
  type: DigitalCatalogControllerFiltersType
  page?: number
  pageSize?: number
  search?: string
}

export type DigitalCatalogControllerFiltersType =
  typeof DigitalCatalogControllerFiltersType[keyof typeof DigitalCatalogControllerFiltersType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerFiltersType = {
  publishers: 'publishers',
  tags: 'tags',
  languages: 'languages'
} as const

export type DigitalCatalogControllerListAuthoritiesParams = {
  page?: number
  pageSize?: number
  search?: string
  type?: DigitalCatalogControllerListAuthoritiesType
  status?: DigitalCatalogControllerListAuthoritiesStatus
}

export type DigitalCatalogControllerListAuthoritiesType =
  typeof DigitalCatalogControllerListAuthoritiesType[keyof typeof DigitalCatalogControllerListAuthoritiesType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListAuthoritiesType = {
  person: 'person',
  organization: 'organization',
  place: 'place',
  uniform_title: 'uniform_title'
} as const

export type DigitalCatalogControllerListAuthoritiesStatus =
  typeof DigitalCatalogControllerListAuthoritiesStatus[keyof typeof DigitalCatalogControllerListAuthoritiesStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListAuthoritiesStatus = {
  active: 'active',
  pending_review: 'pending_review',
  inactive: 'inactive'
} as const

export type DigitalCatalogControllerListVocabularyTermsParams = {
  page?: number
  pageSize?: number
  search?: string
  taxonomy?: DigitalCatalogControllerListVocabularyTermsTaxonomy
  status?: DigitalCatalogControllerListVocabularyTermsStatus
}

export type DigitalCatalogControllerListVocabularyTermsTaxonomy =
  typeof DigitalCatalogControllerListVocabularyTermsTaxonomy[keyof typeof DigitalCatalogControllerListVocabularyTermsTaxonomy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListVocabularyTermsTaxonomy = {
  subject: 'subject',
  genre: 'genre',
  material_type: 'material_type',
  audience: 'audience',
  language: 'language'
} as const

export type DigitalCatalogControllerListVocabularyTermsStatus =
  typeof DigitalCatalogControllerListVocabularyTermsStatus[keyof typeof DigitalCatalogControllerListVocabularyTermsStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalCatalogControllerListVocabularyTermsStatus = {
  preferred: 'preferred',
  pending: 'pending'
} as const

export type DigitalCatalogControllerListVideosParams = {
  /**
   * Page number
   */
  page?: number
  /**
   * Page size
   */
  pageSize?: number
  /**
   * Search by title or author
   */
  search?: string
  /**
   * Filter by modality
   */
  modality?: string
  /**
   * Filter by origin
   */
  origin?: string
  /**
   * Filter by degree (EI, EF1, EF2, EM)
   */
  degree?: string
  /**
   * Filter by license status (active, expired)
   */
  license?: string
}

export type DigitalCatalogControllerListPodcastsParams = {
  /**
   * Page number
   */
  page?: number
  /**
   * Page size
   */
  pageSize?: number
  /**
   * Search by title or author
   */
  search?: string
  /**
   * Filter by modality
   */
  modality?: string
  /**
   * Filter by origin
   */
  origin?: string
  /**
   * Filter by degree (EI, EF1, EF2, EM)
   */
  degree?: string
  /**
   * Filter by license status (active, expired)
   */
  license?: string
}

export type CampanhaFluenciaControllerUploadDemoAudioBody = {
  file?: Blob
  referenceText?: string
  duration?: number
}

export type BookFileReplacementControllerSearchParams = {
  /**
   * ISBN or slug of the book
   */
  q: string
}

export type BooksControllerGetMostBorrowedParams = {
  limit: string
}

export type BooksControllerGetRecommendationsParams = {
  /**
   * Número de livros a retornar
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * Filter results to only books in the digital catalog (not exhausted)
   */
  digitalCatalogOnly?: boolean
}

export type ViewedBooksRelayControllerListParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  first?: number
  /**
   * @minimum 1
   * @maximum 100
   */
  last?: number
  after?: string
  before?: string
  order?: ViewedBooksRelayControllerListOrder
  /**
   * true | false | undefined (filtra por status de leitura)
   */
  isReading?: boolean
  contentFilter?: string
}

export type ViewedBooksRelayControllerListOrder =
  typeof ViewedBooksRelayControllerListOrder[keyof typeof ViewedBooksRelayControllerListOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ViewedBooksRelayControllerListOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type CardsControllerGetCardParams = {
  /**
   * ID of the class entity (returns readers from this class)
   */
  entityId?: number
  /**
   * ID of the school entity (returns readers from all classes in school)
   */
  parentId?: number
  /**
   * ID of a specific reader
   */
  readerId?: number
}

export type CardsControllerGetCardPdfParams = {
  /**
   * ID of the class entity (returns readers from this class)
   */
  entityId?: number
  /**
   * ID of the school entity (returns readers from all classes in school)
   */
  parentId?: number
  /**
   * ID of a specific reader
   */
  readerId?: number
}

export type ContinueReadingControllerListParams = {
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number
}

export type OlympicsShelvesControllerSearchParams = {
  q: string
}

export type ReaderOlympicsShelvesControllerListParams = {
  degree?: string
  rootId?: number
}

export type OlympicsReportControllerGetParams = {
  /**
   * Ano da olimpíada. Default = ano corrente.
   * @minimum 2026
   */
  year?: number
}

export type FluencyDemoControllerUploadAudioBodyLanguage =
  typeof FluencyDemoControllerUploadAudioBodyLanguage[keyof typeof FluencyDemoControllerUploadAudioBodyLanguage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FluencyDemoControllerUploadAudioBodyLanguage = {
  'pt-BR': 'pt-BR',
  'es-ES': 'es-ES',
  'es-UY': 'es-UY',
  'en-US': 'en-US',
  'fr-FR': 'fr-FR'
} as const

export type FluencyDemoControllerUploadAudioBody = {
  file?: Blob
  referenceText?: string
  duration?: number
  language?: FluencyDemoControllerUploadAudioBodyLanguage
}

export type ForestControllerGetFriendsParams = {
  /**
   * @minimum 1
   */
  page?: unknown
  /**
   * @minimum 1
   */
  count?: unknown
}

export type ForestControllerGetFriendsForAdminParams = {
  entityId: number
  /**
   * @minimum 1
   */
  page?: unknown
  /**
   * @minimum 1
   */
  count?: unknown
}

export type ForestControllerGetFriendTreeListingsParams = {
  friendReaderId: number
  /**
   * @minimum 1
   */
  count?: number
}

export type HybridOfferPublicControllerCatalogParams = {
  grade?: string
  search?: string
  featured?: boolean
  active?: boolean
  sortOrder?: HybridOfferPublicControllerCatalogSortOrder
  page?: number
  limit?: number
}

export type HybridOfferPublicControllerCatalogSortOrder =
  typeof HybridOfferPublicControllerCatalogSortOrder[keyof typeof HybridOfferPublicControllerCatalogSortOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HybridOfferPublicControllerCatalogSortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type HybridOfferSelectionControllerListParams = {
  entityId: number
  schoolId?: number
}

export type HybridOfferSelectionControllerHasSelectionParams = {
  entityId: number
}

export type HybridOfferSelectionControllerCatalogDetailParams = {
  by: string
}

export type HybridOfferSelectionControllerCoordinatorReviewParams = {
  entityId?: string
  year?: string
}

export type HybridOfferSelectionControllerCoordinatorApproveParams = {
  entityId?: string
}

export type HybridOfferSelectionControllerOrderConfigParams = {
  year?: string
}

export type HybridOfferCatalogPublicControllerListParams = {
  grade?: string
  search?: string
  featured?: boolean
  active?: boolean
  sortOrder?: HybridOfferCatalogPublicControllerListSortOrder
  page?: number
  limit?: number
}

export type HybridOfferCatalogPublicControllerListSortOrder =
  typeof HybridOfferCatalogPublicControllerListSortOrder[keyof typeof HybridOfferCatalogPublicControllerListSortOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HybridOfferCatalogPublicControllerListSortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type HybridOfferCatalogAdminControllerListParams = {
  grade?: string
  search?: string
  featured?: boolean
  active?: boolean
  sortOrder?: HybridOfferCatalogAdminControllerListSortOrder
  page?: number
  limit?: number
}

export type HybridOfferCatalogAdminControllerListSortOrder =
  typeof HybridOfferCatalogAdminControllerListSortOrder[keyof typeof HybridOfferCatalogAdminControllerListSortOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HybridOfferCatalogAdminControllerListSortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type HybridOfferCatalogAdminControllerSearchBooksParams = {
  q: string
  limit?: number
}

export type HybridOfferCatalogAdminControllerListLeadsParams = {
  limit: string
  lastKey: string
}

export type HybridOfferOrdersAdminControllerListParams = {
  schoolId?: number
  status?: HybridOfferOrdersAdminControllerListStatus
  page?: number
  limit?: number
}

export type HybridOfferOrdersAdminControllerListStatus =
  typeof HybridOfferOrdersAdminControllerListStatus[keyof typeof HybridOfferOrdersAdminControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HybridOfferOrdersAdminControllerListStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected'
} as const

export type HybridOfferOrdersAdminControllerSearchEntitiesParams = {
  q: string
}

export type HybridOfferOrderDeadlinesAdminControllerListParams = {
  year?: number
  entityId?: number
  active?: boolean
  page?: number
  limit?: number
}

export type OmsAssemblyControllerAssemblyParams = {
  schoolRef?: number
  schoolYear?: number
  status?: OmsAssemblyControllerAssemblyStatus
  assemblyState?: OmsAssemblyControllerAssemblyAssemblyState
  type?: OmsAssemblyControllerAssemblyType
  page?: number
  limit?: number
}

export type OmsAssemblyControllerAssemblyStatus =
  typeof OmsAssemblyControllerAssemblyStatus[keyof typeof OmsAssemblyControllerAssemblyStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsAssemblyControllerAssemblyStatus = {
  submitted: 'submitted'
} as const

export type OmsAssemblyControllerAssemblyAssemblyState =
  typeof OmsAssemblyControllerAssemblyAssemblyState[keyof typeof OmsAssemblyControllerAssemblyAssemblyState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsAssemblyControllerAssemblyAssemblyState = {
  queue: 'queue',
  in_assembly: 'in_assembly'
} as const

export type OmsAssemblyControllerAssemblyType =
  typeof OmsAssemblyControllerAssemblyType[keyof typeof OmsAssemblyControllerAssemblyType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsAssemblyControllerAssemblyType = {
  base: 'base',
  additional: 'additional',
  standalone: 'standalone'
} as const

export type OmsOrdersControllerListParams = {
  schoolRef?: number
  schoolYear?: number
  status?: OmsOrdersControllerListStatus
  assemblyState?: OmsOrdersControllerListAssemblyState
  type?: OmsOrdersControllerListType
  page?: number
  limit?: number
}

export type OmsOrdersControllerListStatus =
  typeof OmsOrdersControllerListStatus[keyof typeof OmsOrdersControllerListStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrdersControllerListStatus = {
  submitted: 'submitted'
} as const

export type OmsOrdersControllerListAssemblyState =
  typeof OmsOrdersControllerListAssemblyState[keyof typeof OmsOrdersControllerListAssemblyState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrdersControllerListAssemblyState = {
  queue: 'queue',
  in_assembly: 'in_assembly'
} as const

export type OmsOrdersControllerListType =
  typeof OmsOrdersControllerListType[keyof typeof OmsOrdersControllerListType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsOrdersControllerListType = {
  base: 'base',
  additional: 'additional',
  standalone: 'standalone'
} as const

export type OmsPurchasingControllerListPurchasesParams = {
  status?: OmsPurchasingControllerListPurchasesStatus
  page?: number
  limit?: number
}

export type OmsPurchasingControllerListPurchasesStatus =
  typeof OmsPurchasingControllerListPurchasesStatus[keyof typeof OmsPurchasingControllerListPurchasesStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsPurchasingControllerListPurchasesStatus = {
  pending: 'pending',
  in_transit: 'in_transit',
  conciliated: 'conciliated',
  cancelled: 'cancelled'
} as const

export type OmsPurchasingControllerStockParams = {
  search?: string
  onlyInStock?: boolean
}

export type OmsPurchasingControllerDemandParams = {
  schoolYear?: number
  publisher?: string
}

export type OmsPurchasingControllerStockMovementsParams = {
  /**
   * Cursor (id da última movimentação da página anterior)
   */
  after?: number
  limit?: number
}

export type OmsPurchasingControllerPreviewInvoiceBody = {
  file: Blob
}

export type OmsPurchasingControllerPreviewInvoiceMatchBody = {
  file: Blob
}

export type OmsPurchasingControllerConfirmInvoiceMatchBody = {
  file?: Blob
  purchaseId?: number
  invoiceNumber?: string
  supplier?: string
  matchedItems: string
  unmatchedItems: string
}

export type OmsPurchasingControllerReconcileInvoiceBody = {
  file?: Blob
  invoiceNumber?: string
  fileUrl?: string
  items: string[]
}

export type OmsContractsControllerListParams = {
  year?: number
  q?: string
}

export type OmsContractsControllerSelectionDetailParams = {
  year?: number
  q?: string
}

export type OmsContractsControllerGetAddressParams = {
  year?: number
  q?: string
}

export type OmsSkusControllerListParams = {
  grade?: string
  publisher?: string
  publisherGroup?: string
  search?: string
  type?: OmsSkusControllerListType
  stock?: OmsSkusControllerListStock
  incomplete?: boolean
  page?: number
  limit?: number
}

export type OmsSkusControllerListType =
  typeof OmsSkusControllerListType[keyof typeof OmsSkusControllerListType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsSkusControllerListType = {
  literary: 'literary',
  didactic: 'didactic',
  teacher_material: 'teacher_material',
  addon: 'addon'
} as const

export type OmsSkusControllerListStock =
  typeof OmsSkusControllerListStock[keyof typeof OmsSkusControllerListStock]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OmsSkusControllerListStock = {
  in_stock: 'in_stock',
  out_of_stock: 'out_of_stock'
} as const

export type OmsSkusControllerEditionsParams = {
  search: string
  limit: string
}

export type OmsPipelineControllerSchoolsParams = {
  year?: number
  q?: string
}

export type OmsPipelineControllerLeaderEventsParams = {
  since?: string
  limit?: number
}

export type ImageGenerationControllerGenerateBodyFormat =
  typeof ImageGenerationControllerGenerateBodyFormat[keyof typeof ImageGenerationControllerGenerateBodyFormat]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageGenerationControllerGenerateBodyFormat = {
  'instagram-post': 'instagram-post',
  'instagram-story': 'instagram-story',
  'whatsapp-card': 'whatsapp-card'
} as const

export type ImageGenerationControllerGenerateBody = {
  /** Image generation prompt */
  prompt: string
  format: ImageGenerationControllerGenerateBodyFormat
  /** Optional reference images (max 5, images only) */
  images?: Blob[]
}

export type WaTrackerControllerGetQrParams = {
  format: string
}

export type WaTrackerControllerListContactsParams = {
  limit: string
  offset: string
}

export type ClientHubControllerListClientsParams = {
  query?: string
  limit?: number
  offset?: number
}

export type ClientHubControllerListPortfolioParams = {
  /**
   * Filter by deal stage (Pipedrive)
   */
  dealStage?: string
  /**
   * Filter by deal status
   */
  dealStatus?: ClientHubControllerListPortfolioDealStatus
  /**
   * Only open deals when true
   */
  dealOpen?: ClientHubControllerListPortfolioDealOpen
  /**
   * Filter by payment status
   */
  paymentStatus?: string
  /**
   * Clients with no WhatsApp interaction for at least N days
   */
  inactiveWhatsappDays?: number
  /**
   * Deals without Pipedrive update for at least N days
   */
  staleDealDays?: number
  /**
   * Filter by closer name
   */
  closerName?: string
  limit?: number
  offset?: number
}

export type ClientHubControllerListPortfolioDealStatus =
  typeof ClientHubControllerListPortfolioDealStatus[keyof typeof ClientHubControllerListPortfolioDealStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientHubControllerListPortfolioDealStatus = {
  open: 'open',
  won: 'won',
  lost: 'lost'
} as const

export type ClientHubControllerListPortfolioDealOpen =
  typeof ClientHubControllerListPortfolioDealOpen[keyof typeof ClientHubControllerListPortfolioDealOpen]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientHubControllerListPortfolioDealOpen = {
  true: 'true',
  false: 'false'
} as const

export type ClientHubControllerListWaContactsParams = {
  limit?: number
  offset?: number
}

export type ClientHubControllerListElephanUsersParams = {
  search?: string
}

export type ClientHubControllerListPipedriveOrganizationsParams = {
  search?: string
}

export type ClientHubControllerListElephanDealsParams = {
  search?: string
  /**
   * ISO datetime. Default: últimos 7 dias
   */
  startDate?: string
  /**
   * ISO datetime. Default: agora
   */
  endDate?: string
}

export type ClientHubControllerSearchClientConversationsParams = {
  query: string
  source?: string
  limit?: number
}

export type ClientHubControllerListElephanTranscribesByDealParams = {
  /**
   * ISO datetime. Default: últimos 7 dias
   */
  startDate?: string
  /**
   * ISO datetime. Default: agora
   */
  endDate?: string
}

export type ClientHubControllerListForticsContactsParams = {
  name?: string
  email?: string
  /**
   * Filter by channel platform
   */
  platform?: string
  page?: number
}

export type ClientHubControllerSearchForticsContactsParams = {
  query: string
  page?: number
}

export type ClientHubControllerListOctadeskContactsParams = {
  /**
   * Search by name or email
   */
  search?: string
  page?: number
}

export type ClientHubControllerBackfillWhatsappClientIdParams = {
  limit: string
}

export type ClientHubControllerIndexWhatsappConversationsParams = {
  sinceDays: string
}

export type ClientHubControllerIndexElephanTranscribesParams = {
  maxBatches: string
}

export type ClientHubControllerBackfillElephanOrgIdsParams = {
  maxBatches: string
}

export type ClientHubControllerBackfillElephanClientIdParams = {
  limit: string
}

export type ClientHubEmailControllerOauthCallbackParams = {
  code: string
  state: string
}

export type ClientHubEmailControllerListContactsParams = {
  search: string
}

export type ClientHubEmailControllerBackfillClientIdPayloadParams = {
  limit: string
}

export type ClientHubEmailControllerIndexMessagesParams = {
  maxBatches: string
}

export type EntityManagementControllerListEntitiesParams = {
  /**
   * Parent entity ref (e.g. "123" for Árvore or "super:school:456" for Super). Omit for root entities.
   */
  parentId?: string
  /**
   * Search query (name, ID, CNPJ, identity_id)
   */
  q?: string
  type?: EntityManagementControllerListEntitiesType
  page?: number
  perPage?: number
  syncStatus?: EntityManagementControllerListEntitiesSyncStatus
  platform?: EntityManagementControllerListEntitiesPlatform
  /**
   * Filter by Árvore entity ID
   */
  arvoreId?: number
  /**
   * Filter by SuperAutor entity ID
   */
  superId?: number
  /**
   * Filter by SuperAutor project ID
   */
  projectId?: number
}

export type EntityManagementControllerListEntitiesType =
  typeof EntityManagementControllerListEntitiesType[keyof typeof EntityManagementControllerListEntitiesType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListEntitiesType = {
  trademark: 'trademark',
  network: 'network',
  school: 'school',
  class: 'class'
} as const

export type EntityManagementControllerListEntitiesSyncStatus =
  typeof EntityManagementControllerListEntitiesSyncStatus[keyof typeof EntityManagementControllerListEntitiesSyncStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListEntitiesSyncStatus = {
  synced: 'synced',
  synced_discarded: 'synced_discarded',
  arvore_only: 'arvore_only',
  superautor_only: 'superautor_only'
} as const

export type EntityManagementControllerListEntitiesPlatform =
  typeof EntityManagementControllerListEntitiesPlatform[keyof typeof EntityManagementControllerListEntitiesPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListEntitiesPlatform = {
  Leitura: 'Leitura',
  Escrita: 'Escrita'
} as const

export type EntityManagementControllerListChildrenParams = {
  /**
   * Parent entity ref (e.g. "123" for Árvore or "super:school:456" for Super)
   */
  parentId: string
  q?: string
  page?: number
  perPage?: number
  syncStatus?: EntityManagementControllerListChildrenSyncStatus
  platform?: EntityManagementControllerListChildrenPlatform
}

export type EntityManagementControllerListChildrenSyncStatus =
  typeof EntityManagementControllerListChildrenSyncStatus[keyof typeof EntityManagementControllerListChildrenSyncStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListChildrenSyncStatus = {
  synced: 'synced',
  synced_discarded: 'synced_discarded',
  arvore_only: 'arvore_only',
  superautor_only: 'superautor_only'
} as const

export type EntityManagementControllerListChildrenPlatform =
  typeof EntityManagementControllerListChildrenPlatform[keyof typeof EntityManagementControllerListChildrenPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListChildrenPlatform = {
  Leitura: 'Leitura',
  Escrita: 'Escrita'
} as const

export type EntityManagementControllerListUsersParams = {
  /**
   * Entity ref (e.g. "123" for Árvore or "super:school:456" for Super)
   */
  entityId: string
  q?: string
  role?: EntityManagementControllerListUsersRole
  syncStatus?: EntityManagementControllerListUsersSyncStatus
  page?: number
  perPage?: number
}

export type EntityManagementControllerListUsersRole =
  typeof EntityManagementControllerListUsersRole[keyof typeof EntityManagementControllerListUsersRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListUsersRole = {
  admin: 'admin',
  teacher: 'teacher',
  student: 'student'
} as const

export type EntityManagementControllerListUsersSyncStatus =
  typeof EntityManagementControllerListUsersSyncStatus[keyof typeof EntityManagementControllerListUsersSyncStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityManagementControllerListUsersSyncStatus = {
  synced: 'synced',
  synced_discarded: 'synced_discarded',
  arvore_only: 'arvore_only',
  superautor_only: 'superautor_only'
} as const

export type EntityManagementControllerListEntityModulesParams = {
  /**
   * Entity ref (e.g. "123" for Árvore or "super:school:456" for Super)
   */
  entityId: string
}

export type EntityManagementControllerExportCardsParams = {
  profileType: string
}

export type EntityManagementControllerSearchUsersParams = {
  q: string
  page?: number
  perPage?: number
  role?: string
  syncStatus?: string
}

export type EntityManagementControllerRemoveUserProfileParams = {
  entityId: string
}

export type EntityManagementControllerListContractsParams = {
  clientId: number
}

export type ImportationsControllerListParams = {
  page?: number
  limit?: number
  status?: string
}

export type ImportationsControllerGetLinesParams = {
  page?: number
  limit?: number
  status?: string
}

export type JourneysControllerGetClassJourneyReportParams = {
  classId: number
  page?: number
  pageSize?: number
  search?: string
}

export type JourneysManagementControllerSearchBooksParams = {
  q: string
}

export type LeagueControllerGetLeagueReportParams = {
  /**
   * Start date
   */
  startDate: string
  /**
   * End date
   */
  endDate: string
  /**
   * Holding ID
   */
  holdingId?: number
  /**
   * Trademark ID
   */
  trademarkId?: number
  /**
   * Network ID
   */
  networkId?: number
  /**
   * School ID
   */
  schoolId?: number
  /**
   * Class ID
   */
  classId?: number
  /**
   * Year for filtering (e.g., 2024)
   */
  year: number
  /**
   * Month for filtering (1-12)
   */
  month: number
}

export type LeagueManagementControllerGetRankingV1Params = {
  q?: string
  degreeBucket?: LeagueManagementControllerGetRankingV1DegreeBucket
  rootId?: number
  schoolId?: number
  classId?: number
  suspended?: boolean
  page?: number
  /**
   * @maximum 200
   */
  perPage?: number
  sortBy?: LeagueManagementControllerGetRankingV1SortBy
  sortDir?: LeagueManagementControllerGetRankingV1SortDir
}

export type LeagueManagementControllerGetRankingV1DegreeBucket =
  typeof LeagueManagementControllerGetRankingV1DegreeBucket[keyof typeof LeagueManagementControllerGetRankingV1DegreeBucket]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeagueManagementControllerGetRankingV1DegreeBucket = {
  'kids-5': 'kids-5',
  '6-9': '6-9',
  M: 'M',
  F: 'F'
} as const

export type LeagueManagementControllerGetRankingV1SortBy =
  typeof LeagueManagementControllerGetRankingV1SortBy[keyof typeof LeagueManagementControllerGetRankingV1SortBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeagueManagementControllerGetRankingV1SortBy = {
  rank: 'rank',
  points: 'points',
  name: 'name'
} as const

export type LeagueManagementControllerGetRankingV1SortDir =
  typeof LeagueManagementControllerGetRankingV1SortDir[keyof typeof LeagueManagementControllerGetRankingV1SortDir]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeagueManagementControllerGetRankingV1SortDir = {
  asc: 'asc',
  desc: 'desc'
} as const

export type LeagueManagementControllerGetFraudSuspectsV1Params = {
  page?: number
  /**
   * @maximum 200
   */
  perPage?: number
  q?: string
}

export type SearchConfigControllerFacetOptionsParams = {
  facet_key?: string
  search?: string
}

export type SharedPagesControllerListV1200 = { [key: string]: unknown }

export type SharedPagesControllerCreateV1Body = {
  file: Blob
  title: string
  description?: string
}

export type SharedPagesControllerCreateV1201 = { [key: string]: unknown }

export type SharedPagesControllerCreateUploadUrlV1201 = {
  [key: string]: unknown
}

export type SharedPagesControllerConfirmCreateV1201 = { [key: string]: unknown }

export type SharedPagesControllerUpdateUploadUrlV1201 = {
  [key: string]: unknown
}

export type SharedPagesControllerConfirmUpdateV1200 = { [key: string]: unknown }

export type SharedPagesControllerGetMetadataV1200 = { [key: string]: unknown }

export type SharedPagesControllerUpdateV1Body = {
  file?: Blob
  title?: string
  description?: string
}

export type SharedPagesControllerUpdateV1200 = { [key: string]: unknown }

export type SharedPagesControllerCreateGrantV1201 = { [key: string]: unknown }

export type SharedPagesControllerListGrantsV1200Item = {
  [key: string]: unknown
}

export type PublicSharedPagesControllerPublicInfoV1200 = {
  [key: string]: unknown
}

export type PublicSharedPagesControllerSendCodeV1200 = {
  [key: string]: unknown
}

export type PublicSharedPagesControllerVerifyV1200 = { [key: string]: unknown }

export type StoryTreeControllerGetRecommendationsParams = {
  /**
   * When true, only returns books at or below the student lexile level. Falls back to the default behavior when the student has no lexile score yet.
   */
  withinLexileLevel?: boolean
}

export type UserToAdminControllerSearchParams = {
  /**
   * Access token ou e-mail do usuário
   */
  query: string
}

export type ViewedBooksControllerListParams = {
  page?: number
  pageSize?: number
  /**
   * true = em leitura, false = lidos
   */
  isReading?: boolean
  order?: ViewedBooksControllerListOrder
  contentFilter?: ViewedBooksControllerListContentFilter
}

export type ViewedBooksControllerListOrder =
  typeof ViewedBooksControllerListOrder[keyof typeof ViewedBooksControllerListOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ViewedBooksControllerListOrder = {
  recent: 'recent',
  oldest: 'oldest'
} as const

export type ViewedBooksControllerListContentFilter =
  typeof ViewedBooksControllerListContentFilter[keyof typeof ViewedBooksControllerListContentFilter]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ViewedBooksControllerListContentFilter = {
  ebook: 'ebook',
  audiobook: 'audiobook'
} as const

export type TeacherBooksControllerGetBooksParams = {
  /**
   * Page number
   * @minimum 1
   */
  page?: number
  /**
   * Items per page
   * @minimum 1
   */
  perPage?: number
  /**
   * Filter by book degree
   */
  degree?: TeacherBooksControllerGetBooksDegree
  /**
   * Filter by book status
   */
  status?: TeacherBooksControllerGetBooksStatus
}

export type TeacherBooksControllerGetBooksDegree =
  typeof TeacherBooksControllerGetBooksDegree[keyof typeof TeacherBooksControllerGetBooksDegree]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherBooksControllerGetBooksDegree = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  E: 'E',
  EI: 'EI',
  'EM+': 'EM+',
  F: 'F',
  M: 'M',
  S: 'S'
} as const

export type TeacherBooksControllerGetBooksStatus =
  typeof TeacherBooksControllerGetBooksStatus[keyof typeof TeacherBooksControllerGetBooksStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherBooksControllerGetBooksStatus = {
  enabled: 'enabled',
  disabled: 'disabled'
} as const

export type PiMemoryControllerCandidatesParams = {
  limit: string
}

export type WidgetControllerGetActionsParams = {
  language?: WidgetControllerGetActionsLanguage
}

export type WidgetControllerGetActionsLanguage =
  typeof WidgetControllerGetActionsLanguage[keyof typeof WidgetControllerGetActionsLanguage]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WidgetControllerGetActionsLanguage = {
  pt_BR: 'pt_BR',
  en_US: 'en_US',
  en_GB: 'en_GB',
  es_ES: 'es_ES'
} as const

export type PressReaderControllerActivateParams = {
  /**
   * Custom redirect URL after PressReader activation
   */
  redirectUrl?: string
}

export type PressReaderControllerListPublicationsParams = {
  /**
   * Maximum number of publications to return
   * @maximum 100
   */
  limit?: number
  /**
   * Order by field
   */
  orderBy?: string
  /**
   * Filter by property existence
   */
  has?: string
  /**
   * Filter by publication CIDs (comma-separated)
   */
  cid?: string[]
}

export type PersonalAssetsControllerRemoveBackgroundHandlerBody = {
  image: Blob
}

export type PersonalAssetsControllerSubmitAssetRequestHandlerBody = {
  photo: Blob
  signature: Blob
  name: string
  role: string
  area: string
}

export type PersonalAssetsControllerListAssetRequestsHandlerParams = {
  page?: number
  limit?: number
  status?: PersonalAssetsControllerListAssetRequestsHandlerStatus
}

export type PersonalAssetsControllerListAssetRequestsHandlerStatus =
  typeof PersonalAssetsControllerListAssetRequestsHandlerStatus[keyof typeof PersonalAssetsControllerListAssetRequestsHandlerStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalAssetsControllerListAssetRequestsHandlerStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected'
} as const

export type PersonalAssetsControllerBatchSubmitHandlerBody = {
  /** JSON array of {name, role, area, email} objects */
  items: string
}

export type LaunchAnnouncerControllerListHandlerParams = {
  page?: number
  limit?: number
  status?: LaunchAnnouncerControllerListHandlerStatus
}

export type LaunchAnnouncerControllerListHandlerStatus =
  typeof LaunchAnnouncerControllerListHandlerStatus[keyof typeof LaunchAnnouncerControllerListHandlerStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LaunchAnnouncerControllerListHandlerStatus = {
  draft: 'draft',
  published: 'published'
} as const

export type LaunchAnnouncerControllerUploadHandlerBody = {
  file: Blob
}

export type LtiLoginControllerLoginGetParams = {
  /**
   * Issuer URL of the LMS Platform
   */
  iss: string
  /**
   * OIDC login_hint provided by the LMS
   */
  login_hint: string
  /**
   * Target link URI from the LMS launch link
   */
  target_link_uri: string
  /**
   * Optional message hint passed by the LMS
   */
  lti_message_hint?: string
  /**
   * OIDC client_id (required when multiple deployments share an issuer)
   */
  client_id?: string
  /**
   * Optional deployment ID
   */
  lti_deployment_id?: string
}

export type SupportControllerUserLookupParams = {
  /**
   * Email do usuário (busca exata)
   */
  email?: string
  /**
   * Token de acesso (busca exata)
   */
  token?: string
  /**
   * Nome do usuário (busca aproximada)
   */
  nome?: string
  /**
   * Nome da escola (busca aproximada)
   */
  escola?: string
  /**
   * Nome da turma (busca aproximada)
   */
  turma?: string
  /**
   * ID da rede/root para filtrar entidades dentro da mesma rede
   */
  root_id?: number
}

export type SupportControllerProfileStatusParams = {
  /**
   * ID do usuário
   */
  user_id: number
}

export type SupportControllerDetectIntegrationParams = {
  /**
   * ID do usuário
   */
  user_id?: number
  /**
   * ID da entidade
   */
  entity_id?: number
}

export type SupportControllerGetCredentialsParams = {
  /**
   * ID do usuário
   */
  user_id: number
}

/**
 * @summary Health check endpoint
 */
export type appControllerHealthCheckResponse200 = {
  data: HealthCheckResponseDto
  status: 200
}

export type appControllerHealthCheckResponseSuccess =
  appControllerHealthCheckResponse200 & {
    headers: Headers
  }
export type appControllerHealthCheckResponse =
  appControllerHealthCheckResponseSuccess

export const getAppControllerHealthCheckUrl = () => {
  return `/api-arvore`
}

export const appControllerHealthCheck = async (
  options?: RequestInit
): Promise<appControllerHealthCheckResponse> => {
  return customInstance<appControllerHealthCheckResponse>(
    getAppControllerHealthCheckUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the authenticated user profile (name, social name, email, cpf, birth date), whether token login is allowed for the user root, and the access token. socialName is always null for now (no social_name column in the users table yet).
 * @summary Get the current user own profile
 */
export type accountControllerGetProfileResponse200 = {
  data: ProfileResponseDto
  status: 200
}

export type accountControllerGetProfileResponseSuccess =
  accountControllerGetProfileResponse200 & {
    headers: Headers
  }
export type accountControllerGetProfileResponse =
  accountControllerGetProfileResponseSuccess

export const getAccountControllerGetProfileUrl = () => {
  return `/api-arvore/account/me`
}

export const accountControllerGetProfile = async (
  options?: RequestInit
): Promise<accountControllerGetProfileResponse> => {
  return customInstance<accountControllerGetProfileResponse>(
    getAccountControllerGetProfileUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Updates editable registration fields for the authenticated user. CPF and birth date are locked and cannot be changed here. socialName is accepted but not persisted yet (no column).
 * @summary Update the current user own profile (self-service)
 */
export type accountControllerUpdateProfileResponse200 = {
  data: UpdateProfileResponseDto
  status: 200
}

export type accountControllerUpdateProfileResponseSuccess =
  accountControllerUpdateProfileResponse200 & {
    headers: Headers
  }
export type accountControllerUpdateProfileResponse =
  accountControllerUpdateProfileResponseSuccess

export const getAccountControllerUpdateProfileUrl = () => {
  return `/api-arvore/account/me`
}

export const accountControllerUpdateProfile = async (
  updateProfileDto: UpdateProfileDto,
  options?: RequestInit
): Promise<accountControllerUpdateProfileResponse> => {
  return customInstance<accountControllerUpdateProfileResponse>(
    getAccountControllerUpdateProfileUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateProfileDto)
    }
  )
}

/**
 * Verifies the current password and, when valid, sets the new one. The new password is hashed and propagated to the linked identity and Super accounts (when present), mirroring the password reset flow.
 * @summary Change the current user password (self-service)
 */
export type accountControllerChangePasswordResponse200 = {
  data: ChangePasswordResponseDto
  status: 200
}

export type accountControllerChangePasswordResponseSuccess =
  accountControllerChangePasswordResponse200 & {
    headers: Headers
  }
export type accountControllerChangePasswordResponse =
  accountControllerChangePasswordResponseSuccess

export const getAccountControllerChangePasswordUrl = () => {
  return `/api-arvore/account/me/change-password`
}

export const accountControllerChangePassword = async (
  changePasswordDto: ChangePasswordDto,
  options?: RequestInit
): Promise<accountControllerChangePasswordResponse> => {
  return customInstance<accountControllerChangePasswordResponse>(
    getAccountControllerChangePasswordUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changePasswordDto)
    }
  )
}

/**
 * Returns the authenticated user job positions and areas by name. Roles and permissions are exposed via GET /users/me (role, role_permissions), so they are not duplicated here.
 * @summary Get the current user job positions and areas
 */
export type accountControllerGetJobDescriptionResponse200 = {
  data: JobDescriptionResponseDto
  status: 200
}

export type accountControllerGetJobDescriptionResponseSuccess =
  accountControllerGetJobDescriptionResponse200 & {
    headers: Headers
  }
export type accountControllerGetJobDescriptionResponse =
  accountControllerGetJobDescriptionResponseSuccess

export const getAccountControllerGetJobDescriptionUrl = () => {
  return `/api-arvore/account/me/job-description`
}

export const accountControllerGetJobDescription = async (
  options?: RequestInit
): Promise<accountControllerGetJobDescriptionResponse> => {
  return customInstance<accountControllerGetJobDescriptionResponse>(
    getAccountControllerGetJobDescriptionUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Replaces the authenticated user job positions and areas with the provided names.
 * @summary Qualify (replace) the current user job positions and areas
 */
export type accountControllerQualifyJobDescriptionResponse200 = {
  data: JobDescriptionResponseDto
  status: 200
}

export type accountControllerQualifyJobDescriptionResponseSuccess =
  accountControllerQualifyJobDescriptionResponse200 & {
    headers: Headers
  }
export type accountControllerQualifyJobDescriptionResponse =
  accountControllerQualifyJobDescriptionResponseSuccess

export const getAccountControllerQualifyJobDescriptionUrl = () => {
  return `/api-arvore/account/me/job-description`
}

export const accountControllerQualifyJobDescription = async (
  qualifyJobDescriptionDto: QualifyJobDescriptionDto,
  options?: RequestInit
): Promise<accountControllerQualifyJobDescriptionResponse> => {
  return customInstance<accountControllerQualifyJobDescriptionResponse>(
    getAccountControllerQualifyJobDescriptionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(qualifyJobDescriptionDto)
    }
  )
}

/**
 * Returns the weekly reading report preference (defaults to false when unset).
 * @summary Get the current user notification preferences
 */
export type accountControllerGetNotificationPreferencesResponse200 = {
  data: NotificationPreferencesResponseDto
  status: 200
}

export type accountControllerGetNotificationPreferencesResponseSuccess =
  accountControllerGetNotificationPreferencesResponse200 & {
    headers: Headers
  }
export type accountControllerGetNotificationPreferencesResponse =
  accountControllerGetNotificationPreferencesResponseSuccess

export const getAccountControllerGetNotificationPreferencesUrl = () => {
  return `/api-arvore/account/me/notification-preferences`
}

export const accountControllerGetNotificationPreferences = async (
  options?: RequestInit
): Promise<accountControllerGetNotificationPreferencesResponse> => {
  return customInstance<accountControllerGetNotificationPreferencesResponse>(
    getAccountControllerGetNotificationPreferencesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Inverts the given notification preference (upserting the row when missing) and returns the new state.
 * @summary Toggle a notification preference
 */
export type accountControllerToggleNotificationPreferenceResponse200 = {
  data: NotificationPreferencesResponseDto
  status: 200
}

export type accountControllerToggleNotificationPreferenceResponseSuccess =
  accountControllerToggleNotificationPreferenceResponse200 & {
    headers: Headers
  }
export type accountControllerToggleNotificationPreferenceResponse =
  accountControllerToggleNotificationPreferenceResponseSuccess

export const getAccountControllerToggleNotificationPreferenceUrl = () => {
  return `/api-arvore/account/me/notification-preferences/toggle`
}

export const accountControllerToggleNotificationPreference = async (
  toggleNotificationPreferenceDto: ToggleNotificationPreferenceDto,
  options?: RequestInit
): Promise<accountControllerToggleNotificationPreferenceResponse> => {
  return customInstance<accountControllerToggleNotificationPreferenceResponse>(
    getAccountControllerToggleNotificationPreferenceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleNotificationPreferenceDto)
    }
  )
}

export type elasticsearchAdminControllerReindexEntitiesV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexEntitiesV1ResponseSuccess =
  elasticsearchAdminControllerReindexEntitiesV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexEntitiesV1Response =
  elasticsearchAdminControllerReindexEntitiesV1ResponseSuccess

export const getElasticsearchAdminControllerReindexEntitiesV1Url = (
  params: ElasticsearchAdminControllerReindexEntitiesV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-entities?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-entities`
}

export const elasticsearchAdminControllerReindexEntitiesV1 = async (
  params: ElasticsearchAdminControllerReindexEntitiesV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexEntitiesV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexEntitiesV1Response>(
    getElasticsearchAdminControllerReindexEntitiesV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexUsersV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexUsersV1ResponseSuccess =
  elasticsearchAdminControllerReindexUsersV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexUsersV1Response =
  elasticsearchAdminControllerReindexUsersV1ResponseSuccess

export const getElasticsearchAdminControllerReindexUsersV1Url = (
  params: ElasticsearchAdminControllerReindexUsersV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-users?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-users`
}

export const elasticsearchAdminControllerReindexUsersV1 = async (
  params: ElasticsearchAdminControllerReindexUsersV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexUsersV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexUsersV1Response>(
    getElasticsearchAdminControllerReindexUsersV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexVideosV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexVideosV1ResponseSuccess =
  elasticsearchAdminControllerReindexVideosV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexVideosV1Response =
  elasticsearchAdminControllerReindexVideosV1ResponseSuccess

export const getElasticsearchAdminControllerReindexVideosV1Url = (
  params: ElasticsearchAdminControllerReindexVideosV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-videos?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-videos`
}

export const elasticsearchAdminControllerReindexVideosV1 = async (
  params: ElasticsearchAdminControllerReindexVideosV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexVideosV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexVideosV1Response>(
    getElasticsearchAdminControllerReindexVideosV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexPodcastShowsV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexPodcastShowsV1ResponseSuccess =
  elasticsearchAdminControllerReindexPodcastShowsV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexPodcastShowsV1Response =
  elasticsearchAdminControllerReindexPodcastShowsV1ResponseSuccess

export const getElasticsearchAdminControllerReindexPodcastShowsV1Url = (
  params: ElasticsearchAdminControllerReindexPodcastShowsV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-podcast-shows?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-podcast-shows`
}

export const elasticsearchAdminControllerReindexPodcastShowsV1 = async (
  params: ElasticsearchAdminControllerReindexPodcastShowsV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexPodcastShowsV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexPodcastShowsV1Response>(
    getElasticsearchAdminControllerReindexPodcastShowsV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexArvoreUsersV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexArvoreUsersV1ResponseSuccess =
  elasticsearchAdminControllerReindexArvoreUsersV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexArvoreUsersV1Response =
  elasticsearchAdminControllerReindexArvoreUsersV1ResponseSuccess

export const getElasticsearchAdminControllerReindexArvoreUsersV1Url = (
  params: ElasticsearchAdminControllerReindexArvoreUsersV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-arvore-users?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-arvore-users`
}

export const elasticsearchAdminControllerReindexArvoreUsersV1 = async (
  params: ElasticsearchAdminControllerReindexArvoreUsersV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexArvoreUsersV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexArvoreUsersV1Response>(
    getElasticsearchAdminControllerReindexArvoreUsersV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexArvoreActivitiesV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexArvoreActivitiesV1ResponseSuccess =
  elasticsearchAdminControllerReindexArvoreActivitiesV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexArvoreActivitiesV1Response =
  elasticsearchAdminControllerReindexArvoreActivitiesV1ResponseSuccess

export const getElasticsearchAdminControllerReindexArvoreActivitiesV1Url = (
  params: ElasticsearchAdminControllerReindexArvoreActivitiesV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-arvore-activities?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-arvore-activities`
}

export const elasticsearchAdminControllerReindexArvoreActivitiesV1 = async (
  params: ElasticsearchAdminControllerReindexArvoreActivitiesV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexArvoreActivitiesV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexArvoreActivitiesV1Response>(
    getElasticsearchAdminControllerReindexArvoreActivitiesV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerReindexArvoreActivitiesSyncV1Response201 =
  {
    data: void
    status: 201
  }

export type elasticsearchAdminControllerReindexArvoreActivitiesSyncV1ResponseSuccess =
  elasticsearchAdminControllerReindexArvoreActivitiesSyncV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexArvoreActivitiesSyncV1Response =
  elasticsearchAdminControllerReindexArvoreActivitiesSyncV1ResponseSuccess

export const getElasticsearchAdminControllerReindexArvoreActivitiesSyncV1Url = (
  params: ElasticsearchAdminControllerReindexArvoreActivitiesSyncV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-arvore-activities-sync?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-arvore-activities-sync`
}

export const elasticsearchAdminControllerReindexArvoreActivitiesSyncV1 = async (
  params: ElasticsearchAdminControllerReindexArvoreActivitiesSyncV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexArvoreActivitiesSyncV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexArvoreActivitiesSyncV1Response>(
    getElasticsearchAdminControllerReindexArvoreActivitiesSyncV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Response200 =
  {
    data: void
    status: 200
  }

export type elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1ResponseSuccess =
  elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Response200 & {
    headers: Headers
  }
export type elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Response =
  elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1ResponseSuccess

export const getElasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Url =
  () => {
    return `/api-arvore/v1/admin/elasticsearch/reindex-arvore-activities/current`
  }

export const elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1 =
  async (
    options?: RequestInit
  ): Promise<elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Response> => {
    return customInstance<elasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Response>(
      getElasticsearchAdminControllerGetCurrentArvoreActivitiesReindexV1Url(),
      {
        ...options,
        method: 'GET'
      }
    )
  }

export type elasticsearchAdminControllerReindexArvoreUsersSyncV1Response201 = {
  data: void
  status: 201
}

export type elasticsearchAdminControllerReindexArvoreUsersSyncV1ResponseSuccess =
  elasticsearchAdminControllerReindexArvoreUsersSyncV1Response201 & {
    headers: Headers
  }
export type elasticsearchAdminControllerReindexArvoreUsersSyncV1Response =
  elasticsearchAdminControllerReindexArvoreUsersSyncV1ResponseSuccess

export const getElasticsearchAdminControllerReindexArvoreUsersSyncV1Url = (
  params: ElasticsearchAdminControllerReindexArvoreUsersSyncV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/admin/elasticsearch/reindex-arvore-users-sync?${stringifiedParams}`
    : `/api-arvore/v1/admin/elasticsearch/reindex-arvore-users-sync`
}

export const elasticsearchAdminControllerReindexArvoreUsersSyncV1 = async (
  params: ElasticsearchAdminControllerReindexArvoreUsersSyncV1Params,
  options?: RequestInit
): Promise<elasticsearchAdminControllerReindexArvoreUsersSyncV1Response> => {
  return customInstance<elasticsearchAdminControllerReindexArvoreUsersSyncV1Response>(
    getElasticsearchAdminControllerReindexArvoreUsersSyncV1Url(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Response200 =
  {
    data: void
    status: 200
  }

export type elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1ResponseSuccess =
  elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Response200 & {
    headers: Headers
  }
export type elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Response =
  elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1ResponseSuccess

export const getElasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Url =
  () => {
    return `/api-arvore/v1/admin/elasticsearch/reindex-arvore-users/current`
  }

export const elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1 =
  async (
    options?: RequestInit
  ): Promise<elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Response> => {
    return customInstance<elasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Response>(
      getElasticsearchAdminControllerGetCurrentArvoreUsersReindexV1Url(),
      {
        ...options,
        method: 'GET'
      }
    )
  }

/**
 * @summary OpenID Connect Discovery
 */
export type openIdControllerGetOpenIdConfigurationResponse200 = {
  data: void
  status: 200
}

export type openIdControllerGetOpenIdConfigurationResponseSuccess =
  openIdControllerGetOpenIdConfigurationResponse200 & {
    headers: Headers
  }
export type openIdControllerGetOpenIdConfigurationResponse =
  openIdControllerGetOpenIdConfigurationResponseSuccess

export const getOpenIdControllerGetOpenIdConfigurationUrl = () => {
  return `/.well-known/openid-configuration`
}

export const openIdControllerGetOpenIdConfiguration = async (
  options?: RequestInit
): Promise<openIdControllerGetOpenIdConfigurationResponse> => {
  return customInstance<openIdControllerGetOpenIdConfigurationResponse>(
    getOpenIdControllerGetOpenIdConfigurationUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary JSON Web Key Set
 */
export type oauth2ControllerGetJwksResponse200 = {
  data: void
  status: 200
}

export type oauth2ControllerGetJwksResponseSuccess =
  oauth2ControllerGetJwksResponse200 & {
    headers: Headers
  }
export type oauth2ControllerGetJwksResponse =
  oauth2ControllerGetJwksResponseSuccess

export const getOauth2ControllerGetJwksUrl = () => {
  return `/api-arvore/oauth2/jwks`
}

export const oauth2ControllerGetJwks = async (
  options?: RequestInit
): Promise<oauth2ControllerGetJwksResponse> => {
  return customInstance<oauth2ControllerGetJwksResponse>(
    getOauth2ControllerGetJwksUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Authorization endpoint
 */
export type oauth2ControllerAuthorizeResponse302 = {
  data: void
  status: 302
}
export type oauth2ControllerAuthorizeResponseError =
  oauth2ControllerAuthorizeResponse302 & {
    headers: Headers
  }

export type oauth2ControllerAuthorizeResponse =
  oauth2ControllerAuthorizeResponseError

export const getOauth2ControllerAuthorizeUrl = (
  params: Oauth2ControllerAuthorizeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/oauth2/authorize?${stringifiedParams}`
    : `/api-arvore/oauth2/authorize`
}

export const oauth2ControllerAuthorize = async (
  params: Oauth2ControllerAuthorizeParams,
  options?: RequestInit
): Promise<oauth2ControllerAuthorizeResponse> => {
  return customInstance<oauth2ControllerAuthorizeResponse>(
    getOauth2ControllerAuthorizeUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Token endpoint
 */
export type oauth2ControllerTokenResponse200 = {
  data: TokenResponseDto
  status: 200
}

export type oauth2ControllerTokenResponseSuccess =
  oauth2ControllerTokenResponse200 & {
    headers: Headers
  }
export type oauth2ControllerTokenResponse = oauth2ControllerTokenResponseSuccess

export const getOauth2ControllerTokenUrl = () => {
  return `/api-arvore/oauth2/token`
}

export const oauth2ControllerToken = async (
  tokenBodyDto: TokenBodyDto,
  options?: RequestInit
): Promise<oauth2ControllerTokenResponse> => {
  return customInstance<oauth2ControllerTokenResponse>(
    getOauth2ControllerTokenUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(tokenBodyDto)
    }
  )
}

/**
 * @summary Exchange an identity token for an Árvore legacy token (RFC 8693)
 */
export type oauth2ControllerExchangeTokenResponse200 = {
  data: ExchangeTokenResponseDto
  status: 200
}

export type oauth2ControllerExchangeTokenResponse401 = {
  data: void
  status: 401
}

export type oauth2ControllerExchangeTokenResponseSuccess =
  oauth2ControllerExchangeTokenResponse200 & {
    headers: Headers
  }
export type oauth2ControllerExchangeTokenResponseError =
  oauth2ControllerExchangeTokenResponse401 & {
    headers: Headers
  }

export type oauth2ControllerExchangeTokenResponse =
  | oauth2ControllerExchangeTokenResponseSuccess
  | oauth2ControllerExchangeTokenResponseError

export const getOauth2ControllerExchangeTokenUrl = () => {
  return `/api-arvore/oauth2/token/exchange`
}

export const oauth2ControllerExchangeToken = async (
  exchangeTokenBodyDto: ExchangeTokenBodyDto,
  options?: RequestInit
): Promise<oauth2ControllerExchangeTokenResponse> => {
  return customInstance<oauth2ControllerExchangeTokenResponse>(
    getOauth2ControllerExchangeTokenUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(exchangeTokenBodyDto)
    }
  )
}

/**
 * Routes authentication to SuperAutor or Árvore based on clientId. Syncs user data bidirectionally.
 * @summary Login with email/phone/username and password
 */
export type authControllerLoginResponse200 = {
  data: LoginResponseDto
  status: 200
}

export type authControllerLoginResponse302 = {
  data: void
  status: 302
}

export type authControllerLoginResponse401 = {
  data: void
  status: 401
}

export type authControllerLoginResponseSuccess =
  authControllerLoginResponse200 & {
    headers: Headers
  }
export type authControllerLoginResponseError = (
  | authControllerLoginResponse302
  | authControllerLoginResponse401
) & {
  headers: Headers
}

export type authControllerLoginResponse =
  | authControllerLoginResponseSuccess
  | authControllerLoginResponseError

export const getAuthControllerLoginUrl = () => {
  return `/api-arvore/auth/login`
}

export const authControllerLogin = async (
  loginBodyDto: LoginBodyDto,
  options?: RequestInit
): Promise<authControllerLoginResponse> => {
  return customInstance<authControllerLoginResponse>(
    getAuthControllerLoginUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(loginBodyDto)
    }
  )
}

/**
 * @summary Logout via redirect - clears session and redirects
 */
export type authControllerLogoutRedirectResponse302 = {
  data: void
  status: 302
}
export type authControllerLogoutRedirectResponseError =
  authControllerLogoutRedirectResponse302 & {
    headers: Headers
  }

export type authControllerLogoutRedirectResponse =
  authControllerLogoutRedirectResponseError

export const getAuthControllerLogoutRedirectUrl = () => {
  return `/api-arvore/auth/logout`
}

export const authControllerLogoutRedirect = async (
  options?: RequestInit
): Promise<authControllerLogoutRedirectResponse> => {
  return customInstance<authControllerLogoutRedirectResponse>(
    getAuthControllerLogoutRedirectUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check current session status
 */
export type authControllerGetSessionResponse200 = {
  data: SessionResponseDto
  status: 200
}

export type authControllerGetSessionResponseSuccess =
  authControllerGetSessionResponse200 & {
    headers: Headers
  }
export type authControllerGetSessionResponse =
  authControllerGetSessionResponseSuccess

export const getAuthControllerGetSessionUrl = () => {
  return `/api-arvore/auth/session`
}

export const authControllerGetSession = async (
  options?: RequestInit
): Promise<authControllerGetSessionResponse> => {
  return customInstance<authControllerGetSessionResponse>(
    getAuthControllerGetSessionUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Supports Árvore access tokens and SuperAutor super_codigo for student login.
 * @summary Login with access token or super_codigo (passwordless)
 */
export type authControllerLoginWithTokenResponse200 = {
  data: LoginResponseDto
  status: 200
}

export type authControllerLoginWithTokenResponse401 = {
  data: void
  status: 401
}

export type authControllerLoginWithTokenResponseSuccess =
  authControllerLoginWithTokenResponse200 & {
    headers: Headers
  }
export type authControllerLoginWithTokenResponseError =
  authControllerLoginWithTokenResponse401 & {
    headers: Headers
  }

export type authControllerLoginWithTokenResponse =
  | authControllerLoginWithTokenResponseSuccess
  | authControllerLoginWithTokenResponseError

export const getAuthControllerLoginWithTokenUrl = () => {
  return `/api-arvore/auth/token`
}

export const authControllerLoginWithToken = async (
  accessTokenLoginBodyDto: AccessTokenLoginBodyDto,
  options?: RequestInit
): Promise<authControllerLoginWithTokenResponse> => {
  return customInstance<authControllerLoginWithTokenResponse>(
    getAuthControllerLoginWithTokenUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(accessTokenLoginBodyDto)
    }
  )
}

/**
 * @summary Request password reset via email or SMS
 */
export type authControllerForgotPasswordResponse200 = {
  data: ForgotPasswordResponseDto
  status: 200
}

export type authControllerForgotPasswordResponseSuccess =
  authControllerForgotPasswordResponse200 & {
    headers: Headers
  }
export type authControllerForgotPasswordResponse =
  authControllerForgotPasswordResponseSuccess

export const getAuthControllerForgotPasswordUrl = () => {
  return `/api-arvore/auth/forgot-password`
}

export const authControllerForgotPassword = async (
  forgotPasswordBodyDto: ForgotPasswordBodyDto,
  options?: RequestInit
): Promise<authControllerForgotPasswordResponse> => {
  return customInstance<authControllerForgotPasswordResponse>(
    getAuthControllerForgotPasswordUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(forgotPasswordBodyDto)
    }
  )
}

/**
 * @summary Reset password with token or SMS code
 */
export type authControllerResetPasswordResponse200 = {
  data: ResetPasswordResponseDto
  status: 200
}

export type authControllerResetPasswordResponse400 = {
  data: void
  status: 400
}

export type authControllerResetPasswordResponseSuccess =
  authControllerResetPasswordResponse200 & {
    headers: Headers
  }
export type authControllerResetPasswordResponseError =
  authControllerResetPasswordResponse400 & {
    headers: Headers
  }

export type authControllerResetPasswordResponse =
  | authControllerResetPasswordResponseSuccess
  | authControllerResetPasswordResponseError

export const getAuthControllerResetPasswordUrl = () => {
  return `/api-arvore/auth/reset-password`
}

export const authControllerResetPassword = async (
  resetPasswordBodyDto: ResetPasswordBodyDto,
  options?: RequestInit
): Promise<authControllerResetPasswordResponse> => {
  return customInstance<authControllerResetPasswordResponse>(
    getAuthControllerResetPasswordUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resetPasswordBodyDto)
    }
  )
}

/**
 * @summary OAuth2 callback - exchange code for Arvore JWT and set cookie
 */
export type authControllerCallbackResponse302 = {
  data: void
  status: 302
}

export type authControllerCallbackResponse400 = {
  data: void
  status: 400
}

export type authControllerCallbackResponse401 = {
  data: void
  status: 401
}
export type authControllerCallbackResponseError = (
  | authControllerCallbackResponse302
  | authControllerCallbackResponse400
  | authControllerCallbackResponse401
) & {
  headers: Headers
}

export type authControllerCallbackResponse = authControllerCallbackResponseError

export const getAuthControllerCallbackUrl = () => {
  return `/api-arvore/auth/callback`
}

export const authControllerCallback = async (
  options?: RequestInit
): Promise<authControllerCallbackResponse> => {
  return customInstance<authControllerCallbackResponse>(
    getAuthControllerCallbackUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Resolve short access_token to JWT (internal use)
 */
export type authControllerResolveTokenResponse200 = {
  data: void
  status: 200
}

export type authControllerResolveTokenResponseSuccess =
  authControllerResolveTokenResponse200 & {
    headers: Headers
  }
export type authControllerResolveTokenResponse =
  authControllerResolveTokenResponseSuccess

export const getAuthControllerResolveTokenUrl = () => {
  return `/api-arvore/auth/resolve-token`
}

export const authControllerResolveToken = async (
  options?: RequestInit
): Promise<authControllerResolveTokenResponse> => {
  return customInstance<authControllerResolveTokenResponse>(
    getAuthControllerResolveTokenUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Accepts an api_token (Árvore) or identityId (Super) and returns a grant URL. The identifier type is inferred from the authenticated OAuth client. Authenticated via OAuth client credentials (Basic Auth or X-Client-Id/X-Client-Secret headers).
 * @summary Exchange a system token for a one-time grant URL (server-to-server)
 */
export type tokenExchangeControllerTokenExchangeResponse200 = {
  data: TokenExchangeResponseDto
  status: 200
}

export type tokenExchangeControllerTokenExchangeResponse401 = {
  data: void
  status: 401
}

export type tokenExchangeControllerTokenExchangeResponseSuccess =
  tokenExchangeControllerTokenExchangeResponse200 & {
    headers: Headers
  }
export type tokenExchangeControllerTokenExchangeResponseError =
  tokenExchangeControllerTokenExchangeResponse401 & {
    headers: Headers
  }

export type tokenExchangeControllerTokenExchangeResponse =
  | tokenExchangeControllerTokenExchangeResponseSuccess
  | tokenExchangeControllerTokenExchangeResponseError

export const getTokenExchangeControllerTokenExchangeUrl = () => {
  return `/api-arvore/auth/token-exchange`
}

export const tokenExchangeControllerTokenExchange = async (
  tokenExchangeBodyDto: TokenExchangeBodyDto,
  options?: RequestInit
): Promise<tokenExchangeControllerTokenExchangeResponse> => {
  return customInstance<tokenExchangeControllerTokenExchangeResponse>(
    getTokenExchangeControllerTokenExchangeUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(tokenExchangeBodyDto)
    }
  )
}

/**
 * Sets the Identity session cookie and redirects to the OAuth callback with the authorization code. This is the URL returned by POST /auth/token-exchange.
 * @summary Consume a one-time grant token
 */
export type tokenExchangeControllerGrantResponse302 = {
  data: void
  status: 302
}

export type tokenExchangeControllerGrantResponse410 = {
  data: void
  status: 410
}
export type tokenExchangeControllerGrantResponseError = (
  | tokenExchangeControllerGrantResponse302
  | tokenExchangeControllerGrantResponse410
) & {
  headers: Headers
}

export type tokenExchangeControllerGrantResponse =
  tokenExchangeControllerGrantResponseError

export const getTokenExchangeControllerGrantUrl = (token: string) => {
  return `/api-arvore/oauth2/grant/${token}`
}

export const tokenExchangeControllerGrant = async (
  token: string,
  options?: RequestInit
): Promise<tokenExchangeControllerGrantResponse> => {
  return customInstance<tokenExchangeControllerGrantResponse>(
    getTokenExchangeControllerGrantUrl(token),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Redirect to Identity OAuth2 authorize
 */
export type loginRedirectControllerLoginResponse302 = {
  data: void
  status: 302
}

export type loginRedirectControllerLoginResponse400 = {
  data: void
  status: 400
}
export type loginRedirectControllerLoginResponseError = (
  | loginRedirectControllerLoginResponse302
  | loginRedirectControllerLoginResponse400
) & {
  headers: Headers
}

export type loginRedirectControllerLoginResponse =
  loginRedirectControllerLoginResponseError

export const getLoginRedirectControllerLoginUrl = () => {
  return `/login`
}

export const loginRedirectControllerLogin = async (
  options?: RequestInit
): Promise<loginRedirectControllerLoginResponse> => {
  return customInstance<loginRedirectControllerLoginResponse>(
    getLoginRedirectControllerLoginUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Start Google OAuth flow
 */
export type socialControllerGoogleStartResponse302 = {
  data: void
  status: 302
}
export type socialControllerGoogleStartResponseError =
  socialControllerGoogleStartResponse302 & {
    headers: Headers
  }

export type socialControllerGoogleStartResponse =
  socialControllerGoogleStartResponseError

export const getSocialControllerGoogleStartUrl = (
  params: SocialControllerGoogleStartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/google/start?${stringifiedParams}`
    : `/api-arvore/auth/google/start`
}

export const socialControllerGoogleStart = async (
  params: SocialControllerGoogleStartParams,
  options?: RequestInit
): Promise<socialControllerGoogleStartResponse> => {
  return customInstance<socialControllerGoogleStartResponse>(
    getSocialControllerGoogleStartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Google OAuth callback
 */
export type socialControllerGoogleCallbackResponse200 = {
  data: void
  status: 200
}

export type socialControllerGoogleCallbackResponseSuccess =
  socialControllerGoogleCallbackResponse200 & {
    headers: Headers
  }
export type socialControllerGoogleCallbackResponse =
  socialControllerGoogleCallbackResponseSuccess

export const getSocialControllerGoogleCallbackUrl = (
  params: SocialControllerGoogleCallbackParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/google/callback?${stringifiedParams}`
    : `/api-arvore/auth/google/callback`
}

export const socialControllerGoogleCallback = async (
  params: SocialControllerGoogleCallbackParams,
  options?: RequestInit
): Promise<socialControllerGoogleCallbackResponse> => {
  return customInstance<socialControllerGoogleCallbackResponse>(
    getSocialControllerGoogleCallbackUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Google One Tap login
 */
export type socialControllerGoogleOneTapResponse200 = {
  data: void
  status: 200
}

export type socialControllerGoogleOneTapResponse400 = {
  data: void
  status: 400
}

export type socialControllerGoogleOneTapResponse401 = {
  data: void
  status: 401
}

export type socialControllerGoogleOneTapResponseSuccess =
  socialControllerGoogleOneTapResponse200 & {
    headers: Headers
  }
export type socialControllerGoogleOneTapResponseError = (
  | socialControllerGoogleOneTapResponse400
  | socialControllerGoogleOneTapResponse401
) & {
  headers: Headers
}

export type socialControllerGoogleOneTapResponse =
  | socialControllerGoogleOneTapResponseSuccess
  | socialControllerGoogleOneTapResponseError

export const getSocialControllerGoogleOneTapUrl = () => {
  return `/api-arvore/auth/google/one-tap`
}

export const socialControllerGoogleOneTap = async (
  googleOneTapBodyDto: GoogleOneTapBodyDto,
  options?: RequestInit
): Promise<socialControllerGoogleOneTapResponse> => {
  return customInstance<socialControllerGoogleOneTapResponse>(
    getSocialControllerGoogleOneTapUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(googleOneTapBodyDto)
    }
  )
}

/**
 * @summary Start Microsoft OAuth flow
 */
export type socialControllerMicrosoftStartResponse302 = {
  data: void
  status: 302
}
export type socialControllerMicrosoftStartResponseError =
  socialControllerMicrosoftStartResponse302 & {
    headers: Headers
  }

export type socialControllerMicrosoftStartResponse =
  socialControllerMicrosoftStartResponseError

export const getSocialControllerMicrosoftStartUrl = (
  params: SocialControllerMicrosoftStartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/microsoft/start?${stringifiedParams}`
    : `/api-arvore/auth/microsoft/start`
}

export const socialControllerMicrosoftStart = async (
  params: SocialControllerMicrosoftStartParams,
  options?: RequestInit
): Promise<socialControllerMicrosoftStartResponse> => {
  return customInstance<socialControllerMicrosoftStartResponse>(
    getSocialControllerMicrosoftStartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Microsoft OAuth callback
 */
export type socialControllerMicrosoftCallbackResponse200 = {
  data: void
  status: 200
}

export type socialControllerMicrosoftCallbackResponseSuccess =
  socialControllerMicrosoftCallbackResponse200 & {
    headers: Headers
  }
export type socialControllerMicrosoftCallbackResponse =
  socialControllerMicrosoftCallbackResponseSuccess

export const getSocialControllerMicrosoftCallbackUrl = (
  params: SocialControllerMicrosoftCallbackParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/microsoft/callback?${stringifiedParams}`
    : `/api-arvore/auth/microsoft/callback`
}

export const socialControllerMicrosoftCallback = async (
  params: SocialControllerMicrosoftCallbackParams,
  options?: RequestInit
): Promise<socialControllerMicrosoftCallbackResponse> => {
  return customInstance<socialControllerMicrosoftCallbackResponse>(
    getSocialControllerMicrosoftCallbackUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Start Lex OAuth flow
 */
export type socialControllerLexStartResponse302 = {
  data: void
  status: 302
}
export type socialControllerLexStartResponseError =
  socialControllerLexStartResponse302 & {
    headers: Headers
  }

export type socialControllerLexStartResponse =
  socialControllerLexStartResponseError

export const getSocialControllerLexStartUrl = (
  params: SocialControllerLexStartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/lex/start?${stringifiedParams}`
    : `/api-arvore/auth/lex/start`
}

export const socialControllerLexStart = async (
  params: SocialControllerLexStartParams,
  options?: RequestInit
): Promise<socialControllerLexStartResponse> => {
  return customInstance<socialControllerLexStartResponse>(
    getSocialControllerLexStartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Lex OAuth callback
 */
export type socialControllerLexCallbackResponse200 = {
  data: void
  status: 200
}

export type socialControllerLexCallbackResponseSuccess =
  socialControllerLexCallbackResponse200 & {
    headers: Headers
  }
export type socialControllerLexCallbackResponse =
  socialControllerLexCallbackResponseSuccess

export const getSocialControllerLexCallbackUrl = (
  params: SocialControllerLexCallbackParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/lex/callback?${stringifiedParams}`
    : `/api-arvore/auth/lex/callback`
}

export const socialControllerLexCallback = async (
  params: SocialControllerLexCallbackParams,
  options?: RequestInit
): Promise<socialControllerLexCallbackResponse> => {
  return customInstance<socialControllerLexCallbackResponse>(
    getSocialControllerLexCallbackUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Start ClassLink OAuth flow
 */
export type socialControllerClasslinkStartResponse302 = {
  data: void
  status: 302
}
export type socialControllerClasslinkStartResponseError =
  socialControllerClasslinkStartResponse302 & {
    headers: Headers
  }

export type socialControllerClasslinkStartResponse =
  socialControllerClasslinkStartResponseError

export const getSocialControllerClasslinkStartUrl = (
  params: SocialControllerClasslinkStartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/classlink/start?${stringifiedParams}`
    : `/api-arvore/auth/classlink/start`
}

export const socialControllerClasslinkStart = async (
  params: SocialControllerClasslinkStartParams,
  options?: RequestInit
): Promise<socialControllerClasslinkStartResponse> => {
  return customInstance<socialControllerClasslinkStartResponse>(
    getSocialControllerClasslinkStartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary ClassLink OAuth callback
 */
export type socialControllerClasslinkCallbackResponse200 = {
  data: void
  status: 200
}

export type socialControllerClasslinkCallbackResponseSuccess =
  socialControllerClasslinkCallbackResponse200 & {
    headers: Headers
  }
export type socialControllerClasslinkCallbackResponse =
  socialControllerClasslinkCallbackResponseSuccess

export const getSocialControllerClasslinkCallbackUrl = (
  params: SocialControllerClasslinkCallbackParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/auth/classlink/callback?${stringifiedParams}`
    : `/api-arvore/auth/classlink/callback`
}

export const socialControllerClasslinkCallback = async (
  params: SocialControllerClasslinkCallbackParams,
  options?: RequestInit
): Promise<socialControllerClasslinkCallbackResponse> => {
  return customInstance<socialControllerClasslinkCallbackResponse>(
    getSocialControllerClasslinkCallbackUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @deprecated
 * @summary Start Google OAuth flow for mobile WebView (deprecated, redirects to unified endpoint)
 */
export type googleMobileControllerStartResponse302 = {
  data: void
  status: 302
}
export type googleMobileControllerStartResponseError =
  googleMobileControllerStartResponse302 & {
    headers: Headers
  }

export type googleMobileControllerStartResponse =
  googleMobileControllerStartResponseError

export const getGoogleMobileControllerStartUrl = () => {
  return `/api-arvore/auth/google/mobile/start`
}

export const googleMobileControllerStart = async (
  options?: RequestInit
): Promise<googleMobileControllerStartResponse> => {
  return customInstance<googleMobileControllerStartResponse>(
    getGoogleMobileControllerStartUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @deprecated
 * @summary Start Microsoft OAuth flow for mobile WebView (deprecated, redirects to unified endpoint)
 */
export type microsoftMobileControllerStartResponse302 = {
  data: void
  status: 302
}
export type microsoftMobileControllerStartResponseError =
  microsoftMobileControllerStartResponse302 & {
    headers: Headers
  }

export type microsoftMobileControllerStartResponse =
  microsoftMobileControllerStartResponseError

export const getMicrosoftMobileControllerStartUrl = () => {
  return `/api-arvore/auth/microsoft/mobile/start`
}

export const microsoftMobileControllerStart = async (
  options?: RequestInit
): Promise<microsoftMobileControllerStartResponse> => {
  return customInstance<microsoftMobileControllerStartResponse>(
    getMicrosoftMobileControllerStartUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Start GitHub OAuth flow for internal team members
 */
export type gitHubInternalControllerStartResponse302 = {
  data: void
  status: 302
}

export type gitHubInternalControllerStartResponse500 = {
  data: void
  status: 500
}
export type gitHubInternalControllerStartResponseError = (
  | gitHubInternalControllerStartResponse302
  | gitHubInternalControllerStartResponse500
) & {
  headers: Headers
}

export type gitHubInternalControllerStartResponse =
  gitHubInternalControllerStartResponseError

export const getGitHubInternalControllerStartUrl = () => {
  return `/api-arvore/auth/github/start`
}

export const gitHubInternalControllerStart = async (
  options?: RequestInit
): Promise<gitHubInternalControllerStartResponse> => {
  return customInstance<gitHubInternalControllerStartResponse>(
    getGitHubInternalControllerStartUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary GitHub OAuth callback — validates org membership and returns JWT
 */
export type gitHubInternalControllerCallbackResponse200 = {
  data: void
  status: 200
}

export type gitHubInternalControllerCallbackResponse401 = {
  data: void
  status: 401
}

export type gitHubInternalControllerCallbackResponse403 = {
  data: void
  status: 403
}

export type gitHubInternalControllerCallbackResponseSuccess =
  gitHubInternalControllerCallbackResponse200 & {
    headers: Headers
  }
export type gitHubInternalControllerCallbackResponseError = (
  | gitHubInternalControllerCallbackResponse401
  | gitHubInternalControllerCallbackResponse403
) & {
  headers: Headers
}

export type gitHubInternalControllerCallbackResponse =
  | gitHubInternalControllerCallbackResponseSuccess
  | gitHubInternalControllerCallbackResponseError

export const getGitHubInternalControllerCallbackUrl = () => {
  return `/api-arvore/auth/github/callback`
}

export const gitHubInternalControllerCallback = async (
  options?: RequestInit
): Promise<gitHubInternalControllerCallbackResponse> => {
  return customInstance<gitHubInternalControllerCallbackResponse>(
    getGitHubInternalControllerCallbackUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Validate GitHub internal JWT and return user info
 */
export type gitHubInternalControllerMeResponse200 = {
  data: void
  status: 200
}

export type gitHubInternalControllerMeResponse401 = {
  data: void
  status: 401
}

export type gitHubInternalControllerMeResponseSuccess =
  gitHubInternalControllerMeResponse200 & {
    headers: Headers
  }
export type gitHubInternalControllerMeResponseError =
  gitHubInternalControllerMeResponse401 & {
    headers: Headers
  }

export type gitHubInternalControllerMeResponse =
  | gitHubInternalControllerMeResponseSuccess
  | gitHubInternalControllerMeResponseError

export const getGitHubInternalControllerMeUrl = () => {
  return `/api-arvore/auth/github/me`
}

export const gitHubInternalControllerMe = async (
  options?: RequestInit
): Promise<gitHubInternalControllerMeResponse> => {
  return customInstance<gitHubInternalControllerMeResponse>(
    getGitHubInternalControllerMeUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Exchange a refresh token for a new access token
 */
export type gitHubInternalControllerRefreshResponse200 = {
  data: void
  status: 200
}

export type gitHubInternalControllerRefreshResponse401 = {
  data: void
  status: 401
}

export type gitHubInternalControllerRefreshResponseSuccess =
  gitHubInternalControllerRefreshResponse200 & {
    headers: Headers
  }
export type gitHubInternalControllerRefreshResponseError =
  gitHubInternalControllerRefreshResponse401 & {
    headers: Headers
  }

export type gitHubInternalControllerRefreshResponse =
  | gitHubInternalControllerRefreshResponseSuccess
  | gitHubInternalControllerRefreshResponseError

export const getGitHubInternalControllerRefreshUrl = () => {
  return `/api-arvore/auth/github/refresh`
}

export const gitHubInternalControllerRefresh = async (
  options?: RequestInit
): Promise<gitHubInternalControllerRefreshResponse> => {
  return customInstance<gitHubInternalControllerRefreshResponse>(
    getGitHubInternalControllerRefreshUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @deprecated
 * @summary List classes for a teacher by identity ID
 */
export type teacherClassControllerGetTeacherClassesResponse200 = {
  data: TeacherClassesResponseDto
  status: 200
}

export type teacherClassControllerGetTeacherClassesResponseSuccess =
  teacherClassControllerGetTeacherClassesResponse200 & {
    headers: Headers
  }
export type teacherClassControllerGetTeacherClassesResponse =
  teacherClassControllerGetTeacherClassesResponseSuccess

export const getTeacherClassControllerGetTeacherClassesUrl = (
  identityId: string
) => {
  return `/api-arvore/v1/teachers/${identityId}/classes`
}

export const teacherClassControllerGetTeacherClasses = async (
  identityId: string,
  options?: RequestInit
): Promise<teacherClassControllerGetTeacherClassesResponse> => {
  return customInstance<teacherClassControllerGetTeacherClassesResponse>(
    getTeacherClassControllerGetTeacherClassesUrl(identityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @deprecated
 * @summary List students for a class
 */
export type teacherClassControllerGetClassStudentsResponse200 = {
  data: ClassStudentsResponseDto
  status: 200
}

export type teacherClassControllerGetClassStudentsResponseSuccess =
  teacherClassControllerGetClassStudentsResponse200 & {
    headers: Headers
  }
export type teacherClassControllerGetClassStudentsResponse =
  teacherClassControllerGetClassStudentsResponseSuccess

export const getTeacherClassControllerGetClassStudentsUrl = (
  classEntityId: string
) => {
  return `/api-arvore/v1/teachers/classes/${classEntityId}/students`
}

export const teacherClassControllerGetClassStudents = async (
  classEntityId: string,
  options?: RequestInit
): Promise<teacherClassControllerGetClassStudentsResponse> => {
  return customInstance<teacherClassControllerGetClassStudentsResponse>(
    getTeacherClassControllerGetClassStudentsUrl(classEntityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @deprecated
 * @summary Trigger sync for all students in a class
 */
export type teacherClassControllerSyncClassStudentsResponse200 = {
  data: ClassSyncResponseDto
  status: 200
}

export type teacherClassControllerSyncClassStudentsResponseSuccess =
  teacherClassControllerSyncClassStudentsResponse200 & {
    headers: Headers
  }
export type teacherClassControllerSyncClassStudentsResponse =
  teacherClassControllerSyncClassStudentsResponseSuccess

export const getTeacherClassControllerSyncClassStudentsUrl = (
  classEntityId: string
) => {
  return `/api-arvore/v1/teachers/classes/${classEntityId}/sync`
}

export const teacherClassControllerSyncClassStudents = async (
  classEntityId: string,
  options?: RequestInit
): Promise<teacherClassControllerSyncClassStudentsResponse> => {
  return customInstance<teacherClassControllerSyncClassStudentsResponse>(
    getTeacherClassControllerSyncClassStudentsUrl(classEntityId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Search entities in Arvore or Super
 */
export type entitySyncControllerSearchEntitiesResponse200 = {
  data: SearchEntitySyncResponseDto
  status: 200
}

export type entitySyncControllerSearchEntitiesResponseSuccess =
  entitySyncControllerSearchEntitiesResponse200 & {
    headers: Headers
  }
export type entitySyncControllerSearchEntitiesResponse =
  entitySyncControllerSearchEntitiesResponseSuccess

export const getEntitySyncControllerSearchEntitiesUrl = (
  params: EntitySyncControllerSearchEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entity-sync/search?${stringifiedParams}`
    : `/api-arvore/entity-sync/search`
}

export const entitySyncControllerSearchEntities = async (
  params: EntitySyncControllerSearchEntitiesParams,
  options?: RequestInit
): Promise<entitySyncControllerSearchEntitiesResponse> => {
  return customInstance<entitySyncControllerSearchEntitiesResponse>(
    getEntitySyncControllerSearchEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List classes for a school by its identity ID
 */
export type entitySyncControllerListSchoolClassesResponse200 = {
  data: ListSchoolClassesResponseDto
  status: 200
}

export type entitySyncControllerListSchoolClassesResponseSuccess =
  entitySyncControllerListSchoolClassesResponse200 & {
    headers: Headers
  }
export type entitySyncControllerListSchoolClassesResponse =
  entitySyncControllerListSchoolClassesResponseSuccess

export const getEntitySyncControllerListSchoolClassesUrl = (
  schoolIdentityId: string
) => {
  return `/api-arvore/entity-sync/schools/${schoolIdentityId}/classes`
}

export const entitySyncControllerListSchoolClasses = async (
  schoolIdentityId: string,
  options?: RequestInit
): Promise<entitySyncControllerListSchoolClassesResponse> => {
  return customInstance<entitySyncControllerListSchoolClassesResponse>(
    getEntitySyncControllerListSchoolClassesUrl(schoolIdentityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get entity by ID from Arvore or Super
 */
export type entitySyncControllerGetEntityResponse200 = {
  data: GetEntitySyncResponseDto
  status: 200
}

export type entitySyncControllerGetEntityResponseSuccess =
  entitySyncControllerGetEntityResponse200 & {
    headers: Headers
  }
export type entitySyncControllerGetEntityResponse =
  entitySyncControllerGetEntityResponseSuccess

export const getEntitySyncControllerGetEntityUrl = (
  source: 'arvore' | 'super',
  entityType: 'network' | 'school' | 'class',
  entityId: string
) => {
  return `/api-arvore/entity-sync/${source}/${entityType}/${entityId}`
}

export const entitySyncControllerGetEntity = async (
  source: 'arvore' | 'super',
  entityType: 'network' | 'school' | 'class',
  entityId: string,
  options?: RequestInit
): Promise<entitySyncControllerGetEntityResponse> => {
  return customInstance<entitySyncControllerGetEntityResponse>(
    getEntitySyncControllerGetEntityUrl(source, entityType, entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Enqueue sync for an entity between Arvore and Super
 */
export type entitySyncControllerSyncEntityResponse200 = {
  data: SyncEntityResponseDto
  status: 200
}

export type entitySyncControllerSyncEntityResponseSuccess =
  entitySyncControllerSyncEntityResponse200 & {
    headers: Headers
  }
export type entitySyncControllerSyncEntityResponse =
  entitySyncControllerSyncEntityResponseSuccess

export const getEntitySyncControllerSyncEntityUrl = (entityId: string) => {
  return `/api-arvore/entity-sync/${entityId}/sync`
}

export const entitySyncControllerSyncEntity = async (
  entityId: string,
  syncEntityBidirectionalBodyDto: SyncEntityBidirectionalBodyDto,
  options?: RequestInit
): Promise<entitySyncControllerSyncEntityResponse> => {
  return customInstance<entitySyncControllerSyncEntityResponse>(
    getEntitySyncControllerSyncEntityUrl(entityId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(syncEntityBidirectionalBodyDto)
    }
  )
}

/**
 * Verifies if the email service is operational by sending a test email via SendGrid
 * @summary Email service health check
 */
export type emailHealthControllerCheckEmailHealthResponse200 = {
  data: EmailHealthResponseDto
  status: 200
}

export type emailHealthControllerCheckEmailHealthResponseSuccess =
  emailHealthControllerCheckEmailHealthResponse200 & {
    headers: Headers
  }
export type emailHealthControllerCheckEmailHealthResponse =
  emailHealthControllerCheckEmailHealthResponseSuccess

export const getEmailHealthControllerCheckEmailHealthUrl = () => {
  return `/api-arvore/health/email`
}

export const emailHealthControllerCheckEmailHealth = async (
  options?: RequestInit
): Promise<emailHealthControllerCheckEmailHealthResponse> => {
  return customInstance<emailHealthControllerCheckEmailHealthResponse>(
    getEmailHealthControllerCheckEmailHealthUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Provisiona logins de demonstração e gera CSV no formato comercial
 */
export type demoLoginsControllerProvisionResponse200 = {
  data: ProvisionDemoLoginsResponseDto
  status: 200
}

export type demoLoginsControllerProvisionResponseSuccess =
  demoLoginsControllerProvisionResponse200 & {
    headers: Headers
  }
export type demoLoginsControllerProvisionResponse =
  demoLoginsControllerProvisionResponseSuccess

export const getDemoLoginsControllerProvisionUrl = () => {
  return `/api-arvore/demo-logins/provision`
}

export const demoLoginsControllerProvision = async (
  provisionDemoLoginsBodyDto: ProvisionDemoLoginsBodyDto,
  options?: RequestInit
): Promise<demoLoginsControllerProvisionResponse> => {
  return customInstance<demoLoginsControllerProvisionResponse>(
    getDemoLoginsControllerProvisionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(provisionDemoLoginsBodyDto)
    }
  )
}

/**
 * @summary Provisiona logins demo para um serviço automatizado (token de serviço, escopo restrito a poucas contas)
 */
export type demoLoginsControllerProvisionForServiceResponse200 = {
  data: ProvisionDemoLoginsResponseDto
  status: 200
}

export type demoLoginsControllerProvisionForServiceResponseSuccess =
  demoLoginsControllerProvisionForServiceResponse200 & {
    headers: Headers
  }
export type demoLoginsControllerProvisionForServiceResponse =
  demoLoginsControllerProvisionForServiceResponseSuccess

export const getDemoLoginsControllerProvisionForServiceUrl = () => {
  return `/api-arvore/demo-logins/service/provision`
}

export const demoLoginsControllerProvisionForService = async (
  serviceProvisionDemoLoginsBodyDto: ServiceProvisionDemoLoginsBodyDto,
  options?: RequestInit
): Promise<demoLoginsControllerProvisionForServiceResponse> => {
  return customInstance<demoLoginsControllerProvisionForServiceResponse>(
    getDemoLoginsControllerProvisionForServiceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(serviceProvisionDemoLoginsBodyDto)
    }
  )
}

/**
 * @summary Create a debug session and generate a debug link
 */
export type debugSessionAdminControllerCreateResponse201 = {
  data: void
  status: 201
}

export type debugSessionAdminControllerCreateResponseSuccess =
  debugSessionAdminControllerCreateResponse201 & {
    headers: Headers
  }
export type debugSessionAdminControllerCreateResponse =
  debugSessionAdminControllerCreateResponseSuccess

export const getDebugSessionAdminControllerCreateUrl = () => {
  return `/api-arvore/debug-sessions`
}

export const debugSessionAdminControllerCreate = async (
  createDebugSessionBodyDto: CreateDebugSessionBodyDto,
  options?: RequestInit
): Promise<debugSessionAdminControllerCreateResponse> => {
  return customInstance<debugSessionAdminControllerCreateResponse>(
    getDebugSessionAdminControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createDebugSessionBodyDto)
    }
  )
}

/**
 * @summary List encrypted chunks and return presigned download URLs
 */
export type debugSessionAdminControllerDownloadResponse200 = {
  data: void
  status: 200
}

export type debugSessionAdminControllerDownloadResponseSuccess =
  debugSessionAdminControllerDownloadResponse200 & {
    headers: Headers
  }
export type debugSessionAdminControllerDownloadResponse =
  debugSessionAdminControllerDownloadResponseSuccess

export const getDebugSessionAdminControllerDownloadUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}/download`
}

export const debugSessionAdminControllerDownload = async (
  token: string,
  options?: RequestInit
): Promise<debugSessionAdminControllerDownloadResponse> => {
  return customInstance<debugSessionAdminControllerDownloadResponse>(
    getDebugSessionAdminControllerDownloadUrl(token),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Resolve a debug session payload for the browser widget
 */
export type debugSessionPublicControllerGetResponse200 = {
  data: void
  status: 200
}

export type debugSessionPublicControllerGetResponseSuccess =
  debugSessionPublicControllerGetResponse200 & {
    headers: Headers
  }
export type debugSessionPublicControllerGetResponse =
  debugSessionPublicControllerGetResponseSuccess

export const getDebugSessionPublicControllerGetUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}`
}

export const debugSessionPublicControllerGet = async (
  token: string,
  options?: RequestInit
): Promise<debugSessionPublicControllerGetResponse> => {
  return customInstance<debugSessionPublicControllerGetResponse>(
    getDebugSessionPublicControllerGetUrl(token),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get a presigned PUT URL for an encrypted chunk
 */
export type debugSessionPublicControllerChunkUrlResponse200 = {
  data: void
  status: 200
}

export type debugSessionPublicControllerChunkUrlResponseSuccess =
  debugSessionPublicControllerChunkUrlResponse200 & {
    headers: Headers
  }
export type debugSessionPublicControllerChunkUrlResponse =
  debugSessionPublicControllerChunkUrlResponseSuccess

export const getDebugSessionPublicControllerChunkUrlUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}/chunk-url`
}

export const debugSessionPublicControllerChunkUrl = async (
  token: string,
  chunkUrlBodyDto: ChunkUrlBodyDto,
  options?: RequestInit
): Promise<debugSessionPublicControllerChunkUrlResponse> => {
  return customInstance<debugSessionPublicControllerChunkUrlResponse>(
    getDebugSessionPublicControllerChunkUrlUrl(token),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(chunkUrlBodyDto)
    }
  )
}

/**
 * @summary Save page metadata for a debug session
 */
export type debugSessionPublicControllerMetaResponse200 = {
  data: void
  status: 200
}

export type debugSessionPublicControllerMetaResponseSuccess =
  debugSessionPublicControllerMetaResponse200 & {
    headers: Headers
  }
export type debugSessionPublicControllerMetaResponse =
  debugSessionPublicControllerMetaResponseSuccess

export const getDebugSessionPublicControllerMetaUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}/meta`
}

export const debugSessionPublicControllerMeta = async (
  token: string,
  saveMetaBodyDto: SaveMetaBodyDto,
  options?: RequestInit
): Promise<debugSessionPublicControllerMetaResponse> => {
  return customInstance<debugSessionPublicControllerMetaResponse>(
    getDebugSessionPublicControllerMetaUrl(token),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saveMetaBodyDto)
    }
  )
}

/**
 * @summary Latency probe for the speed test
 */
export type debugSessionPublicControllerPingResponse204 = {
  data: void
  status: 204
}

export type debugSessionPublicControllerPingResponseSuccess =
  debugSessionPublicControllerPingResponse204 & {
    headers: Headers
  }
export type debugSessionPublicControllerPingResponse =
  debugSessionPublicControllerPingResponseSuccess

export const getDebugSessionPublicControllerPingUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}/speedtest/ping`
}

export const debugSessionPublicControllerPing = async (
  token: string,
  options?: RequestInit
): Promise<debugSessionPublicControllerPingResponse> => {
  return customInstance<debugSessionPublicControllerPingResponse>(
    getDebugSessionPublicControllerPingUrl(token),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Serve random bytes for the download speed test
 */
export type debugSessionPublicControllerDownloadResponse200 = {
  data: void
  status: 200
}

export type debugSessionPublicControllerDownloadResponseSuccess =
  debugSessionPublicControllerDownloadResponse200 & {
    headers: Headers
  }
export type debugSessionPublicControllerDownloadResponse =
  debugSessionPublicControllerDownloadResponseSuccess

export const getDebugSessionPublicControllerDownloadUrl = (
  token: string,
  params: DebugSessionPublicControllerDownloadParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/debug-sessions/${token}/speedtest/download?${stringifiedParams}`
    : `/api-arvore/debug-sessions/${token}/speedtest/download`
}

export const debugSessionPublicControllerDownload = async (
  token: string,
  params: DebugSessionPublicControllerDownloadParams,
  options?: RequestInit
): Promise<debugSessionPublicControllerDownloadResponse> => {
  return customInstance<debugSessionPublicControllerDownloadResponse>(
    getDebugSessionPublicControllerDownloadUrl(token, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Sink endpoint for the upload speed test
 */
export type debugSessionPublicControllerUploadSinkResponse200 = {
  data: void
  status: 200
}

export type debugSessionPublicControllerUploadSinkResponseSuccess =
  debugSessionPublicControllerUploadSinkResponse200 & {
    headers: Headers
  }
export type debugSessionPublicControllerUploadSinkResponse =
  debugSessionPublicControllerUploadSinkResponseSuccess

export const getDebugSessionPublicControllerUploadSinkUrl = (token: string) => {
  return `/api-arvore/debug-sessions/${token}/speedtest/upload`
}

export const debugSessionPublicControllerUploadSink = async (
  token: string,
  options?: RequestInit
): Promise<debugSessionPublicControllerUploadSinkResponse> => {
  return customInstance<debugSessionPublicControllerUploadSinkResponse>(
    getDebugSessionPublicControllerUploadSinkUrl(token),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Retorna o relatório consolidado da Experiência EBR (KPIs, funis, unidades e comparativos) de uma escola do piloto. Disponível apenas para usuários com perfil de equipe escolar pertencentes à mesma rede ou escola solicitada.
 * @summary Obter relatório da Experiência EBR de uma escola
 */
export type ebrControllerGetReportResponse200 = {
  data: GetReportResponseDto
  status: 200
}

export type ebrControllerGetReportResponseSuccess =
  ebrControllerGetReportResponse200 & {
    headers: Headers
  }
export type ebrControllerGetReportResponse =
  ebrControllerGetReportResponseSuccess

export const getEbrControllerGetReportUrl = (schoolId: number) => {
  return `/api-arvore/ebr/schools/${schoolId}`
}

export const ebrControllerGetReport = async (
  schoolId: number,
  options?: RequestInit
): Promise<ebrControllerGetReportResponse> => {
  return customInstance<ebrControllerGetReportResponse>(
    getEbrControllerGetReportUrl(schoolId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Grava as respostas da seção "Sua opinião" (frequência, NPS e objetivos pedagógicos) de uma escola do piloto. Cada envio gera um novo registro.
 * @summary Registrar resposta da pesquisa de opinião da Experiência EBR
 */
export type ebrControllerCreateFeedbackResponse201 = {
  data: CreateFeedbackResponseDto
  status: 201
}

export type ebrControllerCreateFeedbackResponseSuccess =
  ebrControllerCreateFeedbackResponse201 & {
    headers: Headers
  }
export type ebrControllerCreateFeedbackResponse =
  ebrControllerCreateFeedbackResponseSuccess

export const getEbrControllerCreateFeedbackUrl = () => {
  return `/api-arvore/ebr/feedback`
}

export const ebrControllerCreateFeedback = async (
  createFeedbackRequestDto: CreateFeedbackRequestDto,
  options?: RequestInit
): Promise<ebrControllerCreateFeedbackResponse> => {
  return customInstance<ebrControllerCreateFeedbackResponse>(
    getEbrControllerCreateFeedbackUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createFeedbackRequestDto)
    }
  )
}

/**
 * Grava os interesses de renovação selecionados na seção "Conheça nossas soluções" de uma escola do piloto. Cada envio gera um novo registro.
 * @summary Registrar interesses de renovação da Experiência EBR
 */
export type ebrControllerCreateRenewalInterestsResponse201 = {
  data: CreateRenewalInterestsResponseDto
  status: 201
}

export type ebrControllerCreateRenewalInterestsResponseSuccess =
  ebrControllerCreateRenewalInterestsResponse201 & {
    headers: Headers
  }
export type ebrControllerCreateRenewalInterestsResponse =
  ebrControllerCreateRenewalInterestsResponseSuccess

export const getEbrControllerCreateRenewalInterestsUrl = () => {
  return `/api-arvore/ebr/renewal-interests`
}

export const ebrControllerCreateRenewalInterests = async (
  createRenewalInterestsRequestDto: CreateRenewalInterestsRequestDto,
  options?: RequestInit
): Promise<ebrControllerCreateRenewalInterestsResponse> => {
  return customInstance<ebrControllerCreateRenewalInterestsResponse>(
    getEbrControllerCreateRenewalInterestsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createRenewalInterestsRequestDto)
    }
  )
}

/**
 * @summary List audit events with filters and pagination
 */
export type auditEventsControllerListResponse200 = {
  data: ListAuditEventsResponseDto
  status: 200
}

export type auditEventsControllerListResponseSuccess =
  auditEventsControllerListResponse200 & {
    headers: Headers
  }
export type auditEventsControllerListResponse =
  auditEventsControllerListResponseSuccess

export const getAuditEventsControllerListUrl = (
  params?: AuditEventsControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/audit-events?${stringifiedParams}`
    : `/api-arvore/audit-events`
}

export const auditEventsControllerList = async (
  params?: AuditEventsControllerListParams,
  options?: RequestInit
): Promise<auditEventsControllerListResponse> => {
  return customInstance<auditEventsControllerListResponse>(
    getAuditEventsControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get a single audit event by user and sort key
 */
export type auditEventsControllerDetailResponse200 = {
  data: AuditEventDto
  status: 200
}

export type auditEventsControllerDetailResponseSuccess =
  auditEventsControllerDetailResponse200 & {
    headers: Headers
  }
export type auditEventsControllerDetailResponse =
  auditEventsControllerDetailResponseSuccess

export const getAuditEventsControllerDetailUrl = (
  params: AuditEventsControllerDetailParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/audit-events/detail?${stringifiedParams}`
    : `/api-arvore/audit-events/detail`
}

export const auditEventsControllerDetail = async (
  params: AuditEventsControllerDetailParams,
  options?: RequestInit
): Promise<auditEventsControllerDetailResponse> => {
  return customInstance<auditEventsControllerDetailResponse>(
    getAuditEventsControllerDetailUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get audit event statistics for a given month
 */
export type auditEventsControllerStatsResponse200 = {
  data: AuditStatsResponseDto
  status: 200
}

export type auditEventsControllerStatsResponseSuccess =
  auditEventsControllerStatsResponse200 & {
    headers: Headers
  }
export type auditEventsControllerStatsResponse =
  auditEventsControllerStatsResponseSuccess

export const getAuditEventsControllerStatsUrl = (
  params?: AuditEventsControllerStatsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/audit-events/stats?${stringifiedParams}`
    : `/api-arvore/audit-events/stats`
}

export const auditEventsControllerStats = async (
  params?: AuditEventsControllerStatsParams,
  options?: RequestInit
): Promise<auditEventsControllerStatsResponse> => {
  return customInstance<auditEventsControllerStatsResponse>(
    getAuditEventsControllerStatsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get geolocation info for an IP address
 */
export type auditEventsControllerIpInfoResponse200 = {
  data: IpInfoResponseDto
  status: 200
}

export type auditEventsControllerIpInfoResponseSuccess =
  auditEventsControllerIpInfoResponse200 & {
    headers: Headers
  }
export type auditEventsControllerIpInfoResponse =
  auditEventsControllerIpInfoResponseSuccess

export const getAuditEventsControllerIpInfoUrl = (
  params: AuditEventsControllerIpInfoParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/audit-events/ip-info?${stringifiedParams}`
    : `/api-arvore/audit-events/ip-info`
}

export const auditEventsControllerIpInfo = async (
  params: AuditEventsControllerIpInfoParams,
  options?: RequestInit
): Promise<auditEventsControllerIpInfoResponse> => {
  return customInstance<auditEventsControllerIpInfoResponse>(
    getAuditEventsControllerIpInfoUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get current user backoffice profile and permissions
 */
export type backofficeControllerGetMeV1Response200 = {
  data: void
  status: 200
}

export type backofficeControllerGetMeV1ResponseSuccess =
  backofficeControllerGetMeV1Response200 & {
    headers: Headers
  }
export type backofficeControllerGetMeV1Response =
  backofficeControllerGetMeV1ResponseSuccess

export const getBackofficeControllerGetMeV1Url = () => {
  return `/api-arvore/v1/backoffice/me`
}

export const backofficeControllerGetMeV1 = async (
  options?: RequestInit
): Promise<backofficeControllerGetMeV1Response> => {
  return customInstance<backofficeControllerGetMeV1Response>(
    getBackofficeControllerGetMeV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all backoffice features with linked teams
 */
export type backofficeControllerListFeaturesV1Response200 = {
  data: void
  status: 200
}

export type backofficeControllerListFeaturesV1ResponseSuccess =
  backofficeControllerListFeaturesV1Response200 & {
    headers: Headers
  }
export type backofficeControllerListFeaturesV1Response =
  backofficeControllerListFeaturesV1ResponseSuccess

export const getBackofficeControllerListFeaturesV1Url = () => {
  return `/api-arvore/v1/backoffice/features`
}

export const backofficeControllerListFeaturesV1 = async (
  options?: RequestInit
): Promise<backofficeControllerListFeaturesV1Response> => {
  return customInstance<backofficeControllerListFeaturesV1Response>(
    getBackofficeControllerListFeaturesV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new backoffice feature
 */
export type backofficeControllerCreateFeatureV1Response201 = {
  data: void
  status: 201
}

export type backofficeControllerCreateFeatureV1ResponseSuccess =
  backofficeControllerCreateFeatureV1Response201 & {
    headers: Headers
  }
export type backofficeControllerCreateFeatureV1Response =
  backofficeControllerCreateFeatureV1ResponseSuccess

export const getBackofficeControllerCreateFeatureV1Url = () => {
  return `/api-arvore/v1/backoffice/features`
}

export const backofficeControllerCreateFeatureV1 = async (
  createFeatureBodyDto: CreateFeatureBodyDto,
  options?: RequestInit
): Promise<backofficeControllerCreateFeatureV1Response> => {
  return customInstance<backofficeControllerCreateFeatureV1Response>(
    getBackofficeControllerCreateFeatureV1Url(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createFeatureBodyDto)
    }
  )
}

/**
 * @summary Link a team to a feature
 */
export type backofficeControllerAddTeamToFeatureV1Response204 = {
  data: void
  status: 204
}

export type backofficeControllerAddTeamToFeatureV1ResponseSuccess =
  backofficeControllerAddTeamToFeatureV1Response204 & {
    headers: Headers
  }
export type backofficeControllerAddTeamToFeatureV1Response =
  backofficeControllerAddTeamToFeatureV1ResponseSuccess

export const getBackofficeControllerAddTeamToFeatureV1Url = (
  featureId: number
) => {
  return `/api-arvore/v1/backoffice/features/${featureId}/teams`
}

export const backofficeControllerAddTeamToFeatureV1 = async (
  featureId: number,
  addTeamToFeatureBodyDto: AddTeamToFeatureBodyDto,
  options?: RequestInit
): Promise<backofficeControllerAddTeamToFeatureV1Response> => {
  return customInstance<backofficeControllerAddTeamToFeatureV1Response>(
    getBackofficeControllerAddTeamToFeatureV1Url(featureId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(addTeamToFeatureBodyDto)
    }
  )
}

/**
 * @summary Remove a team from a feature
 */
export type backofficeControllerRemoveTeamFromFeatureV1Response204 = {
  data: void
  status: 204
}

export type backofficeControllerRemoveTeamFromFeatureV1ResponseSuccess =
  backofficeControllerRemoveTeamFromFeatureV1Response204 & {
    headers: Headers
  }
export type backofficeControllerRemoveTeamFromFeatureV1Response =
  backofficeControllerRemoveTeamFromFeatureV1ResponseSuccess

export const getBackofficeControllerRemoveTeamFromFeatureV1Url = (
  featureId: number,
  teamId: number
) => {
  return `/api-arvore/v1/backoffice/features/${featureId}/teams/${teamId}`
}

export const backofficeControllerRemoveTeamFromFeatureV1 = async (
  featureId: number,
  teamId: number,
  options?: RequestInit
): Promise<backofficeControllerRemoveTeamFromFeatureV1Response> => {
  return customInstance<backofficeControllerRemoveTeamFromFeatureV1Response>(
    getBackofficeControllerRemoveTeamFromFeatureV1Url(featureId, teamId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List all backoffice teams
 */
export type backofficeControllerListTeamsV1Response200 = {
  data: void
  status: 200
}

export type backofficeControllerListTeamsV1ResponseSuccess =
  backofficeControllerListTeamsV1Response200 & {
    headers: Headers
  }
export type backofficeControllerListTeamsV1Response =
  backofficeControllerListTeamsV1ResponseSuccess

export const getBackofficeControllerListTeamsV1Url = () => {
  return `/api-arvore/v1/backoffice/teams`
}

export const backofficeControllerListTeamsV1 = async (
  options?: RequestInit
): Promise<backofficeControllerListTeamsV1Response> => {
  return customInstance<backofficeControllerListTeamsV1Response>(
    getBackofficeControllerListTeamsV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns all publishers with their ID, name and discount
 * @summary List all publishers
 */
export type publisherImportControllerListPublishersResponse200 = {
  data: ListPublishersResponseDto
  status: 200
}

export type publisherImportControllerListPublishersResponse403 = {
  data: void
  status: 403
}

export type publisherImportControllerListPublishersResponseSuccess =
  publisherImportControllerListPublishersResponse200 & {
    headers: Headers
  }
export type publisherImportControllerListPublishersResponseError =
  publisherImportControllerListPublishersResponse403 & {
    headers: Headers
  }

export type publisherImportControllerListPublishersResponse =
  | publisherImportControllerListPublishersResponseSuccess
  | publisherImportControllerListPublishersResponseError

export const getPublisherImportControllerListPublishersUrl = () => {
  return `/api-arvore/publishers`
}

export const publisherImportControllerListPublishers = async (
  options?: RequestInit
): Promise<publisherImportControllerListPublishersResponse> => {
  return customInstance<publisherImportControllerListPublishersResponse>(
    getPublisherImportControllerListPublishersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Reads CSV from CDN and queues each book for async processing via SQS
 * @summary Queue books import for a publisher
 */
export type publisherImportControllerImportBooksResponse201 = {
  data: QueueBooksResponseDto
  status: 201
}

export type publisherImportControllerImportBooksResponse403 = {
  data: void
  status: 403
}

export type publisherImportControllerImportBooksResponse404 = {
  data: void
  status: 404
}

export type publisherImportControllerImportBooksResponseSuccess =
  publisherImportControllerImportBooksResponse201 & {
    headers: Headers
  }
export type publisherImportControllerImportBooksResponseError = (
  | publisherImportControllerImportBooksResponse403
  | publisherImportControllerImportBooksResponse404
) & {
  headers: Headers
}

export type publisherImportControllerImportBooksResponse =
  | publisherImportControllerImportBooksResponseSuccess
  | publisherImportControllerImportBooksResponseError

export const getPublisherImportControllerImportBooksUrl = (
  publisherId: number
) => {
  return `/api-arvore/publishers/${publisherId}/import-books`
}

export const publisherImportControllerImportBooks = async (
  publisherId: number,
  options?: RequestInit
): Promise<publisherImportControllerImportBooksResponse> => {
  return customInstance<publisherImportControllerImportBooksResponse>(
    getPublisherImportControllerImportBooksUrl(publisherId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List all publishers with status and counts
 */
export type publisherAdminControllerListPublishersV1Response200 = {
  data: void
  status: 200
}

export type publisherAdminControllerListPublishersV1ResponseSuccess =
  publisherAdminControllerListPublishersV1Response200 & {
    headers: Headers
  }
export type publisherAdminControllerListPublishersV1Response =
  publisherAdminControllerListPublishersV1ResponseSuccess

export const getPublisherAdminControllerListPublishersV1Url = () => {
  return `/api-arvore/v1/publisher-portal/admin/publishers`
}

export const publisherAdminControllerListPublishersV1 = async (
  options?: RequestInit
): Promise<publisherAdminControllerListPublishersV1Response> => {
  return customInstance<publisherAdminControllerListPublishersV1Response>(
    getPublisherAdminControllerListPublishersV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new publisher workspace with slug
 */
export type publisherAdminControllerCreatePublisherV1Response201 = {
  data: void
  status: 201
}

export type publisherAdminControllerCreatePublisherV1ResponseSuccess =
  publisherAdminControllerCreatePublisherV1Response201 & {
    headers: Headers
  }
export type publisherAdminControllerCreatePublisherV1Response =
  publisherAdminControllerCreatePublisherV1ResponseSuccess

export const getPublisherAdminControllerCreatePublisherV1Url = () => {
  return `/api-arvore/v1/publisher-portal/admin/publishers`
}

export const publisherAdminControllerCreatePublisherV1 = async (
  createPublisherDto: CreatePublisherDto,
  options?: RequestInit
): Promise<publisherAdminControllerCreatePublisherV1Response> => {
  return customInstance<publisherAdminControllerCreatePublisherV1Response>(
    getPublisherAdminControllerCreatePublisherV1Url(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createPublisherDto)
    }
  )
}

/**
 * @summary List files for a publisher workspace
 */
export type publisherAdminControllerListPublisherFilesV1Response200 = {
  data: void
  status: 200
}

export type publisherAdminControllerListPublisherFilesV1ResponseSuccess =
  publisherAdminControllerListPublisherFilesV1Response200 & {
    headers: Headers
  }
export type publisherAdminControllerListPublisherFilesV1Response =
  publisherAdminControllerListPublisherFilesV1ResponseSuccess

export const getPublisherAdminControllerListPublisherFilesV1Url = (
  slug: string
) => {
  return `/api-arvore/v1/publisher-portal/admin/publishers/${slug}/files`
}

export const publisherAdminControllerListPublisherFilesV1 = async (
  slug: string,
  options?: RequestInit
): Promise<publisherAdminControllerListPublisherFilesV1Response> => {
  return customInstance<publisherAdminControllerListPublisherFilesV1Response>(
    getPublisherAdminControllerListPublisherFilesV1Url(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get publisher workspace by slug
 */
export type publisherPortalControllerGetWorkspaceV1Response200 = {
  data: void
  status: 200
}

export type publisherPortalControllerGetWorkspaceV1ResponseSuccess =
  publisherPortalControllerGetWorkspaceV1Response200 & {
    headers: Headers
  }
export type publisherPortalControllerGetWorkspaceV1Response =
  publisherPortalControllerGetWorkspaceV1ResponseSuccess

export const getPublisherPortalControllerGetWorkspaceV1Url = (slug: string) => {
  return `/api-arvore/v1/publisher-portal/${slug}`
}

export const publisherPortalControllerGetWorkspaceV1 = async (
  slug: string,
  options?: RequestInit
): Promise<publisherPortalControllerGetWorkspaceV1Response> => {
  return customInstance<publisherPortalControllerGetWorkspaceV1Response>(
    getPublisherPortalControllerGetWorkspaceV1Url(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload and validate CSV metadata file
 */
export type publisherPortalControllerUploadMetadataV1Response201 = {
  data: void
  status: 201
}

export type publisherPortalControllerUploadMetadataV1ResponseSuccess =
  publisherPortalControllerUploadMetadataV1Response201 & {
    headers: Headers
  }
export type publisherPortalControllerUploadMetadataV1Response =
  publisherPortalControllerUploadMetadataV1ResponseSuccess

export const getPublisherPortalControllerUploadMetadataV1Url = (
  slug: string
) => {
  return `/api-arvore/v1/publisher-portal/${slug}/metadata`
}

export const publisherPortalControllerUploadMetadataV1 = async (
  slug: string,
  options?: RequestInit
): Promise<publisherPortalControllerUploadMetadataV1Response> => {
  return customInstance<publisherPortalControllerUploadMetadataV1Response>(
    getPublisherPortalControllerUploadMetadataV1Url(slug),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List files in publisher workspace
 */
export type publisherPortalControllerListFilesV1Response200 = {
  data: void
  status: 200
}

export type publisherPortalControllerListFilesV1ResponseSuccess =
  publisherPortalControllerListFilesV1Response200 & {
    headers: Headers
  }
export type publisherPortalControllerListFilesV1Response =
  publisherPortalControllerListFilesV1ResponseSuccess

export const getPublisherPortalControllerListFilesV1Url = (slug: string) => {
  return `/api-arvore/v1/publisher-portal/${slug}/files`
}

export const publisherPortalControllerListFilesV1 = async (
  slug: string,
  options?: RequestInit
): Promise<publisherPortalControllerListFilesV1Response> => {
  return customInstance<publisherPortalControllerListFilesV1Response>(
    getPublisherPortalControllerListFilesV1Url(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Request a presigned upload URL
 */
export type publisherPortalControllerRequestUploadUrlV1Response201 = {
  data: void
  status: 201
}

export type publisherPortalControllerRequestUploadUrlV1ResponseSuccess =
  publisherPortalControllerRequestUploadUrlV1Response201 & {
    headers: Headers
  }
export type publisherPortalControllerRequestUploadUrlV1Response =
  publisherPortalControllerRequestUploadUrlV1ResponseSuccess

export const getPublisherPortalControllerRequestUploadUrlV1Url = (
  slug: string
) => {
  return `/api-arvore/v1/publisher-portal/${slug}/files/upload-url`
}

export const publisherPortalControllerRequestUploadUrlV1 = async (
  slug: string,
  uploadUrlRequestDto: UploadUrlRequestDto,
  options?: RequestInit
): Promise<publisherPortalControllerRequestUploadUrlV1Response> => {
  return customInstance<publisherPortalControllerRequestUploadUrlV1Response>(
    getPublisherPortalControllerRequestUploadUrlV1Url(slug),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(uploadUrlRequestDto)
    }
  )
}

/**
 * @summary Confirm file upload and register in database
 */
export type publisherPortalControllerConfirmUploadV1Response201 = {
  data: void
  status: 201
}

export type publisherPortalControllerConfirmUploadV1ResponseSuccess =
  publisherPortalControllerConfirmUploadV1Response201 & {
    headers: Headers
  }
export type publisherPortalControllerConfirmUploadV1Response =
  publisherPortalControllerConfirmUploadV1ResponseSuccess

export const getPublisherPortalControllerConfirmUploadV1Url = (
  slug: string
) => {
  return `/api-arvore/v1/publisher-portal/${slug}/files/confirm`
}

export const publisherPortalControllerConfirmUploadV1 = async (
  slug: string,
  confirmUploadDto: ConfirmUploadDto,
  options?: RequestInit
): Promise<publisherPortalControllerConfirmUploadV1Response> => {
  return customInstance<publisherPortalControllerConfirmUploadV1Response>(
    getPublisherPortalControllerConfirmUploadV1Url(slug),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmUploadDto)
    }
  )
}

/**
 * @summary Get a presigned download URL for a file
 */
export type publisherPortalControllerGetDownloadUrlV1Response200 = {
  data: void
  status: 200
}

export type publisherPortalControllerGetDownloadUrlV1ResponseSuccess =
  publisherPortalControllerGetDownloadUrlV1Response200 & {
    headers: Headers
  }
export type publisherPortalControllerGetDownloadUrlV1Response =
  publisherPortalControllerGetDownloadUrlV1ResponseSuccess

export const getPublisherPortalControllerGetDownloadUrlV1Url = (
  slug: string,
  fileId: number
) => {
  return `/api-arvore/v1/publisher-portal/${slug}/files/${fileId}/download-url`
}

export const publisherPortalControllerGetDownloadUrlV1 = async (
  slug: string,
  fileId: number,
  options?: RequestInit
): Promise<publisherPortalControllerGetDownloadUrlV1Response> => {
  return customInstance<publisherPortalControllerGetDownloadUrlV1Response>(
    getPublisherPortalControllerGetDownloadUrlV1Url(slug, fileId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete a file from publisher workspace
 */
export type publisherPortalControllerDeleteFileV1Response204 = {
  data: void
  status: 204
}

export type publisherPortalControllerDeleteFileV1ResponseSuccess =
  publisherPortalControllerDeleteFileV1Response204 & {
    headers: Headers
  }
export type publisherPortalControllerDeleteFileV1Response =
  publisherPortalControllerDeleteFileV1ResponseSuccess

export const getPublisherPortalControllerDeleteFileV1Url = (
  slug: string,
  fileId: number
) => {
  return `/api-arvore/v1/publisher-portal/${slug}/files/${fileId}`
}

export const publisherPortalControllerDeleteFileV1 = async (
  slug: string,
  fileId: number,
  options?: RequestInit
): Promise<publisherPortalControllerDeleteFileV1Response> => {
  return customInstance<publisherPortalControllerDeleteFileV1Response>(
    getPublisherPortalControllerDeleteFileV1Url(slug, fileId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List publisher settlements grouped by month/year
 */
export type publisherSettlementControllerListV1Response200 = {
  data: void
  status: 200
}

export type publisherSettlementControllerListV1ResponseSuccess =
  publisherSettlementControllerListV1Response200 & {
    headers: Headers
  }
export type publisherSettlementControllerListV1Response =
  publisherSettlementControllerListV1ResponseSuccess

export const getPublisherSettlementControllerListV1Url = (
  params?: PublisherSettlementControllerListV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/publisher-settlement?${stringifiedParams}`
    : `/api-arvore/v1/publisher-settlement`
}

export const publisherSettlementControllerListV1 = async (
  params?: PublisherSettlementControllerListV1Params,
  options?: RequestInit
): Promise<publisherSettlementControllerListV1Response> => {
  return customInstance<publisherSettlementControllerListV1Response>(
    getPublisherSettlementControllerListV1Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get settlement detail by ID (year-month)
 */
export type publisherSettlementControllerDetailV1Response200 = {
  data: void
  status: 200
}

export type publisherSettlementControllerDetailV1ResponseSuccess =
  publisherSettlementControllerDetailV1Response200 & {
    headers: Headers
  }
export type publisherSettlementControllerDetailV1Response =
  publisherSettlementControllerDetailV1ResponseSuccess

export const getPublisherSettlementControllerDetailV1Url = (
  settlementId: string
) => {
  return `/api-arvore/v1/publisher-settlement/${settlementId}`
}

export const publisherSettlementControllerDetailV1 = async (
  settlementId: string,
  options?: RequestInit
): Promise<publisherSettlementControllerDetailV1Response> => {
  return customInstance<publisherSettlementControllerDetailV1Response>(
    getPublisherSettlementControllerDetailV1Url(settlementId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Register a push token for the current user
 */
export type pushNotificationsControllerRegisterPushTokenResponse201 = {
  data: RegisterPushTokenResponseDto
  status: 201
}

export type pushNotificationsControllerRegisterPushTokenResponseSuccess =
  pushNotificationsControllerRegisterPushTokenResponse201 & {
    headers: Headers
  }
export type pushNotificationsControllerRegisterPushTokenResponse =
  pushNotificationsControllerRegisterPushTokenResponseSuccess

export const getPushNotificationsControllerRegisterPushTokenUrl = () => {
  return `/api-arvore/push-tokens`
}

export const pushNotificationsControllerRegisterPushToken = async (
  registerPushTokenBodyDto: RegisterPushTokenBodyDto,
  options?: RequestInit
): Promise<pushNotificationsControllerRegisterPushTokenResponse> => {
  return customInstance<pushNotificationsControllerRegisterPushTokenResponse>(
    getPushNotificationsControllerRegisterPushTokenUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerPushTokenBodyDto)
    }
  )
}

/**
 * @summary Remove push token(s) for the current user
 */
export type pushNotificationsControllerRemovePushTokenResponse204 = {
  data: void
  status: 204
}

export type pushNotificationsControllerRemovePushTokenResponseSuccess =
  pushNotificationsControllerRemovePushTokenResponse204 & {
    headers: Headers
  }
export type pushNotificationsControllerRemovePushTokenResponse =
  pushNotificationsControllerRemovePushTokenResponseSuccess

export const getPushNotificationsControllerRemovePushTokenUrl = (
  params?: PushNotificationsControllerRemovePushTokenParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/push-tokens?${stringifiedParams}`
    : `/api-arvore/push-tokens`
}

export const pushNotificationsControllerRemovePushToken = async (
  params?: PushNotificationsControllerRemovePushTokenParams,
  options?: RequestInit
): Promise<pushNotificationsControllerRemovePushTokenResponse> => {
  return customInstance<pushNotificationsControllerRemovePushTokenResponse>(
    getPushNotificationsControllerRemovePushTokenUrl(params),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Check if the current user has an active push token
 */
export type pushNotificationsControllerHasActivePushTokenResponse200 = {
  data: HasActivePushTokenResponseDto
  status: 200
}

export type pushNotificationsControllerHasActivePushTokenResponseSuccess =
  pushNotificationsControllerHasActivePushTokenResponse200 & {
    headers: Headers
  }
export type pushNotificationsControllerHasActivePushTokenResponse =
  pushNotificationsControllerHasActivePushTokenResponseSuccess

export const getPushNotificationsControllerHasActivePushTokenUrl = () => {
  return `/api-arvore/push-tokens/me`
}

export const pushNotificationsControllerHasActivePushToken = async (
  options?: RequestInit
): Promise<pushNotificationsControllerHasActivePushTokenResponse> => {
  return customInstance<pushNotificationsControllerHasActivePushTokenResponse>(
    getPushNotificationsControllerHasActivePushTokenUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Send push notification to filtered users
 */
export type pushNotificationsControllerSendPushNotificationResponse201 = {
  data: SendPushNotificationResponseDto
  status: 201
}

export type pushNotificationsControllerSendPushNotificationResponse403 = {
  data: void
  status: 403
}

export type pushNotificationsControllerSendPushNotificationResponseSuccess =
  pushNotificationsControllerSendPushNotificationResponse201 & {
    headers: Headers
  }
export type pushNotificationsControllerSendPushNotificationResponseError =
  pushNotificationsControllerSendPushNotificationResponse403 & {
    headers: Headers
  }

export type pushNotificationsControllerSendPushNotificationResponse =
  | pushNotificationsControllerSendPushNotificationResponseSuccess
  | pushNotificationsControllerSendPushNotificationResponseError

export const getPushNotificationsControllerSendPushNotificationUrl = () => {
  return `/api-arvore/push-notifications/send`
}

export const pushNotificationsControllerSendPushNotification = async (
  sendPushNotificationBodyDto: SendPushNotificationBodyDto,
  options?: RequestInit
): Promise<pushNotificationsControllerSendPushNotificationResponse> => {
  return customInstance<pushNotificationsControllerSendPushNotificationResponse>(
    getPushNotificationsControllerSendPushNotificationUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sendPushNotificationBodyDto)
    }
  )
}

/**
 * @summary List push notifications with pagination
 */
export type pushNotificationsControllerListPushNotificationsResponse200 = {
  data: ListPushNotificationsResponseDto
  status: 200
}

export type pushNotificationsControllerListPushNotificationsResponse403 = {
  data: void
  status: 403
}

export type pushNotificationsControllerListPushNotificationsResponseSuccess =
  pushNotificationsControllerListPushNotificationsResponse200 & {
    headers: Headers
  }
export type pushNotificationsControllerListPushNotificationsResponseError =
  pushNotificationsControllerListPushNotificationsResponse403 & {
    headers: Headers
  }

export type pushNotificationsControllerListPushNotificationsResponse =
  | pushNotificationsControllerListPushNotificationsResponseSuccess
  | pushNotificationsControllerListPushNotificationsResponseError

export const getPushNotificationsControllerListPushNotificationsUrl = (
  params?: PushNotificationsControllerListPushNotificationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/push-notifications?${stringifiedParams}`
    : `/api-arvore/push-notifications`
}

export const pushNotificationsControllerListPushNotifications = async (
  params?: PushNotificationsControllerListPushNotificationsParams,
  options?: RequestInit
): Promise<pushNotificationsControllerListPushNotificationsResponse> => {
  return customInstance<pushNotificationsControllerListPushNotificationsResponse>(
    getPushNotificationsControllerListPushNotificationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get push notification details
 */
export type pushNotificationsControllerGetPushNotificationResponse200 = {
  data: PushNotificationDetailsResponseDto
  status: 200
}

export type pushNotificationsControllerGetPushNotificationResponse403 = {
  data: void
  status: 403
}

export type pushNotificationsControllerGetPushNotificationResponse404 = {
  data: void
  status: 404
}

export type pushNotificationsControllerGetPushNotificationResponseSuccess =
  pushNotificationsControllerGetPushNotificationResponse200 & {
    headers: Headers
  }
export type pushNotificationsControllerGetPushNotificationResponseError = (
  | pushNotificationsControllerGetPushNotificationResponse403
  | pushNotificationsControllerGetPushNotificationResponse404
) & {
  headers: Headers
}

export type pushNotificationsControllerGetPushNotificationResponse =
  | pushNotificationsControllerGetPushNotificationResponseSuccess
  | pushNotificationsControllerGetPushNotificationResponseError

export const getPushNotificationsControllerGetPushNotificationUrl = (
  id: string
) => {
  return `/api-arvore/push-notifications/${id}`
}

export const pushNotificationsControllerGetPushNotification = async (
  id: string,
  options?: RequestInit
): Promise<pushNotificationsControllerGetPushNotificationResponse> => {
  return customInstance<pushNotificationsControllerGetPushNotificationResponse>(
    getPushNotificationsControllerGetPushNotificationUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List custom notification workflows
 */
export type customNotificationsControllerListNotificationsResponse200 = {
  data: CustomNotificationsControllerListNotifications200
  status: 200
}

export type customNotificationsControllerListNotificationsResponseSuccess =
  customNotificationsControllerListNotificationsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerListNotificationsResponse =
  customNotificationsControllerListNotificationsResponseSuccess

export const getCustomNotificationsControllerListNotificationsUrl = (
  params?: CustomNotificationsControllerListNotificationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/custom-notifications?${stringifiedParams}`
    : `/api-arvore/custom-notifications`
}

export const customNotificationsControllerListNotifications = async (
  params?: CustomNotificationsControllerListNotificationsParams,
  options?: RequestInit
): Promise<customNotificationsControllerListNotificationsResponse> => {
  return customInstance<customNotificationsControllerListNotificationsResponse>(
    getCustomNotificationsControllerListNotificationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a custom notification workflow
 */
export type customNotificationsControllerCreateNotificationResponse201 = {
  data: CustomNotificationsControllerCreateNotification201
  status: 201
}

export type customNotificationsControllerCreateNotificationResponseSuccess =
  customNotificationsControllerCreateNotificationResponse201 & {
    headers: Headers
  }
export type customNotificationsControllerCreateNotificationResponse =
  customNotificationsControllerCreateNotificationResponseSuccess

export const getCustomNotificationsControllerCreateNotificationUrl = () => {
  return `/api-arvore/custom-notifications`
}

export const customNotificationsControllerCreateNotification = async (
  createNotificationDto: CreateNotificationDto,
  options?: RequestInit
): Promise<customNotificationsControllerCreateNotificationResponse> => {
  return customInstance<customNotificationsControllerCreateNotificationResponse>(
    getCustomNotificationsControllerCreateNotificationUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createNotificationDto)
    }
  )
}

/**
 * @summary Get available conditions for workflow builder
 */
export type customNotificationsControllerGetAvailableConditionsResponse200 = {
  data: CustomNotificationsControllerGetAvailableConditions200Item[]
  status: 200
}

export type customNotificationsControllerGetAvailableConditionsResponseSuccess =
  customNotificationsControllerGetAvailableConditionsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerGetAvailableConditionsResponse =
  customNotificationsControllerGetAvailableConditionsResponseSuccess

export const getCustomNotificationsControllerGetAvailableConditionsUrl = () => {
  return `/api-arvore/custom-notifications/available-conditions`
}

export const customNotificationsControllerGetAvailableConditions = async (
  options?: RequestInit
): Promise<customNotificationsControllerGetAvailableConditionsResponse> => {
  return customInstance<customNotificationsControllerGetAvailableConditionsResponse>(
    getCustomNotificationsControllerGetAvailableConditionsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get available template variables
 */
export type customNotificationsControllerGetAvailableVariablesResponse200 = {
  data: CustomNotificationsControllerGetAvailableVariables200Item[]
  status: 200
}

export type customNotificationsControllerGetAvailableVariablesResponseSuccess =
  customNotificationsControllerGetAvailableVariablesResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerGetAvailableVariablesResponse =
  customNotificationsControllerGetAvailableVariablesResponseSuccess

export const getCustomNotificationsControllerGetAvailableVariablesUrl = () => {
  return `/api-arvore/custom-notifications/available-variables`
}

export const customNotificationsControllerGetAvailableVariables = async (
  options?: RequestInit
): Promise<customNotificationsControllerGetAvailableVariablesResponse> => {
  return customInstance<customNotificationsControllerGetAvailableVariablesResponse>(
    getCustomNotificationsControllerGetAvailableVariablesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get dynamic options for a condition field
 */
export type customNotificationsControllerGetConditionOptionsResponse200 = {
  data: CustomNotificationsControllerGetConditionOptions200Item[]
  status: 200
}

export type customNotificationsControllerGetConditionOptionsResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerGetConditionOptionsResponseSuccess =
  customNotificationsControllerGetConditionOptionsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerGetConditionOptionsResponseError =
  customNotificationsControllerGetConditionOptionsResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerGetConditionOptionsResponse =
  | customNotificationsControllerGetConditionOptionsResponseSuccess
  | customNotificationsControllerGetConditionOptionsResponseError

export const getCustomNotificationsControllerGetConditionOptionsUrl = (
  field: string
) => {
  return `/api-arvore/custom-notifications/condition-options/${field}`
}

export const customNotificationsControllerGetConditionOptions = async (
  field: string,
  options?: RequestInit
): Promise<customNotificationsControllerGetConditionOptionsResponse> => {
  return customInstance<customNotificationsControllerGetConditionOptionsResponse>(
    getCustomNotificationsControllerGetConditionOptionsUrl(field),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List audit logs
 */
export type customNotificationsControllerListAuditLogsResponse200 = {
  data: CustomNotificationsControllerListAuditLogs200
  status: 200
}

export type customNotificationsControllerListAuditLogsResponseSuccess =
  customNotificationsControllerListAuditLogsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerListAuditLogsResponse =
  customNotificationsControllerListAuditLogsResponseSuccess

export const getCustomNotificationsControllerListAuditLogsUrl = (
  params?: CustomNotificationsControllerListAuditLogsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/custom-notifications/audit-logs?${stringifiedParams}`
    : `/api-arvore/custom-notifications/audit-logs`
}

export const customNotificationsControllerListAuditLogs = async (
  params?: CustomNotificationsControllerListAuditLogsParams,
  options?: RequestInit
): Promise<customNotificationsControllerListAuditLogsResponse> => {
  return customInstance<customNotificationsControllerListAuditLogsResponse>(
    getCustomNotificationsControllerListAuditLogsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get execution details
 */
export type customNotificationsControllerGetExecutionDetailsResponse200 = {
  data: CustomNotificationsControllerGetExecutionDetails200
  status: 200
}

export type customNotificationsControllerGetExecutionDetailsResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerGetExecutionDetailsResponseSuccess =
  customNotificationsControllerGetExecutionDetailsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerGetExecutionDetailsResponseError =
  customNotificationsControllerGetExecutionDetailsResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerGetExecutionDetailsResponse =
  | customNotificationsControllerGetExecutionDetailsResponseSuccess
  | customNotificationsControllerGetExecutionDetailsResponseError

export const getCustomNotificationsControllerGetExecutionDetailsUrl = (
  executionId: string
) => {
  return `/api-arvore/custom-notifications/executions/${executionId}`
}

export const customNotificationsControllerGetExecutionDetails = async (
  executionId: string,
  options?: RequestInit
): Promise<customNotificationsControllerGetExecutionDetailsResponse> => {
  return customInstance<customNotificationsControllerGetExecutionDetailsResponse>(
    getCustomNotificationsControllerGetExecutionDetailsUrl(executionId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get custom notification workflow details
 */
export type customNotificationsControllerGetNotificationResponse200 = {
  data: CustomNotificationsControllerGetNotification200
  status: 200
}

export type customNotificationsControllerGetNotificationResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerGetNotificationResponseSuccess =
  customNotificationsControllerGetNotificationResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerGetNotificationResponseError =
  customNotificationsControllerGetNotificationResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerGetNotificationResponse =
  | customNotificationsControllerGetNotificationResponseSuccess
  | customNotificationsControllerGetNotificationResponseError

export const getCustomNotificationsControllerGetNotificationUrl = (
  id: string
) => {
  return `/api-arvore/custom-notifications/${id}`
}

export const customNotificationsControllerGetNotification = async (
  id: string,
  options?: RequestInit
): Promise<customNotificationsControllerGetNotificationResponse> => {
  return customInstance<customNotificationsControllerGetNotificationResponse>(
    getCustomNotificationsControllerGetNotificationUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update a custom notification workflow
 */
export type customNotificationsControllerUpdateNotificationResponse200 = {
  data: CustomNotificationsControllerUpdateNotification200
  status: 200
}

export type customNotificationsControllerUpdateNotificationResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerUpdateNotificationResponseSuccess =
  customNotificationsControllerUpdateNotificationResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerUpdateNotificationResponseError =
  customNotificationsControllerUpdateNotificationResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerUpdateNotificationResponse =
  | customNotificationsControllerUpdateNotificationResponseSuccess
  | customNotificationsControllerUpdateNotificationResponseError

export const getCustomNotificationsControllerUpdateNotificationUrl = (
  id: string
) => {
  return `/api-arvore/custom-notifications/${id}`
}

export const customNotificationsControllerUpdateNotification = async (
  id: string,
  updateNotificationDto: UpdateNotificationDto,
  options?: RequestInit
): Promise<customNotificationsControllerUpdateNotificationResponse> => {
  return customInstance<customNotificationsControllerUpdateNotificationResponse>(
    getCustomNotificationsControllerUpdateNotificationUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateNotificationDto)
    }
  )
}

/**
 * @summary Delete a custom notification workflow
 */
export type customNotificationsControllerDeleteNotificationResponse204 = {
  data: void
  status: 204
}

export type customNotificationsControllerDeleteNotificationResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerDeleteNotificationResponseSuccess =
  customNotificationsControllerDeleteNotificationResponse204 & {
    headers: Headers
  }
export type customNotificationsControllerDeleteNotificationResponseError =
  customNotificationsControllerDeleteNotificationResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerDeleteNotificationResponse =
  | customNotificationsControllerDeleteNotificationResponseSuccess
  | customNotificationsControllerDeleteNotificationResponseError

export const getCustomNotificationsControllerDeleteNotificationUrl = (
  id: string
) => {
  return `/api-arvore/custom-notifications/${id}`
}

export const customNotificationsControllerDeleteNotification = async (
  id: string,
  options?: RequestInit
): Promise<customNotificationsControllerDeleteNotificationResponse> => {
  return customInstance<customNotificationsControllerDeleteNotificationResponse>(
    getCustomNotificationsControllerDeleteNotificationUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Toggle notification active status
 */
export type customNotificationsControllerToggleNotificationResponse200 = {
  data: CustomNotificationsControllerToggleNotification200
  status: 200
}

export type customNotificationsControllerToggleNotificationResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerToggleNotificationResponseSuccess =
  customNotificationsControllerToggleNotificationResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerToggleNotificationResponseError =
  customNotificationsControllerToggleNotificationResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerToggleNotificationResponse =
  | customNotificationsControllerToggleNotificationResponseSuccess
  | customNotificationsControllerToggleNotificationResponseError

export const getCustomNotificationsControllerToggleNotificationUrl = (
  id: string
) => {
  return `/api-arvore/custom-notifications/${id}/toggle`
}

export const customNotificationsControllerToggleNotification = async (
  id: string,
  options?: RequestInit
): Promise<customNotificationsControllerToggleNotificationResponse> => {
  return customInstance<customNotificationsControllerToggleNotificationResponse>(
    getCustomNotificationsControllerToggleNotificationUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Manually execute a notification workflow
 */
export type customNotificationsControllerExecuteNotificationResponse201 = {
  data: CustomNotificationsControllerExecuteNotification201
  status: 201
}

export type customNotificationsControllerExecuteNotificationResponse404 = {
  data: void
  status: 404
}

export type customNotificationsControllerExecuteNotificationResponseSuccess =
  customNotificationsControllerExecuteNotificationResponse201 & {
    headers: Headers
  }
export type customNotificationsControllerExecuteNotificationResponseError =
  customNotificationsControllerExecuteNotificationResponse404 & {
    headers: Headers
  }

export type customNotificationsControllerExecuteNotificationResponse =
  | customNotificationsControllerExecuteNotificationResponseSuccess
  | customNotificationsControllerExecuteNotificationResponseError

export const getCustomNotificationsControllerExecuteNotificationUrl = (
  id: string
) => {
  return `/api-arvore/custom-notifications/${id}/execute`
}

export const customNotificationsControllerExecuteNotification = async (
  id: string,
  options?: RequestInit
): Promise<customNotificationsControllerExecuteNotificationResponse> => {
  return customInstance<customNotificationsControllerExecuteNotificationResponse>(
    getCustomNotificationsControllerExecuteNotificationUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List executions for a notification
 */
export type customNotificationsControllerListExecutionsResponse200 = {
  data: CustomNotificationsControllerListExecutions200
  status: 200
}

export type customNotificationsControllerListExecutionsResponseSuccess =
  customNotificationsControllerListExecutionsResponse200 & {
    headers: Headers
  }
export type customNotificationsControllerListExecutionsResponse =
  customNotificationsControllerListExecutionsResponseSuccess

export const getCustomNotificationsControllerListExecutionsUrl = (
  id: string,
  params: CustomNotificationsControllerListExecutionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/custom-notifications/${id}/executions?${stringifiedParams}`
    : `/api-arvore/custom-notifications/${id}/executions`
}

export const customNotificationsControllerListExecutions = async (
  id: string,
  params: CustomNotificationsControllerListExecutionsParams,
  options?: RequestInit
): Promise<customNotificationsControllerListExecutionsResponse> => {
  return customInstance<customNotificationsControllerListExecutionsResponse>(
    getCustomNotificationsControllerListExecutionsUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List notifications for the current user
 */
export type userNotificationsControllerListNotificationsResponse200 = {
  data: UserNotificationsControllerListNotifications200
  status: 200
}

export type userNotificationsControllerListNotificationsResponseSuccess =
  userNotificationsControllerListNotificationsResponse200 & {
    headers: Headers
  }
export type userNotificationsControllerListNotificationsResponse =
  userNotificationsControllerListNotificationsResponseSuccess

export const getUserNotificationsControllerListNotificationsUrl = (
  params?: UserNotificationsControllerListNotificationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/notifications/me?${stringifiedParams}`
    : `/api-arvore/notifications/me`
}

export const userNotificationsControllerListNotifications = async (
  params?: UserNotificationsControllerListNotificationsParams,
  options?: RequestInit
): Promise<userNotificationsControllerListNotificationsResponse> => {
  return customInstance<userNotificationsControllerListNotificationsResponse>(
    getUserNotificationsControllerListNotificationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get unread notification count
 */
export type userNotificationsControllerGetUnreadCountResponse200 = {
  data: UserNotificationsControllerGetUnreadCount200
  status: 200
}

export type userNotificationsControllerGetUnreadCountResponseSuccess =
  userNotificationsControllerGetUnreadCountResponse200 & {
    headers: Headers
  }
export type userNotificationsControllerGetUnreadCountResponse =
  userNotificationsControllerGetUnreadCountResponseSuccess

export const getUserNotificationsControllerGetUnreadCountUrl = () => {
  return `/api-arvore/notifications/me/unread-count`
}

export const userNotificationsControllerGetUnreadCount = async (
  options?: RequestInit
): Promise<userNotificationsControllerGetUnreadCountResponse> => {
  return customInstance<userNotificationsControllerGetUnreadCountResponse>(
    getUserNotificationsControllerGetUnreadCountUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Mark all notifications as read
 */
export type userNotificationsControllerMarkAllAsReadResponse204 = {
  data: void
  status: 204
}

export type userNotificationsControllerMarkAllAsReadResponseSuccess =
  userNotificationsControllerMarkAllAsReadResponse204 & {
    headers: Headers
  }
export type userNotificationsControllerMarkAllAsReadResponse =
  userNotificationsControllerMarkAllAsReadResponseSuccess

export const getUserNotificationsControllerMarkAllAsReadUrl = () => {
  return `/api-arvore/notifications/read-all`
}

export const userNotificationsControllerMarkAllAsRead = async (
  options?: RequestInit
): Promise<userNotificationsControllerMarkAllAsReadResponse> => {
  return customInstance<userNotificationsControllerMarkAllAsReadResponse>(
    getUserNotificationsControllerMarkAllAsReadUrl(),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Mark a notification as read
 */
export type userNotificationsControllerMarkAsReadResponse204 = {
  data: void
  status: 204
}

export type userNotificationsControllerMarkAsReadResponse404 = {
  data: void
  status: 404
}

export type userNotificationsControllerMarkAsReadResponseSuccess =
  userNotificationsControllerMarkAsReadResponse204 & {
    headers: Headers
  }
export type userNotificationsControllerMarkAsReadResponseError =
  userNotificationsControllerMarkAsReadResponse404 & {
    headers: Headers
  }

export type userNotificationsControllerMarkAsReadResponse =
  | userNotificationsControllerMarkAsReadResponseSuccess
  | userNotificationsControllerMarkAsReadResponseError

export const getUserNotificationsControllerMarkAsReadUrl = (id: string) => {
  return `/api-arvore/notifications/${id}/read`
}

export const userNotificationsControllerMarkAsRead = async (
  id: string,
  options?: RequestInit
): Promise<userNotificationsControllerMarkAsReadResponse> => {
  return customInstance<userNotificationsControllerMarkAsReadResponse>(
    getUserNotificationsControllerMarkAsReadUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Register notification click
 */
export type userNotificationsControllerMarkAsClickedResponse204 = {
  data: void
  status: 204
}

export type userNotificationsControllerMarkAsClickedResponse404 = {
  data: void
  status: 404
}

export type userNotificationsControllerMarkAsClickedResponseSuccess =
  userNotificationsControllerMarkAsClickedResponse204 & {
    headers: Headers
  }
export type userNotificationsControllerMarkAsClickedResponseError =
  userNotificationsControllerMarkAsClickedResponse404 & {
    headers: Headers
  }

export type userNotificationsControllerMarkAsClickedResponse =
  | userNotificationsControllerMarkAsClickedResponseSuccess
  | userNotificationsControllerMarkAsClickedResponseError

export const getUserNotificationsControllerMarkAsClickedUrl = (id: string) => {
  return `/api-arvore/notifications/${id}/clicked`
}

export const userNotificationsControllerMarkAsClicked = async (
  id: string,
  options?: RequestInit
): Promise<userNotificationsControllerMarkAsClickedResponse> => {
  return customInstance<userNotificationsControllerMarkAsClickedResponse>(
    getUserNotificationsControllerMarkAsClickedUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Dismiss a notification
 */
export type userNotificationsControllerDismissResponse204 = {
  data: void
  status: 204
}

export type userNotificationsControllerDismissResponse404 = {
  data: void
  status: 404
}

export type userNotificationsControllerDismissResponseSuccess =
  userNotificationsControllerDismissResponse204 & {
    headers: Headers
  }
export type userNotificationsControllerDismissResponseError =
  userNotificationsControllerDismissResponse404 & {
    headers: Headers
  }

export type userNotificationsControllerDismissResponse =
  | userNotificationsControllerDismissResponseSuccess
  | userNotificationsControllerDismissResponseError

export const getUserNotificationsControllerDismissUrl = (id: string) => {
  return `/api-arvore/notifications/${id}/dismiss`
}

export const userNotificationsControllerDismiss = async (
  id: string,
  options?: RequestInit
): Promise<userNotificationsControllerDismissResponse> => {
  return customInstance<userNotificationsControllerDismissResponse>(
    getUserNotificationsControllerDismissUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * Returns a curated list of books matching the student comprehension level and degree from reading fluency assessments.
 * @summary Get recommended books based on student comprehension level
 */
export type readingFluencyControllerGetRecommendedBooksByLevelResponse200 = {
  data: GetRecommendedBooksByLevelResponseDto
  status: 200
}

export type readingFluencyControllerGetRecommendedBooksByLevelResponseSuccess =
  readingFluencyControllerGetRecommendedBooksByLevelResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerGetRecommendedBooksByLevelResponse =
  readingFluencyControllerGetRecommendedBooksByLevelResponseSuccess

export const getReadingFluencyControllerGetRecommendedBooksByLevelUrl = () => {
  return `/api-arvore/reading-fluency/recommended-books-by-level`
}

export const readingFluencyControllerGetRecommendedBooksByLevel = async (
  options?: RequestInit
): Promise<readingFluencyControllerGetRecommendedBooksByLevelResponse> => {
  return customInstance<readingFluencyControllerGetRecommendedBooksByLevelResponse>(
    getReadingFluencyControllerGetRecommendedBooksByLevelUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Creates a reading fluency assessment for students in the specified classes. Only available for teachers with the reading fluency feature enabled.
 * @summary Start a reading fluency assessment for teacher classes
 */
export type readingFluencyControllerStartReadingFluencyAssessmentResponse201 = {
  data: StartReadingFluencyAssessmentResponseDto
  status: 201
}

export type readingFluencyControllerStartReadingFluencyAssessmentResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerStartReadingFluencyAssessmentResponse403 = {
  data: void
  status: 403
}

export type readingFluencyControllerStartReadingFluencyAssessmentResponse500 = {
  data: void
  status: 500
}

export type readingFluencyControllerStartReadingFluencyAssessmentResponseSuccess =
  readingFluencyControllerStartReadingFluencyAssessmentResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerStartReadingFluencyAssessmentResponseError =
  (
    | readingFluencyControllerStartReadingFluencyAssessmentResponse400
    | readingFluencyControllerStartReadingFluencyAssessmentResponse403
    | readingFluencyControllerStartReadingFluencyAssessmentResponse500
  ) & {
    headers: Headers
  }

export type readingFluencyControllerStartReadingFluencyAssessmentResponse =
  | readingFluencyControllerStartReadingFluencyAssessmentResponseSuccess
  | readingFluencyControllerStartReadingFluencyAssessmentResponseError

export const getReadingFluencyControllerStartReadingFluencyAssessmentUrl =
  () => {
    return `/api-arvore/reading-fluency`
  }

export const readingFluencyControllerStartReadingFluencyAssessment = async (
  startReadingFluencyAssessmentDto: StartReadingFluencyAssessmentDto,
  options?: RequestInit
): Promise<readingFluencyControllerStartReadingFluencyAssessmentResponse> => {
  return customInstance<readingFluencyControllerStartReadingFluencyAssessmentResponse>(
    getReadingFluencyControllerStartReadingFluencyAssessmentUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(startReadingFluencyAssessmentDto)
    }
  )
}

/**
 * @summary Get raw text from reading fluency assessment book snippet by reader
 */
export type readingFluencyControllerGetReadingFluencyResponse200 = {
  data: GetReadingFluencyResponseDto
  status: 200
}

export type readingFluencyControllerGetReadingFluencyResponseSuccess =
  readingFluencyControllerGetReadingFluencyResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerGetReadingFluencyResponse =
  readingFluencyControllerGetReadingFluencyResponseSuccess

export const getReadingFluencyControllerGetReadingFluencyUrl = () => {
  return `/api-arvore/reading-fluency`
}

export const readingFluencyControllerGetReadingFluency = async (
  options?: RequestInit
): Promise<readingFluencyControllerGetReadingFluencyResponse> => {
  return customInstance<readingFluencyControllerGetReadingFluencyResponse>(
    getReadingFluencyControllerGetReadingFluencyUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Issues a short-lived JWT scoped to the reading fluency student flow for a student with a pending assessment, so the teacher can hand over the device without logging out.
 * @summary Open an impersonated session so a student can perform the assessment
 */
export type readingFluencyControllerCreateImpersonatedSessionResponse201 = {
  data: CreateImpersonatedSessionResponseDto
  status: 201
}

export type readingFluencyControllerCreateImpersonatedSessionResponse403 = {
  data: void
  status: 403
}

export type readingFluencyControllerCreateImpersonatedSessionResponse422 = {
  data: void
  status: 422
}

export type readingFluencyControllerCreateImpersonatedSessionResponseSuccess =
  readingFluencyControllerCreateImpersonatedSessionResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerCreateImpersonatedSessionResponseError = (
  | readingFluencyControllerCreateImpersonatedSessionResponse403
  | readingFluencyControllerCreateImpersonatedSessionResponse422
) & {
  headers: Headers
}

export type readingFluencyControllerCreateImpersonatedSessionResponse =
  | readingFluencyControllerCreateImpersonatedSessionResponseSuccess
  | readingFluencyControllerCreateImpersonatedSessionResponseError

export const getReadingFluencyControllerCreateImpersonatedSessionUrl = () => {
  return `/api-arvore/reading-fluency/impersonated-session`
}

export const readingFluencyControllerCreateImpersonatedSession = async (
  createImpersonatedSessionDto: CreateImpersonatedSessionDto,
  options?: RequestInit
): Promise<readingFluencyControllerCreateImpersonatedSessionResponse> => {
  return customInstance<readingFluencyControllerCreateImpersonatedSessionResponse>(
    getReadingFluencyControllerCreateImpersonatedSessionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createImpersonatedSessionDto)
    }
  )
}

/**
 * @summary Apply bulk reading fluency to multiple classes (Admin only)
 */
export type readingFluencyControllerApplyBulkReadingFluencyResponse201 = {
  data: CreateReadingFluencyResponseDto
  status: 201
}

export type readingFluencyControllerApplyBulkReadingFluencyResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerApplyBulkReadingFluencyResponse500 = {
  data: void
  status: 500
}

export type readingFluencyControllerApplyBulkReadingFluencyResponseSuccess =
  readingFluencyControllerApplyBulkReadingFluencyResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerApplyBulkReadingFluencyResponseError = (
  | readingFluencyControllerApplyBulkReadingFluencyResponse400
  | readingFluencyControllerApplyBulkReadingFluencyResponse500
) & {
  headers: Headers
}

export type readingFluencyControllerApplyBulkReadingFluencyResponse =
  | readingFluencyControllerApplyBulkReadingFluencyResponseSuccess
  | readingFluencyControllerApplyBulkReadingFluencyResponseError

export const getReadingFluencyControllerApplyBulkReadingFluencyUrl = () => {
  return `/api-arvore/reading-fluency/bulk`
}

export const readingFluencyControllerApplyBulkReadingFluency = async (
  createReadingFluencyDto: CreateReadingFluencyDto,
  options?: RequestInit
): Promise<readingFluencyControllerApplyBulkReadingFluencyResponse> => {
  return customInstance<readingFluencyControllerApplyBulkReadingFluencyResponse>(
    getReadingFluencyControllerApplyBulkReadingFluencyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createReadingFluencyDto)
    }
  )
}

/**
 * @summary Reapply reading fluency assessment for specific users (Admin only)
 */
export type readingFluencyControllerReapplyReadingFluencyResponse201 = {
  data: void
  status: 201
}

export type readingFluencyControllerReapplyReadingFluencyResponseSuccess =
  readingFluencyControllerReapplyReadingFluencyResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerReapplyReadingFluencyResponse =
  readingFluencyControllerReapplyReadingFluencyResponseSuccess

export const getReadingFluencyControllerReapplyReadingFluencyUrl = () => {
  return `/api-arvore/reading-fluency/reapply`
}

export const readingFluencyControllerReapplyReadingFluency = async (
  reapplyReadingFluencyDto: ReapplyReadingFluencyDto,
  options?: RequestInit
): Promise<readingFluencyControllerReapplyReadingFluencyResponse> => {
  return customInstance<readingFluencyControllerReapplyReadingFluencyResponse>(
    getReadingFluencyControllerReapplyReadingFluencyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reapplyReadingFluencyDto)
    }
  )
}

/**
 * Returns whether a reading fluency assessment is available for the authenticated student based on user ID and entity ID
 * @summary Check if reading fluency assessment is available for the student
 */
export type readingFluencyControllerCheckAssessmentAvailableResponse200 = {
  data: CheckReadingFluencyAssessmentAvailableResponseDto
  status: 200
}

export type readingFluencyControllerCheckAssessmentAvailableResponseSuccess =
  readingFluencyControllerCheckAssessmentAvailableResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerCheckAssessmentAvailableResponse =
  readingFluencyControllerCheckAssessmentAvailableResponseSuccess

export const getReadingFluencyControllerCheckAssessmentAvailableUrl = () => {
  return `/api-arvore/reading-fluency/assessment-available`
}

export const readingFluencyControllerCheckAssessmentAvailable = async (
  options?: RequestInit
): Promise<readingFluencyControllerCheckAssessmentAvailableResponse> => {
  return customInstance<readingFluencyControllerCheckAssessmentAvailableResponse>(
    getReadingFluencyControllerCheckAssessmentAvailableUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns book snippets filtered by degree (grade level) for use in the reading fluency assessment application modal
 * @summary Get book snippets by degree
 */
export type readingFluencyControllerGetBookSnippetsByDegreeResponse200 = {
  data: BookSnippetDto[]
  status: 200
}

export type readingFluencyControllerGetBookSnippetsByDegreeResponse403 = {
  data: void
  status: 403
}

export type readingFluencyControllerGetBookSnippetsByDegreeResponseSuccess =
  readingFluencyControllerGetBookSnippetsByDegreeResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerGetBookSnippetsByDegreeResponseError =
  readingFluencyControllerGetBookSnippetsByDegreeResponse403 & {
    headers: Headers
  }

export type readingFluencyControllerGetBookSnippetsByDegreeResponse =
  | readingFluencyControllerGetBookSnippetsByDegreeResponseSuccess
  | readingFluencyControllerGetBookSnippetsByDegreeResponseError

export const getReadingFluencyControllerGetBookSnippetsByDegreeUrl = (
  degree: string,
  params?: ReadingFluencyControllerGetBookSnippetsByDegreeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['entitiesIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reading-fluency/book-snippets/${degree}?${stringifiedParams}`
    : `/api-arvore/reading-fluency/book-snippets/${degree}`
}

export const readingFluencyControllerGetBookSnippetsByDegree = async (
  degree: string,
  params?: ReadingFluencyControllerGetBookSnippetsByDegreeParams,
  options?: RequestInit
): Promise<readingFluencyControllerGetBookSnippetsByDegreeResponse> => {
  return customInstance<readingFluencyControllerGetBookSnippetsByDegreeResponse>(
    getReadingFluencyControllerGetBookSnippetsByDegreeUrl(degree, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the list of classes (entities) of the logged teacher that have reading fluency assessments in progress
 * @summary Get classes with reading fluency assessment in progress
 */
export type readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse200 =
  {
    data: GetClassesWithReadingFluencyAssessmentResponseDto
    status: 200
  }

export type readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse403 =
  {
    data: void
    status: 403
  }

export type readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponseSuccess =
  readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponseError =
  readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse403 & {
    headers: Headers
  }

export type readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse =

    | readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponseSuccess
    | readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponseError

export const getReadingFluencyControllerGetClassesWithReadingFluencyAssessmentUrl =
  () => {
    return `/api-arvore/reading-fluency/classes-with-assessment`
  }

export const readingFluencyControllerGetClassesWithReadingFluencyAssessment =
  async (
    options?: RequestInit
  ): Promise<readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse> => {
    return customInstance<readingFluencyControllerGetClassesWithReadingFluencyAssessmentResponse>(
      getReadingFluencyControllerGetClassesWithReadingFluencyAssessmentUrl(),
      {
        ...options,
        method: 'GET'
      }
    )
  }

/**
 * Determines if the forest info card should be shown based on reading fluency assessments availability and completion status
 * @summary Check if forest info card should be displayed
 */
export type readingFluencyControllerShouldShowForestInfoCardResponse200 = {
  data: ShouldShowForestInfoCardResponseDto
  status: 200
}

export type readingFluencyControllerShouldShowForestInfoCardResponseSuccess =
  readingFluencyControllerShouldShowForestInfoCardResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerShouldShowForestInfoCardResponse =
  readingFluencyControllerShouldShowForestInfoCardResponseSuccess

export const getReadingFluencyControllerShouldShowForestInfoCardUrl = () => {
  return `/api-arvore/reading-fluency/forest-info-card/visibility`
}

export const readingFluencyControllerShouldShowForestInfoCard = async (
  options?: RequestInit
): Promise<readingFluencyControllerShouldShowForestInfoCardResponse> => {
  return customInstance<readingFluencyControllerShouldShowForestInfoCardResponse>(
    getReadingFluencyControllerShouldShowForestInfoCardUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns true if teacher has 5 or more students who completed reading fluency assessments in the current year
 * @summary Check if teacher has students with reading fluency results
 */
export type readingFluencyControllerHasStudentsWithResultsResponse200 = {
  data: HasStudentsWithReadingFluencyResultsResponseDto
  status: 200
}

export type readingFluencyControllerHasStudentsWithResultsResponseSuccess =
  readingFluencyControllerHasStudentsWithResultsResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerHasStudentsWithResultsResponse =
  readingFluencyControllerHasStudentsWithResultsResponseSuccess

export const getReadingFluencyControllerHasStudentsWithResultsUrl = () => {
  return `/api-arvore/reading-fluency/has-students-with-results`
}

export const readingFluencyControllerHasStudentsWithResults = async (
  options?: RequestInit
): Promise<readingFluencyControllerHasStudentsWithResultsResponse> => {
  return customInstance<readingFluencyControllerHasStudentsWithResultsResponse>(
    getReadingFluencyControllerHasStudentsWithResultsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Associates a reading fluency assessment result with an applied activity. The user ID is automatically extracted from the authentication token.
 * @summary Link an applied activity to a reading fluency result
 */
export type readingFluencyControllerLinkAppliedActivityResponse201 = {
  data: LinkAppliedActivityResponseDto
  status: 201
}

export type readingFluencyControllerLinkAppliedActivityResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerLinkAppliedActivityResponse404 = {
  data: void
  status: 404
}

export type readingFluencyControllerLinkAppliedActivityResponse500 = {
  data: void
  status: 500
}

export type readingFluencyControllerLinkAppliedActivityResponseSuccess =
  readingFluencyControllerLinkAppliedActivityResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerLinkAppliedActivityResponseError = (
  | readingFluencyControllerLinkAppliedActivityResponse400
  | readingFluencyControllerLinkAppliedActivityResponse404
  | readingFluencyControllerLinkAppliedActivityResponse500
) & {
  headers: Headers
}

export type readingFluencyControllerLinkAppliedActivityResponse =
  | readingFluencyControllerLinkAppliedActivityResponseSuccess
  | readingFluencyControllerLinkAppliedActivityResponseError

export const getReadingFluencyControllerLinkAppliedActivityUrl = () => {
  return `/api-arvore/reading-fluency/link-applied-activity`
}

export const readingFluencyControllerLinkAppliedActivity = async (
  linkAppliedActivityDto: LinkAppliedActivityDto,
  options?: RequestInit
): Promise<readingFluencyControllerLinkAppliedActivityResponse> => {
  return customInstance<readingFluencyControllerLinkAppliedActivityResponse>(
    getReadingFluencyControllerLinkAppliedActivityUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(linkAppliedActivityDto)
    }
  )
}

/**
 * @summary Set reading fluency comprehension level based on quiz results
 */
export type readingFluencyControllerSetReadingFluencyLevelResponse201 = {
  data: SetReadingFluencyLevelResponseDto
  status: 201
}

export type readingFluencyControllerSetReadingFluencyLevelResponse404 = {
  data: void
  status: 404
}

export type readingFluencyControllerSetReadingFluencyLevelResponse500 = {
  data: void
  status: 500
}

export type readingFluencyControllerSetReadingFluencyLevelResponseSuccess =
  readingFluencyControllerSetReadingFluencyLevelResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerSetReadingFluencyLevelResponseError = (
  | readingFluencyControllerSetReadingFluencyLevelResponse404
  | readingFluencyControllerSetReadingFluencyLevelResponse500
) & {
  headers: Headers
}

export type readingFluencyControllerSetReadingFluencyLevelResponse =
  | readingFluencyControllerSetReadingFluencyLevelResponseSuccess
  | readingFluencyControllerSetReadingFluencyLevelResponseError

export const getReadingFluencyControllerSetReadingFluencyLevelUrl = (
  assessmentId: string
) => {
  return `/api-arvore/reading-fluency/${assessmentId}/level`
}

export const readingFluencyControllerSetReadingFluencyLevel = async (
  assessmentId: string,
  options?: RequestInit
): Promise<readingFluencyControllerSetReadingFluencyLevelResponse> => {
  return customInstance<readingFluencyControllerSetReadingFluencyLevelResponse>(
    getReadingFluencyControllerSetReadingFluencyLevelUrl(assessmentId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Get reading fluency report for educator panel
 */
export type readingFluencyControllerGetEducatorReportResponse200 = {
  data: GetEducatorReportResponseDto
  status: 200
}

export type readingFluencyControllerGetEducatorReportResponse404 = {
  data: void
  status: 404
}

export type readingFluencyControllerGetEducatorReportResponseSuccess =
  readingFluencyControllerGetEducatorReportResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerGetEducatorReportResponseError =
  readingFluencyControllerGetEducatorReportResponse404 & {
    headers: Headers
  }

export type readingFluencyControllerGetEducatorReportResponse =
  | readingFluencyControllerGetEducatorReportResponseSuccess
  | readingFluencyControllerGetEducatorReportResponseError

export const getReadingFluencyControllerGetEducatorReportUrl = (
  assessmentId: string,
  userId: string
) => {
  return `/api-arvore/reading-fluency/${assessmentId}/reader/${userId}/report`
}

export const readingFluencyControllerGetEducatorReport = async (
  assessmentId: string,
  userId: string,
  options?: RequestInit
): Promise<readingFluencyControllerGetEducatorReportResponse> => {
  return customInstance<readingFluencyControllerGetEducatorReportResponse>(
    getReadingFluencyControllerGetEducatorReportUrl(assessmentId, userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload reading fluency audio
 */
export type readingFluencyControllerUploadAudioResponse201 = {
  data: void
  status: 201
}

export type readingFluencyControllerUploadAudioResponseSuccess =
  readingFluencyControllerUploadAudioResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerUploadAudioResponse =
  readingFluencyControllerUploadAudioResponseSuccess

export const getReadingFluencyControllerUploadAudioUrl = () => {
  return `/api-arvore/reading-fluency/audio`
}

export const readingFluencyControllerUploadAudio = async (
  readingFluencyControllerUploadAudioBody: ReadingFluencyControllerUploadAudioBody,
  options?: RequestInit
): Promise<readingFluencyControllerUploadAudioResponse> => {
  const formData = new FormData()
  if (readingFluencyControllerUploadAudioBody.file !== undefined) {
    formData.append(`file`, readingFluencyControllerUploadAudioBody.file)
  }
  if (readingFluencyControllerUploadAudioBody.duration !== undefined) {
    formData.append(
      `duration`,
      readingFluencyControllerUploadAudioBody.duration.toString()
    )
  }
  if (readingFluencyControllerUploadAudioBody.assessmentId !== undefined) {
    formData.append(
      `assessmentId`,
      readingFluencyControllerUploadAudioBody.assessmentId.toString()
    )
  }

  return customInstance<readingFluencyControllerUploadAudioResponse>(
    getReadingFluencyControllerUploadAudioUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * Returns active assessments with student counts and result statistics. Used by backoffice to identify assessments for cancellation.
 * @summary List active assessments by entity or assessment ID
 */
export type readingFluencyControllerListActiveAssessmentsResponse200 = {
  data: ListActiveAssessmentsResponseDto
  status: 200
}

export type readingFluencyControllerListActiveAssessmentsResponseSuccess =
  readingFluencyControllerListActiveAssessmentsResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerListActiveAssessmentsResponse =
  readingFluencyControllerListActiveAssessmentsResponseSuccess

export const getReadingFluencyControllerListActiveAssessmentsUrl = (
  params?: ReadingFluencyControllerListActiveAssessmentsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reading-fluency/active-assessments?${stringifiedParams}`
    : `/api-arvore/reading-fluency/active-assessments`
}

export const readingFluencyControllerListActiveAssessments = async (
  params?: ReadingFluencyControllerListActiveAssessmentsParams,
  options?: RequestInit
): Promise<readingFluencyControllerListActiveAssessmentsResponse> => {
  return customInstance<readingFluencyControllerListActiveAssessmentsResponse>(
    getReadingFluencyControllerListActiveAssessmentsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Disables the assessment and cancels all user_assessments. Preserves existing results.
 * @summary Cancel an active assessment
 */
export type readingFluencyControllerCancelAssessmentResponse201 = {
  data: CancelAssessmentResponseDto
  status: 201
}

export type readingFluencyControllerCancelAssessmentResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerCancelAssessmentResponse404 = {
  data: void
  status: 404
}

export type readingFluencyControllerCancelAssessmentResponseSuccess =
  readingFluencyControllerCancelAssessmentResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerCancelAssessmentResponseError = (
  | readingFluencyControllerCancelAssessmentResponse400
  | readingFluencyControllerCancelAssessmentResponse404
) & {
  headers: Headers
}

export type readingFluencyControllerCancelAssessmentResponse =
  | readingFluencyControllerCancelAssessmentResponseSuccess
  | readingFluencyControllerCancelAssessmentResponseError

export const getReadingFluencyControllerCancelAssessmentUrl = () => {
  return `/api-arvore/reading-fluency/cancel-assessment`
}

export const readingFluencyControllerCancelAssessment = async (
  cancelAssessmentDto: CancelAssessmentDto,
  options?: RequestInit
): Promise<readingFluencyControllerCancelAssessmentResponse> => {
  return customInstance<readingFluencyControllerCancelAssessmentResponse>(
    getReadingFluencyControllerCancelAssessmentUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(cancelAssessmentDto)
    }
  )
}

/**
 * Cancels multiple assessments. Already disabled assessments are skipped.
 * @summary Cancel multiple assessments at once
 */
export type readingFluencyControllerCancelAssessmentsBulkResponse201 = {
  data: CancelAssessmentsBulkResponseDto
  status: 201
}

export type readingFluencyControllerCancelAssessmentsBulkResponseSuccess =
  readingFluencyControllerCancelAssessmentsBulkResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerCancelAssessmentsBulkResponse =
  readingFluencyControllerCancelAssessmentsBulkResponseSuccess

export const getReadingFluencyControllerCancelAssessmentsBulkUrl = () => {
  return `/api-arvore/reading-fluency/cancel-assessments/bulk`
}

export const readingFluencyControllerCancelAssessmentsBulk = async (
  cancelAssessmentsBulkDto: CancelAssessmentsBulkDto,
  options?: RequestInit
): Promise<readingFluencyControllerCancelAssessmentsBulkResponse> => {
  return customInstance<readingFluencyControllerCancelAssessmentsBulkResponse>(
    getReadingFluencyControllerCancelAssessmentsBulkUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(cancelAssessmentsBulkDto)
    }
  )
}

/**
 * @summary List assessment results with filters (Admin only)
 */
export type readingFluencyControllerListAssessmentResultsResponse200 = {
  data: ListAssessmentResultsResponseDto
  status: 200
}

export type readingFluencyControllerListAssessmentResultsResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerListAssessmentResultsResponseSuccess =
  readingFluencyControllerListAssessmentResultsResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerListAssessmentResultsResponseError =
  readingFluencyControllerListAssessmentResultsResponse400 & {
    headers: Headers
  }

export type readingFluencyControllerListAssessmentResultsResponse =
  | readingFluencyControllerListAssessmentResultsResponseSuccess
  | readingFluencyControllerListAssessmentResultsResponseError

export const getReadingFluencyControllerListAssessmentResultsUrl = (
  params?: ReadingFluencyControllerListAssessmentResultsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reading-fluency/assessment-results?${stringifiedParams}`
    : `/api-arvore/reading-fluency/assessment-results`
}

export const readingFluencyControllerListAssessmentResults = async (
  params?: ReadingFluencyControllerListAssessmentResultsParams,
  options?: RequestInit
): Promise<readingFluencyControllerListAssessmentResultsResponse> => {
  return customInstance<readingFluencyControllerListAssessmentResultsResponse>(
    getReadingFluencyControllerListAssessmentResultsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete assessment results by result IDs (Admin only)
 */
export type readingFluencyControllerDeleteAssessmentResultsResponse201 = {
  data: DeleteAssessmentResultsResponseDto
  status: 201
}

export type readingFluencyControllerDeleteAssessmentResultsResponse400 = {
  data: void
  status: 400
}

export type readingFluencyControllerDeleteAssessmentResultsResponseSuccess =
  readingFluencyControllerDeleteAssessmentResultsResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerDeleteAssessmentResultsResponseError =
  readingFluencyControllerDeleteAssessmentResultsResponse400 & {
    headers: Headers
  }

export type readingFluencyControllerDeleteAssessmentResultsResponse =
  | readingFluencyControllerDeleteAssessmentResultsResponseSuccess
  | readingFluencyControllerDeleteAssessmentResultsResponseError

export const getReadingFluencyControllerDeleteAssessmentResultsUrl = () => {
  return `/api-arvore/reading-fluency/delete-results`
}

export const readingFluencyControllerDeleteAssessmentResults = async (
  deleteAssessmentResultsDto: DeleteAssessmentResultsDto,
  options?: RequestInit
): Promise<readingFluencyControllerDeleteAssessmentResultsResponse> => {
  return customInstance<readingFluencyControllerDeleteAssessmentResultsResponse>(
    getReadingFluencyControllerDeleteAssessmentResultsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(deleteAssessmentResultsDto)
    }
  )
}

/**
 * @summary Delete all active results for an assessment (Admin only)
 */
export type readingFluencyControllerDeleteAssessmentResultsByAssessmentResponse201 =
  {
    data: DeleteAssessmentResultsByAssessmentResponseDto
    status: 201
  }

export type readingFluencyControllerDeleteAssessmentResultsByAssessmentResponseSuccess =
  readingFluencyControllerDeleteAssessmentResultsByAssessmentResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerDeleteAssessmentResultsByAssessmentResponse =
  readingFluencyControllerDeleteAssessmentResultsByAssessmentResponseSuccess

export const getReadingFluencyControllerDeleteAssessmentResultsByAssessmentUrl =
  () => {
    return `/api-arvore/reading-fluency/delete-results/by-assessment`
  }

export const readingFluencyControllerDeleteAssessmentResultsByAssessment =
  async (
    deleteAssessmentResultsByAssessmentDto: DeleteAssessmentResultsByAssessmentDto,
    options?: RequestInit
  ): Promise<readingFluencyControllerDeleteAssessmentResultsByAssessmentResponse> => {
    return customInstance<readingFluencyControllerDeleteAssessmentResultsByAssessmentResponse>(
      getReadingFluencyControllerDeleteAssessmentResultsByAssessmentUrl(),
      {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deleteAssessmentResultsByAssessmentDto)
      }
    )
  }

/**
 * Cancels the last reading fluency assessment result for a student, allowing them to retake the assessment. Only one retry is allowed per assessment - if the assessment already has a canceled result, the request will be rejected.
 * @summary Cancel last reading fluency assessment result for a student
 */
export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse201 =
  {
    data: CancelLastReadingFluencyAssessmentResponseDto
    status: 201
  }

export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse400 =
  {
    data: void
    status: 400
  }

export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse403 =
  {
    data: void
    status: 403
  }

export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse404 =
  {
    data: void
    status: 404
  }

export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponseSuccess =
  readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponseError =
  (
    | readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse400
    | readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse403
    | readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse404
  ) & {
    headers: Headers
  }

export type readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse =

    | readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponseSuccess
    | readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponseError

export const getReadingFluencyControllerCancelLastReadingFluencyAssessmentResultUrl =
  () => {
    return `/api-arvore/reading-fluency/cancel-result`
  }

export const readingFluencyControllerCancelLastReadingFluencyAssessmentResult =
  async (
    cancelLastReadingFluencyAssessmentDto: CancelLastReadingFluencyAssessmentDto,
    options?: RequestInit
  ): Promise<readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse> => {
    return customInstance<readingFluencyControllerCancelLastReadingFluencyAssessmentResultResponse>(
      getReadingFluencyControllerCancelLastReadingFluencyAssessmentResultUrl(),
      {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(cancelLastReadingFluencyAssessmentDto)
      }
    )
  }

/**
 * @summary Disable automatic assessments for an entity (Admin only)
 */
export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse201 =
  {
    data: DisableAutomaticAssessmentsResponseDto
    status: 201
  }

export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse400 =
  {
    data: void
    status: 400
  }

export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse404 =
  {
    data: void
    status: 404
  }

export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponseSuccess =
  readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponseError =
  (
    | readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse400
    | readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse404
  ) & {
    headers: Headers
  }

export type readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse =

    | readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponseSuccess
    | readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponseError

export const getReadingFluencyControllerDisableAutomaticAssessmentsBackofficeUrl =
  () => {
    return `/api-arvore/reading-fluency/backoffice/automatic-exclusions`
  }

export const readingFluencyControllerDisableAutomaticAssessmentsBackoffice =
  async (
    disableAutomaticAssessmentsDto: DisableAutomaticAssessmentsDto,
    options?: RequestInit
  ): Promise<readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse> => {
    return customInstance<readingFluencyControllerDisableAutomaticAssessmentsBackofficeResponse>(
      getReadingFluencyControllerDisableAutomaticAssessmentsBackofficeUrl(),
      {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(disableAutomaticAssessmentsDto)
      }
    )
  }

/**
 * @summary Re-enable automatic assessments for an entity (Admin only)
 */
export type readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse200 =
  {
    data: void
    status: 200
  }

export type readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse404 =
  {
    data: void
    status: 404
  }

export type readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponseSuccess =
  readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponseError =
  readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse404 & {
    headers: Headers
  }

export type readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse =

    | readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponseSuccess
    | readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponseError

export const getReadingFluencyControllerEnableAutomaticAssessmentsBackofficeUrl =
  (entityId: number) => {
    return `/api-arvore/reading-fluency/backoffice/automatic-exclusions/${entityId}`
  }

export const readingFluencyControllerEnableAutomaticAssessmentsBackoffice =
  async (
    entityId: number,
    options?: RequestInit
  ): Promise<readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse> => {
    return customInstance<readingFluencyControllerEnableAutomaticAssessmentsBackofficeResponse>(
      getReadingFluencyControllerEnableAutomaticAssessmentsBackofficeUrl(
        entityId
      ),
      {
        ...options,
        method: 'DELETE'
      }
    )
  }

/**
 * @summary Disable automatic assessments for teacher classes
 */
export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse201 =
  {
    data: DisableAutomaticAssessmentsResponseDto
    status: 201
  }

export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse400 =
  {
    data: void
    status: 400
  }

export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse403 =
  {
    data: void
    status: 403
  }

export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse404 =
  {
    data: void
    status: 404
  }

export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponseSuccess =
  readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse201 & {
    headers: Headers
  }
export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponseError =
  (
    | readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse400
    | readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse403
    | readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse404
  ) & {
    headers: Headers
  }

export type readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse =

    | readingFluencyControllerDisableAutomaticAssessmentsTeacherResponseSuccess
    | readingFluencyControllerDisableAutomaticAssessmentsTeacherResponseError

export const getReadingFluencyControllerDisableAutomaticAssessmentsTeacherUrl =
  () => {
    return `/api-arvore/reading-fluency/teacher/automatic-exclusions`
  }

export const readingFluencyControllerDisableAutomaticAssessmentsTeacher =
  async (
    disableAutomaticAssessmentsDto: DisableAutomaticAssessmentsDto,
    options?: RequestInit
  ): Promise<readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse> => {
    return customInstance<readingFluencyControllerDisableAutomaticAssessmentsTeacherResponse>(
      getReadingFluencyControllerDisableAutomaticAssessmentsTeacherUrl(),
      {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(disableAutomaticAssessmentsDto)
      }
    )
  }

/**
 * @summary Re-enable automatic assessments for teacher classes
 */
export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse200 =
  {
    data: void
    status: 200
  }

export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse403 =
  {
    data: void
    status: 403
  }

export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse404 =
  {
    data: void
    status: 404
  }

export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponseSuccess =
  readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponseError =
  (
    | readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse403
    | readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse404
  ) & {
    headers: Headers
  }

export type readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse =
  | readingFluencyControllerEnableAutomaticAssessmentsTeacherResponseSuccess
  | readingFluencyControllerEnableAutomaticAssessmentsTeacherResponseError

export const getReadingFluencyControllerEnableAutomaticAssessmentsTeacherUrl = (
  entityId: number
) => {
  return `/api-arvore/reading-fluency/teacher/automatic-exclusions/${entityId}`
}

export const readingFluencyControllerEnableAutomaticAssessmentsTeacher = async (
  entityId: number,
  options?: RequestInit
): Promise<readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse> => {
  return customInstance<readingFluencyControllerEnableAutomaticAssessmentsTeacherResponse>(
    getReadingFluencyControllerEnableAutomaticAssessmentsTeacherUrl(entityId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Check if an entity is excluded from automatic assessments
 */
export type readingFluencyControllerCheckAutomaticExclusionResponse200 = {
  data: CheckAutomaticExclusionResponseDto
  status: 200
}

export type readingFluencyControllerCheckAutomaticExclusionResponseSuccess =
  readingFluencyControllerCheckAutomaticExclusionResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerCheckAutomaticExclusionResponse =
  readingFluencyControllerCheckAutomaticExclusionResponseSuccess

export const getReadingFluencyControllerCheckAutomaticExclusionUrl = (
  entityId: number
) => {
  return `/api-arvore/reading-fluency/automatic-exclusions/check/${entityId}`
}

export const readingFluencyControllerCheckAutomaticExclusion = async (
  entityId: number,
  options?: RequestInit
): Promise<readingFluencyControllerCheckAutomaticExclusionResponse> => {
  return customInstance<readingFluencyControllerCheckAutomaticExclusionResponse>(
    getReadingFluencyControllerCheckAutomaticExclusionUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List automatic assessments for an entity
 */
export type readingFluencyControllerListAutomaticAssessmentsResponse200 = {
  data: ListAutomaticAssessmentsResponseDto
  status: 200
}

export type readingFluencyControllerListAutomaticAssessmentsResponseSuccess =
  readingFluencyControllerListAutomaticAssessmentsResponse200 & {
    headers: Headers
  }
export type readingFluencyControllerListAutomaticAssessmentsResponse =
  readingFluencyControllerListAutomaticAssessmentsResponseSuccess

export const getReadingFluencyControllerListAutomaticAssessmentsUrl = (
  params: ReadingFluencyControllerListAutomaticAssessmentsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reading-fluency/automatic-assessments?${stringifiedParams}`
    : `/api-arvore/reading-fluency/automatic-assessments`
}

export const readingFluencyControllerListAutomaticAssessments = async (
  params: ReadingFluencyControllerListAutomaticAssessmentsParams,
  options?: RequestInit
): Promise<readingFluencyControllerListAutomaticAssessmentsResponse> => {
  return customInstance<readingFluencyControllerListAutomaticAssessmentsResponse>(
    getReadingFluencyControllerListAutomaticAssessmentsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get trail linked to a book
 */
export type readingTrailsControllerGetTrailByBookResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerGetTrailByBookResponseSuccess =
  readingTrailsControllerGetTrailByBookResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerGetTrailByBookResponse =
  readingTrailsControllerGetTrailByBookResponseSuccess

export const getReadingTrailsControllerGetTrailByBookUrl = (bookId: number) => {
  return `/api-arvore/reading-trails/by-book/${bookId}`
}

export const readingTrailsControllerGetTrailByBook = async (
  bookId: number,
  options?: RequestInit
): Promise<readingTrailsControllerGetTrailByBookResponse> => {
  return customInstance<readingTrailsControllerGetTrailByBookResponse>(
    getReadingTrailsControllerGetTrailByBookUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List active trail instances for the authenticated teacher
 */
export type readingTrailsControllerGetMyInstancesResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerGetMyInstancesResponseSuccess =
  readingTrailsControllerGetMyInstancesResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerGetMyInstancesResponse =
  readingTrailsControllerGetMyInstancesResponseSuccess

export const getReadingTrailsControllerGetMyInstancesUrl = () => {
  return `/api-arvore/reading-trails/instances/my`
}

export const readingTrailsControllerGetMyInstances = async (
  options?: RequestInit
): Promise<readingTrailsControllerGetMyInstancesResponse> => {
  return customInstance<readingTrailsControllerGetMyInstancesResponse>(
    getReadingTrailsControllerGetMyInstancesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get trail instance details with steps and progress
 */
export type readingTrailsControllerGetTrailInstanceResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerGetTrailInstanceResponseSuccess =
  readingTrailsControllerGetTrailInstanceResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerGetTrailInstanceResponse =
  readingTrailsControllerGetTrailInstanceResponseSuccess

export const getReadingTrailsControllerGetTrailInstanceUrl = (
  instanceId: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}`
}

export const readingTrailsControllerGetTrailInstance = async (
  instanceId: number,
  options?: RequestInit
): Promise<readingTrailsControllerGetTrailInstanceResponse> => {
  return customInstance<readingTrailsControllerGetTrailInstanceResponse>(
    getReadingTrailsControllerGetTrailInstanceUrl(instanceId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update scheduled date or reading milestone for a step
 */
export type readingTrailsControllerUpdateStepResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerUpdateStepResponseSuccess =
  readingTrailsControllerUpdateStepResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerUpdateStepResponse =
  readingTrailsControllerUpdateStepResponseSuccess

export const getReadingTrailsControllerUpdateStepUrl = (
  instanceId: number,
  stepNumber: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}/steps/${stepNumber}`
}

export const readingTrailsControllerUpdateStep = async (
  instanceId: number,
  stepNumber: number,
  updateStepDto: UpdateStepDto,
  options?: RequestInit
): Promise<readingTrailsControllerUpdateStepResponse> => {
  return customInstance<readingTrailsControllerUpdateStepResponse>(
    getReadingTrailsControllerUpdateStepUrl(instanceId, stepNumber),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateStepDto)
    }
  )
}

/**
 * @summary Mark a step as completed
 */
export type readingTrailsControllerCompleteStepResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerCompleteStepResponseSuccess =
  readingTrailsControllerCompleteStepResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerCompleteStepResponse =
  readingTrailsControllerCompleteStepResponseSuccess

export const getReadingTrailsControllerCompleteStepUrl = (
  instanceId: number,
  stepNumber: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}/steps/${stepNumber}/complete`
}

export const readingTrailsControllerCompleteStep = async (
  instanceId: number,
  stepNumber: number,
  options?: RequestInit
): Promise<readingTrailsControllerCompleteStepResponse> => {
  return customInstance<readingTrailsControllerCompleteStepResponse>(
    getReadingTrailsControllerCompleteStepUrl(instanceId, stepNumber),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Activate collaborative board for a step
 */
export type readingTrailsControllerActivateBoardResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerActivateBoardResponseSuccess =
  readingTrailsControllerActivateBoardResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerActivateBoardResponse =
  readingTrailsControllerActivateBoardResponseSuccess

export const getReadingTrailsControllerActivateBoardUrl = (
  instanceId: number,
  stepNumber: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}/steps/${stepNumber}/board`
}

export const readingTrailsControllerActivateBoard = async (
  instanceId: number,
  stepNumber: number,
  options?: RequestInit
): Promise<readingTrailsControllerActivateBoardResponse> => {
  return customInstance<readingTrailsControllerActivateBoardResponse>(
    getReadingTrailsControllerActivateBoardUrl(instanceId, stepNumber),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List posts from the collaborative board
 */
export type readingTrailsControllerGetStepPostsResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerGetStepPostsResponseSuccess =
  readingTrailsControllerGetStepPostsResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerGetStepPostsResponse =
  readingTrailsControllerGetStepPostsResponseSuccess

export const getReadingTrailsControllerGetStepPostsUrl = (
  instanceId: number,
  stepNumber: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}/steps/${stepNumber}/posts`
}

export const readingTrailsControllerGetStepPosts = async (
  instanceId: number,
  stepNumber: number,
  options?: RequestInit
): Promise<readingTrailsControllerGetStepPostsResponse> => {
  return customInstance<readingTrailsControllerGetStepPostsResponse>(
    getReadingTrailsControllerGetStepPostsUrl(instanceId, stepNumber),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a post on the collaborative board
 */
export type readingTrailsControllerCreatePostResponse201 = {
  data: void
  status: 201
}

export type readingTrailsControllerCreatePostResponseSuccess =
  readingTrailsControllerCreatePostResponse201 & {
    headers: Headers
  }
export type readingTrailsControllerCreatePostResponse =
  readingTrailsControllerCreatePostResponseSuccess

export const getReadingTrailsControllerCreatePostUrl = (
  instanceId: number,
  stepNumber: number
) => {
  return `/api-arvore/reading-trails/instances/${instanceId}/steps/${stepNumber}/posts`
}

export const readingTrailsControllerCreatePost = async (
  instanceId: number,
  stepNumber: number,
  createPostDto: CreatePostDto,
  options?: RequestInit
): Promise<readingTrailsControllerCreatePostResponse> => {
  return customInstance<readingTrailsControllerCreatePostResponse>(
    getReadingTrailsControllerCreatePostUrl(instanceId, stepNumber),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createPostDto)
    }
  )
}

/**
 * @summary Get trail details with all steps
 */
export type readingTrailsControllerGetTrailDetailsResponse200 = {
  data: void
  status: 200
}

export type readingTrailsControllerGetTrailDetailsResponseSuccess =
  readingTrailsControllerGetTrailDetailsResponse200 & {
    headers: Headers
  }
export type readingTrailsControllerGetTrailDetailsResponse =
  readingTrailsControllerGetTrailDetailsResponseSuccess

export const getReadingTrailsControllerGetTrailDetailsUrl = (
  trailId: number
) => {
  return `/api-arvore/reading-trails/${trailId}`
}

export const readingTrailsControllerGetTrailDetails = async (
  trailId: number,
  options?: RequestInit
): Promise<readingTrailsControllerGetTrailDetailsResponse> => {
  return customInstance<readingTrailsControllerGetTrailDetailsResponse>(
    getReadingTrailsControllerGetTrailDetailsUrl(trailId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Assign trail to a class
 */
export type readingTrailsControllerAssignTrailResponse201 = {
  data: void
  status: 201
}

export type readingTrailsControllerAssignTrailResponseSuccess =
  readingTrailsControllerAssignTrailResponse201 & {
    headers: Headers
  }
export type readingTrailsControllerAssignTrailResponse =
  readingTrailsControllerAssignTrailResponseSuccess

export const getReadingTrailsControllerAssignTrailUrl = (trailId: number) => {
  return `/api-arvore/reading-trails/${trailId}/assign`
}

export const readingTrailsControllerAssignTrail = async (
  trailId: number,
  assignTrailDto: AssignTrailDto,
  options?: RequestInit
): Promise<readingTrailsControllerAssignTrailResponse> => {
  return customInstance<readingTrailsControllerAssignTrailResponse>(
    getReadingTrailsControllerAssignTrailUrl(trailId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(assignTrailDto)
    }
  )
}

/**
 * Upload audio file and send to running records assessment queue
 * @summary Send running record audio for assessment
 */
export type runningRecordsControllerSendToAssessmentResponse201 = {
  data: SendToAssessmentResponseDto
  status: 201
}

export type runningRecordsControllerSendToAssessmentResponseSuccess =
  runningRecordsControllerSendToAssessmentResponse201 & {
    headers: Headers
  }
export type runningRecordsControllerSendToAssessmentResponse =
  runningRecordsControllerSendToAssessmentResponseSuccess

export const getRunningRecordsControllerSendToAssessmentUrl = () => {
  return `/api-arvore/running-records/send-to-assessment`
}

export const runningRecordsControllerSendToAssessment = async (
  runningRecordsControllerSendToAssessmentBody: RunningRecordsControllerSendToAssessmentBody,
  options?: RequestInit
): Promise<runningRecordsControllerSendToAssessmentResponse> => {
  const formData = new FormData()
  formData.append(`audio`, runningRecordsControllerSendToAssessmentBody.audio)
  if (runningRecordsControllerSendToAssessmentBody.assessmentId !== undefined) {
    formData.append(
      `assessmentId`,
      runningRecordsControllerSendToAssessmentBody.assessmentId.toString()
    )
  }
  formData.append(
    `bookSnippetId`,
    runningRecordsControllerSendToAssessmentBody.bookSnippetId.toString()
  )

  return customInstance<runningRecordsControllerSendToAssessmentResponse>(
    getRunningRecordsControllerSendToAssessmentUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * Register a new running record assessment result
 * @summary Register running record assessment result
 */
export type runningRecordsControllerRegisterAssessmentResultResponse201 = {
  data: RegisterAssessmentResultResponseDto
  status: 201
}

export type runningRecordsControllerRegisterAssessmentResultResponseSuccess =
  runningRecordsControllerRegisterAssessmentResultResponse201 & {
    headers: Headers
  }
export type runningRecordsControllerRegisterAssessmentResultResponse =
  runningRecordsControllerRegisterAssessmentResultResponseSuccess

export const getRunningRecordsControllerRegisterAssessmentResultUrl = () => {
  return `/api-arvore/running-records/register-result`
}

export const runningRecordsControllerRegisterAssessmentResult = async (
  registerAssessmentResultBodyDto: RegisterAssessmentResultBodyDto,
  options?: RequestInit
): Promise<runningRecordsControllerRegisterAssessmentResultResponse> => {
  return customInstance<runningRecordsControllerRegisterAssessmentResultResponse>(
    getRunningRecordsControllerRegisterAssessmentResultUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerAssessmentResultBodyDto)
    }
  )
}

/**
 * Edit an existing running record assessment result
 * @summary Edit running record assessment
 */
export type runningRecordsControllerEditAssessmentResponse200 = {
  data: EditAssessmentResponseDto
  status: 200
}

export type runningRecordsControllerEditAssessmentResponseSuccess =
  runningRecordsControllerEditAssessmentResponse200 & {
    headers: Headers
  }
export type runningRecordsControllerEditAssessmentResponse =
  runningRecordsControllerEditAssessmentResponseSuccess

export const getRunningRecordsControllerEditAssessmentUrl = (
  assessmentResultId: number
) => {
  return `/api-arvore/running-records/edit-assessment/${assessmentResultId}`
}

export const runningRecordsControllerEditAssessment = async (
  assessmentResultId: number,
  editAssessmentBodyDto: EditAssessmentBodyDto,
  options?: RequestInit
): Promise<runningRecordsControllerEditAssessmentResponse> => {
  return customInstance<runningRecordsControllerEditAssessmentResponse>(
    getRunningRecordsControllerEditAssessmentUrl(assessmentResultId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(editAssessmentBodyDto)
    }
  )
}

/**
 * Delete an existing running record assessment result
 * @summary Delete running record assessment
 */
export type runningRecordsControllerDeleteAssessmentResponse200 = {
  data: DeleteAssessmentResponseDto
  status: 200
}

export type runningRecordsControllerDeleteAssessmentResponseSuccess =
  runningRecordsControllerDeleteAssessmentResponse200 & {
    headers: Headers
  }
export type runningRecordsControllerDeleteAssessmentResponse =
  runningRecordsControllerDeleteAssessmentResponseSuccess

export const getRunningRecordsControllerDeleteAssessmentUrl = (
  assessmentResultId: number
) => {
  return `/api-arvore/running-records/assessment/${assessmentResultId}`
}

export const runningRecordsControllerDeleteAssessment = async (
  assessmentResultId: number,
  options?: RequestInit
): Promise<runningRecordsControllerDeleteAssessmentResponse> => {
  return customInstance<runningRecordsControllerDeleteAssessmentResponse>(
    getRunningRecordsControllerDeleteAssessmentUrl(assessmentResultId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Get available filter options (degrees, book snippets)
 */
export type fluencyAudioReviewControllerGetFilterOptionsV1Response200 = {
  data: FluencyAudioReviewFilterOptionsResponseDto
  status: 200
}

export type fluencyAudioReviewControllerGetFilterOptionsV1ResponseSuccess =
  fluencyAudioReviewControllerGetFilterOptionsV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerGetFilterOptionsV1Response =
  fluencyAudioReviewControllerGetFilterOptionsV1ResponseSuccess

export const getFluencyAudioReviewControllerGetFilterOptionsV1Url = () => {
  return `/api-arvore/v1/fluency-audio-review/filter-options`
}

export const fluencyAudioReviewControllerGetFilterOptionsV1 = async (
  options?: RequestInit
): Promise<fluencyAudioReviewControllerGetFilterOptionsV1Response> => {
  return customInstance<fluencyAudioReviewControllerGetFilterOptionsV1Response>(
    getFluencyAudioReviewControllerGetFilterOptionsV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List reading fluency assessment results with filters and pagination
 */
export type fluencyAudioReviewControllerListResultsV1Response200 = {
  data: ListFluencyAudioReviewResultsResponseDto
  status: 200
}

export type fluencyAudioReviewControllerListResultsV1ResponseSuccess =
  fluencyAudioReviewControllerListResultsV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerListResultsV1Response =
  fluencyAudioReviewControllerListResultsV1ResponseSuccess

export const getFluencyAudioReviewControllerListResultsV1Url = (
  params?: FluencyAudioReviewControllerListResultsV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/fluency-audio-review/results?${stringifiedParams}`
    : `/api-arvore/v1/fluency-audio-review/results`
}

export const fluencyAudioReviewControllerListResultsV1 = async (
  params?: FluencyAudioReviewControllerListResultsV1Params,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerListResultsV1Response> => {
  return customInstance<fluencyAudioReviewControllerListResultsV1Response>(
    getFluencyAudioReviewControllerListResultsV1Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get full detail of a single assessment result
 */
export type fluencyAudioReviewControllerGetResultDetailV1Response200 = {
  data: FluencyAudioReviewResultDetailDto
  status: 200
}

export type fluencyAudioReviewControllerGetResultDetailV1ResponseSuccess =
  fluencyAudioReviewControllerGetResultDetailV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerGetResultDetailV1Response =
  fluencyAudioReviewControllerGetResultDetailV1ResponseSuccess

export const getFluencyAudioReviewControllerGetResultDetailV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}`
}

export const fluencyAudioReviewControllerGetResultDetailV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerGetResultDetailV1Response> => {
  return customInstance<fluencyAudioReviewControllerGetResultDetailV1Response>(
    getFluencyAudioReviewControllerGetResultDetailV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get presigned S3 URL for the audio of a result
 */
export type fluencyAudioReviewControllerGetAudioUrlV1Response200 = {
  data: FluencyAudioReviewAudioUrlResponseDto
  status: 200
}

export type fluencyAudioReviewControllerGetAudioUrlV1ResponseSuccess =
  fluencyAudioReviewControllerGetAudioUrlV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerGetAudioUrlV1Response =
  fluencyAudioReviewControllerGetAudioUrlV1ResponseSuccess

export const getFluencyAudioReviewControllerGetAudioUrlV1Url = (id: number) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}/audio-url`
}

export const fluencyAudioReviewControllerGetAudioUrlV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerGetAudioUrlV1Response> => {
  return customInstance<fluencyAudioReviewControllerGetAudioUrlV1Response>(
    getFluencyAudioReviewControllerGetAudioUrlV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List review comments for a result (newest first)
 */
export type fluencyAudioReviewControllerListCommentsV1Response200 = {
  data: ListFluencyAudioReviewCommentsResponseDto
  status: 200
}

export type fluencyAudioReviewControllerListCommentsV1ResponseSuccess =
  fluencyAudioReviewControllerListCommentsV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerListCommentsV1Response =
  fluencyAudioReviewControllerListCommentsV1ResponseSuccess

export const getFluencyAudioReviewControllerListCommentsV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}/comments`
}

export const fluencyAudioReviewControllerListCommentsV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerListCommentsV1Response> => {
  return customInstance<fluencyAudioReviewControllerListCommentsV1Response>(
    getFluencyAudioReviewControllerListCommentsV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new review comment for a result (append-only)
 */
export type fluencyAudioReviewControllerCreateCommentV1Response201 = {
  data: FluencyAudioReviewCommentDto
  status: 201
}

export type fluencyAudioReviewControllerCreateCommentV1ResponseSuccess =
  fluencyAudioReviewControllerCreateCommentV1Response201 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerCreateCommentV1Response =
  fluencyAudioReviewControllerCreateCommentV1ResponseSuccess

export const getFluencyAudioReviewControllerCreateCommentV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}/comments`
}

export const fluencyAudioReviewControllerCreateCommentV1 = async (
  id: number,
  createFluencyAudioReviewCommentDto: CreateFluencyAudioReviewCommentDto,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerCreateCommentV1Response> => {
  return customInstance<fluencyAudioReviewControllerCreateCommentV1Response>(
    getFluencyAudioReviewControllerCreateCommentV1Url(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createFluencyAudioReviewCommentDto)
    }
  )
}

/**
 * @summary Mark a result as listened by the current reviewer (idempotent)
 */
export type fluencyAudioReviewControllerMarkAsListenedV1Response201 = {
  data: FluencyAudioReviewListenDto
  status: 201
}

export type fluencyAudioReviewControllerMarkAsListenedV1ResponseSuccess =
  fluencyAudioReviewControllerMarkAsListenedV1Response201 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerMarkAsListenedV1Response =
  fluencyAudioReviewControllerMarkAsListenedV1ResponseSuccess

export const getFluencyAudioReviewControllerMarkAsListenedV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}/listens`
}

export const fluencyAudioReviewControllerMarkAsListenedV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerMarkAsListenedV1Response> => {
  return customInstance<fluencyAudioReviewControllerMarkAsListenedV1Response>(
    getFluencyAudioReviewControllerMarkAsListenedV1Url(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Set or remove the current reviewer transcription vote (up/down/null)
 */
export type fluencyAudioReviewControllerSetTranscriptionVoteV1Response200 = {
  data: FluencyAudioReviewTranscriptionVoteSummaryDto
  status: 200
}

export type fluencyAudioReviewControllerSetTranscriptionVoteV1ResponseSuccess =
  fluencyAudioReviewControllerSetTranscriptionVoteV1Response200 & {
    headers: Headers
  }
export type fluencyAudioReviewControllerSetTranscriptionVoteV1Response =
  fluencyAudioReviewControllerSetTranscriptionVoteV1ResponseSuccess

export const getFluencyAudioReviewControllerSetTranscriptionVoteV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-audio-review/results/${id}/transcription-vote`
}

export const fluencyAudioReviewControllerSetTranscriptionVoteV1 = async (
  id: number,
  setFluencyAudioReviewTranscriptionVoteDto: SetFluencyAudioReviewTranscriptionVoteDto,
  options?: RequestInit
): Promise<fluencyAudioReviewControllerSetTranscriptionVoteV1Response> => {
  return customInstance<fluencyAudioReviewControllerSetTranscriptionVoteV1Response>(
    getFluencyAudioReviewControllerSetTranscriptionVoteV1Url(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setFluencyAudioReviewTranscriptionVoteDto)
    }
  )
}

/**
 * @summary Get access report
 */
export type reportsControllerGetAccessReportResponse200 = {
  data: AccessReportResponseDto
  status: 200
}

export type reportsControllerGetAccessReportResponseSuccess =
  reportsControllerGetAccessReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetAccessReportResponse =
  reportsControllerGetAccessReportResponseSuccess

export const getReportsControllerGetAccessReportUrl = (
  params: ReportsControllerGetAccessReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/access?${stringifiedParams}`
    : `/api-arvore/reports/access`
}

export const reportsControllerGetAccessReport = async (
  params: ReportsControllerGetAccessReportParams,
  options?: RequestInit
): Promise<reportsControllerGetAccessReportResponse> => {
  return customInstance<reportsControllerGetAccessReportResponse>(
    getReportsControllerGetAccessReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.)
 * @summary Get access report using user sessions
 */
export type reportsControllerGetAccessReportV2V2Response200 = {
  data: AccessReportV2ResponseDto
  status: 200
}

export type reportsControllerGetAccessReportV2V2ResponseSuccess =
  reportsControllerGetAccessReportV2V2Response200 & {
    headers: Headers
  }
export type reportsControllerGetAccessReportV2V2Response =
  reportsControllerGetAccessReportV2V2ResponseSuccess

export const getReportsControllerGetAccessReportV2V2Url = (
  params: ReportsControllerGetAccessReportV2V2Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v2/reports/access?${stringifiedParams}`
    : `/api-arvore/v2/reports/access`
}

export const reportsControllerGetAccessReportV2V2 = async (
  params: ReportsControllerGetAccessReportV2V2Params,
  options?: RequestInit
): Promise<reportsControllerGetAccessReportV2V2Response> => {
  return customInstance<reportsControllerGetAccessReportV2V2Response>(
    getReportsControllerGetAccessReportV2V2Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get general vision summary metrics only
 */
export type reportsControllerGetGeneralVisionSummaryResponse200 = {
  data: GeneralVisionSummaryResponseDto
  status: 200
}

export type reportsControllerGetGeneralVisionSummaryResponseSuccess =
  reportsControllerGetGeneralVisionSummaryResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionSummaryResponse =
  reportsControllerGetGeneralVisionSummaryResponseSuccess

export const getReportsControllerGetGeneralVisionSummaryUrl = (
  params: ReportsControllerGetGeneralVisionSummaryParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision/summary?${stringifiedParams}`
    : `/api-arvore/reports/general-vision/summary`
}

export const reportsControllerGetGeneralVisionSummary = async (
  params: ReportsControllerGetGeneralVisionSummaryParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionSummaryResponse> => {
  return customInstance<reportsControllerGetGeneralVisionSummaryResponse>(
    getReportsControllerGetGeneralVisionSummaryUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get general vision entities list with pagination
 */
export type reportsControllerGetGeneralVisionEntitiesResponse200 = {
  data: GeneralVisionEntitiesResponseDto
  status: 200
}

export type reportsControllerGetGeneralVisionEntitiesResponseSuccess =
  reportsControllerGetGeneralVisionEntitiesResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionEntitiesResponse =
  reportsControllerGetGeneralVisionEntitiesResponseSuccess

export const getReportsControllerGetGeneralVisionEntitiesUrl = (
  params: ReportsControllerGetGeneralVisionEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision/entities?${stringifiedParams}`
    : `/api-arvore/reports/general-vision/entities`
}

export const reportsControllerGetGeneralVisionEntities = async (
  params: ReportsControllerGetGeneralVisionEntitiesParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionEntitiesResponse> => {
  return customInstance<reportsControllerGetGeneralVisionEntitiesResponse>(
    getReportsControllerGetGeneralVisionEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Stream entity metrics via SSE for general vision
 */
export type reportsControllerGetGeneralVisionEntityMetricsStreamResponse200 = {
  data: void
  status: 200
}

export type reportsControllerGetGeneralVisionEntityMetricsStreamResponseSuccess =
  reportsControllerGetGeneralVisionEntityMetricsStreamResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionEntityMetricsStreamResponse =
  reportsControllerGetGeneralVisionEntityMetricsStreamResponseSuccess

export const getReportsControllerGetGeneralVisionEntityMetricsStreamUrl = (
  params: ReportsControllerGetGeneralVisionEntityMetricsStreamParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision/entities/metrics?${stringifiedParams}`
    : `/api-arvore/reports/general-vision/entities/metrics`
}

export const reportsControllerGetGeneralVisionEntityMetricsStream = async (
  params: ReportsControllerGetGeneralVisionEntityMetricsStreamParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionEntityMetricsStreamResponse> => {
  return customInstance<reportsControllerGetGeneralVisionEntityMetricsStreamResponse>(
    getReportsControllerGetGeneralVisionEntityMetricsStreamUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get general vision report with comprehensive metrics
 */
export type reportsControllerGetGeneralVisionReportResponse200 = {
  data: GeneralVisionReportResponseDto
  status: 200
}

export type reportsControllerGetGeneralVisionReportResponseSuccess =
  reportsControllerGetGeneralVisionReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionReportResponse =
  reportsControllerGetGeneralVisionReportResponseSuccess

export const getReportsControllerGetGeneralVisionReportUrl = (
  params: ReportsControllerGetGeneralVisionReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision?${stringifiedParams}`
    : `/api-arvore/reports/general-vision`
}

export const reportsControllerGetGeneralVisionReport = async (
  params: ReportsControllerGetGeneralVisionReportParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionReportResponse> => {
  return customInstance<reportsControllerGetGeneralVisionReportResponse>(
    getReportsControllerGetGeneralVisionReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get general vision class report
 */
export type reportsControllerGetGeneralVisionClassReportResponse200 = {
  data: GeneralVisionClassReportResponseDto
  status: 200
}

export type reportsControllerGetGeneralVisionClassReportResponseSuccess =
  reportsControllerGetGeneralVisionClassReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionClassReportResponse =
  reportsControllerGetGeneralVisionClassReportResponseSuccess

export const getReportsControllerGetGeneralVisionClassReportUrl = (
  params: ReportsControllerGetGeneralVisionClassReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision/class?${stringifiedParams}`
    : `/api-arvore/reports/general-vision/class`
}

export const reportsControllerGetGeneralVisionClassReport = async (
  params: ReportsControllerGetGeneralVisionClassReportParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionClassReportResponse> => {
  return customInstance<reportsControllerGetGeneralVisionClassReportResponse>(
    getReportsControllerGetGeneralVisionClassReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get general vision user report
 */
export type reportsControllerGetGeneralVisionUserReportResponse200 = {
  data: GeneralVisionUserReportResponseDto
  status: 200
}

export type reportsControllerGetGeneralVisionUserReportResponseSuccess =
  reportsControllerGetGeneralVisionUserReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetGeneralVisionUserReportResponse =
  reportsControllerGetGeneralVisionUserReportResponseSuccess

export const getReportsControllerGetGeneralVisionUserReportUrl = (
  params: ReportsControllerGetGeneralVisionUserReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/general-vision/user?${stringifiedParams}`
    : `/api-arvore/reports/general-vision/user`
}

export const reportsControllerGetGeneralVisionUserReport = async (
  params: ReportsControllerGetGeneralVisionUserReportParams,
  options?: RequestInit
): Promise<reportsControllerGetGeneralVisionUserReportResponse> => {
  return customInstance<reportsControllerGetGeneralVisionUserReportResponse>(
    getReportsControllerGetGeneralVisionUserReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get reading report by class
 */
export type reportsControllerGetReadingReportResponse200 = {
  data: ReadingReportResponseDto
  status: 200
}

export type reportsControllerGetReadingReportResponseSuccess =
  reportsControllerGetReadingReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingReportResponse =
  reportsControllerGetReadingReportResponseSuccess

export const getReportsControllerGetReadingReportUrl = (
  params: ReportsControllerGetReadingReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/reading?${stringifiedParams}`
    : `/api-arvore/reports/reading`
}

export const reportsControllerGetReadingReport = async (
  params: ReportsControllerGetReadingReportParams,
  options?: RequestInit
): Promise<reportsControllerGetReadingReportResponse> => {
  return customInstance<reportsControllerGetReadingReportResponse>(
    getReportsControllerGetReadingReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get reading report by reader
 */
export type reportsControllerGetReadingReportByReaderResponse200 = {
  data: ReadingReportByReaderResponseDto
  status: 200
}

export type reportsControllerGetReadingReportByReaderResponseSuccess =
  reportsControllerGetReadingReportByReaderResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingReportByReaderResponse =
  reportsControllerGetReadingReportByReaderResponseSuccess

export const getReportsControllerGetReadingReportByReaderUrl = (
  readerId: string,
  params: ReportsControllerGetReadingReportByReaderParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/reading/reader/${readerId}?${stringifiedParams}`
    : `/api-arvore/reports/reading/reader/${readerId}`
}

export const reportsControllerGetReadingReportByReader = async (
  readerId: string,
  params: ReportsControllerGetReadingReportByReaderParams,
  options?: RequestInit
): Promise<reportsControllerGetReadingReportByReaderResponse> => {
  return customInstance<reportsControllerGetReadingReportByReaderResponse>(
    getReportsControllerGetReadingReportByReaderUrl(readerId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get books report by entity
 */
export type reportsControllerGetBooksReportResponse200 = {
  data: BooksReportResponseDto
  status: 200
}

export type reportsControllerGetBooksReportResponseSuccess =
  reportsControllerGetBooksReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetBooksReportResponse =
  reportsControllerGetBooksReportResponseSuccess

export const getReportsControllerGetBooksReportUrl = (
  params: ReportsControllerGetBooksReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/books-report?${stringifiedParams}`
    : `/api-arvore/reports/books-report`
}

export const reportsControllerGetBooksReport = async (
  params: ReportsControllerGetBooksReportParams,
  options?: RequestInit
): Promise<reportsControllerGetBooksReportResponse> => {
  return customInstance<reportsControllerGetBooksReportResponse>(
    getReportsControllerGetBooksReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get books report by user
 */
export type reportsControllerGetBooksUserReportResponse200 = {
  data: BooksUserReportResponseDto
  status: 200
}

export type reportsControllerGetBooksUserReportResponseSuccess =
  reportsControllerGetBooksUserReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetBooksUserReportResponse =
  reportsControllerGetBooksUserReportResponseSuccess

export const getReportsControllerGetBooksUserReportUrl = (
  userId: string,
  params: ReportsControllerGetBooksUserReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/books-report/user/${userId}?${stringifiedParams}`
    : `/api-arvore/reports/books-report/user/${userId}`
}

export const reportsControllerGetBooksUserReport = async (
  userId: string,
  params: ReportsControllerGetBooksUserReportParams,
  options?: RequestInit
): Promise<reportsControllerGetBooksUserReportResponse> => {
  return customInstance<reportsControllerGetBooksUserReportResponse>(
    getReportsControllerGetBooksUserReportUrl(userId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book detail report by class
 */
export type reportsControllerGetBookDetailReportResponse200 = {
  data: BookDetailReportResponseDto
  status: 200
}

export type reportsControllerGetBookDetailReportResponseSuccess =
  reportsControllerGetBookDetailReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetBookDetailReportResponse =
  reportsControllerGetBookDetailReportResponseSuccess

export const getReportsControllerGetBookDetailReportUrl = (
  params: ReportsControllerGetBookDetailReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/books-report/detail?${stringifiedParams}`
    : `/api-arvore/reports/books-report/detail`
}

export const reportsControllerGetBookDetailReport = async (
  params: ReportsControllerGetBookDetailReportParams,
  options?: RequestInit
): Promise<reportsControllerGetBookDetailReportResponse> => {
  return customInstance<reportsControllerGetBookDetailReportResponse>(
    getReportsControllerGetBookDetailReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get weekly reading goals report
 */
export type reportsControllerGetReadingGoalsReportResponse200 = {
  data: ReadingGoalsReportResponseDto
  status: 200
}

export type reportsControllerGetReadingGoalsReportResponseSuccess =
  reportsControllerGetReadingGoalsReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingGoalsReportResponse =
  reportsControllerGetReadingGoalsReportResponseSuccess

export const getReportsControllerGetReadingGoalsReportUrl = (
  params: ReportsControllerGetReadingGoalsReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/reading-goals?${stringifiedParams}`
    : `/api-arvore/reports/reading-goals`
}

export const reportsControllerGetReadingGoalsReport = async (
  params: ReportsControllerGetReadingGoalsReportParams,
  options?: RequestInit
): Promise<reportsControllerGetReadingGoalsReportResponse> => {
  return customInstance<reportsControllerGetReadingGoalsReportResponse>(
    getReportsControllerGetReadingGoalsReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns all activities (applied activities, reading indications, and fluency assessments) for an entity and its sub-entities
 * @summary Get activities report by entity
 */
export type reportsControllerGetActivitiesReportResponse200 = {
  data: ActivitiesEntityReportResponseDto
  status: 200
}

export type reportsControllerGetActivitiesReportResponseSuccess =
  reportsControllerGetActivitiesReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetActivitiesReportResponse =
  reportsControllerGetActivitiesReportResponseSuccess

export const getReportsControllerGetActivitiesReportUrl = (
  params: ReportsControllerGetActivitiesReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/activities?${stringifiedParams}`
    : `/api-arvore/reports/activities`
}

export const reportsControllerGetActivitiesReport = async (
  params: ReportsControllerGetActivitiesReportParams,
  options?: RequestInit
): Promise<reportsControllerGetActivitiesReportResponse> => {
  return customInstance<reportsControllerGetActivitiesReportResponse>(
    getReportsControllerGetActivitiesReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns all activities (applied activities, reading indications) for a specific student with status and accuracy
 * @summary Get activities report for a specific student
 */
export type reportsControllerGetActivitiesStudentReportResponse200 = {
  data: ActivitiesStudentReportResponseDto
  status: 200
}

export type reportsControllerGetActivitiesStudentReportResponseSuccess =
  reportsControllerGetActivitiesStudentReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetActivitiesStudentReportResponse =
  reportsControllerGetActivitiesStudentReportResponseSuccess

export const getReportsControllerGetActivitiesStudentReportUrl = (
  params: ReportsControllerGetActivitiesStudentReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/activities/student?${stringifiedParams}`
    : `/api-arvore/reports/activities/student`
}

export const reportsControllerGetActivitiesStudentReport = async (
  params: ReportsControllerGetActivitiesStudentReportParams,
  options?: RequestInit
): Promise<reportsControllerGetActivitiesStudentReportResponse> => {
  return customInstance<reportsControllerGetActivitiesStudentReportResponse>(
    getReportsControllerGetActivitiesStudentReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns detailed information about an applied activity including student answers, completion percentage, and question-by-question results
 * @summary Get detailed report of activity with questions
 */
export type reportsControllerGetActivityQuestionsDetailsResponse200 = {
  data: ActivityQuestionsDetailsResponseDto
  status: 200
}

export type reportsControllerGetActivityQuestionsDetailsResponseSuccess =
  reportsControllerGetActivityQuestionsDetailsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetActivityQuestionsDetailsResponse =
  reportsControllerGetActivityQuestionsDetailsResponseSuccess

export const getReportsControllerGetActivityQuestionsDetailsUrl = (
  params: ReportsControllerGetActivityQuestionsDetailsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/activities/questions/details?${stringifiedParams}`
    : `/api-arvore/reports/activities/questions/details`
}

export const reportsControllerGetActivityQuestionsDetails = async (
  params: ReportsControllerGetActivityQuestionsDetailsParams,
  options?: RequestInit
): Promise<reportsControllerGetActivityQuestionsDetailsResponse> => {
  return customInstance<reportsControllerGetActivityQuestionsDetailsResponse>(
    getReportsControllerGetActivityQuestionsDetailsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns detailed information about a reading indication including student reading status, time spent, effective reading time, and pages read
 * @summary Get detailed report of reading activity
 */
export type reportsControllerGetActivityReadingDetailsResponse200 = {
  data: ActivityReadingDetailsResponseDto
  status: 200
}

export type reportsControllerGetActivityReadingDetailsResponseSuccess =
  reportsControllerGetActivityReadingDetailsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetActivityReadingDetailsResponse =
  reportsControllerGetActivityReadingDetailsResponseSuccess

export const getReportsControllerGetActivityReadingDetailsUrl = (
  params: ReportsControllerGetActivityReadingDetailsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/activities/reading/details?${stringifiedParams}`
    : `/api-arvore/reports/activities/reading/details`
}

export const reportsControllerGetActivityReadingDetails = async (
  params: ReportsControllerGetActivityReadingDetailsParams,
  options?: RequestInit
): Promise<reportsControllerGetActivityReadingDetailsResponse> => {
  return customInstance<reportsControllerGetActivityReadingDetailsResponse>(
    getReportsControllerGetActivityReadingDetailsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get articles report
 */
export type reportsControllerGetArticlesReportResponse200 = {
  data: ArticlesReportResponseDto
  status: 200
}

export type reportsControllerGetArticlesReportResponseSuccess =
  reportsControllerGetArticlesReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetArticlesReportResponse =
  reportsControllerGetArticlesReportResponseSuccess

export const getReportsControllerGetArticlesReportUrl = (
  params: ReportsControllerGetArticlesReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/articles?${stringifiedParams}`
    : `/api-arvore/reports/articles`
}

export const reportsControllerGetArticlesReport = async (
  params: ReportsControllerGetArticlesReportParams,
  options?: RequestInit
): Promise<reportsControllerGetArticlesReportResponse> => {
  return customInstance<reportsControllerGetArticlesReportResponse>(
    getReportsControllerGetArticlesReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get articles consumed by user ID
 */
export type reportsControllerGetArticlesReportByUserResponse200 = {
  data: UserArticlesResponseDto[]
  status: 200
}

export type reportsControllerGetArticlesReportByUserResponseSuccess =
  reportsControllerGetArticlesReportByUserResponse200 & {
    headers: Headers
  }
export type reportsControllerGetArticlesReportByUserResponse =
  reportsControllerGetArticlesReportByUserResponseSuccess

export const getReportsControllerGetArticlesReportByUserUrl = (
  userId: string,
  params: ReportsControllerGetArticlesReportByUserParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/articles/user/${userId}?${stringifiedParams}`
    : `/api-arvore/reports/articles/user/${userId}`
}

export const reportsControllerGetArticlesReportByUser = async (
  userId: string,
  params: ReportsControllerGetArticlesReportByUserParams,
  options?: RequestInit
): Promise<reportsControllerGetArticlesReportByUserResponse> => {
  return customInstance<reportsControllerGetArticlesReportByUserResponse>(
    getReportsControllerGetArticlesReportByUserUrl(userId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get article details by class and article
 */
export type reportsControllerGetArticleDetailsResponse200 = {
  data: ArticleDetailsResponseDto
  status: 200
}

export type reportsControllerGetArticleDetailsResponseSuccess =
  reportsControllerGetArticleDetailsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetArticleDetailsResponse =
  reportsControllerGetArticleDetailsResponseSuccess

export const getReportsControllerGetArticleDetailsUrl = (
  params: ReportsControllerGetArticleDetailsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/article-details?${stringifiedParams}`
    : `/api-arvore/reports/article-details`
}

export const reportsControllerGetArticleDetails = async (
  params: ReportsControllerGetArticleDetailsParams,
  options?: RequestInit
): Promise<reportsControllerGetArticleDetailsResponse> => {
  return customInstance<reportsControllerGetArticleDetailsResponse>(
    getReportsControllerGetArticleDetailsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get student access report
 */
export type reportsControllerGetStudentAccessReportResponse200 = {
  data: StudentAccessReportResponseDto
  status: 200
}

export type reportsControllerGetStudentAccessReportResponseSuccess =
  reportsControllerGetStudentAccessReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetStudentAccessReportResponse =
  reportsControllerGetStudentAccessReportResponseSuccess

export const getReportsControllerGetStudentAccessReportUrl = (
  params: ReportsControllerGetStudentAccessReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/student-access?${stringifiedParams}`
    : `/api-arvore/reports/student-access`
}

export const reportsControllerGetStudentAccessReport = async (
  params: ReportsControllerGetStudentAccessReportParams,
  options?: RequestInit
): Promise<reportsControllerGetStudentAccessReportResponse> => {
  return customInstance<reportsControllerGetStudentAccessReportResponse>(
    getReportsControllerGetStudentAccessReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.)
 * @summary Get student access report using user sessions
 */
export type reportsControllerGetStudentAccessReportV2V2Response200 = {
  data: StudentAccessReportV2ResponseDto
  status: 200
}

export type reportsControllerGetStudentAccessReportV2V2ResponseSuccess =
  reportsControllerGetStudentAccessReportV2V2Response200 & {
    headers: Headers
  }
export type reportsControllerGetStudentAccessReportV2V2Response =
  reportsControllerGetStudentAccessReportV2V2ResponseSuccess

export const getReportsControllerGetStudentAccessReportV2V2Url = (
  params: ReportsControllerGetStudentAccessReportV2V2Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v2/reports/student-access?${stringifiedParams}`
    : `/api-arvore/v2/reports/student-access`
}

export const reportsControllerGetStudentAccessReportV2V2 = async (
  params: ReportsControllerGetStudentAccessReportV2V2Params,
  options?: RequestInit
): Promise<reportsControllerGetStudentAccessReportV2V2Response> => {
  return customInstance<reportsControllerGetStudentAccessReportV2V2Response>(
    getReportsControllerGetStudentAccessReportV2V2Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get task report
 */
export type reportsControllerGetTaskReportResponse200 = {
  data: TaskReportResponseDto
  status: 200
}

export type reportsControllerGetTaskReportResponseSuccess =
  reportsControllerGetTaskReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetTaskReportResponse =
  reportsControllerGetTaskReportResponseSuccess

export const getReportsControllerGetTaskReportUrl = (
  params: ReportsControllerGetTaskReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/tasks?${stringifiedParams}`
    : `/api-arvore/reports/tasks`
}

export const reportsControllerGetTaskReport = async (
  params: ReportsControllerGetTaskReportParams,
  options?: RequestInit
): Promise<reportsControllerGetTaskReportResponse> => {
  return customInstance<reportsControllerGetTaskReportResponse>(
    getReportsControllerGetTaskReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get activity statistics by month
 */
export type reportsControllerGetActivityStatsByMonthResponse200 = {
  data: ActivityStatsByMonthResponseDto[]
  status: 200
}

export type reportsControllerGetActivityStatsByMonthResponseSuccess =
  reportsControllerGetActivityStatsByMonthResponse200 & {
    headers: Headers
  }
export type reportsControllerGetActivityStatsByMonthResponse =
  reportsControllerGetActivityStatsByMonthResponseSuccess

export const getReportsControllerGetActivityStatsByMonthUrl = (
  params: ReportsControllerGetActivityStatsByMonthParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/activity-stats-by-month?${stringifiedParams}`
    : `/api-arvore/reports/activity-stats-by-month`
}

export const reportsControllerGetActivityStatsByMonth = async (
  params: ReportsControllerGetActivityStatsByMonthParams,
  options?: RequestInit
): Promise<reportsControllerGetActivityStatsByMonthResponse> => {
  return customInstance<reportsControllerGetActivityStatsByMonthResponse>(
    getReportsControllerGetActivityStatsByMonthUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get task report by user ID
 */
export type reportsControllerGetTaskReportByUserResponse200 = {
  data: TaskReportByUserResponseDto[]
  status: 200
}

export type reportsControllerGetTaskReportByUserResponseSuccess =
  reportsControllerGetTaskReportByUserResponse200 & {
    headers: Headers
  }
export type reportsControllerGetTaskReportByUserResponse =
  reportsControllerGetTaskReportByUserResponseSuccess

export const getReportsControllerGetTaskReportByUserUrl = (
  userId: string,
  params: ReportsControllerGetTaskReportByUserParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/tasks/user/${userId}?${stringifiedParams}`
    : `/api-arvore/reports/tasks/user/${userId}`
}

export const reportsControllerGetTaskReportByUser = async (
  userId: string,
  params: ReportsControllerGetTaskReportByUserParams,
  options?: RequestInit
): Promise<reportsControllerGetTaskReportByUserResponse> => {
  return customInstance<reportsControllerGetTaskReportByUserResponse>(
    getReportsControllerGetTaskReportByUserUrl(userId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get task details by task ID
 */
export type reportsControllerGetTaskDetailsResponse200 = {
  data: TaskDetailsResponseDto
  status: 200
}

export type reportsControllerGetTaskDetailsResponseSuccess =
  reportsControllerGetTaskDetailsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetTaskDetailsResponse =
  reportsControllerGetTaskDetailsResponseSuccess

export const getReportsControllerGetTaskDetailsUrl = (
  taskId: string,
  params?: ReportsControllerGetTaskDetailsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/tasks/detail/${taskId}?${stringifiedParams}`
    : `/api-arvore/reports/tasks/detail/${taskId}`
}

export const reportsControllerGetTaskDetails = async (
  taskId: string,
  params?: ReportsControllerGetTaskDetailsParams,
  options?: RequestInit
): Promise<reportsControllerGetTaskDetailsResponse> => {
  return customInstance<reportsControllerGetTaskDetailsResponse>(
    getReportsControllerGetTaskDetailsUrl(taskId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get applied activity details by applied activity ID
 */
export type reportsControllerGetAppliedActivityDetailsResponse200 = {
  data: AppliedActivityReportsDetailsResponseDto[]
  status: 200
}

export type reportsControllerGetAppliedActivityDetailsResponseSuccess =
  reportsControllerGetAppliedActivityDetailsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetAppliedActivityDetailsResponse =
  reportsControllerGetAppliedActivityDetailsResponseSuccess

export const getReportsControllerGetAppliedActivityDetailsUrl = (
  appliedActivityId: string,
  params?: ReportsControllerGetAppliedActivityDetailsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/applied-activities/detail/${appliedActivityId}?${stringifiedParams}`
    : `/api-arvore/reports/applied-activities/detail/${appliedActivityId}`
}

export const reportsControllerGetAppliedActivityDetails = async (
  appliedActivityId: string,
  params?: ReportsControllerGetAppliedActivityDetailsParams,
  options?: RequestInit
): Promise<reportsControllerGetAppliedActivityDetailsResponse> => {
  return customInstance<reportsControllerGetAppliedActivityDetailsResponse>(
    getReportsControllerGetAppliedActivityDetailsUrl(appliedActivityId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get managers by entity type
 */
export type reportsControllerGetManagersByEntityTypeResponse200 = {
  data: TeachersReportResponseDto
  status: 200
}

export type reportsControllerGetManagersByEntityTypeResponseSuccess =
  reportsControllerGetManagersByEntityTypeResponse200 & {
    headers: Headers
  }
export type reportsControllerGetManagersByEntityTypeResponse =
  reportsControllerGetManagersByEntityTypeResponseSuccess

export const getReportsControllerGetManagersByEntityTypeUrl = (
  entityType: 'class' | 'holding' | 'network' | 'school' | 'trademark',
  params: ReportsControllerGetManagersByEntityTypeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/managers/${entityType}?${stringifiedParams}`
    : `/api-arvore/reports/managers/${entityType}`
}

export const reportsControllerGetManagersByEntityType = async (
  entityType: 'class' | 'holding' | 'network' | 'school' | 'trademark',
  params: ReportsControllerGetManagersByEntityTypeParams,
  options?: RequestInit
): Promise<reportsControllerGetManagersByEntityTypeResponse> => {
  return customInstance<reportsControllerGetManagersByEntityTypeResponse>(
    getReportsControllerGetManagersByEntityTypeUrl(entityType, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get teachers by entity type
 */
export type reportsControllerGetTeachersByEntityTypeResponse200 = {
  data: TeachersReportResponseDto
  status: 200
}

export type reportsControllerGetTeachersByEntityTypeResponseSuccess =
  reportsControllerGetTeachersByEntityTypeResponse200 & {
    headers: Headers
  }
export type reportsControllerGetTeachersByEntityTypeResponse =
  reportsControllerGetTeachersByEntityTypeResponseSuccess

export const getReportsControllerGetTeachersByEntityTypeUrl = (
  entityType: 'class' | 'holding' | 'network' | 'school' | 'trademark',
  params: ReportsControllerGetTeachersByEntityTypeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/teachers/${entityType}?${stringifiedParams}`
    : `/api-arvore/reports/teachers/${entityType}`
}

export const reportsControllerGetTeachersByEntityType = async (
  entityType: 'class' | 'holding' | 'network' | 'school' | 'trademark',
  params: ReportsControllerGetTeachersByEntityTypeParams,
  options?: RequestInit
): Promise<reportsControllerGetTeachersByEntityTypeResponse> => {
  return customInstance<reportsControllerGetTeachersByEntityTypeResponse>(
    getReportsControllerGetTeachersByEntityTypeUrl(entityType, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get all educators by current entity
 */
export type reportsControllerGetEducatorsByEntityResponse200 = {
  data: EducatorsByRootResponseDto
  status: 200
}

export type reportsControllerGetEducatorsByEntityResponseSuccess =
  reportsControllerGetEducatorsByEntityResponse200 & {
    headers: Headers
  }
export type reportsControllerGetEducatorsByEntityResponse =
  reportsControllerGetEducatorsByEntityResponseSuccess

export const getReportsControllerGetEducatorsByEntityUrl = (
  params: ReportsControllerGetEducatorsByEntityParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/educators?${stringifiedParams}`
    : `/api-arvore/reports/educators`
}

export const reportsControllerGetEducatorsByEntity = async (
  params: ReportsControllerGetEducatorsByEntityParams,
  options?: RequestInit
): Promise<reportsControllerGetEducatorsByEntityResponse> => {
  return customInstance<reportsControllerGetEducatorsByEntityResponse>(
    getReportsControllerGetEducatorsByEntityUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get journeys report by class
 */
export type reportsControllerGetJourneysReportResponse200 = {
  data: JourneysReportResponseDto
  status: 200
}

export type reportsControllerGetJourneysReportResponseSuccess =
  reportsControllerGetJourneysReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetJourneysReportResponse =
  reportsControllerGetJourneysReportResponseSuccess

export const getReportsControllerGetJourneysReportUrl = (
  params: ReportsControllerGetJourneysReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/journeys?${stringifiedParams}`
    : `/api-arvore/reports/journeys`
}

export const reportsControllerGetJourneysReport = async (
  params: ReportsControllerGetJourneysReportParams,
  options?: RequestInit
): Promise<reportsControllerGetJourneysReportResponse> => {
  return customInstance<reportsControllerGetJourneysReportResponse>(
    getReportsControllerGetJourneysReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get running records report by class
 */
export type reportsControllerGetRunningRecordsClassReportResponse200 = {
  data: RunningRecordsClassReportResponseDto
  status: 200
}

export type reportsControllerGetRunningRecordsClassReportResponseSuccess =
  reportsControllerGetRunningRecordsClassReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetRunningRecordsClassReportResponse =
  reportsControllerGetRunningRecordsClassReportResponseSuccess

export const getReportsControllerGetRunningRecordsClassReportUrl = (
  classId: string
) => {
  return `/api-arvore/reports/running-records/class/${classId}`
}

export const reportsControllerGetRunningRecordsClassReport = async (
  classId: string,
  options?: RequestInit
): Promise<reportsControllerGetRunningRecordsClassReportResponse> => {
  return customInstance<reportsControllerGetRunningRecordsClassReportResponse>(
    getReportsControllerGetRunningRecordsClassReportUrl(classId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get running records report by student
 */
export type reportsControllerGetRunningRecordsStudentReportResponse200 = {
  data: RunningRecordsStudentReportResponseDto
  status: 200
}

export type reportsControllerGetRunningRecordsStudentReportResponseSuccess =
  reportsControllerGetRunningRecordsStudentReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetRunningRecordsStudentReportResponse =
  reportsControllerGetRunningRecordsStudentReportResponseSuccess

export const getReportsControllerGetRunningRecordsStudentReportUrl = (
  userId: number
) => {
  return `/api-arvore/reports/running-records/student/${userId}`
}

export const reportsControllerGetRunningRecordsStudentReport = async (
  userId: number,
  options?: RequestInit
): Promise<reportsControllerGetRunningRecordsStudentReportResponse> => {
  return customInstance<reportsControllerGetRunningRecordsStudentReportResponse>(
    getReportsControllerGetRunningRecordsStudentReportUrl(userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get running records assessment detail
 */
export type reportsControllerGetRunningRecordsAssessmentDetailResponse200 = {
  data: RunningRecordsAssessmentDetailResponseDto
  status: 200
}

export type reportsControllerGetRunningRecordsAssessmentDetailResponseSuccess =
  reportsControllerGetRunningRecordsAssessmentDetailResponse200 & {
    headers: Headers
  }
export type reportsControllerGetRunningRecordsAssessmentDetailResponse =
  reportsControllerGetRunningRecordsAssessmentDetailResponseSuccess

export const getReportsControllerGetRunningRecordsAssessmentDetailUrl = (
  assessmentResultId: number
) => {
  return `/api-arvore/reports/running-records/assessment/${assessmentResultId}`
}

export const reportsControllerGetRunningRecordsAssessmentDetail = async (
  assessmentResultId: number,
  options?: RequestInit
): Promise<reportsControllerGetRunningRecordsAssessmentDetailResponse> => {
  return customInstance<reportsControllerGetRunningRecordsAssessmentDetailResponse>(
    getReportsControllerGetRunningRecordsAssessmentDetailUrl(
      assessmentResultId
    ),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get journey details by user ID
 */
export type reportsControllerGetJourneyDetailsByUserResponse200 = {
  data: JourneyDetailsByUserResponseDto
  status: 200
}

export type reportsControllerGetJourneyDetailsByUserResponseSuccess =
  reportsControllerGetJourneyDetailsByUserResponse200 & {
    headers: Headers
  }
export type reportsControllerGetJourneyDetailsByUserResponse =
  reportsControllerGetJourneyDetailsByUserResponseSuccess

export const getReportsControllerGetJourneyDetailsByUserUrl = (
  userId: string,
  params: ReportsControllerGetJourneyDetailsByUserParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/journeys/user/${userId}?${stringifiedParams}`
    : `/api-arvore/reports/journeys/user/${userId}`
}

export const reportsControllerGetJourneyDetailsByUser = async (
  userId: string,
  params: ReportsControllerGetJourneyDetailsByUserParams,
  options?: RequestInit
): Promise<reportsControllerGetJourneyDetailsByUserResponse> => {
  return customInstance<reportsControllerGetJourneyDetailsByUserResponse>(
    getReportsControllerGetJourneyDetailsByUserUrl(userId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get payment report overview
 */
export type reportsControllerGetPaymentReportResponse200 = {
  data: PaymentReportResponseDto
  status: 200
}

export type reportsControllerGetPaymentReportResponseSuccess =
  reportsControllerGetPaymentReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetPaymentReportResponse =
  reportsControllerGetPaymentReportResponseSuccess

export const getReportsControllerGetPaymentReportUrl = (
  params: ReportsControllerGetPaymentReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/payments?${stringifiedParams}`
    : `/api-arvore/reports/payments`
}

export const reportsControllerGetPaymentReport = async (
  params: ReportsControllerGetPaymentReportParams,
  options?: RequestInit
): Promise<reportsControllerGetPaymentReportResponse> => {
  return customInstance<reportsControllerGetPaymentReportResponse>(
    getReportsControllerGetPaymentReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get payment report by class
 */
export type reportsControllerGetPaymentClassReportResponse200 = {
  data: PaymentClassReportResponseDto
  status: 200
}

export type reportsControllerGetPaymentClassReportResponseSuccess =
  reportsControllerGetPaymentClassReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetPaymentClassReportResponse =
  reportsControllerGetPaymentClassReportResponseSuccess

export const getReportsControllerGetPaymentClassReportUrl = (
  classId: string
) => {
  return `/api-arvore/reports/payments/class/${classId}`
}

export const reportsControllerGetPaymentClassReport = async (
  classId: string,
  options?: RequestInit
): Promise<reportsControllerGetPaymentClassReportResponse> => {
  return customInstance<reportsControllerGetPaymentClassReportResponse>(
    getReportsControllerGetPaymentClassReportUrl(classId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get reading fluency report by class
 */
export type reportsControllerGetReadingFluencyClassReportResponse200 = {
  data: ReadingFluencyClassReportResponseDto
  status: 200
}

export type reportsControllerGetReadingFluencyClassReportResponseSuccess =
  reportsControllerGetReadingFluencyClassReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingFluencyClassReportResponse =
  reportsControllerGetReadingFluencyClassReportResponseSuccess

export const getReportsControllerGetReadingFluencyClassReportUrl = (
  classId: string
) => {
  return `/api-arvore/reports/reading-fluency/class/${classId}`
}

export const reportsControllerGetReadingFluencyClassReport = async (
  classId: string,
  options?: RequestInit
): Promise<reportsControllerGetReadingFluencyClassReportResponse> => {
  return customInstance<reportsControllerGetReadingFluencyClassReportResponse>(
    getReportsControllerGetReadingFluencyClassReportUrl(classId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns assessment history for a specific student including comprehension and oral reading levels, trends, and evolution data for charts
 * @summary Get reading fluency report by student
 */
export type reportsControllerGetReadingFluencyStudentReportResponse200 = {
  data: ReadingFluencyStudentReportResponseDto
  status: 200
}

export type reportsControllerGetReadingFluencyStudentReportResponseSuccess =
  reportsControllerGetReadingFluencyStudentReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingFluencyStudentReportResponse =
  reportsControllerGetReadingFluencyStudentReportResponseSuccess

export const getReportsControllerGetReadingFluencyStudentReportUrl = (
  userId: string
) => {
  return `/api-arvore/reports/reading-fluency/student/${userId}`
}

export const reportsControllerGetReadingFluencyStudentReport = async (
  userId: string,
  options?: RequestInit
): Promise<reportsControllerGetReadingFluencyStudentReportResponse> => {
  return customInstance<reportsControllerGetReadingFluencyStudentReportResponse>(
    getReportsControllerGetReadingFluencyStudentReportUrl(userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns detailed information about a specific assessment including comprehension questions with student answers and oral reading data with highlighted errors
 * @summary Get reading fluency assessment detail
 */
export type reportsControllerGetReadingFluencyStudentAssessmentDetailResponse200 =
  {
    data: ReadingFluencyStudentAssessmentDetailResponseDto
    status: 200
  }

export type reportsControllerGetReadingFluencyStudentAssessmentDetailResponseSuccess =
  reportsControllerGetReadingFluencyStudentAssessmentDetailResponse200 & {
    headers: Headers
  }
export type reportsControllerGetReadingFluencyStudentAssessmentDetailResponse =
  reportsControllerGetReadingFluencyStudentAssessmentDetailResponseSuccess

export const getReportsControllerGetReadingFluencyStudentAssessmentDetailUrl = (
  userId: string,
  assessmentId: string
) => {
  return `/api-arvore/reports/reading-fluency/student/${userId}/assessment/${assessmentId}`
}

export const reportsControllerGetReadingFluencyStudentAssessmentDetail = async (
  userId: string,
  assessmentId: string,
  options?: RequestInit
): Promise<reportsControllerGetReadingFluencyStudentAssessmentDetailResponse> => {
  return customInstance<reportsControllerGetReadingFluencyStudentAssessmentDetailResponse>(
    getReportsControllerGetReadingFluencyStudentAssessmentDetailUrl(
      userId,
      assessmentId
    ),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns the three main summary cards: total readings/book openings, effective reading time, and total activities performed
 * @summary Get summary cards with key metrics
 */
export type reportsControllerGetSummaryCardsResponse200 = {
  data: SummaryCardsResponseDto
  status: 200
}

export type reportsControllerGetSummaryCardsResponseSuccess =
  reportsControllerGetSummaryCardsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryCardsResponse =
  reportsControllerGetSummaryCardsResponseSuccess

export const getReportsControllerGetSummaryCardsUrl = (
  params: ReportsControllerGetSummaryCardsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/cards?${stringifiedParams}`
    : `/api-arvore/reports/summary/cards`
}

export const reportsControllerGetSummaryCards = async (
  params: ReportsControllerGetSummaryCardsParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryCardsResponse> => {
  return customInstance<reportsControllerGetSummaryCardsResponse>(
    getReportsControllerGetSummaryCardsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns effective reading time and contents read grouped by month
 * @summary Get effective reading chart data by month
 */
export type reportsControllerGetSummaryEffectiveReadingChartResponse200 = {
  data: SummaryEffectiveReadingChartResponseDto
  status: 200
}

export type reportsControllerGetSummaryEffectiveReadingChartResponseSuccess =
  reportsControllerGetSummaryEffectiveReadingChartResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryEffectiveReadingChartResponse =
  reportsControllerGetSummaryEffectiveReadingChartResponseSuccess

export const getReportsControllerGetSummaryEffectiveReadingChartUrl = (
  params: ReportsControllerGetSummaryEffectiveReadingChartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/effective-reading-chart?${stringifiedParams}`
    : `/api-arvore/reports/summary/effective-reading-chart`
}

export const reportsControllerGetSummaryEffectiveReadingChart = async (
  params: ReportsControllerGetSummaryEffectiveReadingChartParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryEffectiveReadingChartResponse> => {
  return customInstance<reportsControllerGetSummaryEffectiveReadingChartResponse>(
    getReportsControllerGetSummaryEffectiveReadingChartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns classes ranked by total effective reading time with pagination
 * @summary Get top reading classes by effective reading time
 */
export type reportsControllerGetSummaryTopReadingClassesResponse200 = {
  data: SummaryTopReadingClassesResponseDto
  status: 200
}

export type reportsControllerGetSummaryTopReadingClassesResponseSuccess =
  reportsControllerGetSummaryTopReadingClassesResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryTopReadingClassesResponse =
  reportsControllerGetSummaryTopReadingClassesResponseSuccess

export const getReportsControllerGetSummaryTopReadingClassesUrl = (
  params: ReportsControllerGetSummaryTopReadingClassesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/top-reading-classes?${stringifiedParams}`
    : `/api-arvore/reports/summary/top-reading-classes`
}

export const reportsControllerGetSummaryTopReadingClasses = async (
  params: ReportsControllerGetSummaryTopReadingClassesParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryTopReadingClassesResponse> => {
  return customInstance<reportsControllerGetSummaryTopReadingClassesResponse>(
    getReportsControllerGetSummaryTopReadingClassesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns students ranked by total effective reading time with pagination
 * @summary Get top reading students by effective reading time
 */
export type reportsControllerGetSummaryTopReadingStudentsResponse200 = {
  data: SummaryTopReadingStudentsResponseDto
  status: 200
}

export type reportsControllerGetSummaryTopReadingStudentsResponseSuccess =
  reportsControllerGetSummaryTopReadingStudentsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryTopReadingStudentsResponse =
  reportsControllerGetSummaryTopReadingStudentsResponseSuccess

export const getReportsControllerGetSummaryTopReadingStudentsUrl = (
  params: ReportsControllerGetSummaryTopReadingStudentsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/top-reading-students?${stringifiedParams}`
    : `/api-arvore/reports/summary/top-reading-students`
}

export const reportsControllerGetSummaryTopReadingStudents = async (
  params: ReportsControllerGetSummaryTopReadingStudentsParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryTopReadingStudentsResponse> => {
  return customInstance<reportsControllerGetSummaryTopReadingStudentsResponse>(
    getReportsControllerGetSummaryTopReadingStudentsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns top 5 most read contents combining books and articles
 * @summary Get top read contents (books and articles)
 */
export type reportsControllerGetSummaryTopContentsResponse200 = {
  data: SummaryTopContentsResponseDto
  status: 200
}

export type reportsControllerGetSummaryTopContentsResponseSuccess =
  reportsControllerGetSummaryTopContentsResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryTopContentsResponse =
  reportsControllerGetSummaryTopContentsResponseSuccess

export const getReportsControllerGetSummaryTopContentsUrl = (
  params: ReportsControllerGetSummaryTopContentsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/top-contents?${stringifiedParams}`
    : `/api-arvore/reports/summary/top-contents`
}

export const reportsControllerGetSummaryTopContents = async (
  params: ReportsControllerGetSummaryTopContentsParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryTopContentsResponse> => {
  return customInstance<reportsControllerGetSummaryTopContentsResponse>(
    getReportsControllerGetSummaryTopContentsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns questions answered and correct answers grouped by month
 * @summary Get activities chart data by month
 */
export type reportsControllerGetSummaryActivitiesChartResponse200 = {
  data: SummaryActivitiesChartResponseDto
  status: 200
}

export type reportsControllerGetSummaryActivitiesChartResponseSuccess =
  reportsControllerGetSummaryActivitiesChartResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryActivitiesChartResponse =
  reportsControllerGetSummaryActivitiesChartResponseSuccess

export const getReportsControllerGetSummaryActivitiesChartUrl = (
  params: ReportsControllerGetSummaryActivitiesChartParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/activities-chart?${stringifiedParams}`
    : `/api-arvore/reports/summary/activities-chart`
}

export const reportsControllerGetSummaryActivitiesChart = async (
  params: ReportsControllerGetSummaryActivitiesChartParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryActivitiesChartResponse> => {
  return customInstance<reportsControllerGetSummaryActivitiesChartResponse>(
    getReportsControllerGetSummaryActivitiesChartUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Summary endpoint: Returns readings count grouped by format (books, audiobooks, articles) with percentages
 * @summary Get readings distribution by format
 */
export type reportsControllerGetSummaryReadingsByFormatResponse200 = {
  data: SummaryReadingsByFormatResponseDto
  status: 200
}

export type reportsControllerGetSummaryReadingsByFormatResponseSuccess =
  reportsControllerGetSummaryReadingsByFormatResponse200 & {
    headers: Headers
  }
export type reportsControllerGetSummaryReadingsByFormatResponse =
  reportsControllerGetSummaryReadingsByFormatResponseSuccess

export const getReportsControllerGetSummaryReadingsByFormatUrl = (
  params: ReportsControllerGetSummaryReadingsByFormatParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['classIds']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/summary/readings-by-format?${stringifiedParams}`
    : `/api-arvore/reports/summary/readings-by-format`
}

export const reportsControllerGetSummaryReadingsByFormat = async (
  params: ReportsControllerGetSummaryReadingsByFormatParams,
  options?: RequestInit
): Promise<reportsControllerGetSummaryReadingsByFormatResponse> => {
  return customInstance<reportsControllerGetSummaryReadingsByFormatResponse>(
    getReportsControllerGetSummaryReadingsByFormatUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns indications without due date, separated by books and articles, with hierarchy and date filters
 * @summary Get indications report
 */
export type reportsControllerGetIndicationsReportResponse200 = {
  data: IndicationsReportResponseDto
  status: 200
}

export type reportsControllerGetIndicationsReportResponseSuccess =
  reportsControllerGetIndicationsReportResponse200 & {
    headers: Headers
  }
export type reportsControllerGetIndicationsReportResponse =
  reportsControllerGetIndicationsReportResponseSuccess

export const getReportsControllerGetIndicationsReportUrl = (
  params: ReportsControllerGetIndicationsReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/indications?${stringifiedParams}`
    : `/api-arvore/reports/indications`
}

export const reportsControllerGetIndicationsReport = async (
  params: ReportsControllerGetIndicationsReportParams,
  options?: RequestInit
): Promise<reportsControllerGetIndicationsReportResponse> => {
  return customInstance<reportsControllerGetIndicationsReportResponse>(
    getReportsControllerGetIndicationsReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List users by class ancestry
 */
export type reportsControllerGetUsersByAncestryResponse200 = {
  data: UserByAncestryDto[]
  status: 200
}

export type reportsControllerGetUsersByAncestryResponseSuccess =
  reportsControllerGetUsersByAncestryResponse200 & {
    headers: Headers
  }
export type reportsControllerGetUsersByAncestryResponse =
  reportsControllerGetUsersByAncestryResponseSuccess

export const getReportsControllerGetUsersByAncestryUrl = (
  params: ReportsControllerGetUsersByAncestryParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reports/users-by-ancestry?${stringifiedParams}`
    : `/api-arvore/reports/users-by-ancestry`
}

export const reportsControllerGetUsersByAncestry = async (
  params: ReportsControllerGetUsersByAncestryParams,
  options?: RequestInit
): Promise<reportsControllerGetUsersByAncestryResponse> => {
  return customInstance<reportsControllerGetUsersByAncestryResponse>(
    getReportsControllerGetUsersByAncestryUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search books by name, ISBN or slug (for the Publish form)
 */
export type fluencyAuthoringControllerSearchBooksV1Response200 = {
  data: SearchBooksResponseDto
  status: 200
}

export type fluencyAuthoringControllerSearchBooksV1ResponseSuccess =
  fluencyAuthoringControllerSearchBooksV1Response200 & {
    headers: Headers
  }
export type fluencyAuthoringControllerSearchBooksV1Response =
  fluencyAuthoringControllerSearchBooksV1ResponseSuccess

export const getFluencyAuthoringControllerSearchBooksV1Url = (
  params: FluencyAuthoringControllerSearchBooksV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/fluency-authoring/books/search?${stringifiedParams}`
    : `/api-arvore/v1/fluency-authoring/books/search`
}

export const fluencyAuthoringControllerSearchBooksV1 = async (
  params: FluencyAuthoringControllerSearchBooksV1Params,
  options?: RequestInit
): Promise<fluencyAuthoringControllerSearchBooksV1Response> => {
  return customInstance<fluencyAuthoringControllerSearchBooksV1Response>(
    getFluencyAuthoringControllerSearchBooksV1Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List snippet lineages grouped by slug with their versions
 */
export type fluencyAuthoringControllerListLineagesV1Response200 = {
  data: ListSnippetLineagesResponseDto
  status: 200
}

export type fluencyAuthoringControllerListLineagesV1ResponseSuccess =
  fluencyAuthoringControllerListLineagesV1Response200 & {
    headers: Headers
  }
export type fluencyAuthoringControllerListLineagesV1Response =
  fluencyAuthoringControllerListLineagesV1ResponseSuccess

export const getFluencyAuthoringControllerListLineagesV1Url = () => {
  return `/api-arvore/v1/fluency-authoring/lineages`
}

export const fluencyAuthoringControllerListLineagesV1 = async (
  options?: RequestInit
): Promise<fluencyAuthoringControllerListLineagesV1Response> => {
  return customInstance<fluencyAuthoringControllerListLineagesV1Response>(
    getFluencyAuthoringControllerListLineagesV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get full content of a snippet version (text + quiz)
 */
export type fluencyAuthoringControllerGetVersionDetailV1Response200 = {
  data: SnippetVersionDetailResponseDto
  status: 200
}

export type fluencyAuthoringControllerGetVersionDetailV1ResponseSuccess =
  fluencyAuthoringControllerGetVersionDetailV1Response200 & {
    headers: Headers
  }
export type fluencyAuthoringControllerGetVersionDetailV1Response =
  fluencyAuthoringControllerGetVersionDetailV1ResponseSuccess

export const getFluencyAuthoringControllerGetVersionDetailV1Url = (
  id: number
) => {
  return `/api-arvore/v1/fluency-authoring/versions/${id}`
}

export const fluencyAuthoringControllerGetVersionDetailV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAuthoringControllerGetVersionDetailV1Response> => {
  return customInstance<fluencyAuthoringControllerGetVersionDetailV1Response>(
    getFluencyAuthoringControllerGetVersionDetailV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Publish a new snippet version (copy-on-write): inserts the whole aggregate atomically and disables the previous version
 */
export type fluencyAuthoringControllerPublishV1Response201 = {
  data: PublishSnippetVersionResponseDto
  status: 201
}

export type fluencyAuthoringControllerPublishV1ResponseSuccess =
  fluencyAuthoringControllerPublishV1Response201 & {
    headers: Headers
  }
export type fluencyAuthoringControllerPublishV1Response =
  fluencyAuthoringControllerPublishV1ResponseSuccess

export const getFluencyAuthoringControllerPublishV1Url = () => {
  return `/api-arvore/v1/fluency-authoring/publish`
}

export const fluencyAuthoringControllerPublishV1 = async (
  publishSnippetVersionDto: PublishSnippetVersionDto,
  options?: RequestInit
): Promise<fluencyAuthoringControllerPublishV1Response> => {
  return customInstance<fluencyAuthoringControllerPublishV1Response>(
    getFluencyAuthoringControllerPublishV1Url(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(publishSnippetVersionDto)
    }
  )
}

/**
 * @summary Deactivate a snippet version without publishing a replacement, retiring it from new Aplicações
 */
export type fluencyAuthoringControllerDeactivateV1Response200 = {
  data: DeactivateSnippetVersionResponseDto
  status: 200
}

export type fluencyAuthoringControllerDeactivateV1ResponseSuccess =
  fluencyAuthoringControllerDeactivateV1Response200 & {
    headers: Headers
  }
export type fluencyAuthoringControllerDeactivateV1Response =
  fluencyAuthoringControllerDeactivateV1ResponseSuccess

export const getFluencyAuthoringControllerDeactivateV1Url = (id: number) => {
  return `/api-arvore/v1/fluency-authoring/versions/${id}/deactivate`
}

export const fluencyAuthoringControllerDeactivateV1 = async (
  id: number,
  options?: RequestInit
): Promise<fluencyAuthoringControllerDeactivateV1Response> => {
  return customInstance<fluencyAuthoringControllerDeactivateV1Response>(
    getFluencyAuthoringControllerDeactivateV1Url(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List all teacher activities
 */
export type activitiesControllerFindAllResponse200 = {
  data: ActivitiesResponseDto
  status: 200
}

export type activitiesControllerFindAllResponseSuccess =
  activitiesControllerFindAllResponse200 & {
    headers: Headers
  }
export type activitiesControllerFindAllResponse =
  activitiesControllerFindAllResponseSuccess

export const getActivitiesControllerFindAllUrl = (
  params?: ActivitiesControllerFindAllParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/activities?${stringifiedParams}`
    : `/api-arvore/activities`
}

export const activitiesControllerFindAll = async (
  params?: ActivitiesControllerFindAllParams,
  options?: RequestInit
): Promise<activitiesControllerFindAllResponse> => {
  return customInstance<activitiesControllerFindAllResponse>(
    getActivitiesControllerFindAllUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create new activity
 */
export type activitiesControllerCreateResponse201 = {
  data: CreateActivityResponseDto
  status: 201
}

export type activitiesControllerCreateResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerCreateResponseSuccess =
  activitiesControllerCreateResponse201 & {
    headers: Headers
  }
export type activitiesControllerCreateResponseError =
  activitiesControllerCreateResponse400 & {
    headers: Headers
  }

export type activitiesControllerCreateResponse =
  | activitiesControllerCreateResponseSuccess
  | activitiesControllerCreateResponseError

export const getActivitiesControllerCreateUrl = () => {
  return `/api-arvore/activities`
}

export const activitiesControllerCreate = async (
  createActivityDto: CreateActivityDto,
  options?: RequestInit
): Promise<activitiesControllerCreateResponse> => {
  return customInstance<activitiesControllerCreateResponse>(
    getActivitiesControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createActivityDto)
    }
  )
}

/**
 * @summary Get available activity filters
 */
export type activitiesControllerGetFiltersResponse200 = {
  data: ActivityFiltersResponseDto
  status: 200
}

export type activitiesControllerGetFiltersResponseSuccess =
  activitiesControllerGetFiltersResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetFiltersResponse =
  activitiesControllerGetFiltersResponseSuccess

export const getActivitiesControllerGetFiltersUrl = () => {
  return `/api-arvore/activities/filters`
}

export const activitiesControllerGetFilters = async (
  options?: RequestInit
): Promise<activitiesControllerGetFiltersResponse> => {
  return customInstance<activitiesControllerGetFiltersResponse>(
    getActivitiesControllerGetFiltersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary [Admin] List all activities with filters and pagination
 */
export type activitiesControllerFindAllAdminResponse200 = {
  data: AdminActivitiesResponseDto
  status: 200
}

export type activitiesControllerFindAllAdminResponse403 = {
  data: void
  status: 403
}

export type activitiesControllerFindAllAdminResponseSuccess =
  activitiesControllerFindAllAdminResponse200 & {
    headers: Headers
  }
export type activitiesControllerFindAllAdminResponseError =
  activitiesControllerFindAllAdminResponse403 & {
    headers: Headers
  }

export type activitiesControllerFindAllAdminResponse =
  | activitiesControllerFindAllAdminResponseSuccess
  | activitiesControllerFindAllAdminResponseError

export const getActivitiesControllerFindAllAdminUrl = (
  params?: ActivitiesControllerFindAllAdminParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/activities/admin?${stringifiedParams}`
    : `/api-arvore/activities/admin`
}

export const activitiesControllerFindAllAdmin = async (
  params?: ActivitiesControllerFindAllAdminParams,
  options?: RequestInit
): Promise<activitiesControllerFindAllAdminResponse> => {
  return customInstance<activitiesControllerFindAllAdminResponse>(
    getActivitiesControllerFindAllAdminUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get student activities
 */
export type activitiesControllerGetStudentActivitiesResponse200 = {
  data: StudentActivitiesResponseDto
  status: 200
}

export type activitiesControllerGetStudentActivitiesResponseSuccess =
  activitiesControllerGetStudentActivitiesResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetStudentActivitiesResponse =
  activitiesControllerGetStudentActivitiesResponseSuccess

export const getActivitiesControllerGetStudentActivitiesUrl = () => {
  return `/api-arvore/activities/student-activities`
}

export const activitiesControllerGetStudentActivities = async (
  options?: RequestInit
): Promise<activitiesControllerGetStudentActivitiesResponse> => {
  return customInstance<activitiesControllerGetStudentActivitiesResponse>(
    getActivitiesControllerGetStudentActivitiesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get student activities v2 with fluency and indications
 */
export type activitiesControllerGetStudentActivitiesV2Response200 = {
  data: StudentActivitiesV2ResponseDto
  status: 200
}

export type activitiesControllerGetStudentActivitiesV2ResponseSuccess =
  activitiesControllerGetStudentActivitiesV2Response200 & {
    headers: Headers
  }
export type activitiesControllerGetStudentActivitiesV2Response =
  activitiesControllerGetStudentActivitiesV2ResponseSuccess

export const getActivitiesControllerGetStudentActivitiesV2Url = () => {
  return `/api-arvore/activities/student-activities-v2`
}

export const activitiesControllerGetStudentActivitiesV2 = async (
  options?: RequestInit
): Promise<activitiesControllerGetStudentActivitiesV2Response> => {
  return customInstance<activitiesControllerGetStudentActivitiesV2Response>(
    getActivitiesControllerGetStudentActivitiesV2Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get count of pending activities for student
 */
export type activitiesControllerGetPendingActivitiesCountResponse200 = {
  data: PendingActivitiesCountResponseDto
  status: 200
}

export type activitiesControllerGetPendingActivitiesCountResponseSuccess =
  activitiesControllerGetPendingActivitiesCountResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetPendingActivitiesCountResponse =
  activitiesControllerGetPendingActivitiesCountResponseSuccess

export const getActivitiesControllerGetPendingActivitiesCountUrl = () => {
  return `/api-arvore/activities/pending-activities-count`
}

export const activitiesControllerGetPendingActivitiesCount = async (
  options?: RequestInit
): Promise<activitiesControllerGetPendingActivitiesCountResponse> => {
  return customInstance<activitiesControllerGetPendingActivitiesCountResponse>(
    getActivitiesControllerGetPendingActivitiesCountUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get pending activities for student filtered by book slug
 */
export type activitiesControllerGetPendingActivitiesByBookSlugResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerGetPendingActivitiesByBookSlugResponseSuccess =
  activitiesControllerGetPendingActivitiesByBookSlugResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetPendingActivitiesByBookSlugResponse =
  activitiesControllerGetPendingActivitiesByBookSlugResponseSuccess

export const getActivitiesControllerGetPendingActivitiesByBookSlugUrl = (
  slug: string
) => {
  return `/api-arvore/activities/pending-by-book/${slug}`
}

export const activitiesControllerGetPendingActivitiesByBookSlug = async (
  slug: string,
  options?: RequestInit
): Promise<activitiesControllerGetPendingActivitiesByBookSlugResponse> => {
  return customInstance<activitiesControllerGetPendingActivitiesByBookSlugResponse>(
    getActivitiesControllerGetPendingActivitiesByBookSlugUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get activities grouped by language practices
 */
export type activitiesControllerGetActivitiesByLanguagePracticesResponse200 = {
  data: LanguagePracticeWithActivitiesDto[]
  status: 200
}

export type activitiesControllerGetActivitiesByLanguagePracticesResponseSuccess =
  activitiesControllerGetActivitiesByLanguagePracticesResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetActivitiesByLanguagePracticesResponse =
  activitiesControllerGetActivitiesByLanguagePracticesResponseSuccess

export const getActivitiesControllerGetActivitiesByLanguagePracticesUrl =
  () => {
    return `/api-arvore/activities/by-language-practices`
  }

export const activitiesControllerGetActivitiesByLanguagePractices = async (
  options?: RequestInit
): Promise<activitiesControllerGetActivitiesByLanguagePracticesResponse> => {
  return customInstance<activitiesControllerGetActivitiesByLanguagePracticesResponse>(
    getActivitiesControllerGetActivitiesByLanguagePracticesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete applied activities by application group
 */
export type activitiesControllerDeleteAppliedActivitiesResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerDeleteAppliedActivitiesResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerDeleteAppliedActivitiesResponseSuccess =
  activitiesControllerDeleteAppliedActivitiesResponse200 & {
    headers: Headers
  }
export type activitiesControllerDeleteAppliedActivitiesResponseError =
  activitiesControllerDeleteAppliedActivitiesResponse404 & {
    headers: Headers
  }

export type activitiesControllerDeleteAppliedActivitiesResponse =
  | activitiesControllerDeleteAppliedActivitiesResponseSuccess
  | activitiesControllerDeleteAppliedActivitiesResponseError

export const getActivitiesControllerDeleteAppliedActivitiesUrl = (
  id: string
) => {
  return `/api-arvore/activities/applied/${id}`
}

export const activitiesControllerDeleteAppliedActivities = async (
  id: string,
  options?: RequestInit
): Promise<activitiesControllerDeleteAppliedActivitiesResponse> => {
  return customInstance<activitiesControllerDeleteAppliedActivitiesResponse>(
    getActivitiesControllerDeleteAppliedActivitiesUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Delete content indication and all related user indications
 */
export type activitiesControllerDeleteContentIndicationResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerDeleteContentIndicationResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerDeleteContentIndicationResponseSuccess =
  activitiesControllerDeleteContentIndicationResponse200 & {
    headers: Headers
  }
export type activitiesControllerDeleteContentIndicationResponseError =
  activitiesControllerDeleteContentIndicationResponse404 & {
    headers: Headers
  }

export type activitiesControllerDeleteContentIndicationResponse =
  | activitiesControllerDeleteContentIndicationResponseSuccess
  | activitiesControllerDeleteContentIndicationResponseError

export const getActivitiesControllerDeleteContentIndicationUrl = (
  id: string
) => {
  return `/api-arvore/activities/content-indication/${id}`
}

export const activitiesControllerDeleteContentIndication = async (
  id: string,
  options?: RequestInit
): Promise<activitiesControllerDeleteContentIndicationResponse> => {
  return customInstance<activitiesControllerDeleteContentIndicationResponse>(
    getActivitiesControllerDeleteContentIndicationUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Delete activity
 */
export type activitiesControllerDeleteResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerDeleteResponse403 = {
  data: void
  status: 403
}

export type activitiesControllerDeleteResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerDeleteResponseSuccess =
  activitiesControllerDeleteResponse200 & {
    headers: Headers
  }
export type activitiesControllerDeleteResponseError = (
  | activitiesControllerDeleteResponse403
  | activitiesControllerDeleteResponse404
) & {
  headers: Headers
}

export type activitiesControllerDeleteResponse =
  | activitiesControllerDeleteResponseSuccess
  | activitiesControllerDeleteResponseError

export const getActivitiesControllerDeleteUrl = (id: string) => {
  return `/api-arvore/activities/${id}`
}

export const activitiesControllerDelete = async (
  id: string,
  options?: RequestInit
): Promise<activitiesControllerDeleteResponse> => {
  return customInstance<activitiesControllerDeleteResponse>(
    getActivitiesControllerDeleteUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Find activity by ID
 */
export type activitiesControllerFindOneResponse200 = {
  data: ActivityResponseDto
  status: 200
}

export type activitiesControllerFindOneResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerFindOneResponseSuccess =
  activitiesControllerFindOneResponse200 & {
    headers: Headers
  }
export type activitiesControllerFindOneResponseError =
  activitiesControllerFindOneResponse404 & {
    headers: Headers
  }

export type activitiesControllerFindOneResponse =
  | activitiesControllerFindOneResponseSuccess
  | activitiesControllerFindOneResponseError

export const getActivitiesControllerFindOneUrl = (id: string) => {
  return `/api-arvore/activities/${id}`
}

export const activitiesControllerFindOne = async (
  id: string,
  options?: RequestInit
): Promise<activitiesControllerFindOneResponse> => {
  return customInstance<activitiesControllerFindOneResponse>(
    getActivitiesControllerFindOneUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary [Admin] Update activity approvedForPublic
 */
export type activitiesControllerUpdateApprovedForPublicResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerUpdateApprovedForPublicResponse403 = {
  data: void
  status: 403
}

export type activitiesControllerUpdateApprovedForPublicResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerUpdateApprovedForPublicResponseSuccess =
  activitiesControllerUpdateApprovedForPublicResponse200 & {
    headers: Headers
  }
export type activitiesControllerUpdateApprovedForPublicResponseError = (
  | activitiesControllerUpdateApprovedForPublicResponse403
  | activitiesControllerUpdateApprovedForPublicResponse404
) & {
  headers: Headers
}

export type activitiesControllerUpdateApprovedForPublicResponse =
  | activitiesControllerUpdateApprovedForPublicResponseSuccess
  | activitiesControllerUpdateApprovedForPublicResponseError

export const getActivitiesControllerUpdateApprovedForPublicUrl = (
  id: string
) => {
  return `/api-arvore/activities/${id}/approved-for-public`
}

export const activitiesControllerUpdateApprovedForPublic = async (
  id: string,
  updateApprovedForPublicDto: UpdateApprovedForPublicDto,
  options?: RequestInit
): Promise<activitiesControllerUpdateApprovedForPublicResponse> => {
  return customInstance<activitiesControllerUpdateApprovedForPublicResponse>(
    getActivitiesControllerUpdateApprovedForPublicUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateApprovedForPublicDto)
    }
  )
}

/**
 * @summary Get reader IDs that have pending book creation activities
 */
export type activitiesControllerGetReadersWithPendingBookCreationResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerGetReadersWithPendingBookCreationResponseSuccess =
  activitiesControllerGetReadersWithPendingBookCreationResponse200 & {
    headers: Headers
  }
export type activitiesControllerGetReadersWithPendingBookCreationResponse =
  activitiesControllerGetReadersWithPendingBookCreationResponseSuccess

export const getActivitiesControllerGetReadersWithPendingBookCreationUrl = (
  params: ActivitiesControllerGetReadersWithPendingBookCreationParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/activities/readers-with-pending-book-creation?${stringifiedParams}`
    : `/api-arvore/activities/readers-with-pending-book-creation`
}

export const activitiesControllerGetReadersWithPendingBookCreation = async (
  params: ActivitiesControllerGetReadersWithPendingBookCreationParams,
  options?: RequestInit
): Promise<activitiesControllerGetReadersWithPendingBookCreationResponse> => {
  return customInstance<activitiesControllerGetReadersWithPendingBookCreationResponse>(
    getActivitiesControllerGetReadersWithPendingBookCreationUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check if activity has applied activities
 */
export type activitiesControllerHasAppliedActivityResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerHasAppliedActivityResponseSuccess =
  activitiesControllerHasAppliedActivityResponse200 & {
    headers: Headers
  }
export type activitiesControllerHasAppliedActivityResponse =
  activitiesControllerHasAppliedActivityResponseSuccess

export const getActivitiesControllerHasAppliedActivityUrl = (id: string) => {
  return `/api-arvore/activities/${id}/has-applied`
}

export const activitiesControllerHasAppliedActivity = async (
  id: string,
  options?: RequestInit
): Promise<activitiesControllerHasAppliedActivityResponse> => {
  return customInstance<activitiesControllerHasAppliedActivityResponse>(
    getActivitiesControllerHasAppliedActivityUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary [Admin] Create public activity (no teacher)
 */
export type activitiesControllerCreatePublicResponse201 = {
  data: CreateActivityResponseDto
  status: 201
}

export type activitiesControllerCreatePublicResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerCreatePublicResponseSuccess =
  activitiesControllerCreatePublicResponse201 & {
    headers: Headers
  }
export type activitiesControllerCreatePublicResponseError =
  activitiesControllerCreatePublicResponse400 & {
    headers: Headers
  }

export type activitiesControllerCreatePublicResponse =
  | activitiesControllerCreatePublicResponseSuccess
  | activitiesControllerCreatePublicResponseError

export const getActivitiesControllerCreatePublicUrl = () => {
  return `/api-arvore/activities/public`
}

export const activitiesControllerCreatePublic = async (
  createActivityDto: CreateActivityDto,
  options?: RequestInit
): Promise<activitiesControllerCreatePublicResponse> => {
  return customInstance<activitiesControllerCreatePublicResponse>(
    getActivitiesControllerCreatePublicUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createActivityDto)
    }
  )
}

/**
 * @summary Update activity questions
 */
export type activitiesControllerUpdateQuestionsResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerUpdateQuestionsResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerUpdateQuestionsResponseSuccess =
  activitiesControllerUpdateQuestionsResponse200 & {
    headers: Headers
  }
export type activitiesControllerUpdateQuestionsResponseError =
  activitiesControllerUpdateQuestionsResponse404 & {
    headers: Headers
  }

export type activitiesControllerUpdateQuestionsResponse =
  | activitiesControllerUpdateQuestionsResponseSuccess
  | activitiesControllerUpdateQuestionsResponseError

export const getActivitiesControllerUpdateQuestionsUrl = (id: string) => {
  return `/api-arvore/activities/${id}/questions`
}

export const activitiesControllerUpdateQuestions = async (
  id: string,
  updateActivityQuestionsDto: UpdateActivityQuestionsDto,
  options?: RequestInit
): Promise<activitiesControllerUpdateQuestionsResponse> => {
  return customInstance<activitiesControllerUpdateQuestionsResponse>(
    getActivitiesControllerUpdateQuestionsUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateActivityQuestionsDto)
    }
  )
}

/**
 * @summary Update activity title
 */
export type activitiesControllerUpdateTitleResponse200 = {
  data: void
  status: 200
}

export type activitiesControllerUpdateTitleResponse403 = {
  data: void
  status: 403
}

export type activitiesControllerUpdateTitleResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerUpdateTitleResponseSuccess =
  activitiesControllerUpdateTitleResponse200 & {
    headers: Headers
  }
export type activitiesControllerUpdateTitleResponseError = (
  | activitiesControllerUpdateTitleResponse403
  | activitiesControllerUpdateTitleResponse404
) & {
  headers: Headers
}

export type activitiesControllerUpdateTitleResponse =
  | activitiesControllerUpdateTitleResponseSuccess
  | activitiesControllerUpdateTitleResponseError

export const getActivitiesControllerUpdateTitleUrl = (id: string) => {
  return `/api-arvore/activities/${id}/title`
}

export const activitiesControllerUpdateTitle = async (
  id: string,
  updateActivityTitleDto: UpdateActivityTitleDto,
  options?: RequestInit
): Promise<activitiesControllerUpdateTitleResponse> => {
  return customInstance<activitiesControllerUpdateTitleResponse>(
    getActivitiesControllerUpdateTitleUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateActivityTitleDto)
    }
  )
}

/**
 * @summary Generate questions using AI
 */
export type activitiesControllerGenerateAiQuestionsResponse201 = {
  data: ActivityQuestionResponseDto[]
  status: 201
}

export type activitiesControllerGenerateAiQuestionsResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerGenerateAiQuestionsResponseSuccess =
  activitiesControllerGenerateAiQuestionsResponse201 & {
    headers: Headers
  }
export type activitiesControllerGenerateAiQuestionsResponseError =
  activitiesControllerGenerateAiQuestionsResponse400 & {
    headers: Headers
  }

export type activitiesControllerGenerateAiQuestionsResponse =
  | activitiesControllerGenerateAiQuestionsResponseSuccess
  | activitiesControllerGenerateAiQuestionsResponseError

export const getActivitiesControllerGenerateAiQuestionsUrl = () => {
  return `/api-arvore/activities/ai/generate-questions`
}

export const activitiesControllerGenerateAiQuestions = async (
  generateAiQuestionsDto: GenerateAiQuestionsDto,
  options?: RequestInit
): Promise<activitiesControllerGenerateAiQuestionsResponse> => {
  return customInstance<activitiesControllerGenerateAiQuestionsResponse>(
    getActivitiesControllerGenerateAiQuestionsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateAiQuestionsDto)
    }
  )
}

/**
 * @summary Upload images for activities
 */
export type activitiesControllerUploadImageResponse201 = {
  data: UploadImageResponseDto[]
  status: 201
}

export type activitiesControllerUploadImageResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerUploadImageResponseSuccess =
  activitiesControllerUploadImageResponse201 & {
    headers: Headers
  }
export type activitiesControllerUploadImageResponseError =
  activitiesControllerUploadImageResponse400 & {
    headers: Headers
  }

export type activitiesControllerUploadImageResponse =
  | activitiesControllerUploadImageResponseSuccess
  | activitiesControllerUploadImageResponseError

export const getActivitiesControllerUploadImageUrl = () => {
  return `/api-arvore/activities/upload-image`
}

export const activitiesControllerUploadImage = async (
  activitiesControllerUploadImageBody: ActivitiesControllerUploadImageBody,
  options?: RequestInit
): Promise<activitiesControllerUploadImageResponse> => {
  const formData = new FormData()
  if (activitiesControllerUploadImageBody.images !== undefined) {
    activitiesControllerUploadImageBody.images.forEach(value =>
      formData.append(`images`, value)
    )
  }

  return customInstance<activitiesControllerUploadImageResponse>(
    getActivitiesControllerUploadImageUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Upload activity image
 */
export type activitiesControllerUploadActivityImageResponse201 = {
  data: UploadImageResponseDto
  status: 201
}

export type activitiesControllerUploadActivityImageResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerUploadActivityImageResponseSuccess =
  activitiesControllerUploadActivityImageResponse201 & {
    headers: Headers
  }
export type activitiesControllerUploadActivityImageResponseError =
  activitiesControllerUploadActivityImageResponse400 & {
    headers: Headers
  }

export type activitiesControllerUploadActivityImageResponse =
  | activitiesControllerUploadActivityImageResponseSuccess
  | activitiesControllerUploadActivityImageResponseError

export const getActivitiesControllerUploadActivityImageUrl = (id: string) => {
  return `/api-arvore/activities/${id}/upload-image`
}

export const activitiesControllerUploadActivityImage = async (
  id: string,
  activitiesControllerUploadActivityImageBody: ActivitiesControllerUploadActivityImageBody,
  options?: RequestInit
): Promise<activitiesControllerUploadActivityImageResponse> => {
  const formData = new FormData()
  if (activitiesControllerUploadActivityImageBody.image !== undefined) {
    formData.append(`image`, activitiesControllerUploadActivityImageBody.image)
  }

  return customInstance<activitiesControllerUploadActivityImageResponse>(
    getActivitiesControllerUploadActivityImageUrl(id),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Apply activities to students
 */
export type activitiesControllerApplyResponse201 = {
  data: ApplyActivityResponseDto
  status: 201
}

export type activitiesControllerApplyResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerApplyResponseSuccess =
  activitiesControllerApplyResponse201 & {
    headers: Headers
  }
export type activitiesControllerApplyResponseError =
  activitiesControllerApplyResponse400 & {
    headers: Headers
  }

export type activitiesControllerApplyResponse =
  | activitiesControllerApplyResponseSuccess
  | activitiesControllerApplyResponseError

export const getActivitiesControllerApplyUrl = () => {
  return `/api-arvore/activities/apply`
}

export const activitiesControllerApply = async (
  applyActivityDto: ApplyActivityDto,
  options?: RequestInit
): Promise<activitiesControllerApplyResponse> => {
  return customInstance<activitiesControllerApplyResponse>(
    getActivitiesControllerApplyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(applyActivityDto)
    }
  )
}

/**
 * @summary Submit answer for objective question
 */
export type activitiesControllerSetChoiceAnswerResponse200 = {
  data: SetChoiceAnswerResponseDto
  status: 200
}

export type activitiesControllerSetChoiceAnswerResponse400 = {
  data: void
  status: 400
}

export type activitiesControllerSetChoiceAnswerResponse403 = {
  data: void
  status: 403
}

export type activitiesControllerSetChoiceAnswerResponse404 = {
  data: void
  status: 404
}

export type activitiesControllerSetChoiceAnswerResponseSuccess =
  activitiesControllerSetChoiceAnswerResponse200 & {
    headers: Headers
  }
export type activitiesControllerSetChoiceAnswerResponseError = (
  | activitiesControllerSetChoiceAnswerResponse400
  | activitiesControllerSetChoiceAnswerResponse403
  | activitiesControllerSetChoiceAnswerResponse404
) & {
  headers: Headers
}

export type activitiesControllerSetChoiceAnswerResponse =
  | activitiesControllerSetChoiceAnswerResponseSuccess
  | activitiesControllerSetChoiceAnswerResponseError

export const getActivitiesControllerSetChoiceAnswerUrl = () => {
  return `/api-arvore/activities/answers/choice`
}

export const activitiesControllerSetChoiceAnswer = async (
  setChoiceAnswerDto: SetChoiceAnswerDto,
  options?: RequestInit
): Promise<activitiesControllerSetChoiceAnswerResponse> => {
  return customInstance<activitiesControllerSetChoiceAnswerResponse>(
    getActivitiesControllerSetChoiceAnswerUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setChoiceAnswerDto)
    }
  )
}

/**
 * @summary List BibliON libraries (schools) available for registration
 */
export type biblionRegistrationControllerListLibrariesResponse200 = {
  data: ListLibrariesResponseDto
  status: 200
}

export type biblionRegistrationControllerListLibrariesResponseSuccess =
  biblionRegistrationControllerListLibrariesResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerListLibrariesResponse =
  biblionRegistrationControllerListLibrariesResponseSuccess

export const getBiblionRegistrationControllerListLibrariesUrl = () => {
  return `/api-arvore/biblion/registration/libraries`
}

export const biblionRegistrationControllerListLibraries = async (
  options?: RequestInit
): Promise<biblionRegistrationControllerListLibrariesResponse> => {
  return customInstance<biblionRegistrationControllerListLibrariesResponse>(
    getBiblionRegistrationControllerListLibrariesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check whether an email is available for BibliON registration
 */
export type biblionRegistrationControllerCheckEmailResponse200 = {
  data: EmailAvailabilityResponseDto
  status: 200
}

export type biblionRegistrationControllerCheckEmailResponseSuccess =
  biblionRegistrationControllerCheckEmailResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerCheckEmailResponse =
  biblionRegistrationControllerCheckEmailResponseSuccess

export const getBiblionRegistrationControllerCheckEmailUrl = (
  params: BiblionRegistrationControllerCheckEmailParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/biblion/registration/email-availability?${stringifiedParams}`
    : `/api-arvore/biblion/registration/email-availability`
}

export const biblionRegistrationControllerCheckEmail = async (
  params: BiblionRegistrationControllerCheckEmailParams,
  options?: RequestInit
): Promise<biblionRegistrationControllerCheckEmailResponse> => {
  return customInstance<biblionRegistrationControllerCheckEmailResponse>(
    getBiblionRegistrationControllerCheckEmailUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Register a new BibliON user (email + password, pending confirmation)
 */
export type biblionRegistrationControllerRegisterResponse201 = {
  data: RegisterBiblionResponseDto
  status: 201
}

export type biblionRegistrationControllerRegisterResponseSuccess =
  biblionRegistrationControllerRegisterResponse201 & {
    headers: Headers
  }
export type biblionRegistrationControllerRegisterResponse =
  biblionRegistrationControllerRegisterResponseSuccess

export const getBiblionRegistrationControllerRegisterUrl = () => {
  return `/api-arvore/biblion/registration`
}

export const biblionRegistrationControllerRegister = async (
  registerBiblionBodyDto: RegisterBiblionBodyDto,
  options?: RequestInit
): Promise<biblionRegistrationControllerRegisterResponse> => {
  return customInstance<biblionRegistrationControllerRegisterResponse>(
    getBiblionRegistrationControllerRegisterUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerBiblionBodyDto)
    }
  )
}

/**
 * @summary Confirm a BibliON registration via email token
 */
export type biblionRegistrationControllerConfirmResponse200 = {
  data: ConfirmBiblionResponseDto
  status: 200
}

export type biblionRegistrationControllerConfirmResponse400 = {
  data: void
  status: 400
}

export type biblionRegistrationControllerConfirmResponseSuccess =
  biblionRegistrationControllerConfirmResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerConfirmResponseError =
  biblionRegistrationControllerConfirmResponse400 & {
    headers: Headers
  }

export type biblionRegistrationControllerConfirmResponse =
  | biblionRegistrationControllerConfirmResponseSuccess
  | biblionRegistrationControllerConfirmResponseError

export const getBiblionRegistrationControllerConfirmUrl = () => {
  return `/api-arvore/biblion/registration/confirm`
}

export const biblionRegistrationControllerConfirm = async (
  confirmBiblionBodyDto: ConfirmBiblionBodyDto,
  options?: RequestInit
): Promise<biblionRegistrationControllerConfirmResponse> => {
  return customInstance<biblionRegistrationControllerConfirmResponse>(
    getBiblionRegistrationControllerConfirmUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmBiblionBodyDto)
    }
  )
}

/**
 * @summary Resend the BibliON confirmation email
 */
export type biblionRegistrationControllerResendResponse200 = {
  data: ResendConfirmationResponseDto
  status: 200
}

export type biblionRegistrationControllerResendResponseSuccess =
  biblionRegistrationControllerResendResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerResendResponse =
  biblionRegistrationControllerResendResponseSuccess

export const getBiblionRegistrationControllerResendUrl = () => {
  return `/api-arvore/biblion/registration/resend`
}

export const biblionRegistrationControllerResend = async (
  resendConfirmationBodyDto: ResendConfirmationBodyDto,
  options?: RequestInit
): Promise<biblionRegistrationControllerResendResponse> => {
  return customInstance<biblionRegistrationControllerResendResponse>(
    getBiblionRegistrationControllerResendUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resendConfirmationBodyDto)
    }
  )
}

/**
 * @summary Send a password-setup email to a migrated BibliON account that has no password yet
 */
export type biblionRegistrationControllerRequestPasswordSetupResponse200 = {
  data: RequestPasswordSetupResponseDto
  status: 200
}

export type biblionRegistrationControllerRequestPasswordSetupResponseSuccess =
  biblionRegistrationControllerRequestPasswordSetupResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerRequestPasswordSetupResponse =
  biblionRegistrationControllerRequestPasswordSetupResponseSuccess

export const getBiblionRegistrationControllerRequestPasswordSetupUrl = () => {
  return `/api-arvore/biblion/registration/request-password-setup`
}

export const biblionRegistrationControllerRequestPasswordSetup = async (
  requestPasswordSetupBodyDto: RequestPasswordSetupBodyDto,
  options?: RequestInit
): Promise<biblionRegistrationControllerRequestPasswordSetupResponse> => {
  return customInstance<biblionRegistrationControllerRequestPasswordSetupResponse>(
    getBiblionRegistrationControllerRequestPasswordSetupUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(requestPasswordSetupBodyDto)
    }
  )
}

/**
 * @summary List profile fields the authenticated user still needs to complete
 */
export type biblionRegistrationControllerGetMissingFieldsResponse200 = {
  data: BiblionProfileStatusResponseDto
  status: 200
}

export type biblionRegistrationControllerGetMissingFieldsResponseSuccess =
  biblionRegistrationControllerGetMissingFieldsResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerGetMissingFieldsResponse =
  biblionRegistrationControllerGetMissingFieldsResponseSuccess

export const getBiblionRegistrationControllerGetMissingFieldsUrl = () => {
  return `/api-arvore/biblion/registration/profile/missing-fields`
}

export const biblionRegistrationControllerGetMissingFields = async (
  options?: RequestInit
): Promise<biblionRegistrationControllerGetMissingFieldsResponse> => {
  return customInstance<biblionRegistrationControllerGetMissingFieldsResponse>(
    getBiblionRegistrationControllerGetMissingFieldsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Complete the authenticated user profile with the missing fields
 */
export type biblionRegistrationControllerCompleteProfileResponse200 = {
  data: BiblionProfileStatusResponseDto
  status: 200
}

export type biblionRegistrationControllerCompleteProfileResponseSuccess =
  biblionRegistrationControllerCompleteProfileResponse200 & {
    headers: Headers
  }
export type biblionRegistrationControllerCompleteProfileResponse =
  biblionRegistrationControllerCompleteProfileResponseSuccess

export const getBiblionRegistrationControllerCompleteProfileUrl = () => {
  return `/api-arvore/biblion/registration/profile/complete`
}

export const biblionRegistrationControllerCompleteProfile = async (
  completeBiblionProfileBodyDto: CompleteBiblionProfileBodyDto,
  options?: RequestInit
): Promise<biblionRegistrationControllerCompleteProfileResponse> => {
  return customInstance<biblionRegistrationControllerCompleteProfileResponse>(
    getBiblionRegistrationControllerCompleteProfileUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(completeBiblionProfileBodyDto)
    }
  )
}

/**
 * @summary List SESC RS networks (units) available for registration
 */
export type sescRegistrationControllerListNetworksResponse200 = {
  data: ListSescNetworksResponseDto
  status: 200
}

export type sescRegistrationControllerListNetworksResponseSuccess =
  sescRegistrationControllerListNetworksResponse200 & {
    headers: Headers
  }
export type sescRegistrationControllerListNetworksResponse =
  sescRegistrationControllerListNetworksResponseSuccess

export const getSescRegistrationControllerListNetworksUrl = () => {
  return `/api-arvore/sesc-rs/registration/networks`
}

export const sescRegistrationControllerListNetworks = async (
  options?: RequestInit
): Promise<sescRegistrationControllerListNetworksResponse> => {
  return customInstance<sescRegistrationControllerListNetworksResponse>(
    getSescRegistrationControllerListNetworksUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List user types (schools) under the selected SESC RS network
 */
export type sescRegistrationControllerListUserTypesResponse200 = {
  data: ListSescUserTypesResponseDto
  status: 200
}

export type sescRegistrationControllerListUserTypesResponseSuccess =
  sescRegistrationControllerListUserTypesResponse200 & {
    headers: Headers
  }
export type sescRegistrationControllerListUserTypesResponse =
  sescRegistrationControllerListUserTypesResponseSuccess

export const getSescRegistrationControllerListUserTypesUrl = (
  networkId: number
) => {
  return `/api-arvore/sesc-rs/registration/networks/${networkId}/user-types`
}

export const sescRegistrationControllerListUserTypes = async (
  networkId: number,
  options?: RequestInit
): Promise<sescRegistrationControllerListUserTypesResponse> => {
  return customInstance<sescRegistrationControllerListUserTypesResponse>(
    getSescRegistrationControllerListUserTypesUrl(networkId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check whether an email is available for SESC RS registration
 */
export type sescRegistrationControllerCheckEmailResponse200 = {
  data: SescEmailAvailabilityResponseDto
  status: 200
}

export type sescRegistrationControllerCheckEmailResponseSuccess =
  sescRegistrationControllerCheckEmailResponse200 & {
    headers: Headers
  }
export type sescRegistrationControllerCheckEmailResponse =
  sescRegistrationControllerCheckEmailResponseSuccess

export const getSescRegistrationControllerCheckEmailUrl = (
  params: SescRegistrationControllerCheckEmailParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/sesc-rs/registration/email-availability?${stringifiedParams}`
    : `/api-arvore/sesc-rs/registration/email-availability`
}

export const sescRegistrationControllerCheckEmail = async (
  params: SescRegistrationControllerCheckEmailParams,
  options?: RequestInit
): Promise<sescRegistrationControllerCheckEmailResponse> => {
  return customInstance<sescRegistrationControllerCheckEmailResponse>(
    getSescRegistrationControllerCheckEmailUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Register a new SESC RS reader (active immediately with a 20-day loan)
 */
export type sescRegistrationControllerRegisterResponse201 = {
  data: RegisterSescResponseDto
  status: 201
}

export type sescRegistrationControllerRegisterResponseSuccess =
  sescRegistrationControllerRegisterResponse201 & {
    headers: Headers
  }
export type sescRegistrationControllerRegisterResponse =
  sescRegistrationControllerRegisterResponseSuccess

export const getSescRegistrationControllerRegisterUrl = () => {
  return `/api-arvore/sesc-rs/registration`
}

export const sescRegistrationControllerRegister = async (
  registerSescBodyDto: RegisterSescBodyDto,
  options?: RequestInit
): Promise<sescRegistrationControllerRegisterResponse> => {
  return customInstance<sescRegistrationControllerRegisterResponse>(
    getSescRegistrationControllerRegisterUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerSescBodyDto)
    }
  )
}

/**
 * @summary List all article shelves
 */
export type articleShelvesControllerListResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerListResponseSuccess =
  articleShelvesControllerListResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerListResponse =
  articleShelvesControllerListResponseSuccess

export const getArticleShelvesControllerListUrl = () => {
  return `/api-arvore/article-shelves`
}

export const articleShelvesControllerList = async (
  options?: RequestInit
): Promise<articleShelvesControllerListResponse> => {
  return customInstance<articleShelvesControllerListResponse>(
    getArticleShelvesControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new article shelf
 */
export type articleShelvesControllerCreateResponse201 = {
  data: void
  status: 201
}

export type articleShelvesControllerCreateResponseSuccess =
  articleShelvesControllerCreateResponse201 & {
    headers: Headers
  }
export type articleShelvesControllerCreateResponse =
  articleShelvesControllerCreateResponseSuccess

export const getArticleShelvesControllerCreateUrl = () => {
  return `/api-arvore/article-shelves`
}

export const articleShelvesControllerCreate = async (
  createShelfBodyDto: CreateShelfBodyDto,
  options?: RequestInit
): Promise<articleShelvesControllerCreateResponse> => {
  return customInstance<articleShelvesControllerCreateResponse>(
    getArticleShelvesControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createShelfBodyDto)
    }
  )
}

/**
 * @summary Reorder article shelves
 */
export type articleShelvesControllerReorderResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerReorderResponseSuccess =
  articleShelvesControllerReorderResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerReorderResponse =
  articleShelvesControllerReorderResponseSuccess

export const getArticleShelvesControllerReorderUrl = () => {
  return `/api-arvore/article-shelves/reorder`
}

export const articleShelvesControllerReorder = async (
  reorderShelvesBodyDto: ReorderShelvesBodyDto,
  options?: RequestInit
): Promise<articleShelvesControllerReorderResponse> => {
  return customInstance<articleShelvesControllerReorderResponse>(
    getArticleShelvesControllerReorderUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reorderShelvesBodyDto)
    }
  )
}

/**
 * @summary Update article shelf details
 */
export type articleShelvesControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerUpdateResponseSuccess =
  articleShelvesControllerUpdateResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerUpdateResponse =
  articleShelvesControllerUpdateResponseSuccess

export const getArticleShelvesControllerUpdateUrl = (id: number) => {
  return `/api-arvore/article-shelves/${id}`
}

export const articleShelvesControllerUpdate = async (
  id: number,
  updateShelfBodyDto: UpdateShelfBodyDto,
  options?: RequestInit
): Promise<articleShelvesControllerUpdateResponse> => {
  return customInstance<articleShelvesControllerUpdateResponse>(
    getArticleShelvesControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateShelfBodyDto)
    }
  )
}

/**
 * @summary Delete an article shelf
 */
export type articleShelvesControllerDeleteResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerDeleteResponseSuccess =
  articleShelvesControllerDeleteResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerDeleteResponse =
  articleShelvesControllerDeleteResponseSuccess

export const getArticleShelvesControllerDeleteUrl = (id: number) => {
  return `/api-arvore/article-shelves/${id}`
}

export const articleShelvesControllerDelete = async (
  id: number,
  options?: RequestInit
): Promise<articleShelvesControllerDeleteResponse> => {
  return customInstance<articleShelvesControllerDeleteResponse>(
    getArticleShelvesControllerDeleteUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Toggle article shelf enabled status
 */
export type articleShelvesControllerToggleResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerToggleResponseSuccess =
  articleShelvesControllerToggleResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerToggleResponse =
  articleShelvesControllerToggleResponseSuccess

export const getArticleShelvesControllerToggleUrl = (id: number) => {
  return `/api-arvore/article-shelves/${id}/toggle`
}

export const articleShelvesControllerToggle = async (
  id: number,
  toggleShelfBodyDto: ToggleShelfBodyDto,
  options?: RequestInit
): Promise<articleShelvesControllerToggleResponse> => {
  return customInstance<articleShelvesControllerToggleResponse>(
    getArticleShelvesControllerToggleUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleShelfBodyDto)
    }
  )
}

/**
 * @summary Get article shelf items with order
 */
export type articleShelvesControllerGetItemsResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerGetItemsResponseSuccess =
  articleShelvesControllerGetItemsResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerGetItemsResponse =
  articleShelvesControllerGetItemsResponseSuccess

export const getArticleShelvesControllerGetItemsUrl = (id: number) => {
  return `/api-arvore/article-shelves/${id}/items`
}

export const articleShelvesControllerGetItems = async (
  id: number,
  options?: RequestInit
): Promise<articleShelvesControllerGetItemsResponse> => {
  return customInstance<articleShelvesControllerGetItemsResponse>(
    getArticleShelvesControllerGetItemsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update article shelf items order
 */
export type articleShelvesControllerUpdateItemsResponse200 = {
  data: void
  status: 200
}

export type articleShelvesControllerUpdateItemsResponseSuccess =
  articleShelvesControllerUpdateItemsResponse200 & {
    headers: Headers
  }
export type articleShelvesControllerUpdateItemsResponse =
  articleShelvesControllerUpdateItemsResponseSuccess

export const getArticleShelvesControllerUpdateItemsUrl = (id: number) => {
  return `/api-arvore/article-shelves/${id}/items`
}

export const articleShelvesControllerUpdateItems = async (
  id: number,
  updateShelfItemsBodyDto: UpdateShelfItemsBodyDto,
  options?: RequestInit
): Promise<articleShelvesControllerUpdateItemsResponse> => {
  return customInstance<articleShelvesControllerUpdateItemsResponse>(
    getArticleShelvesControllerUpdateItemsUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateShelfItemsBodyDto)
    }
  )
}

/**
 * @summary List enabled article shelves with articles for reader
 */
export type readerArticleShelvesControllerListResponse200 = {
  data: void
  status: 200
}

export type readerArticleShelvesControllerListResponseSuccess =
  readerArticleShelvesControllerListResponse200 & {
    headers: Headers
  }
export type readerArticleShelvesControllerListResponse =
  readerArticleShelvesControllerListResponseSuccess

export const getReaderArticleShelvesControllerListUrl = (
  params?: ReaderArticleShelvesControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reader/article-shelves?${stringifiedParams}`
    : `/api-arvore/reader/article-shelves`
}

export const readerArticleShelvesControllerList = async (
  params?: ReaderArticleShelvesControllerListParams,
  options?: RequestInit
): Promise<readerArticleShelvesControllerListResponse> => {
  return customInstance<readerArticleShelvesControllerListResponse>(
    getReaderArticleShelvesControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all articles from a shelf with pagination
 */
export type readerArticleShelvesControllerListArticlesResponse200 = {
  data: void
  status: 200
}

export type readerArticleShelvesControllerListArticlesResponseSuccess =
  readerArticleShelvesControllerListArticlesResponse200 & {
    headers: Headers
  }
export type readerArticleShelvesControllerListArticlesResponse =
  readerArticleShelvesControllerListArticlesResponseSuccess

export const getReaderArticleShelvesControllerListArticlesUrl = (
  id: number,
  params?: ReaderArticleShelvesControllerListArticlesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reader/article-shelves/${id}/articles?${stringifiedParams}`
    : `/api-arvore/reader/article-shelves/${id}/articles`
}

export const readerArticleShelvesControllerListArticles = async (
  id: number,
  params?: ReaderArticleShelvesControllerListArticlesParams,
  options?: RequestInit
): Promise<readerArticleShelvesControllerListArticlesResponse> => {
  return customInstance<readerArticleShelvesControllerListArticlesResponse>(
    getReaderArticleShelvesControllerListArticlesUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List articles with pagination and filters
 */
export type articlesControllerListResponse200 = {
  data: ListArticlesResponseDto
  status: 200
}

export type articlesControllerListResponseSuccess =
  articlesControllerListResponse200 & {
    headers: Headers
  }
export type articlesControllerListResponse =
  articlesControllerListResponseSuccess

export const getArticlesControllerListUrl = (
  params?: ArticlesControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/articles?${stringifiedParams}`
    : `/api-arvore/articles`
}

export const articlesControllerList = async (
  params?: ArticlesControllerListParams,
  options?: RequestInit
): Promise<articlesControllerListResponse> => {
  return customInstance<articlesControllerListResponse>(
    getArticlesControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new article
 */
export type articlesControllerCreateResponse201 = {
  data: void
  status: 201
}

export type articlesControllerCreateResponseSuccess =
  articlesControllerCreateResponse201 & {
    headers: Headers
  }
export type articlesControllerCreateResponse =
  articlesControllerCreateResponseSuccess

export const getArticlesControllerCreateUrl = () => {
  return `/api-arvore/articles`
}

export const articlesControllerCreate = async (
  createArticleDto: CreateArticleDto,
  options?: RequestInit
): Promise<articlesControllerCreateResponse> => {
  return customInstance<articlesControllerCreateResponse>(
    getArticlesControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createArticleDto)
    }
  )
}

/**
 * @summary List school segments
 */
export type articlesControllerGetSchoolSegmentsResponse200 = {
  data: SchoolSegmentResponseDto[]
  status: 200
}

export type articlesControllerGetSchoolSegmentsResponseSuccess =
  articlesControllerGetSchoolSegmentsResponse200 & {
    headers: Headers
  }
export type articlesControllerGetSchoolSegmentsResponse =
  articlesControllerGetSchoolSegmentsResponseSuccess

export const getArticlesControllerGetSchoolSegmentsUrl = () => {
  return `/api-arvore/articles/school-segments`
}

export const articlesControllerGetSchoolSegments = async (
  options?: RequestInit
): Promise<articlesControllerGetSchoolSegmentsResponse> => {
  return customInstance<articlesControllerGetSchoolSegmentsResponse>(
    getArticlesControllerGetSchoolSegmentsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get article by ID
 */
export type articlesControllerGetByIdResponse200 = {
  data: ArticleResponseDto
  status: 200
}

export type articlesControllerGetByIdResponse404 = {
  data: void
  status: 404
}

export type articlesControllerGetByIdResponseSuccess =
  articlesControllerGetByIdResponse200 & {
    headers: Headers
  }
export type articlesControllerGetByIdResponseError =
  articlesControllerGetByIdResponse404 & {
    headers: Headers
  }

export type articlesControllerGetByIdResponse =
  | articlesControllerGetByIdResponseSuccess
  | articlesControllerGetByIdResponseError

export const getArticlesControllerGetByIdUrl = (id: number) => {
  return `/api-arvore/articles/${id}`
}

export const articlesControllerGetById = async (
  id: number,
  options?: RequestInit
): Promise<articlesControllerGetByIdResponse> => {
  return customInstance<articlesControllerGetByIdResponse>(
    getArticlesControllerGetByIdUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update an article
 */
export type articlesControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type articlesControllerUpdateResponse404 = {
  data: void
  status: 404
}

export type articlesControllerUpdateResponseSuccess =
  articlesControllerUpdateResponse200 & {
    headers: Headers
  }
export type articlesControllerUpdateResponseError =
  articlesControllerUpdateResponse404 & {
    headers: Headers
  }

export type articlesControllerUpdateResponse =
  | articlesControllerUpdateResponseSuccess
  | articlesControllerUpdateResponseError

export const getArticlesControllerUpdateUrl = (id: number) => {
  return `/api-arvore/articles/${id}`
}

export const articlesControllerUpdate = async (
  id: number,
  updateArticleDto: UpdateArticleDto,
  options?: RequestInit
): Promise<articlesControllerUpdateResponse> => {
  return customInstance<articlesControllerUpdateResponse>(
    getArticlesControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateArticleDto)
    }
  )
}

/**
 * @summary Upload article cover image
 */
export type articlesControllerUploadImageResponse201 = {
  data: void
  status: 201
}

export type articlesControllerUploadImageResponseSuccess =
  articlesControllerUploadImageResponse201 & {
    headers: Headers
  }
export type articlesControllerUploadImageResponse =
  articlesControllerUploadImageResponseSuccess

export const getArticlesControllerUploadImageUrl = (id: number) => {
  return `/api-arvore/articles/${id}/image`
}

export const articlesControllerUploadImage = async (
  id: number,
  articlesControllerUploadImageBody: ArticlesControllerUploadImageBody,
  options?: RequestInit
): Promise<articlesControllerUploadImageResponse> => {
  const formData = new FormData()
  if (articlesControllerUploadImageBody.image !== undefined) {
    formData.append(`image`, articlesControllerUploadImageBody.image)
  }

  return customInstance<articlesControllerUploadImageResponse>(
    getArticlesControllerUploadImageUrl(id),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Publish a draft article
 */
export type articlesControllerPublishResponse200 = {
  data: void
  status: 200
}

export type articlesControllerPublishResponse404 = {
  data: void
  status: 404
}

export type articlesControllerPublishResponseSuccess =
  articlesControllerPublishResponse200 & {
    headers: Headers
  }
export type articlesControllerPublishResponseError =
  articlesControllerPublishResponse404 & {
    headers: Headers
  }

export type articlesControllerPublishResponse =
  | articlesControllerPublishResponseSuccess
  | articlesControllerPublishResponseError

export const getArticlesControllerPublishUrl = (id: number) => {
  return `/api-arvore/articles/${id}/publish`
}

export const articlesControllerPublish = async (
  id: number,
  options?: RequestInit
): Promise<articlesControllerPublishResponse> => {
  return customInstance<articlesControllerPublishResponse>(
    getArticlesControllerPublishUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Unpublish a published article
 */
export type articlesControllerUnpublishResponse200 = {
  data: void
  status: 200
}

export type articlesControllerUnpublishResponse404 = {
  data: void
  status: 404
}

export type articlesControllerUnpublishResponseSuccess =
  articlesControllerUnpublishResponse200 & {
    headers: Headers
  }
export type articlesControllerUnpublishResponseError =
  articlesControllerUnpublishResponse404 & {
    headers: Headers
  }

export type articlesControllerUnpublishResponse =
  | articlesControllerUnpublishResponseSuccess
  | articlesControllerUnpublishResponseError

export const getArticlesControllerUnpublishUrl = (id: number) => {
  return `/api-arvore/articles/${id}/unpublish`
}

export const articlesControllerUnpublish = async (
  id: number,
  options?: RequestInit
): Promise<articlesControllerUnpublishResponse> => {
  return customInstance<articlesControllerUnpublishResponse>(
    getArticlesControllerUnpublishUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Get article details for reader
 */
export type readerArticlesControllerGetDetailsResponse200 = {
  data: ReaderArticleDetailsResponseDto
  status: 200
}

export type readerArticlesControllerGetDetailsResponse404 = {
  data: void
  status: 404
}

export type readerArticlesControllerGetDetailsResponseSuccess =
  readerArticlesControllerGetDetailsResponse200 & {
    headers: Headers
  }
export type readerArticlesControllerGetDetailsResponseError =
  readerArticlesControllerGetDetailsResponse404 & {
    headers: Headers
  }

export type readerArticlesControllerGetDetailsResponse =
  | readerArticlesControllerGetDetailsResponseSuccess
  | readerArticlesControllerGetDetailsResponseError

export const getReaderArticlesControllerGetDetailsUrl = (id: number) => {
  return `/api-arvore/reader/articles/${id}`
}

export const readerArticlesControllerGetDetails = async (
  id: number,
  options?: RequestInit
): Promise<readerArticlesControllerGetDetailsResponse> => {
  return customInstance<readerArticlesControllerGetDetailsResponse>(
    getReaderArticlesControllerGetDetailsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get available adoption list filters
 */
export type adoptionListControllerGetFiltersResponse200 = {
  data: AdoptionListFiltersResponseDto
  status: 200
}

export type adoptionListControllerGetFiltersResponseSuccess =
  adoptionListControllerGetFiltersResponse200 & {
    headers: Headers
  }
export type adoptionListControllerGetFiltersResponse =
  adoptionListControllerGetFiltersResponseSuccess

export const getAdoptionListControllerGetFiltersUrl = () => {
  return `/api-arvore/adoption-list/filters`
}

export const adoptionListControllerGetFilters = async (
  options?: RequestInit
): Promise<adoptionListControllerGetFiltersResponse> => {
  return customInstance<adoptionListControllerGetFiltersResponse>(
    getAdoptionListControllerGetFiltersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Checks whether the calling app (Arvore or Super) is enabled for a user or entity. For Arvore: enabled if entity has any active contract module. For Super: enabled if entity has the CRIAR module with an active contract.
 * @summary Check if the app is enabled for a given identity
 */
export type entitlementsControllerCheckAvailabilityResponse200 = {
  data: CheckAppAvailabilityResponseDto
  status: 200
}

export type entitlementsControllerCheckAvailabilityResponse400 = {
  data: void
  status: 400
}

export type entitlementsControllerCheckAvailabilityResponse401 = {
  data: void
  status: 401
}

export type entitlementsControllerCheckAvailabilityResponse404 = {
  data: void
  status: 404
}

export type entitlementsControllerCheckAvailabilityResponseSuccess =
  entitlementsControllerCheckAvailabilityResponse200 & {
    headers: Headers
  }
export type entitlementsControllerCheckAvailabilityResponseError = (
  | entitlementsControllerCheckAvailabilityResponse400
  | entitlementsControllerCheckAvailabilityResponse401
  | entitlementsControllerCheckAvailabilityResponse404
) & {
  headers: Headers
}

export type entitlementsControllerCheckAvailabilityResponse =
  | entitlementsControllerCheckAvailabilityResponseSuccess
  | entitlementsControllerCheckAvailabilityResponseError

export const getEntitlementsControllerCheckAvailabilityUrl = (
  params: EntitlementsControllerCheckAvailabilityParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entitlements/apps?${stringifiedParams}`
    : `/api-arvore/entitlements/apps`
}

export const entitlementsControllerCheckAvailability = async (
  params: EntitlementsControllerCheckAvailabilityParams,
  options?: RequestInit
): Promise<entitlementsControllerCheckAvailabilityResponse> => {
  return customInstance<entitlementsControllerCheckAvailabilityResponse>(
    getEntitlementsControllerCheckAvailabilityUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Listar livros favoritos do leitor
 */
export type favoritesControllerListResponse200 = {
  data: FavoriteBooksResponseDto
  status: 200
}

export type favoritesControllerListResponseSuccess =
  favoritesControllerListResponse200 & {
    headers: Headers
  }
export type favoritesControllerListResponse =
  favoritesControllerListResponseSuccess

export const getFavoritesControllerListUrl = (
  params?: FavoritesControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/favorites?${stringifiedParams}`
    : `/api-arvore/favorites`
}

export const favoritesControllerList = async (
  params?: FavoritesControllerListParams,
  options?: RequestInit
): Promise<favoritesControllerListResponse> => {
  return customInstance<favoritesControllerListResponse>(
    getFavoritesControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Adicionar livro aos favoritos
 */
export type favoritesControllerAddResponse204 = {
  data: void
  status: 204
}

export type favoritesControllerAddResponse404 = {
  data: void
  status: 404
}

export type favoritesControllerAddResponseSuccess =
  favoritesControllerAddResponse204 & {
    headers: Headers
  }
export type favoritesControllerAddResponseError =
  favoritesControllerAddResponse404 & {
    headers: Headers
  }

export type favoritesControllerAddResponse =
  | favoritesControllerAddResponseSuccess
  | favoritesControllerAddResponseError

export const getFavoritesControllerAddUrl = () => {
  return `/api-arvore/favorites`
}

export const favoritesControllerAdd = async (
  toggleFavoriteDto: ToggleFavoriteDto,
  options?: RequestInit
): Promise<favoritesControllerAddResponse> => {
  return customInstance<favoritesControllerAddResponse>(
    getFavoritesControllerAddUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleFavoriteDto)
    }
  )
}

/**
 * @summary Remover livro dos favoritos
 */
export type favoritesControllerRemoveResponse204 = {
  data: void
  status: 204
}

export type favoritesControllerRemoveResponse404 = {
  data: void
  status: 404
}

export type favoritesControllerRemoveResponseSuccess =
  favoritesControllerRemoveResponse204 & {
    headers: Headers
  }
export type favoritesControllerRemoveResponseError =
  favoritesControllerRemoveResponse404 & {
    headers: Headers
  }

export type favoritesControllerRemoveResponse =
  | favoritesControllerRemoveResponseSuccess
  | favoritesControllerRemoveResponseError

export const getFavoritesControllerRemoveUrl = () => {
  return `/api-arvore/favorites`
}

export const favoritesControllerRemove = async (
  toggleFavoriteDto: ToggleFavoriteDto,
  options?: RequestInit
): Promise<favoritesControllerRemoveResponse> => {
  return customInstance<favoritesControllerRemoveResponse>(
    getFavoritesControllerRemoveUrl(),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleFavoriteDto)
    }
  )
}

/**
 * @summary Listar favoritos do leitor (livros, vídeos e podcasts)
 */
export type favoritesControllerListLibraryResponse200 = {
  data: FavoriteItemsResponseDto
  status: 200
}

export type favoritesControllerListLibraryResponseSuccess =
  favoritesControllerListLibraryResponse200 & {
    headers: Headers
  }
export type favoritesControllerListLibraryResponse =
  favoritesControllerListLibraryResponseSuccess

export const getFavoritesControllerListLibraryUrl = (
  params?: FavoritesControllerListLibraryParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/favorites/library?${stringifiedParams}`
    : `/api-arvore/favorites/library`
}

export const favoritesControllerListLibrary = async (
  params?: FavoritesControllerListLibraryParams,
  options?: RequestInit
): Promise<favoritesControllerListLibraryResponse> => {
  return customInstance<favoritesControllerListLibraryResponse>(
    getFavoritesControllerListLibraryUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check if a book is favorited
 */
export type favoritesControllerCheckResponse200 = {
  data: CheckFavoriteResponseDto
  status: 200
}

export type favoritesControllerCheckResponseSuccess =
  favoritesControllerCheckResponse200 & {
    headers: Headers
  }
export type favoritesControllerCheckResponse =
  favoritesControllerCheckResponseSuccess

export const getFavoritesControllerCheckUrl = (slug: string) => {
  return `/api-arvore/favorites/check/${slug}`
}

export const favoritesControllerCheck = async (
  slug: string,
  options?: RequestInit
): Promise<favoritesControllerCheckResponse> => {
  return customInstance<favoritesControllerCheckResponse>(
    getFavoritesControllerCheckUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get answers data with flexible filtering
 */
export type analyticsControllerGetAnswersResponse200 = {
  data: GetAnswersResponseDto
  status: 200
}

export type analyticsControllerGetAnswersResponseSuccess =
  analyticsControllerGetAnswersResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetAnswersResponse =
  analyticsControllerGetAnswersResponseSuccess

export const getAnalyticsControllerGetAnswersUrl = (
  params?: AnalyticsControllerGetAnswersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/answers?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/answers`
}

export const analyticsControllerGetAnswers = async (
  params?: AnalyticsControllerGetAnswersParams,
  options?: RequestInit
): Promise<analyticsControllerGetAnswersResponse> => {
  return customInstance<analyticsControllerGetAnswersResponse>(
    getAnalyticsControllerGetAnswersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book page views data with flexible filtering
 */
export type analyticsControllerGetBookPageViewsResponse200 = {
  data: GetBookPageViewsResponseDto
  status: 200
}

export type analyticsControllerGetBookPageViewsResponseSuccess =
  analyticsControllerGetBookPageViewsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetBookPageViewsResponse =
  analyticsControllerGetBookPageViewsResponseSuccess

export const getAnalyticsControllerGetBookPageViewsUrl = (
  params?: AnalyticsControllerGetBookPageViewsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/book-page-views?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/book-page-views`
}

export const analyticsControllerGetBookPageViews = async (
  params?: AnalyticsControllerGetBookPageViewsParams,
  options?: RequestInit
): Promise<analyticsControllerGetBookPageViewsResponse> => {
  return customInstance<analyticsControllerGetBookPageViewsResponse>(
    getAnalyticsControllerGetBookPageViewsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get indications data with flexible filtering
 */
export type analyticsControllerGetIndicationsResponse200 = {
  data: GetIndicationsResponseDto
  status: 200
}

export type analyticsControllerGetIndicationsResponseSuccess =
  analyticsControllerGetIndicationsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetIndicationsResponse =
  analyticsControllerGetIndicationsResponseSuccess

export const getAnalyticsControllerGetIndicationsUrl = (
  params?: AnalyticsControllerGetIndicationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/indications?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/indications`
}

export const analyticsControllerGetIndications = async (
  params?: AnalyticsControllerGetIndicationsParams,
  options?: RequestInit
): Promise<analyticsControllerGetIndicationsResponse> => {
  return customInstance<analyticsControllerGetIndicationsResponse>(
    getAnalyticsControllerGetIndicationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get league rankings data with flexible filtering
 */
export type analyticsControllerGetLeagueRankingsResponse200 = {
  data: GetLeagueRankingsResponseDto
  status: 200
}

export type analyticsControllerGetLeagueRankingsResponseSuccess =
  analyticsControllerGetLeagueRankingsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetLeagueRankingsResponse =
  analyticsControllerGetLeagueRankingsResponseSuccess

export const getAnalyticsControllerGetLeagueRankingsUrl = (
  params?: AnalyticsControllerGetLeagueRankingsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy', 'teacherClasses']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/league-rankings?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/league-rankings`
}

export const analyticsControllerGetLeagueRankings = async (
  params?: AnalyticsControllerGetLeagueRankingsParams,
  options?: RequestInit
): Promise<analyticsControllerGetLeagueRankingsResponse> => {
  return customInstance<analyticsControllerGetLeagueRankingsResponse>(
    getAnalyticsControllerGetLeagueRankingsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get users data with flexible filtering
 */
export type analyticsControllerGetUsersResponse200 = {
  data: GetUsersResponseDto
  status: 200
}

export type analyticsControllerGetUsersResponseSuccess =
  analyticsControllerGetUsersResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetUsersResponse =
  analyticsControllerGetUsersResponseSuccess

export const getAnalyticsControllerGetUsersUrl = (
  params?: AnalyticsControllerGetUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/users?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/users`
}

export const analyticsControllerGetUsers = async (
  params?: AnalyticsControllerGetUsersParams,
  options?: RequestInit
): Promise<analyticsControllerGetUsersResponse> => {
  return customInstance<analyticsControllerGetUsersResponse>(
    getAnalyticsControllerGetUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get classes data with flexible filtering
 */
export type analyticsControllerGetClassesResponse200 = {
  data: GetClassesResponseDto
  status: 200
}

export type analyticsControllerGetClassesResponseSuccess =
  analyticsControllerGetClassesResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetClassesResponse =
  analyticsControllerGetClassesResponseSuccess

export const getAnalyticsControllerGetClassesUrl = (
  params?: AnalyticsControllerGetClassesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/classes?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/classes`
}

export const analyticsControllerGetClasses = async (
  params?: AnalyticsControllerGetClassesParams,
  options?: RequestInit
): Promise<analyticsControllerGetClassesResponse> => {
  return customInstance<analyticsControllerGetClassesResponse>(
    getAnalyticsControllerGetClassesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get schools data with flexible filtering
 */
export type analyticsControllerGetSchoolsResponse200 = {
  data: GetSchoolsResponseDto
  status: 200
}

export type analyticsControllerGetSchoolsResponseSuccess =
  analyticsControllerGetSchoolsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetSchoolsResponse =
  analyticsControllerGetSchoolsResponseSuccess

export const getAnalyticsControllerGetSchoolsUrl = (
  params?: AnalyticsControllerGetSchoolsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/schools?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/schools`
}

export const analyticsControllerGetSchools = async (
  params?: AnalyticsControllerGetSchoolsParams,
  options?: RequestInit
): Promise<analyticsControllerGetSchoolsResponse> => {
  return customInstance<analyticsControllerGetSchoolsResponse>(
    getAnalyticsControllerGetSchoolsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get networks data with flexible filtering
 */
export type analyticsControllerGetNetworksResponse200 = {
  data: GetNetworksResponseDto
  status: 200
}

export type analyticsControllerGetNetworksResponseSuccess =
  analyticsControllerGetNetworksResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetNetworksResponse =
  analyticsControllerGetNetworksResponseSuccess

export const getAnalyticsControllerGetNetworksUrl = (
  params?: AnalyticsControllerGetNetworksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/networks?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/networks`
}

export const analyticsControllerGetNetworks = async (
  params?: AnalyticsControllerGetNetworksParams,
  options?: RequestInit
): Promise<analyticsControllerGetNetworksResponse> => {
  return customInstance<analyticsControllerGetNetworksResponse>(
    getAnalyticsControllerGetNetworksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get trademarks data with flexible filtering
 */
export type analyticsControllerGetTrademarksResponse200 = {
  data: GetTrademarksResponseDto
  status: 200
}

export type analyticsControllerGetTrademarksResponseSuccess =
  analyticsControllerGetTrademarksResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetTrademarksResponse =
  analyticsControllerGetTrademarksResponseSuccess

export const getAnalyticsControllerGetTrademarksUrl = (
  params?: AnalyticsControllerGetTrademarksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/trademarks?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/trademarks`
}

export const analyticsControllerGetTrademarks = async (
  params?: AnalyticsControllerGetTrademarksParams,
  options?: RequestInit
): Promise<analyticsControllerGetTrademarksResponse> => {
  return customInstance<analyticsControllerGetTrademarksResponse>(
    getAnalyticsControllerGetTrademarksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get holdings data with flexible filtering
 */
export type analyticsControllerGetHoldingsResponse200 = {
  data: GetHoldingsResponseDto
  status: 200
}

export type analyticsControllerGetHoldingsResponseSuccess =
  analyticsControllerGetHoldingsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetHoldingsResponse =
  analyticsControllerGetHoldingsResponseSuccess

export const getAnalyticsControllerGetHoldingsUrl = (
  params?: AnalyticsControllerGetHoldingsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/holdings?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/holdings`
}

export const analyticsControllerGetHoldings = async (
  params?: AnalyticsControllerGetHoldingsParams,
  options?: RequestInit
): Promise<analyticsControllerGetHoldingsResponse> => {
  return customInstance<analyticsControllerGetHoldingsResponse>(
    getAnalyticsControllerGetHoldingsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * IMPORTANT: Session data is only available from October 2025 onwards. Analyses prior to this date do not include platform usage information. (Os dados de sessões estão disponíveis apenas a partir de outubro de 2025. Análises anteriores a esta data não incluem informações de uso da plataforma.)
 * @summary Get sessions data with flexible filtering
 */
export type analyticsControllerGetSessionsResponse200 = {
  data: GetSessionsResponseDto
  status: 200
}

export type analyticsControllerGetSessionsResponseSuccess =
  analyticsControllerGetSessionsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetSessionsResponse =
  analyticsControllerGetSessionsResponseSuccess

export const getAnalyticsControllerGetSessionsUrl = (
  params?: AnalyticsControllerGetSessionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/sessions?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/sessions`
}

export const analyticsControllerGetSessions = async (
  params?: AnalyticsControllerGetSessionsParams,
  options?: RequestInit
): Promise<analyticsControllerGetSessionsResponse> => {
  return customInstance<analyticsControllerGetSessionsResponse>(
    getAnalyticsControllerGetSessionsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get readings fluency data with flexible filtering
 */
export type analyticsControllerGetReadingsFluencyResponse200 = {
  data: GetReadingsFluencyResponseDto
  status: 200
}

export type analyticsControllerGetReadingsFluencyResponseSuccess =
  analyticsControllerGetReadingsFluencyResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetReadingsFluencyResponse =
  analyticsControllerGetReadingsFluencyResponseSuccess

export const getAnalyticsControllerGetReadingsFluencyUrl = (
  params?: AnalyticsControllerGetReadingsFluencyParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/readings-fluency?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/readings-fluency`
}

export const analyticsControllerGetReadingsFluency = async (
  params?: AnalyticsControllerGetReadingsFluencyParams,
  options?: RequestInit
): Promise<analyticsControllerGetReadingsFluencyResponse> => {
  return customInstance<analyticsControllerGetReadingsFluencyResponse>(
    getAnalyticsControllerGetReadingsFluencyUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get readings data with flexible filtering
 */
export type analyticsControllerGetReadingsResponse200 = {
  data: GetReadingsResponseDto
  status: 200
}

export type analyticsControllerGetReadingsResponseSuccess =
  analyticsControllerGetReadingsResponse200 & {
    headers: Headers
  }
export type analyticsControllerGetReadingsResponse =
  analyticsControllerGetReadingsResponseSuccess

export const getAnalyticsControllerGetReadingsUrl = (
  params?: AnalyticsControllerGetReadingsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['groupBy']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/analytics/readings?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/analytics/readings`
}

export const analyticsControllerGetReadings = async (
  params?: AnalyticsControllerGetReadingsParams,
  options?: RequestInit
): Promise<analyticsControllerGetReadingsResponse> => {
  return customInstance<analyticsControllerGetReadingsResponse>(
    getAnalyticsControllerGetReadingsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Lists all chats from the authenticated user, ordered by last update
 * @summary List user chats
 */
export type chatsControllerListChatsResponse200 = {
  data: ListChatsResponseDto
  status: 200
}

export type chatsControllerListChatsResponseSuccess =
  chatsControllerListChatsResponse200 & {
    headers: Headers
  }
export type chatsControllerListChatsResponse =
  chatsControllerListChatsResponseSuccess

export const getChatsControllerListChatsUrl = (
  params?: ChatsControllerListChatsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/arvore-intelligence/chats?${stringifiedParams}`
    : `/api-arvore/arvore-intelligence/chats`
}

export const chatsControllerListChats = async (
  params?: ChatsControllerListChatsParams,
  options?: RequestInit
): Promise<chatsControllerListChatsResponse> => {
  return customInstance<chatsControllerListChatsResponse>(
    getChatsControllerListChatsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Creates a new chat session for the user
 * @summary Create new chat
 */
export type chatsControllerCreateChatResponse201 = {
  data: CreateChatResponseDto
  status: 201
}

export type chatsControllerCreateChatResponseSuccess =
  chatsControllerCreateChatResponse201 & {
    headers: Headers
  }
export type chatsControllerCreateChatResponse =
  chatsControllerCreateChatResponseSuccess

export const getChatsControllerCreateChatUrl = () => {
  return `/api-arvore/arvore-intelligence/chats`
}

export const chatsControllerCreateChat = async (
  createChatRequestDto: CreateChatRequestDto,
  options?: RequestInit
): Promise<chatsControllerCreateChatResponse> => {
  return customInstance<chatsControllerCreateChatResponse>(
    getChatsControllerCreateChatUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createChatRequestDto)
    }
  )
}

/**
 * Send messages to AI and receive streaming responses. The AI can use tools from MCP servers. Returns Server-Sent Events (SSE) stream. Optionally provide chatId to auto-save messages.
 * @summary Stream AI chat responses with MCP tools
 */
export type chatsControllerChatResponse201 = {
  data: void
  status: 201
}

export type chatsControllerChatResponseSuccess =
  chatsControllerChatResponse201 & {
    headers: Headers
  }
export type chatsControllerChatResponse = chatsControllerChatResponseSuccess

export const getChatsControllerChatUrl = () => {
  return `/api-arvore/arvore-intelligence/chats/stream`
}

export const chatsControllerChat = async (
  chatRequestDto: ChatRequestDto,
  options?: RequestInit
): Promise<chatsControllerChatResponse> => {
  return customInstance<chatsControllerChatResponse>(
    getChatsControllerChatUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(chatRequestDto)
    }
  )
}

/**
 * Updates the title of an existing chat
 * @summary Update chat title
 */
export type chatsControllerUpdateChatTitleResponse200 = {
  data: UpdateChatTitleResponseDto
  status: 200
}

export type chatsControllerUpdateChatTitleResponse403 = {
  data: void
  status: 403
}

export type chatsControllerUpdateChatTitleResponse404 = {
  data: void
  status: 404
}

export type chatsControllerUpdateChatTitleResponseSuccess =
  chatsControllerUpdateChatTitleResponse200 & {
    headers: Headers
  }
export type chatsControllerUpdateChatTitleResponseError = (
  | chatsControllerUpdateChatTitleResponse403
  | chatsControllerUpdateChatTitleResponse404
) & {
  headers: Headers
}

export type chatsControllerUpdateChatTitleResponse =
  | chatsControllerUpdateChatTitleResponseSuccess
  | chatsControllerUpdateChatTitleResponseError

export const getChatsControllerUpdateChatTitleUrl = (id: string) => {
  return `/api-arvore/arvore-intelligence/chats/title/${id}`
}

export const chatsControllerUpdateChatTitle = async (
  id: string,
  updateChatTitleRequestDto: UpdateChatTitleRequestDto,
  options?: RequestInit
): Promise<chatsControllerUpdateChatTitleResponse> => {
  return customInstance<chatsControllerUpdateChatTitleResponse>(
    getChatsControllerUpdateChatTitleUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateChatTitleRequestDto)
    }
  )
}

/**
 * Automatically generates a descriptive title for the chat based on its messages using AI.
 * @summary Generate chat title with AI
 */
export type chatsControllerGenerateChatTitleResponse200 = {
  data: GenerateChatTitleResponseDto
  status: 200
}

export type chatsControllerGenerateChatTitleResponse403 = {
  data: void
  status: 403
}

export type chatsControllerGenerateChatTitleResponse404 = {
  data: void
  status: 404
}

export type chatsControllerGenerateChatTitleResponseSuccess =
  chatsControllerGenerateChatTitleResponse200 & {
    headers: Headers
  }
export type chatsControllerGenerateChatTitleResponseError = (
  | chatsControllerGenerateChatTitleResponse403
  | chatsControllerGenerateChatTitleResponse404
) & {
  headers: Headers
}

export type chatsControllerGenerateChatTitleResponse =
  | chatsControllerGenerateChatTitleResponseSuccess
  | chatsControllerGenerateChatTitleResponseError

export const getChatsControllerGenerateChatTitleUrl = (id: string) => {
  return `/api-arvore/arvore-intelligence/chats/${id}/generate-title`
}

export const chatsControllerGenerateChatTitle = async (
  id: string,
  generateChatTitleBodyDto: GenerateChatTitleBodyDto,
  options?: RequestInit
): Promise<chatsControllerGenerateChatTitleResponse> => {
  return customInstance<chatsControllerGenerateChatTitleResponse>(
    getChatsControllerGenerateChatTitleUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateChatTitleBodyDto)
    }
  )
}

/**
 * Saves one or more messages to an existing chat. Used after streaming with Vercel AI SDK
 * @summary Save messages to chat
 */
export type chatsControllerSaveMessagesResponse201 = {
  data: SaveMessagesResponseDto
  status: 201
}

export type chatsControllerSaveMessagesResponse403 = {
  data: void
  status: 403
}

export type chatsControllerSaveMessagesResponse404 = {
  data: void
  status: 404
}

export type chatsControllerSaveMessagesResponseSuccess =
  chatsControllerSaveMessagesResponse201 & {
    headers: Headers
  }
export type chatsControllerSaveMessagesResponseError = (
  | chatsControllerSaveMessagesResponse403
  | chatsControllerSaveMessagesResponse404
) & {
  headers: Headers
}

export type chatsControllerSaveMessagesResponse =
  | chatsControllerSaveMessagesResponseSuccess
  | chatsControllerSaveMessagesResponseError

export const getChatsControllerSaveMessagesUrl = (id: string) => {
  return `/api-arvore/arvore-intelligence/chats/${id}/messages`
}

export const chatsControllerSaveMessages = async (
  id: string,
  saveMessagesRequestDto: SaveMessagesRequestDto,
  options?: RequestInit
): Promise<chatsControllerSaveMessagesResponse> => {
  return customInstance<chatsControllerSaveMessagesResponse>(
    getChatsControllerSaveMessagesUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saveMessagesRequestDto)
    }
  )
}

/**
 * Returns details of a specific chat with all messages
 * @summary Get specific chat
 */
export type chatsControllerGetChatResponse200 = {
  data: GetChatResponseDto
  status: 200
}

export type chatsControllerGetChatResponse403 = {
  data: void
  status: 403
}

export type chatsControllerGetChatResponse404 = {
  data: ChatsControllerGetChat404
  status: 404
}

export type chatsControllerGetChatResponseSuccess =
  chatsControllerGetChatResponse200 & {
    headers: Headers
  }
export type chatsControllerGetChatResponseError = (
  | chatsControllerGetChatResponse403
  | chatsControllerGetChatResponse404
) & {
  headers: Headers
}

export type chatsControllerGetChatResponse =
  | chatsControllerGetChatResponseSuccess
  | chatsControllerGetChatResponseError

export const getChatsControllerGetChatUrl = (id: string) => {
  return `/api-arvore/arvore-intelligence/chats/${id}`
}

export const chatsControllerGetChat = async (
  id: string,
  options?: RequestInit
): Promise<chatsControllerGetChatResponse> => {
  return customInstance<chatsControllerGetChatResponse>(
    getChatsControllerGetChatUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Deletes a chat and all its associated messages
 * @summary Delete chat
 */
export type chatsControllerDeleteChatResponse200 = {
  data: void
  status: 200
}

export type chatsControllerDeleteChatResponse403 = {
  data: void
  status: 403
}

export type chatsControllerDeleteChatResponse404 = {
  data: void
  status: 404
}

export type chatsControllerDeleteChatResponseSuccess =
  chatsControllerDeleteChatResponse200 & {
    headers: Headers
  }
export type chatsControllerDeleteChatResponseError = (
  | chatsControllerDeleteChatResponse403
  | chatsControllerDeleteChatResponse404
) & {
  headers: Headers
}

export type chatsControllerDeleteChatResponse =
  | chatsControllerDeleteChatResponseSuccess
  | chatsControllerDeleteChatResponseError

export const getChatsControllerDeleteChatUrl = (id: string) => {
  return `/api-arvore/arvore-intelligence/chats/${id}`
}

export const chatsControllerDeleteChat = async (
  id: string,
  options?: RequestInit
): Promise<chatsControllerDeleteChatResponse> => {
  return customInstance<chatsControllerDeleteChatResponse>(
    getChatsControllerDeleteChatUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List all classes by ancestry
 */
export type entitiesControllerListClassesResponse200 = {
  data: ListClassesByAncestryResponseDto[]
  status: 200
}

export type entitiesControllerListClassesResponseSuccess =
  entitiesControllerListClassesResponse200 & {
    headers: Headers
  }
export type entitiesControllerListClassesResponse =
  entitiesControllerListClassesResponseSuccess

export const getEntitiesControllerListClassesUrl = (
  params?: EntitiesControllerListClassesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/classes?${stringifiedParams}`
    : `/api-arvore/entities/classes`
}

export const entitiesControllerListClasses = async (
  params?: EntitiesControllerListClassesParams,
  options?: RequestInit
): Promise<entitiesControllerListClassesResponse> => {
  return customInstance<entitiesControllerListClassesResponse>(
    getEntitiesControllerListClassesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get entity subtree information
 */
export type entitiesControllerGetSubtreeResponse200 = {
  data: GetEntitySubtreeResponseDto
  status: 200
}

export type entitiesControllerGetSubtreeResponseSuccess =
  entitiesControllerGetSubtreeResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetSubtreeResponse =
  entitiesControllerGetSubtreeResponseSuccess

export const getEntitiesControllerGetSubtreeUrl = (
  params?: EntitiesControllerGetSubtreeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/subtree?${stringifiedParams}`
    : `/api-arvore/entities/subtree`
}

export const entitiesControllerGetSubtree = async (
  params?: EntitiesControllerGetSubtreeParams,
  options?: RequestInit
): Promise<entitiesControllerGetSubtreeResponse> => {
  return customInstance<entitiesControllerGetSubtreeResponse>(
    getEntitiesControllerGetSubtreeUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get classes by entity ID (optional degree filter)
 */
export type entitiesControllerGetClassesByEntityResponse200 = {
  data: ClassesByEntityResponseDto
  status: 200
}

export type entitiesControllerGetClassesByEntityResponseSuccess =
  entitiesControllerGetClassesByEntityResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetClassesByEntityResponse =
  entitiesControllerGetClassesByEntityResponseSuccess

export const getEntitiesControllerGetClassesByEntityUrl = (
  params: EntitiesControllerGetClassesByEntityParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/classes-by-entity?${stringifiedParams}`
    : `/api-arvore/entities/classes-by-entity`
}

export const entitiesControllerGetClassesByEntity = async (
  params: EntitiesControllerGetClassesByEntityParams,
  options?: RequestInit
): Promise<entitiesControllerGetClassesByEntityResponse> => {
  return customInstance<entitiesControllerGetClassesByEntityResponse>(
    getEntitiesControllerGetClassesByEntityUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search entities
 */
export type entitiesControllerSearchEntitiesResponse200 = {
  data: SearchEntitiesResponseDto
  status: 200
}

export type entitiesControllerSearchEntitiesResponseSuccess =
  entitiesControllerSearchEntitiesResponse200 & {
    headers: Headers
  }
export type entitiesControllerSearchEntitiesResponse =
  entitiesControllerSearchEntitiesResponseSuccess

export const getEntitiesControllerSearchEntitiesUrl = (
  params: EntitiesControllerSearchEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/search?${stringifiedParams}`
    : `/api-arvore/entities/search`
}

export const entitiesControllerSearchEntities = async (
  params: EntitiesControllerSearchEntitiesParams,
  options?: RequestInit
): Promise<entitiesControllerSearchEntitiesResponse> => {
  return customInstance<entitiesControllerSearchEntitiesResponse>(
    getEntitiesControllerSearchEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns an entity by ID with its direct children paginated. Used to navigate the entity hierarchy (network → school → class). If teacher has assigned classes, only shows entities in those classes hierarchy.
 * @summary Get entity children with basic info (paginated)
 */
export type entitiesControllerGetEntityChildrenResponse200 = {
  data: GetEntityChildrenResponseDto
  status: 200
}

export type entitiesControllerGetEntityChildrenResponseSuccess =
  entitiesControllerGetEntityChildrenResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityChildrenResponse =
  entitiesControllerGetEntityChildrenResponseSuccess

export const getEntitiesControllerGetEntityChildrenUrl = (
  params: EntitiesControllerGetEntityChildrenParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/children?${stringifiedParams}`
    : `/api-arvore/entities/children`
}

export const entitiesControllerGetEntityChildren = async (
  params: EntitiesControllerGetEntityChildrenParams,
  options?: RequestInit
): Promise<entitiesControllerGetEntityChildrenResponse> => {
  return customInstance<entitiesControllerGetEntityChildrenResponse>(
    getEntitiesControllerGetEntityChildrenUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns all entities that are root of their hierarchies (ancestry = null). These can be holdings, trademarks, or networks depending on the hierarchy structure.
 * @summary Get all root entities (Admin only)
 */
export type entitiesControllerGetRootEntitiesResponse200 = {
  data: GetRootEntitiesResponseDto
  status: 200
}

export type entitiesControllerGetRootEntitiesResponseSuccess =
  entitiesControllerGetRootEntitiesResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetRootEntitiesResponse =
  entitiesControllerGetRootEntitiesResponseSuccess

export const getEntitiesControllerGetRootEntitiesUrl = (
  params?: EntitiesControllerGetRootEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/roots?${stringifiedParams}`
    : `/api-arvore/entities/roots`
}

export const entitiesControllerGetRootEntities = async (
  params?: EntitiesControllerGetRootEntitiesParams,
  options?: RequestInit
): Promise<entitiesControllerGetRootEntitiesResponse> => {
  return customInstance<entitiesControllerGetRootEntitiesResponse>(
    getEntitiesControllerGetRootEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns root entities with their complete hierarchical trees. Limited to 20 roots by default to prevent overwhelming requests. Use the limit parameter to control the number of results.
 * @summary Get root entities with their complete trees (Admin only)
 */
export type entitiesControllerGetRootEntitiesWithTreesResponse200 = {
  data: GetRootEntitiesWithTreesAdminResponseDto
  status: 200
}

export type entitiesControllerGetRootEntitiesWithTreesResponseSuccess =
  entitiesControllerGetRootEntitiesWithTreesResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetRootEntitiesWithTreesResponse =
  entitiesControllerGetRootEntitiesWithTreesResponseSuccess

export const getEntitiesControllerGetRootEntitiesWithTreesUrl = (
  params?: EntitiesControllerGetRootEntitiesWithTreesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/admin/roots-with-trees?${stringifiedParams}`
    : `/api-arvore/entities/admin/roots-with-trees`
}

export const entitiesControllerGetRootEntitiesWithTrees = async (
  params?: EntitiesControllerGetRootEntitiesWithTreesParams,
  options?: RequestInit
): Promise<entitiesControllerGetRootEntitiesWithTreesResponse> => {
  return customInstance<entitiesControllerGetRootEntitiesWithTreesResponse>(
    getEntitiesControllerGetRootEntitiesWithTreesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the complete subtree starting from a root entity with full parent-child relationships. The response includes all entities in the hierarchy (root → units → schools → classes) organized in a nested tree structure.
 * @summary Get complete entity tree with hierarchical structure
 */
export type entitiesControllerGetEntityTreeResponse200 = {
  data: GetEntityTreeResponseDto
  status: 200
}

export type entitiesControllerGetEntityTreeResponseSuccess =
  entitiesControllerGetEntityTreeResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityTreeResponse =
  entitiesControllerGetEntityTreeResponseSuccess

export const getEntitiesControllerGetEntityTreeUrl = (
  params?: EntitiesControllerGetEntityTreeParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/tree?${stringifiedParams}`
    : `/api-arvore/entities/tree`
}

export const entitiesControllerGetEntityTree = async (
  params?: EntitiesControllerGetEntityTreeParams,
  options?: RequestInit
): Promise<entitiesControllerGetEntityTreeResponse> => {
  return customInstance<entitiesControllerGetEntityTreeResponse>(
    getEntitiesControllerGetEntityTreeUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Searches entities by name using Elasticsearch. Admin only. Use this to find entities before fetching their tokens.
 * @summary Search entities by name (Admin only)
 */
export type entitiesControllerSearchEntitiesAdminResponse200 = {
  data: SearchEntitiesAdminResponseDto
  status: 200
}

export type entitiesControllerSearchEntitiesAdminResponseSuccess =
  entitiesControllerSearchEntitiesAdminResponse200 & {
    headers: Headers
  }
export type entitiesControllerSearchEntitiesAdminResponse =
  entitiesControllerSearchEntitiesAdminResponseSuccess

export const getEntitiesControllerSearchEntitiesAdminUrl = (
  params: EntitiesControllerSearchEntitiesAdminParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/admin/search?${stringifiedParams}`
    : `/api-arvore/entities/admin/search`
}

export const entitiesControllerSearchEntitiesAdmin = async (
  params: EntitiesControllerSearchEntitiesAdminParams,
  options?: RequestInit
): Promise<entitiesControllerSearchEntitiesAdminResponse> => {
  return customInstance<entitiesControllerSearchEntitiesAdminResponse>(
    getEntitiesControllerSearchEntitiesAdminUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the 20 most recent B2B subscription accounts with entity info.
 * @summary List recent B2B integrations
 */
export type entitiesControllerGetRecentIntegrationsResponse200 = {
  data: GetRecentIntegrationsResponseDto
  status: 200
}

export type entitiesControllerGetRecentIntegrationsResponseSuccess =
  entitiesControllerGetRecentIntegrationsResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetRecentIntegrationsResponse =
  entitiesControllerGetRecentIntegrationsResponseSuccess

export const getEntitiesControllerGetRecentIntegrationsUrl = () => {
  return `/api-arvore/entities/admin/recent-integrations`
}

export const entitiesControllerGetRecentIntegrations = async (
  options?: RequestInit
): Promise<entitiesControllerGetRecentIntegrationsResponse> => {
  return customInstance<entitiesControllerGetRecentIntegrationsResponse>(
    getEntitiesControllerGetRecentIntegrationsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns integration status for an entity including B2B subscription info.
 * @summary Get entity integration status
 */
export type entitiesControllerGetEntityIntegrationResponse200 = {
  data: GetEntityIntegrationResponseDto
  status: 200
}

export type entitiesControllerGetEntityIntegrationResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerGetEntityIntegrationResponseSuccess =
  entitiesControllerGetEntityIntegrationResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityIntegrationResponseError =
  entitiesControllerGetEntityIntegrationResponse404 & {
    headers: Headers
  }

export type entitiesControllerGetEntityIntegrationResponse =
  | entitiesControllerGetEntityIntegrationResponseSuccess
  | entitiesControllerGetEntityIntegrationResponseError

export const getEntitiesControllerGetEntityIntegrationUrl = (
  entityId: number
) => {
  return `/api-arvore/entities/${entityId}/integration`
}

export const entitiesControllerGetEntityIntegration = async (
  entityId: number,
  options?: RequestInit
): Promise<entitiesControllerGetEntityIntegrationResponse> => {
  return customInstance<entitiesControllerGetEntityIntegrationResponse>(
    getEntitiesControllerGetEntityIntegrationUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Updates the legacy_id field of an entity.
 * @summary Update entity legacy ID
 */
export type entitiesControllerUpdateLegacyIdResponse200 = {
  data: UpdateLegacyIdResponseDto
  status: 200
}

export type entitiesControllerUpdateLegacyIdResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerUpdateLegacyIdResponseSuccess =
  entitiesControllerUpdateLegacyIdResponse200 & {
    headers: Headers
  }
export type entitiesControllerUpdateLegacyIdResponseError =
  entitiesControllerUpdateLegacyIdResponse404 & {
    headers: Headers
  }

export type entitiesControllerUpdateLegacyIdResponse =
  | entitiesControllerUpdateLegacyIdResponseSuccess
  | entitiesControllerUpdateLegacyIdResponseError

export const getEntitiesControllerUpdateLegacyIdUrl = (entityId: number) => {
  return `/api-arvore/entities/${entityId}/legacy-id`
}

export const entitiesControllerUpdateLegacyId = async (
  entityId: number,
  updateLegacyIdBodyDto: UpdateLegacyIdBodyDto,
  options?: RequestInit
): Promise<entitiesControllerUpdateLegacyIdResponse> => {
  return customInstance<entitiesControllerUpdateLegacyIdResponse>(
    getEntitiesControllerUpdateLegacyIdUrl(entityId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateLegacyIdBodyDto)
    }
  )
}

/**
 * Generates a new access key for the entity B2B integration.
 * @summary Generate new access key for entity integration
 */
export type entitiesControllerGenerateAccessKeyResponse200 = {
  data: GenerateAccessKeyResponseDto
  status: 200
}

export type entitiesControllerGenerateAccessKeyResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerGenerateAccessKeyResponseSuccess =
  entitiesControllerGenerateAccessKeyResponse200 & {
    headers: Headers
  }
export type entitiesControllerGenerateAccessKeyResponseError =
  entitiesControllerGenerateAccessKeyResponse404 & {
    headers: Headers
  }

export type entitiesControllerGenerateAccessKeyResponse =
  | entitiesControllerGenerateAccessKeyResponseSuccess
  | entitiesControllerGenerateAccessKeyResponseError

export const getEntitiesControllerGenerateAccessKeyUrl = (entityId: number) => {
  return `/api-arvore/entities/${entityId}/integration/access-key`
}

export const entitiesControllerGenerateAccessKey = async (
  entityId: number,
  options?: RequestInit
): Promise<entitiesControllerGenerateAccessKeyResponse> => {
  return customInstance<entitiesControllerGenerateAccessKeyResponse>(
    getEntitiesControllerGenerateAccessKeyUrl(entityId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Deletes an access key for the entity integration.
 * @summary Delete an access key
 */
export type entitiesControllerDeleteAccessKeyResponse200 = {
  data: DeleteAccessKeyResponseDto
  status: 200
}

export type entitiesControllerDeleteAccessKeyResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerDeleteAccessKeyResponseSuccess =
  entitiesControllerDeleteAccessKeyResponse200 & {
    headers: Headers
  }
export type entitiesControllerDeleteAccessKeyResponseError =
  entitiesControllerDeleteAccessKeyResponse404 & {
    headers: Headers
  }

export type entitiesControllerDeleteAccessKeyResponse =
  | entitiesControllerDeleteAccessKeyResponseSuccess
  | entitiesControllerDeleteAccessKeyResponseError

export const getEntitiesControllerDeleteAccessKeyUrl = (entityId: number) => {
  return `/api-arvore/entities/${entityId}/integration/access-key`
}

export const entitiesControllerDeleteAccessKey = async (
  entityId: number,
  deleteAccessKeyBodyDto: DeleteAccessKeyBodyDto,
  options?: RequestInit
): Promise<entitiesControllerDeleteAccessKeyResponse> => {
  return customInstance<entitiesControllerDeleteAccessKeyResponse>(
    getEntitiesControllerDeleteAccessKeyUrl(entityId),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(deleteAccessKeyBodyDto)
    }
  )
}

/**
 * Deactivates the B2B subscription account for the entity.
 * @summary Deactivate entity integration
 */
export type entitiesControllerDeactivateIntegrationResponse200 = {
  data: DeactivateIntegrationResponseDto
  status: 200
}

export type entitiesControllerDeactivateIntegrationResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerDeactivateIntegrationResponseSuccess =
  entitiesControllerDeactivateIntegrationResponse200 & {
    headers: Headers
  }
export type entitiesControllerDeactivateIntegrationResponseError =
  entitiesControllerDeactivateIntegrationResponse404 & {
    headers: Headers
  }

export type entitiesControllerDeactivateIntegrationResponse =
  | entitiesControllerDeactivateIntegrationResponseSuccess
  | entitiesControllerDeactivateIntegrationResponseError

export const getEntitiesControllerDeactivateIntegrationUrl = (
  entityId: number
) => {
  return `/api-arvore/entities/${entityId}/integration/deactivate`
}

export const entitiesControllerDeactivateIntegration = async (
  entityId: number,
  options?: RequestInit
): Promise<entitiesControllerDeactivateIntegrationResponse> => {
  return customInstance<entitiesControllerDeactivateIntegrationResponse>(
    getEntitiesControllerDeactivateIntegrationUrl(entityId),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * Creates a temporary share link restricted to a specific email.
 * @summary Create a share link for entity credentials
 */
export type entitiesControllerCreateShareLinkResponse200 = {
  data: CreateShareLinkResponseDto
  status: 200
}

export type entitiesControllerCreateShareLinkResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerCreateShareLinkResponseSuccess =
  entitiesControllerCreateShareLinkResponse200 & {
    headers: Headers
  }
export type entitiesControllerCreateShareLinkResponseError =
  entitiesControllerCreateShareLinkResponse404 & {
    headers: Headers
  }

export type entitiesControllerCreateShareLinkResponse =
  | entitiesControllerCreateShareLinkResponseSuccess
  | entitiesControllerCreateShareLinkResponseError

export const getEntitiesControllerCreateShareLinkUrl = (entityId: number) => {
  return `/api-arvore/entities/${entityId}/integration/share`
}

export const entitiesControllerCreateShareLink = async (
  entityId: number,
  createShareLinkBodyDto: CreateShareLinkBodyDto,
  options?: RequestInit
): Promise<entitiesControllerCreateShareLinkResponse> => {
  return customInstance<entitiesControllerCreateShareLinkResponse>(
    getEntitiesControllerCreateShareLinkUrl(entityId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createShareLinkBodyDto)
    }
  )
}

/**
 * @summary List users (readers + teachers) of an entity
 */
export type entitiesControllerGetEntityUsersResponse200 = {
  data: GetEntityUsersResponseDto
  status: 200
}

export type entitiesControllerGetEntityUsersResponseSuccess =
  entitiesControllerGetEntityUsersResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityUsersResponse =
  entitiesControllerGetEntityUsersResponseSuccess

export const getEntitiesControllerGetEntityUsersUrl = (
  params: EntitiesControllerGetEntityUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/users?${stringifiedParams}`
    : `/api-arvore/entities/users`
}

export const entitiesControllerGetEntityUsers = async (
  params: EntitiesControllerGetEntityUsersParams,
  options?: RequestInit
): Promise<entitiesControllerGetEntityUsersResponse> => {
  return customInstance<entitiesControllerGetEntityUsersResponse>(
    getEntitiesControllerGetEntityUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a reader in an entity
 */
export type entitiesControllerCreateEntityUserResponse200 = {
  data: CreateEntityUserResponseDto
  status: 200
}

export type entitiesControllerCreateEntityUserResponseSuccess =
  entitiesControllerCreateEntityUserResponse200 & {
    headers: Headers
  }
export type entitiesControllerCreateEntityUserResponse =
  entitiesControllerCreateEntityUserResponseSuccess

export const getEntitiesControllerCreateEntityUserUrl = (
  params: EntitiesControllerCreateEntityUserParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/users?${stringifiedParams}`
    : `/api-arvore/entities/users`
}

export const entitiesControllerCreateEntityUser = async (
  createEntityUserBodyDto: CreateEntityUserBodyDto,
  params: EntitiesControllerCreateEntityUserParams,
  options?: RequestInit
): Promise<entitiesControllerCreateEntityUserResponse> => {
  return customInstance<entitiesControllerCreateEntityUserResponse>(
    getEntitiesControllerCreateEntityUserUrl(params),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createEntityUserBodyDto)
    }
  )
}

/**
 * @summary Export all users of an entity as CSV
 */
export type entitiesControllerExportEntityUsersResponse200 = {
  data: void
  status: 200
}

export type entitiesControllerExportEntityUsersResponseSuccess =
  entitiesControllerExportEntityUsersResponse200 & {
    headers: Headers
  }
export type entitiesControllerExportEntityUsersResponse =
  entitiesControllerExportEntityUsersResponseSuccess

export const getEntitiesControllerExportEntityUsersUrl = (
  params: EntitiesControllerExportEntityUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/users/export?${stringifiedParams}`
    : `/api-arvore/entities/users/export`
}

export const entitiesControllerExportEntityUsers = async (
  params: EntitiesControllerExportEntityUsersParams,
  options?: RequestInit
): Promise<entitiesControllerExportEntityUsersResponse> => {
  return customInstance<entitiesControllerExportEntityUsersResponse>(
    getEntitiesControllerExportEntityUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Import users into an entity from CSV/XLSX (async via SQS)
 */
export type entitiesControllerImportEntityUsersResponse201 = {
  data: void
  status: 201
}

export type entitiesControllerImportEntityUsersResponseSuccess =
  entitiesControllerImportEntityUsersResponse201 & {
    headers: Headers
  }
export type entitiesControllerImportEntityUsersResponse =
  entitiesControllerImportEntityUsersResponseSuccess

export const getEntitiesControllerImportEntityUsersUrl = (
  params: EntitiesControllerImportEntityUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/entities/users/import?${stringifiedParams}`
    : `/api-arvore/entities/users/import`
}

export const entitiesControllerImportEntityUsers = async (
  params: EntitiesControllerImportEntityUsersParams,
  options?: RequestInit
): Promise<entitiesControllerImportEntityUsersResponse> => {
  return customInstance<entitiesControllerImportEntityUsersResponse>(
    getEntitiesControllerImportEntityUsersUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update a user
 */
export type entitiesControllerUpdateEntityUserResponse200 = {
  data: EntityUserActionResponseDto
  status: 200
}

export type entitiesControllerUpdateEntityUserResponseSuccess =
  entitiesControllerUpdateEntityUserResponse200 & {
    headers: Headers
  }
export type entitiesControllerUpdateEntityUserResponse =
  entitiesControllerUpdateEntityUserResponseSuccess

export const getEntitiesControllerUpdateEntityUserUrl = (readerId: number) => {
  return `/api-arvore/entities/users/${readerId}`
}

export const entitiesControllerUpdateEntityUser = async (
  readerId: number,
  updateEntityUserBodyDto: UpdateEntityUserBodyDto,
  options?: RequestInit
): Promise<entitiesControllerUpdateEntityUserResponse> => {
  return customInstance<entitiesControllerUpdateEntityUserResponse>(
    getEntitiesControllerUpdateEntityUserUrl(readerId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateEntityUserBodyDto)
    }
  )
}

/**
 * @summary Deactivate a user
 */
export type entitiesControllerDeleteEntityUserResponse200 = {
  data: EntityUserActionResponseDto
  status: 200
}

export type entitiesControllerDeleteEntityUserResponseSuccess =
  entitiesControllerDeleteEntityUserResponse200 & {
    headers: Headers
  }
export type entitiesControllerDeleteEntityUserResponse =
  entitiesControllerDeleteEntityUserResponseSuccess

export const getEntitiesControllerDeleteEntityUserUrl = (readerId: number) => {
  return `/api-arvore/entities/users/${readerId}`
}

export const entitiesControllerDeleteEntityUser = async (
  readerId: number,
  options?: RequestInit
): Promise<entitiesControllerDeleteEntityUserResponse> => {
  return customInstance<entitiesControllerDeleteEntityUserResponse>(
    getEntitiesControllerDeleteEntityUserUrl(readerId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Move a user to another entity
 */
export type entitiesControllerMoveEntityUserResponse200 = {
  data: EntityUserActionResponseDto
  status: 200
}

export type entitiesControllerMoveEntityUserResponseSuccess =
  entitiesControllerMoveEntityUserResponse200 & {
    headers: Headers
  }
export type entitiesControllerMoveEntityUserResponse =
  entitiesControllerMoveEntityUserResponseSuccess

export const getEntitiesControllerMoveEntityUserUrl = (readerId: number) => {
  return `/api-arvore/entities/users/${readerId}/move`
}

export const entitiesControllerMoveEntityUser = async (
  readerId: number,
  moveEntityUserBodyDto: MoveEntityUserBodyDto,
  options?: RequestInit
): Promise<entitiesControllerMoveEntityUserResponse> => {
  return customInstance<entitiesControllerMoveEntityUserResponse>(
    getEntitiesControllerMoveEntityUserUrl(readerId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(moveEntityUserBodyDto)
    }
  )
}

/**
 * @summary Reset user password
 */
export type entitiesControllerResetEntityUserPasswordResponse200 = {
  data: EntityUserActionResponseDto
  status: 200
}

export type entitiesControllerResetEntityUserPasswordResponseSuccess =
  entitiesControllerResetEntityUserPasswordResponse200 & {
    headers: Headers
  }
export type entitiesControllerResetEntityUserPasswordResponse =
  entitiesControllerResetEntityUserPasswordResponseSuccess

export const getEntitiesControllerResetEntityUserPasswordUrl = (
  readerId: number
) => {
  return `/api-arvore/entities/users/${readerId}/reset-password`
}

export const entitiesControllerResetEntityUserPassword = async (
  readerId: number,
  options?: RequestInit
): Promise<entitiesControllerResetEntityUserPasswordResponse> => {
  return customInstance<entitiesControllerResetEntityUserPasswordResponse>(
    getEntitiesControllerResetEntityUserPasswordUrl(readerId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List available roles
 */
export type entitiesControllerListRolesResponse200 = {
  data: ListRolesResponseDto
  status: 200
}

export type entitiesControllerListRolesResponseSuccess =
  entitiesControllerListRolesResponse200 & {
    headers: Headers
  }
export type entitiesControllerListRolesResponse =
  entitiesControllerListRolesResponseSuccess

export const getEntitiesControllerListRolesUrl = () => {
  return `/api-arvore/entities/roles`
}

export const entitiesControllerListRoles = async (
  options?: RequestInit
): Promise<entitiesControllerListRolesResponse> => {
  return customInstance<entitiesControllerListRolesResponse>(
    getEntitiesControllerListRolesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Change a user role
 */
export type entitiesControllerChangeUserRoleResponse200 = {
  data: ChangeUserRoleResponseDto
  status: 200
}

export type entitiesControllerChangeUserRoleResponseSuccess =
  entitiesControllerChangeUserRoleResponse200 & {
    headers: Headers
  }
export type entitiesControllerChangeUserRoleResponse =
  entitiesControllerChangeUserRoleResponseSuccess

export const getEntitiesControllerChangeUserRoleUrl = (userId: number) => {
  return `/api-arvore/entities/users/${userId}/role`
}

export const entitiesControllerChangeUserRole = async (
  userId: number,
  changeUserRoleBodyDto: ChangeUserRoleBodyDto,
  options?: RequestInit
): Promise<entitiesControllerChangeUserRoleResponse> => {
  return customInstance<entitiesControllerChangeUserRoleResponse>(
    getEntitiesControllerChangeUserRoleUrl(userId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changeUserRoleBodyDto)
    }
  )
}

/**
 * Returns entity basic information by ID. Admin only.
 * @summary Get entity by ID
 */
export type entitiesControllerGetEntityByIdResponse200 = {
  data: GetEntityByIdResponseDto
  status: 200
}

export type entitiesControllerGetEntityByIdResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerGetEntityByIdResponseSuccess =
  entitiesControllerGetEntityByIdResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityByIdResponseError =
  entitiesControllerGetEntityByIdResponse404 & {
    headers: Headers
  }

export type entitiesControllerGetEntityByIdResponse =
  | entitiesControllerGetEntityByIdResponseSuccess
  | entitiesControllerGetEntityByIdResponseError

export const getEntitiesControllerGetEntityByIdUrl = (id: number) => {
  return `/api-arvore/entities/${id}`
}

export const entitiesControllerGetEntityById = async (
  id: number,
  options?: RequestInit
): Promise<entitiesControllerGetEntityByIdResponse> => {
  return customInstance<entitiesControllerGetEntityByIdResponse>(
    getEntitiesControllerGetEntityByIdUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Same as admin/sync but streams progress events. Use fetch with ReadableStream to consume.
 * @summary Sync entity with streaming progress (SSE)
 */
export type entitiesControllerSyncEntityStreamResponse201 = {
  data: void
  status: 201
}

export type entitiesControllerSyncEntityStreamResponseSuccess =
  entitiesControllerSyncEntityStreamResponse201 & {
    headers: Headers
  }
export type entitiesControllerSyncEntityStreamResponse =
  entitiesControllerSyncEntityStreamResponseSuccess

export const getEntitiesControllerSyncEntityStreamUrl = () => {
  return `/api-arvore/entities/admin/sync-stream`
}

export const entitiesControllerSyncEntityStream = async (
  syncEntityBodyDto: SyncEntityBodyDto,
  options?: RequestInit
): Promise<entitiesControllerSyncEntityStreamResponse> => {
  return customInstance<entitiesControllerSyncEntityStreamResponse>(
    getEntitiesControllerSyncEntityStreamUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(syncEntityBodyDto)
    }
  )
}

/**
 * Returns access tokens (access_key and secret) for an entity. Admin only.
 * @summary Get entity access tokens
 */
export type entitiesControllerGetEntityTokensResponse200 = {
  data: GetEntityTokensResponseDto
  status: 200
}

export type entitiesControllerGetEntityTokensResponse404 = {
  data: void
  status: 404
}

export type entitiesControllerGetEntityTokensResponseSuccess =
  entitiesControllerGetEntityTokensResponse200 & {
    headers: Headers
  }
export type entitiesControllerGetEntityTokensResponseError =
  entitiesControllerGetEntityTokensResponse404 & {
    headers: Headers
  }

export type entitiesControllerGetEntityTokensResponse =
  | entitiesControllerGetEntityTokensResponseSuccess
  | entitiesControllerGetEntityTokensResponseError

export const getEntitiesControllerGetEntityTokensUrl = (id: number) => {
  return `/api-arvore/entities/${id}/tokens`
}

export const entitiesControllerGetEntityTokens = async (
  id: number,
  options?: RequestInit
): Promise<entitiesControllerGetEntityTokensResponse> => {
  return customInstance<entitiesControllerGetEntityTokensResponse>(
    getEntitiesControllerGetEntityTokensUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns basic info about a share link without revealing credentials.
 * @summary Get share link info (public)
 */
export type integrationShareControllerGetShareLinkInfoResponse200 = {
  data: ShareLinkInfoResponseDto
  status: 200
}

export type integrationShareControllerGetShareLinkInfoResponse404 = {
  data: void
  status: 404
}

export type integrationShareControllerGetShareLinkInfoResponseSuccess =
  integrationShareControllerGetShareLinkInfoResponse200 & {
    headers: Headers
  }
export type integrationShareControllerGetShareLinkInfoResponseError =
  integrationShareControllerGetShareLinkInfoResponse404 & {
    headers: Headers
  }

export type integrationShareControllerGetShareLinkInfoResponse =
  | integrationShareControllerGetShareLinkInfoResponseSuccess
  | integrationShareControllerGetShareLinkInfoResponseError

export const getIntegrationShareControllerGetShareLinkInfoUrl = (
  token: string
) => {
  return `/api-arvore/integration-share/${token}`
}

export const integrationShareControllerGetShareLinkInfo = async (
  token: string,
  options?: RequestInit
): Promise<integrationShareControllerGetShareLinkInfoResponse> => {
  return customInstance<integrationShareControllerGetShareLinkInfoResponse>(
    getIntegrationShareControllerGetShareLinkInfoUrl(token),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Sends a 6-digit verification code to the recipient email via SendGrid.
 * @summary Send verification code to email (public)
 */
export type integrationShareControllerSendVerificationCodeResponse200 = {
  data: SendVerificationCodeResponseDto
  status: 200
}

export type integrationShareControllerSendVerificationCodeResponseSuccess =
  integrationShareControllerSendVerificationCodeResponse200 & {
    headers: Headers
  }
export type integrationShareControllerSendVerificationCodeResponse =
  integrationShareControllerSendVerificationCodeResponseSuccess

export const getIntegrationShareControllerSendVerificationCodeUrl = (
  token: string
) => {
  return `/api-arvore/integration-share/${token}/send-code`
}

export const integrationShareControllerSendVerificationCode = async (
  token: string,
  sendVerificationCodeBodyDto: SendVerificationCodeBodyDto,
  options?: RequestInit
): Promise<integrationShareControllerSendVerificationCodeResponse> => {
  return customInstance<integrationShareControllerSendVerificationCodeResponse>(
    getIntegrationShareControllerSendVerificationCodeUrl(token),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sendVerificationCodeBodyDto)
    }
  )
}

/**
 * Verifies the code and returns credentials. Link is marked as used.
 * @summary Verify code and get credentials (public)
 */
export type integrationShareControllerVerifyAndGetCredentialsResponse200 = {
  data: VerifyCodeResponseDto
  status: 200
}

export type integrationShareControllerVerifyAndGetCredentialsResponseSuccess =
  integrationShareControllerVerifyAndGetCredentialsResponse200 & {
    headers: Headers
  }
export type integrationShareControllerVerifyAndGetCredentialsResponse =
  integrationShareControllerVerifyAndGetCredentialsResponseSuccess

export const getIntegrationShareControllerVerifyAndGetCredentialsUrl = (
  token: string
) => {
  return `/api-arvore/integration-share/${token}/verify`
}

export const integrationShareControllerVerifyAndGetCredentials = async (
  token: string,
  verifyCodeBodyDto: VerifyCodeBodyDto,
  options?: RequestInit
): Promise<integrationShareControllerVerifyAndGetCredentialsResponse> => {
  return customInstance<integrationShareControllerVerifyAndGetCredentialsResponse>(
    getIntegrationShareControllerVerifyAndGetCredentialsUrl(token),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(verifyCodeBodyDto)
    }
  )
}

/**
 * @summary Get current user information
 */
export type usersControllerGetUserInfoResponse200 = {
  data: GetUserInfoResponseDto
  status: 200
}

export type usersControllerGetUserInfoResponseSuccess =
  usersControllerGetUserInfoResponse200 & {
    headers: Headers
  }
export type usersControllerGetUserInfoResponse =
  usersControllerGetUserInfoResponseSuccess

export const getUsersControllerGetUserInfoUrl = () => {
  return `/api-arvore/users/me`
}

export const usersControllerGetUserInfo = async (
  options?: RequestInit
): Promise<usersControllerGetUserInfoResponse> => {
  return customInstance<usersControllerGetUserInfoResponse>(
    getUsersControllerGetUserInfoUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Deactivate current user account
 */
export type usersControllerDeactivateMyAccountResponse200 = {
  data: DeactivateMyAccountResponseDto
  status: 200
}

export type usersControllerDeactivateMyAccountResponseSuccess =
  usersControllerDeactivateMyAccountResponse200 & {
    headers: Headers
  }
export type usersControllerDeactivateMyAccountResponse =
  usersControllerDeactivateMyAccountResponseSuccess

export const getUsersControllerDeactivateMyAccountUrl = () => {
  return `/api-arvore/users/me/deactivate`
}

export const usersControllerDeactivateMyAccount = async (
  options?: RequestInit
): Promise<usersControllerDeactivateMyAccountResponse> => {
  return customInstance<usersControllerDeactivateMyAccountResponse>(
    getUsersControllerDeactivateMyAccountUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Get backoffice features accessible by the current employee
 */
export type usersControllerGetBackofficeFeaturesResponse200 = {
  data: GetBackofficeFeaturesResponseDto
  status: 200
}

export type usersControllerGetBackofficeFeaturesResponseSuccess =
  usersControllerGetBackofficeFeaturesResponse200 & {
    headers: Headers
  }
export type usersControllerGetBackofficeFeaturesResponse =
  usersControllerGetBackofficeFeaturesResponseSuccess

export const getUsersControllerGetBackofficeFeaturesUrl = () => {
  return `/api-arvore/users/me/backoffice-features`
}

export const usersControllerGetBackofficeFeatures = async (
  options?: RequestInit
): Promise<usersControllerGetBackofficeFeaturesResponse> => {
  return customInstance<usersControllerGetBackofficeFeaturesResponse>(
    getUsersControllerGetBackofficeFeaturesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check whether the current employee can access the OMS operation app
 */
export type usersControllerGetOmsAccessResponse200 = {
  data: GetOmsAccessResponseDto
  status: 200
}

export type usersControllerGetOmsAccessResponseSuccess =
  usersControllerGetOmsAccessResponse200 & {
    headers: Headers
  }
export type usersControllerGetOmsAccessResponse =
  usersControllerGetOmsAccessResponseSuccess

export const getUsersControllerGetOmsAccessUrl = () => {
  return `/api-arvore/users/me/oms-access`
}

export const usersControllerGetOmsAccess = async (
  options?: RequestInit
): Promise<usersControllerGetOmsAccessResponse> => {
  return customInstance<usersControllerGetOmsAccessResponse>(
    getUsersControllerGetOmsAccessUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the teacher's classes. When teacher_classes are configured, only those (filtered to the teacher hierarchy) are returned. Otherwise, every class under the teacher entity ancestry is returned (entity_type = class).
 * @summary List classes accessible to the authenticated teacher
 */
export type usersControllerListMyClassesResponse200 = {
  data: MeClassesResponseDto
  status: 200
}

export type usersControllerListMyClassesResponseSuccess =
  usersControllerListMyClassesResponse200 & {
    headers: Headers
  }
export type usersControllerListMyClassesResponse =
  usersControllerListMyClassesResponseSuccess

export const getUsersControllerListMyClassesUrl = () => {
  return `/api-arvore/users/me/classes`
}

export const usersControllerListMyClasses = async (
  options?: RequestInit
): Promise<usersControllerListMyClassesResponse> => {
  return customInstance<usersControllerListMyClassesResponse>(
    getUsersControllerListMyClassesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns active students for the requested class. Returns 403 if the class is not accessible to the authenticated teacher (either it is not in their teacher_classes or it is not under their entity ancestry).
 * @summary List students for a class accessible to the authenticated teacher
 */
export type usersControllerListMyClassStudentsResponse200 = {
  data: MeClassStudentsResponseDto
  status: 200
}

export type usersControllerListMyClassStudentsResponseSuccess =
  usersControllerListMyClassStudentsResponse200 & {
    headers: Headers
  }
export type usersControllerListMyClassStudentsResponse =
  usersControllerListMyClassStudentsResponseSuccess

export const getUsersControllerListMyClassStudentsUrl = (
  classEntityId: number
) => {
  return `/api-arvore/users/me/classes/${classEntityId}/students`
}

export const usersControllerListMyClassStudents = async (
  classEntityId: number,
  options?: RequestInit
): Promise<usersControllerListMyClassStudentsResponse> => {
  return customInstance<usersControllerListMyClassStudentsResponse>(
    getUsersControllerListMyClassStudentsUrl(classEntityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List users by full ancestry
 */
export type usersControllerListUsersByAncestryResponse200 = {
  data: ListUsersByAncestryResponseDto[]
  status: 200
}

export type usersControllerListUsersByAncestryResponseSuccess =
  usersControllerListUsersByAncestryResponse200 & {
    headers: Headers
  }
export type usersControllerListUsersByAncestryResponse =
  usersControllerListUsersByAncestryResponseSuccess

export const getUsersControllerListUsersByAncestryUrl = (
  params?: UsersControllerListUsersByAncestryParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/users/by-ancestry?${stringifiedParams}`
    : `/api-arvore/users/by-ancestry`
}

export const usersControllerListUsersByAncestry = async (
  params?: UsersControllerListUsersByAncestryParams,
  options?: RequestInit
): Promise<usersControllerListUsersByAncestryResponse> => {
  return customInstance<usersControllerListUsersByAncestryResponse>(
    getUsersControllerListUsersByAncestryUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List users with roles and job positions scoped to an entity and its descendants
 */
export type usersControllerListUsersWithRolesResponse200 = {
  data: ListUsersWithRolesResponseDto
  status: 200
}

export type usersControllerListUsersWithRolesResponseSuccess =
  usersControllerListUsersWithRolesResponse200 & {
    headers: Headers
  }
export type usersControllerListUsersWithRolesResponse =
  usersControllerListUsersWithRolesResponseSuccess

export const getUsersControllerListUsersWithRolesUrl = (
  params: UsersControllerListUsersWithRolesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/users/with-roles?${stringifiedParams}`
    : `/api-arvore/users/with-roles`
}

export const usersControllerListUsersWithRoles = async (
  params: UsersControllerListUsersWithRolesParams,
  options?: RequestInit
): Promise<usersControllerListUsersWithRolesResponse> => {
  return customInstance<usersControllerListUsersWithRolesResponse>(
    getUsersControllerListUsersWithRolesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search users by name or email
 */
export type usersControllerSearchUsersResponse200 = {
  data: SearchUsersResponseDto
  status: 200
}

export type usersControllerSearchUsersResponseSuccess =
  usersControllerSearchUsersResponse200 & {
    headers: Headers
  }
export type usersControllerSearchUsersResponse =
  usersControllerSearchUsersResponseSuccess

export const getUsersControllerSearchUsersUrl = (
  params: UsersControllerSearchUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/users/search?${stringifiedParams}`
    : `/api-arvore/users/search`
}

export const usersControllerSearchUsers = async (
  params: UsersControllerSearchUsersParams,
  options?: RequestInit
): Promise<usersControllerSearchUsersResponse> => {
  return customInstance<usersControllerSearchUsersResponse>(
    getUsersControllerSearchUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Search users by email, access token and/or user ID. Returns user info with hierarchy (turma, escola, rede). Requires API key (X-API-Key or Authorization: Bearer). Used by chatbot integration.
 * @summary Lookup users by email, access token or user ID
 */
export type usersControllerLookupUsersResponse200 = {
  data: LookupUserResponseDto
  status: 200
}

export type usersControllerLookupUsersResponseSuccess =
  usersControllerLookupUsersResponse200 & {
    headers: Headers
  }
export type usersControllerLookupUsersResponse =
  usersControllerLookupUsersResponseSuccess

export const getUsersControllerLookupUsersUrl = (
  params?: UsersControllerLookupUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/users/lookup?${stringifiedParams}`
    : `/api-arvore/users/lookup`
}

export const usersControllerLookupUsers = async (
  params?: UsersControllerLookupUsersParams,
  options?: RequestInit
): Promise<usersControllerLookupUsersResponse> => {
  return customInstance<usersControllerLookupUsersResponse>(
    getUsersControllerLookupUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Receives a list of users (email and/or access token) and returns, for each input row, whether the user exists and is linked to an entity (class, school or network), along with the resolved hierarchy. Used by the backoffice batch verification screen.
 * @summary Look up multiple users by email and/or access token in batch
 */
export type usersControllerLookupUsersBatchResponse200 = {
  data: LookupUsersBatchResponseDto
  status: 200
}

export type usersControllerLookupUsersBatchResponseSuccess =
  usersControllerLookupUsersBatchResponse200 & {
    headers: Headers
  }
export type usersControllerLookupUsersBatchResponse =
  usersControllerLookupUsersBatchResponseSuccess

export const getUsersControllerLookupUsersBatchUrl = () => {
  return `/api-arvore/users/lookup/batch`
}

export const usersControllerLookupUsersBatch = async (
  lookupUsersBatchRequestDto: LookupUsersBatchRequestDto,
  options?: RequestInit
): Promise<usersControllerLookupUsersBatchResponse> => {
  return customInstance<usersControllerLookupUsersBatchResponse>(
    getUsersControllerLookupUsersBatchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(lookupUsersBatchRequestDto)
    }
  )
}

/**
 * Receives an entity (class, school or network) and a list of names as written in a school spreadsheet, and returns, for each name, the best matching user in the platform (canonical name, access token, email and class) using accent-insensitive normalization and fuzzy similarity. The profileType field selects whether names are matched against students (reader profiles) or educators (teachers/coordinators bound to the entity). Used by the backoffice name normalization screen to fix names that PROCV cannot match due to typos or different spellings.
 * @summary Normalize a list of names against the platform base scoped by entity
 */
export type usersControllerNormalizeNamesResponse200 = {
  data: NormalizeNamesResponseDto
  status: 200
}

export type usersControllerNormalizeNamesResponseSuccess =
  usersControllerNormalizeNamesResponse200 & {
    headers: Headers
  }
export type usersControllerNormalizeNamesResponse =
  usersControllerNormalizeNamesResponseSuccess

export const getUsersControllerNormalizeNamesUrl = () => {
  return `/api-arvore/users/normalize-names`
}

export const usersControllerNormalizeNames = async (
  normalizeNamesRequestDto: NormalizeNamesRequestDto,
  options?: RequestInit
): Promise<usersControllerNormalizeNamesResponse> => {
  return customInstance<usersControllerNormalizeNamesResponse>(
    getUsersControllerNormalizeNamesUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(normalizeNamesRequestDto)
    }
  )
}

/**
 * Creates or updates feedback (like/dislike) for an assistant message. If the user already has feedback for this message, it will be updated.
 * @summary Add or update feedback for a message
 */
export type messageFeedbackControllerUpsertFeedbackResponse201 = {
  data: UpsertFeedbackResponseDto
  status: 201
}

export type messageFeedbackControllerUpsertFeedbackResponse400 = {
  data: void
  status: 400
}

export type messageFeedbackControllerUpsertFeedbackResponse403 = {
  data: void
  status: 403
}

export type messageFeedbackControllerUpsertFeedbackResponse404 = {
  data: void
  status: 404
}

export type messageFeedbackControllerUpsertFeedbackResponseSuccess =
  messageFeedbackControllerUpsertFeedbackResponse201 & {
    headers: Headers
  }
export type messageFeedbackControllerUpsertFeedbackResponseError = (
  | messageFeedbackControllerUpsertFeedbackResponse400
  | messageFeedbackControllerUpsertFeedbackResponse403
  | messageFeedbackControllerUpsertFeedbackResponse404
) & {
  headers: Headers
}

export type messageFeedbackControllerUpsertFeedbackResponse =
  | messageFeedbackControllerUpsertFeedbackResponseSuccess
  | messageFeedbackControllerUpsertFeedbackResponseError

export const getMessageFeedbackControllerUpsertFeedbackUrl = (
  id: string,
  messageId: string
) => {
  return `/api-arvore/arvore-intelligence/chats/${id}/messages/${messageId}/feedback`
}

export const messageFeedbackControllerUpsertFeedback = async (
  id: string,
  messageId: string,
  upsertFeedbackRequestDto: UpsertFeedbackRequestDto,
  options?: RequestInit
): Promise<messageFeedbackControllerUpsertFeedbackResponse> => {
  return customInstance<messageFeedbackControllerUpsertFeedbackResponse>(
    getMessageFeedbackControllerUpsertFeedbackUrl(id, messageId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertFeedbackRequestDto)
    }
  )
}

/**
 * @summary Delete an assignment and its applied activities
 */
export type assignmentsControllerDeleteAssignmentResponse404 = {
  data: void
  status: 404
}
export type assignmentsControllerDeleteAssignmentResponseError =
  assignmentsControllerDeleteAssignmentResponse404 & {
    headers: Headers
  }

export type assignmentsControllerDeleteAssignmentResponse =
  assignmentsControllerDeleteAssignmentResponseError

export const getAssignmentsControllerDeleteAssignmentUrl = (
  assignmentId: string
) => {
  return `/api-arvore/assignments/${assignmentId}`
}

export const assignmentsControllerDeleteAssignment = async (
  assignmentId: string,
  options?: RequestInit
): Promise<assignmentsControllerDeleteAssignmentResponse> => {
  return customInstance<assignmentsControllerDeleteAssignmentResponse>(
    getAssignmentsControllerDeleteAssignmentUrl(assignmentId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Add 20 coins to the reader account after successful assignment
 */
export type assignmentsControllerAddCoinsResponse200 = {
  data: AddCoinsResponseDto
  status: 200
}

export type assignmentsControllerAddCoinsResponseSuccess =
  assignmentsControllerAddCoinsResponse200 & {
    headers: Headers
  }
export type assignmentsControllerAddCoinsResponse =
  assignmentsControllerAddCoinsResponseSuccess

export const getAssignmentsControllerAddCoinsUrl = () => {
  return `/api-arvore/assignments/success`
}

export const assignmentsControllerAddCoins = async (
  options?: RequestInit
): Promise<assignmentsControllerAddCoinsResponse> => {
  return customInstance<assignmentsControllerAddCoinsResponse>(
    getAssignmentsControllerAddCoinsUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Retorna os capítulos do audiobook com progresso de escuta do usuário
 * @summary Obter detalhes do audiobook
 */
export type audiobooksControllerGetDetailsResponse200 = {
  data: AudiobookDetailsResponseDto
  status: 200
}

export type audiobooksControllerGetDetailsResponse404 = {
  data: void
  status: 404
}

export type audiobooksControllerGetDetailsResponseSuccess =
  audiobooksControllerGetDetailsResponse200 & {
    headers: Headers
  }
export type audiobooksControllerGetDetailsResponseError =
  audiobooksControllerGetDetailsResponse404 & {
    headers: Headers
  }

export type audiobooksControllerGetDetailsResponse =
  | audiobooksControllerGetDetailsResponseSuccess
  | audiobooksControllerGetDetailsResponseError

export const getAudiobooksControllerGetDetailsUrl = (slug: string) => {
  return `/api-arvore/audiobooks/${slug}`
}

export const audiobooksControllerGetDetails = async (
  slug: string,
  options?: RequestInit
): Promise<audiobooksControllerGetDetailsResponse> => {
  return customInstance<audiobooksControllerGetDetailsResponse>(
    getAudiobooksControllerGetDetailsUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Registra o progresso de escuta de um capítulo do audiobook
 * @summary Registrar progresso de escuta do audiobook
 */
export type audiobooksControllerRegisterProgressResponse200 = {
  data: void
  status: 200
}

export type audiobooksControllerRegisterProgressResponse404 = {
  data: void
  status: 404
}

export type audiobooksControllerRegisterProgressResponseSuccess =
  audiobooksControllerRegisterProgressResponse200 & {
    headers: Headers
  }
export type audiobooksControllerRegisterProgressResponseError =
  audiobooksControllerRegisterProgressResponse404 & {
    headers: Headers
  }

export type audiobooksControllerRegisterProgressResponse =
  | audiobooksControllerRegisterProgressResponseSuccess
  | audiobooksControllerRegisterProgressResponseError

export const getAudiobooksControllerRegisterProgressUrl = () => {
  return `/api-arvore/audiobooks/register-progress`
}

export const audiobooksControllerRegisterProgress = async (
  registerAudiobookProgressDto: RegisterAudiobookProgressDto,
  options?: RequestInit
): Promise<audiobooksControllerRegisterProgressResponse> => {
  return customInstance<audiobooksControllerRegisterProgressResponse>(
    getAudiobooksControllerRegisterProgressUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerAudiobookProgressDto)
    }
  )
}

/**
 * Retorna as coleções de vídeo ativas que o leitor tem acesso por contrato, com os vídeos filtrados por degree
 * @summary Listar coleções de vídeos disponíveis para o leitor
 */
export type videosControllerCollectionsResponse200 = {
  data: ListVideoCollectionsResponseDto
  status: 200
}

export type videosControllerCollectionsResponseSuccess =
  videosControllerCollectionsResponse200 & {
    headers: Headers
  }
export type videosControllerCollectionsResponse =
  videosControllerCollectionsResponseSuccess

export const getVideosControllerCollectionsUrl = () => {
  return `/api-arvore/videos/collections`
}

export const videosControllerCollections = async (
  options?: RequestInit
): Promise<videosControllerCollectionsResponse> => {
  return customInstance<videosControllerCollectionsResponse>(
    getVideosControllerCollectionsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Retorna os dados do vídeo com URL assinada e progresso de visualização do usuário
 * @summary Obter detalhes do vídeo
 */
export type videosControllerGetDetailsResponse200 = {
  data: VideoDetailsResponseDto
  status: 200
}

export type videosControllerGetDetailsResponse403 = {
  data: void
  status: 403
}

export type videosControllerGetDetailsResponse404 = {
  data: void
  status: 404
}

export type videosControllerGetDetailsResponseSuccess =
  videosControllerGetDetailsResponse200 & {
    headers: Headers
  }
export type videosControllerGetDetailsResponseError = (
  | videosControllerGetDetailsResponse403
  | videosControllerGetDetailsResponse404
) & {
  headers: Headers
}

export type videosControllerGetDetailsResponse =
  | videosControllerGetDetailsResponseSuccess
  | videosControllerGetDetailsResponseError

export const getVideosControllerGetDetailsUrl = (slug: string) => {
  return `/api-arvore/videos/${slug}`
}

export const videosControllerGetDetails = async (
  slug: string,
  options?: RequestInit
): Promise<videosControllerGetDetailsResponse> => {
  return customInstance<videosControllerGetDetailsResponse>(
    getVideosControllerGetDetailsUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Registra o ponto de reprodução do vídeo
 * @summary Registrar progresso de visualização do vídeo
 */
export type videosControllerRegisterProgressResponse200 = {
  data: void
  status: 200
}

export type videosControllerRegisterProgressResponse403 = {
  data: void
  status: 403
}

export type videosControllerRegisterProgressResponse404 = {
  data: void
  status: 404
}

export type videosControllerRegisterProgressResponseSuccess =
  videosControllerRegisterProgressResponse200 & {
    headers: Headers
  }
export type videosControllerRegisterProgressResponseError = (
  | videosControllerRegisterProgressResponse403
  | videosControllerRegisterProgressResponse404
) & {
  headers: Headers
}

export type videosControllerRegisterProgressResponse =
  | videosControllerRegisterProgressResponseSuccess
  | videosControllerRegisterProgressResponseError

export const getVideosControllerRegisterProgressUrl = () => {
  return `/api-arvore/videos/register-progress`
}

export const videosControllerRegisterProgress = async (
  registerVideoProgressDto: RegisterVideoProgressDto,
  options?: RequestInit
): Promise<videosControllerRegisterProgressResponse> => {
  return customInstance<videosControllerRegisterProgressResponse>(
    getVideosControllerRegisterProgressUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerVideoProgressDto)
    }
  )
}

/**
 * Retorna as trilhas publicadas para a entidade do leitor, com progresso do usuário
 * @summary Listar trilhas de aprendizado
 */
export type learningTrailsControllerListResponse200 = {
  data: ListLearningTrailsResponseDto
  status: 200
}

export type learningTrailsControllerListResponseSuccess =
  learningTrailsControllerListResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerListResponse =
  learningTrailsControllerListResponseSuccess

export const getLearningTrailsControllerListUrl = () => {
  return `/api-arvore/learning-trails`
}

export const learningTrailsControllerList = async (
  options?: RequestInit
): Promise<learningTrailsControllerListResponse> => {
  return customInstance<learningTrailsControllerListResponse>(
    getLearningTrailsControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Retorna trilhas iniciadas/concluídas com progresso resumido
 * @summary Progresso do usuário
 */
export type learningTrailsControllerUserProgressResponse200 = {
  data: GetUserProgressResponseDto
  status: 200
}

export type learningTrailsControllerUserProgressResponseSuccess =
  learningTrailsControllerUserProgressResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerUserProgressResponse =
  learningTrailsControllerUserProgressResponseSuccess

export const getLearningTrailsControllerUserProgressUrl = () => {
  return `/api-arvore/learning-trails/me/progress`
}

export const learningTrailsControllerUserProgress = async (
  options?: RequestInit
): Promise<learningTrailsControllerUserProgressResponse> => {
  return customInstance<learningTrailsControllerUserProgressResponse>(
    getLearningTrailsControllerUserProgressUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Retorna metadados, seções e atividades com status do usuário
 * @summary Detalhe da trilha
 */
export type learningTrailsControllerDetailResponse200 = {
  data: GetTrailDetailResponseDto
  status: 200
}

export type learningTrailsControllerDetailResponseSuccess =
  learningTrailsControllerDetailResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerDetailResponse =
  learningTrailsControllerDetailResponseSuccess

export const getLearningTrailsControllerDetailUrl = (trailId: number) => {
  return `/api-arvore/learning-trails/${trailId}`
}

export const learningTrailsControllerDetail = async (
  trailId: number,
  options?: RequestInit
): Promise<learningTrailsControllerDetailResponse> => {
  return customInstance<learningTrailsControllerDetailResponse>(
    getLearningTrailsControllerDetailUrl(trailId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Cria registros de progresso do usuário. Idempotente.
 * @summary Iniciar trilha
 */
export type learningTrailsControllerStartResponse200 = {
  data: StartTrailResponseDto
  status: 200
}

export type learningTrailsControllerStartResponseSuccess =
  learningTrailsControllerStartResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerStartResponse =
  learningTrailsControllerStartResponseSuccess

export const getLearningTrailsControllerStartUrl = (trailId: number) => {
  return `/api-arvore/learning-trails/${trailId}/start`
}

export const learningTrailsControllerStart = async (
  trailId: number,
  options?: RequestInit
): Promise<learningTrailsControllerStartResponse> => {
  return customInstance<learningTrailsControllerStartResponse>(
    getLearningTrailsControllerStartUrl(trailId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Marca atividade como concluída, desbloqueia próxima e verifica conclusão da trilha
 * @summary Completar atividade
 */
export type learningTrailsControllerCompleteResponse200 = {
  data: CompleteActivityResponseDto
  status: 200
}

export type learningTrailsControllerCompleteResponseSuccess =
  learningTrailsControllerCompleteResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerCompleteResponse =
  learningTrailsControllerCompleteResponseSuccess

export const getLearningTrailsControllerCompleteUrl = (activityId: number) => {
  return `/api-arvore/learning-trails/activities/${activityId}/complete`
}

export const learningTrailsControllerComplete = async (
  activityId: number,
  options?: RequestInit
): Promise<learningTrailsControllerCompleteResponse> => {
  return customInstance<learningTrailsControllerCompleteResponse>(
    getLearningTrailsControllerCompleteUrl(activityId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Retorna conteúdo para renderização. Marca como in_progress se disponível.
 * @summary Conteúdo da atividade
 */
export type learningTrailsControllerActivityContentResponse200 = {
  data: GetActivityContentResponseDto
  status: 200
}

export type learningTrailsControllerActivityContentResponseSuccess =
  learningTrailsControllerActivityContentResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerActivityContentResponse =
  learningTrailsControllerActivityContentResponseSuccess

export const getLearningTrailsControllerActivityContentUrl = (
  activityId: number
) => {
  return `/api-arvore/learning-trails/activities/${activityId}`
}

export const learningTrailsControllerActivityContent = async (
  activityId: number,
  options?: RequestInit
): Promise<learningTrailsControllerActivityContentResponse> => {
  return customInstance<learningTrailsControllerActivityContentResponse>(
    getLearningTrailsControllerActivityContentUrl(activityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Persiste a posição atual do vídeo/áudio para resume.
 * @summary Salvar progresso de mídia
 */
export type learningTrailsControllerProgressResponse200 = {
  data: SaveActivityProgressResponseDto
  status: 200
}

export type learningTrailsControllerProgressResponseSuccess =
  learningTrailsControllerProgressResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerProgressResponse =
  learningTrailsControllerProgressResponseSuccess

export const getLearningTrailsControllerProgressUrl = (activityId: number) => {
  return `/api-arvore/learning-trails/activities/${activityId}/progress`
}

export const learningTrailsControllerProgress = async (
  activityId: number,
  saveActivityProgressDto: SaveActivityProgressDto,
  options?: RequestInit
): Promise<learningTrailsControllerProgressResponse> => {
  return customInstance<learningTrailsControllerProgressResponse>(
    getLearningTrailsControllerProgressUrl(activityId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saveActivityProgressDto)
    }
  )
}

/**
 * Calcula nota, registra tentativa e marca como concluída se aprovado.
 * @summary Submeter respostas do quiz
 */
export type learningTrailsControllerQuizSubmitResponse200 = {
  data: SubmitQuizResponseDto
  status: 200
}

export type learningTrailsControllerQuizSubmitResponseSuccess =
  learningTrailsControllerQuizSubmitResponse200 & {
    headers: Headers
  }
export type learningTrailsControllerQuizSubmitResponse =
  learningTrailsControllerQuizSubmitResponseSuccess

export const getLearningTrailsControllerQuizSubmitUrl = (
  activityId: number
) => {
  return `/api-arvore/learning-trails/activities/${activityId}/quiz/submit`
}

export const learningTrailsControllerQuizSubmit = async (
  activityId: number,
  submitQuizDto: SubmitQuizDto,
  options?: RequestInit
): Promise<learningTrailsControllerQuizSubmitResponse> => {
  return customInstance<learningTrailsControllerQuizSubmitResponse>(
    getLearningTrailsControllerQuizSubmitUrl(activityId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(submitQuizDto)
    }
  )
}

/**
 * Recebe um ZIP SCORM, parseia o manifest e cria a trilha com atividades.
 * @summary Importar pacote SCORM
 */
export type scormControllerImportResponse200 = {
  data: ImportScormResponseDto
  status: 200
}

export type scormControllerImportResponseSuccess =
  scormControllerImportResponse200 & {
    headers: Headers
  }
export type scormControllerImportResponse = scormControllerImportResponseSuccess

export const getScormControllerImportUrl = () => {
  return `/api-arvore/scorm/import`
}

export const scormControllerImport = async (
  importScormDto: ImportScormDto,
  options?: RequestInit
): Promise<scormControllerImportResponse> => {
  const formData = new FormData()
  formData.append(`entityId`, importScormDto.entityId.toString())
  if (importScormDto.title !== undefined) {
    formData.append(`title`, importScormDto.title)
  }
  if (importScormDto.categoryId !== undefined) {
    formData.append(`categoryId`, importScormDto.categoryId.toString())
  }

  return customInstance<scormControllerImportResponse>(
    getScormControllerImportUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Borrow a video
 */
export type videoLoansControllerBorrowResponse201 = {
  data: void
  status: 201
}

export type videoLoansControllerBorrowResponse409 = {
  data: void
  status: 409
}

export type videoLoansControllerBorrowResponseSuccess =
  videoLoansControllerBorrowResponse201 & {
    headers: Headers
  }
export type videoLoansControllerBorrowResponseError =
  videoLoansControllerBorrowResponse409 & {
    headers: Headers
  }

export type videoLoansControllerBorrowResponse =
  | videoLoansControllerBorrowResponseSuccess
  | videoLoansControllerBorrowResponseError

export const getVideoLoansControllerBorrowUrl = () => {
  return `/api-arvore/video-loans`
}

export const videoLoansControllerBorrow = async (
  borrowVideoDto: BorrowVideoDto,
  options?: RequestInit
): Promise<videoLoansControllerBorrowResponse> => {
  return customInstance<videoLoansControllerBorrowResponse>(
    getVideoLoansControllerBorrowUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(borrowVideoDto)
    }
  )
}

/**
 * @summary List user video loans
 */
export type videoLoansControllerListResponse200 = {
  data: void
  status: 200
}

export type videoLoansControllerListResponseSuccess =
  videoLoansControllerListResponse200 & {
    headers: Headers
  }
export type videoLoansControllerListResponse =
  videoLoansControllerListResponseSuccess

export const getVideoLoansControllerListUrl = (
  params?: VideoLoansControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/video-loans?${stringifiedParams}`
    : `/api-arvore/video-loans`
}

export const videoLoansControllerList = async (
  params?: VideoLoansControllerListParams,
  options?: RequestInit
): Promise<videoLoansControllerListResponse> => {
  return customInstance<videoLoansControllerListResponse>(
    getVideoLoansControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Return a video
 */
export type videoLoansControllerReturnResponse200 = {
  data: void
  status: 200
}

export type videoLoansControllerReturnResponse404 = {
  data: void
  status: 404
}

export type videoLoansControllerReturnResponseSuccess =
  videoLoansControllerReturnResponse200 & {
    headers: Headers
  }
export type videoLoansControllerReturnResponseError =
  videoLoansControllerReturnResponse404 & {
    headers: Headers
  }

export type videoLoansControllerReturnResponse =
  | videoLoansControllerReturnResponseSuccess
  | videoLoansControllerReturnResponseError

export const getVideoLoansControllerReturnUrl = (id: number) => {
  return `/api-arvore/video-loans/${id}`
}

export const videoLoansControllerReturn = async (
  id: number,
  options?: RequestInit
): Promise<videoLoansControllerReturnResponse> => {
  return customInstance<videoLoansControllerReturnResponse>(
    getVideoLoansControllerReturnUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Renew a video loan
 */
export type videoLoansControllerRenewResponse200 = {
  data: void
  status: 200
}

export type videoLoansControllerRenewResponse409 = {
  data: void
  status: 409
}

export type videoLoansControllerRenewResponseSuccess =
  videoLoansControllerRenewResponse200 & {
    headers: Headers
  }
export type videoLoansControllerRenewResponseError =
  videoLoansControllerRenewResponse409 & {
    headers: Headers
  }

export type videoLoansControllerRenewResponse =
  | videoLoansControllerRenewResponseSuccess
  | videoLoansControllerRenewResponseError

export const getVideoLoansControllerRenewUrl = (id: number) => {
  return `/api-arvore/video-loans/${id}/renew`
}

export const videoLoansControllerRenew = async (
  id: number,
  options?: RequestInit
): Promise<videoLoansControllerRenewResponse> => {
  return customInstance<videoLoansControllerRenewResponse>(
    getVideoLoansControllerRenewUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Check video availability by ID or slug
 */
export type videoLoansControllerAvailabilityResponse200 = {
  data: void
  status: 200
}

export type videoLoansControllerAvailabilityResponseSuccess =
  videoLoansControllerAvailabilityResponse200 & {
    headers: Headers
  }
export type videoLoansControllerAvailabilityResponse =
  videoLoansControllerAvailabilityResponseSuccess

export const getVideoLoansControllerAvailabilityUrl = (
  videoIdOrSlug: string
) => {
  return `/api-arvore/video-loans/videos/${videoIdOrSlug}/availability`
}

export const videoLoansControllerAvailability = async (
  videoIdOrSlug: string,
  options?: RequestInit
): Promise<videoLoansControllerAvailabilityResponse> => {
  return customInstance<videoLoansControllerAvailabilityResponse>(
    getVideoLoansControllerAvailabilityUrl(videoIdOrSlug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Reserve a video (join queue)
 */
export type videoReservationsControllerReserveResponse201 = {
  data: void
  status: 201
}

export type videoReservationsControllerReserveResponse409 = {
  data: void
  status: 409
}

export type videoReservationsControllerReserveResponseSuccess =
  videoReservationsControllerReserveResponse201 & {
    headers: Headers
  }
export type videoReservationsControllerReserveResponseError =
  videoReservationsControllerReserveResponse409 & {
    headers: Headers
  }

export type videoReservationsControllerReserveResponse =
  | videoReservationsControllerReserveResponseSuccess
  | videoReservationsControllerReserveResponseError

export const getVideoReservationsControllerReserveUrl = () => {
  return `/api-arvore/video-reservations`
}

export const videoReservationsControllerReserve = async (
  reserveVideoDto: ReserveVideoDto,
  options?: RequestInit
): Promise<videoReservationsControllerReserveResponse> => {
  return customInstance<videoReservationsControllerReserveResponse>(
    getVideoReservationsControllerReserveUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reserveVideoDto)
    }
  )
}

/**
 * @summary List user video reservations
 */
export type videoReservationsControllerListResponse200 = {
  data: void
  status: 200
}

export type videoReservationsControllerListResponseSuccess =
  videoReservationsControllerListResponse200 & {
    headers: Headers
  }
export type videoReservationsControllerListResponse =
  videoReservationsControllerListResponseSuccess

export const getVideoReservationsControllerListUrl = () => {
  return `/api-arvore/video-reservations`
}

export const videoReservationsControllerList = async (
  options?: RequestInit
): Promise<videoReservationsControllerListResponse> => {
  return customInstance<videoReservationsControllerListResponse>(
    getVideoReservationsControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Borrow a book
 */
export type loansControllerBorrowResponse201 = {
  data: void
  status: 201
}

export type loansControllerBorrowResponse409 = {
  data: void
  status: 409
}

export type loansControllerBorrowResponseSuccess =
  loansControllerBorrowResponse201 & {
    headers: Headers
  }
export type loansControllerBorrowResponseError =
  loansControllerBorrowResponse409 & {
    headers: Headers
  }

export type loansControllerBorrowResponse =
  | loansControllerBorrowResponseSuccess
  | loansControllerBorrowResponseError

export const getLoansControllerBorrowUrl = () => {
  return `/api-arvore/loans`
}

export const loansControllerBorrow = async (
  borrowBookDto: BorrowBookDto,
  options?: RequestInit
): Promise<loansControllerBorrowResponse> => {
  return customInstance<loansControllerBorrowResponse>(
    getLoansControllerBorrowUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(borrowBookDto)
    }
  )
}

/**
 * @summary List user loans
 */
export type loansControllerListResponse200 = {
  data: void
  status: 200
}

export type loansControllerListResponseSuccess =
  loansControllerListResponse200 & {
    headers: Headers
  }
export type loansControllerListResponse = loansControllerListResponseSuccess

export const getLoansControllerListUrl = (
  params?: LoansControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/loans?${stringifiedParams}`
    : `/api-arvore/loans`
}

export const loansControllerList = async (
  params?: LoansControllerListParams,
  options?: RequestInit
): Promise<loansControllerListResponse> => {
  return customInstance<loansControllerListResponse>(
    getLoansControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Return a book
 */
export type loansControllerReturnResponse200 = {
  data: void
  status: 200
}

export type loansControllerReturnResponse404 = {
  data: void
  status: 404
}

export type loansControllerReturnResponseSuccess =
  loansControllerReturnResponse200 & {
    headers: Headers
  }
export type loansControllerReturnResponseError =
  loansControllerReturnResponse404 & {
    headers: Headers
  }

export type loansControllerReturnResponse =
  | loansControllerReturnResponseSuccess
  | loansControllerReturnResponseError

export const getLoansControllerReturnUrl = (id: number) => {
  return `/api-arvore/loans/${id}`
}

export const loansControllerReturn = async (
  id: number,
  options?: RequestInit
): Promise<loansControllerReturnResponse> => {
  return customInstance<loansControllerReturnResponse>(
    getLoansControllerReturnUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Renew a loan
 */
export type loansControllerRenewResponse200 = {
  data: void
  status: 200
}

export type loansControllerRenewResponse409 = {
  data: void
  status: 409
}

export type loansControllerRenewResponseSuccess =
  loansControllerRenewResponse200 & {
    headers: Headers
  }
export type loansControllerRenewResponseError =
  loansControllerRenewResponse409 & {
    headers: Headers
  }

export type loansControllerRenewResponse =
  | loansControllerRenewResponseSuccess
  | loansControllerRenewResponseError

export const getLoansControllerRenewUrl = (id: number) => {
  return `/api-arvore/loans/${id}/renew`
}

export const loansControllerRenew = async (
  id: number,
  options?: RequestInit
): Promise<loansControllerRenewResponse> => {
  return customInstance<loansControllerRenewResponse>(
    getLoansControllerRenewUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Confirm loan after reading threshold
 */
export type loansControllerConfirmReadingResponse204 = {
  data: void
  status: 204
}

export type loansControllerConfirmReadingResponseSuccess =
  loansControllerConfirmReadingResponse204 & {
    headers: Headers
  }
export type loansControllerConfirmReadingResponse =
  loansControllerConfirmReadingResponseSuccess

export const getLoansControllerConfirmReadingUrl = () => {
  return `/api-arvore/loans/confirm-reading`
}

export const loansControllerConfirmReading = async (
  borrowBookDto: BorrowBookDto,
  options?: RequestInit
): Promise<loansControllerConfirmReadingResponse> => {
  return customInstance<loansControllerConfirmReadingResponse>(
    getLoansControllerConfirmReadingUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(borrowBookDto)
    }
  )
}

/**
 * @summary List loan history (returned and expired)
 */
export type loansControllerHistoryResponse200 = {
  data: LoanHistoryResponseDto
  status: 200
}

export type loansControllerHistoryResponseSuccess =
  loansControllerHistoryResponse200 & {
    headers: Headers
  }
export type loansControllerHistoryResponse =
  loansControllerHistoryResponseSuccess

export const getLoansControllerHistoryUrl = (
  params?: LoansControllerHistoryParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/loans/history?${stringifiedParams}`
    : `/api-arvore/loans/history`
}

export const loansControllerHistory = async (
  params?: LoansControllerHistoryParams,
  options?: RequestInit
): Promise<loansControllerHistoryResponse> => {
  return customInstance<loansControllerHistoryResponse>(
    getLoansControllerHistoryUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check book availability by ID or slug
 */
export type loansControllerAvailabilityResponse200 = {
  data: void
  status: 200
}

export type loansControllerAvailabilityResponseSuccess =
  loansControllerAvailabilityResponse200 & {
    headers: Headers
  }
export type loansControllerAvailabilityResponse =
  loansControllerAvailabilityResponseSuccess

export const getLoansControllerAvailabilityUrl = (bookIdOrSlug: string) => {
  return `/api-arvore/loans/books/${bookIdOrSlug}/availability`
}

export const loansControllerAvailability = async (
  bookIdOrSlug: string,
  options?: RequestInit
): Promise<loansControllerAvailabilityResponse> => {
  return customInstance<loansControllerAvailabilityResponse>(
    getLoansControllerAvailabilityUrl(bookIdOrSlug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Confirm loan (internal service-to-service)
 */
export type loansInternalControllerConfirmReadingResponse204 = {
  data: void
  status: 204
}

export type loansInternalControllerConfirmReadingResponseSuccess =
  loansInternalControllerConfirmReadingResponse204 & {
    headers: Headers
  }
export type loansInternalControllerConfirmReadingResponse =
  loansInternalControllerConfirmReadingResponseSuccess

export const getLoansInternalControllerConfirmReadingUrl = () => {
  return `/api-arvore/internal/loans/confirm-reading`
}

export const loansInternalControllerConfirmReading = async (
  confirmLoanInternalDto: ConfirmLoanInternalDto,
  options?: RequestInit
): Promise<loansInternalControllerConfirmReadingResponse> => {
  return customInstance<loansInternalControllerConfirmReadingResponse>(
    getLoansInternalControllerConfirmReadingUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmLoanInternalDto)
    }
  )
}

/**
 * @summary Reserve a book (join queue)
 */
export type reservationsControllerReserveResponse201 = {
  data: void
  status: 201
}

export type reservationsControllerReserveResponse409 = {
  data: void
  status: 409
}

export type reservationsControllerReserveResponseSuccess =
  reservationsControllerReserveResponse201 & {
    headers: Headers
  }
export type reservationsControllerReserveResponseError =
  reservationsControllerReserveResponse409 & {
    headers: Headers
  }

export type reservationsControllerReserveResponse =
  | reservationsControllerReserveResponseSuccess
  | reservationsControllerReserveResponseError

export const getReservationsControllerReserveUrl = () => {
  return `/api-arvore/reservations`
}

export const reservationsControllerReserve = async (
  reserveBookDto: ReserveBookDto,
  options?: RequestInit
): Promise<reservationsControllerReserveResponse> => {
  return customInstance<reservationsControllerReserveResponse>(
    getReservationsControllerReserveUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reserveBookDto)
    }
  )
}

/**
 * @summary List user reservations
 */
export type reservationsControllerListResponse200 = {
  data: void
  status: 200
}

export type reservationsControllerListResponseSuccess =
  reservationsControllerListResponse200 & {
    headers: Headers
  }
export type reservationsControllerListResponse =
  reservationsControllerListResponseSuccess

export const getReservationsControllerListUrl = () => {
  return `/api-arvore/reservations`
}

export const reservationsControllerList = async (
  options?: RequestInit
): Promise<reservationsControllerListResponse> => {
  return customInstance<reservationsControllerListResponse>(
    getReservationsControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Cancel a reservation
 */
export type reservationsControllerCancelResponse204 = {
  data: void
  status: 204
}

export type reservationsControllerCancelResponseSuccess =
  reservationsControllerCancelResponse204 & {
    headers: Headers
  }
export type reservationsControllerCancelResponse =
  reservationsControllerCancelResponseSuccess

export const getReservationsControllerCancelUrl = (id: number) => {
  return `/api-arvore/reservations/${id}`
}

export const reservationsControllerCancel = async (
  id: number,
  options?: RequestInit
): Promise<reservationsControllerCancelResponse> => {
  return customInstance<reservationsControllerCancelResponse>(
    getReservationsControllerCancelUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Toggle notify-me request when queue is full
 */
export type reservationsControllerToggleNotifyResponse201 = {
  data: void
  status: 201
}

export type reservationsControllerToggleNotifyResponseSuccess =
  reservationsControllerToggleNotifyResponse201 & {
    headers: Headers
  }
export type reservationsControllerToggleNotifyResponse =
  reservationsControllerToggleNotifyResponseSuccess

export const getReservationsControllerToggleNotifyUrl = () => {
  return `/api-arvore/reservations/notify`
}

export const reservationsControllerToggleNotify = async (
  reserveBookDto: ReserveBookDto,
  options?: RequestInit
): Promise<reservationsControllerToggleNotifyResponse> => {
  return customInstance<reservationsControllerToggleNotifyResponse>(
    getReservationsControllerToggleNotifyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reserveBookDto)
    }
  )
}

/**
 * @summary Check if a video is favorited
 */
export type videoFavoritesControllerCheckResponse200 = {
  data: CheckVideoFavoriteResponseDto
  status: 200
}

export type videoFavoritesControllerCheckResponseSuccess =
  videoFavoritesControllerCheckResponse200 & {
    headers: Headers
  }
export type videoFavoritesControllerCheckResponse =
  videoFavoritesControllerCheckResponseSuccess

export const getVideoFavoritesControllerCheckUrl = (slug: string) => {
  return `/api-arvore/video-favorites/check/${slug}`
}

export const videoFavoritesControllerCheck = async (
  slug: string,
  options?: RequestInit
): Promise<videoFavoritesControllerCheckResponse> => {
  return customInstance<videoFavoritesControllerCheckResponse>(
    getVideoFavoritesControllerCheckUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Adicionar vídeo aos favoritos
 */
export type videoFavoritesControllerAddResponse204 = {
  data: void
  status: 204
}

export type videoFavoritesControllerAddResponse404 = {
  data: void
  status: 404
}

export type videoFavoritesControllerAddResponseSuccess =
  videoFavoritesControllerAddResponse204 & {
    headers: Headers
  }
export type videoFavoritesControllerAddResponseError =
  videoFavoritesControllerAddResponse404 & {
    headers: Headers
  }

export type videoFavoritesControllerAddResponse =
  | videoFavoritesControllerAddResponseSuccess
  | videoFavoritesControllerAddResponseError

export const getVideoFavoritesControllerAddUrl = () => {
  return `/api-arvore/video-favorites`
}

export const videoFavoritesControllerAdd = async (
  toggleVideoFavoriteDto: ToggleVideoFavoriteDto,
  options?: RequestInit
): Promise<videoFavoritesControllerAddResponse> => {
  return customInstance<videoFavoritesControllerAddResponse>(
    getVideoFavoritesControllerAddUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleVideoFavoriteDto)
    }
  )
}

/**
 * @summary Remover vídeo dos favoritos
 */
export type videoFavoritesControllerRemoveResponse204 = {
  data: void
  status: 204
}

export type videoFavoritesControllerRemoveResponse404 = {
  data: void
  status: 404
}

export type videoFavoritesControllerRemoveResponseSuccess =
  videoFavoritesControllerRemoveResponse204 & {
    headers: Headers
  }
export type videoFavoritesControllerRemoveResponseError =
  videoFavoritesControllerRemoveResponse404 & {
    headers: Headers
  }

export type videoFavoritesControllerRemoveResponse =
  | videoFavoritesControllerRemoveResponseSuccess
  | videoFavoritesControllerRemoveResponseError

export const getVideoFavoritesControllerRemoveUrl = () => {
  return `/api-arvore/video-favorites`
}

export const videoFavoritesControllerRemove = async (
  toggleVideoFavoriteDto: ToggleVideoFavoriteDto,
  options?: RequestInit
): Promise<videoFavoritesControllerRemoveResponse> => {
  return customInstance<videoFavoritesControllerRemoveResponse>(
    getVideoFavoritesControllerRemoveUrl(),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleVideoFavoriteDto)
    }
  )
}

/**
 * Busca de vídeos no índice `arvore.videos`, com gating por contrato e degree. Gateada pela flag LaunchDarkly `videos_in_search_enabled`.
 * @summary Search videos
 */
export type videoSearchControllerSearchResponse200 = {
  data: VideoSearchResponseDto
  status: 200
}

export type videoSearchControllerSearchResponse403 = {
  data: void
  status: 403
}

export type videoSearchControllerSearchResponseSuccess =
  videoSearchControllerSearchResponse200 & {
    headers: Headers
  }
export type videoSearchControllerSearchResponseError =
  videoSearchControllerSearchResponse403 & {
    headers: Headers
  }

export type videoSearchControllerSearchResponse =
  | videoSearchControllerSearchResponseSuccess
  | videoSearchControllerSearchResponseError

export const getVideoSearchControllerSearchUrl = () => {
  return `/api-arvore/video-search`
}

export const videoSearchControllerSearch = async (
  videoSearchRequestDto: VideoSearchRequestDto,
  options?: RequestInit
): Promise<videoSearchControllerSearchResponse> => {
  return customInstance<videoSearchControllerSearchResponse>(
    getVideoSearchControllerSearchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(videoSearchRequestDto)
    }
  )
}

/**
 * @summary Obter detalhes de um podcast show com episódios paginados
 */
export type podcastShowsControllerGetShowResponse200 = {
  data: PodcastShowDetailsResponseDto
  status: 200
}

export type podcastShowsControllerGetShowResponse403 = {
  data: void
  status: 403
}

export type podcastShowsControllerGetShowResponse404 = {
  data: void
  status: 404
}

export type podcastShowsControllerGetShowResponseSuccess =
  podcastShowsControllerGetShowResponse200 & {
    headers: Headers
  }
export type podcastShowsControllerGetShowResponseError = (
  | podcastShowsControllerGetShowResponse403
  | podcastShowsControllerGetShowResponse404
) & {
  headers: Headers
}

export type podcastShowsControllerGetShowResponse =
  | podcastShowsControllerGetShowResponseSuccess
  | podcastShowsControllerGetShowResponseError

export const getPodcastShowsControllerGetShowUrl = (
  slug: string,
  params?: PodcastShowsControllerGetShowParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/podcast-shows/${slug}?${stringifiedParams}`
    : `/api-arvore/podcast-shows/${slug}`
}

export const podcastShowsControllerGetShow = async (
  slug: string,
  params?: PodcastShowsControllerGetShowParams,
  options?: RequestInit
): Promise<podcastShowsControllerGetShowResponse> => {
  return customInstance<podcastShowsControllerGetShowResponse>(
    getPodcastShowsControllerGetShowUrl(slug, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Obter detalhes do episódio com posição de retomada
 */
export type podcastEpisodesControllerGetEpisodeResponse200 = {
  data: PodcastEpisodeDetailsResponseDto
  status: 200
}

export type podcastEpisodesControllerGetEpisodeResponse403 = {
  data: void
  status: 403
}

export type podcastEpisodesControllerGetEpisodeResponse404 = {
  data: void
  status: 404
}

export type podcastEpisodesControllerGetEpisodeResponseSuccess =
  podcastEpisodesControllerGetEpisodeResponse200 & {
    headers: Headers
  }
export type podcastEpisodesControllerGetEpisodeResponseError = (
  | podcastEpisodesControllerGetEpisodeResponse403
  | podcastEpisodesControllerGetEpisodeResponse404
) & {
  headers: Headers
}

export type podcastEpisodesControllerGetEpisodeResponse =
  | podcastEpisodesControllerGetEpisodeResponseSuccess
  | podcastEpisodesControllerGetEpisodeResponseError

export const getPodcastEpisodesControllerGetEpisodeUrl = (slug: string) => {
  return `/api-arvore/podcast-episodes/${slug}`
}

export const podcastEpisodesControllerGetEpisode = async (
  slug: string,
  options?: RequestInit
): Promise<podcastEpisodesControllerGetEpisodeResponse> => {
  return customInstance<podcastEpisodesControllerGetEpisodeResponse>(
    getPodcastEpisodesControllerGetEpisodeUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * URL assinada via CloudFront com TTL de 30min. Se não houver empréstimo ativo, retorna previewMode: true
 * @summary Obter URL assinada do MP3 do episódio
 */
export type podcastEpisodesControllerGetPlayResponse200 = {
  data: PodcastEpisodePlayResponseDto
  status: 200
}

export type podcastEpisodesControllerGetPlayResponse403 = {
  data: void
  status: 403
}

export type podcastEpisodesControllerGetPlayResponse404 = {
  data: void
  status: 404
}

export type podcastEpisodesControllerGetPlayResponseSuccess =
  podcastEpisodesControllerGetPlayResponse200 & {
    headers: Headers
  }
export type podcastEpisodesControllerGetPlayResponseError = (
  | podcastEpisodesControllerGetPlayResponse403
  | podcastEpisodesControllerGetPlayResponse404
) & {
  headers: Headers
}

export type podcastEpisodesControllerGetPlayResponse =
  | podcastEpisodesControllerGetPlayResponseSuccess
  | podcastEpisodesControllerGetPlayResponseError

export const getPodcastEpisodesControllerGetPlayUrl = (slug: string) => {
  return `/api-arvore/podcast-episodes/${slug}/play`
}

export const podcastEpisodesControllerGetPlay = async (
  slug: string,
  options?: RequestInit
): Promise<podcastEpisodesControllerGetPlayResponse> => {
  return customInstance<podcastEpisodesControllerGetPlayResponse>(
    getPodcastEpisodesControllerGetPlayUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Listar coleções de podcast disponíveis para o leitor
 */
export type podcastsControllerCollectionsResponse200 = {
  data: ListPodcastCollectionsResponseDto
  status: 200
}

export type podcastsControllerCollectionsResponseSuccess =
  podcastsControllerCollectionsResponse200 & {
    headers: Headers
  }
export type podcastsControllerCollectionsResponse =
  podcastsControllerCollectionsResponseSuccess

export const getPodcastsControllerCollectionsUrl = () => {
  return `/api-arvore/podcasts/collections`
}

export const podcastsControllerCollections = async (
  options?: RequestInit
): Promise<podcastsControllerCollectionsResponse> => {
  return customInstance<podcastsControllerCollectionsResponse>(
    getPodcastsControllerCollectionsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Requer empréstimo ativo do show
 * @summary Registrar progresso de escuta do episódio
 */
export type podcastsControllerRegisterProgressResponse200 = {
  data: void
  status: 200
}

export type podcastsControllerRegisterProgressResponse403 = {
  data: void
  status: 403
}

export type podcastsControllerRegisterProgressResponse404 = {
  data: void
  status: 404
}

export type podcastsControllerRegisterProgressResponseSuccess =
  podcastsControllerRegisterProgressResponse200 & {
    headers: Headers
  }
export type podcastsControllerRegisterProgressResponseError = (
  | podcastsControllerRegisterProgressResponse403
  | podcastsControllerRegisterProgressResponse404
) & {
  headers: Headers
}

export type podcastsControllerRegisterProgressResponse =
  | podcastsControllerRegisterProgressResponseSuccess
  | podcastsControllerRegisterProgressResponseError

export const getPodcastsControllerRegisterProgressUrl = () => {
  return `/api-arvore/podcasts/register-progress`
}

export const podcastsControllerRegisterProgress = async (
  registerPodcastProgressDto: RegisterPodcastProgressDto,
  options?: RequestInit
): Promise<podcastsControllerRegisterProgressResponse> => {
  return customInstance<podcastsControllerRegisterProgressResponse>(
    getPodcastsControllerRegisterProgressUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerPodcastProgressDto)
    }
  )
}

/**
 * @summary Borrow a podcast
 */
export type podcastLoansControllerBorrowResponse201 = {
  data: void
  status: 201
}

export type podcastLoansControllerBorrowResponse409 = {
  data: void
  status: 409
}

export type podcastLoansControllerBorrowResponseSuccess =
  podcastLoansControllerBorrowResponse201 & {
    headers: Headers
  }
export type podcastLoansControllerBorrowResponseError =
  podcastLoansControllerBorrowResponse409 & {
    headers: Headers
  }

export type podcastLoansControllerBorrowResponse =
  | podcastLoansControllerBorrowResponseSuccess
  | podcastLoansControllerBorrowResponseError

export const getPodcastLoansControllerBorrowUrl = () => {
  return `/api-arvore/podcast-loans`
}

export const podcastLoansControllerBorrow = async (
  borrowPodcastDto: BorrowPodcastDto,
  options?: RequestInit
): Promise<podcastLoansControllerBorrowResponse> => {
  return customInstance<podcastLoansControllerBorrowResponse>(
    getPodcastLoansControllerBorrowUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(borrowPodcastDto)
    }
  )
}

/**
 * @summary List user podcast loans
 */
export type podcastLoansControllerListResponse200 = {
  data: void
  status: 200
}

export type podcastLoansControllerListResponseSuccess =
  podcastLoansControllerListResponse200 & {
    headers: Headers
  }
export type podcastLoansControllerListResponse =
  podcastLoansControllerListResponseSuccess

export const getPodcastLoansControllerListUrl = (
  params?: PodcastLoansControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/podcast-loans?${stringifiedParams}`
    : `/api-arvore/podcast-loans`
}

export const podcastLoansControllerList = async (
  params?: PodcastLoansControllerListParams,
  options?: RequestInit
): Promise<podcastLoansControllerListResponse> => {
  return customInstance<podcastLoansControllerListResponse>(
    getPodcastLoansControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Return a podcast
 */
export type podcastLoansControllerReturnResponse200 = {
  data: void
  status: 200
}

export type podcastLoansControllerReturnResponse404 = {
  data: void
  status: 404
}

export type podcastLoansControllerReturnResponseSuccess =
  podcastLoansControllerReturnResponse200 & {
    headers: Headers
  }
export type podcastLoansControllerReturnResponseError =
  podcastLoansControllerReturnResponse404 & {
    headers: Headers
  }

export type podcastLoansControllerReturnResponse =
  | podcastLoansControllerReturnResponseSuccess
  | podcastLoansControllerReturnResponseError

export const getPodcastLoansControllerReturnUrl = (id: number) => {
  return `/api-arvore/podcast-loans/${id}`
}

export const podcastLoansControllerReturn = async (
  id: number,
  options?: RequestInit
): Promise<podcastLoansControllerReturnResponse> => {
  return customInstance<podcastLoansControllerReturnResponse>(
    getPodcastLoansControllerReturnUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Renew a podcast loan
 */
export type podcastLoansControllerRenewResponse200 = {
  data: void
  status: 200
}

export type podcastLoansControllerRenewResponse409 = {
  data: void
  status: 409
}

export type podcastLoansControllerRenewResponseSuccess =
  podcastLoansControllerRenewResponse200 & {
    headers: Headers
  }
export type podcastLoansControllerRenewResponseError =
  podcastLoansControllerRenewResponse409 & {
    headers: Headers
  }

export type podcastLoansControllerRenewResponse =
  | podcastLoansControllerRenewResponseSuccess
  | podcastLoansControllerRenewResponseError

export const getPodcastLoansControllerRenewUrl = (id: number) => {
  return `/api-arvore/podcast-loans/${id}/renew`
}

export const podcastLoansControllerRenew = async (
  id: number,
  options?: RequestInit
): Promise<podcastLoansControllerRenewResponse> => {
  return customInstance<podcastLoansControllerRenewResponse>(
    getPodcastLoansControllerRenewUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Check podcast show availability by ID or slug
 */
export type podcastLoansControllerAvailabilityResponse200 = {
  data: void
  status: 200
}

export type podcastLoansControllerAvailabilityResponseSuccess =
  podcastLoansControllerAvailabilityResponse200 & {
    headers: Headers
  }
export type podcastLoansControllerAvailabilityResponse =
  podcastLoansControllerAvailabilityResponseSuccess

export const getPodcastLoansControllerAvailabilityUrl = (
  showIdOrSlug: string
) => {
  return `/api-arvore/podcast-loans/podcast-shows/${showIdOrSlug}/availability`
}

export const podcastLoansControllerAvailability = async (
  showIdOrSlug: string,
  options?: RequestInit
): Promise<podcastLoansControllerAvailabilityResponse> => {
  return customInstance<podcastLoansControllerAvailabilityResponse>(
    getPodcastLoansControllerAvailabilityUrl(showIdOrSlug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Reserve a podcast (join queue)
 */
export type podcastReservationsControllerReserveResponse201 = {
  data: void
  status: 201
}

export type podcastReservationsControllerReserveResponse409 = {
  data: void
  status: 409
}

export type podcastReservationsControllerReserveResponseSuccess =
  podcastReservationsControllerReserveResponse201 & {
    headers: Headers
  }
export type podcastReservationsControllerReserveResponseError =
  podcastReservationsControllerReserveResponse409 & {
    headers: Headers
  }

export type podcastReservationsControllerReserveResponse =
  | podcastReservationsControllerReserveResponseSuccess
  | podcastReservationsControllerReserveResponseError

export const getPodcastReservationsControllerReserveUrl = () => {
  return `/api-arvore/podcast-reservations`
}

export const podcastReservationsControllerReserve = async (
  reservePodcastDto: ReservePodcastDto,
  options?: RequestInit
): Promise<podcastReservationsControllerReserveResponse> => {
  return customInstance<podcastReservationsControllerReserveResponse>(
    getPodcastReservationsControllerReserveUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reservePodcastDto)
    }
  )
}

/**
 * @summary List user podcast reservations
 */
export type podcastReservationsControllerListResponse200 = {
  data: void
  status: 200
}

export type podcastReservationsControllerListResponseSuccess =
  podcastReservationsControllerListResponse200 & {
    headers: Headers
  }
export type podcastReservationsControllerListResponse =
  podcastReservationsControllerListResponseSuccess

export const getPodcastReservationsControllerListUrl = () => {
  return `/api-arvore/podcast-reservations`
}

export const podcastReservationsControllerList = async (
  options?: RequestInit
): Promise<podcastReservationsControllerListResponse> => {
  return customInstance<podcastReservationsControllerListResponse>(
    getPodcastReservationsControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check if a podcast is favorited
 */
export type podcastFavoritesControllerCheckResponse200 = {
  data: CheckPodcastFavoriteResponseDto
  status: 200
}

export type podcastFavoritesControllerCheckResponseSuccess =
  podcastFavoritesControllerCheckResponse200 & {
    headers: Headers
  }
export type podcastFavoritesControllerCheckResponse =
  podcastFavoritesControllerCheckResponseSuccess

export const getPodcastFavoritesControllerCheckUrl = (slug: string) => {
  return `/api-arvore/podcast-favorites/check/${slug}`
}

export const podcastFavoritesControllerCheck = async (
  slug: string,
  options?: RequestInit
): Promise<podcastFavoritesControllerCheckResponse> => {
  return customInstance<podcastFavoritesControllerCheckResponse>(
    getPodcastFavoritesControllerCheckUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Adicionar podcast aos favoritos
 */
export type podcastFavoritesControllerAddResponse204 = {
  data: void
  status: 204
}

export type podcastFavoritesControllerAddResponse404 = {
  data: void
  status: 404
}

export type podcastFavoritesControllerAddResponseSuccess =
  podcastFavoritesControllerAddResponse204 & {
    headers: Headers
  }
export type podcastFavoritesControllerAddResponseError =
  podcastFavoritesControllerAddResponse404 & {
    headers: Headers
  }

export type podcastFavoritesControllerAddResponse =
  | podcastFavoritesControllerAddResponseSuccess
  | podcastFavoritesControllerAddResponseError

export const getPodcastFavoritesControllerAddUrl = () => {
  return `/api-arvore/podcast-favorites`
}

export const podcastFavoritesControllerAdd = async (
  togglePodcastFavoriteDto: TogglePodcastFavoriteDto,
  options?: RequestInit
): Promise<podcastFavoritesControllerAddResponse> => {
  return customInstance<podcastFavoritesControllerAddResponse>(
    getPodcastFavoritesControllerAddUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(togglePodcastFavoriteDto)
    }
  )
}

/**
 * @summary Remover podcast dos favoritos
 */
export type podcastFavoritesControllerRemoveResponse204 = {
  data: void
  status: 204
}

export type podcastFavoritesControllerRemoveResponse404 = {
  data: void
  status: 404
}

export type podcastFavoritesControllerRemoveResponseSuccess =
  podcastFavoritesControllerRemoveResponse204 & {
    headers: Headers
  }
export type podcastFavoritesControllerRemoveResponseError =
  podcastFavoritesControllerRemoveResponse404 & {
    headers: Headers
  }

export type podcastFavoritesControllerRemoveResponse =
  | podcastFavoritesControllerRemoveResponseSuccess
  | podcastFavoritesControllerRemoveResponseError

export const getPodcastFavoritesControllerRemoveUrl = () => {
  return `/api-arvore/podcast-favorites`
}

export const podcastFavoritesControllerRemove = async (
  togglePodcastFavoriteDto: TogglePodcastFavoriteDto,
  options?: RequestInit
): Promise<podcastFavoritesControllerRemoveResponse> => {
  return customInstance<podcastFavoritesControllerRemoveResponse>(
    getPodcastFavoritesControllerRemoveUrl(),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(togglePodcastFavoriteDto)
    }
  )
}

/**
 * Busca de podcast shows no índice `arvore.podcast_shows`, com gating por contrato e degree. Gateada pela flag LaunchDarkly `podcasts_search_enabled`.
 * @summary Search podcasts
 */
export type podcastSearchControllerSearchResponse200 = {
  data: PodcastSearchResponseDto
  status: 200
}

export type podcastSearchControllerSearchResponse403 = {
  data: void
  status: 403
}

export type podcastSearchControllerSearchResponseSuccess =
  podcastSearchControllerSearchResponse200 & {
    headers: Headers
  }
export type podcastSearchControllerSearchResponseError =
  podcastSearchControllerSearchResponse403 & {
    headers: Headers
  }

export type podcastSearchControllerSearchResponse =
  | podcastSearchControllerSearchResponseSuccess
  | podcastSearchControllerSearchResponseError

export const getPodcastSearchControllerSearchUrl = () => {
  return `/api-arvore/podcast-search`
}

export const podcastSearchControllerSearch = async (
  podcastSearchRequestDto: PodcastSearchRequestDto,
  options?: RequestInit
): Promise<podcastSearchControllerSearchResponse> => {
  return customInstance<podcastSearchControllerSearchResponse>(
    getPodcastSearchControllerSearchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(podcastSearchRequestDto)
    }
  )
}

/**
 * @summary List all BNCC abilities
 */
export type bnccControllerListAbilitiesResponse200 = {
  data: BnccAbilityResponseDto[]
  status: 200
}

export type bnccControllerListAbilitiesResponseSuccess =
  bnccControllerListAbilitiesResponse200 & {
    headers: Headers
  }
export type bnccControllerListAbilitiesResponse =
  bnccControllerListAbilitiesResponseSuccess

export const getBnccControllerListAbilitiesUrl = () => {
  return `/api-arvore/bncc/abilities`
}

export const bnccControllerListAbilities = async (
  options?: RequestInit
): Promise<bnccControllerListAbilitiesResponse> => {
  return customInstance<bnccControllerListAbilitiesResponse>(
    getBnccControllerListAbilitiesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Streams the AI chat response as text/plain chunked. If the book is already indexed, uses hierarchical summaries. Otherwise extracts text on-the-fly and triggers background indexing.
 * @summary Stream chat response about a book
 */
export type bookChatControllerStreamChatResponse201 = {
  data: void
  status: 201
}

export type bookChatControllerStreamChatResponseSuccess =
  bookChatControllerStreamChatResponse201 & {
    headers: Headers
  }
export type bookChatControllerStreamChatResponse =
  bookChatControllerStreamChatResponseSuccess

export const getBookChatControllerStreamChatUrl = () => {
  return `/api-arvore/lab/book_chat_stream`
}

export const bookChatControllerStreamChat = async (
  streamChatBodyDto: StreamChatBodyDto,
  options?: RequestInit
): Promise<bookChatControllerStreamChatResponse> => {
  return customInstance<bookChatControllerStreamChatResponse>(
    getBookChatControllerStreamChatUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(streamChatBodyDto)
    }
  )
}

/**
 * @summary Get indexing status of a book
 */
export type bookChatControllerGetStatusResponse200 = {
  data: void
  status: 200
}

export type bookChatControllerGetStatusResponseSuccess =
  bookChatControllerGetStatusResponse200 & {
    headers: Headers
  }
export type bookChatControllerGetStatusResponse =
  bookChatControllerGetStatusResponseSuccess

export const getBookChatControllerGetStatusUrl = (
  params: BookChatControllerGetStatusParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/lab/book_chat_status?${stringifiedParams}`
    : `/api-arvore/lab/book_chat_status`
}

export const bookChatControllerGetStatus = async (
  params: BookChatControllerGetStatusParams,
  options?: RequestInit
): Promise<bookChatControllerGetStatusResponse> => {
  return customInstance<bookChatControllerGetStatusResponse>(
    getBookChatControllerGetStatusUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get the latest book chat session for the authenticated user
 */
export type bookChatControllerGetSessionResponse200 = {
  data: void
  status: 200
}

export type bookChatControllerGetSessionResponseSuccess =
  bookChatControllerGetSessionResponse200 & {
    headers: Headers
  }
export type bookChatControllerGetSessionResponse =
  bookChatControllerGetSessionResponseSuccess

export const getBookChatControllerGetSessionUrl = (
  params: BookChatControllerGetSessionParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/lab/book_chat_session?${stringifiedParams}`
    : `/api-arvore/lab/book_chat_session`
}

export const bookChatControllerGetSession = async (
  params: BookChatControllerGetSessionParams,
  options?: RequestInit
): Promise<bookChatControllerGetSessionResponse> => {
  return customInstance<bookChatControllerGetSessionResponse>(
    getBookChatControllerGetSessionUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update the latest book chat session for the authenticated user
 */
export type bookChatControllerUpdateSessionResponse200 = {
  data: void
  status: 200
}

export type bookChatControllerUpdateSessionResponseSuccess =
  bookChatControllerUpdateSessionResponse200 & {
    headers: Headers
  }
export type bookChatControllerUpdateSessionResponse =
  bookChatControllerUpdateSessionResponseSuccess

export const getBookChatControllerUpdateSessionUrl = () => {
  return `/api-arvore/lab/book_chat_session`
}

export const bookChatControllerUpdateSession = async (
  updateSessionBodyDto: UpdateSessionBodyDto,
  options?: RequestInit
): Promise<bookChatControllerUpdateSessionResponse> => {
  return customInstance<bookChatControllerUpdateSessionResponse>(
    getBookChatControllerUpdateSessionUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateSessionBodyDto)
    }
  )
}

/**
 * @summary Submit like/dislike feedback for the book chat
 */
export type bookChatControllerCreateFeedbackResponse201 = {
  data: void
  status: 201
}

export type bookChatControllerCreateFeedbackResponseSuccess =
  bookChatControllerCreateFeedbackResponse201 & {
    headers: Headers
  }
export type bookChatControllerCreateFeedbackResponse =
  bookChatControllerCreateFeedbackResponseSuccess

export const getBookChatControllerCreateFeedbackUrl = () => {
  return `/api-arvore/lab/book_chat_feedback`
}

export const bookChatControllerCreateFeedback = async (
  bookChatFeedbackBodyDto: BookChatFeedbackBodyDto,
  options?: RequestInit
): Promise<bookChatControllerCreateFeedbackResponse> => {
  return customInstance<bookChatControllerCreateFeedbackResponse>(
    getBookChatControllerCreateFeedbackUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(bookChatFeedbackBodyDto)
    }
  )
}

/**
 * @summary Submit text feedback for the book chat
 */
export type bookChatControllerCreateFeedbackTextResponse201 = {
  data: void
  status: 201
}

export type bookChatControllerCreateFeedbackTextResponseSuccess =
  bookChatControllerCreateFeedbackTextResponse201 & {
    headers: Headers
  }
export type bookChatControllerCreateFeedbackTextResponse =
  bookChatControllerCreateFeedbackTextResponseSuccess

export const getBookChatControllerCreateFeedbackTextUrl = () => {
  return `/api-arvore/lab/book_chat_feedback_text`
}

export const bookChatControllerCreateFeedbackText = async (
  bookChatFeedbackTextBodyDto: BookChatFeedbackTextBodyDto,
  options?: RequestInit
): Promise<bookChatControllerCreateFeedbackTextResponse> => {
  return customInstance<bookChatControllerCreateFeedbackTextResponse>(
    getBookChatControllerCreateFeedbackTextUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(bookChatFeedbackTextBodyDto)
    }
  )
}

/**
 * @summary List book levelling scores
 */
export type bookLevellingControllerListScoresV1Response200 = {
  data: void
  status: 200
}

export type bookLevellingControllerListScoresV1ResponseSuccess =
  bookLevellingControllerListScoresV1Response200 & {
    headers: Headers
  }
export type bookLevellingControllerListScoresV1Response =
  bookLevellingControllerListScoresV1ResponseSuccess

export const getBookLevellingControllerListScoresV1Url = (
  params?: BookLevellingControllerListScoresV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/book-levelling?${stringifiedParams}`
    : `/api-arvore/v1/book-levelling`
}

export const bookLevellingControllerListScoresV1 = async (
  params?: BookLevellingControllerListScoresV1Params,
  options?: RequestInit
): Promise<bookLevellingControllerListScoresV1Response> => {
  return customInstance<bookLevellingControllerListScoresV1Response>(
    getBookLevellingControllerListScoresV1Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search books by title/author for levelling
 */
export type bookLevellingControllerSearchBooksV1Response200 = {
  data: void
  status: 200
}

export type bookLevellingControllerSearchBooksV1ResponseSuccess =
  bookLevellingControllerSearchBooksV1Response200 & {
    headers: Headers
  }
export type bookLevellingControllerSearchBooksV1Response =
  bookLevellingControllerSearchBooksV1ResponseSuccess

export const getBookLevellingControllerSearchBooksV1Url = (
  params: BookLevellingControllerSearchBooksV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/book-levelling/search-books?${stringifiedParams}`
    : `/api-arvore/v1/book-levelling/search-books`
}

export const bookLevellingControllerSearchBooksV1 = async (
  params: BookLevellingControllerSearchBooksV1Params,
  options?: RequestInit
): Promise<bookLevellingControllerSearchBooksV1Response> => {
  return customInstance<bookLevellingControllerSearchBooksV1Response>(
    getBookLevellingControllerSearchBooksV1Url(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book levelling details from DynamoDB
 */
export type bookLevellingControllerGetDetailsV1Response200 = {
  data: void
  status: 200
}

export type bookLevellingControllerGetDetailsV1ResponseSuccess =
  bookLevellingControllerGetDetailsV1Response200 & {
    headers: Headers
  }
export type bookLevellingControllerGetDetailsV1Response =
  bookLevellingControllerGetDetailsV1ResponseSuccess

export const getBookLevellingControllerGetDetailsV1Url = (
  slug: string,
  version: number
) => {
  return `/api-arvore/v1/book-levelling/${slug}/${version}`
}

export const bookLevellingControllerGetDetailsV1 = async (
  slug: string,
  version: number,
  options?: RequestInit
): Promise<bookLevellingControllerGetDetailsV1Response> => {
  return customInstance<bookLevellingControllerGetDetailsV1Response>(
    getBookLevellingControllerGetDetailsV1Url(slug, version),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Enqueue ISBNs for book levelling analysis
 */
export type bookLevellingControllerEnqueueV1Response204 = {
  data: void
  status: 204
}

export type bookLevellingControllerEnqueueV1ResponseSuccess =
  bookLevellingControllerEnqueueV1Response204 & {
    headers: Headers
  }
export type bookLevellingControllerEnqueueV1Response =
  bookLevellingControllerEnqueueV1ResponseSuccess

export const getBookLevellingControllerEnqueueV1Url = () => {
  return `/api-arvore/v1/book-levelling/enqueue`
}

export const bookLevellingControllerEnqueueV1 = async (
  enqueueBookLevellingBodyDto: EnqueueBookLevellingBodyDto,
  options?: RequestInit
): Promise<bookLevellingControllerEnqueueV1Response> => {
  return customInstance<bookLevellingControllerEnqueueV1Response>(
    getBookLevellingControllerEnqueueV1Url(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(enqueueBookLevellingBodyDto)
    }
  )
}

/**
 * @summary Lista livros catalogados pelo abismal (visão admin, sem filtros de produto)
 */
export type catalogationControllerAdminListCatalogedBooksResponse200 = {
  data: AdminListCatalogedBooksResponseDto
  status: 200
}

export type catalogationControllerAdminListCatalogedBooksResponseSuccess =
  catalogationControllerAdminListCatalogedBooksResponse200 & {
    headers: Headers
  }
export type catalogationControllerAdminListCatalogedBooksResponse =
  catalogationControllerAdminListCatalogedBooksResponseSuccess

export const getCatalogationControllerAdminListCatalogedBooksUrl = (
  params?: CatalogationControllerAdminListCatalogedBooksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['degrees']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/catalogation/admin/books?${stringifiedParams}`
    : `/api-arvore/catalogation/admin/books`
}

export const catalogationControllerAdminListCatalogedBooks = async (
  params?: CatalogationControllerAdminListCatalogedBooksParams,
  options?: RequestInit
): Promise<catalogationControllerAdminListCatalogedBooksResponse> => {
  return customInstance<catalogationControllerAdminListCatalogedBooksResponse>(
    getCatalogationControllerAdminListCatalogedBooksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Retorna a catalogação crua de um livro (todos os temas, sem filtro de exibição)
 */
export type catalogationControllerAdminGetCatalogedBookDetailResponse200 = {
  data: AdminGetCatalogedBookDetailResponseDto
  status: 200
}

export type catalogationControllerAdminGetCatalogedBookDetailResponseSuccess =
  catalogationControllerAdminGetCatalogedBookDetailResponse200 & {
    headers: Headers
  }
export type catalogationControllerAdminGetCatalogedBookDetailResponse =
  catalogationControllerAdminGetCatalogedBookDetailResponseSuccess

export const getCatalogationControllerAdminGetCatalogedBookDetailUrl = (
  bookId: number
) => {
  return `/api-arvore/catalogation/admin/books/${bookId}`
}

export const catalogationControllerAdminGetCatalogedBookDetail = async (
  bookId: number,
  options?: RequestInit
): Promise<catalogationControllerAdminGetCatalogedBookDetailResponse> => {
  return customInstance<catalogationControllerAdminGetCatalogedBookDetailResponse>(
    getCatalogationControllerAdminGetCatalogedBookDetailUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Adiciona manualmente um tema de sensibilidade + trecho a um livro
 */
export type catalogationControllerAddManualSensitivityResponse201 = {
  data: AddManualSensitivityResponseDto
  status: 201
}

export type catalogationControllerAddManualSensitivityResponseSuccess =
  catalogationControllerAddManualSensitivityResponse201 & {
    headers: Headers
  }
export type catalogationControllerAddManualSensitivityResponse =
  catalogationControllerAddManualSensitivityResponseSuccess

export const getCatalogationControllerAddManualSensitivityUrl = (
  bookId: number
) => {
  return `/api-arvore/catalogation/admin/books/${bookId}/sensitivity`
}

export const catalogationControllerAddManualSensitivity = async (
  bookId: number,
  addManualSensitivityBodyDto: AddManualSensitivityBodyDto,
  options?: RequestInit
): Promise<catalogationControllerAddManualSensitivityResponse> => {
  return customInstance<catalogationControllerAddManualSensitivityResponse>(
    getCatalogationControllerAddManualSensitivityUrl(bookId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(addManualSensitivityBodyDto)
    }
  )
}

/**
 * @summary Remove um tema de sensibilidade adicionado manualmente
 */
export type catalogationControllerRemoveManualSensitivityResponse204 = {
  data: void
  status: 204
}

export type catalogationControllerRemoveManualSensitivityResponseSuccess =
  catalogationControllerRemoveManualSensitivityResponse204 & {
    headers: Headers
  }
export type catalogationControllerRemoveManualSensitivityResponse =
  catalogationControllerRemoveManualSensitivityResponseSuccess

export const getCatalogationControllerRemoveManualSensitivityUrl = (
  bookId: number,
  sensitivityId: number
) => {
  return `/api-arvore/catalogation/admin/books/${bookId}/sensitivity/${sensitivityId}`
}

export const catalogationControllerRemoveManualSensitivity = async (
  bookId: number,
  sensitivityId: number,
  options?: RequestInit
): Promise<catalogationControllerRemoveManualSensitivityResponse> => {
  return customInstance<catalogationControllerRemoveManualSensitivityResponse>(
    getCatalogationControllerRemoveManualSensitivityUrl(bookId, sensitivityId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Lista livros catalogados com filtros e paginação
 */
export type catalogationControllerListCatalogedBooksResponse200 = {
  data: ListCatalogedBooksResponseDto
  status: 200
}

export type catalogationControllerListCatalogedBooksResponseSuccess =
  catalogationControllerListCatalogedBooksResponse200 & {
    headers: Headers
  }
export type catalogationControllerListCatalogedBooksResponse =
  catalogationControllerListCatalogedBooksResponseSuccess

export const getCatalogationControllerListCatalogedBooksUrl = (
  params?: CatalogationControllerListCatalogedBooksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['degrees', 'genres', 'themes', 'mediations']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/catalogation/books?${stringifiedParams}`
    : `/api-arvore/catalogation/books`
}

export const catalogationControllerListCatalogedBooks = async (
  params?: CatalogationControllerListCatalogedBooksParams,
  options?: RequestInit
): Promise<catalogationControllerListCatalogedBooksResponse> => {
  return customInstance<catalogationControllerListCatalogedBooksResponse>(
    getCatalogationControllerListCatalogedBooksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Retorna sentences de sensibilidade de um livro filtradas por label
 */
export type catalogationControllerGetBookSensitivitySentencesResponse200 = {
  data: GetBookSensitivitySentencesResponseDto
  status: 200
}

export type catalogationControllerGetBookSensitivitySentencesResponseSuccess =
  catalogationControllerGetBookSensitivitySentencesResponse200 & {
    headers: Headers
  }
export type catalogationControllerGetBookSensitivitySentencesResponse =
  catalogationControllerGetBookSensitivitySentencesResponseSuccess

export const getCatalogationControllerGetBookSensitivitySentencesUrl = (
  params: CatalogationControllerGetBookSensitivitySentencesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/catalogation/books/sensitivity-sentences?${stringifiedParams}`
    : `/api-arvore/catalogation/books/sensitivity-sentences`
}

export const catalogationControllerGetBookSensitivitySentences = async (
  params: CatalogationControllerGetBookSensitivitySentencesParams,
  options?: RequestInit
): Promise<catalogationControllerGetBookSensitivitySentencesResponse> => {
  return customInstance<catalogationControllerGetBookSensitivitySentencesResponse>(
    getCatalogationControllerGetBookSensitivitySentencesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Retorna detalhes de um livro catalogado (com evidence excerpts)
 */
export type catalogationControllerGetCatalogedBookDetailResponse200 = {
  data: GetCatalogedBookDetailResponseDto
  status: 200
}

export type catalogationControllerGetCatalogedBookDetailResponseSuccess =
  catalogationControllerGetCatalogedBookDetailResponse200 & {
    headers: Headers
  }
export type catalogationControllerGetCatalogedBookDetailResponse =
  catalogationControllerGetCatalogedBookDetailResponseSuccess

export const getCatalogationControllerGetCatalogedBookDetailUrl = (
  bookId: number
) => {
  return `/api-arvore/catalogation/books/${bookId}`
}

export const catalogationControllerGetCatalogedBookDetail = async (
  bookId: number,
  options?: RequestInit
): Promise<catalogationControllerGetCatalogedBookDetailResponse> => {
  return customInstance<catalogationControllerGetCatalogedBookDetailResponse>(
    getCatalogationControllerGetCatalogedBookDetailUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Retorna todas as listas de adoção do educador
 */
export type catalogationControllerGetListsResponse200 = {
  data: GetCatalogationListsResponseDto
  status: 200
}

export type catalogationControllerGetListsResponseSuccess =
  catalogationControllerGetListsResponse200 & {
    headers: Headers
  }
export type catalogationControllerGetListsResponse =
  catalogationControllerGetListsResponseSuccess

export const getCatalogationControllerGetListsUrl = (userId: number) => {
  return `/api-arvore/catalogation/lists/${userId}`
}

export const catalogationControllerGetLists = async (
  userId: number,
  options?: RequestInit
): Promise<catalogationControllerGetListsResponse> => {
  return customInstance<catalogationControllerGetListsResponse>(
    getCatalogationControllerGetListsUrl(userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Indica os livros da lista de adoção para alunos ou turmas
 */
export type catalogationControllerCreateContentIndicationsFromAdoptionListResponse201 =
  {
    data: CreateContentIndicationsFromAdoptionListResponseDto
    status: 201
  }

export type catalogationControllerCreateContentIndicationsFromAdoptionListResponseSuccess =
  catalogationControllerCreateContentIndicationsFromAdoptionListResponse201 & {
    headers: Headers
  }
export type catalogationControllerCreateContentIndicationsFromAdoptionListResponse =
  catalogationControllerCreateContentIndicationsFromAdoptionListResponseSuccess

export const getCatalogationControllerCreateContentIndicationsFromAdoptionListUrl =
  (bookListId: number) => {
    return `/api-arvore/catalogation/lists/${bookListId}/indicate`
  }

export const catalogationControllerCreateContentIndicationsFromAdoptionList =
  async (
    bookListId: number,
    createContentIndicationsFromAdoptionListBodyDto: CreateContentIndicationsFromAdoptionListBodyDto,
    options?: RequestInit
  ): Promise<catalogationControllerCreateContentIndicationsFromAdoptionListResponse> => {
    return customInstance<catalogationControllerCreateContentIndicationsFromAdoptionListResponse>(
      getCatalogationControllerCreateContentIndicationsFromAdoptionListUrl(
        bookListId
      ),
      {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createContentIndicationsFromAdoptionListBodyDto)
      }
    )
  }

/**
 * @summary Cria ou atualiza lista de adoção e adiciona livros
 */
export type catalogationControllerCreateListResponse201 = {
  data: CreateCatalogationListResponseDto
  status: 201
}

export type catalogationControllerCreateListResponseSuccess =
  catalogationControllerCreateListResponse201 & {
    headers: Headers
  }
export type catalogationControllerCreateListResponse =
  catalogationControllerCreateListResponseSuccess

export const getCatalogationControllerCreateListUrl = () => {
  return `/api-arvore/catalogation/lists`
}

export const catalogationControllerCreateList = async (
  createCatalogationListBodyDto: CreateCatalogationListBodyDto,
  options?: RequestInit
): Promise<catalogationControllerCreateListResponse> => {
  return customInstance<catalogationControllerCreateListResponse>(
    getCatalogationControllerCreateListUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createCatalogationListBodyDto)
    }
  )
}

/**
 * @summary Updates list name and/or description
 */
export type catalogationControllerUpdateListResponse200 = {
  data: UpdateCatalogationListResponseDto
  status: 200
}

export type catalogationControllerUpdateListResponseSuccess =
  catalogationControllerUpdateListResponse200 & {
    headers: Headers
  }
export type catalogationControllerUpdateListResponse =
  catalogationControllerUpdateListResponseSuccess

export const getCatalogationControllerUpdateListUrl = (bookListId: number) => {
  return `/api-arvore/catalogation/lists/${bookListId}`
}

export const catalogationControllerUpdateList = async (
  bookListId: number,
  updateCatalogationListBodyDto: UpdateCatalogationListBodyDto,
  options?: RequestInit
): Promise<catalogationControllerUpdateListResponse> => {
  return customInstance<catalogationControllerUpdateListResponse>(
    getCatalogationControllerUpdateListUrl(bookListId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateCatalogationListBodyDto)
    }
  )
}

/**
 * @summary Remove a book from the list or delete the entire list by soft delete
 */
export type catalogationControllerDeleteListResponse200 = {
  data: void
  status: 200
}

export type catalogationControllerDeleteListResponseSuccess =
  catalogationControllerDeleteListResponse200 & {
    headers: Headers
  }
export type catalogationControllerDeleteListResponse =
  catalogationControllerDeleteListResponseSuccess

export const getCatalogationControllerDeleteListUrl = (
  bookListId: number,
  params?: CatalogationControllerDeleteListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/catalogation/lists/${bookListId}?${stringifiedParams}`
    : `/api-arvore/catalogation/lists/${bookListId}`
}

export const catalogationControllerDeleteList = async (
  bookListId: number,
  params?: CatalogationControllerDeleteListParams,
  options?: RequestInit
): Promise<catalogationControllerDeleteListResponse> => {
  return customInstance<catalogationControllerDeleteListResponse>(
    getCatalogationControllerDeleteListUrl(bookListId, params),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Gera descricao da lista de livros com IA
 */
export type catalogationControllerGenerateListDescriptionResponse200 = {
  data: GenerateListDescriptionResponseDto
  status: 200
}

export type catalogationControllerGenerateListDescriptionResponseSuccess =
  catalogationControllerGenerateListDescriptionResponse200 & {
    headers: Headers
  }
export type catalogationControllerGenerateListDescriptionResponse =
  catalogationControllerGenerateListDescriptionResponseSuccess

export const getCatalogationControllerGenerateListDescriptionUrl = (
  bookListId: number
) => {
  return `/api-arvore/catalogation/lists/${bookListId}/description`
}

export const catalogationControllerGenerateListDescription = async (
  bookListId: number,
  options?: RequestInit
): Promise<catalogationControllerGenerateListDescriptionResponse> => {
  return customInstance<catalogationControllerGenerateListDescriptionResponse>(
    getCatalogationControllerGenerateListDescriptionUrl(bookListId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Submit talk-to-book feedback
 */
export type catalogationControllerCreateConverseComLivroFeedbackResponse201 = {
  data: void
  status: 201
}

export type catalogationControllerCreateConverseComLivroFeedbackResponseSuccess =
  catalogationControllerCreateConverseComLivroFeedbackResponse201 & {
    headers: Headers
  }
export type catalogationControllerCreateConverseComLivroFeedbackResponse =
  catalogationControllerCreateConverseComLivroFeedbackResponseSuccess

export const getCatalogationControllerCreateConverseComLivroFeedbackUrl =
  () => {
    return `/api-arvore/catalogation/converse-com-livro/feedback`
  }

export const catalogationControllerCreateConverseComLivroFeedback = async (
  createConverseComLivroFeedbackBodyDto: CreateConverseComLivroFeedbackBodyDto,
  options?: RequestInit
): Promise<catalogationControllerCreateConverseComLivroFeedbackResponse> => {
  return customInstance<catalogationControllerCreateConverseComLivroFeedbackResponse>(
    getCatalogationControllerCreateConverseComLivroFeedbackUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createConverseComLivroFeedbackBodyDto)
    }
  )
}

/**
 * @summary Reprocess audiobook links for a book
 */
export type catalogationControllerReprocessAudiobookResponse200 = {
  data: ReprocessAudiobookResponseDto
  status: 200
}

export type catalogationControllerReprocessAudiobookResponseSuccess =
  catalogationControllerReprocessAudiobookResponse200 & {
    headers: Headers
  }
export type catalogationControllerReprocessAudiobookResponse =
  catalogationControllerReprocessAudiobookResponseSuccess

export const getCatalogationControllerReprocessAudiobookUrl = () => {
  return `/api-arvore/catalogation/books/audiobook-reprocessing`
}

export const catalogationControllerReprocessAudiobook = async (
  reprocessAudiobookBodyDto: ReprocessAudiobookBodyDto,
  options?: RequestInit
): Promise<catalogationControllerReprocessAudiobookResponse> => {
  return customInstance<catalogationControllerReprocessAudiobookResponse>(
    getCatalogationControllerReprocessAudiobookUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reprocessAudiobookBodyDto)
    }
  )
}

/**
 * @summary Set takedown date for a single book by slug
 */
export type bookRemovalControllerSetTakedownDateSingleResponse201 = {
  data: void
  status: 201
}

export type bookRemovalControllerSetTakedownDateSingleResponseSuccess =
  bookRemovalControllerSetTakedownDateSingleResponse201 & {
    headers: Headers
  }
export type bookRemovalControllerSetTakedownDateSingleResponse =
  bookRemovalControllerSetTakedownDateSingleResponseSuccess

export const getBookRemovalControllerSetTakedownDateSingleUrl = () => {
  return `/api-arvore/backoffice/book-removal/set-takedown-date`
}

export const bookRemovalControllerSetTakedownDateSingle = async (
  setTakedownDateDto: SetTakedownDateDto,
  options?: RequestInit
): Promise<bookRemovalControllerSetTakedownDateSingleResponse> => {
  return customInstance<bookRemovalControllerSetTakedownDateSingleResponse>(
    getBookRemovalControllerSetTakedownDateSingleUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setTakedownDateDto)
    }
  )
}

/**
 * @summary Set takedown date for multiple books by slug
 */
export type bookRemovalControllerSetTakedownDateBatchActionResponse201 = {
  data: void
  status: 201
}

export type bookRemovalControllerSetTakedownDateBatchActionResponseSuccess =
  bookRemovalControllerSetTakedownDateBatchActionResponse201 & {
    headers: Headers
  }
export type bookRemovalControllerSetTakedownDateBatchActionResponse =
  bookRemovalControllerSetTakedownDateBatchActionResponseSuccess

export const getBookRemovalControllerSetTakedownDateBatchActionUrl = () => {
  return `/api-arvore/backoffice/book-removal/set-takedown-date-batch`
}

export const bookRemovalControllerSetTakedownDateBatchAction = async (
  setTakedownDateBatchDto: SetTakedownDateBatchDto,
  options?: RequestInit
): Promise<bookRemovalControllerSetTakedownDateBatchActionResponse> => {
  return customInstance<bookRemovalControllerSetTakedownDateBatchActionResponse>(
    getBookRemovalControllerSetTakedownDateBatchActionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setTakedownDateBatchDto)
    }
  )
}

/**
 * @summary List digital catalog items with filters and pagination
 */
export type digitalCatalogControllerListResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerListResponseSuccess =
  digitalCatalogControllerListResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerListResponse =
  digitalCatalogControllerListResponseSuccess

export const getDigitalCatalogControllerListUrl = (
  params?: DigitalCatalogControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog?${stringifiedParams}`
    : `/api-arvore/digital-catalog`
}

export const digitalCatalogControllerList = async (
  params?: DigitalCatalogControllerListParams,
  options?: RequestInit
): Promise<digitalCatalogControllerListResponse> => {
  return customInstance<digitalCatalogControllerListResponse>(
    getDigitalCatalogControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Reindex the marketplace catalog into Elasticsearch
 */
export type digitalCatalogControllerReindexMarketplaceResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerReindexMarketplaceResponseSuccess =
  digitalCatalogControllerReindexMarketplaceResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerReindexMarketplaceResponse =
  digitalCatalogControllerReindexMarketplaceResponseSuccess

export const getDigitalCatalogControllerReindexMarketplaceUrl = (
  params: DigitalCatalogControllerReindexMarketplaceParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/marketplace/reindex?${stringifiedParams}`
    : `/api-arvore/digital-catalog/marketplace/reindex`
}

export const digitalCatalogControllerReindexMarketplace = async (
  params: DigitalCatalogControllerReindexMarketplaceParams,
  options?: RequestInit
): Promise<digitalCatalogControllerReindexMarketplaceResponse> => {
  return customInstance<digitalCatalogControllerReindexMarketplaceResponse>(
    getDigitalCatalogControllerReindexMarketplaceUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List filter options (publishers, tags, languages) with search and pagination
 */
export type digitalCatalogControllerFiltersResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerFiltersResponseSuccess =
  digitalCatalogControllerFiltersResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerFiltersResponse =
  digitalCatalogControllerFiltersResponseSuccess

export const getDigitalCatalogControllerFiltersUrl = (
  params: DigitalCatalogControllerFiltersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/filters?${stringifiedParams}`
    : `/api-arvore/digital-catalog/filters`
}

export const digitalCatalogControllerFilters = async (
  params: DigitalCatalogControllerFiltersParams,
  options?: RequestInit
): Promise<digitalCatalogControllerFiltersResponse> => {
  return customInstance<digitalCatalogControllerFiltersResponse>(
    getDigitalCatalogControllerFiltersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List authorities with search, type and status filters
 */
export type digitalCatalogControllerListAuthoritiesResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerListAuthoritiesResponseSuccess =
  digitalCatalogControllerListAuthoritiesResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerListAuthoritiesResponse =
  digitalCatalogControllerListAuthoritiesResponseSuccess

export const getDigitalCatalogControllerListAuthoritiesUrl = (
  params?: DigitalCatalogControllerListAuthoritiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/authorities?${stringifiedParams}`
    : `/api-arvore/digital-catalog/authorities`
}

export const digitalCatalogControllerListAuthorities = async (
  params?: DigitalCatalogControllerListAuthoritiesParams,
  options?: RequestInit
): Promise<digitalCatalogControllerListAuthoritiesResponse> => {
  return customInstance<digitalCatalogControllerListAuthoritiesResponse>(
    getDigitalCatalogControllerListAuthoritiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List vocabulary terms with search, taxonomy and status filters
 */
export type digitalCatalogControllerListVocabularyTermsResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerListVocabularyTermsResponseSuccess =
  digitalCatalogControllerListVocabularyTermsResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerListVocabularyTermsResponse =
  digitalCatalogControllerListVocabularyTermsResponseSuccess

export const getDigitalCatalogControllerListVocabularyTermsUrl = (
  params?: DigitalCatalogControllerListVocabularyTermsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/vocabulary-terms?${stringifiedParams}`
    : `/api-arvore/digital-catalog/vocabulary-terms`
}

export const digitalCatalogControllerListVocabularyTerms = async (
  params?: DigitalCatalogControllerListVocabularyTermsParams,
  options?: RequestInit
): Promise<digitalCatalogControllerListVocabularyTermsResponse> => {
  return customInstance<digitalCatalogControllerListVocabularyTermsResponse>(
    getDigitalCatalogControllerListVocabularyTermsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload a book (with optional audiobook tracks) to the BibliON catalog
 */
export type digitalCatalogControllerUploadBookResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerUploadBookResponse409 = {
  data: void
  status: 409
}

export type digitalCatalogControllerUploadBookResponseSuccess =
  digitalCatalogControllerUploadBookResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerUploadBookResponseError =
  digitalCatalogControllerUploadBookResponse409 & {
    headers: Headers
  }

export type digitalCatalogControllerUploadBookResponse =
  | digitalCatalogControllerUploadBookResponseSuccess
  | digitalCatalogControllerUploadBookResponseError

export const getDigitalCatalogControllerUploadBookUrl = () => {
  return `/api-arvore/digital-catalog/books`
}

export const digitalCatalogControllerUploadBook = async (
  uploadCatalogBookBodyDto: UploadCatalogBookBodyDto,
  options?: RequestInit
): Promise<digitalCatalogControllerUploadBookResponse> => {
  const formData = new FormData()
  formData.append(`title`, uploadCatalogBookBodyDto.title)
  if (uploadCatalogBookBodyDto.subtitle !== undefined) {
    formData.append(`subtitle`, uploadCatalogBookBodyDto.subtitle)
  }
  formData.append(`author`, uploadCatalogBookBodyDto.author)
  formData.append(`isbn`, uploadCatalogBookBodyDto.isbn)
  if (uploadCatalogBookBodyDto.publisher !== undefined) {
    formData.append(`publisher`, uploadCatalogBookBodyDto.publisher)
  }
  if (uploadCatalogBookBodyDto.language !== undefined) {
    formData.append(`language`, uploadCatalogBookBodyDto.language)
  }
  if (uploadCatalogBookBodyDto.edition !== undefined) {
    formData.append(`edition`, uploadCatalogBookBodyDto.edition)
  }
  if (uploadCatalogBookBodyDto.imprint !== undefined) {
    formData.append(`imprint`, uploadCatalogBookBodyDto.imprint)
  }
  if (uploadCatalogBookBodyDto.description !== undefined) {
    formData.append(`description`, uploadCatalogBookBodyDto.description)
  }
  if (uploadCatalogBookBodyDto.minimumAge !== undefined) {
    formData.append(
      `minimumAge`,
      uploadCatalogBookBodyDto.minimumAge.toString()
    )
  }
  if (uploadCatalogBookBodyDto.degree !== undefined) {
    formData.append(`degree`, uploadCatalogBookBodyDto.degree)
  }
  if (uploadCatalogBookBodyDto.audioBookIsbn !== undefined) {
    formData.append(`audioBookIsbn`, uploadCatalogBookBodyDto.audioBookIsbn)
  }
  if (uploadCatalogBookBodyDto.maxSimultaneous !== undefined) {
    formData.append(
      `maxSimultaneous`,
      uploadCatalogBookBodyDto.maxSimultaneous.toString()
    )
  }
  if (uploadCatalogBookBodyDto.modality !== undefined) {
    formData.append(`modality`, uploadCatalogBookBodyDto.modality)
  }
  if (uploadCatalogBookBodyDto.copies !== undefined) {
    formData.append(`copies`, uploadCatalogBookBodyDto.copies.toString())
  }
  if (uploadCatalogBookBodyDto.expiresAt !== undefined) {
    formData.append(`expiresAt`, uploadCatalogBookBodyDto.expiresAt)
  }

  return customInstance<digitalCatalogControllerUploadBookResponse>(
    getDigitalCatalogControllerUploadBookUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary List video catalog items with filters and pagination
 */
export type digitalCatalogControllerListVideosResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerListVideosResponseSuccess =
  digitalCatalogControllerListVideosResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerListVideosResponse =
  digitalCatalogControllerListVideosResponseSuccess

export const getDigitalCatalogControllerListVideosUrl = (
  params?: DigitalCatalogControllerListVideosParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/videos?${stringifiedParams}`
    : `/api-arvore/digital-catalog/videos`
}

export const digitalCatalogControllerListVideos = async (
  params?: DigitalCatalogControllerListVideosParams,
  options?: RequestInit
): Promise<digitalCatalogControllerListVideosResponse> => {
  return customInstance<digitalCatalogControllerListVideosResponse>(
    getDigitalCatalogControllerListVideosUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload a video manually to the BibliON catalog
 */
export type digitalCatalogControllerUploadVideoResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerUploadVideoResponseSuccess =
  digitalCatalogControllerUploadVideoResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerUploadVideoResponse =
  digitalCatalogControllerUploadVideoResponseSuccess

export const getDigitalCatalogControllerUploadVideoUrl = () => {
  return `/api-arvore/digital-catalog/videos`
}

export const digitalCatalogControllerUploadVideo = async (
  uploadCatalogVideoBodyDto: UploadCatalogVideoBodyDto,
  options?: RequestInit
): Promise<digitalCatalogControllerUploadVideoResponse> => {
  const formData = new FormData()
  formData.append(`title`, uploadCatalogVideoBodyDto.title)
  if (uploadCatalogVideoBodyDto.description !== undefined) {
    formData.append(`description`, uploadCatalogVideoBodyDto.description)
  }
  if (uploadCatalogVideoBodyDto.author !== undefined) {
    formData.append(`author`, uploadCatalogVideoBodyDto.author)
  }
  if (uploadCatalogVideoBodyDto.degree !== undefined) {
    formData.append(`degree`, uploadCatalogVideoBodyDto.degree)
  }
  if (uploadCatalogVideoBodyDto.maxSimultaneous !== undefined) {
    formData.append(
      `maxSimultaneous`,
      uploadCatalogVideoBodyDto.maxSimultaneous.toString()
    )
  }

  return customInstance<digitalCatalogControllerUploadVideoResponse>(
    getDigitalCatalogControllerUploadVideoUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary List podcast catalog items with filters and pagination
 */
export type digitalCatalogControllerListPodcastsResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerListPodcastsResponseSuccess =
  digitalCatalogControllerListPodcastsResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerListPodcastsResponse =
  digitalCatalogControllerListPodcastsResponseSuccess

export const getDigitalCatalogControllerListPodcastsUrl = (
  params?: DigitalCatalogControllerListPodcastsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/digital-catalog/podcasts?${stringifiedParams}`
    : `/api-arvore/digital-catalog/podcasts`
}

export const digitalCatalogControllerListPodcasts = async (
  params?: DigitalCatalogControllerListPodcastsParams,
  options?: RequestInit
): Promise<digitalCatalogControllerListPodcastsResponse> => {
  return customInstance<digitalCatalogControllerListPodcastsResponse>(
    getDigitalCatalogControllerListPodcastsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload a podcast (show with episodes) manually to the BibliON catalog
 */
export type digitalCatalogControllerUploadPodcastResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerUploadPodcastResponseSuccess =
  digitalCatalogControllerUploadPodcastResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerUploadPodcastResponse =
  digitalCatalogControllerUploadPodcastResponseSuccess

export const getDigitalCatalogControllerUploadPodcastUrl = () => {
  return `/api-arvore/digital-catalog/podcasts`
}

export const digitalCatalogControllerUploadPodcast = async (
  uploadCatalogPodcastBodyDto: UploadCatalogPodcastBodyDto,
  options?: RequestInit
): Promise<digitalCatalogControllerUploadPodcastResponse> => {
  const formData = new FormData()
  formData.append(`title`, uploadCatalogPodcastBodyDto.title)
  if (uploadCatalogPodcastBodyDto.description !== undefined) {
    formData.append(`description`, uploadCatalogPodcastBodyDto.description)
  }
  if (uploadCatalogPodcastBodyDto.author !== undefined) {
    formData.append(`author`, uploadCatalogPodcastBodyDto.author)
  }
  if (uploadCatalogPodcastBodyDto.language !== undefined) {
    formData.append(`language`, uploadCatalogPodcastBodyDto.language)
  }
  if (uploadCatalogPodcastBodyDto.degree !== undefined) {
    formData.append(`degree`, uploadCatalogPodcastBodyDto.degree)
  }
  if (uploadCatalogPodcastBodyDto.maxSimultaneous !== undefined) {
    formData.append(
      `maxSimultaneous`,
      uploadCatalogPodcastBodyDto.maxSimultaneous.toString()
    )
  }
  uploadCatalogPodcastBodyDto.episodeTitles.forEach(value =>
    formData.append(`episodeTitles`, value)
  )

  return customInstance<digitalCatalogControllerUploadPodcastResponse>(
    getDigitalCatalogControllerUploadPodcastUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Get the shared marketplace cart for the entity
 */
export type digitalCatalogControllerCartResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerCartResponseSuccess =
  digitalCatalogControllerCartResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerCartResponse =
  digitalCatalogControllerCartResponseSuccess

export const getDigitalCatalogControllerCartUrl = () => {
  return `/api-arvore/digital-catalog/marketplace/cart`
}

export const digitalCatalogControllerCart = async (
  options?: RequestInit
): Promise<digitalCatalogControllerCartResponse> => {
  return customInstance<digitalCatalogControllerCartResponse>(
    getDigitalCatalogControllerCartUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Add or update a book in the shared marketplace cart
 */
export type digitalCatalogControllerAddToCartResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerAddToCartResponse404 = {
  data: void
  status: 404
}

export type digitalCatalogControllerAddToCartResponse409 = {
  data: void
  status: 409
}

export type digitalCatalogControllerAddToCartResponseSuccess =
  digitalCatalogControllerAddToCartResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerAddToCartResponseError = (
  | digitalCatalogControllerAddToCartResponse404
  | digitalCatalogControllerAddToCartResponse409
) & {
  headers: Headers
}

export type digitalCatalogControllerAddToCartResponse =
  | digitalCatalogControllerAddToCartResponseSuccess
  | digitalCatalogControllerAddToCartResponseError

export const getDigitalCatalogControllerAddToCartUrl = (bookId: number) => {
  return `/api-arvore/digital-catalog/marketplace/cart/${bookId}`
}

export const digitalCatalogControllerAddToCart = async (
  bookId: number,
  upsertCartItemBodyDto: UpsertCartItemBodyDto,
  options?: RequestInit
): Promise<digitalCatalogControllerAddToCartResponse> => {
  return customInstance<digitalCatalogControllerAddToCartResponse>(
    getDigitalCatalogControllerAddToCartUrl(bookId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertCartItemBodyDto)
    }
  )
}

/**
 * @summary Remove a book from the shared marketplace cart
 */
export type digitalCatalogControllerRemoveFromCartResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerRemoveFromCartResponseSuccess =
  digitalCatalogControllerRemoveFromCartResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerRemoveFromCartResponse =
  digitalCatalogControllerRemoveFromCartResponseSuccess

export const getDigitalCatalogControllerRemoveFromCartUrl = (
  bookId: number
) => {
  return `/api-arvore/digital-catalog/marketplace/cart/${bookId}`
}

export const digitalCatalogControllerRemoveFromCart = async (
  bookId: number,
  options?: RequestInit
): Promise<digitalCatalogControllerRemoveFromCartResponse> => {
  return customInstance<digitalCatalogControllerRemoveFromCartResponse>(
    getDigitalCatalogControllerRemoveFromCartUrl(bookId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Checkout the shared marketplace cart
 */
export type digitalCatalogControllerCheckoutResponse201 = {
  data: void
  status: 201
}

export type digitalCatalogControllerCheckoutResponse400 = {
  data: void
  status: 400
}

export type digitalCatalogControllerCheckoutResponseSuccess =
  digitalCatalogControllerCheckoutResponse201 & {
    headers: Headers
  }
export type digitalCatalogControllerCheckoutResponseError =
  digitalCatalogControllerCheckoutResponse400 & {
    headers: Headers
  }

export type digitalCatalogControllerCheckoutResponse =
  | digitalCatalogControllerCheckoutResponseSuccess
  | digitalCatalogControllerCheckoutResponseError

export const getDigitalCatalogControllerCheckoutUrl = () => {
  return `/api-arvore/digital-catalog/marketplace/checkout`
}

export const digitalCatalogControllerCheckout = async (
  options?: RequestInit
): Promise<digitalCatalogControllerCheckoutResponse> => {
  return customInstance<digitalCatalogControllerCheckoutResponse>(
    getDigitalCatalogControllerCheckoutUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List marketplace purchase history for the entity
 */
export type digitalCatalogControllerPurchaseHistoryResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerPurchaseHistoryResponseSuccess =
  digitalCatalogControllerPurchaseHistoryResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerPurchaseHistoryResponse =
  digitalCatalogControllerPurchaseHistoryResponseSuccess

export const getDigitalCatalogControllerPurchaseHistoryUrl = () => {
  return `/api-arvore/digital-catalog/marketplace/purchases`
}

export const digitalCatalogControllerPurchaseHistory = async (
  options?: RequestInit
): Promise<digitalCatalogControllerPurchaseHistoryResponse> => {
  return customInstance<digitalCatalogControllerPurchaseHistoryResponse>(
    getDigitalCatalogControllerPurchaseHistoryUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Export BibliON-owned catalog books (origin manual) as a MARC21 binary file
 */
export type digitalCatalogControllerExportMarc21Response200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerExportMarc21ResponseSuccess =
  digitalCatalogControllerExportMarc21Response200 & {
    headers: Headers
  }
export type digitalCatalogControllerExportMarc21Response =
  digitalCatalogControllerExportMarc21ResponseSuccess

export const getDigitalCatalogControllerExportMarc21Url = () => {
  return `/api-arvore/digital-catalog/export/marc21`
}

export const digitalCatalogControllerExportMarc21 = async (
  options?: RequestInit
): Promise<digitalCatalogControllerExportMarc21Response> => {
  return customInstance<digitalCatalogControllerExportMarc21Response>(
    getDigitalCatalogControllerExportMarc21Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get loan status for a catalog book, including renewal status for marketplace items
 */
export type digitalCatalogControllerLoansStatusResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerLoansStatusResponse404 = {
  data: void
  status: 404
}

export type digitalCatalogControllerLoansStatusResponseSuccess =
  digitalCatalogControllerLoansStatusResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerLoansStatusResponseError =
  digitalCatalogControllerLoansStatusResponse404 & {
    headers: Headers
  }

export type digitalCatalogControllerLoansStatusResponse =
  | digitalCatalogControllerLoansStatusResponseSuccess
  | digitalCatalogControllerLoansStatusResponseError

export const getDigitalCatalogControllerLoansStatusUrl = (bookId: number) => {
  return `/api-arvore/digital-catalog/${bookId}/loans`
}

export const digitalCatalogControllerLoansStatus = async (
  bookId: number,
  options?: RequestInit
): Promise<digitalCatalogControllerLoansStatusResponse> => {
  return customInstance<digitalCatalogControllerLoansStatusResponse>(
    getDigitalCatalogControllerLoansStatusUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update catalog item settings such as max simultaneous accesses
 */
export type digitalCatalogControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerUpdateResponse404 = {
  data: void
  status: 404
}

export type digitalCatalogControllerUpdateResponseSuccess =
  digitalCatalogControllerUpdateResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerUpdateResponseError =
  digitalCatalogControllerUpdateResponse404 & {
    headers: Headers
  }

export type digitalCatalogControllerUpdateResponse =
  | digitalCatalogControllerUpdateResponseSuccess
  | digitalCatalogControllerUpdateResponseError

export const getDigitalCatalogControllerUpdateUrl = (bookId: number) => {
  return `/api-arvore/digital-catalog/${bookId}`
}

export const digitalCatalogControllerUpdate = async (
  bookId: number,
  updateDigitalCatalogItemBodyDto: UpdateDigitalCatalogItemBodyDto,
  options?: RequestInit
): Promise<digitalCatalogControllerUpdateResponse> => {
  return customInstance<digitalCatalogControllerUpdateResponse>(
    getDigitalCatalogControllerUpdateUrl(bookId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateDigitalCatalogItemBodyDto)
    }
  )
}

/**
 * @summary Get digital catalog item detail by book ID
 */
export type digitalCatalogControllerDetailResponse200 = {
  data: void
  status: 200
}

export type digitalCatalogControllerDetailResponseSuccess =
  digitalCatalogControllerDetailResponse200 & {
    headers: Headers
  }
export type digitalCatalogControllerDetailResponse =
  digitalCatalogControllerDetailResponseSuccess

export const getDigitalCatalogControllerDetailUrl = (bookId: number) => {
  return `/api-arvore/digital-catalog/${bookId}`
}

export const digitalCatalogControllerDetail = async (
  bookId: number,
  options?: RequestInit
): Promise<digitalCatalogControllerDetailResponse> => {
  return customInstance<digitalCatalogControllerDetailResponse>(
    getDigitalCatalogControllerDetailUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get license alert preferences for a root
 */
export type licenseAlertsControllerGetResponse200 = {
  data: void
  status: 200
}

export type licenseAlertsControllerGetResponseSuccess =
  licenseAlertsControllerGetResponse200 & {
    headers: Headers
  }
export type licenseAlertsControllerGetResponse =
  licenseAlertsControllerGetResponseSuccess

export const getLicenseAlertsControllerGetUrl = (rootId: number) => {
  return `/api-arvore/license-alerts/preferences/${rootId}`
}

export const licenseAlertsControllerGet = async (
  rootId: number,
  options?: RequestInit
): Promise<licenseAlertsControllerGetResponse> => {
  return customInstance<licenseAlertsControllerGetResponse>(
    getLicenseAlertsControllerGetUrl(rootId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create or update license alert preferences for a root
 */
export type licenseAlertsControllerUpsertResponse200 = {
  data: void
  status: 200
}

export type licenseAlertsControllerUpsertResponseSuccess =
  licenseAlertsControllerUpsertResponse200 & {
    headers: Headers
  }
export type licenseAlertsControllerUpsertResponse =
  licenseAlertsControllerUpsertResponseSuccess

export const getLicenseAlertsControllerUpsertUrl = (rootId: number) => {
  return `/api-arvore/license-alerts/preferences/${rootId}`
}

export const licenseAlertsControllerUpsert = async (
  rootId: number,
  upsertLicenseAlertPreferencesDto: UpsertLicenseAlertPreferencesDto,
  options?: RequestInit
): Promise<licenseAlertsControllerUpsertResponse> => {
  return customInstance<licenseAlertsControllerUpsertResponse>(
    getLicenseAlertsControllerUpsertUrl(rootId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertLicenseAlertPreferencesDto)
    }
  )
}

/**
 * @summary Submit campanha fluência lead
 */
export type campanhaFluenciaControllerCreateLeadResponse201 = {
  data: void
  status: 201
}

export type campanhaFluenciaControllerCreateLeadResponseSuccess =
  campanhaFluenciaControllerCreateLeadResponse201 & {
    headers: Headers
  }
export type campanhaFluenciaControllerCreateLeadResponse =
  campanhaFluenciaControllerCreateLeadResponseSuccess

export const getCampanhaFluenciaControllerCreateLeadUrl = () => {
  return `/api-arvore/campanha-fluencia/leads`
}

export const campanhaFluenciaControllerCreateLead = async (
  createCampanhaFluenciaLeadBodyDto: CreateCampanhaFluenciaLeadBodyDto,
  options?: RequestInit
): Promise<campanhaFluenciaControllerCreateLeadResponse> => {
  return customInstance<campanhaFluenciaControllerCreateLeadResponse>(
    getCampanhaFluenciaControllerCreateLeadUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createCampanhaFluenciaLeadBodyDto)
    }
  )
}

/**
 * @summary Upload demo audio for pronunciation assessment
 */
export type campanhaFluenciaControllerUploadDemoAudioResponse201 = {
  data: void
  status: 201
}

export type campanhaFluenciaControllerUploadDemoAudioResponseSuccess =
  campanhaFluenciaControllerUploadDemoAudioResponse201 & {
    headers: Headers
  }
export type campanhaFluenciaControllerUploadDemoAudioResponse =
  campanhaFluenciaControllerUploadDemoAudioResponseSuccess

export const getCampanhaFluenciaControllerUploadDemoAudioUrl = () => {
  return `/api-arvore/campanha-fluencia/demo/audio`
}

export const campanhaFluenciaControllerUploadDemoAudio = async (
  campanhaFluenciaControllerUploadDemoAudioBody: CampanhaFluenciaControllerUploadDemoAudioBody,
  options?: RequestInit
): Promise<campanhaFluenciaControllerUploadDemoAudioResponse> => {
  const formData = new FormData()
  if (campanhaFluenciaControllerUploadDemoAudioBody.file !== undefined) {
    formData.append(`file`, campanhaFluenciaControllerUploadDemoAudioBody.file)
  }
  if (
    campanhaFluenciaControllerUploadDemoAudioBody.referenceText !== undefined
  ) {
    formData.append(
      `referenceText`,
      campanhaFluenciaControllerUploadDemoAudioBody.referenceText
    )
  }
  if (campanhaFluenciaControllerUploadDemoAudioBody.duration !== undefined) {
    formData.append(
      `duration`,
      campanhaFluenciaControllerUploadDemoAudioBody.duration.toString()
    )
  }

  return customInstance<campanhaFluenciaControllerUploadDemoAudioResponse>(
    getCampanhaFluenciaControllerUploadDemoAudioUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Get demo audio assessment result
 */
export type campanhaFluenciaControllerGetDemoResultResponse200 = {
  data: void
  status: 200
}

export type campanhaFluenciaControllerGetDemoResultResponse404 = {
  data: void
  status: 404
}

export type campanhaFluenciaControllerGetDemoResultResponseSuccess =
  campanhaFluenciaControllerGetDemoResultResponse200 & {
    headers: Headers
  }
export type campanhaFluenciaControllerGetDemoResultResponseError =
  campanhaFluenciaControllerGetDemoResultResponse404 & {
    headers: Headers
  }

export type campanhaFluenciaControllerGetDemoResultResponse =
  | campanhaFluenciaControllerGetDemoResultResponseSuccess
  | campanhaFluenciaControllerGetDemoResultResponseError

export const getCampanhaFluenciaControllerGetDemoResultUrl = (
  demoId: string
) => {
  return `/api-arvore/campanha-fluencia/demo/audio/${demoId}`
}

export const campanhaFluenciaControllerGetDemoResult = async (
  demoId: string,
  options?: RequestInit
): Promise<campanhaFluenciaControllerGetDemoResultResponse> => {
  return customInstance<campanhaFluenciaControllerGetDemoResultResponse>(
    getCampanhaFluenciaControllerGetDemoResultUrl(demoId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search book by ISBN or slug
 */
export type bookFileReplacementControllerSearchResponse200 = {
  data: void
  status: 200
}

export type bookFileReplacementControllerSearchResponseSuccess =
  bookFileReplacementControllerSearchResponse200 & {
    headers: Headers
  }
export type bookFileReplacementControllerSearchResponse =
  bookFileReplacementControllerSearchResponseSuccess

export const getBookFileReplacementControllerSearchUrl = (
  params: BookFileReplacementControllerSearchParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/book-file-replacement/search?${stringifiedParams}`
    : `/api-arvore/backoffice/book-file-replacement/search`
}

export const bookFileReplacementControllerSearch = async (
  params: BookFileReplacementControllerSearchParams,
  options?: RequestInit
): Promise<bookFileReplacementControllerSearchResponse> => {
  return customInstance<bookFileReplacementControllerSearchResponse>(
    getBookFileReplacementControllerSearchUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Generate presigned URL to overwrite existing book file in S3
 */
export type bookFileReplacementControllerGenerateUploadUrlResponse201 = {
  data: void
  status: 201
}

export type bookFileReplacementControllerGenerateUploadUrlResponseSuccess =
  bookFileReplacementControllerGenerateUploadUrlResponse201 & {
    headers: Headers
  }
export type bookFileReplacementControllerGenerateUploadUrlResponse =
  bookFileReplacementControllerGenerateUploadUrlResponseSuccess

export const getBookFileReplacementControllerGenerateUploadUrlUrl = () => {
  return `/api-arvore/backoffice/book-file-replacement/upload-url`
}

export const bookFileReplacementControllerGenerateUploadUrl = async (
  generateBookUploadUrlDto: GenerateBookUploadUrlDto,
  options?: RequestInit
): Promise<bookFileReplacementControllerGenerateUploadUrlResponse> => {
  return customInstance<bookFileReplacementControllerGenerateUploadUrlResponse>(
    getBookFileReplacementControllerGenerateUploadUrlUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateBookUploadUrlDto)
    }
  )
}

/**
 * @summary Reprocess a single book by ISBN
 */
export type bookReprocessingControllerProcessSingleResponse201 = {
  data: void
  status: 201
}

export type bookReprocessingControllerProcessSingleResponseSuccess =
  bookReprocessingControllerProcessSingleResponse201 & {
    headers: Headers
  }
export type bookReprocessingControllerProcessSingleResponse =
  bookReprocessingControllerProcessSingleResponseSuccess

export const getBookReprocessingControllerProcessSingleUrl = () => {
  return `/api-arvore/backoffice/book-reprocessing/process`
}

export const bookReprocessingControllerProcessSingle = async (
  processBookDto: ProcessBookDto,
  options?: RequestInit
): Promise<bookReprocessingControllerProcessSingleResponse> => {
  return customInstance<bookReprocessingControllerProcessSingleResponse>(
    getBookReprocessingControllerProcessSingleUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(processBookDto)
    }
  )
}

/**
 * @summary Reprocess multiple books by ISBN list
 */
export type bookReprocessingControllerProcessBatchResponse201 = {
  data: void
  status: 201
}

export type bookReprocessingControllerProcessBatchResponseSuccess =
  bookReprocessingControllerProcessBatchResponse201 & {
    headers: Headers
  }
export type bookReprocessingControllerProcessBatchResponse =
  bookReprocessingControllerProcessBatchResponseSuccess

export const getBookReprocessingControllerProcessBatchUrl = () => {
  return `/api-arvore/backoffice/book-reprocessing/process-batch`
}

export const bookReprocessingControllerProcessBatch = async (
  processBookBatchDto: ProcessBookBatchDto,
  options?: RequestInit
): Promise<bookReprocessingControllerProcessBatchResponse> => {
  return customInstance<bookReprocessingControllerProcessBatchResponse>(
    getBookReprocessingControllerProcessBatchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(processBookBatchDto)
    }
  )
}

/**
 * Creates a book-request record from a logged-in reader. Triggered by the empty-state of the catalog search when no results are found.
 * @summary Submit a book request
 */
export type bookRequestsControllerCreateResponse201 = {
  data: BookRequestResponseDto
  status: 201
}

export type bookRequestsControllerCreateResponseSuccess =
  bookRequestsControllerCreateResponse201 & {
    headers: Headers
  }
export type bookRequestsControllerCreateResponse =
  bookRequestsControllerCreateResponseSuccess

export const getBookRequestsControllerCreateUrl = () => {
  return `/api-arvore/v1/reader/book-requests`
}

export const bookRequestsControllerCreate = async (
  createBookRequestDto: CreateBookRequestDto,
  options?: RequestInit
): Promise<bookRequestsControllerCreateResponse> => {
  return customInstance<bookRequestsControllerCreateResponse>(
    getBookRequestsControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createBookRequestDto)
    }
  )
}

/**
 * Behavioral parity with the Elixir resolver. Used behind `book_search_via_nestjs` LaunchDarkly flag.
 * @summary Search books (NestJS port of GraphQL searchBookV3)
 */
export type bookSearchControllerSearchResponse200 = {
  data: BookSearchResponseDto
  status: 200
}

export type bookSearchControllerSearchResponseSuccess =
  bookSearchControllerSearchResponse200 & {
    headers: Headers
  }
export type bookSearchControllerSearchResponse =
  bookSearchControllerSearchResponseSuccess

export const getBookSearchControllerSearchUrl = () => {
  return `/api-arvore/book-search`
}

export const bookSearchControllerSearch = async (
  bookSearchRequestDto: BookSearchRequestDto,
  options?: RequestInit
): Promise<bookSearchControllerSearchResponse> => {
  return customInstance<bookSearchControllerSearchResponse>(
    getBookSearchControllerSearchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(bookSearchRequestDto)
    }
  )
}

/**
 * @summary List all collections
 */
export type collectionRemovalControllerListCollectionsResponse200 = {
  data: void
  status: 200
}

export type collectionRemovalControllerListCollectionsResponseSuccess =
  collectionRemovalControllerListCollectionsResponse200 & {
    headers: Headers
  }
export type collectionRemovalControllerListCollectionsResponse =
  collectionRemovalControllerListCollectionsResponseSuccess

export const getCollectionRemovalControllerListCollectionsUrl = () => {
  return `/api-arvore/backoffice/collection-removal/collections`
}

export const collectionRemovalControllerListCollections = async (
  options?: RequestInit
): Promise<collectionRemovalControllerListCollectionsResponse> => {
  return customInstance<collectionRemovalControllerListCollectionsResponse>(
    getCollectionRemovalControllerListCollectionsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List books by IDs or slugs
 */
export type collectionRemovalControllerListBooksResponse201 = {
  data: void
  status: 201
}

export type collectionRemovalControllerListBooksResponseSuccess =
  collectionRemovalControllerListBooksResponse201 & {
    headers: Headers
  }
export type collectionRemovalControllerListBooksResponse =
  collectionRemovalControllerListBooksResponseSuccess

export const getCollectionRemovalControllerListBooksUrl = () => {
  return `/api-arvore/backoffice/collection-removal/list-books`
}

export const collectionRemovalControllerListBooks = async (
  listBooksByIdentifiersDto: ListBooksByIdentifiersDto,
  options?: RequestInit
): Promise<collectionRemovalControllerListBooksResponse> => {
  return customInstance<collectionRemovalControllerListBooksResponse>(
    getCollectionRemovalControllerListBooksUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(listBooksByIdentifiersDto)
    }
  )
}

/**
 * @summary Add books to collections
 */
export type collectionRemovalControllerAddBooksResponse201 = {
  data: void
  status: 201
}

export type collectionRemovalControllerAddBooksResponseSuccess =
  collectionRemovalControllerAddBooksResponse201 & {
    headers: Headers
  }
export type collectionRemovalControllerAddBooksResponse =
  collectionRemovalControllerAddBooksResponseSuccess

export const getCollectionRemovalControllerAddBooksUrl = () => {
  return `/api-arvore/backoffice/collection-removal/add-books`
}

export const collectionRemovalControllerAddBooks = async (
  addBooksToCollectionDto: AddBooksToCollectionDto,
  options?: RequestInit
): Promise<collectionRemovalControllerAddBooksResponse> => {
  return customInstance<collectionRemovalControllerAddBooksResponse>(
    getCollectionRemovalControllerAddBooksUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(addBooksToCollectionDto)
    }
  )
}

/**
 * @summary Remove books from collections
 */
export type collectionRemovalControllerRemoveBooksResponse201 = {
  data: void
  status: 201
}

export type collectionRemovalControllerRemoveBooksResponseSuccess =
  collectionRemovalControllerRemoveBooksResponse201 & {
    headers: Headers
  }
export type collectionRemovalControllerRemoveBooksResponse =
  collectionRemovalControllerRemoveBooksResponseSuccess

export const getCollectionRemovalControllerRemoveBooksUrl = () => {
  return `/api-arvore/backoffice/collection-removal/remove-books`
}

export const collectionRemovalControllerRemoveBooks = async (
  removeBooksFromCollectionDto: RemoveBooksFromCollectionDto,
  options?: RequestInit
): Promise<collectionRemovalControllerRemoveBooksResponse> => {
  return customInstance<collectionRemovalControllerRemoveBooksResponse>(
    getCollectionRemovalControllerRemoveBooksUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(removeBooksFromCollectionDto)
    }
  )
}

/**
 * @summary Get most borrowed catalog items (books, podcasts and videos) for the BibliON home
 */
export type booksControllerGetMostBorrowedResponse200 = {
  data: MostBorrowedShelfResponseDto
  status: 200
}

export type booksControllerGetMostBorrowedResponseSuccess =
  booksControllerGetMostBorrowedResponse200 & {
    headers: Headers
  }
export type booksControllerGetMostBorrowedResponse =
  booksControllerGetMostBorrowedResponseSuccess

export const getBooksControllerGetMostBorrowedUrl = (
  params: BooksControllerGetMostBorrowedParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/books/most-borrowed?${stringifiedParams}`
    : `/api-arvore/books/most-borrowed`
}

export const booksControllerGetMostBorrowed = async (
  params: BooksControllerGetMostBorrowedParams,
  options?: RequestInit
): Promise<booksControllerGetMostBorrowedResponse> => {
  return customInstance<booksControllerGetMostBorrowedResponse>(
    getBooksControllerGetMostBorrowedUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book details by slug
 */
export type booksControllerGetDetailsResponse200 = {
  data: void
  status: 200
}

export type booksControllerGetDetailsResponse404 = {
  data: void
  status: 404
}

export type booksControllerGetDetailsResponseSuccess =
  booksControllerGetDetailsResponse200 & {
    headers: Headers
  }
export type booksControllerGetDetailsResponseError =
  booksControllerGetDetailsResponse404 & {
    headers: Headers
  }

export type booksControllerGetDetailsResponse =
  | booksControllerGetDetailsResponseSuccess
  | booksControllerGetDetailsResponseError

export const getBooksControllerGetDetailsUrl = (slug: string) => {
  return `/api-arvore/books/${slug}/details`
}

export const booksControllerGetDetails = async (
  slug: string,
  options?: RequestInit
): Promise<booksControllerGetDetailsResponse> => {
  return customInstance<booksControllerGetDetailsResponse>(
    getBooksControllerGetDetailsUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book recommendations (same series, related, same author)
 */
export type booksControllerGetBookRecommendationsEndpointResponse200 = {
  data: void
  status: 200
}

export type booksControllerGetBookRecommendationsEndpointResponse404 = {
  data: void
  status: 404
}

export type booksControllerGetBookRecommendationsEndpointResponseSuccess =
  booksControllerGetBookRecommendationsEndpointResponse200 & {
    headers: Headers
  }
export type booksControllerGetBookRecommendationsEndpointResponseError =
  booksControllerGetBookRecommendationsEndpointResponse404 & {
    headers: Headers
  }

export type booksControllerGetBookRecommendationsEndpointResponse =
  | booksControllerGetBookRecommendationsEndpointResponseSuccess
  | booksControllerGetBookRecommendationsEndpointResponseError

export const getBooksControllerGetBookRecommendationsEndpointUrl = (
  slug: string
) => {
  return `/api-arvore/books/${slug}/recommendations`
}

export const booksControllerGetBookRecommendationsEndpoint = async (
  slug: string,
  options?: RequestInit
): Promise<booksControllerGetBookRecommendationsEndpointResponse> => {
  return customInstance<booksControllerGetBookRecommendationsEndpointResponse>(
    getBooksControllerGetBookRecommendationsEndpointUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Indicate a book to students or classes
 */
export type booksControllerIndicateResponse201 = {
  data: void
  status: 201
}

export type booksControllerIndicateResponse400 = {
  data: void
  status: 400
}

export type booksControllerIndicateResponse403 = {
  data: void
  status: 403
}

export type booksControllerIndicateResponse404 = {
  data: void
  status: 404
}

export type booksControllerIndicateResponseSuccess =
  booksControllerIndicateResponse201 & {
    headers: Headers
  }
export type booksControllerIndicateResponseError = (
  | booksControllerIndicateResponse400
  | booksControllerIndicateResponse403
  | booksControllerIndicateResponse404
) & {
  headers: Headers
}

export type booksControllerIndicateResponse =
  | booksControllerIndicateResponseSuccess
  | booksControllerIndicateResponseError

export const getBooksControllerIndicateUrl = () => {
  return `/api-arvore/books/indicate`
}

export const booksControllerIndicate = async (
  createBookIndicationDto: CreateBookIndicationDto,
  options?: RequestInit
): Promise<booksControllerIndicateResponse> => {
  return customInstance<booksControllerIndicateResponse>(
    getBooksControllerIndicateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createBookIndicationDto)
    }
  )
}

/**
 * Retorna livros similares aos temas selecionados, filtrados pelo acervo disponível da entidade
 * @summary Obter recomendações de livros para onboarding
 */
export type booksControllerGetOnboardingRecommendationsEndpointResponse200 = {
  data: OnboardingRecommendationsResponseDto
  status: 200
}

export type booksControllerGetOnboardingRecommendationsEndpointResponse400 = {
  data: void
  status: 400
}

export type booksControllerGetOnboardingRecommendationsEndpointResponse404 = {
  data: void
  status: 404
}

export type booksControllerGetOnboardingRecommendationsEndpointResponseSuccess =
  booksControllerGetOnboardingRecommendationsEndpointResponse200 & {
    headers: Headers
  }
export type booksControllerGetOnboardingRecommendationsEndpointResponseError = (
  | booksControllerGetOnboardingRecommendationsEndpointResponse400
  | booksControllerGetOnboardingRecommendationsEndpointResponse404
) & {
  headers: Headers
}

export type booksControllerGetOnboardingRecommendationsEndpointResponse =
  | booksControllerGetOnboardingRecommendationsEndpointResponseSuccess
  | booksControllerGetOnboardingRecommendationsEndpointResponseError

export const getBooksControllerGetOnboardingRecommendationsEndpointUrl = () => {
  return `/api-arvore/books/onboarding-recommendations`
}

export const booksControllerGetOnboardingRecommendationsEndpoint = async (
  getOnboardingRecommendationsDto: GetOnboardingRecommendationsDto,
  options?: RequestInit
): Promise<booksControllerGetOnboardingRecommendationsEndpointResponse> => {
  return customInstance<booksControllerGetOnboardingRecommendationsEndpointResponse>(
    getBooksControllerGetOnboardingRecommendationsEndpointUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(getOnboardingRecommendationsDto)
    }
  )
}

/**
 * Registra se o usuário gostou (like) ou não gostou (dislike) de um livro durante o onboarding
 * @summary Salvar reação do usuário a um livro
 */
export type booksControllerSaveBookReactionEndpointResponse204 = {
  data: void
  status: 204
}

export type booksControllerSaveBookReactionEndpointResponse400 = {
  data: void
  status: 400
}

export type booksControllerSaveBookReactionEndpointResponseSuccess =
  booksControllerSaveBookReactionEndpointResponse204 & {
    headers: Headers
  }
export type booksControllerSaveBookReactionEndpointResponseError =
  booksControllerSaveBookReactionEndpointResponse400 & {
    headers: Headers
  }

export type booksControllerSaveBookReactionEndpointResponse =
  | booksControllerSaveBookReactionEndpointResponseSuccess
  | booksControllerSaveBookReactionEndpointResponseError

export const getBooksControllerSaveBookReactionEndpointUrl = () => {
  return `/api-arvore/books/reactions`
}

export const booksControllerSaveBookReactionEndpoint = async (
  saveBookReactionDto: SaveBookReactionDto,
  options?: RequestInit
): Promise<booksControllerSaveBookReactionEndpointResponse> => {
  return customInstance<booksControllerSaveBookReactionEndpointResponse>(
    getBooksControllerSaveBookReactionEndpointUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saveBookReactionDto)
    }
  )
}

/**
 * Retorna livros similares aos temas previamente selecionados durante o onboarding
 * @summary Obter recomendações baseadas em themes salvos
 */
export type booksControllerGetRecommendationsResponse200 = {
  data: OnboardingRecommendationsResponseDto
  status: 200
}

export type booksControllerGetRecommendationsResponse400 = {
  data: void
  status: 400
}

export type booksControllerGetRecommendationsResponseSuccess =
  booksControllerGetRecommendationsResponse200 & {
    headers: Headers
  }
export type booksControllerGetRecommendationsResponseError =
  booksControllerGetRecommendationsResponse400 & {
    headers: Headers
  }

export type booksControllerGetRecommendationsResponse =
  | booksControllerGetRecommendationsResponseSuccess
  | booksControllerGetRecommendationsResponseError

export const getBooksControllerGetRecommendationsUrl = (
  params?: BooksControllerGetRecommendationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/books/recommendations?${stringifiedParams}`
    : `/api-arvore/books/recommendations`
}

export const booksControllerGetRecommendations = async (
  params?: BooksControllerGetRecommendationsParams,
  options?: RequestInit
): Promise<booksControllerGetRecommendationsResponse> => {
  return customInstance<booksControllerGetRecommendationsResponse>(
    getBooksControllerGetRecommendationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Porta a query relayPaginatedViewedBooks do Elixir, aplicando scope de acervo, filtros de contrato e status de leitura.
 * @summary Listar viewed_books do leitor com paginação Relay
 */
export type viewedBooksRelayControllerListResponse200 = {
  data: ViewedBooksRelayResponseDto
  status: 200
}

export type viewedBooksRelayControllerListResponseSuccess =
  viewedBooksRelayControllerListResponse200 & {
    headers: Headers
  }
export type viewedBooksRelayControllerListResponse =
  viewedBooksRelayControllerListResponseSuccess

export const getViewedBooksRelayControllerListUrl = (
  params?: ViewedBooksRelayControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/viewed-books-relay?${stringifiedParams}`
    : `/api-arvore/viewed-books-relay`
}

export const viewedBooksRelayControllerList = async (
  params?: ViewedBooksRelayControllerListParams,
  options?: RequestInit
): Promise<viewedBooksRelayControllerListResponse> => {
  return customInstance<viewedBooksRelayControllerListResponse>(
    getViewedBooksRelayControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns reader information for card generation. Allows searching by class (entity_id), school (parent_id) or specific reader (reader_id).
 * @summary Get reader card information
 */
export type cardsControllerGetCardResponse200 = {
  data: GetCardResponseDto[]
  status: 200
}

export type cardsControllerGetCardResponse401 = {
  data: void
  status: 401
}

export type cardsControllerGetCardResponse403 = {
  data: GetCardPermissionErrorDto
  status: 403
}

export type cardsControllerGetCardResponseSuccess =
  cardsControllerGetCardResponse200 & {
    headers: Headers
  }
export type cardsControllerGetCardResponseError = (
  | cardsControllerGetCardResponse401
  | cardsControllerGetCardResponse403
) & {
  headers: Headers
}

export type cardsControllerGetCardResponse =
  | cardsControllerGetCardResponseSuccess
  | cardsControllerGetCardResponseError

export const getCardsControllerGetCardUrl = (
  params?: CardsControllerGetCardParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/api/v3/get_card?${stringifiedParams}`
    : `/api-arvore/api/v3/get_card`
}

export const cardsControllerGetCard = async (
  params?: CardsControllerGetCardParams,
  options?: RequestInit
): Promise<cardsControllerGetCardResponse> => {
  return customInstance<cardsControllerGetCardResponse>(
    getCardsControllerGetCardUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Generates a PDF file with all reader cards for the given entity hierarchy.
 * @summary Generate PDF with reader cards
 */
export type cardsControllerGetCardPdfResponse401 = {
  data: void
  status: 401
}

export type cardsControllerGetCardPdfResponse403 = {
  data: GetCardPermissionErrorDto
  status: 403
}
export type cardsControllerGetCardPdfResponseError = (
  | cardsControllerGetCardPdfResponse401
  | cardsControllerGetCardPdfResponse403
) & {
  headers: Headers
}

export type cardsControllerGetCardPdfResponse =
  cardsControllerGetCardPdfResponseError

export const getCardsControllerGetCardPdfUrl = (
  params?: CardsControllerGetCardPdfParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/api/v3/get_card/pdf?${stringifiedParams}`
    : `/api-arvore/api/v3/get_card/pdf`
}

export const cardsControllerGetCardPdf = async (
  params?: CardsControllerGetCardPdfParams,
  options?: RequestInit
): Promise<cardsControllerGetCardPdfResponse> => {
  return customInstance<cardsControllerGetCardPdfResponse>(
    getCardsControllerGetCardPdfUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get users in a class
 */
export type classesControllerGetClassUsersResponse200 = {
  data: GetClassUsersResponseDto
  status: 200
}

export type classesControllerGetClassUsersResponseSuccess =
  classesControllerGetClassUsersResponse200 & {
    headers: Headers
  }
export type classesControllerGetClassUsersResponse =
  classesControllerGetClassUsersResponseSuccess

export const getClassesControllerGetClassUsersUrl = (classId: number) => {
  return `/api-arvore/classes/${classId}/users`
}

export const classesControllerGetClassUsers = async (
  classId: number,
  options?: RequestInit
): Promise<classesControllerGetClassUsersResponse> => {
  return customInstance<classesControllerGetClassUsersResponse>(
    getClassesControllerGetClassUsersUrl(classId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Retorna os itens da shelf "Que tal continuar sua última leitura?", mesclando livros em leitura, vídeos em progresso e podcasts em progresso ordenados por updated_at desc. Vídeos e podcasts só são incluídos quando os respectivos feature flags estão ativos para o usuário.
 * @summary Listar livros, vídeos e podcasts em progresso do leitor
 */
export type continueReadingControllerListResponse200 = {
  data: ContinueReadingResponseDto
  status: 200
}

export type continueReadingControllerListResponseSuccess =
  continueReadingControllerListResponse200 & {
    headers: Headers
  }
export type continueReadingControllerListResponse =
  continueReadingControllerListResponseSuccess

export const getContinueReadingControllerListUrl = (
  params?: ContinueReadingControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/continue-reading?${stringifiedParams}`
    : `/api-arvore/continue-reading`
}

export const continueReadingControllerList = async (
  params?: ContinueReadingControllerListParams,
  options?: RequestInit
): Promise<continueReadingControllerListResponse> => {
  return customInstance<continueReadingControllerListResponse>(
    getContinueReadingControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Remover vídeo dos recentes
 */
export type continueReadingControllerRemoveVideoResponse204 = {
  data: void
  status: 204
}

export type continueReadingControllerRemoveVideoResponseSuccess =
  continueReadingControllerRemoveVideoResponse204 & {
    headers: Headers
  }
export type continueReadingControllerRemoveVideoResponse =
  continueReadingControllerRemoveVideoResponseSuccess

export const getContinueReadingControllerRemoveVideoUrl = (slug: string) => {
  return `/api-arvore/continue-reading/video/${slug}`
}

export const continueReadingControllerRemoveVideo = async (
  slug: string,
  options?: RequestInit
): Promise<continueReadingControllerRemoveVideoResponse> => {
  return customInstance<continueReadingControllerRemoveVideoResponse>(
    getContinueReadingControllerRemoveVideoUrl(slug),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Remover podcast dos recentes
 */
export type continueReadingControllerRemovePodcastResponse204 = {
  data: void
  status: 204
}

export type continueReadingControllerRemovePodcastResponseSuccess =
  continueReadingControllerRemovePodcastResponse204 & {
    headers: Headers
  }
export type continueReadingControllerRemovePodcastResponse =
  continueReadingControllerRemovePodcastResponseSuccess

export const getContinueReadingControllerRemovePodcastUrl = (slug: string) => {
  return `/api-arvore/continue-reading/podcast/${slug}`
}

export const continueReadingControllerRemovePodcast = async (
  slug: string,
  options?: RequestInit
): Promise<continueReadingControllerRemovePodcastResponse> => {
  return customInstance<continueReadingControllerRemovePodcastResponse>(
    getContinueReadingControllerRemovePodcastUrl(slug),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Executa offboarding de um usuário: move para Ex Galhos e remove is_admin
 */
export type offboardingControllerExecuteResponse200 = {
  data: OffboardUserResponseDto
  status: 200
}

export type offboardingControllerExecuteResponseSuccess =
  offboardingControllerExecuteResponse200 & {
    headers: Headers
  }
export type offboardingControllerExecuteResponse =
  offboardingControllerExecuteResponseSuccess

export const getOffboardingControllerExecuteUrl = () => {
  return `/api-arvore/offboarding/execute`
}

export const offboardingControllerExecute = async (
  offboardUserBodyDto: OffboardUserBodyDto,
  options?: RequestInit
): Promise<offboardingControllerExecuteResponse> => {
  return customInstance<offboardingControllerExecuteResponse>(
    getOffboardingControllerExecuteUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(offboardUserBodyDto)
    }
  )
}

/**
 * @summary List all olympics shelves
 */
export type olympicsShelvesControllerListResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerListResponseSuccess =
  olympicsShelvesControllerListResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerListResponse =
  olympicsShelvesControllerListResponseSuccess

export const getOlympicsShelvesControllerListUrl = () => {
  return `/api-arvore/olympics-shelves`
}

export const olympicsShelvesControllerList = async (
  options?: RequestInit
): Promise<olympicsShelvesControllerListResponse> => {
  return customInstance<olympicsShelvesControllerListResponse>(
    getOlympicsShelvesControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new olympics shelf
 */
export type olympicsShelvesControllerCreateResponse201 = {
  data: void
  status: 201
}

export type olympicsShelvesControllerCreateResponseSuccess =
  olympicsShelvesControllerCreateResponse201 & {
    headers: Headers
  }
export type olympicsShelvesControllerCreateResponse =
  olympicsShelvesControllerCreateResponseSuccess

export const getOlympicsShelvesControllerCreateUrl = () => {
  return `/api-arvore/olympics-shelves`
}

export const olympicsShelvesControllerCreate = async (
  createOlympicsShelfBodyDto: CreateOlympicsShelfBodyDto,
  options?: RequestInit
): Promise<olympicsShelvesControllerCreateResponse> => {
  return customInstance<olympicsShelvesControllerCreateResponse>(
    getOlympicsShelvesControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createOlympicsShelfBodyDto)
    }
  )
}

/**
 * @summary Reorder olympics shelves
 */
export type olympicsShelvesControllerReorderResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerReorderResponseSuccess =
  olympicsShelvesControllerReorderResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerReorderResponse =
  olympicsShelvesControllerReorderResponseSuccess

export const getOlympicsShelvesControllerReorderUrl = () => {
  return `/api-arvore/olympics-shelves/reorder`
}

export const olympicsShelvesControllerReorder = async (
  reorderOlympicsShelvesBodyDto: ReorderOlympicsShelvesBodyDto,
  options?: RequestInit
): Promise<olympicsShelvesControllerReorderResponse> => {
  return customInstance<olympicsShelvesControllerReorderResponse>(
    getOlympicsShelvesControllerReorderUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reorderOlympicsShelvesBodyDto)
    }
  )
}

/**
 * @summary Search books by title/author/slug for olympics shelves
 */
export type olympicsShelvesControllerSearchResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerSearchResponseSuccess =
  olympicsShelvesControllerSearchResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerSearchResponse =
  olympicsShelvesControllerSearchResponseSuccess

export const getOlympicsShelvesControllerSearchUrl = (
  params: OlympicsShelvesControllerSearchParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/olympics-shelves/search-books?${stringifiedParams}`
    : `/api-arvore/olympics-shelves/search-books`
}

export const olympicsShelvesControllerSearch = async (
  params: OlympicsShelvesControllerSearchParams,
  options?: RequestInit
): Promise<olympicsShelvesControllerSearchResponse> => {
  return customInstance<olympicsShelvesControllerSearchResponse>(
    getOlympicsShelvesControllerSearchUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update olympics shelf details
 */
export type olympicsShelvesControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerUpdateResponseSuccess =
  olympicsShelvesControllerUpdateResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerUpdateResponse =
  olympicsShelvesControllerUpdateResponseSuccess

export const getOlympicsShelvesControllerUpdateUrl = (id: number) => {
  return `/api-arvore/olympics-shelves/${id}`
}

export const olympicsShelvesControllerUpdate = async (
  id: number,
  updateOlympicsShelfBodyDto: UpdateOlympicsShelfBodyDto,
  options?: RequestInit
): Promise<olympicsShelvesControllerUpdateResponse> => {
  return customInstance<olympicsShelvesControllerUpdateResponse>(
    getOlympicsShelvesControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateOlympicsShelfBodyDto)
    }
  )
}

/**
 * @summary Delete an olympics shelf
 */
export type olympicsShelvesControllerDeleteResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerDeleteResponseSuccess =
  olympicsShelvesControllerDeleteResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerDeleteResponse =
  olympicsShelvesControllerDeleteResponseSuccess

export const getOlympicsShelvesControllerDeleteUrl = (id: number) => {
  return `/api-arvore/olympics-shelves/${id}`
}

export const olympicsShelvesControllerDelete = async (
  id: number,
  options?: RequestInit
): Promise<olympicsShelvesControllerDeleteResponse> => {
  return customInstance<olympicsShelvesControllerDeleteResponse>(
    getOlympicsShelvesControllerDeleteUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Toggle olympics shelf enabled status
 */
export type olympicsShelvesControllerToggleResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerToggleResponseSuccess =
  olympicsShelvesControllerToggleResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerToggleResponse =
  olympicsShelvesControllerToggleResponseSuccess

export const getOlympicsShelvesControllerToggleUrl = (id: number) => {
  return `/api-arvore/olympics-shelves/${id}/toggle`
}

export const olympicsShelvesControllerToggle = async (
  id: number,
  toggleOlympicsShelfBodyDto: ToggleOlympicsShelfBodyDto,
  options?: RequestInit
): Promise<olympicsShelvesControllerToggleResponse> => {
  return customInstance<olympicsShelvesControllerToggleResponse>(
    getOlympicsShelvesControllerToggleUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleOlympicsShelfBodyDto)
    }
  )
}

/**
 * @summary Get olympics shelf books
 */
export type olympicsShelvesControllerGetBooksResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerGetBooksResponseSuccess =
  olympicsShelvesControllerGetBooksResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerGetBooksResponse =
  olympicsShelvesControllerGetBooksResponseSuccess

export const getOlympicsShelvesControllerGetBooksUrl = (id: number) => {
  return `/api-arvore/olympics-shelves/${id}/books`
}

export const olympicsShelvesControllerGetBooks = async (
  id: number,
  options?: RequestInit
): Promise<olympicsShelvesControllerGetBooksResponse> => {
  return customInstance<olympicsShelvesControllerGetBooksResponse>(
    getOlympicsShelvesControllerGetBooksUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update olympics shelf books
 */
export type olympicsShelvesControllerUpdateBooksResponse200 = {
  data: void
  status: 200
}

export type olympicsShelvesControllerUpdateBooksResponseSuccess =
  olympicsShelvesControllerUpdateBooksResponse200 & {
    headers: Headers
  }
export type olympicsShelvesControllerUpdateBooksResponse =
  olympicsShelvesControllerUpdateBooksResponseSuccess

export const getOlympicsShelvesControllerUpdateBooksUrl = (id: number) => {
  return `/api-arvore/olympics-shelves/${id}/books`
}

export const olympicsShelvesControllerUpdateBooks = async (
  id: number,
  updateOlympicsShelfBooksBodyDto: UpdateOlympicsShelfBooksBodyDto,
  options?: RequestInit
): Promise<olympicsShelvesControllerUpdateBooksResponse> => {
  return customInstance<olympicsShelvesControllerUpdateBooksResponse>(
    getOlympicsShelvesControllerUpdateBooksUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateOlympicsShelfBooksBodyDto)
    }
  )
}

/**
 * @summary List enabled olympics shelves with books for reader
 */
export type readerOlympicsShelvesControllerListResponse200 = {
  data: void
  status: 200
}

export type readerOlympicsShelvesControllerListResponseSuccess =
  readerOlympicsShelvesControllerListResponse200 & {
    headers: Headers
  }
export type readerOlympicsShelvesControllerListResponse =
  readerOlympicsShelvesControllerListResponseSuccess

export const getReaderOlympicsShelvesControllerListUrl = (
  params?: ReaderOlympicsShelvesControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/reader/olympics-shelves?${stringifiedParams}`
    : `/api-arvore/reader/olympics-shelves`
}

export const readerOlympicsShelvesControllerList = async (
  params?: ReaderOlympicsShelvesControllerListParams,
  options?: RequestInit
): Promise<readerOlympicsShelvesControllerListResponse> => {
  return customInstance<readerOlympicsShelvesControllerListResponse>(
    getReaderOlympicsShelvesControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Olympics certificate downloads report (PostHog)
 */
export type olympicsReportControllerGetResponse200 = {
  data: void
  status: 200
}

export type olympicsReportControllerGetResponseSuccess =
  olympicsReportControllerGetResponse200 & {
    headers: Headers
  }
export type olympicsReportControllerGetResponse =
  olympicsReportControllerGetResponseSuccess

export const getOlympicsReportControllerGetUrl = (
  params?: OlympicsReportControllerGetParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/olympics-report?${stringifiedParams}`
    : `/api-arvore/olympics-report`
}

export const olympicsReportControllerGet = async (
  params?: OlympicsReportControllerGetParams,
  options?: RequestInit
): Promise<olympicsReportControllerGetResponse> => {
  return customInstance<olympicsReportControllerGetResponse>(
    getOlympicsReportControllerGetUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns an existing tutorial or creates a new one with state=pending if it does not exist
 * @summary Find or create tutorial
 */
export type onboardingControllerFindOrCreateTutorialEndpointResponse200 = {
  data: TutorialResponseDto
  status: 200
}

export type onboardingControllerFindOrCreateTutorialEndpointResponse400 = {
  data: void
  status: 400
}

export type onboardingControllerFindOrCreateTutorialEndpointResponseSuccess =
  onboardingControllerFindOrCreateTutorialEndpointResponse200 & {
    headers: Headers
  }
export type onboardingControllerFindOrCreateTutorialEndpointResponseError =
  onboardingControllerFindOrCreateTutorialEndpointResponse400 & {
    headers: Headers
  }

export type onboardingControllerFindOrCreateTutorialEndpointResponse =
  | onboardingControllerFindOrCreateTutorialEndpointResponseSuccess
  | onboardingControllerFindOrCreateTutorialEndpointResponseError

export const getOnboardingControllerFindOrCreateTutorialEndpointUrl = () => {
  return `/api-arvore/onboarding/tutorials`
}

export const onboardingControllerFindOrCreateTutorialEndpoint = async (
  findOrCreateTutorialDto: FindOrCreateTutorialDto,
  options?: RequestInit
): Promise<onboardingControllerFindOrCreateTutorialEndpointResponse> => {
  return customInstance<onboardingControllerFindOrCreateTutorialEndpointResponse>(
    getOnboardingControllerFindOrCreateTutorialEndpointUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(findOrCreateTutorialDto)
    }
  )
}

/**
 * Updates the tutorial state based on the action (CONSUME, DISMISS, COMPLETE)
 * @summary Update tutorial state
 */
export type onboardingControllerUpdateTutorialEndpointResponse200 = {
  data: TutorialResponseDto
  status: 200
}

export type onboardingControllerUpdateTutorialEndpointResponse400 = {
  data: void
  status: 400
}

export type onboardingControllerUpdateTutorialEndpointResponse404 = {
  data: void
  status: 404
}

export type onboardingControllerUpdateTutorialEndpointResponseSuccess =
  onboardingControllerUpdateTutorialEndpointResponse200 & {
    headers: Headers
  }
export type onboardingControllerUpdateTutorialEndpointResponseError = (
  | onboardingControllerUpdateTutorialEndpointResponse400
  | onboardingControllerUpdateTutorialEndpointResponse404
) & {
  headers: Headers
}

export type onboardingControllerUpdateTutorialEndpointResponse =
  | onboardingControllerUpdateTutorialEndpointResponseSuccess
  | onboardingControllerUpdateTutorialEndpointResponseError

export const getOnboardingControllerUpdateTutorialEndpointUrl = () => {
  return `/api-arvore/onboarding/tutorials`
}

export const onboardingControllerUpdateTutorialEndpoint = async (
  updateTutorialDto: UpdateTutorialDto,
  options?: RequestInit
): Promise<onboardingControllerUpdateTutorialEndpointResponse> => {
  return customInstance<onboardingControllerUpdateTutorialEndpointResponse>(
    getOnboardingControllerUpdateTutorialEndpointUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateTutorialDto)
    }
  )
}

/**
 * Returns the onboarding checklist status for a user, checking first reading, achievement area, and plant tree
 * @summary Get checklist status
 */
export type onboardingControllerGetChecklistStatusEndpointResponse200 = {
  data: ChecklistStatusResponseDto
  status: 200
}

export type onboardingControllerGetChecklistStatusEndpointResponseSuccess =
  onboardingControllerGetChecklistStatusEndpointResponse200 & {
    headers: Headers
  }
export type onboardingControllerGetChecklistStatusEndpointResponse =
  onboardingControllerGetChecklistStatusEndpointResponseSuccess

export const getOnboardingControllerGetChecklistStatusEndpointUrl = (
  userId: number
) => {
  return `/api-arvore/onboarding/checklist/${userId}`
}

export const onboardingControllerGetChecklistStatusEndpoint = async (
  userId: number,
  options?: RequestInit
): Promise<onboardingControllerGetChecklistStatusEndpointResponse> => {
  return customInstance<onboardingControllerGetChecklistStatusEndpointResponse>(
    getOnboardingControllerGetChecklistStatusEndpointUrl(userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Adds coins and water drops to the user games record.
 * @summary Give rewards to user
 */
export type onboardingControllerGiveRewardsEndpointResponse200 = {
  data: void
  status: 200
}

export type onboardingControllerGiveRewardsEndpointResponse400 = {
  data: void
  status: 400
}

export type onboardingControllerGiveRewardsEndpointResponseSuccess =
  onboardingControllerGiveRewardsEndpointResponse200 & {
    headers: Headers
  }
export type onboardingControllerGiveRewardsEndpointResponseError =
  onboardingControllerGiveRewardsEndpointResponse400 & {
    headers: Headers
  }

export type onboardingControllerGiveRewardsEndpointResponse =
  | onboardingControllerGiveRewardsEndpointResponseSuccess
  | onboardingControllerGiveRewardsEndpointResponseError

export const getOnboardingControllerGiveRewardsEndpointUrl = () => {
  return `/api-arvore/onboarding/rewards`
}

export const onboardingControllerGiveRewardsEndpoint = async (
  giveRewardsDto: GiveRewardsDto,
  options?: RequestInit
): Promise<onboardingControllerGiveRewardsEndpointResponse> => {
  return customInstance<onboardingControllerGiveRewardsEndpointResponse>(
    getOnboardingControllerGiveRewardsEndpointUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(giveRewardsDto)
    }
  )
}

/**
 * Updates user job positions and job areas, and automatically updates user role based on job positions. Users are created with ADVANCED role by default, and the role can be upgraded (ADVANCED → ADMIN) or downgraded (ADVANCED → BASIC) based on the job positions.
 * @summary Qualify job description
 */
export type onboardingControllerQualifyJobDescriptionEndpointResponse200 = {
  data: QualifyJobDescriptionResponseDto
  status: 200
}

export type onboardingControllerQualifyJobDescriptionEndpointResponse400 = {
  data: void
  status: 400
}

export type onboardingControllerQualifyJobDescriptionEndpointResponse404 = {
  data: void
  status: 404
}

export type onboardingControllerQualifyJobDescriptionEndpointResponseSuccess =
  onboardingControllerQualifyJobDescriptionEndpointResponse200 & {
    headers: Headers
  }
export type onboardingControllerQualifyJobDescriptionEndpointResponseError = (
  | onboardingControllerQualifyJobDescriptionEndpointResponse400
  | onboardingControllerQualifyJobDescriptionEndpointResponse404
) & {
  headers: Headers
}

export type onboardingControllerQualifyJobDescriptionEndpointResponse =
  | onboardingControllerQualifyJobDescriptionEndpointResponseSuccess
  | onboardingControllerQualifyJobDescriptionEndpointResponseError

export const getOnboardingControllerQualifyJobDescriptionEndpointUrl = () => {
  return `/api-arvore/onboarding/job-description`
}

export const onboardingControllerQualifyJobDescriptionEndpoint = async (
  qualifyJobDescriptionDto: QualifyJobDescriptionDto,
  options?: RequestInit
): Promise<onboardingControllerQualifyJobDescriptionEndpointResponse> => {
  return customInstance<onboardingControllerQualifyJobDescriptionEndpointResponse>(
    getOnboardingControllerQualifyJobDescriptionEndpointUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(qualifyJobDescriptionDto)
    }
  )
}

/**
 * @summary Upload audio for multilingual fluency demo assessment
 */
export type fluencyDemoControllerUploadAudioResponse201 = {
  data: void
  status: 201
}

export type fluencyDemoControllerUploadAudioResponseSuccess =
  fluencyDemoControllerUploadAudioResponse201 & {
    headers: Headers
  }
export type fluencyDemoControllerUploadAudioResponse =
  fluencyDemoControllerUploadAudioResponseSuccess

export const getFluencyDemoControllerUploadAudioUrl = () => {
  return `/api-arvore/fluency-demo/audio`
}

export const fluencyDemoControllerUploadAudio = async (
  fluencyDemoControllerUploadAudioBody: FluencyDemoControllerUploadAudioBody,
  options?: RequestInit
): Promise<fluencyDemoControllerUploadAudioResponse> => {
  const formData = new FormData()
  if (fluencyDemoControllerUploadAudioBody.file !== undefined) {
    formData.append(`file`, fluencyDemoControllerUploadAudioBody.file)
  }
  if (fluencyDemoControllerUploadAudioBody.referenceText !== undefined) {
    formData.append(
      `referenceText`,
      fluencyDemoControllerUploadAudioBody.referenceText
    )
  }
  if (fluencyDemoControllerUploadAudioBody.duration !== undefined) {
    formData.append(
      `duration`,
      fluencyDemoControllerUploadAudioBody.duration.toString()
    )
  }
  if (fluencyDemoControllerUploadAudioBody.language !== undefined) {
    formData.append(`language`, fluencyDemoControllerUploadAudioBody.language)
  }

  return customInstance<fluencyDemoControllerUploadAudioResponse>(
    getFluencyDemoControllerUploadAudioUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Get fluency demo assessment result
 */
export type fluencyDemoControllerGetResultResponse200 = {
  data: void
  status: 200
}

export type fluencyDemoControllerGetResultResponse404 = {
  data: void
  status: 404
}

export type fluencyDemoControllerGetResultResponseSuccess =
  fluencyDemoControllerGetResultResponse200 & {
    headers: Headers
  }
export type fluencyDemoControllerGetResultResponseError =
  fluencyDemoControllerGetResultResponse404 & {
    headers: Headers
  }

export type fluencyDemoControllerGetResultResponse =
  | fluencyDemoControllerGetResultResponseSuccess
  | fluencyDemoControllerGetResultResponseError

export const getFluencyDemoControllerGetResultUrl = (demoId: string) => {
  return `/api-arvore/fluency-demo/audio/${demoId}`
}

export const fluencyDemoControllerGetResult = async (
  demoId: string,
  options?: RequestInit
): Promise<fluencyDemoControllerGetResultResponse> => {
  return customInstance<fluencyDemoControllerGetResultResponse>(
    getFluencyDemoControllerGetResultUrl(demoId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get available seeds for the user forest
 */
export type gamingControllerGetSeedsResponse200 = {
  data: SeedsResponseDto
  status: 200
}

export type gamingControllerGetSeedsResponse404 = {
  data: void
  status: 404
}

export type gamingControllerGetSeedsResponseSuccess =
  gamingControllerGetSeedsResponse200 & {
    headers: Headers
  }
export type gamingControllerGetSeedsResponseError =
  gamingControllerGetSeedsResponse404 & {
    headers: Headers
  }

export type gamingControllerGetSeedsResponse =
  | gamingControllerGetSeedsResponseSuccess
  | gamingControllerGetSeedsResponseError

export const getGamingControllerGetSeedsUrl = () => {
  return `/api-arvore/gaming/seeds`
}

export const gamingControllerGetSeeds = async (
  options?: RequestInit
): Promise<gamingControllerGetSeedsResponse> => {
  return customInstance<gamingControllerGetSeedsResponse>(
    getGamingControllerGetSeedsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get the Copa da Arvore 2026 card data for the user forest
 */
export type gamingControllerGetCopaResponse200 = {
  data: CopaResponseDto
  status: 200
}

export type gamingControllerGetCopaResponse404 = {
  data: void
  status: 404
}

export type gamingControllerGetCopaResponseSuccess =
  gamingControllerGetCopaResponse200 & {
    headers: Headers
  }
export type gamingControllerGetCopaResponseError =
  gamingControllerGetCopaResponse404 & {
    headers: Headers
  }

export type gamingControllerGetCopaResponse =
  | gamingControllerGetCopaResponseSuccess
  | gamingControllerGetCopaResponseError

export const getGamingControllerGetCopaUrl = () => {
  return `/api-arvore/gaming/copa`
}

export const gamingControllerGetCopa = async (
  options?: RequestInit
): Promise<gamingControllerGetCopaResponse> => {
  return customInstance<gamingControllerGetCopaResponse>(
    getGamingControllerGetCopaUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get the Gincana de Leitura 2026 card data for the user forest
 */
export type gamingControllerGetGincanaResponse200 = {
  data: GincanaResponseDto
  status: 200
}

export type gamingControllerGetGincanaResponse404 = {
  data: void
  status: 404
}

export type gamingControllerGetGincanaResponseSuccess =
  gamingControllerGetGincanaResponse200 & {
    headers: Headers
  }
export type gamingControllerGetGincanaResponseError =
  gamingControllerGetGincanaResponse404 & {
    headers: Headers
  }

export type gamingControllerGetGincanaResponse =
  | gamingControllerGetGincanaResponseSuccess
  | gamingControllerGetGincanaResponseError

export const getGamingControllerGetGincanaUrl = () => {
  return `/api-arvore/gaming/gincana`
}

export const gamingControllerGetGincana = async (
  options?: RequestInit
): Promise<gamingControllerGetGincanaResponse> => {
  return customInstance<gamingControllerGetGincanaResponse>(
    getGamingControllerGetGincanaUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the reader's forest with trees, available seeds, special items and water drop details. Equivalent to the GetDataMainForestScreen GraphQL query.
 * @summary Get the data for the main forest screen
 */
export type forestControllerGetMainScreenResponse200 = {
  data: GetMainForestScreenResponseDto
  status: 200
}

export type forestControllerGetMainScreenResponseSuccess =
  forestControllerGetMainScreenResponse200 & {
    headers: Headers
  }
export type forestControllerGetMainScreenResponse =
  forestControllerGetMainScreenResponseSuccess

export const getForestControllerGetMainScreenUrl = () => {
  return `/api-arvore/forest/main-screen`
}

export const forestControllerGetMainScreen = async (
  options?: RequestInit
): Promise<forestControllerGetMainScreenResponse> => {
  return customInstance<forestControllerGetMainScreenResponse>(
    getForestControllerGetMainScreenUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Buys a seed and plants a tree at the given position. Equivalent to the buySeed GraphQL mutation.
 * @summary Plant a seed in the forest
 */
export type forestControllerBuySeedResponse200 = {
  data: BuySeedResponseDto
  status: 200
}

export type forestControllerBuySeedResponseSuccess =
  forestControllerBuySeedResponse200 & {
    headers: Headers
  }
export type forestControllerBuySeedResponse =
  forestControllerBuySeedResponseSuccess

export const getForestControllerBuySeedUrl = () => {
  return `/api-arvore/forest/seeds`
}

export const forestControllerBuySeed = async (
  buySeedDto: BuySeedDto,
  options?: RequestInit
): Promise<forestControllerBuySeedResponse> => {
  return customInstance<forestControllerBuySeedResponse>(
    getForestControllerBuySeedUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(buySeedDto)
    }
  )
}

/**
 * Buys and applies a special item (fertilizer, super fertilizer or rainy days). Equivalent to the buySpecialItem GraphQL mutation.
 * @summary Use a special item in the forest
 */
export type forestControllerBuySpecialItemResponse200 = {
  data: BuySpecialItemResponseDto
  status: 200
}

export type forestControllerBuySpecialItemResponseSuccess =
  forestControllerBuySpecialItemResponse200 & {
    headers: Headers
  }
export type forestControllerBuySpecialItemResponse =
  forestControllerBuySpecialItemResponseSuccess

export const getForestControllerBuySpecialItemUrl = () => {
  return `/api-arvore/forest/special-items`
}

export const forestControllerBuySpecialItem = async (
  buySpecialItemDto: BuySpecialItemDto,
  options?: RequestInit
): Promise<forestControllerBuySpecialItemResponse> => {
  return customInstance<forestControllerBuySpecialItemResponse>(
    getForestControllerBuySpecialItemUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(buySpecialItemDto)
    }
  )
}

/**
 * Bootstraps the reader game and forest if needed, or creates a missing forest for an existing game. Equivalent to the joinGame GraphQL mutation.
 * @summary Join the forest game
 */
export type forestControllerJoinGameResponse200 = {
  data: JoinGameResponseDto
  status: 200
}

export type forestControllerJoinGameResponseSuccess =
  forestControllerJoinGameResponse200 & {
    headers: Headers
  }
export type forestControllerJoinGameResponse =
  forestControllerJoinGameResponseSuccess

export const getForestControllerJoinGameUrl = () => {
  return `/api-arvore/forest/join-game`
}

export const forestControllerJoinGame = async (
  options?: RequestInit
): Promise<forestControllerJoinGameResponse> => {
  return customInstance<forestControllerJoinGameResponse>(
    getForestControllerJoinGameUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Returns non-admin readers from the reader's entity, excluding the reader themselves. Equivalent to the forest.friends GraphQL field.
 * @summary List forest friends
 */
export type forestControllerGetFriendsResponse200 = {
  data: ForestFriendDto[]
  status: 200
}

export type forestControllerGetFriendsResponseSuccess =
  forestControllerGetFriendsResponse200 & {
    headers: Headers
  }
export type forestControllerGetFriendsResponse =
  forestControllerGetFriendsResponseSuccess

export const getForestControllerGetFriendsUrl = (
  params: ForestControllerGetFriendsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/forest/friends?${stringifiedParams}`
    : `/api-arvore/forest/friends`
}

export const forestControllerGetFriends = async (
  params: ForestControllerGetFriendsParams,
  options?: RequestInit
): Promise<forestControllerGetFriendsResponse> => {
  return customInstance<forestControllerGetFriendsResponse>(
    getForestControllerGetFriendsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns descendant entities of the given entity, or its readers when there are no descendants. Equivalent to the forest.friendsForAdmin GraphQL field.
 * @summary List forest friends for admin
 */
export type forestControllerGetFriendsForAdminResponse200 = {
  data: ForestFriendForAdminDto[]
  status: 200
}

export type forestControllerGetFriendsForAdminResponseSuccess =
  forestControllerGetFriendsForAdminResponse200 & {
    headers: Headers
  }
export type forestControllerGetFriendsForAdminResponse =
  forestControllerGetFriendsForAdminResponseSuccess

export const getForestControllerGetFriendsForAdminUrl = (
  params: ForestControllerGetFriendsForAdminParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/forest/friends-for-admin?${stringifiedParams}`
    : `/api-arvore/forest/friends-for-admin`
}

export const forestControllerGetFriendsForAdmin = async (
  params: ForestControllerGetFriendsForAdminParams,
  options?: RequestInit
): Promise<forestControllerGetFriendsForAdminResponse> => {
  return customInstance<forestControllerGetFriendsForAdminResponse>(
    getForestControllerGetFriendsForAdminUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the latest trees of a friend's forest for display. Equivalent to the forest.friendTreeListings GraphQL field.
 * @summary List a friend forest tree listings
 */
export type forestControllerGetFriendTreeListingsResponse200 = {
  data: ForestTreeListingDto[]
  status: 200
}

export type forestControllerGetFriendTreeListingsResponseSuccess =
  forestControllerGetFriendTreeListingsResponse200 & {
    headers: Headers
  }
export type forestControllerGetFriendTreeListingsResponse =
  forestControllerGetFriendTreeListingsResponseSuccess

export const getForestControllerGetFriendTreeListingsUrl = (
  params: ForestControllerGetFriendTreeListingsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/forest/friend-tree-listings?${stringifiedParams}`
    : `/api-arvore/forest/friend-tree-listings`
}

export const forestControllerGetFriendTreeListings = async (
  params: ForestControllerGetFriendTreeListingsParams,
  options?: RequestInit
): Promise<forestControllerGetFriendTreeListingsResponse> => {
  return customInstance<forestControllerGetFriendTreeListingsResponse>(
    getForestControllerGetFriendTreeListingsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List catalog items (public)
 */
export type hybridOfferPublicControllerCatalogResponse200 = {
  data: void
  status: 200
}

export type hybridOfferPublicControllerCatalogResponseSuccess =
  hybridOfferPublicControllerCatalogResponse200 & {
    headers: Headers
  }
export type hybridOfferPublicControllerCatalogResponse =
  hybridOfferPublicControllerCatalogResponseSuccess

export const getHybridOfferPublicControllerCatalogUrl = (
  params?: HybridOfferPublicControllerCatalogParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/public/hybrid-offer/catalog?${stringifiedParams}`
    : `/api-arvore/public/hybrid-offer/catalog`
}

export const hybridOfferPublicControllerCatalog = async (
  params?: HybridOfferPublicControllerCatalogParams,
  options?: RequestInit
): Promise<hybridOfferPublicControllerCatalogResponse> => {
  return customInstance<hybridOfferPublicControllerCatalogResponse>(
    getHybridOfferPublicControllerCatalogUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get catalog item detail by catalog ID (public)
 */
export type hybridOfferPublicControllerCatalogItemDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferPublicControllerCatalogItemDetailResponseSuccess =
  hybridOfferPublicControllerCatalogItemDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferPublicControllerCatalogItemDetailResponse =
  hybridOfferPublicControllerCatalogItemDetailResponseSuccess

export const getHybridOfferPublicControllerCatalogItemDetailUrl = (
  id: number
) => {
  return `/api-arvore/public/hybrid-offer/catalog/item/${id}`
}

export const hybridOfferPublicControllerCatalogItemDetail = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferPublicControllerCatalogItemDetailResponse> => {
  return customInstance<hybridOfferPublicControllerCatalogItemDetailResponse>(
    getHybridOfferPublicControllerCatalogItemDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get catalog book detail (public)
 */
export type hybridOfferPublicControllerCatalogDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferPublicControllerCatalogDetailResponseSuccess =
  hybridOfferPublicControllerCatalogDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferPublicControllerCatalogDetailResponse =
  hybridOfferPublicControllerCatalogDetailResponseSuccess

export const getHybridOfferPublicControllerCatalogDetailUrl = (
  bookId: number
) => {
  return `/api-arvore/public/hybrid-offer/catalog/${bookId}`
}

export const hybridOfferPublicControllerCatalogDetail = async (
  bookId: number,
  options?: RequestInit
): Promise<hybridOfferPublicControllerCatalogDetailResponse> => {
  return customInstance<hybridOfferPublicControllerCatalogDetailResponse>(
    getHybridOfferPublicControllerCatalogDetailUrl(bookId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get adoption list filters (public)
 */
export type hybridOfferPublicControllerFiltersResponse200 = {
  data: void
  status: 200
}

export type hybridOfferPublicControllerFiltersResponseSuccess =
  hybridOfferPublicControllerFiltersResponse200 & {
    headers: Headers
  }
export type hybridOfferPublicControllerFiltersResponse =
  hybridOfferPublicControllerFiltersResponseSuccess

export const getHybridOfferPublicControllerFiltersUrl = () => {
  return `/api-arvore/public/hybrid-offer/filters`
}

export const hybridOfferPublicControllerFilters = async (
  options?: RequestInit
): Promise<hybridOfferPublicControllerFiltersResponse> => {
  return customInstance<hybridOfferPublicControllerFiltersResponse>(
    getHybridOfferPublicControllerFiltersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create lead
 */
export type hybridOfferPublicControllerCreateLeadResponse201 = {
  data: void
  status: 201
}

export type hybridOfferPublicControllerCreateLeadResponseSuccess =
  hybridOfferPublicControllerCreateLeadResponse201 & {
    headers: Headers
  }
export type hybridOfferPublicControllerCreateLeadResponse =
  hybridOfferPublicControllerCreateLeadResponseSuccess

export const getHybridOfferPublicControllerCreateLeadUrl = () => {
  return `/api-arvore/public/hybrid-offer/leads`
}

export const hybridOfferPublicControllerCreateLead = async (
  createLeadBodyDto: CreateLeadBodyDto,
  options?: RequestInit
): Promise<hybridOfferPublicControllerCreateLeadResponse> => {
  return customInstance<hybridOfferPublicControllerCreateLeadResponse>(
    getHybridOfferPublicControllerCreateLeadUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createLeadBodyDto)
    }
  )
}

/**
 * @summary Create book selection for school/grade
 */
export type hybridOfferSelectionControllerCreateResponse201 = {
  data: void
  status: 201
}

export type hybridOfferSelectionControllerCreateResponseSuccess =
  hybridOfferSelectionControllerCreateResponse201 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerCreateResponse =
  hybridOfferSelectionControllerCreateResponseSuccess

export const getHybridOfferSelectionControllerCreateUrl = () => {
  return `/api-arvore/hybrid-offer/selection`
}

export const hybridOfferSelectionControllerCreate = async (
  createBookSelectionBodyDto: CreateBookSelectionBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerCreateResponse> => {
  return customInstance<hybridOfferSelectionControllerCreateResponse>(
    getHybridOfferSelectionControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createBookSelectionBodyDto)
    }
  )
}

/**
 * @summary List book selections for a school
 */
export type hybridOfferSelectionControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerListResponseSuccess =
  hybridOfferSelectionControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerListResponse =
  hybridOfferSelectionControllerListResponseSuccess

export const getHybridOfferSelectionControllerListUrl = (
  params: HybridOfferSelectionControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection`
}

export const hybridOfferSelectionControllerList = async (
  params: HybridOfferSelectionControllerListParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerListResponse> => {
  return customInstance<hybridOfferSelectionControllerListResponse>(
    getHybridOfferSelectionControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Check if entity has book selections
 */
export type hybridOfferSelectionControllerHasSelectionResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerHasSelectionResponseSuccess =
  hybridOfferSelectionControllerHasSelectionResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerHasSelectionResponse =
  hybridOfferSelectionControllerHasSelectionResponseSuccess

export const getHybridOfferSelectionControllerHasSelectionUrl = (
  params: HybridOfferSelectionControllerHasSelectionParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection/has-selection?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection/has-selection`
}

export const hybridOfferSelectionControllerHasSelection = async (
  params: HybridOfferSelectionControllerHasSelectionParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerHasSelectionResponse> => {
  return customInstance<hybridOfferSelectionControllerHasSelectionResponse>(
    getHybridOfferSelectionControllerHasSelectionUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get enriched catalog detail by catalog ID or physical edition ID
 */
export type hybridOfferSelectionControllerCatalogDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerCatalogDetailResponseSuccess =
  hybridOfferSelectionControllerCatalogDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerCatalogDetailResponse =
  hybridOfferSelectionControllerCatalogDetailResponseSuccess

export const getHybridOfferSelectionControllerCatalogDetailUrl = (
  id: string,
  params: HybridOfferSelectionControllerCatalogDetailParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection/catalog/${id}?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection/catalog/${id}`
}

export const hybridOfferSelectionControllerCatalogDetail = async (
  id: string,
  params: HybridOfferSelectionControllerCatalogDetailParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerCatalogDetailResponse> => {
  return customInstance<hybridOfferSelectionControllerCatalogDetailResponse>(
    getHybridOfferSelectionControllerCatalogDetailUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get coordinator review with all grades and books
 */
export type hybridOfferSelectionControllerCoordinatorReviewResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerCoordinatorReviewResponseSuccess =
  hybridOfferSelectionControllerCoordinatorReviewResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerCoordinatorReviewResponse =
  hybridOfferSelectionControllerCoordinatorReviewResponseSuccess

export const getHybridOfferSelectionControllerCoordinatorReviewUrl = (
  params?: HybridOfferSelectionControllerCoordinatorReviewParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection/coordinator-review?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection/coordinator-review`
}

export const hybridOfferSelectionControllerCoordinatorReview = async (
  params?: HybridOfferSelectionControllerCoordinatorReviewParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerCoordinatorReviewResponse> => {
  return customInstance<hybridOfferSelectionControllerCoordinatorReviewResponse>(
    getHybridOfferSelectionControllerCoordinatorReviewUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Preview book details for physical edition IDs (before saving)
 */
export type hybridOfferSelectionControllerPreviewItemsResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerPreviewItemsResponseSuccess =
  hybridOfferSelectionControllerPreviewItemsResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerPreviewItemsResponse =
  hybridOfferSelectionControllerPreviewItemsResponseSuccess

export const getHybridOfferSelectionControllerPreviewItemsUrl = () => {
  return `/api-arvore/hybrid-offer/selection/preview-items`
}

export const hybridOfferSelectionControllerPreviewItems = async (
  previewSelectionItemsBodyDto: PreviewSelectionItemsBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerPreviewItemsResponse> => {
  return customInstance<hybridOfferSelectionControllerPreviewItemsResponse>(
    getHybridOfferSelectionControllerPreviewItemsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(previewSelectionItemsBodyDto)
    }
  )
}

/**
 * @summary Approve all pending selections for coordinator entity
 */
export type hybridOfferSelectionControllerCoordinatorApproveResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerCoordinatorApproveResponseSuccess =
  hybridOfferSelectionControllerCoordinatorApproveResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerCoordinatorApproveResponse =
  hybridOfferSelectionControllerCoordinatorApproveResponseSuccess

export const getHybridOfferSelectionControllerCoordinatorApproveUrl = (
  params?: HybridOfferSelectionControllerCoordinatorApproveParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection/coordinator-approve?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection/coordinator-approve`
}

export const hybridOfferSelectionControllerCoordinatorApprove = async (
  approveCoordinatorSelectionsBodyDto: ApproveCoordinatorSelectionsBodyDto,
  params?: HybridOfferSelectionControllerCoordinatorApproveParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerCoordinatorApproveResponse> => {
  return customInstance<hybridOfferSelectionControllerCoordinatorApproveResponse>(
    getHybridOfferSelectionControllerCoordinatorApproveUrl(params),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(approveCoordinatorSelectionsBodyDto)
    }
  )
}

/**
 * @summary Get active order deadline config for current user entity
 */
export type hybridOfferSelectionControllerOrderConfigResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerOrderConfigResponseSuccess =
  hybridOfferSelectionControllerOrderConfigResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerOrderConfigResponse =
  hybridOfferSelectionControllerOrderConfigResponseSuccess

export const getHybridOfferSelectionControllerOrderConfigUrl = (
  params?: HybridOfferSelectionControllerOrderConfigParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/selection/order-config?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/selection/order-config`
}

export const hybridOfferSelectionControllerOrderConfig = async (
  params?: HybridOfferSelectionControllerOrderConfigParams,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerOrderConfigResponse> => {
  return customInstance<hybridOfferSelectionControllerOrderConfigResponse>(
    getHybridOfferSelectionControllerOrderConfigUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get enriched selection review with books, teachers, logs
 */
export type hybridOfferSelectionControllerSelectionReviewResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerSelectionReviewResponseSuccess =
  hybridOfferSelectionControllerSelectionReviewResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerSelectionReviewResponse =
  hybridOfferSelectionControllerSelectionReviewResponseSuccess

export const getHybridOfferSelectionControllerSelectionReviewUrl = (
  id: number
) => {
  return `/api-arvore/hybrid-offer/selection/${id}/review`
}

export const hybridOfferSelectionControllerSelectionReview = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerSelectionReviewResponse> => {
  return customInstance<hybridOfferSelectionControllerSelectionReviewResponse>(
    getHybridOfferSelectionControllerSelectionReviewUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book selection details
 */
export type hybridOfferSelectionControllerDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerDetailResponseSuccess =
  hybridOfferSelectionControllerDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerDetailResponse =
  hybridOfferSelectionControllerDetailResponseSuccess

export const getHybridOfferSelectionControllerDetailUrl = (id: number) => {
  return `/api-arvore/hybrid-offer/selection/${id}`
}

export const hybridOfferSelectionControllerDetail = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerDetailResponse> => {
  return customInstance<hybridOfferSelectionControllerDetailResponse>(
    getHybridOfferSelectionControllerDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update book selection
 */
export type hybridOfferSelectionControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerUpdateResponseSuccess =
  hybridOfferSelectionControllerUpdateResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerUpdateResponse =
  hybridOfferSelectionControllerUpdateResponseSuccess

export const getHybridOfferSelectionControllerUpdateUrl = (id: number) => {
  return `/api-arvore/hybrid-offer/selection/${id}`
}

export const hybridOfferSelectionControllerUpdate = async (
  id: number,
  updateBookSelectionBodyDto: UpdateBookSelectionBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerUpdateResponse> => {
  return customInstance<hybridOfferSelectionControllerUpdateResponse>(
    getHybridOfferSelectionControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateBookSelectionBodyDto)
    }
  )
}

/**
 * @summary Create additional order for approved selection
 */
export type hybridOfferSelectionControllerAdditionalOrderResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerAdditionalOrderResponseSuccess =
  hybridOfferSelectionControllerAdditionalOrderResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerAdditionalOrderResponse =
  hybridOfferSelectionControllerAdditionalOrderResponseSuccess

export const getHybridOfferSelectionControllerAdditionalOrderUrl = (
  id: number
) => {
  return `/api-arvore/hybrid-offer/selection/${id}/additional-order`
}

export const hybridOfferSelectionControllerAdditionalOrder = async (
  id: number,
  createAdditionalOrderBodyDto: CreateAdditionalOrderBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerAdditionalOrderResponse> => {
  return customInstance<hybridOfferSelectionControllerAdditionalOrderResponse>(
    getHybridOfferSelectionControllerAdditionalOrderUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createAdditionalOrderBodyDto)
    }
  )
}

/**
 * @summary Approve or reject book selection
 */
export type hybridOfferSelectionControllerUpdateStatusResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionControllerUpdateStatusResponseSuccess =
  hybridOfferSelectionControllerUpdateStatusResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionControllerUpdateStatusResponse =
  hybridOfferSelectionControllerUpdateStatusResponseSuccess

export const getHybridOfferSelectionControllerUpdateStatusUrl = (
  id: number
) => {
  return `/api-arvore/hybrid-offer/selection/${id}/status`
}

export const hybridOfferSelectionControllerUpdateStatus = async (
  id: number,
  updateBookSelectionStatusBodyDto: UpdateBookSelectionStatusBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionControllerUpdateStatusResponse> => {
  return customInstance<hybridOfferSelectionControllerUpdateStatusResponse>(
    getHybridOfferSelectionControllerUpdateStatusUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateBookSelectionStatusBodyDto)
    }
  )
}

/**
 * @summary List catalog items with resolution logic
 */
export type hybridOfferCatalogPublicControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogPublicControllerListResponseSuccess =
  hybridOfferCatalogPublicControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogPublicControllerListResponse =
  hybridOfferCatalogPublicControllerListResponseSuccess

export const getHybridOfferCatalogPublicControllerListUrl = (
  params?: HybridOfferCatalogPublicControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/hybrid-offer/catalog?${stringifiedParams}`
    : `/api-arvore/hybrid-offer/catalog`
}

export const hybridOfferCatalogPublicControllerList = async (
  params?: HybridOfferCatalogPublicControllerListParams,
  options?: RequestInit
): Promise<hybridOfferCatalogPublicControllerListResponse> => {
  return customInstance<hybridOfferCatalogPublicControllerListResponse>(
    getHybridOfferCatalogPublicControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get catalog item details with physical editions
 */
export type hybridOfferCatalogPublicControllerDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogPublicControllerDetailResponseSuccess =
  hybridOfferCatalogPublicControllerDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogPublicControllerDetailResponse =
  hybridOfferCatalogPublicControllerDetailResponseSuccess

export const getHybridOfferCatalogPublicControllerDetailUrl = (id: number) => {
  return `/api-arvore/hybrid-offer/catalog/${id}`
}

export const hybridOfferCatalogPublicControllerDetail = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferCatalogPublicControllerDetailResponse> => {
  return customInstance<hybridOfferCatalogPublicControllerDetailResponse>(
    getHybridOfferCatalogPublicControllerDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all catalog items (admin)
 */
export type hybridOfferCatalogAdminControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerListResponseSuccess =
  hybridOfferCatalogAdminControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerListResponse =
  hybridOfferCatalogAdminControllerListResponseSuccess

export const getHybridOfferCatalogAdminControllerListUrl = (
  params?: HybridOfferCatalogAdminControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/catalog?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/catalog`
}

export const hybridOfferCatalogAdminControllerList = async (
  params?: HybridOfferCatalogAdminControllerListParams,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerListResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerListResponse>(
    getHybridOfferCatalogAdminControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create catalog item
 */
export type hybridOfferCatalogAdminControllerCreateResponse201 = {
  data: void
  status: 201
}

export type hybridOfferCatalogAdminControllerCreateResponseSuccess =
  hybridOfferCatalogAdminControllerCreateResponse201 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerCreateResponse =
  hybridOfferCatalogAdminControllerCreateResponseSuccess

export const getHybridOfferCatalogAdminControllerCreateUrl = () => {
  return `/api-arvore/admin/hybrid-offer/catalog`
}

export const hybridOfferCatalogAdminControllerCreate = async (
  createCatalogItemBodyDto: CreateCatalogItemBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerCreateResponse> => {
  const formData = new FormData()
  if (createCatalogItemBodyDto.bookIdArvore !== undefined) {
    formData.append(
      `bookIdArvore`,
      createCatalogItemBodyDto.bookIdArvore.toString()
    )
  }
  if (createCatalogItemBodyDto.title !== undefined) {
    formData.append(`title`, createCatalogItemBodyDto.title)
  }
  if (createCatalogItemBodyDto.author !== undefined) {
    formData.append(`author`, createCatalogItemBodyDto.author)
  }
  if (createCatalogItemBodyDto.coverUrl !== undefined) {
    formData.append(`coverUrl`, createCatalogItemBodyDto.coverUrl)
  }
  if (createCatalogItemBodyDto.genre !== undefined) {
    formData.append(`genre`, createCatalogItemBodyDto.genre)
  }
  if (createCatalogItemBodyDto.synopsis !== undefined) {
    formData.append(`synopsis`, createCatalogItemBodyDto.synopsis)
  }
  formData.append(`grade`, createCatalogItemBodyDto.grade)
  if (createCatalogItemBodyDto.isFeatured !== undefined) {
    formData.append(
      `isFeatured`,
      createCatalogItemBodyDto.isFeatured.toString()
    )
  }
  if (createCatalogItemBodyDto.displayOrder !== undefined) {
    formData.append(
      `displayOrder`,
      createCatalogItemBodyDto.displayOrder.toString()
    )
  }

  return customInstance<hybridOfferCatalogAdminControllerCreateResponse>(
    getHybridOfferCatalogAdminControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Update catalog item
 */
export type hybridOfferCatalogAdminControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerUpdateResponseSuccess =
  hybridOfferCatalogAdminControllerUpdateResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerUpdateResponse =
  hybridOfferCatalogAdminControllerUpdateResponseSuccess

export const getHybridOfferCatalogAdminControllerUpdateUrl = (id: number) => {
  return `/api-arvore/admin/hybrid-offer/catalog/${id}`
}

export const hybridOfferCatalogAdminControllerUpdate = async (
  id: number,
  updateCatalogItemBodyDto: UpdateCatalogItemBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerUpdateResponse> => {
  const formData = new FormData()
  if (updateCatalogItemBodyDto.bookIdArvore !== undefined) {
    formData.append(
      `bookIdArvore`,
      updateCatalogItemBodyDto.bookIdArvore.toString()
    )
  }
  if (updateCatalogItemBodyDto.title !== undefined) {
    formData.append(`title`, updateCatalogItemBodyDto.title)
  }
  if (updateCatalogItemBodyDto.author !== undefined) {
    formData.append(`author`, updateCatalogItemBodyDto.author)
  }
  if (updateCatalogItemBodyDto.coverUrl !== undefined) {
    formData.append(`coverUrl`, updateCatalogItemBodyDto.coverUrl)
  }
  if (updateCatalogItemBodyDto.genre !== undefined) {
    formData.append(`genre`, updateCatalogItemBodyDto.genre)
  }
  if (updateCatalogItemBodyDto.synopsis !== undefined) {
    formData.append(`synopsis`, updateCatalogItemBodyDto.synopsis)
  }
  if (updateCatalogItemBodyDto.grade !== undefined) {
    formData.append(`grade`, updateCatalogItemBodyDto.grade)
  }
  if (updateCatalogItemBodyDto.isFeatured !== undefined) {
    formData.append(
      `isFeatured`,
      updateCatalogItemBodyDto.isFeatured.toString()
    )
  }
  if (updateCatalogItemBodyDto.displayOrder !== undefined) {
    formData.append(
      `displayOrder`,
      updateCatalogItemBodyDto.displayOrder.toString()
    )
  }
  if (updateCatalogItemBodyDto.active !== undefined) {
    formData.append(`active`, updateCatalogItemBodyDto.active.toString())
  }

  return customInstance<hybridOfferCatalogAdminControllerUpdateResponse>(
    getHybridOfferCatalogAdminControllerUpdateUrl(id),
    {
      ...options,
      method: 'PUT',
      body: formData
    }
  )
}

/**
 * @summary Soft delete catalog item
 */
export type hybridOfferCatalogAdminControllerDeleteResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerDeleteResponseSuccess =
  hybridOfferCatalogAdminControllerDeleteResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerDeleteResponse =
  hybridOfferCatalogAdminControllerDeleteResponseSuccess

export const getHybridOfferCatalogAdminControllerDeleteUrl = (id: number) => {
  return `/api-arvore/admin/hybrid-offer/catalog/${id}`
}

export const hybridOfferCatalogAdminControllerDelete = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerDeleteResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerDeleteResponse>(
    getHybridOfferCatalogAdminControllerDeleteUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Create physical edition
 */
export type hybridOfferCatalogAdminControllerCreatePhysicalEditionResponse201 =
  {
    data: void
    status: 201
  }

export type hybridOfferCatalogAdminControllerCreatePhysicalEditionResponseSuccess =
  hybridOfferCatalogAdminControllerCreatePhysicalEditionResponse201 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerCreatePhysicalEditionResponse =
  hybridOfferCatalogAdminControllerCreatePhysicalEditionResponseSuccess

export const getHybridOfferCatalogAdminControllerCreatePhysicalEditionUrl =
  () => {
    return `/api-arvore/admin/hybrid-offer/physical-edition`
  }

export const hybridOfferCatalogAdminControllerCreatePhysicalEdition = async (
  createPhysicalEditionBodyDto: CreatePhysicalEditionBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerCreatePhysicalEditionResponse> => {
  const formData = new FormData()
  formData.append(
    `catalogId`,
    createPhysicalEditionBodyDto.catalogId.toString()
  )
  formData.append(`isbnPhysical`, createPhysicalEditionBodyDto.isbnPhysical)
  if (createPhysicalEditionBodyDto.isbnDigital !== undefined) {
    formData.append(`isbnDigital`, createPhysicalEditionBodyDto.isbnDigital)
  }
  if (createPhysicalEditionBodyDto.bookId !== undefined) {
    formData.append(`bookId`, createPhysicalEditionBodyDto.bookId.toString())
  }
  if (createPhysicalEditionBodyDto.publisher !== undefined) {
    formData.append(`publisher`, createPhysicalEditionBodyDto.publisher)
  }
  if (createPhysicalEditionBodyDto.pageCount !== undefined) {
    formData.append(
      `pageCount`,
      createPhysicalEditionBodyDto.pageCount.toString()
    )
  }
  if (createPhysicalEditionBodyDto.physicalPrice !== undefined) {
    formData.append(`physicalPrice`, createPhysicalEditionBodyDto.physicalPrice)
  }
  if (createPhysicalEditionBodyDto.maxStock !== undefined) {
    formData.append(
      `maxStock`,
      createPhysicalEditionBodyDto.maxStock.toString()
    )
  }
  if (createPhysicalEditionBodyDto.currentStock !== undefined) {
    formData.append(
      `currentStock`,
      createPhysicalEditionBodyDto.currentStock.toString()
    )
  }
  if (createPhysicalEditionBodyDto.minPrintRun !== undefined) {
    formData.append(
      `minPrintRun`,
      createPhysicalEditionBodyDto.minPrintRun.toString()
    )
  }
  if (createPhysicalEditionBodyDto.isDiscountedBulk !== undefined) {
    formData.append(
      `isDiscountedBulk`,
      createPhysicalEditionBodyDto.isDiscountedBulk.toString()
    )
  }
  if (createPhysicalEditionBodyDto.bulkDiscountThreshold !== undefined) {
    formData.append(
      `bulkDiscountThreshold`,
      createPhysicalEditionBodyDto.bulkDiscountThreshold.toString()
    )
  }

  return customInstance<hybridOfferCatalogAdminControllerCreatePhysicalEditionResponse>(
    getHybridOfferCatalogAdminControllerCreatePhysicalEditionUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Update physical edition
 */
export type hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponse200 =
  {
    data: void
    status: 200
  }

export type hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponseSuccess =
  hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponse =
  hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponseSuccess

export const getHybridOfferCatalogAdminControllerUpdatePhysicalEditionUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/physical-edition/${id}`
}

export const hybridOfferCatalogAdminControllerUpdatePhysicalEdition = async (
  id: number,
  updatePhysicalEditionBodyDto: UpdatePhysicalEditionBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponse> => {
  const formData = new FormData()
  if (updatePhysicalEditionBodyDto.isbnPhysical !== undefined) {
    formData.append(`isbnPhysical`, updatePhysicalEditionBodyDto.isbnPhysical)
  }
  if (updatePhysicalEditionBodyDto.isbnDigital !== undefined) {
    formData.append(`isbnDigital`, updatePhysicalEditionBodyDto.isbnDigital)
  }
  if (updatePhysicalEditionBodyDto.bookId !== undefined) {
    formData.append(`bookId`, updatePhysicalEditionBodyDto.bookId.toString())
  }
  if (updatePhysicalEditionBodyDto.publisher !== undefined) {
    formData.append(`publisher`, updatePhysicalEditionBodyDto.publisher)
  }
  if (updatePhysicalEditionBodyDto.pageCount !== undefined) {
    formData.append(
      `pageCount`,
      updatePhysicalEditionBodyDto.pageCount.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.physicalPrice !== undefined) {
    formData.append(`physicalPrice`, updatePhysicalEditionBodyDto.physicalPrice)
  }
  if (updatePhysicalEditionBodyDto.maxStock !== undefined) {
    formData.append(
      `maxStock`,
      updatePhysicalEditionBodyDto.maxStock.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.currentStock !== undefined) {
    formData.append(
      `currentStock`,
      updatePhysicalEditionBodyDto.currentStock.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.minPrintRun !== undefined) {
    formData.append(
      `minPrintRun`,
      updatePhysicalEditionBodyDto.minPrintRun.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.isDiscountedBulk !== undefined) {
    formData.append(
      `isDiscountedBulk`,
      updatePhysicalEditionBodyDto.isDiscountedBulk.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.bulkDiscountThreshold !== undefined) {
    formData.append(
      `bulkDiscountThreshold`,
      updatePhysicalEditionBodyDto.bulkDiscountThreshold.toString()
    )
  }
  if (updatePhysicalEditionBodyDto.active !== undefined) {
    formData.append(`active`, updatePhysicalEditionBodyDto.active.toString())
  }

  return customInstance<hybridOfferCatalogAdminControllerUpdatePhysicalEditionResponse>(
    getHybridOfferCatalogAdminControllerUpdatePhysicalEditionUrl(id),
    {
      ...options,
      method: 'PUT',
      body: formData
    }
  )
}

/**
 * @summary Delete physical edition
 */
export type hybridOfferCatalogAdminControllerDeletePhysicalEditionResponse200 =
  {
    data: void
    status: 200
  }

export type hybridOfferCatalogAdminControllerDeletePhysicalEditionResponseSuccess =
  hybridOfferCatalogAdminControllerDeletePhysicalEditionResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerDeletePhysicalEditionResponse =
  hybridOfferCatalogAdminControllerDeletePhysicalEditionResponseSuccess

export const getHybridOfferCatalogAdminControllerDeletePhysicalEditionUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/physical-edition/${id}`
}

export const hybridOfferCatalogAdminControllerDeletePhysicalEdition = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerDeletePhysicalEditionResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerDeletePhysicalEditionResponse>(
    getHybridOfferCatalogAdminControllerDeletePhysicalEditionUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Import catalog items from CSV
 */
export type hybridOfferCatalogAdminControllerImportCsvResponse201 = {
  data: void
  status: 201
}

export type hybridOfferCatalogAdminControllerImportCsvResponseSuccess =
  hybridOfferCatalogAdminControllerImportCsvResponse201 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerImportCsvResponse =
  hybridOfferCatalogAdminControllerImportCsvResponseSuccess

export const getHybridOfferCatalogAdminControllerImportCsvUrl = () => {
  return `/api-arvore/admin/hybrid-offer/catalog/import-csv`
}

export const hybridOfferCatalogAdminControllerImportCsv = async (
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerImportCsvResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerImportCsvResponse>(
    getHybridOfferCatalogAdminControllerImportCsvUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Search Arvore books for curation
 */
export type hybridOfferCatalogAdminControllerSearchBooksResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerSearchBooksResponseSuccess =
  hybridOfferCatalogAdminControllerSearchBooksResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerSearchBooksResponse =
  hybridOfferCatalogAdminControllerSearchBooksResponseSuccess

export const getHybridOfferCatalogAdminControllerSearchBooksUrl = (
  params: HybridOfferCatalogAdminControllerSearchBooksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/books/search?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/books/search`
}

export const hybridOfferCatalogAdminControllerSearchBooks = async (
  params: HybridOfferCatalogAdminControllerSearchBooksParams,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerSearchBooksResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerSearchBooksResponse>(
    getHybridOfferCatalogAdminControllerSearchBooksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Generate presigned URL for physical book cover upload
 */
export type hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponse201 =
  {
    data: void
    status: 201
  }

export type hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponseSuccess =
  hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponse201 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponse =
  hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponseSuccess

export const getHybridOfferCatalogAdminControllerGenerateCoverUploadUrlUrl =
  () => {
    return `/api-arvore/admin/hybrid-offer/catalog/cover-upload-url`
  }

export const hybridOfferCatalogAdminControllerGenerateCoverUploadUrl = async (
  generateCoverUploadUrlBodyDto: GenerateCoverUploadUrlBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerGenerateCoverUploadUrlResponse>(
    getHybridOfferCatalogAdminControllerGenerateCoverUploadUrlUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateCoverUploadUrlBodyDto)
    }
  )
}

/**
 * @summary Upload reading trail (PDF + cover) for a catalog item and create backing book
 */
export type hybridOfferCatalogAdminControllerCreateCatalogTrailResponse201 = {
  data: void
  status: 201
}

export type hybridOfferCatalogAdminControllerCreateCatalogTrailResponseSuccess =
  hybridOfferCatalogAdminControllerCreateCatalogTrailResponse201 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerCreateCatalogTrailResponse =
  hybridOfferCatalogAdminControllerCreateCatalogTrailResponseSuccess

export const getHybridOfferCatalogAdminControllerCreateCatalogTrailUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/catalog/${id}/trail`
}

export const hybridOfferCatalogAdminControllerCreateCatalogTrail = async (
  id: number,
  createCatalogTrailBodyDto: CreateCatalogTrailBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerCreateCatalogTrailResponse> => {
  const formData = new FormData()
  formData.append(
    `publisherId`,
    createCatalogTrailBodyDto.publisherId.toString()
  )
  if (createCatalogTrailBodyDto.description !== undefined) {
    formData.append(`description`, createCatalogTrailBodyDto.description)
  }
  if (createCatalogTrailBodyDto.isbn !== undefined) {
    formData.append(`isbn`, createCatalogTrailBodyDto.isbn)
  }
  if (createCatalogTrailBodyDto.author !== undefined) {
    formData.append(`author`, createCatalogTrailBodyDto.author)
  }
  if (createCatalogTrailBodyDto.minimumAge !== undefined) {
    formData.append(
      `minimumAge`,
      createCatalogTrailBodyDto.minimumAge.toString()
    )
  }

  return customInstance<hybridOfferCatalogAdminControllerCreateCatalogTrailResponse>(
    getHybridOfferCatalogAdminControllerCreateCatalogTrailUrl(id),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Replace PDF/image of an existing trail book and optionally change publisher
 */
export type hybridOfferCatalogAdminControllerUpdateCatalogTrailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerUpdateCatalogTrailResponseSuccess =
  hybridOfferCatalogAdminControllerUpdateCatalogTrailResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerUpdateCatalogTrailResponse =
  hybridOfferCatalogAdminControllerUpdateCatalogTrailResponseSuccess

export const getHybridOfferCatalogAdminControllerUpdateCatalogTrailUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/catalog/${id}/trail`
}

export const hybridOfferCatalogAdminControllerUpdateCatalogTrail = async (
  id: number,
  updateCatalogTrailBodyDto: UpdateCatalogTrailBodyDto,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerUpdateCatalogTrailResponse> => {
  const formData = new FormData()
  if (updateCatalogTrailBodyDto.publisherId !== undefined) {
    formData.append(
      `publisherId`,
      updateCatalogTrailBodyDto.publisherId.toString()
    )
  }

  return customInstance<hybridOfferCatalogAdminControllerUpdateCatalogTrailResponse>(
    getHybridOfferCatalogAdminControllerUpdateCatalogTrailUrl(id),
    {
      ...options,
      method: 'PUT',
      body: formData
    }
  )
}

/**
 * @summary Disable trail book and unlink it from catalog item
 */
export type hybridOfferCatalogAdminControllerDeleteCatalogTrailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerDeleteCatalogTrailResponseSuccess =
  hybridOfferCatalogAdminControllerDeleteCatalogTrailResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerDeleteCatalogTrailResponse =
  hybridOfferCatalogAdminControllerDeleteCatalogTrailResponseSuccess

export const getHybridOfferCatalogAdminControllerDeleteCatalogTrailUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/catalog/${id}/trail`
}

export const hybridOfferCatalogAdminControllerDeleteCatalogTrail = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerDeleteCatalogTrailResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerDeleteCatalogTrailResponse>(
    getHybridOfferCatalogAdminControllerDeleteCatalogTrailUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List hybrid offer leads
 */
export type hybridOfferCatalogAdminControllerListLeadsResponse200 = {
  data: void
  status: 200
}

export type hybridOfferCatalogAdminControllerListLeadsResponseSuccess =
  hybridOfferCatalogAdminControllerListLeadsResponse200 & {
    headers: Headers
  }
export type hybridOfferCatalogAdminControllerListLeadsResponse =
  hybridOfferCatalogAdminControllerListLeadsResponseSuccess

export const getHybridOfferCatalogAdminControllerListLeadsUrl = (
  params: HybridOfferCatalogAdminControllerListLeadsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/leads?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/leads`
}

export const hybridOfferCatalogAdminControllerListLeads = async (
  params: HybridOfferCatalogAdminControllerListLeadsParams,
  options?: RequestInit
): Promise<hybridOfferCatalogAdminControllerListLeadsResponse> => {
  return customInstance<hybridOfferCatalogAdminControllerListLeadsResponse>(
    getHybridOfferCatalogAdminControllerListLeadsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all book selection orders (admin)
 */
export type hybridOfferOrdersAdminControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrdersAdminControllerListResponseSuccess =
  hybridOfferOrdersAdminControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferOrdersAdminControllerListResponse =
  hybridOfferOrdersAdminControllerListResponseSuccess

export const getHybridOfferOrdersAdminControllerListUrl = (
  params?: HybridOfferOrdersAdminControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/orders?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/orders`
}

export const hybridOfferOrdersAdminControllerList = async (
  params?: HybridOfferOrdersAdminControllerListParams,
  options?: RequestInit
): Promise<hybridOfferOrdersAdminControllerListResponse> => {
  return customInstance<hybridOfferOrdersAdminControllerListResponse>(
    getHybridOfferOrdersAdminControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create book selection orders (admin)
 */
export type hybridOfferOrdersAdminControllerCreateResponse201 = {
  data: void
  status: 201
}

export type hybridOfferOrdersAdminControllerCreateResponseSuccess =
  hybridOfferOrdersAdminControllerCreateResponse201 & {
    headers: Headers
  }
export type hybridOfferOrdersAdminControllerCreateResponse =
  hybridOfferOrdersAdminControllerCreateResponseSuccess

export const getHybridOfferOrdersAdminControllerCreateUrl = () => {
  return `/api-arvore/admin/hybrid-offer/orders`
}

export const hybridOfferOrdersAdminControllerCreate = async (
  createOrderBodyDto: CreateOrderBodyDto,
  options?: RequestInit
): Promise<hybridOfferOrdersAdminControllerCreateResponse> => {
  return customInstance<hybridOfferOrdersAdminControllerCreateResponse>(
    getHybridOfferOrdersAdminControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createOrderBodyDto)
    }
  )
}

/**
 * @summary Get order detail with items and logs
 */
export type hybridOfferOrdersAdminControllerDetailResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrdersAdminControllerDetailResponseSuccess =
  hybridOfferOrdersAdminControllerDetailResponse200 & {
    headers: Headers
  }
export type hybridOfferOrdersAdminControllerDetailResponse =
  hybridOfferOrdersAdminControllerDetailResponseSuccess

export const getHybridOfferOrdersAdminControllerDetailUrl = (id: number) => {
  return `/api-arvore/admin/hybrid-offer/orders/${id}`
}

export const hybridOfferOrdersAdminControllerDetail = async (
  id: number,
  options?: RequestInit
): Promise<hybridOfferOrdersAdminControllerDetailResponse> => {
  return customInstance<hybridOfferOrdersAdminControllerDetailResponse>(
    getHybridOfferOrdersAdminControllerDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Approve or reject an order (admin)
 */
export type hybridOfferOrdersAdminControllerUpdateStatusResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrdersAdminControllerUpdateStatusResponseSuccess =
  hybridOfferOrdersAdminControllerUpdateStatusResponse200 & {
    headers: Headers
  }
export type hybridOfferOrdersAdminControllerUpdateStatusResponse =
  hybridOfferOrdersAdminControllerUpdateStatusResponseSuccess

export const getHybridOfferOrdersAdminControllerUpdateStatusUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/orders/${id}/status`
}

export const hybridOfferOrdersAdminControllerUpdateStatus = async (
  id: number,
  updateBookSelectionStatusBodyDto: UpdateBookSelectionStatusBodyDto,
  options?: RequestInit
): Promise<hybridOfferOrdersAdminControllerUpdateStatusResponse> => {
  return customInstance<hybridOfferOrdersAdminControllerUpdateStatusResponse>(
    getHybridOfferOrdersAdminControllerUpdateStatusUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateBookSelectionStatusBodyDto)
    }
  )
}

/**
 * @summary Search entities that have book selections
 */
export type hybridOfferOrdersAdminControllerSearchEntitiesResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrdersAdminControllerSearchEntitiesResponseSuccess =
  hybridOfferOrdersAdminControllerSearchEntitiesResponse200 & {
    headers: Headers
  }
export type hybridOfferOrdersAdminControllerSearchEntitiesResponse =
  hybridOfferOrdersAdminControllerSearchEntitiesResponseSuccess

export const getHybridOfferOrdersAdminControllerSearchEntitiesUrl = (
  params: HybridOfferOrdersAdminControllerSearchEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/orders/entities/search?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/orders/entities/search`
}

export const hybridOfferOrdersAdminControllerSearchEntities = async (
  params: HybridOfferOrdersAdminControllerSearchEntitiesParams,
  options?: RequestInit
): Promise<hybridOfferOrdersAdminControllerSearchEntitiesResponse> => {
  return customInstance<hybridOfferOrdersAdminControllerSearchEntitiesResponse>(
    getHybridOfferOrdersAdminControllerSearchEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List order deadline configs
 */
export type hybridOfferOrderDeadlinesAdminControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrderDeadlinesAdminControllerListResponseSuccess =
  hybridOfferOrderDeadlinesAdminControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferOrderDeadlinesAdminControllerListResponse =
  hybridOfferOrderDeadlinesAdminControllerListResponseSuccess

export const getHybridOfferOrderDeadlinesAdminControllerListUrl = (
  params?: HybridOfferOrderDeadlinesAdminControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/hybrid-offer/order-deadlines?${stringifiedParams}`
    : `/api-arvore/admin/hybrid-offer/order-deadlines`
}

export const hybridOfferOrderDeadlinesAdminControllerList = async (
  params?: HybridOfferOrderDeadlinesAdminControllerListParams,
  options?: RequestInit
): Promise<hybridOfferOrderDeadlinesAdminControllerListResponse> => {
  return customInstance<hybridOfferOrderDeadlinesAdminControllerListResponse>(
    getHybridOfferOrderDeadlinesAdminControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create order deadline config (global or entity override)
 */
export type hybridOfferOrderDeadlinesAdminControllerCreateResponse201 = {
  data: void
  status: 201
}

export type hybridOfferOrderDeadlinesAdminControllerCreateResponseSuccess =
  hybridOfferOrderDeadlinesAdminControllerCreateResponse201 & {
    headers: Headers
  }
export type hybridOfferOrderDeadlinesAdminControllerCreateResponse =
  hybridOfferOrderDeadlinesAdminControllerCreateResponseSuccess

export const getHybridOfferOrderDeadlinesAdminControllerCreateUrl = () => {
  return `/api-arvore/admin/hybrid-offer/order-deadlines`
}

export const hybridOfferOrderDeadlinesAdminControllerCreate = async (
  createOrderDeadlineBodyDto: CreateOrderDeadlineBodyDto,
  options?: RequestInit
): Promise<hybridOfferOrderDeadlinesAdminControllerCreateResponse> => {
  return customInstance<hybridOfferOrderDeadlinesAdminControllerCreateResponse>(
    getHybridOfferOrderDeadlinesAdminControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createOrderDeadlineBodyDto)
    }
  )
}

/**
 * @summary Update order deadline config
 */
export type hybridOfferOrderDeadlinesAdminControllerUpdateResponse200 = {
  data: void
  status: 200
}

export type hybridOfferOrderDeadlinesAdminControllerUpdateResponseSuccess =
  hybridOfferOrderDeadlinesAdminControllerUpdateResponse200 & {
    headers: Headers
  }
export type hybridOfferOrderDeadlinesAdminControllerUpdateResponse =
  hybridOfferOrderDeadlinesAdminControllerUpdateResponseSuccess

export const getHybridOfferOrderDeadlinesAdminControllerUpdateUrl = (
  id: number
) => {
  return `/api-arvore/admin/hybrid-offer/order-deadlines/${id}`
}

export const hybridOfferOrderDeadlinesAdminControllerUpdate = async (
  id: number,
  updateOrderDeadlineBodyDto: UpdateOrderDeadlineBodyDto,
  options?: RequestInit
): Promise<hybridOfferOrderDeadlinesAdminControllerUpdateResponse> => {
  return customInstance<hybridOfferOrderDeadlinesAdminControllerUpdateResponse>(
    getHybridOfferOrderDeadlinesAdminControllerUpdateUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateOrderDeadlineBodyDto)
    }
  )
}

/**
 * @summary Add a physical edition to the selection
 */
export type hybridOfferSelectionItemsControllerAddResponse201 = {
  data: void
  status: 201
}

export type hybridOfferSelectionItemsControllerAddResponseSuccess =
  hybridOfferSelectionItemsControllerAddResponse201 & {
    headers: Headers
  }
export type hybridOfferSelectionItemsControllerAddResponse =
  hybridOfferSelectionItemsControllerAddResponseSuccess

export const getHybridOfferSelectionItemsControllerAddUrl = (
  selectionId: number
) => {
  return `/api-arvore/hybrid-offer/selection/${selectionId}/items`
}

export const hybridOfferSelectionItemsControllerAdd = async (
  selectionId: number,
  addSelectionItemBodyDto: AddSelectionItemBodyDto,
  options?: RequestInit
): Promise<hybridOfferSelectionItemsControllerAddResponse> => {
  return customInstance<hybridOfferSelectionItemsControllerAddResponse>(
    getHybridOfferSelectionItemsControllerAddUrl(selectionId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(addSelectionItemBodyDto)
    }
  )
}

/**
 * @summary List all active items in the selection
 */
export type hybridOfferSelectionItemsControllerListResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionItemsControllerListResponseSuccess =
  hybridOfferSelectionItemsControllerListResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionItemsControllerListResponse =
  hybridOfferSelectionItemsControllerListResponseSuccess

export const getHybridOfferSelectionItemsControllerListUrl = (
  selectionId: number
) => {
  return `/api-arvore/hybrid-offer/selection/${selectionId}/items`
}

export const hybridOfferSelectionItemsControllerList = async (
  selectionId: number,
  options?: RequestInit
): Promise<hybridOfferSelectionItemsControllerListResponse> => {
  return customInstance<hybridOfferSelectionItemsControllerListResponse>(
    getHybridOfferSelectionItemsControllerListUrl(selectionId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Soft-delete an item from the selection
 */
export type hybridOfferSelectionItemsControllerRemoveResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSelectionItemsControllerRemoveResponseSuccess =
  hybridOfferSelectionItemsControllerRemoveResponse200 & {
    headers: Headers
  }
export type hybridOfferSelectionItemsControllerRemoveResponse =
  hybridOfferSelectionItemsControllerRemoveResponseSuccess

export const getHybridOfferSelectionItemsControllerRemoveUrl = (
  selectionId: number,
  itemId: number
) => {
  return `/api-arvore/hybrid-offer/selection/${selectionId}/items/${itemId}`
}

export const hybridOfferSelectionItemsControllerRemove = async (
  selectionId: number,
  itemId: number,
  options?: RequestInit
): Promise<hybridOfferSelectionItemsControllerRemoveResponse> => {
  return customInstance<hybridOfferSelectionItemsControllerRemoveResponse>(
    getHybridOfferSelectionItemsControllerRemoveUrl(selectionId, itemId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Receive HubSpot webhook to create book selections
 */
export type hybridOfferWebhookControllerHubspotWebhookResponse200 = {
  data: void
  status: 200
}

export type hybridOfferWebhookControllerHubspotWebhookResponse401 = {
  data: void
  status: 401
}

export type hybridOfferWebhookControllerHubspotWebhookResponseSuccess =
  hybridOfferWebhookControllerHubspotWebhookResponse200 & {
    headers: Headers
  }
export type hybridOfferWebhookControllerHubspotWebhookResponseError =
  hybridOfferWebhookControllerHubspotWebhookResponse401 & {
    headers: Headers
  }

export type hybridOfferWebhookControllerHubspotWebhookResponse =
  | hybridOfferWebhookControllerHubspotWebhookResponseSuccess
  | hybridOfferWebhookControllerHubspotWebhookResponseError

export const getHybridOfferWebhookControllerHubspotWebhookUrl = () => {
  return `/api-arvore/public/hybrid-offer/webhook/hubspot`
}

export const hybridOfferWebhookControllerHubspotWebhook = async (
  hubspotWebhookBodyDto: HubspotWebhookBodyDto,
  options?: RequestInit
): Promise<hybridOfferWebhookControllerHubspotWebhookResponse> => {
  return customInstance<hybridOfferWebhookControllerHubspotWebhookResponse>(
    getHybridOfferWebhookControllerHubspotWebhookUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(hubspotWebhookBodyDto)
    }
  )
}

/**
 * @summary Trigger hybrid offer deals sync manually
 */
export type hybridOfferSyncControllerTriggerResponse200 = {
  data: void
  status: 200
}

export type hybridOfferSyncControllerTriggerResponseSuccess =
  hybridOfferSyncControllerTriggerResponse200 & {
    headers: Headers
  }
export type hybridOfferSyncControllerTriggerResponse =
  hybridOfferSyncControllerTriggerResponseSuccess

export const getHybridOfferSyncControllerTriggerUrl = () => {
  return `/api-arvore/admin/hybrid-offer/sync-deals/trigger`
}

export const hybridOfferSyncControllerTrigger = async (
  options?: RequestInit
): Promise<hybridOfferSyncControllerTriggerResponse> => {
  return customInstance<hybridOfferSyncControllerTriggerResponse>(
    getHybridOfferSyncControllerTriggerUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Find or create hybrid offer tutorial for current user
 */
export type hybridOfferTutorialControllerFindOrCreateResponse200 = {
  data: TutorialResponseDto
  status: 200
}

export type hybridOfferTutorialControllerFindOrCreateResponseSuccess =
  hybridOfferTutorialControllerFindOrCreateResponse200 & {
    headers: Headers
  }
export type hybridOfferTutorialControllerFindOrCreateResponse =
  hybridOfferTutorialControllerFindOrCreateResponseSuccess

export const getHybridOfferTutorialControllerFindOrCreateUrl = () => {
  return `/api-arvore/hybrid-offer/tutorial`
}

export const hybridOfferTutorialControllerFindOrCreate = async (
  options?: RequestInit
): Promise<hybridOfferTutorialControllerFindOrCreateResponse> => {
  return customInstance<hybridOfferTutorialControllerFindOrCreateResponse>(
    getHybridOfferTutorialControllerFindOrCreateUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update hybrid offer tutorial state
 */
export type hybridOfferTutorialControllerUpdateResponse200 = {
  data: TutorialResponseDto
  status: 200
}

export type hybridOfferTutorialControllerUpdateResponseSuccess =
  hybridOfferTutorialControllerUpdateResponse200 & {
    headers: Headers
  }
export type hybridOfferTutorialControllerUpdateResponse =
  hybridOfferTutorialControllerUpdateResponseSuccess

export const getHybridOfferTutorialControllerUpdateUrl = () => {
  return `/api-arvore/hybrid-offer/tutorial`
}

export const hybridOfferTutorialControllerUpdate = async (
  updateTutorialDto: UpdateTutorialDto,
  options?: RequestInit
): Promise<hybridOfferTutorialControllerUpdateResponse> => {
  return customInstance<hybridOfferTutorialControllerUpdateResponse>(
    getHybridOfferTutorialControllerUpdateUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateTutorialDto)
    }
  )
}

/**
 * @summary List email logs for an entity (DynamoDB + SendGrid status)
 */
export type hybridOfferEmailAdminControllerEmailLogsResponse200 = {
  data: EmailLogsResponseDto
  status: 200
}

export type hybridOfferEmailAdminControllerEmailLogsResponseSuccess =
  hybridOfferEmailAdminControllerEmailLogsResponse200 & {
    headers: Headers
  }
export type hybridOfferEmailAdminControllerEmailLogsResponse =
  hybridOfferEmailAdminControllerEmailLogsResponseSuccess

export const getHybridOfferEmailAdminControllerEmailLogsUrl = (
  entityId: number
) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/email-logs`
}

export const hybridOfferEmailAdminControllerEmailLogs = async (
  entityId: number,
  options?: RequestInit
): Promise<hybridOfferEmailAdminControllerEmailLogsResponse> => {
  return customInstance<hybridOfferEmailAdminControllerEmailLogsResponse>(
    getHybridOfferEmailAdminControllerEmailLogsUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List directors/coordinators who receive hybrid offer emails
 */
export type hybridOfferEmailAdminControllerEmailRecipientsResponse200 = {
  data: EmailRecipientsResponseDto
  status: 200
}

export type hybridOfferEmailAdminControllerEmailRecipientsResponseSuccess =
  hybridOfferEmailAdminControllerEmailRecipientsResponse200 & {
    headers: Headers
  }
export type hybridOfferEmailAdminControllerEmailRecipientsResponse =
  hybridOfferEmailAdminControllerEmailRecipientsResponseSuccess

export const getHybridOfferEmailAdminControllerEmailRecipientsUrl = (
  entityId: number
) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/email-recipients`
}

export const hybridOfferEmailAdminControllerEmailRecipients = async (
  entityId: number,
  options?: RequestInit
): Promise<hybridOfferEmailAdminControllerEmailRecipientsResponse> => {
  return customInstance<hybridOfferEmailAdminControllerEmailRecipientsResponse>(
    getHybridOfferEmailAdminControllerEmailRecipientsUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all admin profiles for an entity (to assign director/coordinator)
 */
export type hybridOfferEmailAdminControllerAdminProfilesResponse200 = {
  data: AdminProfilesResponseDto
  status: 200
}

export type hybridOfferEmailAdminControllerAdminProfilesResponseSuccess =
  hybridOfferEmailAdminControllerAdminProfilesResponse200 & {
    headers: Headers
  }
export type hybridOfferEmailAdminControllerAdminProfilesResponse =
  hybridOfferEmailAdminControllerAdminProfilesResponseSuccess

export const getHybridOfferEmailAdminControllerAdminProfilesUrl = (
  entityId: number
) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/admin-profiles`
}

export const hybridOfferEmailAdminControllerAdminProfiles = async (
  entityId: number,
  options?: RequestInit
): Promise<hybridOfferEmailAdminControllerAdminProfilesResponse> => {
  return customInstance<hybridOfferEmailAdminControllerAdminProfilesResponse>(
    getHybridOfferEmailAdminControllerAdminProfilesUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update admin profile role to Diretor or Coordenador
 */
export type hybridOfferEmailAdminControllerUpdateRoleResponse200 = {
  data: UpdateRoleResponseDto
  status: 200
}

export type hybridOfferEmailAdminControllerUpdateRoleResponseSuccess =
  hybridOfferEmailAdminControllerUpdateRoleResponse200 & {
    headers: Headers
  }
export type hybridOfferEmailAdminControllerUpdateRoleResponse =
  hybridOfferEmailAdminControllerUpdateRoleResponseSuccess

export const getHybridOfferEmailAdminControllerUpdateRoleUrl = (
  entityId: number,
  profileId: number
) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/admin-profiles/${profileId}/role`
}

export const hybridOfferEmailAdminControllerUpdateRole = async (
  entityId: number,
  profileId: number,
  updateRoleBodyDto: UpdateRoleBodyDto,
  options?: RequestInit
): Promise<hybridOfferEmailAdminControllerUpdateRoleResponse> => {
  return customInstance<hybridOfferEmailAdminControllerUpdateRoleResponse>(
    getHybridOfferEmailAdminControllerUpdateRoleUrl(entityId, profileId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateRoleBodyDto)
    }
  )
}

/**
 * @summary Send the selection released email to selected recipients
 */
export type hybridOfferEmailAdminControllerResendSelectionReleasedResponse200 =
  {
    data: ResendSelectionReleasedResponseDto
    status: 200
  }

export type hybridOfferEmailAdminControllerResendSelectionReleasedResponseSuccess =
  hybridOfferEmailAdminControllerResendSelectionReleasedResponse200 & {
    headers: Headers
  }
export type hybridOfferEmailAdminControllerResendSelectionReleasedResponse =
  hybridOfferEmailAdminControllerResendSelectionReleasedResponseSuccess

export const getHybridOfferEmailAdminControllerResendSelectionReleasedUrl = (
  entityId: number
) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/resend-selection-released`
}

export const hybridOfferEmailAdminControllerResendSelectionReleased = async (
  entityId: number,
  resendSelectionReleasedBodyDto: ResendSelectionReleasedBodyDto,
  options?: RequestInit
): Promise<hybridOfferEmailAdminControllerResendSelectionReleasedResponse> => {
  return customInstance<hybridOfferEmailAdminControllerResendSelectionReleasedResponse>(
    getHybridOfferEmailAdminControllerResendSelectionReleasedUrl(entityId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resendSelectionReleasedBodyDto)
    }
  )
}

/**
 * @summary List orders in the assembly line (kanban board)
 */
export type omsAssemblyControllerAssemblyResponse200 = {
  data: AssemblyOrderListResponseDto
  status: 200
}

export type omsAssemblyControllerAssemblyResponseSuccess =
  omsAssemblyControllerAssemblyResponse200 & {
    headers: Headers
  }
export type omsAssemblyControllerAssemblyResponse =
  omsAssemblyControllerAssemblyResponseSuccess

export const getOmsAssemblyControllerAssemblyUrl = (
  params?: OmsAssemblyControllerAssemblyParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/orders/assembly?${stringifiedParams}`
    : `/api-arvore/admin/oms/orders/assembly`
}

export const omsAssemblyControllerAssembly = async (
  params?: OmsAssemblyControllerAssemblyParams,
  options?: RequestInit
): Promise<omsAssemblyControllerAssemblyResponse> => {
  return customInstance<omsAssemblyControllerAssemblyResponse>(
    getOmsAssemblyControllerAssemblyUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Resolve a kit label code to its order
 */
export type omsAssemblyControllerResolveKitCodeResponse200 = {
  data: ResolveKitCodeResponseDto
  status: 200
}

export type omsAssemblyControllerResolveKitCodeResponseSuccess =
  omsAssemblyControllerResolveKitCodeResponse200 & {
    headers: Headers
  }
export type omsAssemblyControllerResolveKitCodeResponse =
  omsAssemblyControllerResolveKitCodeResponseSuccess

export const getOmsAssemblyControllerResolveKitCodeUrl = (code: string) => {
  return `/api-arvore/admin/oms/orders/assembly/resolve-kit/${code}`
}

export const omsAssemblyControllerResolveKitCode = async (
  code: string,
  options?: RequestInit
): Promise<omsAssemblyControllerResolveKitCodeResponse> => {
  return customInstance<omsAssemblyControllerResolveKitCodeResponse>(
    getOmsAssemblyControllerResolveKitCodeUrl(code),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List orders ready to assemble (assembly_status = picking)
 */
export type omsAssemblyControllerPickingOrdersResponse200 = {
  data: PickingOrdersResponseDto
  status: 200
}

export type omsAssemblyControllerPickingOrdersResponseSuccess =
  omsAssemblyControllerPickingOrdersResponse200 & {
    headers: Headers
  }
export type omsAssemblyControllerPickingOrdersResponse =
  omsAssemblyControllerPickingOrdersResponseSuccess

export const getOmsAssemblyControllerPickingOrdersUrl = () => {
  return `/api-arvore/admin/oms/orders/assembly/picking-orders`
}

export const omsAssemblyControllerPickingOrders = async (
  options?: RequestInit
): Promise<omsAssemblyControllerPickingOrdersResponse> => {
  return customInstance<omsAssemblyControllerPickingOrdersResponse>(
    getOmsAssemblyControllerPickingOrdersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Preview coverage split before sending orders to the assembly line
 */
export type omsAssemblyControllerPreviewAssemblyResponse201 = {
  data: PreviewAssemblyResponseDto
  status: 201
}

export type omsAssemblyControllerPreviewAssemblyResponseSuccess =
  omsAssemblyControllerPreviewAssemblyResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerPreviewAssemblyResponse =
  omsAssemblyControllerPreviewAssemblyResponseSuccess

export const getOmsAssemblyControllerPreviewAssemblyUrl = () => {
  return `/api-arvore/admin/oms/orders/send-to-assembly/preview`
}

export const omsAssemblyControllerPreviewAssembly = async (
  previewAssemblyBodyDto: PreviewAssemblyBodyDto,
  options?: RequestInit
): Promise<omsAssemblyControllerPreviewAssemblyResponse> => {
  return customInstance<omsAssemblyControllerPreviewAssemblyResponse>(
    getOmsAssemblyControllerPreviewAssemblyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(previewAssemblyBodyDto)
    }
  )
}

/**
 * @summary Send submitted orders to the assembly line (respecting queue order)
 */
export type omsAssemblyControllerSendToAssemblyResponse201 = {
  data: SendToAssemblyResponseDto
  status: 201
}

export type omsAssemblyControllerSendToAssemblyResponseSuccess =
  omsAssemblyControllerSendToAssemblyResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerSendToAssemblyResponse =
  omsAssemblyControllerSendToAssemblyResponseSuccess

export const getOmsAssemblyControllerSendToAssemblyUrl = () => {
  return `/api-arvore/admin/oms/orders/send-to-assembly`
}

export const omsAssemblyControllerSendToAssembly = async (
  sendToAssemblyBodyDto: SendToAssemblyBodyDto,
  options?: RequestInit
): Promise<omsAssemblyControllerSendToAssemblyResponse> => {
  return customInstance<omsAssemblyControllerSendToAssemblyResponse>(
    getOmsAssemblyControllerSendToAssemblyUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sendToAssemblyBodyDto)
    }
  )
}

/**
 * @summary Cancel an order in the assembly queue and release reserved stock
 */
export type omsAssemblyControllerCancelAssemblyResponse201 = {
  data: CancelAssemblyOrderResponseDto
  status: 201
}

export type omsAssemblyControllerCancelAssemblyResponseSuccess =
  omsAssemblyControllerCancelAssemblyResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerCancelAssemblyResponse =
  omsAssemblyControllerCancelAssemblyResponseSuccess

export const getOmsAssemblyControllerCancelAssemblyUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/cancel-assembly`
}

export const omsAssemblyControllerCancelAssembly = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerCancelAssemblyResponse> => {
  return customInstance<omsAssemblyControllerCancelAssemblyResponse>(
    getOmsAssemblyControllerCancelAssemblyUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Start picking an order (queued -> picking), generates and stores print documents
 */
export type omsAssemblyControllerStartPickingResponse201 = {
  data: StartPickingResponseDto
  status: 201
}

export type omsAssemblyControllerStartPickingResponseSuccess =
  omsAssemblyControllerStartPickingResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerStartPickingResponse =
  omsAssemblyControllerStartPickingResponseSuccess

export const getOmsAssemblyControllerStartPickingUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/start-picking`
}

export const omsAssemblyControllerStartPicking = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerStartPickingResponse> => {
  return customInstance<omsAssemblyControllerStartPickingResponse>(
    getOmsAssemblyControllerStartPickingUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Kit assembly session state (groups, locks, progress)
 */
export type omsAssemblyControllerAssemblySessionResponse200 = {
  data: AssemblySessionResponseDto
  status: 200
}

export type omsAssemblyControllerAssemblySessionResponseSuccess =
  omsAssemblyControllerAssemblySessionResponse200 & {
    headers: Headers
  }
export type omsAssemblyControllerAssemblySessionResponse =
  omsAssemblyControllerAssemblySessionResponseSuccess

export const getOmsAssemblyControllerAssemblySessionUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/assembly-session`
}

export const omsAssemblyControllerAssemblySession = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerAssemblySessionResponse> => {
  return customInstance<omsAssemblyControllerAssemblySessionResponse>(
    getOmsAssemblyControllerAssemblySessionUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Claim the next free kit group for assembly (locks it to the operator)
 */
export type omsAssemblyControllerClaimGroupResponse201 = {
  data: ClaimGroupResponseDto
  status: 201
}

export type omsAssemblyControllerClaimGroupResponseSuccess =
  omsAssemblyControllerClaimGroupResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerClaimGroupResponse =
  omsAssemblyControllerClaimGroupResponseSuccess

export const getOmsAssemblyControllerClaimGroupUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/assembly/claim-group`
}

export const omsAssemblyControllerClaimGroup = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerClaimGroupResponse> => {
  return customInstance<omsAssemblyControllerClaimGroupResponse>(
    getOmsAssemblyControllerClaimGroupUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Scan a book ISBN into the operator current kit unit
 */
export type omsAssemblyControllerScanResponse201 = {
  data: ScanResponseDto
  status: 201
}

export type omsAssemblyControllerScanResponseSuccess =
  omsAssemblyControllerScanResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerScanResponse =
  omsAssemblyControllerScanResponseSuccess

export const getOmsAssemblyControllerScanUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/scan`
}

export const omsAssemblyControllerScan = async (
  id: number,
  scanBodyDto: ScanBodyDto,
  options?: RequestInit
): Promise<omsAssemblyControllerScanResponse> => {
  return customInstance<omsAssemblyControllerScanResponse>(
    getOmsAssemblyControllerScanUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(scanBodyDto)
    }
  )
}

/**
 * @summary Undo the last scan of the operator current kit unit
 */
export type omsAssemblyControllerUndoLastScanResponse201 = {
  data: UndoLastScanResponseDto
  status: 201
}

export type omsAssemblyControllerUndoLastScanResponseSuccess =
  omsAssemblyControllerUndoLastScanResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerUndoLastScanResponse =
  omsAssemblyControllerUndoLastScanResponseSuccess

export const getOmsAssemblyControllerUndoLastScanUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/assembly/undo-last-scan`
}

export const omsAssemblyControllerUndoLastScan = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerUndoLastScanResponse> => {
  return customInstance<omsAssemblyControllerUndoLastScanResponse>(
    getOmsAssemblyControllerUndoLastScanUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Discard the operator in-progress kit unit (scans + lock)
 */
export type omsAssemblyControllerDiscardActiveUnitResponse201 = {
  data: DiscardActiveUnitResponseDto
  status: 201
}

export type omsAssemblyControllerDiscardActiveUnitResponseSuccess =
  omsAssemblyControllerDiscardActiveUnitResponse201 & {
    headers: Headers
  }
export type omsAssemblyControllerDiscardActiveUnitResponse =
  omsAssemblyControllerDiscardActiveUnitResponseSuccess

export const getOmsAssemblyControllerDiscardActiveUnitUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/assembly/discard`
}

export const omsAssemblyControllerDiscardActiveUnit = async (
  id: number,
  options?: RequestInit
): Promise<omsAssemblyControllerDiscardActiveUnitResponse> => {
  return customInstance<omsAssemblyControllerDiscardActiveUnitResponse>(
    getOmsAssemblyControllerDiscardActiveUnitUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Order data for separation list and assembly map printing
 */
export type omsOrderPrintControllerPrintResponse200 = {
  data: OmsOrderPrintResponseDto
  status: 200
}

export type omsOrderPrintControllerPrintResponseSuccess =
  omsOrderPrintControllerPrintResponse200 & {
    headers: Headers
  }
export type omsOrderPrintControllerPrintResponse =
  omsOrderPrintControllerPrintResponseSuccess

export const getOmsOrderPrintControllerPrintUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/print`
}

export const omsOrderPrintControllerPrint = async (
  id: number,
  options?: RequestInit
): Promise<omsOrderPrintControllerPrintResponse> => {
  return customInstance<omsOrderPrintControllerPrintResponse>(
    getOmsOrderPrintControllerPrintUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List stored print documents (separation / assembly map) for an order
 */
export type omsOrderPrintControllerPrintLogsResponse200 = {
  data: OmsPrintLogListResponseDto
  status: 200
}

export type omsOrderPrintControllerPrintLogsResponseSuccess =
  omsOrderPrintControllerPrintLogsResponse200 & {
    headers: Headers
  }
export type omsOrderPrintControllerPrintLogsResponse =
  omsOrderPrintControllerPrintLogsResponseSuccess

export const getOmsOrderPrintControllerPrintLogsUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/print-logs`
}

export const omsOrderPrintControllerPrintLogs = async (
  id: number,
  options?: RequestInit
): Promise<omsOrderPrintControllerPrintLogsResponse> => {
  return customInstance<omsOrderPrintControllerPrintLogsResponse>(
    getOmsOrderPrintControllerPrintLogsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Generate and store kit labels (15x10cm, QR + box destination) for an order
 */
export type omsOrderPrintControllerGenerateKitLabelsResponse201 = {
  data: OmsPrintDownloadResponseDto
  status: 201
}

export type omsOrderPrintControllerGenerateKitLabelsResponseSuccess =
  omsOrderPrintControllerGenerateKitLabelsResponse201 & {
    headers: Headers
  }
export type omsOrderPrintControllerGenerateKitLabelsResponse =
  omsOrderPrintControllerGenerateKitLabelsResponseSuccess

export const getOmsOrderPrintControllerGenerateKitLabelsUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/kit-labels`
}

export const omsOrderPrintControllerGenerateKitLabels = async (
  id: number,
  options?: RequestInit
): Promise<omsOrderPrintControllerGenerateKitLabelsResponse> => {
  return customInstance<omsOrderPrintControllerGenerateKitLabelsResponse>(
    getOmsOrderPrintControllerGenerateKitLabelsUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Generate and store box labels (QR with box code) for an order
 */
export type omsOrderPrintControllerGenerateBoxLabelsResponse201 = {
  data: OmsPrintDownloadResponseDto
  status: 201
}

export type omsOrderPrintControllerGenerateBoxLabelsResponseSuccess =
  omsOrderPrintControllerGenerateBoxLabelsResponse201 & {
    headers: Headers
  }
export type omsOrderPrintControllerGenerateBoxLabelsResponse =
  omsOrderPrintControllerGenerateBoxLabelsResponseSuccess

export const getOmsOrderPrintControllerGenerateBoxLabelsUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/box-labels`
}

export const omsOrderPrintControllerGenerateBoxLabels = async (
  id: number,
  options?: RequestInit
): Promise<omsOrderPrintControllerGenerateBoxLabelsResponse> => {
  return customInstance<omsOrderPrintControllerGenerateBoxLabelsResponse>(
    getOmsOrderPrintControllerGenerateBoxLabelsUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Get a temporary signed URL to download the latest stored print document
 */
export type omsOrderPrintControllerDownloadPrintDocumentResponse200 = {
  data: OmsPrintDownloadResponseDto
  status: 200
}

export type omsOrderPrintControllerDownloadPrintDocumentResponseSuccess =
  omsOrderPrintControllerDownloadPrintDocumentResponse200 & {
    headers: Headers
  }
export type omsOrderPrintControllerDownloadPrintDocumentResponse =
  omsOrderPrintControllerDownloadPrintDocumentResponseSuccess

export const getOmsOrderPrintControllerDownloadPrintDocumentUrl = (
  id: number,
  documentType: string
) => {
  return `/api-arvore/admin/oms/orders/${id}/print-logs/${documentType}/download`
}

export const omsOrderPrintControllerDownloadPrintDocument = async (
  id: number,
  documentType: string,
  options?: RequestInit
): Promise<omsOrderPrintControllerDownloadPrintDocumentResponse> => {
  return customInstance<omsOrderPrintControllerDownloadPrintDocumentResponse>(
    getOmsOrderPrintControllerDownloadPrintDocumentUrl(id, documentType),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List OMS orders
 */
export type omsOrdersControllerListResponse200 = {
  data: OmsOrderListResponseDto
  status: 200
}

export type omsOrdersControllerListResponseSuccess =
  omsOrdersControllerListResponse200 & {
    headers: Headers
  }
export type omsOrdersControllerListResponse =
  omsOrdersControllerListResponseSuccess

export const getOmsOrdersControllerListUrl = (
  params?: OmsOrdersControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/orders?${stringifiedParams}`
    : `/api-arvore/admin/oms/orders`
}

export const omsOrdersControllerList = async (
  params?: OmsOrdersControllerListParams,
  options?: RequestInit
): Promise<omsOrdersControllerListResponse> => {
  return customInstance<omsOrdersControllerListResponse>(
    getOmsOrdersControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create standalone order
 */
export type omsOrdersControllerCreateStandaloneResponse201 = {
  data: OmsCreateOrderResponseDto
  status: 201
}

export type omsOrdersControllerCreateStandaloneResponseSuccess =
  omsOrdersControllerCreateStandaloneResponse201 & {
    headers: Headers
  }
export type omsOrdersControllerCreateStandaloneResponse =
  omsOrdersControllerCreateStandaloneResponseSuccess

export const getOmsOrdersControllerCreateStandaloneUrl = () => {
  return `/api-arvore/admin/oms/orders`
}

export const omsOrdersControllerCreateStandalone = async (
  createStandaloneOrderBodyDto: CreateStandaloneOrderBodyDto,
  options?: RequestInit
): Promise<omsOrdersControllerCreateStandaloneResponse> => {
  return customInstance<omsOrdersControllerCreateStandaloneResponse>(
    getOmsOrdersControllerCreateStandaloneUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createStandaloneOrderBodyDto)
    }
  )
}

/**
 * @summary Get order detail
 */
export type omsOrdersControllerDetailResponse200 = {
  data: OmsOrderDetailResponseDto
  status: 200
}

export type omsOrdersControllerDetailResponseSuccess =
  omsOrdersControllerDetailResponse200 & {
    headers: Headers
  }
export type omsOrdersControllerDetailResponse =
  omsOrdersControllerDetailResponseSuccess

export const getOmsOrdersControllerDetailUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}`
}

export const omsOrdersControllerDetail = async (
  id: number,
  options?: RequestInit
): Promise<omsOrdersControllerDetailResponse> => {
  return customInstance<omsOrdersControllerDetailResponse>(
    getOmsOrdersControllerDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete order and its kits
 */
export type omsOrdersControllerRemoveResponse200 = {
  data: OmsDeleteOrderResponseDto
  status: 200
}

export type omsOrdersControllerRemoveResponseSuccess =
  omsOrdersControllerRemoveResponse200 & {
    headers: Headers
  }
export type omsOrdersControllerRemoveResponse =
  omsOrdersControllerRemoveResponseSuccess

export const getOmsOrdersControllerRemoveUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}`
}

export const omsOrdersControllerRemove = async (
  id: number,
  options?: RequestInit
): Promise<omsOrdersControllerRemoveResponse> => {
  return customInstance<omsOrdersControllerRemoveResponse>(
    getOmsOrdersControllerRemoveUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Submit order (freeze demand from book_selection)
 */
export type omsOrdersControllerSubmitResponse201 = {
  data: OmsSubmitOrderResponseDto
  status: 201
}

export type omsOrdersControllerSubmitResponseSuccess =
  omsOrdersControllerSubmitResponse201 & {
    headers: Headers
  }
export type omsOrdersControllerSubmitResponse =
  omsOrdersControllerSubmitResponseSuccess

export const getOmsOrdersControllerSubmitUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/submit`
}

export const omsOrdersControllerSubmit = async (
  id: number,
  options?: RequestInit
): Promise<omsOrdersControllerSubmitResponse> => {
  return customInstance<omsOrdersControllerSubmitResponse>(
    getOmsOrdersControllerSubmitUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Reorder assembly queue priority
 */
export type omsOrdersControllerReorderResponse200 = {
  data: ReorderOrdersResponseDto
  status: 200
}

export type omsOrdersControllerReorderResponseSuccess =
  omsOrdersControllerReorderResponse200 & {
    headers: Headers
  }
export type omsOrdersControllerReorderResponse =
  omsOrdersControllerReorderResponseSuccess

export const getOmsOrdersControllerReorderUrl = () => {
  return `/api-arvore/admin/oms/orders/reorder`
}

export const omsOrdersControllerReorder = async (
  reorderOrdersBodyDto: ReorderOrdersBodyDto,
  options?: RequestInit
): Promise<omsOrdersControllerReorderResponse> => {
  return customInstance<omsOrdersControllerReorderResponse>(
    getOmsOrdersControllerReorderUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reorderOrdersBodyDto)
    }
  )
}

/**
 * @summary List purchases
 */
export type omsPurchasingControllerListPurchasesResponse200 = {
  data: OmsPurchaseListResponseDto
  status: 200
}

export type omsPurchasingControllerListPurchasesResponseSuccess =
  omsPurchasingControllerListPurchasesResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerListPurchasesResponse =
  omsPurchasingControllerListPurchasesResponseSuccess

export const getOmsPurchasingControllerListPurchasesUrl = (
  params?: OmsPurchasingControllerListPurchasesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/purchases?${stringifiedParams}`
    : `/api-arvore/admin/oms/purchases`
}

export const omsPurchasingControllerListPurchases = async (
  params?: OmsPurchasingControllerListPurchasesParams,
  options?: RequestInit
): Promise<omsPurchasingControllerListPurchasesResponse> => {
  return customInstance<omsPurchasingControllerListPurchasesResponse>(
    getOmsPurchasingControllerListPurchasesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a purchase
 */
export type omsPurchasingControllerCreatePurchaseResponse201 = {
  data: OmsCreatePurchaseResponseDto
  status: 201
}

export type omsPurchasingControllerCreatePurchaseResponseSuccess =
  omsPurchasingControllerCreatePurchaseResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerCreatePurchaseResponse =
  omsPurchasingControllerCreatePurchaseResponseSuccess

export const getOmsPurchasingControllerCreatePurchaseUrl = () => {
  return `/api-arvore/admin/oms/purchases`
}

export const omsPurchasingControllerCreatePurchase = async (
  createPurchaseBodyDto: CreatePurchaseBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerCreatePurchaseResponse> => {
  return customInstance<omsPurchasingControllerCreatePurchaseResponse>(
    getOmsPurchasingControllerCreatePurchaseUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createPurchaseBodyDto)
    }
  )
}

/**
 * @summary List items of a purchase
 */
export type omsPurchasingControllerPurchaseItemsResponse200 = {
  data: OmsPurchaseItemsResponseDto
  status: 200
}

export type omsPurchasingControllerPurchaseItemsResponseSuccess =
  omsPurchasingControllerPurchaseItemsResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerPurchaseItemsResponse =
  omsPurchasingControllerPurchaseItemsResponseSuccess

export const getOmsPurchasingControllerPurchaseItemsUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/items`
}

export const omsPurchasingControllerPurchaseItems = async (
  id: number,
  options?: RequestInit
): Promise<omsPurchasingControllerPurchaseItemsResponse> => {
  return customInstance<omsPurchasingControllerPurchaseItemsResponse>(
    getOmsPurchasingControllerPurchaseItemsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List history events of a purchase
 */
export type omsPurchasingControllerPurchaseEventsResponse200 = {
  data: OmsPurchaseEventsResponseDto
  status: 200
}

export type omsPurchasingControllerPurchaseEventsResponseSuccess =
  omsPurchasingControllerPurchaseEventsResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerPurchaseEventsResponse =
  omsPurchasingControllerPurchaseEventsResponseSuccess

export const getOmsPurchasingControllerPurchaseEventsUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/events`
}

export const omsPurchasingControllerPurchaseEvents = async (
  id: number,
  options?: RequestInit
): Promise<omsPurchasingControllerPurchaseEventsResponse> => {
  return customInstance<omsPurchasingControllerPurchaseEventsResponse>(
    getOmsPurchasingControllerPurchaseEventsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Current stock state per SKU
 */
export type omsPurchasingControllerStockResponse200 = {
  data: OmsStockListResponseDto
  status: 200
}

export type omsPurchasingControllerStockResponseSuccess =
  omsPurchasingControllerStockResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerStockResponse =
  omsPurchasingControllerStockResponseSuccess

export const getOmsPurchasingControllerStockUrl = (
  params?: OmsPurchasingControllerStockParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/stock?${stringifiedParams}`
    : `/api-arvore/admin/oms/stock`
}

export const omsPurchasingControllerStock = async (
  params?: OmsPurchasingControllerStockParams,
  options?: RequestInit
): Promise<omsPurchasingControllerStockResponse> => {
  return customInstance<omsPurchasingControllerStockResponse>(
    getOmsPurchasingControllerStockUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Aggregated demand per SKU for purchasing
 */
export type omsPurchasingControllerDemandResponse200 = {
  data: OmsDemandResponseDto
  status: 200
}

export type omsPurchasingControllerDemandResponseSuccess =
  omsPurchasingControllerDemandResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerDemandResponse =
  omsPurchasingControllerDemandResponseSuccess

export const getOmsPurchasingControllerDemandUrl = (
  params?: OmsPurchasingControllerDemandParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/purchasing/demand?${stringifiedParams}`
    : `/api-arvore/admin/oms/purchasing/demand`
}

export const omsPurchasingControllerDemand = async (
  params?: OmsPurchasingControllerDemandParams,
  options?: RequestInit
): Promise<omsPurchasingControllerDemandResponse> => {
  return customInstance<omsPurchasingControllerDemandResponse>(
    getOmsPurchasingControllerDemandUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Kardex (histórico com saldo acumulado) de um SKU
 */
export type omsPurchasingControllerStockMovementsResponse200 = {
  data: OmsStockMovementsResponseDto
  status: 200
}

export type omsPurchasingControllerStockMovementsResponseSuccess =
  omsPurchasingControllerStockMovementsResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerStockMovementsResponse =
  omsPurchasingControllerStockMovementsResponseSuccess

export const getOmsPurchasingControllerStockMovementsUrl = (
  omsSkuId: string,
  params?: OmsPurchasingControllerStockMovementsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/stock/${omsSkuId}/movements?${stringifiedParams}`
    : `/api-arvore/admin/oms/stock/${omsSkuId}/movements`
}

export const omsPurchasingControllerStockMovements = async (
  omsSkuId: string,
  params?: OmsPurchasingControllerStockMovementsParams,
  options?: RequestInit
): Promise<omsPurchasingControllerStockMovementsResponse> => {
  return customInstance<omsPurchasingControllerStockMovementsResponse>(
    getOmsPurchasingControllerStockMovementsUrl(omsSkuId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Cancel a pending purchase
 */
export type omsPurchasingControllerCancelPurchaseResponse201 = {
  data: OmsCancelPurchaseResponseDto
  status: 201
}

export type omsPurchasingControllerCancelPurchaseResponseSuccess =
  omsPurchasingControllerCancelPurchaseResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerCancelPurchaseResponse =
  omsPurchasingControllerCancelPurchaseResponseSuccess

export const getOmsPurchasingControllerCancelPurchaseUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/cancel`
}

export const omsPurchasingControllerCancelPurchase = async (
  id: number,
  options?: RequestInit
): Promise<omsPurchasingControllerCancelPurchaseResponse> => {
  return customInstance<omsPurchasingControllerCancelPurchaseResponse>(
    getOmsPurchasingControllerCancelPurchaseUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update purchase notes
 */
export type omsPurchasingControllerUpdatePurchaseNotesResponse200 = {
  data: OmsUpdatePurchaseNotesResponseDto
  status: 200
}

export type omsPurchasingControllerUpdatePurchaseNotesResponseSuccess =
  omsPurchasingControllerUpdatePurchaseNotesResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerUpdatePurchaseNotesResponse =
  omsPurchasingControllerUpdatePurchaseNotesResponseSuccess

export const getOmsPurchasingControllerUpdatePurchaseNotesUrl = (
  id: number
) => {
  return `/api-arvore/admin/oms/purchases/${id}/notes`
}

export const omsPurchasingControllerUpdatePurchaseNotes = async (
  id: number,
  updatePurchaseNotesBodyDto: UpdatePurchaseNotesBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerUpdatePurchaseNotesResponse> => {
  return customInstance<omsPurchasingControllerUpdatePurchaseNotesResponse>(
    getOmsPurchasingControllerUpdatePurchaseNotesUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updatePurchaseNotesBodyDto)
    }
  )
}

/**
 * @summary Update purchase order number
 */
export type omsPurchasingControllerUpdatePurchaseOrderNumberResponse200 = {
  data: void
  status: 200
}

export type omsPurchasingControllerUpdatePurchaseOrderNumberResponseSuccess =
  omsPurchasingControllerUpdatePurchaseOrderNumberResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerUpdatePurchaseOrderNumberResponse =
  omsPurchasingControllerUpdatePurchaseOrderNumberResponseSuccess

export const getOmsPurchasingControllerUpdatePurchaseOrderNumberUrl = (
  id: number
) => {
  return `/api-arvore/admin/oms/purchases/${id}/purchase-order-number`
}

export const omsPurchasingControllerUpdatePurchaseOrderNumber = async (
  id: number,
  updatePurchaseOrderNumberBodyDto: UpdatePurchaseOrderNumberBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerUpdatePurchaseOrderNumberResponse> => {
  return customInstance<omsPurchasingControllerUpdatePurchaseOrderNumberResponse>(
    getOmsPurchasingControllerUpdatePurchaseOrderNumberUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updatePurchaseOrderNumberBodyDto)
    }
  )
}

/**
 * @summary Update purchase expected arrival date
 */
export type omsPurchasingControllerUpdatePurchaseExpectedArrivalResponse200 = {
  data: void
  status: 200
}

export type omsPurchasingControllerUpdatePurchaseExpectedArrivalResponseSuccess =
  omsPurchasingControllerUpdatePurchaseExpectedArrivalResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerUpdatePurchaseExpectedArrivalResponse =
  omsPurchasingControllerUpdatePurchaseExpectedArrivalResponseSuccess

export const getOmsPurchasingControllerUpdatePurchaseExpectedArrivalUrl = (
  id: number
) => {
  return `/api-arvore/admin/oms/purchases/${id}/expected-arrival`
}

export const omsPurchasingControllerUpdatePurchaseExpectedArrival = async (
  id: number,
  updatePurchaseExpectedArrivalBodyDto: UpdatePurchaseExpectedArrivalBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerUpdatePurchaseExpectedArrivalResponse> => {
  return customInstance<omsPurchasingControllerUpdatePurchaseExpectedArrivalResponse>(
    getOmsPurchasingControllerUpdatePurchaseExpectedArrivalUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updatePurchaseExpectedArrivalBodyDto)
    }
  )
}

/**
 * @summary Parse invoice PDF and match items by ISBN
 */
export type omsPurchasingControllerPreviewInvoiceResponse200 = {
  data: OmsInvoicePreviewResponseDto
  status: 200
}

export type omsPurchasingControllerPreviewInvoiceResponseSuccess =
  omsPurchasingControllerPreviewInvoiceResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerPreviewInvoiceResponse =
  omsPurchasingControllerPreviewInvoiceResponseSuccess

export const getOmsPurchasingControllerPreviewInvoiceUrl = () => {
  return `/api-arvore/admin/oms/purchasing/invoice/preview`
}

export const omsPurchasingControllerPreviewInvoice = async (
  omsPurchasingControllerPreviewInvoiceBody: OmsPurchasingControllerPreviewInvoiceBody,
  options?: RequestInit
): Promise<omsPurchasingControllerPreviewInvoiceResponse> => {
  const formData = new FormData()
  formData.append(`file`, omsPurchasingControllerPreviewInvoiceBody.file)

  return customInstance<omsPurchasingControllerPreviewInvoiceResponse>(
    getOmsPurchasingControllerPreviewInvoiceUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Parse invoice PDF and match items against pending purchases by ISBN
 */
export type omsPurchasingControllerPreviewInvoiceMatchResponse200 = {
  data: OmsInvoiceMatchPreviewResponseDto
  status: 200
}

export type omsPurchasingControllerPreviewInvoiceMatchResponseSuccess =
  omsPurchasingControllerPreviewInvoiceMatchResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerPreviewInvoiceMatchResponse =
  omsPurchasingControllerPreviewInvoiceMatchResponseSuccess

export const getOmsPurchasingControllerPreviewInvoiceMatchUrl = () => {
  return `/api-arvore/admin/oms/invoices/preview-match`
}

export const omsPurchasingControllerPreviewInvoiceMatch = async (
  omsPurchasingControllerPreviewInvoiceMatchBody: OmsPurchasingControllerPreviewInvoiceMatchBody,
  options?: RequestInit
): Promise<omsPurchasingControllerPreviewInvoiceMatchResponse> => {
  const formData = new FormData()
  formData.append(`file`, omsPurchasingControllerPreviewInvoiceMatchBody.file)

  return customInstance<omsPurchasingControllerPreviewInvoiceMatchResponse>(
    getOmsPurchasingControllerPreviewInvoiceMatchUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Confirm an invoice match: reconcile the matched purchase and create a new purchase for unmatched items
 */
export type omsPurchasingControllerConfirmInvoiceMatchResponse201 = {
  data: OmsConfirmInvoiceMatchResponseDto
  status: 201
}

export type omsPurchasingControllerConfirmInvoiceMatchResponseSuccess =
  omsPurchasingControllerConfirmInvoiceMatchResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerConfirmInvoiceMatchResponse =
  omsPurchasingControllerConfirmInvoiceMatchResponseSuccess

export const getOmsPurchasingControllerConfirmInvoiceMatchUrl = () => {
  return `/api-arvore/admin/oms/invoices/confirm-match`
}

export const omsPurchasingControllerConfirmInvoiceMatch = async (
  omsPurchasingControllerConfirmInvoiceMatchBody: OmsPurchasingControllerConfirmInvoiceMatchBody,
  options?: RequestInit
): Promise<omsPurchasingControllerConfirmInvoiceMatchResponse> => {
  const formData = new FormData()
  if (omsPurchasingControllerConfirmInvoiceMatchBody.file !== undefined) {
    formData.append(`file`, omsPurchasingControllerConfirmInvoiceMatchBody.file)
  }
  if (omsPurchasingControllerConfirmInvoiceMatchBody.purchaseId !== undefined) {
    formData.append(
      `purchaseId`,
      omsPurchasingControllerConfirmInvoiceMatchBody.purchaseId.toString()
    )
  }
  if (
    omsPurchasingControllerConfirmInvoiceMatchBody.invoiceNumber !== undefined
  ) {
    formData.append(
      `invoiceNumber`,
      omsPurchasingControllerConfirmInvoiceMatchBody.invoiceNumber
    )
  }
  if (omsPurchasingControllerConfirmInvoiceMatchBody.supplier !== undefined) {
    formData.append(
      `supplier`,
      omsPurchasingControllerConfirmInvoiceMatchBody.supplier
    )
  }
  formData.append(
    `matchedItems`,
    omsPurchasingControllerConfirmInvoiceMatchBody.matchedItems
  )
  formData.append(
    `unmatchedItems`,
    omsPurchasingControllerConfirmInvoiceMatchBody.unmatchedItems
  )

  return customInstance<omsPurchasingControllerConfirmInvoiceMatchResponse>(
    getOmsPurchasingControllerConfirmInvoiceMatchUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Create a conciliated purchase from a confirmed invoice
 */
export type omsPurchasingControllerConfirmInvoiceResponse201 = {
  data: OmsCreatePurchaseResponseDto
  status: 201
}

export type omsPurchasingControllerConfirmInvoiceResponseSuccess =
  omsPurchasingControllerConfirmInvoiceResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerConfirmInvoiceResponse =
  omsPurchasingControllerConfirmInvoiceResponseSuccess

export const getOmsPurchasingControllerConfirmInvoiceUrl = () => {
  return `/api-arvore/admin/oms/purchasing/invoice/confirm`
}

export const omsPurchasingControllerConfirmInvoice = async (
  confirmInvoiceBodyDto: ConfirmInvoiceBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerConfirmInvoiceResponse> => {
  return customInstance<omsPurchasingControllerConfirmInvoiceResponse>(
    getOmsPurchasingControllerConfirmInvoiceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmInvoiceBodyDto)
    }
  )
}

/**
 * @summary Reconcile a pending purchase manually for testing (no invoice, receives full order)
 */
export type omsPurchasingControllerReconcileManualResponse201 = {
  data: OmsInvoiceResponseDto
  status: 201
}

export type omsPurchasingControllerReconcileManualResponseSuccess =
  omsPurchasingControllerReconcileManualResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerReconcileManualResponse =
  omsPurchasingControllerReconcileManualResponseSuccess

export const getOmsPurchasingControllerReconcileManualUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/reconcile-manual`
}

export const omsPurchasingControllerReconcileManual = async (
  id: number,
  options?: RequestInit
): Promise<omsPurchasingControllerReconcileManualResponse> => {
  return customInstance<omsPurchasingControllerReconcileManualResponse>(
    getOmsPurchasingControllerReconcileManualUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Reconcile an uploaded invoice against a pending purchase
 */
export type omsPurchasingControllerReconcileInvoiceResponse201 = {
  data: OmsInvoiceResponseDto
  status: 201
}

export type omsPurchasingControllerReconcileInvoiceResponseSuccess =
  omsPurchasingControllerReconcileInvoiceResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerReconcileInvoiceResponse =
  omsPurchasingControllerReconcileInvoiceResponseSuccess

export const getOmsPurchasingControllerReconcileInvoiceUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/reconcile-invoice`
}

export const omsPurchasingControllerReconcileInvoice = async (
  id: number,
  omsPurchasingControllerReconcileInvoiceBody: OmsPurchasingControllerReconcileInvoiceBody,
  options?: RequestInit
): Promise<omsPurchasingControllerReconcileInvoiceResponse> => {
  const formData = new FormData()
  if (omsPurchasingControllerReconcileInvoiceBody.file !== undefined) {
    formData.append(`file`, omsPurchasingControllerReconcileInvoiceBody.file)
  }
  if (omsPurchasingControllerReconcileInvoiceBody.invoiceNumber !== undefined) {
    formData.append(
      `invoiceNumber`,
      omsPurchasingControllerReconcileInvoiceBody.invoiceNumber
    )
  }
  if (omsPurchasingControllerReconcileInvoiceBody.fileUrl !== undefined) {
    formData.append(
      `fileUrl`,
      omsPurchasingControllerReconcileInvoiceBody.fileUrl
    )
  }
  omsPurchasingControllerReconcileInvoiceBody.items.forEach(value =>
    formData.append(`items`, value)
  )

  return customInstance<omsPurchasingControllerReconcileInvoiceResponse>(
    getOmsPurchasingControllerReconcileInvoiceUrl(id),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Generate a temporary signed URL to download the invoice file
 */
export type omsPurchasingControllerGetInvoiceFileUrlResponse200 = {
  data: OmsInvoiceFileUrlResponseDto
  status: 200
}

export type omsPurchasingControllerGetInvoiceFileUrlResponseSuccess =
  omsPurchasingControllerGetInvoiceFileUrlResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerGetInvoiceFileUrlResponse =
  omsPurchasingControllerGetInvoiceFileUrlResponseSuccess

export const getOmsPurchasingControllerGetInvoiceFileUrlUrl = (id: number) => {
  return `/api-arvore/admin/oms/invoices/${id}/file`
}

export const omsPurchasingControllerGetInvoiceFileUrl = async (
  id: number,
  options?: RequestInit
): Promise<omsPurchasingControllerGetInvoiceFileUrlResponse> => {
  return customInstance<omsPurchasingControllerGetInvoiceFileUrlResponse>(
    getOmsPurchasingControllerGetInvoiceFileUrlUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Add invoice to purchase
 */
export type omsPurchasingControllerAddInvoiceResponse201 = {
  data: OmsInvoiceResponseDto
  status: 201
}

export type omsPurchasingControllerAddInvoiceResponseSuccess =
  omsPurchasingControllerAddInvoiceResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerAddInvoiceResponse =
  omsPurchasingControllerAddInvoiceResponseSuccess

export const getOmsPurchasingControllerAddInvoiceUrl = (id: number) => {
  return `/api-arvore/admin/oms/purchases/${id}/invoice`
}

export const omsPurchasingControllerAddInvoice = async (
  id: number,
  createInvoiceBodyDto: CreateInvoiceBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerAddInvoiceResponse> => {
  return customInstance<omsPurchasingControllerAddInvoiceResponse>(
    getOmsPurchasingControllerAddInvoiceUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createInvoiceBodyDto)
    }
  )
}

/**
 * @summary Find the in-transit purchase for an invoice number and list expected books to receive
 */
export type omsPurchasingControllerInvoiceReceivePreviewResponse200 = {
  data: InvoiceReceivePreviewResponseDto
  status: 200
}

export type omsPurchasingControllerInvoiceReceivePreviewResponseSuccess =
  omsPurchasingControllerInvoiceReceivePreviewResponse200 & {
    headers: Headers
  }
export type omsPurchasingControllerInvoiceReceivePreviewResponse =
  omsPurchasingControllerInvoiceReceivePreviewResponseSuccess

export const getOmsPurchasingControllerInvoiceReceivePreviewUrl = (
  number: string
) => {
  return `/api-arvore/admin/oms/invoices/by-number/${number}/receive-preview`
}

export const omsPurchasingControllerInvoiceReceivePreview = async (
  number: string,
  options?: RequestInit
): Promise<omsPurchasingControllerInvoiceReceivePreviewResponse> => {
  return customInstance<omsPurchasingControllerInvoiceReceivePreviewResponse>(
    getOmsPurchasingControllerInvoiceReceivePreviewUrl(number),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Receive a scanned book against an invoice (moves in_transit to on_hand)
 */
export type omsPurchasingControllerReceiveFromInvoiceResponse201 = {
  data: ReceiveFromInvoiceResponseDto
  status: 201
}

export type omsPurchasingControllerReceiveFromInvoiceResponseSuccess =
  omsPurchasingControllerReceiveFromInvoiceResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerReceiveFromInvoiceResponse =
  omsPurchasingControllerReceiveFromInvoiceResponseSuccess

export const getOmsPurchasingControllerReceiveFromInvoiceUrl = () => {
  return `/api-arvore/admin/oms/stock/receive-from-invoice`
}

export const omsPurchasingControllerReceiveFromInvoice = async (
  receiveFromInvoiceBodyDto: ReceiveFromInvoiceBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerReceiveFromInvoiceResponse> => {
  return customInstance<omsPurchasingControllerReceiveFromInvoiceResponse>(
    getOmsPurchasingControllerReceiveFromInvoiceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(receiveFromInvoiceBodyDto)
    }
  )
}

/**
 * @summary Receive stock by ISBN scan (moves in_transit first, then direct receipt)
 */
export type omsPurchasingControllerScanReceiveResponse201 = {
  data: OmsScanReceiveResponseDto
  status: 201
}

export type omsPurchasingControllerScanReceiveResponseSuccess =
  omsPurchasingControllerScanReceiveResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerScanReceiveResponse =
  omsPurchasingControllerScanReceiveResponseSuccess

export const getOmsPurchasingControllerScanReceiveUrl = () => {
  return `/api-arvore/admin/oms/stock/scan-receive`
}

export const omsPurchasingControllerScanReceive = async (
  scanReceiveBodyDto: ScanReceiveBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerScanReceiveResponse> => {
  return customInstance<omsPurchasingControllerScanReceiveResponse>(
    getOmsPurchasingControllerScanReceiveUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(scanReceiveBodyDto)
    }
  )
}

/**
 * @summary Manual stock receipt
 */
export type omsPurchasingControllerReceiveStockResponse201 = {
  data: OmsReceiveStockResponseDto
  status: 201
}

export type omsPurchasingControllerReceiveStockResponseSuccess =
  omsPurchasingControllerReceiveStockResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerReceiveStockResponse =
  omsPurchasingControllerReceiveStockResponseSuccess

export const getOmsPurchasingControllerReceiveStockUrl = () => {
  return `/api-arvore/admin/oms/stock/receive`
}

export const omsPurchasingControllerReceiveStock = async (
  receiveStockBodyDto: ReceiveStockBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerReceiveStockResponse> => {
  return customInstance<omsPurchasingControllerReceiveStockResponse>(
    getOmsPurchasingControllerReceiveStockUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(receiveStockBodyDto)
    }
  )
}

/**
 * @summary Move in-transit stock to on-hand
 */
export type omsPurchasingControllerReceiveTransitResponse201 = {
  data: OmsReceiveStockResponseDto
  status: 201
}

export type omsPurchasingControllerReceiveTransitResponseSuccess =
  omsPurchasingControllerReceiveTransitResponse201 & {
    headers: Headers
  }
export type omsPurchasingControllerReceiveTransitResponse =
  omsPurchasingControllerReceiveTransitResponseSuccess

export const getOmsPurchasingControllerReceiveTransitUrl = () => {
  return `/api-arvore/admin/oms/stock/receive-transit`
}

export const omsPurchasingControllerReceiveTransit = async (
  receiveTransitBodyDto: ReceiveTransitBodyDto,
  options?: RequestInit
): Promise<omsPurchasingControllerReceiveTransitResponse> => {
  return customInstance<omsPurchasingControllerReceiveTransitResponse>(
    getOmsPurchasingControllerReceiveTransitUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(receiveTransitBodyDto)
    }
  )
}

/**
 * @summary Unified pipeline: HubSpot deals + MySQL selections
 */
export type omsContractsControllerListResponse200 = {
  data: OmsContractsListResponseDto
  status: 200
}

export type omsContractsControllerListResponseSuccess =
  omsContractsControllerListResponse200 & {
    headers: Headers
  }
export type omsContractsControllerListResponse =
  omsContractsControllerListResponseSuccess

export const getOmsContractsControllerListUrl = (
  params?: OmsContractsControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/contracts?${stringifiedParams}`
    : `/api-arvore/admin/oms/contracts`
}

export const omsContractsControllerList = async (
  params?: OmsContractsControllerListParams,
  options?: RequestInit
): Promise<omsContractsControllerListResponse> => {
  return customInstance<omsContractsControllerListResponse>(
    getOmsContractsControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get book selection detail for a school (modal data)
 */
export type omsContractsControllerSelectionDetailResponse200 = {
  data: OmsSelectionDetailRowDto[]
  status: 200
}

export type omsContractsControllerSelectionDetailResponseSuccess =
  omsContractsControllerSelectionDetailResponse200 & {
    headers: Headers
  }
export type omsContractsControllerSelectionDetailResponse =
  omsContractsControllerSelectionDetailResponseSuccess

export const getOmsContractsControllerSelectionDetailUrl = (
  entityId: number,
  params?: OmsContractsControllerSelectionDetailParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/contracts/selection/${entityId}?${stringifiedParams}`
    : `/api-arvore/admin/oms/contracts/selection/${entityId}`
}

export const omsContractsControllerSelectionDetail = async (
  entityId: number,
  params?: OmsContractsControllerSelectionDetailParams,
  options?: RequestInit
): Promise<omsContractsControllerSelectionDetailResponse> => {
  return customInstance<omsContractsControllerSelectionDetailResponse>(
    getOmsContractsControllerSelectionDetailUrl(entityId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Books selected in a given selection
 */
export type omsContractsControllerSelectionBooksResponse200 = {
  data: OmsSelectionBookDto[]
  status: 200
}

export type omsContractsControllerSelectionBooksResponseSuccess =
  omsContractsControllerSelectionBooksResponse200 & {
    headers: Headers
  }
export type omsContractsControllerSelectionBooksResponse =
  omsContractsControllerSelectionBooksResponseSuccess

export const getOmsContractsControllerSelectionBooksUrl = (id: number) => {
  return `/api-arvore/admin/oms/contracts/selection/${id}/books`
}

export const omsContractsControllerSelectionBooks = async (
  id: number,
  options?: RequestInit
): Promise<omsContractsControllerSelectionBooksResponse> => {
  return customInstance<omsContractsControllerSelectionBooksResponse>(
    getOmsContractsControllerSelectionBooksUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Set delivery date for a contract (school + year)
 */
export type omsContractsControllerSetDeliveryDateResponse200 = {
  data: OmsContractDeliveryDateResponseDto
  status: 200
}

export type omsContractsControllerSetDeliveryDateResponseSuccess =
  omsContractsControllerSetDeliveryDateResponse200 & {
    headers: Headers
  }
export type omsContractsControllerSetDeliveryDateResponse =
  omsContractsControllerSetDeliveryDateResponseSuccess

export const getOmsContractsControllerSetDeliveryDateUrl = () => {
  return `/api-arvore/admin/oms/contracts/delivery-date`
}

export const omsContractsControllerSetDeliveryDate = async (
  setContractDeliveryDateBodyDto: SetContractDeliveryDateBodyDto,
  options?: RequestInit
): Promise<omsContractsControllerSetDeliveryDateResponse> => {
  return customInstance<omsContractsControllerSetDeliveryDateResponse>(
    getOmsContractsControllerSetDeliveryDateUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setContractDeliveryDateBodyDto)
    }
  )
}

/**
 * @summary Get delivery address for a school/year
 */
export type omsContractsControllerGetAddressResponse200 = {
  data: OmsAddressDto
  status: 200
}

export type omsContractsControllerGetAddressResponseSuccess =
  omsContractsControllerGetAddressResponse200 & {
    headers: Headers
  }
export type omsContractsControllerGetAddressResponse =
  omsContractsControllerGetAddressResponseSuccess

export const getOmsContractsControllerGetAddressUrl = (
  entityId: number,
  params?: OmsContractsControllerGetAddressParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/contracts/${entityId}/address?${stringifiedParams}`
    : `/api-arvore/admin/oms/contracts/${entityId}/address`
}

export const omsContractsControllerGetAddress = async (
  entityId: number,
  params?: OmsContractsControllerGetAddressParams,
  options?: RequestInit
): Promise<omsContractsControllerGetAddressResponse> => {
  return customInstance<omsContractsControllerGetAddressResponse>(
    getOmsContractsControllerGetAddressUrl(entityId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upsert delivery address for a school/year
 */
export type omsContractsControllerUpsertAddressResponse200 = {
  data: OmsAddressDto
  status: 200
}

export type omsContractsControllerUpsertAddressResponseSuccess =
  omsContractsControllerUpsertAddressResponse200 & {
    headers: Headers
  }
export type omsContractsControllerUpsertAddressResponse =
  omsContractsControllerUpsertAddressResponseSuccess

export const getOmsContractsControllerUpsertAddressUrl = (entityId: number) => {
  return `/api-arvore/admin/oms/contracts/${entityId}/address`
}

export const omsContractsControllerUpsertAddress = async (
  entityId: number,
  upsertOmsAddressBodyDto: UpsertOmsAddressBodyDto,
  options?: RequestInit
): Promise<omsContractsControllerUpsertAddressResponse> => {
  return customInstance<omsContractsControllerUpsertAddressResponse>(
    getOmsContractsControllerUpsertAddressUrl(entityId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertOmsAddressBodyDto)
    }
  )
}

/**
 * @summary List OMS SKUs (literary + didactic)
 */
export type omsSkusControllerListResponse200 = {
  data: OmsSkusListResponseDto
  status: 200
}

export type omsSkusControllerListResponseSuccess =
  omsSkusControllerListResponse200 & {
    headers: Headers
  }
export type omsSkusControllerListResponse = omsSkusControllerListResponseSuccess

export const getOmsSkusControllerListUrl = (
  params?: OmsSkusControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/skus?${stringifiedParams}`
    : `/api-arvore/admin/oms/skus`
}

export const omsSkusControllerList = async (
  params?: OmsSkusControllerListParams,
  options?: RequestInit
): Promise<omsSkusControllerListResponse> => {
  return customInstance<omsSkusControllerListResponse>(
    getOmsSkusControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a manual SKU (literary or didactic)
 */
export type omsSkusControllerCreateResponse201 = {
  data: OmsSkuDto
  status: 201
}

export type omsSkusControllerCreateResponseSuccess =
  omsSkusControllerCreateResponse201 & {
    headers: Headers
  }
export type omsSkusControllerCreateResponse =
  omsSkusControllerCreateResponseSuccess

export const getOmsSkusControllerCreateUrl = () => {
  return `/api-arvore/admin/oms/skus`
}

export const omsSkusControllerCreate = async (
  createSkuBodyDto: CreateSkuBodyDto,
  options?: RequestInit
): Promise<omsSkusControllerCreateResponse> => {
  return customInstance<omsSkusControllerCreateResponse>(
    getOmsSkusControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createSkuBodyDto)
    }
  )
}

/**
 * @summary List distinct publishers for SKU filtering
 */
export type omsSkusControllerPublishersResponse200 = {
  data: string[]
  status: 200
}

export type omsSkusControllerPublishersResponseSuccess =
  omsSkusControllerPublishersResponse200 & {
    headers: Headers
  }
export type omsSkusControllerPublishersResponse =
  omsSkusControllerPublishersResponseSuccess

export const getOmsSkusControllerPublishersUrl = () => {
  return `/api-arvore/admin/oms/skus/publishers`
}

export const omsSkusControllerPublishers = async (
  options?: RequestInit
): Promise<omsSkusControllerPublishersResponse> => {
  return customInstance<omsSkusControllerPublishersResponse>(
    getOmsSkusControllerPublishersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List distinct publisher groups for SKU filtering
 */
export type omsSkusControllerPublisherGroupsResponse200 = {
  data: string[]
  status: 200
}

export type omsSkusControllerPublisherGroupsResponseSuccess =
  omsSkusControllerPublisherGroupsResponse200 & {
    headers: Headers
  }
export type omsSkusControllerPublisherGroupsResponse =
  omsSkusControllerPublisherGroupsResponseSuccess

export const getOmsSkusControllerPublisherGroupsUrl = () => {
  return `/api-arvore/admin/oms/skus/publisher-groups`
}

export const omsSkusControllerPublisherGroups = async (
  options?: RequestInit
): Promise<omsSkusControllerPublisherGroupsResponse> => {
  return customInstance<omsSkusControllerPublisherGroupsResponse>(
    getOmsSkusControllerPublisherGroupsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List distinct grades for SKU filtering
 */
export type omsSkusControllerGradesResponse200 = {
  data: string[]
  status: 200
}

export type omsSkusControllerGradesResponseSuccess =
  omsSkusControllerGradesResponse200 & {
    headers: Headers
  }
export type omsSkusControllerGradesResponse =
  omsSkusControllerGradesResponseSuccess

export const getOmsSkusControllerGradesUrl = () => {
  return `/api-arvore/admin/oms/skus/grades`
}

export const omsSkusControllerGrades = async (
  options?: RequestInit
): Promise<omsSkusControllerGradesResponse> => {
  return customInstance<omsSkusControllerGradesResponse>(
    getOmsSkusControllerGradesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search physical editions to link a SKU (by title/author/ISBN)
 */
export type omsSkusControllerEditionsResponse200 = {
  data: OmsEditionOptionDto[]
  status: 200
}

export type omsSkusControllerEditionsResponseSuccess =
  omsSkusControllerEditionsResponse200 & {
    headers: Headers
  }
export type omsSkusControllerEditionsResponse =
  omsSkusControllerEditionsResponseSuccess

export const getOmsSkusControllerEditionsUrl = (
  params: OmsSkusControllerEditionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/skus/editions?${stringifiedParams}`
    : `/api-arvore/admin/oms/skus/editions`
}

export const omsSkusControllerEditions = async (
  params: OmsSkusControllerEditionsParams,
  options?: RequestInit
): Promise<omsSkusControllerEditionsResponse> => {
  return customInstance<omsSkusControllerEditionsResponse>(
    getOmsSkusControllerEditionsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update SKU operational fields / mark didactic
 */
export type omsSkusControllerUpdateResponse200 = {
  data: OmsSkuDto
  status: 200
}

export type omsSkusControllerUpdateResponseSuccess =
  omsSkusControllerUpdateResponse200 & {
    headers: Headers
  }
export type omsSkusControllerUpdateResponse =
  omsSkusControllerUpdateResponseSuccess

export const getOmsSkusControllerUpdateUrl = (id: number) => {
  return `/api-arvore/admin/oms/skus/${id}`
}

export const omsSkusControllerUpdate = async (
  id: number,
  updateSkuBodyDto: UpdateSkuBodyDto,
  options?: RequestInit
): Promise<omsSkusControllerUpdateResponse> => {
  return customInstance<omsSkusControllerUpdateResponse>(
    getOmsSkusControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateSkuBodyDto)
    }
  )
}

/**
 * @summary Get hybrid offer catalog/edition that originated this SKU
 */
export type omsSkusControllerOriginResponse200 = {
  data: OmsSkuOriginResponseDto
  status: 200
}

export type omsSkusControllerOriginResponseSuccess =
  omsSkusControllerOriginResponse200 & {
    headers: Headers
  }
export type omsSkusControllerOriginResponse =
  omsSkusControllerOriginResponseSuccess

export const getOmsSkusControllerOriginUrl = (id: number) => {
  return `/api-arvore/admin/oms/skus/${id}/origin`
}

export const omsSkusControllerOrigin = async (
  id: number,
  options?: RequestInit
): Promise<omsSkusControllerOriginResponse> => {
  return customInstance<omsSkusControllerOriginResponse>(
    getOmsSkusControllerOriginUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Schools in the pipeline (submitted/selecting) for standalone orders
 */
export type omsPipelineControllerSchoolsResponse200 = {
  data: OmsSchoolDto[]
  status: 200
}

export type omsPipelineControllerSchoolsResponseSuccess =
  omsPipelineControllerSchoolsResponse200 & {
    headers: Headers
  }
export type omsPipelineControllerSchoolsResponse =
  omsPipelineControllerSchoolsResponseSuccess

export const getOmsPipelineControllerSchoolsUrl = (
  params?: OmsPipelineControllerSchoolsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/schools?${stringifiedParams}`
    : `/api-arvore/admin/oms/schools`
}

export const omsPipelineControllerSchools = async (
  params?: OmsPipelineControllerSchoolsParams,
  options?: RequestInit
): Promise<omsPipelineControllerSchoolsResponse> => {
  return customInstance<omsPipelineControllerSchoolsResponse>(
    getOmsPipelineControllerSchoolsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Materialize base order from current selections
 */
export type omsPipelineControllerGenerateOrderResponse201 = {
  data: OmsGenerateOrderResponseDto
  status: 201
}

export type omsPipelineControllerGenerateOrderResponseSuccess =
  omsPipelineControllerGenerateOrderResponse201 & {
    headers: Headers
  }
export type omsPipelineControllerGenerateOrderResponse =
  omsPipelineControllerGenerateOrderResponseSuccess

export const getOmsPipelineControllerGenerateOrderUrl = () => {
  return `/api-arvore/admin/oms/pipeline/generate-order`
}

export const omsPipelineControllerGenerateOrder = async (
  generateOrderBodyDto: GenerateOrderBodyDto,
  options?: RequestInit
): Promise<omsPipelineControllerGenerateOrderResponse> => {
  return customInstance<omsPipelineControllerGenerateOrderResponse>(
    getOmsPipelineControllerGenerateOrderUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateOrderBodyDto)
    }
  )
}

/**
 * @summary Assembly leader overview: pipeline, per-order progress, documents and metrics
 */
export type omsPipelineControllerLeaderOverviewResponse200 = {
  data: OmsLeaderOverviewResponseDto
  status: 200
}

export type omsPipelineControllerLeaderOverviewResponseSuccess =
  omsPipelineControllerLeaderOverviewResponse200 & {
    headers: Headers
  }
export type omsPipelineControllerLeaderOverviewResponse =
  omsPipelineControllerLeaderOverviewResponseSuccess

export const getOmsPipelineControllerLeaderOverviewUrl = () => {
  return `/api-arvore/admin/oms/leader/overview`
}

export const omsPipelineControllerLeaderOverview = async (
  options?: RequestInit
): Promise<omsPipelineControllerLeaderOverviewResponse> => {
  return customInstance<omsPipelineControllerLeaderOverviewResponse>(
    getOmsPipelineControllerLeaderOverviewUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Assembly leader live feed: kit assembled and box kit scan events
 */
export type omsPipelineControllerLeaderEventsResponse200 = {
  data: OmsLeaderEventsResponseDto
  status: 200
}

export type omsPipelineControllerLeaderEventsResponseSuccess =
  omsPipelineControllerLeaderEventsResponse200 & {
    headers: Headers
  }
export type omsPipelineControllerLeaderEventsResponse =
  omsPipelineControllerLeaderEventsResponseSuccess

export const getOmsPipelineControllerLeaderEventsUrl = (
  params?: OmsPipelineControllerLeaderEventsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/admin/oms/leader/events?${stringifiedParams}`
    : `/api-arvore/admin/oms/leader/events`
}

export const omsPipelineControllerLeaderEvents = async (
  params?: OmsPipelineControllerLeaderEventsParams,
  options?: RequestInit
): Promise<omsPipelineControllerLeaderEventsResponse> => {
  return customInstance<omsPipelineControllerLeaderEventsResponse>(
    getOmsPipelineControllerLeaderEventsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List active box types
 */
export type omsBoxControllerListBoxTypesResponse200 = {
  data: BoxTypeListResponseDto
  status: 200
}

export type omsBoxControllerListBoxTypesResponseSuccess =
  omsBoxControllerListBoxTypesResponse200 & {
    headers: Headers
  }
export type omsBoxControllerListBoxTypesResponse =
  omsBoxControllerListBoxTypesResponseSuccess

export const getOmsBoxControllerListBoxTypesUrl = () => {
  return `/api-arvore/admin/oms/box-types`
}

export const omsBoxControllerListBoxTypes = async (
  options?: RequestInit
): Promise<omsBoxControllerListBoxTypesResponse> => {
  return customInstance<omsBoxControllerListBoxTypesResponse>(
    getOmsBoxControllerListBoxTypesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a box type
 */
export type omsBoxControllerCreateBoxTypeResponse201 = {
  data: BoxTypeResponseDto
  status: 201
}

export type omsBoxControllerCreateBoxTypeResponseSuccess =
  omsBoxControllerCreateBoxTypeResponse201 & {
    headers: Headers
  }
export type omsBoxControllerCreateBoxTypeResponse =
  omsBoxControllerCreateBoxTypeResponseSuccess

export const getOmsBoxControllerCreateBoxTypeUrl = () => {
  return `/api-arvore/admin/oms/box-types`
}

export const omsBoxControllerCreateBoxType = async (
  createBoxTypeBodyDto: CreateBoxTypeBodyDto,
  options?: RequestInit
): Promise<omsBoxControllerCreateBoxTypeResponse> => {
  return customInstance<omsBoxControllerCreateBoxTypeResponse>(
    getOmsBoxControllerCreateBoxTypeUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createBoxTypeBodyDto)
    }
  )
}

/**
 * @summary Update a box type
 */
export type omsBoxControllerUpdateBoxTypeResponse200 = {
  data: BoxTypeResponseDto
  status: 200
}

export type omsBoxControllerUpdateBoxTypeResponseSuccess =
  omsBoxControllerUpdateBoxTypeResponse200 & {
    headers: Headers
  }
export type omsBoxControllerUpdateBoxTypeResponse =
  omsBoxControllerUpdateBoxTypeResponseSuccess

export const getOmsBoxControllerUpdateBoxTypeUrl = (id: number) => {
  return `/api-arvore/admin/oms/box-types/${id}`
}

export const omsBoxControllerUpdateBoxType = async (
  id: number,
  updateBoxTypeBodyDto: UpdateBoxTypeBodyDto,
  options?: RequestInit
): Promise<omsBoxControllerUpdateBoxTypeResponse> => {
  return customInstance<omsBoxControllerUpdateBoxTypeResponse>(
    getOmsBoxControllerUpdateBoxTypeUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateBoxTypeBodyDto)
    }
  )
}

/**
 * @summary Delete a box type
 */
export type omsBoxControllerDeleteBoxTypeResponse200 = {
  data: void
  status: 200
}

export type omsBoxControllerDeleteBoxTypeResponseSuccess =
  omsBoxControllerDeleteBoxTypeResponse200 & {
    headers: Headers
  }
export type omsBoxControllerDeleteBoxTypeResponse =
  omsBoxControllerDeleteBoxTypeResponseSuccess

export const getOmsBoxControllerDeleteBoxTypeUrl = (id: number) => {
  return `/api-arvore/admin/oms/box-types/${id}`
}

export const omsBoxControllerDeleteBoxType = async (
  id: number,
  options?: RequestInit
): Promise<omsBoxControllerDeleteBoxTypeResponse> => {
  return customInstance<omsBoxControllerDeleteBoxTypeResponse>(
    getOmsBoxControllerDeleteBoxTypeUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Calculate and save box packing for an order
 */
export type omsBoxControllerCalculateBoxesResponse201 = {
  data: CalculateBoxesResponseDto
  status: 201
}

export type omsBoxControllerCalculateBoxesResponseSuccess =
  omsBoxControllerCalculateBoxesResponse201 & {
    headers: Headers
  }
export type omsBoxControllerCalculateBoxesResponse =
  omsBoxControllerCalculateBoxesResponseSuccess

export const getOmsBoxControllerCalculateBoxesUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/calculate-boxes`
}

export const omsBoxControllerCalculateBoxes = async (
  id: number,
  options?: RequestInit
): Promise<omsBoxControllerCalculateBoxesResponse> => {
  return customInstance<omsBoxControllerCalculateBoxesResponse>(
    getOmsBoxControllerCalculateBoxesUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Resolve the order id from a scanned kit label code
 */
export type omsBoxControllerResolveKitOrderResponse200 = {
  data: ResolveKitOrderResponseDto
  status: 200
}

export type omsBoxControllerResolveKitOrderResponseSuccess =
  omsBoxControllerResolveKitOrderResponse200 & {
    headers: Headers
  }
export type omsBoxControllerResolveKitOrderResponse =
  omsBoxControllerResolveKitOrderResponseSuccess

export const getOmsBoxControllerResolveKitOrderUrl = (code: string) => {
  return `/api-arvore/admin/oms/kits/${code}/order`
}

export const omsBoxControllerResolveKitOrder = async (
  code: string,
  options?: RequestInit
): Promise<omsBoxControllerResolveKitOrderResponse> => {
  return customInstance<omsBoxControllerResolveKitOrderResponse>(
    getOmsBoxControllerResolveKitOrderUrl(code),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List box assignments for an order
 */
export type omsBoxControllerGetBoxesResponse200 = {
  data: CalculateBoxesResponseDto
  status: 200
}

export type omsBoxControllerGetBoxesResponseSuccess =
  omsBoxControllerGetBoxesResponse200 & {
    headers: Headers
  }
export type omsBoxControllerGetBoxesResponse =
  omsBoxControllerGetBoxesResponseSuccess

export const getOmsBoxControllerGetBoxesUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/boxes`
}

export const omsBoxControllerGetBoxes = async (
  id: number,
  options?: RequestInit
): Promise<omsBoxControllerGetBoxesResponse> => {
  return customInstance<omsBoxControllerGetBoxesResponse>(
    getOmsBoxControllerGetBoxesUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Box closing session state (boxes, scanned kits, progress)
 */
export type omsBoxControllerBoxSessionResponse200 = {
  data: BoxSessionResponseDto
  status: 200
}

export type omsBoxControllerBoxSessionResponseSuccess =
  omsBoxControllerBoxSessionResponse200 & {
    headers: Headers
  }
export type omsBoxControllerBoxSessionResponse =
  omsBoxControllerBoxSessionResponseSuccess

export const getOmsBoxControllerBoxSessionUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/box-session`
}

export const omsBoxControllerBoxSession = async (
  id: number,
  options?: RequestInit
): Promise<omsBoxControllerBoxSessionResponse> => {
  return customInstance<omsBoxControllerBoxSessionResponse>(
    getOmsBoxControllerBoxSessionUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Scan a kit label into a box (validates against the packing guide)
 */
export type omsBoxControllerScanKitResponse201 = {
  data: ScanKitResponseDto
  status: 201
}

export type omsBoxControllerScanKitResponseSuccess =
  omsBoxControllerScanKitResponse201 & {
    headers: Headers
  }
export type omsBoxControllerScanKitResponse =
  omsBoxControllerScanKitResponseSuccess

export const getOmsBoxControllerScanKitUrl = (
  id: number,
  boxNumber: number
) => {
  return `/api-arvore/admin/oms/orders/${id}/boxes/${boxNumber}/scan-kit`
}

export const omsBoxControllerScanKit = async (
  id: number,
  boxNumber: number,
  scanKitBodyDto: ScanKitBodyDto,
  options?: RequestInit
): Promise<omsBoxControllerScanKitResponse> => {
  return customInstance<omsBoxControllerScanKitResponse>(
    getOmsBoxControllerScanKitUrl(id, boxNumber),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(scanKitBodyDto)
    }
  )
}

/**
 * @summary Close a box once every kit has been scanned and the weight matches
 */
export type omsBoxControllerCloseBoxResponse201 = {
  data: CloseBoxResponseDto
  status: 201
}

export type omsBoxControllerCloseBoxResponseSuccess =
  omsBoxControllerCloseBoxResponse201 & {
    headers: Headers
  }
export type omsBoxControllerCloseBoxResponse =
  omsBoxControllerCloseBoxResponseSuccess

export const getOmsBoxControllerCloseBoxUrl = (
  id: number,
  boxNumber: number
) => {
  return `/api-arvore/admin/oms/orders/${id}/boxes/${boxNumber}/close`
}

export const omsBoxControllerCloseBox = async (
  id: number,
  boxNumber: number,
  closeBoxBodyDto: CloseBoxBodyDto,
  options?: RequestInit
): Promise<omsBoxControllerCloseBoxResponse> => {
  return customInstance<omsBoxControllerCloseBoxResponse>(
    getOmsBoxControllerCloseBoxUrl(id, boxNumber),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(closeBoxBodyDto)
    }
  )
}

/**
 * @summary Undo the last kit scan of a box
 */
export type omsBoxControllerUndoBoxScanResponse201 = {
  data: BoxUndoScanResponseDto
  status: 201
}

export type omsBoxControllerUndoBoxScanResponseSuccess =
  omsBoxControllerUndoBoxScanResponse201 & {
    headers: Headers
  }
export type omsBoxControllerUndoBoxScanResponse =
  omsBoxControllerUndoBoxScanResponseSuccess

export const getOmsBoxControllerUndoBoxScanUrl = (
  id: number,
  boxNumber: number
) => {
  return `/api-arvore/admin/oms/orders/${id}/boxes/${boxNumber}/undo-last-scan`
}

export const omsBoxControllerUndoBoxScan = async (
  id: number,
  boxNumber: number,
  options?: RequestInit
): Promise<omsBoxControllerUndoBoxScanResponse> => {
  return customInstance<omsBoxControllerUndoBoxScanResponse>(
    getOmsBoxControllerUndoBoxScanUrl(id, boxNumber),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Cota o frete (Braspress)
 */
export type omsShipmentControllerQuoteResponse201 = {
  data: ShipmentResponseDto
  status: 201
}

export type omsShipmentControllerQuoteResponseSuccess =
  omsShipmentControllerQuoteResponse201 & {
    headers: Headers
  }
export type omsShipmentControllerQuoteResponse =
  omsShipmentControllerQuoteResponseSuccess

export const getOmsShipmentControllerQuoteUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/shipment/quote`
}

export const omsShipmentControllerQuote = async (
  id: number,
  options?: RequestInit
): Promise<omsShipmentControllerQuoteResponse> => {
  return customInstance<omsShipmentControllerQuoteResponse>(
    getOmsShipmentControllerQuoteUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Retorna a remessa (cotacao, eventos, NFs) do pedido
 */
export type omsShipmentControllerGetShipmentResponse200 = {
  data: ShipmentResponseDto
  status: 200
}

export type omsShipmentControllerGetShipmentResponseSuccess =
  omsShipmentControllerGetShipmentResponse200 & {
    headers: Headers
  }
export type omsShipmentControllerGetShipmentResponse =
  omsShipmentControllerGetShipmentResponseSuccess

export const getOmsShipmentControllerGetShipmentUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/shipment`
}

export const omsShipmentControllerGetShipment = async (
  id: number,
  options?: RequestInit
): Promise<omsShipmentControllerGetShipmentResponse> => {
  return customInstance<omsShipmentControllerGetShipmentResponse>(
    getOmsShipmentControllerGetShipmentUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Informa o numero da NF despachada para o rastreio Braspress
 */
export type omsShipmentControllerSetTrackingNumberResponse200 = {
  data: ShipmentResponseDto
  status: 200
}

export type omsShipmentControllerSetTrackingNumberResponseSuccess =
  omsShipmentControllerSetTrackingNumberResponse200 & {
    headers: Headers
  }
export type omsShipmentControllerSetTrackingNumberResponse =
  omsShipmentControllerSetTrackingNumberResponseSuccess

export const getOmsShipmentControllerSetTrackingNumberUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/shipment/tracking-number`
}

export const omsShipmentControllerSetTrackingNumber = async (
  id: number,
  setTrackingNumberBodyDto: SetTrackingNumberBodyDto,
  options?: RequestInit
): Promise<omsShipmentControllerSetTrackingNumberResponse> => {
  return customInstance<omsShipmentControllerSetTrackingNumberResponse>(
    getOmsShipmentControllerSetTrackingNumberUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setTrackingNumberBodyDto)
    }
  )
}

/**
 * @summary Atualiza o rastreio da remessa na Braspress
 */
export type omsShipmentControllerRefreshTrackingResponse200 = {
  data: ShipmentResponseDto
  status: 200
}

export type omsShipmentControllerRefreshTrackingResponseSuccess =
  omsShipmentControllerRefreshTrackingResponse200 & {
    headers: Headers
  }
export type omsShipmentControllerRefreshTrackingResponse =
  omsShipmentControllerRefreshTrackingResponseSuccess

export const getOmsShipmentControllerRefreshTrackingUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/shipment/refresh-tracking`
}

export const omsShipmentControllerRefreshTracking = async (
  id: number,
  options?: RequestInit
): Promise<omsShipmentControllerRefreshTrackingResponse> => {
  return customInstance<omsShipmentControllerRefreshTrackingResponse>(
    getOmsShipmentControllerRefreshTrackingUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Registra a NF de remessa (numero/serie/chave + PDF opcional)
 */
export type omsShipmentControllerRegisterNfeResponse201 = {
  data: ShipmentResponseDto
  status: 201
}

export type omsShipmentControllerRegisterNfeResponseSuccess =
  omsShipmentControllerRegisterNfeResponse201 & {
    headers: Headers
  }
export type omsShipmentControllerRegisterNfeResponse =
  omsShipmentControllerRegisterNfeResponseSuccess

export const getOmsShipmentControllerRegisterNfeUrl = (id: number) => {
  return `/api-arvore/admin/oms/orders/${id}/nfe`
}

export const omsShipmentControllerRegisterNfe = async (
  id: number,
  registerNfeBodyDto: RegisterNfeBodyDto,
  options?: RequestInit
): Promise<omsShipmentControllerRegisterNfeResponse> => {
  return customInstance<omsShipmentControllerRegisterNfeResponse>(
    getOmsShipmentControllerRegisterNfeUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(registerNfeBodyDto)
    }
  )
}

/**
 * @summary Start async image generation with Árvore brand identity
 */
export type imageGenerationControllerGenerateResponse201 = {
  data: GenerateImageJobResponseDto
  status: 201
}

export type imageGenerationControllerGenerateResponseSuccess =
  imageGenerationControllerGenerateResponse201 & {
    headers: Headers
  }
export type imageGenerationControllerGenerateResponse =
  imageGenerationControllerGenerateResponseSuccess

export const getImageGenerationControllerGenerateUrl = () => {
  return `/api-arvore/v1/image-generation/generate`
}

export const imageGenerationControllerGenerate = async (
  imageGenerationControllerGenerateBody: ImageGenerationControllerGenerateBody,
  options?: RequestInit
): Promise<imageGenerationControllerGenerateResponse> => {
  const formData = new FormData()
  formData.append(`prompt`, imageGenerationControllerGenerateBody.prompt)
  formData.append(`format`, imageGenerationControllerGenerateBody.format)
  if (imageGenerationControllerGenerateBody.images !== undefined) {
    imageGenerationControllerGenerateBody.images.forEach(value =>
      formData.append(`images`, value)
    )
  }

  return customInstance<imageGenerationControllerGenerateResponse>(
    getImageGenerationControllerGenerateUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Get image generation job status
 */
export type imageGenerationControllerGetJobResponse200 = {
  data: ImageJobStatusResponseDto
  status: 200
}

export type imageGenerationControllerGetJobResponse404 = {
  data: void
  status: 404
}

export type imageGenerationControllerGetJobResponseSuccess =
  imageGenerationControllerGetJobResponse200 & {
    headers: Headers
  }
export type imageGenerationControllerGetJobResponseError =
  imageGenerationControllerGetJobResponse404 & {
    headers: Headers
  }

export type imageGenerationControllerGetJobResponse =
  | imageGenerationControllerGetJobResponseSuccess
  | imageGenerationControllerGetJobResponseError

export const getImageGenerationControllerGetJobUrl = (jobId: string) => {
  return `/api-arvore/v1/image-generation/jobs/${jobId}`
}

export const imageGenerationControllerGetJob = async (
  jobId: string,
  options?: RequestInit
): Promise<imageGenerationControllerGetJobResponse> => {
  return customInstance<imageGenerationControllerGetJobResponse>(
    getImageGenerationControllerGetJobUrl(jobId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a connection and start pairing
 */
export type waTrackerControllerCreateConnectionResponse201 = {
  data: void
  status: 201
}

export type waTrackerControllerCreateConnectionResponseSuccess =
  waTrackerControllerCreateConnectionResponse201 & {
    headers: Headers
  }
export type waTrackerControllerCreateConnectionResponse =
  waTrackerControllerCreateConnectionResponseSuccess

export const getWaTrackerControllerCreateConnectionUrl = () => {
  return `/api-arvore/v1/wa-tracker/connections`
}

export const waTrackerControllerCreateConnection = async (
  createConnectionDto: CreateConnectionDto,
  options?: RequestInit
): Promise<waTrackerControllerCreateConnectionResponse> => {
  return customInstance<waTrackerControllerCreateConnectionResponse>(
    getWaTrackerControllerCreateConnectionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createConnectionDto)
    }
  )
}

/**
 * @summary List connections
 */
export type waTrackerControllerListConnectionsResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerListConnectionsResponseSuccess =
  waTrackerControllerListConnectionsResponse200 & {
    headers: Headers
  }
export type waTrackerControllerListConnectionsResponse =
  waTrackerControllerListConnectionsResponseSuccess

export const getWaTrackerControllerListConnectionsUrl = () => {
  return `/api-arvore/v1/wa-tracker/connections`
}

export const waTrackerControllerListConnections = async (
  options?: RequestInit
): Promise<waTrackerControllerListConnectionsResponse> => {
  return customInstance<waTrackerControllerListConnectionsResponse>(
    getWaTrackerControllerListConnectionsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type waTrackerControllerGetConnectionResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerGetConnectionResponseSuccess =
  waTrackerControllerGetConnectionResponse200 & {
    headers: Headers
  }
export type waTrackerControllerGetConnectionResponse =
  waTrackerControllerGetConnectionResponseSuccess

export const getWaTrackerControllerGetConnectionUrl = (id: string) => {
  return `/api-arvore/v1/wa-tracker/connections/${id}`
}

export const waTrackerControllerGetConnection = async (
  id: string,
  options?: RequestInit
): Promise<waTrackerControllerGetConnectionResponse> => {
  return customInstance<waTrackerControllerGetConnectionResponse>(
    getWaTrackerControllerGetConnectionUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type waTrackerControllerRemoveConnectionResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerRemoveConnectionResponseSuccess =
  waTrackerControllerRemoveConnectionResponse200 & {
    headers: Headers
  }
export type waTrackerControllerRemoveConnectionResponse =
  waTrackerControllerRemoveConnectionResponseSuccess

export const getWaTrackerControllerRemoveConnectionUrl = (id: string) => {
  return `/api-arvore/v1/wa-tracker/connections/${id}`
}

export const waTrackerControllerRemoveConnection = async (
  id: string,
  options?: RequestInit
): Promise<waTrackerControllerRemoveConnectionResponse> => {
  return customInstance<waTrackerControllerRemoveConnectionResponse>(
    getWaTrackerControllerRemoveConnectionUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

export type waTrackerControllerGetQrResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerGetQrResponseSuccess =
  waTrackerControllerGetQrResponse200 & {
    headers: Headers
  }
export type waTrackerControllerGetQrResponse =
  waTrackerControllerGetQrResponseSuccess

export const getWaTrackerControllerGetQrUrl = (
  id: string,
  params: WaTrackerControllerGetQrParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/wa-tracker/connections/${id}/qr?${stringifiedParams}`
    : `/api-arvore/v1/wa-tracker/connections/${id}/qr`
}

export const waTrackerControllerGetQr = async (
  id: string,
  params: WaTrackerControllerGetQrParams,
  options?: RequestInit
): Promise<waTrackerControllerGetQrResponse> => {
  return customInstance<waTrackerControllerGetQrResponse>(
    getWaTrackerControllerGetQrUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type waTrackerControllerListContactsResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerListContactsResponseSuccess =
  waTrackerControllerListContactsResponse200 & {
    headers: Headers
  }
export type waTrackerControllerListContactsResponse =
  waTrackerControllerListContactsResponseSuccess

export const getWaTrackerControllerListContactsUrl = (
  id: string,
  params: WaTrackerControllerListContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/wa-tracker/connections/${id}/contacts?${stringifiedParams}`
    : `/api-arvore/v1/wa-tracker/connections/${id}/contacts`
}

export const waTrackerControllerListContacts = async (
  id: string,
  params: WaTrackerControllerListContactsParams,
  options?: RequestInit
): Promise<waTrackerControllerListContactsResponse> => {
  return customInstance<waTrackerControllerListContactsResponse>(
    getWaTrackerControllerListContactsUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type waTrackerControllerSetClientRefResponse200 = {
  data: void
  status: 200
}

export type waTrackerControllerSetClientRefResponseSuccess =
  waTrackerControllerSetClientRefResponse200 & {
    headers: Headers
  }
export type waTrackerControllerSetClientRefResponse =
  waTrackerControllerSetClientRefResponseSuccess

export const getWaTrackerControllerSetClientRefUrl = (
  id: string,
  jid: string
) => {
  return `/api-arvore/v1/wa-tracker/connections/${id}/contacts/${jid}`
}

export const waTrackerControllerSetClientRef = async (
  id: string,
  jid: string,
  setClientRefDto: SetClientRefDto,
  options?: RequestInit
): Promise<waTrackerControllerSetClientRefResponse> => {
  return customInstance<waTrackerControllerSetClientRefResponse>(
    getWaTrackerControllerSetClientRefUrl(id, jid),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setClientRefDto)
    }
  )
}

/**
 * @summary List root entities (clients)
 */
export type clientHubControllerListClientsResponse200 = {
  data: ClientDto[]
  status: 200
}

export type clientHubControllerListClientsResponseSuccess =
  clientHubControllerListClientsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListClientsResponse =
  clientHubControllerListClientsResponseSuccess

export const getClientHubControllerListClientsUrl = (
  params?: ClientHubControllerListClientsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/clients?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/clients`
}

export const clientHubControllerListClients = async (
  params?: ClientHubControllerListClientsParams,
  options?: RequestInit
): Promise<clientHubControllerListClientsResponse> => {
  return customInstance<clientHubControllerListClientsResponse>(
    getClientHubControllerListClientsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Query the client portfolio (mart 360) with business filters
 */
export type clientHubControllerListPortfolioResponse200 = {
  data: void
  status: 200
}

export type clientHubControllerListPortfolioResponseSuccess =
  clientHubControllerListPortfolioResponse200 & {
    headers: Headers
  }
export type clientHubControllerListPortfolioResponse =
  clientHubControllerListPortfolioResponseSuccess

export const getClientHubControllerListPortfolioUrl = (
  params?: ClientHubControllerListPortfolioParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/portfolio?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/portfolio`
}

export const clientHubControllerListPortfolio = async (
  params?: ClientHubControllerListPortfolioParams,
  options?: RequestInit
): Promise<clientHubControllerListPortfolioResponse> => {
  return customInstance<clientHubControllerListPortfolioResponse>(
    getClientHubControllerListPortfolioUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Run a read-only SELECT/WITH query against a data source (analytics=ClickHouse, super=Postgres, core=MySQL)
 */
export type clientHubControllerRunQueryResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerRunQueryResponseSuccess =
  clientHubControllerRunQueryResponse201 & {
    headers: Headers
  }
export type clientHubControllerRunQueryResponse =
  clientHubControllerRunQueryResponseSuccess

export const getClientHubControllerRunQueryUrl = () => {
  return `/api-arvore/v1/client-hub/query`
}

export const clientHubControllerRunQuery = async (
  rawQueryDto: RawQueryDto,
  options?: RequestInit
): Promise<clientHubControllerRunQueryResponse> => {
  return customInstance<clientHubControllerRunQueryResponse>(
    getClientHubControllerRunQueryUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(rawQueryDto)
    }
  )
}

/**
 * @summary List source links for a client
 */
export type clientHubControllerListLinksResponse200 = {
  data: ClientSourceLinkDto[]
  status: 200
}

export type clientHubControllerListLinksResponseSuccess =
  clientHubControllerListLinksResponse200 & {
    headers: Headers
  }
export type clientHubControllerListLinksResponse =
  clientHubControllerListLinksResponseSuccess

export const getClientHubControllerListLinksUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/clients/${id}/links`
}

export const clientHubControllerListLinks = async (
  id: string,
  options?: RequestInit
): Promise<clientHubControllerListLinksResponse> => {
  return customInstance<clientHubControllerListLinksResponse>(
    getClientHubControllerListLinksUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Link a contact to a client
 */
export type clientHubControllerCreateLinkResponse200 = {
  data: CreateLinkResponseDto
  status: 200
}

export type clientHubControllerCreateLinkResponseSuccess =
  clientHubControllerCreateLinkResponse200 & {
    headers: Headers
  }
export type clientHubControllerCreateLinkResponse =
  clientHubControllerCreateLinkResponseSuccess

export const getClientHubControllerCreateLinkUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/clients/${id}/links`
}

export const clientHubControllerCreateLink = async (
  id: string,
  createLinkDto: CreateLinkDto,
  options?: RequestInit
): Promise<clientHubControllerCreateLinkResponse> => {
  return customInstance<clientHubControllerCreateLinkResponse>(
    getClientHubControllerCreateLinkUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createLinkDto)
    }
  )
}

/**
 * @summary Link multiple contacts to a client
 */
export type clientHubControllerCreateLinksResponse200 = {
  data: CreateLinksResponseDto
  status: 200
}

export type clientHubControllerCreateLinksResponseSuccess =
  clientHubControllerCreateLinksResponse200 & {
    headers: Headers
  }
export type clientHubControllerCreateLinksResponse =
  clientHubControllerCreateLinksResponseSuccess

export const getClientHubControllerCreateLinksUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/clients/${id}/links/bulk`
}

export const clientHubControllerCreateLinks = async (
  id: string,
  createLinksDto: CreateLinksDto,
  options?: RequestInit
): Promise<clientHubControllerCreateLinksResponse> => {
  return customInstance<clientHubControllerCreateLinksResponse>(
    getClientHubControllerCreateLinksUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createLinksDto)
    }
  )
}

/**
 * @summary Unlink a contact from a client
 */
export type clientHubControllerDeleteLinkResponse200 = {
  data: DeleteLinkResponseDto
  status: 200
}

export type clientHubControllerDeleteLinkResponseSuccess =
  clientHubControllerDeleteLinkResponse200 & {
    headers: Headers
  }
export type clientHubControllerDeleteLinkResponse =
  clientHubControllerDeleteLinkResponseSuccess

export const getClientHubControllerDeleteLinkUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/links/${id}`
}

export const clientHubControllerDeleteLink = async (
  id: string,
  options?: RequestInit
): Promise<clientHubControllerDeleteLinkResponse> => {
  return customInstance<clientHubControllerDeleteLinkResponse>(
    getClientHubControllerDeleteLinkUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List available WhatsApp contacts
 */
export type clientHubControllerListWaContactsResponse200 = {
  data: WaContactDto[]
  status: 200
}

export type clientHubControllerListWaContactsResponseSuccess =
  clientHubControllerListWaContactsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListWaContactsResponse =
  clientHubControllerListWaContactsResponseSuccess

export const getClientHubControllerListWaContactsUrl = (
  params?: ClientHubControllerListWaContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/whatsapp/contacts?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/whatsapp/contacts`
}

export const clientHubControllerListWaContacts = async (
  params?: ClientHubControllerListWaContactsParams,
  options?: RequestInit
): Promise<clientHubControllerListWaContactsResponse> => {
  return customInstance<clientHubControllerListWaContactsResponse>(
    getClientHubControllerListWaContactsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List Elephan users
 */
export type clientHubControllerListElephanUsersResponse200 = {
  data: ElephanUserDto[]
  status: 200
}

export type clientHubControllerListElephanUsersResponseSuccess =
  clientHubControllerListElephanUsersResponse200 & {
    headers: Headers
  }
export type clientHubControllerListElephanUsersResponse =
  clientHubControllerListElephanUsersResponseSuccess

export const getClientHubControllerListElephanUsersUrl = (
  params?: ClientHubControllerListElephanUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/users?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/users`
}

export const clientHubControllerListElephanUsers = async (
  params?: ClientHubControllerListElephanUsersParams,
  options?: RequestInit
): Promise<clientHubControllerListElephanUsersResponse> => {
  return customInstance<clientHubControllerListElephanUsersResponse>(
    getClientHubControllerListElephanUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List Pipedrive organizations
 */
export type clientHubControllerListPipedriveOrganizationsResponse200 = {
  data: PipedriveOrganizationDto[]
  status: 200
}

export type clientHubControllerListPipedriveOrganizationsResponseSuccess =
  clientHubControllerListPipedriveOrganizationsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListPipedriveOrganizationsResponse =
  clientHubControllerListPipedriveOrganizationsResponseSuccess

export const getClientHubControllerListPipedriveOrganizationsUrl = (
  params?: ClientHubControllerListPipedriveOrganizationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/pipedrive/organizations?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/pipedrive/organizations`
}

export const clientHubControllerListPipedriveOrganizations = async (
  params?: ClientHubControllerListPipedriveOrganizationsParams,
  options?: RequestInit
): Promise<clientHubControllerListPipedriveOrganizationsResponse> => {
  return customInstance<clientHubControllerListPipedriveOrganizationsResponse>(
    getClientHubControllerListPipedriveOrganizationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List Elephan deals (grouped from transcribes)
 */
export type clientHubControllerListElephanDealsResponse200 = {
  data: ElephanDealDto[]
  status: 200
}

export type clientHubControllerListElephanDealsResponseSuccess =
  clientHubControllerListElephanDealsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListElephanDealsResponse =
  clientHubControllerListElephanDealsResponseSuccess

export const getClientHubControllerListElephanDealsUrl = (
  params?: ClientHubControllerListElephanDealsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/deals?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/deals`
}

export const clientHubControllerListElephanDeals = async (
  params?: ClientHubControllerListElephanDealsParams,
  options?: RequestInit
): Promise<clientHubControllerListElephanDealsResponse> => {
  return customInstance<clientHubControllerListElephanDealsResponse>(
    getClientHubControllerListElephanDealsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get aggregated 360 view for a client
 */
export type clientHubControllerGetClient360Response200 = {
  data: void
  status: 200
}

export type clientHubControllerGetClient360ResponseSuccess =
  clientHubControllerGetClient360Response200 & {
    headers: Headers
  }
export type clientHubControllerGetClient360Response =
  clientHubControllerGetClient360ResponseSuccess

export const getClientHubControllerGetClient360Url = (id: string) => {
  return `/api-arvore/v1/client-hub/clients/${id}/360`
}

export const clientHubControllerGetClient360 = async (
  id: string,
  options?: RequestInit
): Promise<clientHubControllerGetClient360Response> => {
  return customInstance<clientHubControllerGetClient360Response>(
    getClientHubControllerGetClient360Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get the SuperAutor production journey for a client (events, deadlines, blocks)
 */
export type clientHubControllerGetClientJourneyResponse200 = {
  data: void
  status: 200
}

export type clientHubControllerGetClientJourneyResponseSuccess =
  clientHubControllerGetClientJourneyResponse200 & {
    headers: Headers
  }
export type clientHubControllerGetClientJourneyResponse =
  clientHubControllerGetClientJourneyResponseSuccess

export const getClientHubControllerGetClientJourneyUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/clients/${id}/journey`
}

export const clientHubControllerGetClientJourney = async (
  id: string,
  options?: RequestInit
): Promise<clientHubControllerGetClientJourneyResponse> => {
  return customInstance<clientHubControllerGetClientJourneyResponse>(
    getClientHubControllerGetClientJourneyUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Semantic search over a client conversations
 */
export type clientHubControllerSearchClientConversationsResponse200 = {
  data: void
  status: 200
}

export type clientHubControllerSearchClientConversationsResponseSuccess =
  clientHubControllerSearchClientConversationsResponse200 & {
    headers: Headers
  }
export type clientHubControllerSearchClientConversationsResponse =
  clientHubControllerSearchClientConversationsResponseSuccess

export const getClientHubControllerSearchClientConversationsUrl = (
  id: string,
  params: ClientHubControllerSearchClientConversationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/clients/${id}/conversations/search?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/clients/${id}/conversations/search`
}

export const clientHubControllerSearchClientConversations = async (
  id: string,
  params: ClientHubControllerSearchClientConversationsParams,
  options?: RequestInit
): Promise<clientHubControllerSearchClientConversationsResponse> => {
  return customInstance<clientHubControllerSearchClientConversationsResponse>(
    getClientHubControllerSearchClientConversationsUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List Elephan transcribes for a deal
 */
export type clientHubControllerListElephanTranscribesByDealResponse200 = {
  data: ElephanTranscribeDto[]
  status: 200
}

export type clientHubControllerListElephanTranscribesByDealResponseSuccess =
  clientHubControllerListElephanTranscribesByDealResponse200 & {
    headers: Headers
  }
export type clientHubControllerListElephanTranscribesByDealResponse =
  clientHubControllerListElephanTranscribesByDealResponseSuccess

export const getClientHubControllerListElephanTranscribesByDealUrl = (
  dealId: string,
  params?: ClientHubControllerListElephanTranscribesByDealParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/deals/${dealId}/transcribes?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/deals/${dealId}/transcribes`
}

export const clientHubControllerListElephanTranscribesByDeal = async (
  dealId: string,
  params?: ClientHubControllerListElephanTranscribesByDealParams,
  options?: RequestInit
): Promise<clientHubControllerListElephanTranscribesByDealResponse> => {
  return customInstance<clientHubControllerListElephanTranscribesByDealResponse>(
    getClientHubControllerListElephanTranscribesByDealUrl(dealId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List available Fortics contacts
 */
export type clientHubControllerListForticsContactsResponse200 = {
  data: ForticsContactsPageDto
  status: 200
}

export type clientHubControllerListForticsContactsResponseSuccess =
  clientHubControllerListForticsContactsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListForticsContactsResponse =
  clientHubControllerListForticsContactsResponseSuccess

export const getClientHubControllerListForticsContactsUrl = (
  params?: ClientHubControllerListForticsContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/fortics/contacts?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/fortics/contacts`
}

export const clientHubControllerListForticsContacts = async (
  params?: ClientHubControllerListForticsContactsParams,
  options?: RequestInit
): Promise<clientHubControllerListForticsContactsResponse> => {
  return customInstance<clientHubControllerListForticsContactsResponse>(
    getClientHubControllerListForticsContactsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search Fortics contacts
 */
export type clientHubControllerSearchForticsContactsResponse200 = {
  data: ForticsContactsPageDto
  status: 200
}

export type clientHubControllerSearchForticsContactsResponseSuccess =
  clientHubControllerSearchForticsContactsResponse200 & {
    headers: Headers
  }
export type clientHubControllerSearchForticsContactsResponse =
  clientHubControllerSearchForticsContactsResponseSuccess

export const getClientHubControllerSearchForticsContactsUrl = (
  params: ClientHubControllerSearchForticsContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/fortics/contacts/search?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/fortics/contacts/search`
}

export const clientHubControllerSearchForticsContacts = async (
  params: ClientHubControllerSearchForticsContactsParams,
  options?: RequestInit
): Promise<clientHubControllerSearchForticsContactsResponse> => {
  return customInstance<clientHubControllerSearchForticsContactsResponse>(
    getClientHubControllerSearchForticsContactsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List Octadesk contacts (persons)
 */
export type clientHubControllerListOctadeskContactsResponse200 = {
  data: OctadeskContactsPageDto
  status: 200
}

export type clientHubControllerListOctadeskContactsResponseSuccess =
  clientHubControllerListOctadeskContactsResponse200 & {
    headers: Headers
  }
export type clientHubControllerListOctadeskContactsResponse =
  clientHubControllerListOctadeskContactsResponseSuccess

export const getClientHubControllerListOctadeskContactsUrl = (
  params?: ClientHubControllerListOctadeskContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/octadesk/contacts?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/octadesk/contacts`
}

export const clientHubControllerListOctadeskContacts = async (
  params?: ClientHubControllerListOctadeskContactsParams,
  options?: RequestInit
): Promise<clientHubControllerListOctadeskContactsResponse> => {
  return customInstance<clientHubControllerListOctadeskContactsResponse>(
    getClientHubControllerListOctadeskContactsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Copy new WhatsApp messages into the client hub table
 */
export type clientHubControllerCopyWhatsappMessagesResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerCopyWhatsappMessagesResponseSuccess =
  clientHubControllerCopyWhatsappMessagesResponse201 & {
    headers: Headers
  }
export type clientHubControllerCopyWhatsappMessagesResponse =
  clientHubControllerCopyWhatsappMessagesResponseSuccess

export const getClientHubControllerCopyWhatsappMessagesUrl = () => {
  return `/api-arvore/v1/client-hub/sources/whatsapp/copy`
}

export const clientHubControllerCopyWhatsappMessages = async (
  options?: RequestInit
): Promise<clientHubControllerCopyWhatsappMessagesResponse> => {
  return customInstance<clientHubControllerCopyWhatsappMessagesResponse>(
    getClientHubControllerCopyWhatsappMessagesUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Resolve clientId by phone link for copied WhatsApp messages missing it
 */
export type clientHubControllerBackfillWhatsappClientIdResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerBackfillWhatsappClientIdResponseSuccess =
  clientHubControllerBackfillWhatsappClientIdResponse201 & {
    headers: Headers
  }
export type clientHubControllerBackfillWhatsappClientIdResponse =
  clientHubControllerBackfillWhatsappClientIdResponseSuccess

export const getClientHubControllerBackfillWhatsappClientIdUrl = (
  params: ClientHubControllerBackfillWhatsappClientIdParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/whatsapp/backfill-client-id?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/whatsapp/backfill-client-id`
}

export const clientHubControllerBackfillWhatsappClientId = async (
  params: ClientHubControllerBackfillWhatsappClientIdParams,
  options?: RequestInit
): Promise<clientHubControllerBackfillWhatsappClientIdResponse> => {
  return customInstance<clientHubControllerBackfillWhatsappClientIdResponse>(
    getClientHubControllerBackfillWhatsappClientIdUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Reconcile clientId of WhatsApp messages against current links (clears orphans)
 */
export type clientHubControllerRevokeOrphanWhatsappClientIdResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerRevokeOrphanWhatsappClientIdResponseSuccess =
  clientHubControllerRevokeOrphanWhatsappClientIdResponse201 & {
    headers: Headers
  }
export type clientHubControllerRevokeOrphanWhatsappClientIdResponse =
  clientHubControllerRevokeOrphanWhatsappClientIdResponseSuccess

export const getClientHubControllerRevokeOrphanWhatsappClientIdUrl = () => {
  return `/api-arvore/v1/client-hub/sources/whatsapp/revoke-orphan-client-id`
}

export const clientHubControllerRevokeOrphanWhatsappClientId = async (
  options?: RequestInit
): Promise<clientHubControllerRevokeOrphanWhatsappClientIdResponse> => {
  return customInstance<clientHubControllerRevokeOrphanWhatsappClientIdResponse>(
    getClientHubControllerRevokeOrphanWhatsappClientIdUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Index WhatsApp conversations into the vector store
 */
export type clientHubControllerIndexWhatsappConversationsResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerIndexWhatsappConversationsResponseSuccess =
  clientHubControllerIndexWhatsappConversationsResponse201 & {
    headers: Headers
  }
export type clientHubControllerIndexWhatsappConversationsResponse =
  clientHubControllerIndexWhatsappConversationsResponseSuccess

export const getClientHubControllerIndexWhatsappConversationsUrl = (
  params: ClientHubControllerIndexWhatsappConversationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/whatsapp/index?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/whatsapp/index`
}

export const clientHubControllerIndexWhatsappConversations = async (
  params: ClientHubControllerIndexWhatsappConversationsParams,
  options?: RequestInit
): Promise<clientHubControllerIndexWhatsappConversationsResponse> => {
  return customInstance<clientHubControllerIndexWhatsappConversationsResponse>(
    getClientHubControllerIndexWhatsappConversationsUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Index pending Elephan transcribes into the vector store
 */
export type clientHubControllerIndexElephanTranscribesResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerIndexElephanTranscribesResponseSuccess =
  clientHubControllerIndexElephanTranscribesResponse201 & {
    headers: Headers
  }
export type clientHubControllerIndexElephanTranscribesResponse =
  clientHubControllerIndexElephanTranscribesResponseSuccess

export const getClientHubControllerIndexElephanTranscribesUrl = (
  params: ClientHubControllerIndexElephanTranscribesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/index?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/index`
}

export const clientHubControllerIndexElephanTranscribes = async (
  params: ClientHubControllerIndexElephanTranscribesParams,
  options?: RequestInit
): Promise<clientHubControllerIndexElephanTranscribesResponse> => {
  return customInstance<clientHubControllerIndexElephanTranscribesResponse>(
    getClientHubControllerIndexElephanTranscribesUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Resolve and store org_id for Elephan Pipedrive transcribes
 */
export type clientHubControllerBackfillElephanOrgIdsResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerBackfillElephanOrgIdsResponseSuccess =
  clientHubControllerBackfillElephanOrgIdsResponse201 & {
    headers: Headers
  }
export type clientHubControllerBackfillElephanOrgIdsResponse =
  clientHubControllerBackfillElephanOrgIdsResponseSuccess

export const getClientHubControllerBackfillElephanOrgIdsUrl = (
  params: ClientHubControllerBackfillElephanOrgIdsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/backfill-org?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/backfill-org`
}

export const clientHubControllerBackfillElephanOrgIds = async (
  params: ClientHubControllerBackfillElephanOrgIdsParams,
  options?: RequestInit
): Promise<clientHubControllerBackfillElephanOrgIdsResponse> => {
  return customInstance<clientHubControllerBackfillElephanOrgIdsResponse>(
    getClientHubControllerBackfillElephanOrgIdsUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Resolve client_source_links by CNPJ against Super schools
 */
export type clientHubControllerResolvePipedriveLinksResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerResolvePipedriveLinksResponseSuccess =
  clientHubControllerResolvePipedriveLinksResponse201 & {
    headers: Headers
  }
export type clientHubControllerResolvePipedriveLinksResponse =
  clientHubControllerResolvePipedriveLinksResponseSuccess

export const getClientHubControllerResolvePipedriveLinksUrl = () => {
  return `/api-arvore/v1/client-hub/sources/pipedrive/resolve-links`
}

export const clientHubControllerResolvePipedriveLinks = async (
  options?: RequestInit
): Promise<clientHubControllerResolvePipedriveLinksResponse> => {
  return customInstance<clientHubControllerResolvePipedriveLinksResponse>(
    getClientHubControllerResolvePipedriveLinksUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Report Pipedrive org resolution by confidence layer and status
 */
export type clientHubControllerPipedriveResolutionReportResponse200 = {
  data: void
  status: 200
}

export type clientHubControllerPipedriveResolutionReportResponseSuccess =
  clientHubControllerPipedriveResolutionReportResponse200 & {
    headers: Headers
  }
export type clientHubControllerPipedriveResolutionReportResponse =
  clientHubControllerPipedriveResolutionReportResponseSuccess

export const getClientHubControllerPipedriveResolutionReportUrl = () => {
  return `/api-arvore/v1/client-hub/sources/pipedrive/resolution-report`
}

export const clientHubControllerPipedriveResolutionReport = async (
  options?: RequestInit
): Promise<clientHubControllerPipedriveResolutionReportResponse> => {
  return customInstance<clientHubControllerPipedriveResolutionReportResponse>(
    getClientHubControllerPipedriveResolutionReportUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Backfill metadata.clientId on indexed Elephan points (no re-embed)
 */
export type clientHubControllerBackfillElephanClientIdResponse201 = {
  data: void
  status: 201
}

export type clientHubControllerBackfillElephanClientIdResponseSuccess =
  clientHubControllerBackfillElephanClientIdResponse201 & {
    headers: Headers
  }
export type clientHubControllerBackfillElephanClientIdResponse =
  clientHubControllerBackfillElephanClientIdResponseSuccess

export const getClientHubControllerBackfillElephanClientIdUrl = (
  params: ClientHubControllerBackfillElephanClientIdParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/sources/elephan/backfill-client-id?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/sources/elephan/backfill-client-id`
}

export const clientHubControllerBackfillElephanClientId = async (
  params: ClientHubControllerBackfillElephanClientIdParams,
  options?: RequestInit
): Promise<clientHubControllerBackfillElephanClientIdResponse> => {
  return customInstance<clientHubControllerBackfillElephanClientIdResponse>(
    getClientHubControllerBackfillElephanClientIdUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List connected email accounts
 */
export type clientHubEmailControllerListAccountsResponse200 = {
  data: void
  status: 200
}

export type clientHubEmailControllerListAccountsResponseSuccess =
  clientHubEmailControllerListAccountsResponse200 & {
    headers: Headers
  }
export type clientHubEmailControllerListAccountsResponse =
  clientHubEmailControllerListAccountsResponseSuccess

export const getClientHubEmailControllerListAccountsUrl = () => {
  return `/api-arvore/v1/client-hub/email/accounts`
}

export const clientHubEmailControllerListAccounts = async (
  options?: RequestInit
): Promise<clientHubEmailControllerListAccountsResponse> => {
  return customInstance<clientHubEmailControllerListAccountsResponse>(
    getClientHubEmailControllerListAccountsUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get Gmail OAuth consent URL
 */
export type clientHubEmailControllerGetOAuthUrlResponse200 = {
  data: void
  status: 200
}

export type clientHubEmailControllerGetOAuthUrlResponseSuccess =
  clientHubEmailControllerGetOAuthUrlResponse200 & {
    headers: Headers
  }
export type clientHubEmailControllerGetOAuthUrlResponse =
  clientHubEmailControllerGetOAuthUrlResponseSuccess

export const getClientHubEmailControllerGetOAuthUrlUrl = () => {
  return `/api-arvore/v1/client-hub/email/oauth/url`
}

export const clientHubEmailControllerGetOAuthUrl = async (
  options?: RequestInit
): Promise<clientHubEmailControllerGetOAuthUrlResponse> => {
  return customInstance<clientHubEmailControllerGetOAuthUrlResponse>(
    getClientHubEmailControllerGetOAuthUrlUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Gmail OAuth callback
 */
export type clientHubEmailControllerOauthCallbackResponse200 = {
  data: void
  status: 200
}

export type clientHubEmailControllerOauthCallbackResponseSuccess =
  clientHubEmailControllerOauthCallbackResponse200 & {
    headers: Headers
  }
export type clientHubEmailControllerOauthCallbackResponse =
  clientHubEmailControllerOauthCallbackResponseSuccess

export const getClientHubEmailControllerOauthCallbackUrl = (
  params: ClientHubEmailControllerOauthCallbackParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/email/oauth/callback?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/email/oauth/callback`
}

export const clientHubEmailControllerOauthCallback = async (
  params: ClientHubEmailControllerOauthCallbackParams,
  options?: RequestInit
): Promise<clientHubEmailControllerOauthCallbackResponse> => {
  return customInstance<clientHubEmailControllerOauthCallbackResponse>(
    getClientHubEmailControllerOauthCallbackUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Disconnect an email account
 */
export type clientHubEmailControllerDisconnectResponse200 = {
  data: void
  status: 200
}

export type clientHubEmailControllerDisconnectResponseSuccess =
  clientHubEmailControllerDisconnectResponse200 & {
    headers: Headers
  }
export type clientHubEmailControllerDisconnectResponse =
  clientHubEmailControllerDisconnectResponseSuccess

export const getClientHubEmailControllerDisconnectUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/email/accounts/${id}`
}

export const clientHubEmailControllerDisconnect = async (
  id: string,
  options?: RequestInit
): Promise<clientHubEmailControllerDisconnectResponse> => {
  return customInstance<clientHubEmailControllerDisconnectResponse>(
    getClientHubEmailControllerDisconnectUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List contacts from the connected mailbox
 */
export type clientHubEmailControllerListContactsResponse200 = {
  data: void
  status: 200
}

export type clientHubEmailControllerListContactsResponseSuccess =
  clientHubEmailControllerListContactsResponse200 & {
    headers: Headers
  }
export type clientHubEmailControllerListContactsResponse =
  clientHubEmailControllerListContactsResponseSuccess

export const getClientHubEmailControllerListContactsUrl = (
  id: string,
  params: ClientHubEmailControllerListContactsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/email/accounts/${id}/contacts?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/email/accounts/${id}/contacts`
}

export const clientHubEmailControllerListContacts = async (
  id: string,
  params: ClientHubEmailControllerListContactsParams,
  options?: RequestInit
): Promise<clientHubEmailControllerListContactsResponse> => {
  return customInstance<clientHubEmailControllerListContactsResponse>(
    getClientHubEmailControllerListContactsUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Sync contacts from the mailbox into the database
 */
export type clientHubEmailControllerSyncContactsResponse201 = {
  data: void
  status: 201
}

export type clientHubEmailControllerSyncContactsResponseSuccess =
  clientHubEmailControllerSyncContactsResponse201 & {
    headers: Headers
  }
export type clientHubEmailControllerSyncContactsResponse =
  clientHubEmailControllerSyncContactsResponseSuccess

export const getClientHubEmailControllerSyncContactsUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/email/accounts/${id}/sync`
}

export const clientHubEmailControllerSyncContacts = async (
  id: string,
  options?: RequestInit
): Promise<clientHubEmailControllerSyncContactsResponse> => {
  return customInstance<clientHubEmailControllerSyncContactsResponse>(
    getClientHubEmailControllerSyncContactsUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Ingest email bodies from the mailbox into the database
 */
export type clientHubEmailControllerIngestMessagesResponse201 = {
  data: void
  status: 201
}

export type clientHubEmailControllerIngestMessagesResponseSuccess =
  clientHubEmailControllerIngestMessagesResponse201 & {
    headers: Headers
  }
export type clientHubEmailControllerIngestMessagesResponse =
  clientHubEmailControllerIngestMessagesResponseSuccess

export const getClientHubEmailControllerIngestMessagesUrl = (id: string) => {
  return `/api-arvore/v1/client-hub/email/accounts/${id}/ingest`
}

export const clientHubEmailControllerIngestMessages = async (
  id: string,
  options?: RequestInit
): Promise<clientHubEmailControllerIngestMessagesResponse> => {
  return customInstance<clientHubEmailControllerIngestMessagesResponse>(
    getClientHubEmailControllerIngestMessagesUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Resolve clientId by email domain for messages missing it
 */
export type clientHubEmailControllerBackfillClientsResponse201 = {
  data: void
  status: 201
}

export type clientHubEmailControllerBackfillClientsResponseSuccess =
  clientHubEmailControllerBackfillClientsResponse201 & {
    headers: Headers
  }
export type clientHubEmailControllerBackfillClientsResponse =
  clientHubEmailControllerBackfillClientsResponseSuccess

export const getClientHubEmailControllerBackfillClientsUrl = () => {
  return `/api-arvore/v1/client-hub/email/backfill-clients`
}

export const clientHubEmailControllerBackfillClients = async (
  options?: RequestInit
): Promise<clientHubEmailControllerBackfillClientsResponse> => {
  return customInstance<clientHubEmailControllerBackfillClientsResponse>(
    getClientHubEmailControllerBackfillClientsUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Backfill metadata.clientId on indexed email points (no re-embed)
 */
export type clientHubEmailControllerBackfillClientIdPayloadResponse201 = {
  data: void
  status: 201
}

export type clientHubEmailControllerBackfillClientIdPayloadResponseSuccess =
  clientHubEmailControllerBackfillClientIdPayloadResponse201 & {
    headers: Headers
  }
export type clientHubEmailControllerBackfillClientIdPayloadResponse =
  clientHubEmailControllerBackfillClientIdPayloadResponseSuccess

export const getClientHubEmailControllerBackfillClientIdPayloadUrl = (
  params: ClientHubEmailControllerBackfillClientIdPayloadParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/email/backfill-client-id?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/email/backfill-client-id`
}

export const clientHubEmailControllerBackfillClientIdPayload = async (
  params: ClientHubEmailControllerBackfillClientIdPayloadParams,
  options?: RequestInit
): Promise<clientHubEmailControllerBackfillClientIdPayloadResponse> => {
  return customInstance<clientHubEmailControllerBackfillClientIdPayloadResponse>(
    getClientHubEmailControllerBackfillClientIdPayloadUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Index pending email messages into the vector store
 */
export type clientHubEmailControllerIndexMessagesResponse201 = {
  data: void
  status: 201
}

export type clientHubEmailControllerIndexMessagesResponseSuccess =
  clientHubEmailControllerIndexMessagesResponse201 & {
    headers: Headers
  }
export type clientHubEmailControllerIndexMessagesResponse =
  clientHubEmailControllerIndexMessagesResponseSuccess

export const getClientHubEmailControllerIndexMessagesUrl = (
  params: ClientHubEmailControllerIndexMessagesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/client-hub/email/index?${stringifiedParams}`
    : `/api-arvore/v1/client-hub/email/index`
}

export const clientHubEmailControllerIndexMessages = async (
  params: ClientHubEmailControllerIndexMessagesParams,
  options?: RequestInit
): Promise<clientHubEmailControllerIndexMessagesResponse> => {
  return customInstance<clientHubEmailControllerIndexMessagesResponse>(
    getClientHubEmailControllerIndexMessagesUrl(params),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List unified entities (Árvore + SuperAutor)
 */
export type entityManagementControllerListEntitiesResponse200 = {
  data: ListUnifiedEntitiesResponseDto
  status: 200
}

export type entityManagementControllerListEntitiesResponseSuccess =
  entityManagementControllerListEntitiesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListEntitiesResponse =
  entityManagementControllerListEntitiesResponseSuccess

export const getEntityManagementControllerListEntitiesUrl = (
  params?: EntityManagementControllerListEntitiesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/entities?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/entities`
}

export const entityManagementControllerListEntities = async (
  params?: EntityManagementControllerListEntitiesParams,
  options?: RequestInit
): Promise<entityManagementControllerListEntitiesResponse> => {
  return customInstance<entityManagementControllerListEntitiesResponse>(
    getEntityManagementControllerListEntitiesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create unified entity (Árvore + SuperAutor)
 */
export type entityManagementControllerCreateEntityResponse201 = {
  data: CreateUnifiedEntityResponseDto
  status: 201
}

export type entityManagementControllerCreateEntityResponseSuccess =
  entityManagementControllerCreateEntityResponse201 & {
    headers: Headers
  }
export type entityManagementControllerCreateEntityResponse =
  entityManagementControllerCreateEntityResponseSuccess

export const getEntityManagementControllerCreateEntityUrl = () => {
  return `/api-arvore/backoffice/entity-management/entities`
}

export const entityManagementControllerCreateEntity = async (
  createUnifiedEntityBodyDto: CreateUnifiedEntityBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerCreateEntityResponse> => {
  return customInstance<entityManagementControllerCreateEntityResponse>(
    getEntityManagementControllerCreateEntityUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createUnifiedEntityBodyDto)
    }
  )
}

/**
 * @summary List children of an entity
 */
export type entityManagementControllerListChildrenResponse200 = {
  data: ListUnifiedEntitiesResponseDto
  status: 200
}

export type entityManagementControllerListChildrenResponseSuccess =
  entityManagementControllerListChildrenResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListChildrenResponse =
  entityManagementControllerListChildrenResponseSuccess

export const getEntityManagementControllerListChildrenUrl = (
  params: EntityManagementControllerListChildrenParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/children?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/children`
}

export const entityManagementControllerListChildren = async (
  params: EntityManagementControllerListChildrenParams,
  options?: RequestInit
): Promise<entityManagementControllerListChildrenResponse> => {
  return customInstance<entityManagementControllerListChildrenResponse>(
    getEntityManagementControllerListChildrenUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List users of an entity
 */
export type entityManagementControllerListUsersResponse200 = {
  data: ListEntityUsersResponseDto
  status: 200
}

export type entityManagementControllerListUsersResponseSuccess =
  entityManagementControllerListUsersResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListUsersResponse =
  entityManagementControllerListUsersResponseSuccess

export const getEntityManagementControllerListUsersUrl = (
  params: EntityManagementControllerListUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/users?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/users`
}

export const entityManagementControllerListUsers = async (
  params: EntityManagementControllerListUsersParams,
  options?: RequestInit
): Promise<entityManagementControllerListUsersResponse> => {
  return customInstance<entityManagementControllerListUsersResponse>(
    getEntityManagementControllerListUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create users and link to entity
 */
export type entityManagementControllerCreateUsersResponse201 = {
  data: CreateUserResponseDto
  status: 201
}

export type entityManagementControllerCreateUsersResponseSuccess =
  entityManagementControllerCreateUsersResponse201 & {
    headers: Headers
  }
export type entityManagementControllerCreateUsersResponse =
  entityManagementControllerCreateUsersResponseSuccess

export const getEntityManagementControllerCreateUsersUrl = () => {
  return `/api-arvore/backoffice/entity-management/users`
}

export const entityManagementControllerCreateUsers = async (
  createUserBodyDto: CreateUserBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerCreateUsersResponse> => {
  return customInstance<entityManagementControllerCreateUsersResponse>(
    getEntityManagementControllerCreateUsersUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createUserBodyDto)
    }
  )
}

/**
 * @summary List modules assigned to an entity
 */
export type entityManagementControllerListEntityModulesResponse200 = {
  data: ListEntityModulesResponseDto
  status: 200
}

export type entityManagementControllerListEntityModulesResponseSuccess =
  entityManagementControllerListEntityModulesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListEntityModulesResponse =
  entityManagementControllerListEntityModulesResponseSuccess

export const getEntityManagementControllerListEntityModulesUrl = (
  params: EntityManagementControllerListEntityModulesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/entity-modules?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/entity-modules`
}

export const entityManagementControllerListEntityModules = async (
  params: EntityManagementControllerListEntityModulesParams,
  options?: RequestInit
): Promise<entityManagementControllerListEntityModulesResponse> => {
  return customInstance<entityManagementControllerListEntityModulesResponse>(
    getEntityManagementControllerListEntityModulesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Export user cards (carteirinhas) for an entity
 */
export type entityManagementControllerExportCardsResponse200 = {
  data: void
  status: 200
}

export type entityManagementControllerExportCardsResponseSuccess =
  entityManagementControllerExportCardsResponse200 & {
    headers: Headers
  }
export type entityManagementControllerExportCardsResponse =
  entityManagementControllerExportCardsResponseSuccess

export const getEntityManagementControllerExportCardsUrl = (
  ref: string,
  params: EntityManagementControllerExportCardsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/export-cards/${ref}?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/export-cards/${ref}`
}

export const entityManagementControllerExportCards = async (
  ref: string,
  params: EntityManagementControllerExportCardsParams,
  options?: RequestInit
): Promise<entityManagementControllerExportCardsResponse> => {
  return customInstance<entityManagementControllerExportCardsResponse>(
    getEntityManagementControllerExportCardsUrl(ref, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get entity detail with all fields
 */
export type entityManagementControllerGetEntityDetailResponse200 = {
  data: EntityDetailResponseDto
  status: 200
}

export type entityManagementControllerGetEntityDetailResponseSuccess =
  entityManagementControllerGetEntityDetailResponse200 & {
    headers: Headers
  }
export type entityManagementControllerGetEntityDetailResponse =
  entityManagementControllerGetEntityDetailResponseSuccess

export const getEntityManagementControllerGetEntityDetailUrl = (
  ref: string
) => {
  return `/api-arvore/backoffice/entity-management/entities/${ref}`
}

export const entityManagementControllerGetEntityDetail = async (
  ref: string,
  options?: RequestInit
): Promise<entityManagementControllerGetEntityDetailResponse> => {
  return customInstance<entityManagementControllerGetEntityDetailResponse>(
    getEntityManagementControllerGetEntityDetailUrl(ref),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update entity in both systems
 */
export type entityManagementControllerUpdateEntityResponse200 = {
  data: UpdateUnifiedEntityResponseDto
  status: 200
}

export type entityManagementControllerUpdateEntityResponseSuccess =
  entityManagementControllerUpdateEntityResponse200 & {
    headers: Headers
  }
export type entityManagementControllerUpdateEntityResponse =
  entityManagementControllerUpdateEntityResponseSuccess

export const getEntityManagementControllerUpdateEntityUrl = (ref: string) => {
  return `/api-arvore/backoffice/entity-management/entities/${ref}`
}

export const entityManagementControllerUpdateEntity = async (
  ref: string,
  updateUnifiedEntityBodyDto: UpdateUnifiedEntityBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerUpdateEntityResponse> => {
  return customInstance<entityManagementControllerUpdateEntityResponse>(
    getEntityManagementControllerUpdateEntityUrl(ref),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateUnifiedEntityBodyDto)
    }
  )
}

/**
 * @summary Deactivate an entity and its descendants (b2b subscription accounts)
 */
export type entityManagementControllerSoftDeleteEntityResponse200 = {
  data: SoftDeleteEntityResponseDto
  status: 200
}

export type entityManagementControllerSoftDeleteEntityResponseSuccess =
  entityManagementControllerSoftDeleteEntityResponse200 & {
    headers: Headers
  }
export type entityManagementControllerSoftDeleteEntityResponse =
  entityManagementControllerSoftDeleteEntityResponseSuccess

export const getEntityManagementControllerSoftDeleteEntityUrl = (
  ref: string
) => {
  return `/api-arvore/backoffice/entity-management/entities/${ref}`
}

export const entityManagementControllerSoftDeleteEntity = async (
  ref: string,
  options?: RequestInit
): Promise<entityManagementControllerSoftDeleteEntityResponse> => {
  return customInstance<entityManagementControllerSoftDeleteEntityResponse>(
    getEntityManagementControllerSoftDeleteEntityUrl(ref),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Search users globally by name, email, phone, token, identity_id
 */
export type entityManagementControllerSearchUsersResponse200 = {
  data: ListEntityUsersResponseDto
  status: 200
}

export type entityManagementControllerSearchUsersResponseSuccess =
  entityManagementControllerSearchUsersResponse200 & {
    headers: Headers
  }
export type entityManagementControllerSearchUsersResponse =
  entityManagementControllerSearchUsersResponseSuccess

export const getEntityManagementControllerSearchUsersUrl = (
  params: EntityManagementControllerSearchUsersParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/search-users?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/search-users`
}

export const entityManagementControllerSearchUsers = async (
  params: EntityManagementControllerSearchUsersParams,
  options?: RequestInit
): Promise<entityManagementControllerSearchUsersResponse> => {
  return customInstance<entityManagementControllerSearchUsersResponse>(
    getEntityManagementControllerSearchUsersUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Enable/disable Escrita platform for an entity
 */
export type entityManagementControllerTogglePlatformResponse200 = {
  data: TogglePlatformResponseDto
  status: 200
}

export type entityManagementControllerTogglePlatformResponseSuccess =
  entityManagementControllerTogglePlatformResponse200 & {
    headers: Headers
  }
export type entityManagementControllerTogglePlatformResponse =
  entityManagementControllerTogglePlatformResponseSuccess

export const getEntityManagementControllerTogglePlatformUrl = () => {
  return `/api-arvore/backoffice/entity-management/toggle-platform`
}

export const entityManagementControllerTogglePlatform = async (
  togglePlatformBodyDto: TogglePlatformBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerTogglePlatformResponse> => {
  return customInstance<entityManagementControllerTogglePlatformResponse>(
    getEntityManagementControllerTogglePlatformUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(togglePlatformBodyDto)
    }
  )
}

/**
 * @summary Sync all users of an entity to identity queue
 */
export type entityManagementControllerSyncEntityResponse201 = {
  data: void
  status: 201
}

export type entityManagementControllerSyncEntityResponseSuccess =
  entityManagementControllerSyncEntityResponse201 & {
    headers: Headers
  }
export type entityManagementControllerSyncEntityResponse =
  entityManagementControllerSyncEntityResponseSuccess

export const getEntityManagementControllerSyncEntityUrl = (ref: string) => {
  return `/api-arvore/backoffice/entity-management/sync-entity/${ref}`
}

export const entityManagementControllerSyncEntity = async (
  ref: string,
  options?: RequestInit
): Promise<entityManagementControllerSyncEntityResponse> => {
  return customInstance<entityManagementControllerSyncEntityResponse>(
    getEntityManagementControllerSyncEntityUrl(ref),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Move a user from one entity to another
 */
export type entityManagementControllerMoveUserResponse200 = {
  data: MoveUserResponseDto
  status: 200
}

export type entityManagementControllerMoveUserResponseSuccess =
  entityManagementControllerMoveUserResponse200 & {
    headers: Headers
  }
export type entityManagementControllerMoveUserResponse =
  entityManagementControllerMoveUserResponseSuccess

export const getEntityManagementControllerMoveUserUrl = () => {
  return `/api-arvore/backoffice/entity-management/move-user`
}

export const entityManagementControllerMoveUser = async (
  moveUserBodyDto: MoveUserBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerMoveUserResponse> => {
  return customInstance<entityManagementControllerMoveUserResponse>(
    getEntityManagementControllerMoveUserUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(moveUserBodyDto)
    }
  )
}

/**
 * @summary Move and reactivate a user to a target entity
 */
export type entityManagementControllerActivateUserResponse200 = {
  data: ActivateUserResponseDto
  status: 200
}

export type entityManagementControllerActivateUserResponseSuccess =
  entityManagementControllerActivateUserResponse200 & {
    headers: Headers
  }
export type entityManagementControllerActivateUserResponse =
  entityManagementControllerActivateUserResponseSuccess

export const getEntityManagementControllerActivateUserUrl = () => {
  return `/api-arvore/backoffice/entity-management/activate-user`
}

export const entityManagementControllerActivateUser = async (
  activateUserBodyDto: ActivateUserBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerActivateUserResponse> => {
  return customInstance<entityManagementControllerActivateUserResponse>(
    getEntityManagementControllerActivateUserUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(activateUserBodyDto)
    }
  )
}

/**
 * @summary Move and reactivate multiple users in batch
 */
export type entityManagementControllerActivateUsersBulkResponse200 = {
  data: ActivateUsersBulkResponseDto
  status: 200
}

export type entityManagementControllerActivateUsersBulkResponseSuccess =
  entityManagementControllerActivateUsersBulkResponse200 & {
    headers: Headers
  }
export type entityManagementControllerActivateUsersBulkResponse =
  entityManagementControllerActivateUsersBulkResponseSuccess

export const getEntityManagementControllerActivateUsersBulkUrl = () => {
  return `/api-arvore/backoffice/entity-management/activate-users-bulk`
}

export const entityManagementControllerActivateUsersBulk = async (
  activateUsersBulkBodyDto: ActivateUsersBulkBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerActivateUsersBulkResponse> => {
  return customInstance<entityManagementControllerActivateUsersBulkResponse>(
    getEntityManagementControllerActivateUsersBulkUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(activateUsersBulkBodyDto)
    }
  )
}

/**
 * @summary Update user in both systems (Árvore + SuperAutor)
 */
export type entityManagementControllerUpdateUserResponse200 = {
  data: UpdateUserResponseDto
  status: 200
}

export type entityManagementControllerUpdateUserResponseSuccess =
  entityManagementControllerUpdateUserResponse200 & {
    headers: Headers
  }
export type entityManagementControllerUpdateUserResponse =
  entityManagementControllerUpdateUserResponseSuccess

export const getEntityManagementControllerUpdateUserUrl = (ref: string) => {
  return `/api-arvore/backoffice/entity-management/users/${ref}`
}

export const entityManagementControllerUpdateUser = async (
  ref: string,
  updateUserBodyDto: UpdateUserBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerUpdateUserResponse> => {
  return customInstance<entityManagementControllerUpdateUserResponse>(
    getEntityManagementControllerUpdateUserUrl(ref),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateUserBodyDto)
    }
  )
}

/**
 * @summary Remove user profile from an entity (soft delete)
 */
export type entityManagementControllerRemoveUserProfileResponse200 = {
  data: RemoveUserProfileResponseDto
  status: 200
}

export type entityManagementControllerRemoveUserProfileResponseSuccess =
  entityManagementControllerRemoveUserProfileResponse200 & {
    headers: Headers
  }
export type entityManagementControllerRemoveUserProfileResponse =
  entityManagementControllerRemoveUserProfileResponseSuccess

export const getEntityManagementControllerRemoveUserProfileUrl = (
  ref: string,
  params: EntityManagementControllerRemoveUserProfileParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/users/${ref}/profile?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/users/${ref}/profile`
}

export const entityManagementControllerRemoveUserProfile = async (
  ref: string,
  params: EntityManagementControllerRemoveUserProfileParams,
  options?: RequestInit
): Promise<entityManagementControllerRemoveUserProfileResponse> => {
  return customInstance<entityManagementControllerRemoveUserProfileResponse>(
    getEntityManagementControllerRemoveUserProfileUrl(ref, params),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary List contracts for a root entity
 */
export type entityManagementControllerListContractsResponse200 = {
  data: ListContractsResponseDto
  status: 200
}

export type entityManagementControllerListContractsResponseSuccess =
  entityManagementControllerListContractsResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListContractsResponse =
  entityManagementControllerListContractsResponseSuccess

export const getEntityManagementControllerListContractsUrl = (
  params: EntityManagementControllerListContractsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/entity-management/contracts?${stringifiedParams}`
    : `/api-arvore/backoffice/entity-management/contracts`
}

export const entityManagementControllerListContracts = async (
  params: EntityManagementControllerListContractsParams,
  options?: RequestInit
): Promise<entityManagementControllerListContractsResponse> => {
  return customInstance<entityManagementControllerListContractsResponse>(
    getEntityManagementControllerListContractsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new contract
 */
export type entityManagementControllerCreateContractResponse201 = {
  data: CreateContractResponseDto
  status: 201
}

export type entityManagementControllerCreateContractResponseSuccess =
  entityManagementControllerCreateContractResponse201 & {
    headers: Headers
  }
export type entityManagementControllerCreateContractResponse =
  entityManagementControllerCreateContractResponseSuccess

export const getEntityManagementControllerCreateContractUrl = () => {
  return `/api-arvore/backoffice/entity-management/contracts`
}

export const entityManagementControllerCreateContract = async (
  createContractBodyDto: CreateContractBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerCreateContractResponse> => {
  return customInstance<entityManagementControllerCreateContractResponse>(
    getEntityManagementControllerCreateContractUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createContractBodyDto)
    }
  )
}

/**
 * @summary Get full contract detail
 */
export type entityManagementControllerGetContractDetailResponse200 = {
  data: ContractDetailResponseDto
  status: 200
}

export type entityManagementControllerGetContractDetailResponseSuccess =
  entityManagementControllerGetContractDetailResponse200 & {
    headers: Headers
  }
export type entityManagementControllerGetContractDetailResponse =
  entityManagementControllerGetContractDetailResponseSuccess

export const getEntityManagementControllerGetContractDetailUrl = (
  id: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${id}`
}

export const entityManagementControllerGetContractDetail = async (
  id: number,
  options?: RequestInit
): Promise<entityManagementControllerGetContractDetailResponse> => {
  return customInstance<entityManagementControllerGetContractDetailResponse>(
    getEntityManagementControllerGetContractDetailUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update contract fields
 */
export type entityManagementControllerUpdateContractResponse200 = {
  data: UpdateContractResponseDto
  status: 200
}

export type entityManagementControllerUpdateContractResponseSuccess =
  entityManagementControllerUpdateContractResponse200 & {
    headers: Headers
  }
export type entityManagementControllerUpdateContractResponse =
  entityManagementControllerUpdateContractResponseSuccess

export const getEntityManagementControllerUpdateContractUrl = (id: number) => {
  return `/api-arvore/backoffice/entity-management/contracts/${id}`
}

export const entityManagementControllerUpdateContract = async (
  id: number,
  updateContractBodyDto: UpdateContractBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerUpdateContractResponse> => {
  return customInstance<entityManagementControllerUpdateContractResponse>(
    getEntityManagementControllerUpdateContractUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateContractBodyDto)
    }
  )
}

/**
 * @summary Toggle contract active status
 */
export type entityManagementControllerToggleContractActiveResponse200 = {
  data: ToggleContractActiveResponseDto
  status: 200
}

export type entityManagementControllerToggleContractActiveResponseSuccess =
  entityManagementControllerToggleContractActiveResponse200 & {
    headers: Headers
  }
export type entityManagementControllerToggleContractActiveResponse =
  entityManagementControllerToggleContractActiveResponseSuccess

export const getEntityManagementControllerToggleContractActiveUrl = (
  id: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${id}/activate`
}

export const entityManagementControllerToggleContractActive = async (
  id: number,
  toggleContractActiveBodyDto: ToggleContractActiveBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerToggleContractActiveResponse> => {
  return customInstance<entityManagementControllerToggleContractActiveResponse>(
    getEntityManagementControllerToggleContractActiveUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleContractActiveBodyDto)
    }
  )
}

/**
 * @summary Create or update modules for a contract
 */
export type entityManagementControllerUpsertContractModulesResponse200 = {
  data: UpsertContractModulesResponseDto
  status: 200
}

export type entityManagementControllerUpsertContractModulesResponseSuccess =
  entityManagementControllerUpsertContractModulesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerUpsertContractModulesResponse =
  entityManagementControllerUpsertContractModulesResponseSuccess

export const getEntityManagementControllerUpsertContractModulesUrl = (
  id: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${id}/modules`
}

export const entityManagementControllerUpsertContractModules = async (
  id: number,
  upsertContractModulesBodyDto: UpsertContractModulesBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerUpsertContractModulesResponse> => {
  return customInstance<entityManagementControllerUpsertContractModulesResponse>(
    getEntityManagementControllerUpsertContractModulesUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertContractModulesBodyDto)
    }
  )
}

/**
 * @summary Assign module to entities
 */
export type entityManagementControllerAssignModuleToEntitiesResponse200 = {
  data: AssignModuleToEntitiesResponseDto
  status: 200
}

export type entityManagementControllerAssignModuleToEntitiesResponseSuccess =
  entityManagementControllerAssignModuleToEntitiesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerAssignModuleToEntitiesResponse =
  entityManagementControllerAssignModuleToEntitiesResponseSuccess

export const getEntityManagementControllerAssignModuleToEntitiesUrl = (
  contractId: number,
  contractModuleId: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${contractId}/modules/${contractModuleId}/entities`
}

export const entityManagementControllerAssignModuleToEntities = async (
  contractId: number,
  contractModuleId: number,
  assignModuleToEntitiesBodyDto: AssignModuleToEntitiesBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerAssignModuleToEntitiesResponse> => {
  return customInstance<entityManagementControllerAssignModuleToEntitiesResponse>(
    getEntityManagementControllerAssignModuleToEntitiesUrl(
      contractId,
      contractModuleId
    ),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(assignModuleToEntitiesBodyDto)
    }
  )
}

/**
 * @summary Remove module from entities
 */
export type entityManagementControllerRemoveModuleFromEntitiesResponse200 = {
  data: RemoveModuleFromEntitiesResponseDto
  status: 200
}

export type entityManagementControllerRemoveModuleFromEntitiesResponseSuccess =
  entityManagementControllerRemoveModuleFromEntitiesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerRemoveModuleFromEntitiesResponse =
  entityManagementControllerRemoveModuleFromEntitiesResponseSuccess

export const getEntityManagementControllerRemoveModuleFromEntitiesUrl = (
  contractId: number,
  contractModuleId: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${contractId}/modules/${contractModuleId}/entities`
}

export const entityManagementControllerRemoveModuleFromEntities = async (
  contractId: number,
  contractModuleId: number,
  removeModuleFromEntitiesBodyDto: RemoveModuleFromEntitiesBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerRemoveModuleFromEntitiesResponse> => {
  return customInstance<entityManagementControllerRemoveModuleFromEntitiesResponse>(
    getEntityManagementControllerRemoveModuleFromEntitiesUrl(
      contractId,
      contractModuleId
    ),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(removeModuleFromEntitiesBodyDto)
    }
  )
}

/**
 * @summary Toggle contract features
 */
export type entityManagementControllerToggleContractFeaturesResponse200 = {
  data: ToggleContractFeaturesResponseDto
  status: 200
}

export type entityManagementControllerToggleContractFeaturesResponseSuccess =
  entityManagementControllerToggleContractFeaturesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerToggleContractFeaturesResponse =
  entityManagementControllerToggleContractFeaturesResponseSuccess

export const getEntityManagementControllerToggleContractFeaturesUrl = (
  id: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${id}/features`
}

export const entityManagementControllerToggleContractFeatures = async (
  id: number,
  toggleContractFeaturesBodyDto: ToggleContractFeaturesBodyDto,
  options?: RequestInit
): Promise<entityManagementControllerToggleContractFeaturesResponse> => {
  return customInstance<entityManagementControllerToggleContractFeaturesResponse>(
    getEntityManagementControllerToggleContractFeaturesUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleContractFeaturesBodyDto)
    }
  )
}

/**
 * @summary List all available modules
 */
export type entityManagementControllerListModulesResponse200 = {
  data: ListModulesResponseDto
  status: 200
}

export type entityManagementControllerListModulesResponseSuccess =
  entityManagementControllerListModulesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListModulesResponse =
  entityManagementControllerListModulesResponseSuccess

export const getEntityManagementControllerListModulesUrl = () => {
  return `/api-arvore/backoffice/entity-management/modules`
}

export const entityManagementControllerListModules = async (
  options?: RequestInit
): Promise<entityManagementControllerListModulesResponse> => {
  return customInstance<entityManagementControllerListModulesResponse>(
    getEntityManagementControllerListModulesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all available features
 */
export type entityManagementControllerListFeaturesResponse200 = {
  data: ListFeaturesResponseDto
  status: 200
}

export type entityManagementControllerListFeaturesResponseSuccess =
  entityManagementControllerListFeaturesResponse200 & {
    headers: Headers
  }
export type entityManagementControllerListFeaturesResponse =
  entityManagementControllerListFeaturesResponseSuccess

export const getEntityManagementControllerListFeaturesUrl = () => {
  return `/api-arvore/backoffice/entity-management/features`
}

export const entityManagementControllerListFeatures = async (
  options?: RequestInit
): Promise<entityManagementControllerListFeaturesResponse> => {
  return customInstance<entityManagementControllerListFeaturesResponse>(
    getEntityManagementControllerListFeaturesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get entity subtree for module assignment
 */
export type entityManagementControllerGetContractEntityTreeResponse200 = {
  data: ContractEntityTreeResponseDto
  status: 200
}

export type entityManagementControllerGetContractEntityTreeResponseSuccess =
  entityManagementControllerGetContractEntityTreeResponse200 & {
    headers: Headers
  }
export type entityManagementControllerGetContractEntityTreeResponse =
  entityManagementControllerGetContractEntityTreeResponseSuccess

export const getEntityManagementControllerGetContractEntityTreeUrl = (
  contractId: number
) => {
  return `/api-arvore/backoffice/entity-management/contracts/${contractId}/entity-tree`
}

export const entityManagementControllerGetContractEntityTree = async (
  contractId: number,
  options?: RequestInit
): Promise<entityManagementControllerGetContractEntityTreeResponse> => {
  return customInstance<entityManagementControllerGetContractEntityTreeResponse>(
    getEntityManagementControllerGetContractEntityTreeUrl(contractId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload spreadsheet for importation
 */
export type importationsControllerUploadResponse201 = {
  data: void
  status: 201
}

export type importationsControllerUploadResponseSuccess =
  importationsControllerUploadResponse201 & {
    headers: Headers
  }
export type importationsControllerUploadResponse =
  importationsControllerUploadResponseSuccess

export const getImportationsControllerUploadUrl = () => {
  return `/api-arvore/backoffice/importations`
}

export const importationsControllerUpload = async (
  createImportationDto: CreateImportationDto,
  options?: RequestInit
): Promise<importationsControllerUploadResponse> => {
  const formData = new FormData()
  formData.append(`platformType`, createImportationDto.platformType)
  formData.append(`readerType`, createImportationDto.readerType)
  formData.append(
    `navigationContextType`,
    createImportationDto.navigationContextType
  )
  formData.append(
    `navigationContextId`,
    createImportationDto.navigationContextId
  )
  if (createImportationDto.rootEntityId !== undefined) {
    formData.append(
      `rootEntityId`,
      createImportationDto.rootEntityId.toString()
    )
  }

  return customInstance<importationsControllerUploadResponse>(
    getImportationsControllerUploadUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary List importations
 */
export type importationsControllerListResponse200 = {
  data: void
  status: 200
}

export type importationsControllerListResponseSuccess =
  importationsControllerListResponse200 & {
    headers: Headers
  }
export type importationsControllerListResponse =
  importationsControllerListResponseSuccess

export const getImportationsControllerListUrl = (
  params?: ImportationsControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/importations?${stringifiedParams}`
    : `/api-arvore/backoffice/importations`
}

export const importationsControllerList = async (
  params?: ImportationsControllerListParams,
  options?: RequestInit
): Promise<importationsControllerListResponse> => {
  return customInstance<importationsControllerListResponse>(
    getImportationsControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Confirm column mapping for importation
 */
export type importationsControllerConfirmMappingResponse201 = {
  data: void
  status: 201
}

export type importationsControllerConfirmMappingResponseSuccess =
  importationsControllerConfirmMappingResponse201 & {
    headers: Headers
  }
export type importationsControllerConfirmMappingResponse =
  importationsControllerConfirmMappingResponseSuccess

export const getImportationsControllerConfirmMappingUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/confirm-mapping`
}

export const importationsControllerConfirmMapping = async (
  id: string,
  confirmMappingDto: ConfirmMappingDto,
  options?: RequestInit
): Promise<importationsControllerConfirmMappingResponse> => {
  return customInstance<importationsControllerConfirmMappingResponse>(
    getImportationsControllerConfirmMappingUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmMappingDto)
    }
  )
}

/**
 * @summary Select sheet from multi-sheet XLSX
 */
export type importationsControllerSelectSheetResponse201 = {
  data: void
  status: 201
}

export type importationsControllerSelectSheetResponseSuccess =
  importationsControllerSelectSheetResponse201 & {
    headers: Headers
  }
export type importationsControllerSelectSheetResponse =
  importationsControllerSelectSheetResponseSuccess

export const getImportationsControllerSelectSheetUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/select-sheet`
}

export const importationsControllerSelectSheet = async (
  id: string,
  selectSheetDto: SelectSheetDto,
  options?: RequestInit
): Promise<importationsControllerSelectSheetResponse> => {
  return customInstance<importationsControllerSelectSheetResponse>(
    getImportationsControllerSelectSheetUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(selectSheetDto)
    }
  )
}

/**
 * @summary Get importation detail
 */
export type importationsControllerGetImportationResponse200 = {
  data: void
  status: 200
}

export type importationsControllerGetImportationResponseSuccess =
  importationsControllerGetImportationResponse200 & {
    headers: Headers
  }
export type importationsControllerGetImportationResponse =
  importationsControllerGetImportationResponseSuccess

export const getImportationsControllerGetImportationUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}`
}

export const importationsControllerGetImportation = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerGetImportationResponse> => {
  return customInstance<importationsControllerGetImportationResponse>(
    getImportationsControllerGetImportationUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List importation lines
 */
export type importationsControllerGetLinesResponse200 = {
  data: void
  status: 200
}

export type importationsControllerGetLinesResponseSuccess =
  importationsControllerGetLinesResponse200 & {
    headers: Headers
  }
export type importationsControllerGetLinesResponse =
  importationsControllerGetLinesResponseSuccess

export const getImportationsControllerGetLinesUrl = (
  id: string,
  params?: ImportationsControllerGetLinesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/importations/${id}/lines?${stringifiedParams}`
    : `/api-arvore/backoffice/importations/${id}/lines`
}

export const importationsControllerGetLines = async (
  id: string,
  params?: ImportationsControllerGetLinesParams,
  options?: RequestInit
): Promise<importationsControllerGetLinesResponse> => {
  return customInstance<importationsControllerGetLinesResponse>(
    getImportationsControllerGetLinesUrl(id, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update importation line
 */
export type importationsControllerUpdateLineResponse200 = {
  data: void
  status: 200
}

export type importationsControllerUpdateLineResponseSuccess =
  importationsControllerUpdateLineResponse200 & {
    headers: Headers
  }
export type importationsControllerUpdateLineResponse =
  importationsControllerUpdateLineResponseSuccess

export const getImportationsControllerUpdateLineUrl = (
  id: string,
  lineId: string
) => {
  return `/api-arvore/backoffice/importations/${id}/lines/${lineId}`
}

export const importationsControllerUpdateLine = async (
  id: string,
  lineId: string,
  updateImportationLineDto: UpdateImportationLineDto,
  options?: RequestInit
): Promise<importationsControllerUpdateLineResponse> => {
  return customInstance<importationsControllerUpdateLineResponse>(
    getImportationsControllerUpdateLineUrl(id, lineId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateImportationLineDto)
    }
  )
}

/**
 * @summary Delete importation line
 */
export type importationsControllerDeleteLineResponse200 = {
  data: void
  status: 200
}

export type importationsControllerDeleteLineResponseSuccess =
  importationsControllerDeleteLineResponse200 & {
    headers: Headers
  }
export type importationsControllerDeleteLineResponse =
  importationsControllerDeleteLineResponseSuccess

export const getImportationsControllerDeleteLineUrl = (
  id: string,
  lineId: string
) => {
  return `/api-arvore/backoffice/importations/${id}/lines/${lineId}`
}

export const importationsControllerDeleteLine = async (
  id: string,
  lineId: string,
  options?: RequestInit
): Promise<importationsControllerDeleteLineResponse> => {
  return customInstance<importationsControllerDeleteLineResponse>(
    getImportationsControllerDeleteLineUrl(id, lineId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Preview entities that will be created (read-only)
 */
export type importationsControllerPreviewEntitiesResponse201 = {
  data: void
  status: 201
}

export type importationsControllerPreviewEntitiesResponseSuccess =
  importationsControllerPreviewEntitiesResponse201 & {
    headers: Headers
  }
export type importationsControllerPreviewEntitiesResponse =
  importationsControllerPreviewEntitiesResponseSuccess

export const getImportationsControllerPreviewEntitiesUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/preview-entities`
}

export const importationsControllerPreviewEntities = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerPreviewEntitiesResponse> => {
  return customInstance<importationsControllerPreviewEntitiesResponse>(
    getImportationsControllerPreviewEntitiesUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Create entities for importation (async)
 */
export type importationsControllerCreateEntitiesResponse201 = {
  data: void
  status: 201
}

export type importationsControllerCreateEntitiesResponseSuccess =
  importationsControllerCreateEntitiesResponse201 & {
    headers: Headers
  }
export type importationsControllerCreateEntitiesResponse =
  importationsControllerCreateEntitiesResponseSuccess

export const getImportationsControllerCreateEntitiesUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/create-entities`
}

export const importationsControllerCreateEntities = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerCreateEntitiesResponse> => {
  return customInstance<importationsControllerCreateEntitiesResponse>(
    getImportationsControllerCreateEntitiesUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Process importation
 */
export type importationsControllerProcessResponse201 = {
  data: void
  status: 201
}

export type importationsControllerProcessResponseSuccess =
  importationsControllerProcessResponse201 & {
    headers: Headers
  }
export type importationsControllerProcessResponse =
  importationsControllerProcessResponseSuccess

export const getImportationsControllerProcessUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/process`
}

export const importationsControllerProcess = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerProcessResponse> => {
  return customInstance<importationsControllerProcessResponse>(
    getImportationsControllerProcessUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Retry failed importation lines
 */
export type importationsControllerRetryResponse201 = {
  data: void
  status: 201
}

export type importationsControllerRetryResponseSuccess =
  importationsControllerRetryResponse201 & {
    headers: Headers
  }
export type importationsControllerRetryResponse =
  importationsControllerRetryResponseSuccess

export const getImportationsControllerRetryUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/retry`
}

export const importationsControllerRetry = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerRetryResponse> => {
  return customInstance<importationsControllerRetryResponse>(
    getImportationsControllerRetryUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Cancel importation
 */
export type importationsControllerCancelResponse201 = {
  data: void
  status: 201
}

export type importationsControllerCancelResponseSuccess =
  importationsControllerCancelResponse201 & {
    headers: Headers
  }
export type importationsControllerCancelResponse =
  importationsControllerCancelResponseSuccess

export const getImportationsControllerCancelUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/cancel`
}

export const importationsControllerCancel = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerCancelResponse> => {
  return customInstance<importationsControllerCancelResponse>(
    getImportationsControllerCancelUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Export importation results (clears generated passwords after export)
 */
export type importationsControllerExportResultsResponse201 = {
  data: void
  status: 201
}

export type importationsControllerExportResultsResponseSuccess =
  importationsControllerExportResultsResponse201 & {
    headers: Headers
  }
export type importationsControllerExportResultsResponse =
  importationsControllerExportResultsResponseSuccess

export const getImportationsControllerExportResultsUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/export`
}

export const importationsControllerExportResults = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerExportResultsResponse> => {
  return customInstance<importationsControllerExportResultsResponse>(
    getImportationsControllerExportResultsUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary SSE stream for importation updates
 */
export type importationsControllerEventsResponse200 = {
  data: void
  status: 200
}

export type importationsControllerEventsResponseSuccess =
  importationsControllerEventsResponse200 & {
    headers: Headers
  }
export type importationsControllerEventsResponse =
  importationsControllerEventsResponseSuccess

export const getImportationsControllerEventsUrl = (id: string) => {
  return `/api-arvore/backoffice/importations/${id}/events`
}

export const importationsControllerEvents = async (
  id: string,
  options?: RequestInit
): Promise<importationsControllerEventsResponse> => {
  return customInstance<importationsControllerEventsResponse>(
    getImportationsControllerEventsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns all journeys for the student grade with progress and lock status
 * @summary Get journeys status
 */
export type journeysControllerGetJourneysStatusResponse200 = {
  data: GetJourneysStatusResponseDto
  status: 200
}

export type journeysControllerGetJourneysStatusResponseSuccess =
  journeysControllerGetJourneysStatusResponse200 & {
    headers: Headers
  }
export type journeysControllerGetJourneysStatusResponse =
  journeysControllerGetJourneysStatusResponseSuccess

export const getJourneysControllerGetJourneysStatusUrl = () => {
  return `/api-arvore/journeys/status`
}

export const journeysControllerGetJourneysStatus = async (
  options?: RequestInit
): Promise<journeysControllerGetJourneysStatusResponse> => {
  return customInstance<journeysControllerGetJourneysStatusResponse>(
    getJourneysControllerGetJourneysStatusUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns the active journey for the authenticated user
 * @summary Get my journey
 */
export type journeysControllerGetMyJourneyResponse200 = {
  data: GetMyJourneyResponseDto
  status: 200
}

export type journeysControllerGetMyJourneyResponseSuccess =
  journeysControllerGetMyJourneyResponse200 & {
    headers: Headers
  }
export type journeysControllerGetMyJourneyResponse =
  journeysControllerGetMyJourneyResponseSuccess

export const getJourneysControllerGetMyJourneyUrl = () => {
  return `/api-arvore/journeys/me`
}

export const journeysControllerGetMyJourney = async (
  options?: RequestInit
): Promise<journeysControllerGetMyJourneyResponse> => {
  return customInstance<journeysControllerGetMyJourneyResponse>(
    getJourneysControllerGetMyJourneyUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Allows a teacher to manually assign a journey/level to a student
 * @summary Update student journey
 */
export type journeysControllerUpdateStudentJourneyResponse200 = {
  data: UpdateStudentJourneyResponseDto
  status: 200
}

export type journeysControllerUpdateStudentJourneyResponseSuccess =
  journeysControllerUpdateStudentJourneyResponse200 & {
    headers: Headers
  }
export type journeysControllerUpdateStudentJourneyResponse =
  journeysControllerUpdateStudentJourneyResponseSuccess

export const getJourneysControllerUpdateStudentJourneyUrl = (
  userId: number
) => {
  return `/api-arvore/journeys/user/${userId}`
}

export const journeysControllerUpdateStudentJourney = async (
  userId: number,
  updateStudentJourneyDto: UpdateStudentJourneyDto,
  options?: RequestInit
): Promise<journeysControllerUpdateStudentJourneyResponse> => {
  return customInstance<journeysControllerUpdateStudentJourneyResponse>(
    getJourneysControllerUpdateStudentJourneyUrl(userId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateStudentJourneyDto)
    }
  )
}

/**
 * Returns all items of a journey with completion status for the authenticated user
 * @summary Get journey items
 */
export type journeysControllerGetJourneyItemsResponse200 = {
  data: GetJourneyItemsResponseDto
  status: 200
}

export type journeysControllerGetJourneyItemsResponseSuccess =
  journeysControllerGetJourneyItemsResponse200 & {
    headers: Headers
  }
export type journeysControllerGetJourneyItemsResponse =
  journeysControllerGetJourneyItemsResponseSuccess

export const getJourneysControllerGetJourneyItemsUrl = (slug: string) => {
  return `/api-arvore/journeys/${slug}/items`
}

export const journeysControllerGetJourneyItems = async (
  slug: string,
  options?: RequestInit
): Promise<journeysControllerGetJourneyItemsResponse> => {
  return customInstance<journeysControllerGetJourneyItemsResponse>(
    getJourneysControllerGetJourneyItemsUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Creates a user_journey record if the user lexile level is eligible. Returns existing record if already started.
 * @summary Start a journey
 */
export type journeysControllerStartJourneyResponse200 = {
  data: StartJourneyResponseDto
  status: 200
}

export type journeysControllerStartJourneyResponseSuccess =
  journeysControllerStartJourneyResponse200 & {
    headers: Headers
  }
export type journeysControllerStartJourneyResponse =
  journeysControllerStartJourneyResponseSuccess

export const getJourneysControllerStartJourneyUrl = (slug: string) => {
  return `/api-arvore/journeys/${slug}/start`
}

export const journeysControllerStartJourney = async (
  slug: string,
  options?: RequestInit
): Promise<journeysControllerStartJourneyResponse> => {
  return customInstance<journeysControllerStartJourneyResponse>(
    getJourneysControllerStartJourneyUrl(slug),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Returns the excerpt start and end positions for a journey item reading by book slug
 * @summary Get reading excerpt for a book
 */
export type journeysControllerGetReadingExcerptResponse200 = {
  data: GetJourneyReadingExcerptResponseDto
  status: 200
}

export type journeysControllerGetReadingExcerptResponseSuccess =
  journeysControllerGetReadingExcerptResponse200 & {
    headers: Headers
  }
export type journeysControllerGetReadingExcerptResponse =
  journeysControllerGetReadingExcerptResponseSuccess

export const getJourneysControllerGetReadingExcerptUrl = (bookSlug: string) => {
  return `/api-arvore/journeys/reading/excerpt/${bookSlug}`
}

export const journeysControllerGetReadingExcerpt = async (
  bookSlug: string,
  options?: RequestInit
): Promise<journeysControllerGetReadingExcerptResponse> => {
  return customInstance<journeysControllerGetReadingExcerptResponse>(
    getJourneysControllerGetReadingExcerptUrl(bookSlug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Marks the reading activity as completed for a journey item
 * @summary Complete a journey reading
 */
export type journeysControllerCompleteReadingResponse200 = {
  data: CompleteJourneyReadingResponseDto
  status: 200
}

export type journeysControllerCompleteReadingResponseSuccess =
  journeysControllerCompleteReadingResponse200 & {
    headers: Headers
  }
export type journeysControllerCompleteReadingResponse =
  journeysControllerCompleteReadingResponseSuccess

export const getJourneysControllerCompleteReadingUrl = () => {
  return `/api-arvore/journeys/reading/complete`
}

export const journeysControllerCompleteReading = async (
  completeJourneyReadingDto: CompleteJourneyReadingDto,
  options?: RequestInit
): Promise<journeysControllerCompleteReadingResponse> => {
  return customInstance<journeysControllerCompleteReadingResponse>(
    getJourneysControllerCompleteReadingUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(completeJourneyReadingDto)
    }
  )
}

/**
 * Marks a task as completed and rewards the user with coins
 * @summary Complete a book task
 */
export type journeysControllerCompleteBookTaskResponse200 = {
  data: CompleteBookTaskResponseDto
  status: 200
}

export type journeysControllerCompleteBookTaskResponseSuccess =
  journeysControllerCompleteBookTaskResponse200 & {
    headers: Headers
  }
export type journeysControllerCompleteBookTaskResponse =
  journeysControllerCompleteBookTaskResponseSuccess

export const getJourneysControllerCompleteBookTaskUrl = () => {
  return `/api-arvore/journeys/tasks/complete`
}

export const journeysControllerCompleteBookTask = async (
  completeBookTaskDto: CompleteBookTaskDto,
  options?: RequestInit
): Promise<journeysControllerCompleteBookTaskResponse> => {
  return customInstance<journeysControllerCompleteBookTaskResponse>(
    getJourneysControllerCompleteBookTaskUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(completeBookTaskDto)
    }
  )
}

/**
 * Returns the book snippet and metadata needed for the read aloud activity
 * @summary Get running record data for a journey item
 */
export type journeysControllerGetRunningRecordResponse200 = {
  data: GetJourneyRunningRecordResponseDto
  status: 200
}

export type journeysControllerGetRunningRecordResponseSuccess =
  journeysControllerGetRunningRecordResponse200 & {
    headers: Headers
  }
export type journeysControllerGetRunningRecordResponse =
  journeysControllerGetRunningRecordResponseSuccess

export const getJourneysControllerGetRunningRecordUrl = (
  journeyItemId: string
) => {
  return `/api-arvore/journeys/running-records/${journeyItemId}`
}

export const journeysControllerGetRunningRecord = async (
  journeyItemId: string,
  options?: RequestInit
): Promise<journeysControllerGetRunningRecordResponse> => {
  return customInstance<journeysControllerGetRunningRecordResponse>(
    getJourneysControllerGetRunningRecordUrl(journeyItemId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Marks fluency as completed and rewards the user with coins
 * @summary Complete running record for a journey item
 */
export type journeysControllerCompleteRunningRecordResponse200 = {
  data: CompleteJourneyRunningRecordResponseDto
  status: 200
}

export type journeysControllerCompleteRunningRecordResponseSuccess =
  journeysControllerCompleteRunningRecordResponse200 & {
    headers: Headers
  }
export type journeysControllerCompleteRunningRecordResponse =
  journeysControllerCompleteRunningRecordResponseSuccess

export const getJourneysControllerCompleteRunningRecordUrl = (
  journeyItemId: string
) => {
  return `/api-arvore/journeys/running-records/${journeyItemId}/complete`
}

export const journeysControllerCompleteRunningRecord = async (
  journeyItemId: string,
  options?: RequestInit
): Promise<journeysControllerCompleteRunningRecordResponse> => {
  return customInstance<journeysControllerCompleteRunningRecordResponse>(
    getJourneysControllerCompleteRunningRecordUrl(journeyItemId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Returns all questions with options and user progress for the quiz activity
 * @summary Get journey activity questions
 */
export type journeysControllerGetJourneyActivityResponse200 = {
  data: GetJourneyActivityResponseDto
  status: 200
}

export type journeysControllerGetJourneyActivityResponseSuccess =
  journeysControllerGetJourneyActivityResponse200 & {
    headers: Headers
  }
export type journeysControllerGetJourneyActivityResponse =
  journeysControllerGetJourneyActivityResponseSuccess

export const getJourneysControllerGetJourneyActivityUrl = (
  journeyItemId: string
) => {
  return `/api-arvore/journeys/activities/${journeyItemId}`
}

export const journeysControllerGetJourneyActivity = async (
  journeyItemId: string,
  options?: RequestInit
): Promise<journeysControllerGetJourneyActivityResponse> => {
  return customInstance<journeysControllerGetJourneyActivityResponse>(
    getJourneysControllerGetJourneyActivityUrl(journeyItemId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Records the answer attempt. Does not overwrite if already answered correctly.
 * @summary Answer a journey question
 */
export type journeysControllerAnswerJourneyQuestionResponse200 = {
  data: AnswerJourneyQuestionResponseDto
  status: 200
}

export type journeysControllerAnswerJourneyQuestionResponseSuccess =
  journeysControllerAnswerJourneyQuestionResponse200 & {
    headers: Headers
  }
export type journeysControllerAnswerJourneyQuestionResponse =
  journeysControllerAnswerJourneyQuestionResponseSuccess

export const getJourneysControllerAnswerJourneyQuestionUrl = (
  journeyItemId: string
) => {
  return `/api-arvore/journeys/activities/${journeyItemId}/answer`
}

export const journeysControllerAnswerJourneyQuestion = async (
  journeyItemId: string,
  answerJourneyQuestionDto: AnswerJourneyQuestionDto,
  options?: RequestInit
): Promise<journeysControllerAnswerJourneyQuestionResponse> => {
  return customInstance<journeysControllerAnswerJourneyQuestionResponse>(
    getJourneysControllerAnswerJourneyQuestionUrl(journeyItemId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(answerJourneyQuestionDto)
    }
  )
}

/**
 * Marks quiz_completed and completed_at on user_journey_items and awards 10 coins
 * @summary Complete journey activity (quiz)
 */
export type journeysControllerCompleteJourneyActivityResponse200 = {
  data: CompleteJourneyActivityResponseDto
  status: 200
}

export type journeysControllerCompleteJourneyActivityResponseSuccess =
  journeysControllerCompleteJourneyActivityResponse200 & {
    headers: Headers
  }
export type journeysControllerCompleteJourneyActivityResponse =
  journeysControllerCompleteJourneyActivityResponseSuccess

export const getJourneysControllerCompleteJourneyActivityUrl = (
  journeyItemId: string
) => {
  return `/api-arvore/journeys/activities/${journeyItemId}/complete`
}

export const journeysControllerCompleteJourneyActivity = async (
  journeyItemId: string,
  options?: RequestInit
): Promise<journeysControllerCompleteJourneyActivityResponse> => {
  return customInstance<journeysControllerCompleteJourneyActivityResponse>(
    getJourneysControllerCompleteJourneyActivityUrl(journeyItemId),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Checks if all journey items are completed. If so, marks the journey as completed, awards coins and lexile points.
 * @summary Complete a journey
 */
export type journeysControllerCompleteJourneyResponse200 = {
  data: CompleteJourneyResponseDto
  status: 200
}

export type journeysControllerCompleteJourneyResponseSuccess =
  journeysControllerCompleteJourneyResponse200 & {
    headers: Headers
  }
export type journeysControllerCompleteJourneyResponse =
  journeysControllerCompleteJourneyResponseSuccess

export const getJourneysControllerCompleteJourneyUrl = (slug: string) => {
  return `/api-arvore/journeys/${slug}/complete`
}

export const journeysControllerCompleteJourney = async (
  slug: string,
  options?: RequestInit
): Promise<journeysControllerCompleteJourneyResponse> => {
  return customInstance<journeysControllerCompleteJourneyResponse>(
    getJourneysControllerCompleteJourneyUrl(slug),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Awards the grade completion bonus coins once all journeys of the grade are completed. Idempotent per user and grade.
 * @summary Claim grade completion bonus
 */
export type journeysControllerClaimGradeCompletionResponse200 = {
  data: ClaimGradeCompletionResponseDto
  status: 200
}

export type journeysControllerClaimGradeCompletionResponseSuccess =
  journeysControllerClaimGradeCompletionResponse200 & {
    headers: Headers
  }
export type journeysControllerClaimGradeCompletionResponse =
  journeysControllerClaimGradeCompletionResponseSuccess

export const getJourneysControllerClaimGradeCompletionUrl = () => {
  return `/api-arvore/journeys/grade-completion/claim`
}

export const journeysControllerClaimGradeCompletion = async (
  options?: RequestInit
): Promise<journeysControllerClaimGradeCompletionResponse> => {
  return customInstance<journeysControllerClaimGradeCompletionResponse>(
    getJourneysControllerClaimGradeCompletionUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Returns a snapshot of journey performance and a paginated list of students for a class
 * @summary Get class journey report
 */
export type journeysControllerGetClassJourneyReportResponse200 = {
  data: GetClassJourneyReportResponseDto
  status: 200
}

export type journeysControllerGetClassJourneyReportResponseSuccess =
  journeysControllerGetClassJourneyReportResponse200 & {
    headers: Headers
  }
export type journeysControllerGetClassJourneyReportResponse =
  journeysControllerGetClassJourneyReportResponseSuccess

export const getJourneysControllerGetClassJourneyReportUrl = (
  params: JourneysControllerGetClassJourneyReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/journeys/report/class?${stringifiedParams}`
    : `/api-arvore/journeys/report/class`
}

export const journeysControllerGetClassJourneyReport = async (
  params: JourneysControllerGetClassJourneyReportParams,
  options?: RequestInit
): Promise<journeysControllerGetClassJourneyReportResponse> => {
  return customInstance<journeysControllerGetClassJourneyReportResponse>(
    getJourneysControllerGetClassJourneyReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a detailed report of all journeys and items for a specific student
 * @summary Get student journey report
 */
export type journeysControllerGetStudentJourneyReportResponse200 = {
  data: GetStudentJourneyReportResponseDto
  status: 200
}

export type journeysControllerGetStudentJourneyReportResponseSuccess =
  journeysControllerGetStudentJourneyReportResponse200 & {
    headers: Headers
  }
export type journeysControllerGetStudentJourneyReportResponse =
  journeysControllerGetStudentJourneyReportResponseSuccess

export const getJourneysControllerGetStudentJourneyReportUrl = (
  userId: number
) => {
  return `/api-arvore/journeys/report/student/${userId}`
}

export const journeysControllerGetStudentJourneyReport = async (
  userId: number,
  options?: RequestInit
): Promise<journeysControllerGetStudentJourneyReportResponse> => {
  return customInstance<journeysControllerGetStudentJourneyReportResponse>(
    getJourneysControllerGetStudentJourneyReportUrl(userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns detailed quiz and running record results for a specific journey item and student
 * @summary Get journey item detail for a student
 */
export type journeysControllerGetJourneyItemDetailResponse200 = {
  data: void
  status: 200
}

export type journeysControllerGetJourneyItemDetailResponseSuccess =
  journeysControllerGetJourneyItemDetailResponse200 & {
    headers: Headers
  }
export type journeysControllerGetJourneyItemDetailResponse =
  journeysControllerGetJourneyItemDetailResponseSuccess

export const getJourneysControllerGetJourneyItemDetailUrl = (
  journeyItemId: string,
  userId: string
) => {
  return `/api-arvore/journeys/report/journey-item/${journeyItemId}/user/${userId}`
}

export const journeysControllerGetJourneyItemDetail = async (
  journeyItemId: string,
  userId: string,
  options?: RequestInit
): Promise<journeysControllerGetJourneyItemDetailResponse> => {
  return customInstance<journeysControllerGetJourneyItemDetailResponse>(
    getJourneysControllerGetJourneyItemDetailUrl(journeyItemId, userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List all journeys
 */
export type journeysManagementControllerListJourneysResponse200 = {
  data: ListJourneysResponseDto
  status: 200
}

export type journeysManagementControllerListJourneysResponseSuccess =
  journeysManagementControllerListJourneysResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerListJourneysResponse =
  journeysManagementControllerListJourneysResponseSuccess

export const getJourneysManagementControllerListJourneysUrl = () => {
  return `/api-arvore/backoffice/journeys-management`
}

export const journeysManagementControllerListJourneys = async (
  options?: RequestInit
): Promise<journeysManagementControllerListJourneysResponse> => {
  return customInstance<journeysManagementControllerListJourneysResponse>(
    getJourneysManagementControllerListJourneysUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Search books by name, ISBN or slug
 */
export type journeysManagementControllerSearchBooksResponse200 = {
  data: SearchBooksResponseDto
  status: 200
}

export type journeysManagementControllerSearchBooksResponseSuccess =
  journeysManagementControllerSearchBooksResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerSearchBooksResponse =
  journeysManagementControllerSearchBooksResponseSuccess

export const getJourneysManagementControllerSearchBooksUrl = (
  params: JourneysManagementControllerSearchBooksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/backoffice/journeys-management/books/search?${stringifiedParams}`
    : `/api-arvore/backoffice/journeys-management/books/search`
}

export const journeysManagementControllerSearchBooks = async (
  params: JourneysManagementControllerSearchBooksParams,
  options?: RequestInit
): Promise<journeysManagementControllerSearchBooksResponse> => {
  return customInstance<journeysManagementControllerSearchBooksResponse>(
    getJourneysManagementControllerSearchBooksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List items of a journey with association status
 */
export type journeysManagementControllerListJourneyItemsResponse200 = {
  data: ListJourneyItemsResponseDto
  status: 200
}

export type journeysManagementControllerListJourneyItemsResponseSuccess =
  journeysManagementControllerListJourneyItemsResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerListJourneyItemsResponse =
  journeysManagementControllerListJourneyItemsResponseSuccess

export const getJourneysManagementControllerListJourneyItemsUrl = (
  journeyId: number
) => {
  return `/api-arvore/backoffice/journeys-management/${journeyId}/items`
}

export const journeysManagementControllerListJourneyItems = async (
  journeyId: number,
  options?: RequestInit
): Promise<journeysManagementControllerListJourneyItemsResponse> => {
  return customInstance<journeysManagementControllerListJourneyItemsResponse>(
    getJourneysManagementControllerListJourneyItemsUrl(journeyId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new journey item (associate a book)
 */
export type journeysManagementControllerCreateJourneyItemResponse201 = {
  data: void
  status: 201
}

export type journeysManagementControllerCreateJourneyItemResponseSuccess =
  journeysManagementControllerCreateJourneyItemResponse201 & {
    headers: Headers
  }
export type journeysManagementControllerCreateJourneyItemResponse =
  journeysManagementControllerCreateJourneyItemResponseSuccess

export const getJourneysManagementControllerCreateJourneyItemUrl = (
  journeyId: number
) => {
  return `/api-arvore/backoffice/journeys-management/${journeyId}/items`
}

export const journeysManagementControllerCreateJourneyItem = async (
  journeyId: number,
  createJourneyItemDto: CreateJourneyItemDto,
  options?: RequestInit
): Promise<journeysManagementControllerCreateJourneyItemResponse> => {
  return customInstance<journeysManagementControllerCreateJourneyItemResponse>(
    getJourneysManagementControllerCreateJourneyItemUrl(journeyId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createJourneyItemDto)
    }
  )
}

/**
 * @summary Get journey item detail with readings, questions and running record
 */
export type journeysManagementControllerGetJourneyItemDetailResponse200 = {
  data: GetJourneyItemDetailResponseDto
  status: 200
}

export type journeysManagementControllerGetJourneyItemDetailResponseSuccess =
  journeysManagementControllerGetJourneyItemDetailResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerGetJourneyItemDetailResponse =
  journeysManagementControllerGetJourneyItemDetailResponseSuccess

export const getJourneysManagementControllerGetJourneyItemDetailUrl = (
  journeyItemId: number
) => {
  return `/api-arvore/backoffice/journeys-management/items/${journeyItemId}`
}

export const journeysManagementControllerGetJourneyItemDetail = async (
  journeyItemId: number,
  options?: RequestInit
): Promise<journeysManagementControllerGetJourneyItemDetailResponse> => {
  return customInstance<journeysManagementControllerGetJourneyItemDetailResponse>(
    getJourneysManagementControllerGetJourneyItemDetailUrl(journeyItemId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create or update reading excerpt for a journey item
 */
export type journeysManagementControllerUpsertReadingResponse200 = {
  data: void
  status: 200
}

export type journeysManagementControllerUpsertReadingResponseSuccess =
  journeysManagementControllerUpsertReadingResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerUpsertReadingResponse =
  journeysManagementControllerUpsertReadingResponseSuccess

export const getJourneysManagementControllerUpsertReadingUrl = (
  journeyItemId: number
) => {
  return `/api-arvore/backoffice/journeys-management/items/${journeyItemId}/reading`
}

export const journeysManagementControllerUpsertReading = async (
  journeyItemId: number,
  upsertReadingDto: UpsertReadingDto,
  options?: RequestInit
): Promise<journeysManagementControllerUpsertReadingResponse> => {
  return customInstance<journeysManagementControllerUpsertReadingResponse>(
    getJourneysManagementControllerUpsertReadingUrl(journeyItemId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertReadingDto)
    }
  )
}

/**
 * @summary Create a question with options for a journey item
 */
export type journeysManagementControllerCreateQuestionResponse201 = {
  data: void
  status: 201
}

export type journeysManagementControllerCreateQuestionResponseSuccess =
  journeysManagementControllerCreateQuestionResponse201 & {
    headers: Headers
  }
export type journeysManagementControllerCreateQuestionResponse =
  journeysManagementControllerCreateQuestionResponseSuccess

export const getJourneysManagementControllerCreateQuestionUrl = (
  journeyItemId: number
) => {
  return `/api-arvore/backoffice/journeys-management/items/${journeyItemId}/questions`
}

export const journeysManagementControllerCreateQuestion = async (
  journeyItemId: number,
  createQuestionDto: CreateQuestionDto,
  options?: RequestInit
): Promise<journeysManagementControllerCreateQuestionResponse> => {
  return customInstance<journeysManagementControllerCreateQuestionResponse>(
    getJourneysManagementControllerCreateQuestionUrl(journeyItemId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createQuestionDto)
    }
  )
}

/**
 * @summary Update a question and its options
 */
export type journeysManagementControllerUpdateQuestionResponse200 = {
  data: void
  status: 200
}

export type journeysManagementControllerUpdateQuestionResponseSuccess =
  journeysManagementControllerUpdateQuestionResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerUpdateQuestionResponse =
  journeysManagementControllerUpdateQuestionResponseSuccess

export const getJourneysManagementControllerUpdateQuestionUrl = (
  questionId: number
) => {
  return `/api-arvore/backoffice/journeys-management/questions/${questionId}`
}

export const journeysManagementControllerUpdateQuestion = async (
  questionId: number,
  updateQuestionDto: UpdateQuestionDto,
  options?: RequestInit
): Promise<journeysManagementControllerUpdateQuestionResponse> => {
  return customInstance<journeysManagementControllerUpdateQuestionResponse>(
    getJourneysManagementControllerUpdateQuestionUrl(questionId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateQuestionDto)
    }
  )
}

/**
 * @summary Soft delete a question
 */
export type journeysManagementControllerDeleteQuestionResponse200 = {
  data: void
  status: 200
}

export type journeysManagementControllerDeleteQuestionResponseSuccess =
  journeysManagementControllerDeleteQuestionResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerDeleteQuestionResponse =
  journeysManagementControllerDeleteQuestionResponseSuccess

export const getJourneysManagementControllerDeleteQuestionUrl = (
  questionId: number
) => {
  return `/api-arvore/backoffice/journeys-management/questions/${questionId}`
}

export const journeysManagementControllerDeleteQuestion = async (
  questionId: number,
  options?: RequestInit
): Promise<journeysManagementControllerDeleteQuestionResponse> => {
  return customInstance<journeysManagementControllerDeleteQuestionResponse>(
    getJourneysManagementControllerDeleteQuestionUrl(questionId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Create or update running record snippet for a journey item
 */
export type journeysManagementControllerUpsertRunningRecordResponse200 = {
  data: void
  status: 200
}

export type journeysManagementControllerUpsertRunningRecordResponseSuccess =
  journeysManagementControllerUpsertRunningRecordResponse200 & {
    headers: Headers
  }
export type journeysManagementControllerUpsertRunningRecordResponse =
  journeysManagementControllerUpsertRunningRecordResponseSuccess

export const getJourneysManagementControllerUpsertRunningRecordUrl = (
  journeyItemId: number
) => {
  return `/api-arvore/backoffice/journeys-management/items/${journeyItemId}/running-record`
}

export const journeysManagementControllerUpsertRunningRecord = async (
  journeyItemId: number,
  upsertRunningRecordDto: UpsertRunningRecordDto,
  options?: RequestInit
): Promise<journeysManagementControllerUpsertRunningRecordResponse> => {
  return customInstance<journeysManagementControllerUpsertRunningRecordResponse>(
    getJourneysManagementControllerUpsertRunningRecordUrl(journeyItemId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertRunningRecordDto)
    }
  )
}

/**
 * @summary Get league report with filters for month-year and class
 */
export type leagueControllerGetLeagueReportResponse200 = {
  data: LeagueReportResponseDto
  status: 200
}

export type leagueControllerGetLeagueReportResponseSuccess =
  leagueControllerGetLeagueReportResponse200 & {
    headers: Headers
  }
export type leagueControllerGetLeagueReportResponse =
  leagueControllerGetLeagueReportResponseSuccess

export const getLeagueControllerGetLeagueReportUrl = (
  params: LeagueControllerGetLeagueReportParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/league/report?${stringifiedParams}`
    : `/api-arvore/league/report`
}

export const leagueControllerGetLeagueReport = async (
  params: LeagueControllerGetLeagueReportParams,
  options?: RequestInit
): Promise<leagueControllerGetLeagueReportResponse> => {
  return customInstance<leagueControllerGetLeagueReportResponse>(
    getLeagueControllerGetLeagueReportUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get league analysis summary for the given month
 */
export type leagueManagementControllerGetAnalysisV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerGetAnalysisV1ResponseSuccess =
  leagueManagementControllerGetAnalysisV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerGetAnalysisV1Response =
  leagueManagementControllerGetAnalysisV1ResponseSuccess

export const getLeagueManagementControllerGetAnalysisV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}`
}

export const leagueManagementControllerGetAnalysisV1 = async (
  year: number,
  month: number,
  options?: RequestInit
): Promise<leagueManagementControllerGetAnalysisV1Response> => {
  return customInstance<leagueManagementControllerGetAnalysisV1Response>(
    getLeagueManagementControllerGetAnalysisV1Url(year, month),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List ranking for the given month with filters
 */
export type leagueManagementControllerGetRankingV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerGetRankingV1ResponseSuccess =
  leagueManagementControllerGetRankingV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerGetRankingV1Response =
  leagueManagementControllerGetRankingV1ResponseSuccess

export const getLeagueManagementControllerGetRankingV1Url = (
  year: number,
  month: number,
  params?: LeagueManagementControllerGetRankingV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/backoffice/league-management/${year}/${month}/ranking?${stringifiedParams}`
    : `/api-arvore/v1/backoffice/league-management/${year}/${month}/ranking`
}

export const leagueManagementControllerGetRankingV1 = async (
  year: number,
  month: number,
  params?: LeagueManagementControllerGetRankingV1Params,
  options?: RequestInit
): Promise<leagueManagementControllerGetRankingV1Response> => {
  return customInstance<leagueManagementControllerGetRankingV1Response>(
    getLeagueManagementControllerGetRankingV1Url(year, month, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary List suspended readers for the given month
 */
export type leagueManagementControllerGetSuspendedV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerGetSuspendedV1ResponseSuccess =
  leagueManagementControllerGetSuspendedV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerGetSuspendedV1Response =
  leagueManagementControllerGetSuspendedV1ResponseSuccess

export const getLeagueManagementControllerGetSuspendedV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/suspended`
}

export const leagueManagementControllerGetSuspendedV1 = async (
  year: number,
  month: number,
  options?: RequestInit
): Promise<leagueManagementControllerGetSuspendedV1Response> => {
  return customInstance<leagueManagementControllerGetSuspendedV1Response>(
    getLeagueManagementControllerGetSuspendedV1Url(year, month),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Suspend readers for the given month
 */
export type leagueManagementControllerSuspendV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerSuspendV1ResponseSuccess =
  leagueManagementControllerSuspendV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerSuspendV1Response =
  leagueManagementControllerSuspendV1ResponseSuccess

export const getLeagueManagementControllerSuspendV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/suspend`
}

export const leagueManagementControllerSuspendV1 = async (
  year: number,
  month: number,
  suspendReadersBodyDto: SuspendReadersBodyDto,
  options?: RequestInit
): Promise<leagueManagementControllerSuspendV1Response> => {
  return customInstance<leagueManagementControllerSuspendV1Response>(
    getLeagueManagementControllerSuspendV1Url(year, month),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(suspendReadersBodyDto)
    }
  )
}

/**
 * @summary Remove suspensions for readers in the given month
 */
export type leagueManagementControllerUnsuspendV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerUnsuspendV1ResponseSuccess =
  leagueManagementControllerUnsuspendV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerUnsuspendV1Response =
  leagueManagementControllerUnsuspendV1ResponseSuccess

export const getLeagueManagementControllerUnsuspendV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/suspend`
}

export const leagueManagementControllerUnsuspendV1 = async (
  year: number,
  month: number,
  suspendReadersBodyDto: SuspendReadersBodyDto,
  options?: RequestInit
): Promise<leagueManagementControllerUnsuspendV1Response> => {
  return customInstance<leagueManagementControllerUnsuspendV1Response>(
    getLeagueManagementControllerUnsuspendV1Url(year, month),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(suspendReadersBodyDto)
    }
  )
}

/**
 * @summary Close (mark official) the analysis for the given month
 */
export type leagueManagementControllerCloseAnalysisV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerCloseAnalysisV1ResponseSuccess =
  leagueManagementControllerCloseAnalysisV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerCloseAnalysisV1Response =
  leagueManagementControllerCloseAnalysisV1ResponseSuccess

export const getLeagueManagementControllerCloseAnalysisV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/close-analysis`
}

export const leagueManagementControllerCloseAnalysisV1 = async (
  year: number,
  month: number,
  options?: RequestInit
): Promise<leagueManagementControllerCloseAnalysisV1Response> => {
  return customInstance<leagueManagementControllerCloseAnalysisV1Response>(
    getLeagueManagementControllerCloseAnalysisV1Url(year, month),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Reopen the analysis for the given month
 */
export type leagueManagementControllerReopenAnalysisV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerReopenAnalysisV1ResponseSuccess =
  leagueManagementControllerReopenAnalysisV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerReopenAnalysisV1Response =
  leagueManagementControllerReopenAnalysisV1ResponseSuccess

export const getLeagueManagementControllerReopenAnalysisV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/reopen-analysis`
}

export const leagueManagementControllerReopenAnalysisV1 = async (
  year: number,
  month: number,
  options?: RequestInit
): Promise<leagueManagementControllerReopenAnalysisV1Response> => {
  return customInstance<leagueManagementControllerReopenAnalysisV1Response>(
    getLeagueManagementControllerReopenAnalysisV1Url(year, month),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Enqueue recompute of ranking_histories for the given month, excluding suspended readers
 */
export type leagueManagementControllerReconsolidateV1Response202 = {
  data: void
  status: 202
}

export type leagueManagementControllerReconsolidateV1ResponseSuccess =
  leagueManagementControllerReconsolidateV1Response202 & {
    headers: Headers
  }
export type leagueManagementControllerReconsolidateV1Response =
  leagueManagementControllerReconsolidateV1ResponseSuccess

export const getLeagueManagementControllerReconsolidateV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/reconsolidate`
}

export const leagueManagementControllerReconsolidateV1 = async (
  year: number,
  month: number,
  reconsolidateLeagueBodyDto: ReconsolidateLeagueBodyDto,
  options?: RequestInit
): Promise<leagueManagementControllerReconsolidateV1Response> => {
  return customInstance<leagueManagementControllerReconsolidateV1Response>(
    getLeagueManagementControllerReconsolidateV1Url(year, month),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reconsolidateLeagueBodyDto)
    }
  )
}

/**
 * @summary List detected fraud suspects for the given month
 */
export type leagueManagementControllerGetFraudSuspectsV1Response200 = {
  data: ListFraudSuspectsResponseDto
  status: 200
}

export type leagueManagementControllerGetFraudSuspectsV1ResponseSuccess =
  leagueManagementControllerGetFraudSuspectsV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerGetFraudSuspectsV1Response =
  leagueManagementControllerGetFraudSuspectsV1ResponseSuccess

export const getLeagueManagementControllerGetFraudSuspectsV1Url = (
  year: number,
  month: number,
  params?: LeagueManagementControllerGetFraudSuspectsV1Params
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/v1/backoffice/league-management/${year}/${month}/fraud-suspects?${stringifiedParams}`
    : `/api-arvore/v1/backoffice/league-management/${year}/${month}/fraud-suspects`
}

export const leagueManagementControllerGetFraudSuspectsV1 = async (
  year: number,
  month: number,
  params?: LeagueManagementControllerGetFraudSuspectsV1Params,
  options?: RequestInit
): Promise<leagueManagementControllerGetFraudSuspectsV1Response> => {
  return customInstance<leagueManagementControllerGetFraudSuspectsV1Response>(
    getLeagueManagementControllerGetFraudSuspectsV1Url(year, month, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Trigger fraud detection for the given month (idempotent)
 */
export type leagueManagementControllerDetectFraudV1Response200 = {
  data: void
  status: 200
}

export type leagueManagementControllerDetectFraudV1ResponseSuccess =
  leagueManagementControllerDetectFraudV1Response200 & {
    headers: Headers
  }
export type leagueManagementControllerDetectFraudV1Response =
  leagueManagementControllerDetectFraudV1ResponseSuccess

export const getLeagueManagementControllerDetectFraudV1Url = (
  year: number,
  month: number
) => {
  return `/api-arvore/v1/backoffice/league-management/${year}/${month}/detect-fraud`
}

export const leagueManagementControllerDetectFraudV1 = async (
  year: number,
  month: number,
  options?: RequestInit
): Promise<leagueManagementControllerDetectFraudV1Response> => {
  return customInstance<leagueManagementControllerDetectFraudV1Response>(
    getLeagueManagementControllerDetectFraudV1Url(year, month),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Parse a MARC21 .mrc file and return extracted records
 */
export type marc21ControllerParseResponse200 = {
  data: void
  status: 200
}

export type marc21ControllerParseResponse400 = {
  data: void
  status: 400
}

export type marc21ControllerParseResponseSuccess =
  marc21ControllerParseResponse200 & {
    headers: Headers
  }
export type marc21ControllerParseResponseError =
  marc21ControllerParseResponse400 & {
    headers: Headers
  }

export type marc21ControllerParseResponse =
  | marc21ControllerParseResponseSuccess
  | marc21ControllerParseResponseError

export const getMarc21ControllerParseUrl = () => {
  return `/api-arvore/marc21/parse`
}

export const marc21ControllerParse = async (
  options?: RequestInit
): Promise<marc21ControllerParseResponse> => {
  return customInstance<marc21ControllerParseResponse>(
    getMarc21ControllerParseUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Check which ISBNs already exist in the catalog
 */
export type marc21ControllerValidateResponse200 = {
  data: void
  status: 200
}

export type marc21ControllerValidateResponseSuccess =
  marc21ControllerValidateResponse200 & {
    headers: Headers
  }
export type marc21ControllerValidateResponse =
  marc21ControllerValidateResponseSuccess

export const getMarc21ControllerValidateUrl = () => {
  return `/api-arvore/marc21/validate-isbns`
}

export const marc21ControllerValidate = async (
  options?: RequestInit
): Promise<marc21ControllerValidateResponse> => {
  return customInstance<marc21ControllerValidateResponse>(
    getMarc21ControllerValidateUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Import books from MARC21 data with EPUB and cover files
 */
export type marc21ControllerImportResponse201 = {
  data: void
  status: 201
}

export type marc21ControllerImportResponse400 = {
  data: void
  status: 400
}

export type marc21ControllerImportResponseSuccess =
  marc21ControllerImportResponse201 & {
    headers: Headers
  }
export type marc21ControllerImportResponseError =
  marc21ControllerImportResponse400 & {
    headers: Headers
  }

export type marc21ControllerImportResponse =
  | marc21ControllerImportResponseSuccess
  | marc21ControllerImportResponseError

export const getMarc21ControllerImportUrl = () => {
  return `/api-arvore/marc21/import`
}

export const marc21ControllerImport = async (
  options?: RequestInit
): Promise<marc21ControllerImportResponse> => {
  return customInstance<marc21ControllerImportResponse>(
    getMarc21ControllerImportUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary List all lending profiles with their modalities
 */
export type lendingProfilesControllerListResponse200 = {
  data: void
  status: 200
}

export type lendingProfilesControllerListResponseSuccess =
  lendingProfilesControllerListResponse200 & {
    headers: Headers
  }
export type lendingProfilesControllerListResponse =
  lendingProfilesControllerListResponseSuccess

export const getLendingProfilesControllerListUrl = () => {
  return `/api-arvore/lending-profiles`
}

export const lendingProfilesControllerList = async (
  options?: RequestInit
): Promise<lendingProfilesControllerListResponse> => {
  return customInstance<lendingProfilesControllerListResponse>(
    getLendingProfilesControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Toggle a modality for a lending profile
 */
export type lendingProfilesControllerToggleResponse200 = {
  data: void
  status: 200
}

export type lendingProfilesControllerToggleResponse404 = {
  data: void
  status: 404
}

export type lendingProfilesControllerToggleResponseSuccess =
  lendingProfilesControllerToggleResponse200 & {
    headers: Headers
  }
export type lendingProfilesControllerToggleResponseError =
  lendingProfilesControllerToggleResponse404 & {
    headers: Headers
  }

export type lendingProfilesControllerToggleResponse =
  | lendingProfilesControllerToggleResponseSuccess
  | lendingProfilesControllerToggleResponseError

export const getLendingProfilesControllerToggleUrl = (id: number) => {
  return `/api-arvore/lending-profiles/modalities/${id}`
}

export const lendingProfilesControllerToggle = async (
  id: number,
  options?: RequestInit
): Promise<lendingProfilesControllerToggleResponse> => {
  return customInstance<lendingProfilesControllerToggleResponse>(
    getLendingProfilesControllerToggleUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Get search configuration with inheritance fallback
 */
export type searchConfigControllerGetResponse200 = {
  data: void
  status: 200
}

export type searchConfigControllerGetResponseSuccess =
  searchConfigControllerGetResponse200 & {
    headers: Headers
  }
export type searchConfigControllerGetResponse =
  searchConfigControllerGetResponseSuccess

export const getSearchConfigControllerGetUrl = (entityId: number) => {
  return `/api-arvore/search-config/${entityId}`
}

export const searchConfigControllerGet = async (
  entityId: number,
  options?: RequestInit
): Promise<searchConfigControllerGetResponse> => {
  return customInstance<searchConfigControllerGetResponse>(
    getSearchConfigControllerGetUrl(entityId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create or update search configuration
 */
export type searchConfigControllerUpsertResponse200 = {
  data: void
  status: 200
}

export type searchConfigControllerUpsertResponseSuccess =
  searchConfigControllerUpsertResponse200 & {
    headers: Headers
  }
export type searchConfigControllerUpsertResponse =
  searchConfigControllerUpsertResponseSuccess

export const getSearchConfigControllerUpsertUrl = (entityId: number) => {
  return `/api-arvore/search-config/${entityId}`
}

export const searchConfigControllerUpsert = async (
  entityId: number,
  upsertSearchConfigDto: UpsertSearchConfigDto,
  options?: RequestInit
): Promise<searchConfigControllerUpsertResponse> => {
  return customInstance<searchConfigControllerUpsertResponse>(
    getSearchConfigControllerUpsertUrl(entityId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(upsertSearchConfigDto)
    }
  )
}

/**
 * @summary Delete search configuration (entity goes back to inheriting)
 */
export type searchConfigControllerDeleteResponse200 = {
  data: void
  status: 200
}

export type searchConfigControllerDeleteResponse404 = {
  data: void
  status: 404
}

export type searchConfigControllerDeleteResponseSuccess =
  searchConfigControllerDeleteResponse200 & {
    headers: Headers
  }
export type searchConfigControllerDeleteResponseError =
  searchConfigControllerDeleteResponse404 & {
    headers: Headers
  }

export type searchConfigControllerDeleteResponse =
  | searchConfigControllerDeleteResponseSuccess
  | searchConfigControllerDeleteResponseError

export const getSearchConfigControllerDeleteUrl = (entityId: number) => {
  return `/api-arvore/search-config/${entityId}`
}

export const searchConfigControllerDelete = async (
  entityId: number,
  options?: RequestInit
): Promise<searchConfigControllerDeleteResponse> => {
  return customInstance<searchConfigControllerDeleteResponse>(
    getSearchConfigControllerDeleteUrl(entityId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Get available facet values from Elasticsearch
 */
export type searchConfigControllerFacetOptionsResponse200 = {
  data: void
  status: 200
}

export type searchConfigControllerFacetOptionsResponseSuccess =
  searchConfigControllerFacetOptionsResponse200 & {
    headers: Headers
  }
export type searchConfigControllerFacetOptionsResponse =
  searchConfigControllerFacetOptionsResponseSuccess

export const getSearchConfigControllerFacetOptionsUrl = (
  entityId: number,
  params?: SearchConfigControllerFacetOptionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/search-config/${entityId}/facet-options?${stringifiedParams}`
    : `/api-arvore/search-config/${entityId}/facet-options`
}

export const searchConfigControllerFacetOptions = async (
  entityId: number,
  params?: SearchConfigControllerFacetOptionsParams,
  options?: RequestInit
): Promise<searchConfigControllerFacetOptionsResponse> => {
  return customInstance<searchConfigControllerFacetOptionsResponse>(
    getSearchConfigControllerFacetOptionsUrl(entityId, params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get full home configuration
 */
export type homeConfigControllerGetResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerGetResponseSuccess =
  homeConfigControllerGetResponse200 & {
    headers: Headers
  }
export type homeConfigControllerGetResponse =
  homeConfigControllerGetResponseSuccess

export const getHomeConfigControllerGetUrl = () => {
  return `/api-arvore/home-config`
}

export const homeConfigControllerGet = async (
  options?: RequestInit
): Promise<homeConfigControllerGetResponse> => {
  return customInstance<homeConfigControllerGetResponse>(
    getHomeConfigControllerGetUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Create a new manual carousel
 */
export type homeConfigControllerPostCarouselResponse201 = {
  data: void
  status: 201
}

export type homeConfigControllerPostCarouselResponseSuccess =
  homeConfigControllerPostCarouselResponse201 & {
    headers: Headers
  }
export type homeConfigControllerPostCarouselResponse =
  homeConfigControllerPostCarouselResponseSuccess

export const getHomeConfigControllerPostCarouselUrl = () => {
  return `/api-arvore/home-config/carousels`
}

export const homeConfigControllerPostCarousel = async (
  options?: RequestInit
): Promise<homeConfigControllerPostCarouselResponse> => {
  return customInstance<homeConfigControllerPostCarouselResponse>(
    getHomeConfigControllerPostCarouselUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update a carousel
 */
export type homeConfigControllerPatchCarouselResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerPatchCarouselResponseSuccess =
  homeConfigControllerPatchCarouselResponse200 & {
    headers: Headers
  }
export type homeConfigControllerPatchCarouselResponse =
  homeConfigControllerPatchCarouselResponseSuccess

export const getHomeConfigControllerPatchCarouselUrl = (id: number) => {
  return `/api-arvore/home-config/carousels/${id}`
}

export const homeConfigControllerPatchCarousel = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerPatchCarouselResponse> => {
  return customInstance<homeConfigControllerPatchCarouselResponse>(
    getHomeConfigControllerPatchCarouselUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary List items of a carousel
 */
export type homeConfigControllerGetCarouselItemsResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerGetCarouselItemsResponseSuccess =
  homeConfigControllerGetCarouselItemsResponse200 & {
    headers: Headers
  }
export type homeConfigControllerGetCarouselItemsResponse =
  homeConfigControllerGetCarouselItemsResponseSuccess

export const getHomeConfigControllerGetCarouselItemsUrl = (id: number) => {
  return `/api-arvore/home-config/carousels/${id}/items`
}

export const homeConfigControllerGetCarouselItems = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerGetCarouselItemsResponse> => {
  return customInstance<homeConfigControllerGetCarouselItemsResponse>(
    getHomeConfigControllerGetCarouselItemsUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Add a book to a carousel
 */
export type homeConfigControllerAddCarouselItemResponse201 = {
  data: void
  status: 201
}

export type homeConfigControllerAddCarouselItemResponseSuccess =
  homeConfigControllerAddCarouselItemResponse201 & {
    headers: Headers
  }
export type homeConfigControllerAddCarouselItemResponse =
  homeConfigControllerAddCarouselItemResponseSuccess

export const getHomeConfigControllerAddCarouselItemUrl = (id: number) => {
  return `/api-arvore/home-config/carousels/${id}/items`
}

export const homeConfigControllerAddCarouselItem = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerAddCarouselItemResponse> => {
  return customInstance<homeConfigControllerAddCarouselItemResponse>(
    getHomeConfigControllerAddCarouselItemUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update carousel item position
 */
export type homeConfigControllerPatchCarouselItemResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerPatchCarouselItemResponseSuccess =
  homeConfigControllerPatchCarouselItemResponse200 & {
    headers: Headers
  }
export type homeConfigControllerPatchCarouselItemResponse =
  homeConfigControllerPatchCarouselItemResponseSuccess

export const getHomeConfigControllerPatchCarouselItemUrl = (id: number) => {
  return `/api-arvore/home-config/carousel-items/${id}`
}

export const homeConfigControllerPatchCarouselItem = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerPatchCarouselItemResponse> => {
  return customInstance<homeConfigControllerPatchCarouselItemResponse>(
    getHomeConfigControllerPatchCarouselItemUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Remove a book from a carousel
 */
export type homeConfigControllerDeleteCarouselItemResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerDeleteCarouselItemResponseSuccess =
  homeConfigControllerDeleteCarouselItemResponse200 & {
    headers: Headers
  }
export type homeConfigControllerDeleteCarouselItemResponse =
  homeConfigControllerDeleteCarouselItemResponseSuccess

export const getHomeConfigControllerDeleteCarouselItemUrl = (id: number) => {
  return `/api-arvore/home-config/carousel-items/${id}`
}

export const homeConfigControllerDeleteCarouselItem = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerDeleteCarouselItemResponse> => {
  return customInstance<homeConfigControllerDeleteCarouselItemResponse>(
    getHomeConfigControllerDeleteCarouselItemUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Create a new banner
 */
export type homeConfigControllerPostBannerResponse201 = {
  data: void
  status: 201
}

export type homeConfigControllerPostBannerResponseSuccess =
  homeConfigControllerPostBannerResponse201 & {
    headers: Headers
  }
export type homeConfigControllerPostBannerResponse =
  homeConfigControllerPostBannerResponseSuccess

export const getHomeConfigControllerPostBannerUrl = () => {
  return `/api-arvore/home-config/banners`
}

export const homeConfigControllerPostBanner = async (
  options?: RequestInit
): Promise<homeConfigControllerPostBannerResponse> => {
  return customInstance<homeConfigControllerPostBannerResponse>(
    getHomeConfigControllerPostBannerUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update a banner
 */
export type homeConfigControllerPatchBannerResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerPatchBannerResponseSuccess =
  homeConfigControllerPatchBannerResponse200 & {
    headers: Headers
  }
export type homeConfigControllerPatchBannerResponse =
  homeConfigControllerPatchBannerResponseSuccess

export const getHomeConfigControllerPatchBannerUrl = (id: number) => {
  return `/api-arvore/home-config/banners/${id}`
}

export const homeConfigControllerPatchBanner = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerPatchBannerResponse> => {
  return customInstance<homeConfigControllerPatchBannerResponse>(
    getHomeConfigControllerPatchBannerUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Delete a banner
 */
export type homeConfigControllerRemoveBannerResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerRemoveBannerResponseSuccess =
  homeConfigControllerRemoveBannerResponse200 & {
    headers: Headers
  }
export type homeConfigControllerRemoveBannerResponse =
  homeConfigControllerRemoveBannerResponseSuccess

export const getHomeConfigControllerRemoveBannerUrl = (id: number) => {
  return `/api-arvore/home-config/banners/${id}`
}

export const homeConfigControllerRemoveBanner = async (
  id: number,
  options?: RequestInit
): Promise<homeConfigControllerRemoveBannerResponse> => {
  return customInstance<homeConfigControllerRemoveBannerResponse>(
    getHomeConfigControllerRemoveBannerUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Upsert a home setting
 */
export type homeConfigControllerUpsertSettingResponse200 = {
  data: void
  status: 200
}

export type homeConfigControllerUpsertSettingResponseSuccess =
  homeConfigControllerUpsertSettingResponse200 & {
    headers: Headers
  }
export type homeConfigControllerUpsertSettingResponse =
  homeConfigControllerUpsertSettingResponseSuccess

export const getHomeConfigControllerUpsertSettingUrl = () => {
  return `/api-arvore/home-config/settings`
}

export const homeConfigControllerUpsertSetting = async (
  options?: RequestInit
): Promise<homeConfigControllerUpsertSettingResponse> => {
  return customInstance<homeConfigControllerUpsertSettingResponse>(
    getHomeConfigControllerUpsertSettingUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Upload an image for banners or footer
 */
export type homeConfigControllerUploadResponse201 = {
  data: void
  status: 201
}

export type homeConfigControllerUploadResponseSuccess =
  homeConfigControllerUploadResponse201 & {
    headers: Headers
  }
export type homeConfigControllerUploadResponse =
  homeConfigControllerUploadResponseSuccess

export const getHomeConfigControllerUploadUrl = (assetPath: string) => {
  return `/api-arvore/home-config/upload/${assetPath}`
}

export const homeConfigControllerUpload = async (
  assetPath: string,
  options?: RequestInit
): Promise<homeConfigControllerUploadResponse> => {
  return customInstance<homeConfigControllerUploadResponse>(
    getHomeConfigControllerUploadUrl(assetPath),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Get reading statistics for the current user
 */
export type readingStatsControllerMeResponse200 = {
  data: void
  status: 200
}

export type readingStatsControllerMeResponseSuccess =
  readingStatsControllerMeResponse200 & {
    headers: Headers
  }
export type readingStatsControllerMeResponse =
  readingStatsControllerMeResponseSuccess

export const getReadingStatsControllerMeUrl = () => {
  return `/api-arvore/reading-stats/me`
}

export const readingStatsControllerMe = async (
  options?: RequestInit
): Promise<readingStatsControllerMeResponse> => {
  return customInstance<readingStatsControllerMeResponse>(
    getReadingStatsControllerMeUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Open or get existing session
 */
export type sessionsControllerOpenResponse200 = {
  data: OpenSessionResponseDto
  status: 200
}

export type sessionsControllerOpenResponseSuccess =
  sessionsControllerOpenResponse200 & {
    headers: Headers
  }
export type sessionsControllerOpenResponse =
  sessionsControllerOpenResponseSuccess

export const getSessionsControllerOpenUrl = () => {
  return `/api-arvore/sessions/open`
}

export const sessionsControllerOpen = async (
  options?: RequestInit
): Promise<sessionsControllerOpenResponse> => {
  return customInstance<sessionsControllerOpenResponse>(
    getSessionsControllerOpenUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Update session heartbeat
 */
export type sessionsControllerHeartbeatResponse204 = {
  data: void
  status: 204
}

export type sessionsControllerHeartbeatResponse410 = {
  data: void
  status: 410
}

export type sessionsControllerHeartbeatResponseSuccess =
  sessionsControllerHeartbeatResponse204 & {
    headers: Headers
  }
export type sessionsControllerHeartbeatResponseError =
  sessionsControllerHeartbeatResponse410 & {
    headers: Headers
  }

export type sessionsControllerHeartbeatResponse =
  | sessionsControllerHeartbeatResponseSuccess
  | sessionsControllerHeartbeatResponseError

export const getSessionsControllerHeartbeatUrl = () => {
  return `/api-arvore/sessions/hb`
}

export const sessionsControllerHeartbeat = async (
  heartbeatSessionDto: HeartbeatSessionDto,
  options?: RequestInit
): Promise<sessionsControllerHeartbeatResponse> => {
  return customInstance<sessionsControllerHeartbeatResponse>(
    getSessionsControllerHeartbeatUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(heartbeatSessionDto)
    }
  )
}

/**
 * @summary List all shared pages
 */
export type sharedPagesControllerListV1Response200 = {
  data: SharedPagesControllerListV1200
  status: 200
}

export type sharedPagesControllerListV1ResponseSuccess =
  sharedPagesControllerListV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerListV1Response =
  sharedPagesControllerListV1ResponseSuccess

export const getSharedPagesControllerListV1Url = () => {
  return `/api-arvore/v1/shared-pages`
}

export const sharedPagesControllerListV1 = async (
  options?: RequestInit
): Promise<sharedPagesControllerListV1Response> => {
  return customInstance<sharedPagesControllerListV1Response>(
    getSharedPagesControllerListV1Url(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Upload a new shared HTML page
 */
export type sharedPagesControllerCreateV1Response201 = {
  data: SharedPagesControllerCreateV1201
  status: 201
}

export type sharedPagesControllerCreateV1ResponseSuccess =
  sharedPagesControllerCreateV1Response201 & {
    headers: Headers
  }
export type sharedPagesControllerCreateV1Response =
  sharedPagesControllerCreateV1ResponseSuccess

export const getSharedPagesControllerCreateV1Url = () => {
  return `/api-arvore/v1/shared-pages`
}

export const sharedPagesControllerCreateV1 = async (
  sharedPagesControllerCreateV1Body: SharedPagesControllerCreateV1Body,
  options?: RequestInit
): Promise<sharedPagesControllerCreateV1Response> => {
  const formData = new FormData()
  formData.append(`file`, sharedPagesControllerCreateV1Body.file)
  formData.append(`title`, sharedPagesControllerCreateV1Body.title)
  if (sharedPagesControllerCreateV1Body.description !== undefined) {
    formData.append(
      `description`,
      sharedPagesControllerCreateV1Body.description
    )
  }

  return customInstance<sharedPagesControllerCreateV1Response>(
    getSharedPagesControllerCreateV1Url(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Generate a presigned URL to upload a new shared HTML page directly to S3
 */
export type sharedPagesControllerCreateUploadUrlV1Response201 = {
  data: SharedPagesControllerCreateUploadUrlV1201
  status: 201
}

export type sharedPagesControllerCreateUploadUrlV1ResponseSuccess =
  sharedPagesControllerCreateUploadUrlV1Response201 & {
    headers: Headers
  }
export type sharedPagesControllerCreateUploadUrlV1Response =
  sharedPagesControllerCreateUploadUrlV1ResponseSuccess

export const getSharedPagesControllerCreateUploadUrlV1Url = () => {
  return `/api-arvore/v1/shared-pages/upload-url`
}

export const sharedPagesControllerCreateUploadUrlV1 = async (
  options?: RequestInit
): Promise<sharedPagesControllerCreateUploadUrlV1Response> => {
  return customInstance<sharedPagesControllerCreateUploadUrlV1Response>(
    getSharedPagesControllerCreateUploadUrlV1Url(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Confirm a direct-to-S3 upload and create the shared page record
 */
export type sharedPagesControllerConfirmCreateV1Response201 = {
  data: SharedPagesControllerConfirmCreateV1201
  status: 201
}

export type sharedPagesControllerConfirmCreateV1ResponseSuccess =
  sharedPagesControllerConfirmCreateV1Response201 & {
    headers: Headers
  }
export type sharedPagesControllerConfirmCreateV1Response =
  sharedPagesControllerConfirmCreateV1ResponseSuccess

export const getSharedPagesControllerConfirmCreateV1Url = () => {
  return `/api-arvore/v1/shared-pages/confirm`
}

export const sharedPagesControllerConfirmCreateV1 = async (
  confirmCreateSharedPageDto: ConfirmCreateSharedPageDto,
  options?: RequestInit
): Promise<sharedPagesControllerConfirmCreateV1Response> => {
  return customInstance<sharedPagesControllerConfirmCreateV1Response>(
    getSharedPagesControllerConfirmCreateV1Url(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmCreateSharedPageDto)
    }
  )
}

/**
 * @summary Generate a presigned URL to replace an existing shared HTML page directly in S3
 */
export type sharedPagesControllerUpdateUploadUrlV1Response201 = {
  data: SharedPagesControllerUpdateUploadUrlV1201
  status: 201
}

export type sharedPagesControllerUpdateUploadUrlV1ResponseSuccess =
  sharedPagesControllerUpdateUploadUrlV1Response201 & {
    headers: Headers
  }
export type sharedPagesControllerUpdateUploadUrlV1Response =
  sharedPagesControllerUpdateUploadUrlV1ResponseSuccess

export const getSharedPagesControllerUpdateUploadUrlV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/upload-url`
}

export const sharedPagesControllerUpdateUploadUrlV1 = async (
  id: string,
  options?: RequestInit
): Promise<sharedPagesControllerUpdateUploadUrlV1Response> => {
  return customInstance<sharedPagesControllerUpdateUploadUrlV1Response>(
    getSharedPagesControllerUpdateUploadUrlV1Url(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Confirm a direct-to-S3 upload and update the shared page record
 */
export type sharedPagesControllerConfirmUpdateV1Response200 = {
  data: SharedPagesControllerConfirmUpdateV1200
  status: 200
}

export type sharedPagesControllerConfirmUpdateV1ResponseSuccess =
  sharedPagesControllerConfirmUpdateV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerConfirmUpdateV1Response =
  sharedPagesControllerConfirmUpdateV1ResponseSuccess

export const getSharedPagesControllerConfirmUpdateV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/confirm`
}

export const sharedPagesControllerConfirmUpdateV1 = async (
  id: string,
  confirmUpdateSharedPageDto: ConfirmUpdateSharedPageDto,
  options?: RequestInit
): Promise<sharedPagesControllerConfirmUpdateV1Response> => {
  return customInstance<sharedPagesControllerConfirmUpdateV1Response>(
    getSharedPagesControllerConfirmUpdateV1Url(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmUpdateSharedPageDto)
    }
  )
}

/**
 * @summary Get shared page metadata
 */
export type sharedPagesControllerGetMetadataV1Response200 = {
  data: SharedPagesControllerGetMetadataV1200
  status: 200
}

export type sharedPagesControllerGetMetadataV1ResponseSuccess =
  sharedPagesControllerGetMetadataV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerGetMetadataV1Response =
  sharedPagesControllerGetMetadataV1ResponseSuccess

export const getSharedPagesControllerGetMetadataV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}`
}

export const sharedPagesControllerGetMetadataV1 = async (
  id: string,
  options?: RequestInit
): Promise<sharedPagesControllerGetMetadataV1Response> => {
  return customInstance<sharedPagesControllerGetMetadataV1Response>(
    getSharedPagesControllerGetMetadataV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update a shared page (metadata and/or HTML file)
 */
export type sharedPagesControllerUpdateV1Response200 = {
  data: SharedPagesControllerUpdateV1200
  status: 200
}

export type sharedPagesControllerUpdateV1ResponseSuccess =
  sharedPagesControllerUpdateV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerUpdateV1Response =
  sharedPagesControllerUpdateV1ResponseSuccess

export const getSharedPagesControllerUpdateV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}`
}

export const sharedPagesControllerUpdateV1 = async (
  id: string,
  sharedPagesControllerUpdateV1Body: SharedPagesControllerUpdateV1Body,
  options?: RequestInit
): Promise<sharedPagesControllerUpdateV1Response> => {
  const formData = new FormData()
  if (sharedPagesControllerUpdateV1Body.file !== undefined) {
    formData.append(`file`, sharedPagesControllerUpdateV1Body.file)
  }
  if (sharedPagesControllerUpdateV1Body.title !== undefined) {
    formData.append(`title`, sharedPagesControllerUpdateV1Body.title)
  }
  if (sharedPagesControllerUpdateV1Body.description !== undefined) {
    formData.append(
      `description`,
      sharedPagesControllerUpdateV1Body.description
    )
  }

  return customInstance<sharedPagesControllerUpdateV1Response>(
    getSharedPagesControllerUpdateV1Url(id),
    {
      ...options,
      method: 'PUT',
      body: formData
    }
  )
}

/**
 * @summary Delete a shared page
 */
export type sharedPagesControllerDeleteV1Response204 = {
  data: void
  status: 204
}

export type sharedPagesControllerDeleteV1ResponseSuccess =
  sharedPagesControllerDeleteV1Response204 & {
    headers: Headers
  }
export type sharedPagesControllerDeleteV1Response =
  sharedPagesControllerDeleteV1ResponseSuccess

export const getSharedPagesControllerDeleteV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}`
}

export const sharedPagesControllerDeleteV1 = async (
  id: string,
  options?: RequestInit
): Promise<sharedPagesControllerDeleteV1Response> => {
  return customInstance<sharedPagesControllerDeleteV1Response>(
    getSharedPagesControllerDeleteV1Url(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary View the shared HTML page (sandboxed)
 */
export type sharedPagesControllerViewV1Response200 = {
  data: void
  status: 200
}

export type sharedPagesControllerViewV1ResponseSuccess =
  sharedPagesControllerViewV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerViewV1Response =
  sharedPagesControllerViewV1ResponseSuccess

export const getSharedPagesControllerViewV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/view`
}

export const sharedPagesControllerViewV1 = async (
  id: string,
  options?: RequestInit
): Promise<sharedPagesControllerViewV1Response> => {
  return customInstance<sharedPagesControllerViewV1Response>(
    getSharedPagesControllerViewV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Grant temporary access to a shared page
 */
export type sharedPagesControllerCreateGrantV1Response201 = {
  data: SharedPagesControllerCreateGrantV1201
  status: 201
}

export type sharedPagesControllerCreateGrantV1ResponseSuccess =
  sharedPagesControllerCreateGrantV1Response201 & {
    headers: Headers
  }
export type sharedPagesControllerCreateGrantV1Response =
  sharedPagesControllerCreateGrantV1ResponseSuccess

export const getSharedPagesControllerCreateGrantV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/access-grants`
}

export const sharedPagesControllerCreateGrantV1 = async (
  id: string,
  createAccessGrantDto: CreateAccessGrantDto,
  options?: RequestInit
): Promise<sharedPagesControllerCreateGrantV1Response> => {
  return customInstance<sharedPagesControllerCreateGrantV1Response>(
    getSharedPagesControllerCreateGrantV1Url(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createAccessGrantDto)
    }
  )
}

/**
 * @summary List access grants for a shared page
 */
export type sharedPagesControllerListGrantsV1Response200 = {
  data: SharedPagesControllerListGrantsV1200Item[]
  status: 200
}

export type sharedPagesControllerListGrantsV1ResponseSuccess =
  sharedPagesControllerListGrantsV1Response200 & {
    headers: Headers
  }
export type sharedPagesControllerListGrantsV1Response =
  sharedPagesControllerListGrantsV1ResponseSuccess

export const getSharedPagesControllerListGrantsV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/access-grants`
}

export const sharedPagesControllerListGrantsV1 = async (
  id: string,
  options?: RequestInit
): Promise<sharedPagesControllerListGrantsV1Response> => {
  return customInstance<sharedPagesControllerListGrantsV1Response>(
    getSharedPagesControllerListGrantsV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Revoke an access grant
 */
export type sharedPagesControllerRevokeGrantV1Response204 = {
  data: void
  status: 204
}

export type sharedPagesControllerRevokeGrantV1ResponseSuccess =
  sharedPagesControllerRevokeGrantV1Response204 & {
    headers: Headers
  }
export type sharedPagesControllerRevokeGrantV1Response =
  sharedPagesControllerRevokeGrantV1ResponseSuccess

export const getSharedPagesControllerRevokeGrantV1Url = (
  id: string,
  grantId: string
) => {
  return `/api-arvore/v1/shared-pages/${id}/access-grants/${grantId}`
}

export const sharedPagesControllerRevokeGrantV1 = async (
  id: string,
  grantId: string,
  options?: RequestInit
): Promise<sharedPagesControllerRevokeGrantV1Response> => {
  return customInstance<sharedPagesControllerRevokeGrantV1Response>(
    getSharedPagesControllerRevokeGrantV1Url(id, grantId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Public metadata for a shared page (no login)
 */
export type publicSharedPagesControllerPublicInfoV1Response200 = {
  data: PublicSharedPagesControllerPublicInfoV1200
  status: 200
}

export type publicSharedPagesControllerPublicInfoV1ResponseSuccess =
  publicSharedPagesControllerPublicInfoV1Response200 & {
    headers: Headers
  }
export type publicSharedPagesControllerPublicInfoV1Response =
  publicSharedPagesControllerPublicInfoV1ResponseSuccess

export const getPublicSharedPagesControllerPublicInfoV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/public-info`
}

export const publicSharedPagesControllerPublicInfoV1 = async (
  id: string,
  options?: RequestInit
): Promise<publicSharedPagesControllerPublicInfoV1Response> => {
  return customInstance<publicSharedPagesControllerPublicInfoV1Response>(
    getPublicSharedPagesControllerPublicInfoV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Send a verification code to an authorized email
 */
export type publicSharedPagesControllerSendCodeV1Response200 = {
  data: PublicSharedPagesControllerSendCodeV1200
  status: 200
}

export type publicSharedPagesControllerSendCodeV1ResponseSuccess =
  publicSharedPagesControllerSendCodeV1Response200 & {
    headers: Headers
  }
export type publicSharedPagesControllerSendCodeV1Response =
  publicSharedPagesControllerSendCodeV1ResponseSuccess

export const getPublicSharedPagesControllerSendCodeV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/public-access/send-code`
}

export const publicSharedPagesControllerSendCodeV1 = async (
  id: string,
  publicAccessSendCodeDto: PublicAccessSendCodeDto,
  options?: RequestInit
): Promise<publicSharedPagesControllerSendCodeV1Response> => {
  return customInstance<publicSharedPagesControllerSendCodeV1Response>(
    getPublicSharedPagesControllerSendCodeV1Url(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(publicAccessSendCodeDto)
    }
  )
}

/**
 * @summary Verify the code and start a public access session
 */
export type publicSharedPagesControllerVerifyV1Response200 = {
  data: PublicSharedPagesControllerVerifyV1200
  status: 200
}

export type publicSharedPagesControllerVerifyV1ResponseSuccess =
  publicSharedPagesControllerVerifyV1Response200 & {
    headers: Headers
  }
export type publicSharedPagesControllerVerifyV1Response =
  publicSharedPagesControllerVerifyV1ResponseSuccess

export const getPublicSharedPagesControllerVerifyV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/public-access/verify`
}

export const publicSharedPagesControllerVerifyV1 = async (
  id: string,
  publicAccessVerifyDto: PublicAccessVerifyDto,
  options?: RequestInit
): Promise<publicSharedPagesControllerVerifyV1Response> => {
  return customInstance<publicSharedPagesControllerVerifyV1Response>(
    getPublicSharedPagesControllerVerifyV1Url(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(publicAccessVerifyDto)
    }
  )
}

/**
 * @summary View a shared HTML page using a verified session (no login)
 */
export type publicSharedPagesControllerPublicViewV1Response200 = {
  data: void
  status: 200
}

export type publicSharedPagesControllerPublicViewV1ResponseSuccess =
  publicSharedPagesControllerPublicViewV1Response200 & {
    headers: Headers
  }
export type publicSharedPagesControllerPublicViewV1Response =
  publicSharedPagesControllerPublicViewV1ResponseSuccess

export const getPublicSharedPagesControllerPublicViewV1Url = (id: string) => {
  return `/api-arvore/v1/shared-pages/${id}/public-view`
}

export const publicSharedPagesControllerPublicViewV1 = async (
  id: string,
  options?: RequestInit
): Promise<publicSharedPagesControllerPublicViewV1Response> => {
  return customInstance<publicSharedPagesControllerPublicViewV1Response>(
    getPublicSharedPagesControllerPublicViewV1Url(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns data for the Story Tree home page cards (library and forest)
 * @summary Get Story Tree home page data
 */
export type storyTreeControllerGetHomeResponse200 = {
  data: StoryTreeHomeResponseDto
  status: 200
}

export type storyTreeControllerGetHomeResponseSuccess =
  storyTreeControllerGetHomeResponse200 & {
    headers: Headers
  }
export type storyTreeControllerGetHomeResponse =
  storyTreeControllerGetHomeResponseSuccess

export const getStoryTreeControllerGetHomeUrl = () => {
  return `/api-arvore/story-tree/home`
}

export const storyTreeControllerGetHome = async (
  options?: RequestInit
): Promise<storyTreeControllerGetHomeResponse> => {
  return customInstance<storyTreeControllerGetHomeResponse>(
    getStoryTreeControllerGetHomeUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a list of books with progress < 100%, ordered by last read
 * @summary Get books the user is currently reading
 */
export type storyTreeControllerGetViewedBooksResponse200 = {
  data: StoryTreeViewedBooksResponseDto
  status: 200
}

export type storyTreeControllerGetViewedBooksResponseSuccess =
  storyTreeControllerGetViewedBooksResponse200 & {
    headers: Headers
  }
export type storyTreeControllerGetViewedBooksResponse =
  storyTreeControllerGetViewedBooksResponseSuccess

export const getStoryTreeControllerGetViewedBooksUrl = () => {
  return `/api-arvore/story-tree/viewed-books`
}

export const storyTreeControllerGetViewedBooks = async (
  options?: RequestInit
): Promise<storyTreeControllerGetViewedBooksResponse> => {
  return customInstance<storyTreeControllerGetViewedBooksResponse>(
    getStoryTreeControllerGetViewedBooksUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a list of recommended books the user has not read yet
 * @summary Get book recommendations based on reading level
 */
export type storyTreeControllerGetRecommendationsResponse200 = {
  data: StoryTreeRecommendationsResponseDto
  status: 200
}

export type storyTreeControllerGetRecommendationsResponseSuccess =
  storyTreeControllerGetRecommendationsResponse200 & {
    headers: Headers
  }
export type storyTreeControllerGetRecommendationsResponse =
  storyTreeControllerGetRecommendationsResponseSuccess

export const getStoryTreeControllerGetRecommendationsUrl = (
  params?: StoryTreeControllerGetRecommendationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/story-tree/recommendations?${stringifiedParams}`
    : `/api-arvore/story-tree/recommendations`
}

export const storyTreeControllerGetRecommendations = async (
  params?: StoryTreeControllerGetRecommendationsParams,
  options?: RequestInit
): Promise<storyTreeControllerGetRecommendationsResponse> => {
  return customInstance<storyTreeControllerGetRecommendationsResponse>(
    getStoryTreeControllerGetRecommendationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get task details for a specific student
 */
export type tasksControllerGetTaskDetailsByStudentResponse200 = {
  data: TaskDetailsByStudentResponseDto
  status: 200
}

export type tasksControllerGetTaskDetailsByStudentResponseSuccess =
  tasksControllerGetTaskDetailsByStudentResponse200 & {
    headers: Headers
  }
export type tasksControllerGetTaskDetailsByStudentResponse =
  tasksControllerGetTaskDetailsByStudentResponseSuccess

export const getTasksControllerGetTaskDetailsByStudentUrl = (
  taskId: string,
  userId: string
) => {
  return `/api-arvore/tasks/${taskId}/students/${userId}/details`
}

export const tasksControllerGetTaskDetailsByStudent = async (
  taskId: string,
  userId: string,
  options?: RequestInit
): Promise<tasksControllerGetTaskDetailsByStudentResponse> => {
  return customInstance<tasksControllerGetTaskDetailsByStudentResponse>(
    getTasksControllerGetTaskDetailsByStudentUrl(taskId, userId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get quiz questions and alternatives for student
 */
export type tasksControllerGetQuizResponse200 = {
  data: GetQuizResponseDto
  status: 200
}

export type tasksControllerGetQuizResponseSuccess =
  tasksControllerGetQuizResponse200 & {
    headers: Headers
  }
export type tasksControllerGetQuizResponse =
  tasksControllerGetQuizResponseSuccess

export const getTasksControllerGetQuizUrl = (taskId: string) => {
  return `/api-arvore/tasks/${taskId}/quiz`
}

export const tasksControllerGetQuiz = async (
  taskId: string,
  options?: RequestInit
): Promise<tasksControllerGetQuizResponse> => {
  return customInstance<tasksControllerGetQuizResponse>(
    getTasksControllerGetQuizUrl(taskId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Answer a quiz question
 */
export type tasksControllerAnswerQuizResponse200 = {
  data: AnswerQuizResponseDto
  status: 200
}

export type tasksControllerAnswerQuizResponseSuccess =
  tasksControllerAnswerQuizResponse200 & {
    headers: Headers
  }
export type tasksControllerAnswerQuizResponse =
  tasksControllerAnswerQuizResponseSuccess

export const getTasksControllerAnswerQuizUrl = (taskId: string) => {
  return `/api-arvore/tasks/${taskId}/quiz/answer`
}

export const tasksControllerAnswerQuiz = async (
  taskId: string,
  answerQuizBodyDto: AnswerQuizBodyDto,
  options?: RequestInit
): Promise<tasksControllerAnswerQuizResponse> => {
  return customInstance<tasksControllerAnswerQuizResponse>(
    getTasksControllerAnswerQuizUrl(taskId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(answerQuizBodyDto)
    }
  )
}

/**
 * @summary Associa professor a múltiplas unidades por token/e-mail/ID
 */
export type teacherEntitiesControllerAssociateResponse200 = {
  data: AssociateTeacherEntitiesResponseDto
  status: 200
}

export type teacherEntitiesControllerAssociateResponseSuccess =
  teacherEntitiesControllerAssociateResponse200 & {
    headers: Headers
  }
export type teacherEntitiesControllerAssociateResponse =
  teacherEntitiesControllerAssociateResponseSuccess

export const getTeacherEntitiesControllerAssociateUrl = () => {
  return `/api-arvore/teacher-entities/associate`
}

export const teacherEntitiesControllerAssociate = async (
  associateTeacherEntitiesBodyDto: AssociateTeacherEntitiesBodyDto,
  options?: RequestInit
): Promise<teacherEntitiesControllerAssociateResponse> => {
  return customInstance<teacherEntitiesControllerAssociateResponse>(
    getTeacherEntitiesControllerAssociateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(associateTeacherEntitiesBodyDto)
    }
  )
}

/**
 * @summary Associa múltiplos professores a unidades em lote
 */
export type teacherEntitiesControllerAssociateBatchResponse200 = {
  data: TeacherEntitiesBatchResponseDto
  status: 200
}

export type teacherEntitiesControllerAssociateBatchResponseSuccess =
  teacherEntitiesControllerAssociateBatchResponse200 & {
    headers: Headers
  }
export type teacherEntitiesControllerAssociateBatchResponse =
  teacherEntitiesControllerAssociateBatchResponseSuccess

export const getTeacherEntitiesControllerAssociateBatchUrl = () => {
  return `/api-arvore/teacher-entities/associate-batch`
}

export const teacherEntitiesControllerAssociateBatch = async (
  associateTeacherEntitiesBatchBodyDto: AssociateTeacherEntitiesBatchBodyDto,
  options?: RequestInit
): Promise<teacherEntitiesControllerAssociateBatchResponse> => {
  return customInstance<teacherEntitiesControllerAssociateBatchResponse>(
    getTeacherEntitiesControllerAssociateBatchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(associateTeacherEntitiesBatchBodyDto)
    }
  )
}

/**
 * @summary Remove vínculo de professor com unidades
 */
export type teacherEntitiesControllerDissociateResponse200 = {
  data: DissociateTeacherEntitiesResponseDto
  status: 200
}

export type teacherEntitiesControllerDissociateResponseSuccess =
  teacherEntitiesControllerDissociateResponse200 & {
    headers: Headers
  }
export type teacherEntitiesControllerDissociateResponse =
  teacherEntitiesControllerDissociateResponseSuccess

export const getTeacherEntitiesControllerDissociateUrl = () => {
  return `/api-arvore/teacher-entities/dissociate`
}

export const teacherEntitiesControllerDissociate = async (
  dissociateTeacherEntitiesBodyDto: DissociateTeacherEntitiesBodyDto,
  options?: RequestInit
): Promise<teacherEntitiesControllerDissociateResponse> => {
  return customInstance<teacherEntitiesControllerDissociateResponse>(
    getTeacherEntitiesControllerDissociateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(dissociateTeacherEntitiesBodyDto)
    }
  )
}

/**
 * @summary Busca usuário por access_token ou email
 */
export type userToAdminControllerSearchResponse200 = {
  data: SearchUserResponseDto
  status: 200
}

export type userToAdminControllerSearchResponseSuccess =
  userToAdminControllerSearchResponse200 & {
    headers: Headers
  }
export type userToAdminControllerSearchResponse =
  userToAdminControllerSearchResponseSuccess

export const getUserToAdminControllerSearchUrl = (
  params: UserToAdminControllerSearchParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/user-to-admin/search?${stringifiedParams}`
    : `/api-arvore/user-to-admin/search`
}

export const userToAdminControllerSearch = async (
  params: UserToAdminControllerSearchParams,
  options?: RequestInit
): Promise<userToAdminControllerSearchResponse> => {
  return customInstance<userToAdminControllerSearchResponse>(
    getUserToAdminControllerSearchUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Alterna status de admin de um usuário do Time Árvore
 */
export type userToAdminControllerToggleResponse200 = {
  data: ToggleAdminResponseDto
  status: 200
}

export type userToAdminControllerToggleResponseSuccess =
  userToAdminControllerToggleResponse200 & {
    headers: Headers
  }
export type userToAdminControllerToggleResponse =
  userToAdminControllerToggleResponseSuccess

export const getUserToAdminControllerToggleUrl = () => {
  return `/api-arvore/user-to-admin/toggle`
}

export const userToAdminControllerToggle = async (
  toggleAdminBodyDto: ToggleAdminBodyDto,
  options?: RequestInit
): Promise<userToAdminControllerToggleResponse> => {
  return customInstance<userToAdminControllerToggleResponse>(
    getUserToAdminControllerToggleUrl(),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleAdminBodyDto)
    }
  )
}

/**
 * @summary Listar livros visualizados/lidos do leitor
 */
export type viewedBooksControllerListResponse200 = {
  data: ViewedBooksResponseDto
  status: 200
}

export type viewedBooksControllerListResponseSuccess =
  viewedBooksControllerListResponse200 & {
    headers: Headers
  }
export type viewedBooksControllerListResponse =
  viewedBooksControllerListResponseSuccess

export const getViewedBooksControllerListUrl = (
  params?: ViewedBooksControllerListParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/viewed-books?${stringifiedParams}`
    : `/api-arvore/viewed-books`
}

export const viewedBooksControllerList = async (
  params?: ViewedBooksControllerListParams,
  options?: RequestInit
): Promise<viewedBooksControllerListResponse> => {
  return customInstance<viewedBooksControllerListResponse>(
    getViewedBooksControllerListUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Ocultar livro da lista de lidos
 */
export type viewedBooksControllerHideResponse204 = {
  data: void
  status: 204
}

export type viewedBooksControllerHideResponseSuccess =
  viewedBooksControllerHideResponse204 & {
    headers: Headers
  }
export type viewedBooksControllerHideResponse =
  viewedBooksControllerHideResponseSuccess

export const getViewedBooksControllerHideUrl = (slug: string) => {
  return `/api-arvore/viewed-books/${slug}/hide`
}

export const viewedBooksControllerHide = async (
  slug: string,
  options?: RequestInit
): Promise<viewedBooksControllerHideResponse> => {
  return customInstance<viewedBooksControllerHideResponse>(
    getViewedBooksControllerHideUrl(slug),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Change teacher active entity (school)
 */
export type teachersControllerChangeTeacherEntityResponse200 = {
  data: ChangeTeacherEntityResponseDto
  status: 200
}

export type teachersControllerChangeTeacherEntityResponseSuccess =
  teachersControllerChangeTeacherEntityResponse200 & {
    headers: Headers
  }
export type teachersControllerChangeTeacherEntityResponse =
  teachersControllerChangeTeacherEntityResponseSuccess

export const getTeachersControllerChangeTeacherEntityUrl = () => {
  return `/api-arvore/teachers/entity`
}

export const teachersControllerChangeTeacherEntity = async (
  changeTeacherEntityDto: ChangeTeacherEntityDto,
  options?: RequestInit
): Promise<teachersControllerChangeTeacherEntityResponse> => {
  return customInstance<teachersControllerChangeTeacherEntityResponse>(
    getTeachersControllerChangeTeacherEntityUrl(),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changeTeacherEntityDto)
    }
  )
}

/**
 * @summary Set classes for a teacher (replaces all existing)
 */
export type teachersControllerSetTeacherClassesResponse200 = {
  data: AssignClassToTeacherResponseDto
  status: 200
}

export type teachersControllerSetTeacherClassesResponseSuccess =
  teachersControllerSetTeacherClassesResponse200 & {
    headers: Headers
  }
export type teachersControllerSetTeacherClassesResponse =
  teachersControllerSetTeacherClassesResponseSuccess

export const getTeachersControllerSetTeacherClassesUrl = (
  teacherId: number
) => {
  return `/api-arvore/teachers/${teacherId}/classes`
}

export const teachersControllerSetTeacherClasses = async (
  teacherId: number,
  assignClassToTeacherDto: AssignClassToTeacherDto,
  options?: RequestInit
): Promise<teachersControllerSetTeacherClassesResponse> => {
  return customInstance<teachersControllerSetTeacherClassesResponse>(
    getTeachersControllerSetTeacherClassesUrl(teacherId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(assignClassToTeacherDto)
    }
  )
}

/**
 * @summary Get classes assigned to a teacher
 */
export type teachersControllerGetTeacherClassesResponse200 = {
  data: GetTeacherClassesResponseDto
  status: 200
}

export type teachersControllerGetTeacherClassesResponseSuccess =
  teachersControllerGetTeacherClassesResponse200 & {
    headers: Headers
  }
export type teachersControllerGetTeacherClassesResponse =
  teachersControllerGetTeacherClassesResponseSuccess

export const getTeachersControllerGetTeacherClassesUrl = (
  teacherId: number
) => {
  return `/api-arvore/teachers/${teacherId}/classes`
}

export const teachersControllerGetTeacherClasses = async (
  teacherId: number,
  options?: RequestInit
): Promise<teachersControllerGetTeacherClassesResponse> => {
  return customInstance<teachersControllerGetTeacherClassesResponse>(
    getTeachersControllerGetTeacherClassesUrl(teacherId),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get books for a teacher with enabled/disabled status
 */
export type teacherBooksControllerGetBooksResponse200 = {
  data: GetBooksResponseDto
  status: 200
}

export type teacherBooksControllerGetBooksResponseSuccess =
  teacherBooksControllerGetBooksResponse200 & {
    headers: Headers
  }
export type teacherBooksControllerGetBooksResponse =
  teacherBooksControllerGetBooksResponseSuccess

export const getTeacherBooksControllerGetBooksUrl = (
  params?: TeacherBooksControllerGetBooksParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/teachers/books?${stringifiedParams}`
    : `/api-arvore/teachers/books`
}

export const teacherBooksControllerGetBooks = async (
  params?: TeacherBooksControllerGetBooksParams,
  options?: RequestInit
): Promise<teacherBooksControllerGetBooksResponse> => {
  return customInstance<teacherBooksControllerGetBooksResponse>(
    getTeacherBooksControllerGetBooksUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Enable or disable a book for a teacher
 */
export type teacherBooksControllerToggleBookStatusResponse200 = {
  data: void
  status: 200
}

export type teacherBooksControllerToggleBookStatusResponse404 = {
  data: void
  status: 404
}

export type teacherBooksControllerToggleBookStatusResponseSuccess =
  teacherBooksControllerToggleBookStatusResponse200 & {
    headers: Headers
  }
export type teacherBooksControllerToggleBookStatusResponseError =
  teacherBooksControllerToggleBookStatusResponse404 & {
    headers: Headers
  }

export type teacherBooksControllerToggleBookStatusResponse =
  | teacherBooksControllerToggleBookStatusResponseSuccess
  | teacherBooksControllerToggleBookStatusResponseError

export const getTeacherBooksControllerToggleBookStatusUrl = () => {
  return `/api-arvore/teachers/books`
}

export const teacherBooksControllerToggleBookStatus = async (
  toggleBookStatusDto: ToggleBookStatusDto,
  options?: RequestInit
): Promise<teacherBooksControllerToggleBookStatusResponse> => {
  return customInstance<teacherBooksControllerToggleBookStatusResponse>(
    getTeacherBooksControllerToggleBookStatusUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(toggleBookStatusDto)
    }
  )
}

/**
 * @summary Get classes the authenticated reader is associated with
 */
export type readersControllerGetReaderClassesResponse200 = {
  data: GetReaderClassesResponseDto
  status: 200
}

export type readersControllerGetReaderClassesResponseSuccess =
  readersControllerGetReaderClassesResponse200 & {
    headers: Headers
  }
export type readersControllerGetReaderClassesResponse =
  readersControllerGetReaderClassesResponseSuccess

export const getReadersControllerGetReaderClassesUrl = () => {
  return `/api-arvore/readers/classes`
}

export const readersControllerGetReaderClasses = async (
  options?: RequestInit
): Promise<readersControllerGetReaderClassesResponse> => {
  return customInstance<readersControllerGetReaderClassesResponse>(
    getReadersControllerGetReaderClassesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Change reader active entity (class)
 */
export type readersControllerChangeReaderEntityResponse200 = {
  data: ChangeReaderEntityResponseDto
  status: 200
}

export type readersControllerChangeReaderEntityResponseSuccess =
  readersControllerChangeReaderEntityResponse200 & {
    headers: Headers
  }
export type readersControllerChangeReaderEntityResponse =
  readersControllerChangeReaderEntityResponseSuccess

export const getReadersControllerChangeReaderEntityUrl = () => {
  return `/api-arvore/readers/entity`
}

export const readersControllerChangeReaderEntity = async (
  changeReaderEntityDto: ChangeReaderEntityDto,
  options?: RequestInit
): Promise<readersControllerChangeReaderEntityResponse> => {
  return customInstance<readersControllerChangeReaderEntityResponse>(
    getReadersControllerChangeReaderEntityUrl(),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changeReaderEntityDto)
    }
  )
}

/**
 * @summary Transforma um educador individual em leitor removendo seu(s) perfil(is) de educador
 */
export type teacherToReaderControllerExecuteResponse200 = {
  data: TransformTeacherToReaderResponseDto
  status: 200
}

export type teacherToReaderControllerExecuteResponseSuccess =
  teacherToReaderControllerExecuteResponse200 & {
    headers: Headers
  }
export type teacherToReaderControllerExecuteResponse =
  teacherToReaderControllerExecuteResponseSuccess

export const getTeacherToReaderControllerExecuteUrl = () => {
  return `/api-arvore/teacher-to-reader/execute`
}

export const teacherToReaderControllerExecute = async (
  transformTeacherToReaderBodyDto: TransformTeacherToReaderBodyDto,
  options?: RequestInit
): Promise<teacherToReaderControllerExecuteResponse> => {
  return customInstance<teacherToReaderControllerExecuteResponse>(
    getTeacherToReaderControllerExecuteUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(transformTeacherToReaderBodyDto)
    }
  )
}

/**
 * @summary Generate speech from text using ElevenLabs
 */
export type ttsControllerGenerateResponse201 = {
  data: GenerateTtsResponseDto
  status: 201
}

export type ttsControllerGenerateResponse400 = {
  data: void
  status: 400
}

export type ttsControllerGenerateResponse401 = {
  data: void
  status: 401
}

export type ttsControllerGenerateResponseSuccess =
  ttsControllerGenerateResponse201 & {
    headers: Headers
  }
export type ttsControllerGenerateResponseError = (
  | ttsControllerGenerateResponse400
  | ttsControllerGenerateResponse401
) & {
  headers: Headers
}

export type ttsControllerGenerateResponse =
  | ttsControllerGenerateResponseSuccess
  | ttsControllerGenerateResponseError

export const getTtsControllerGenerateUrl = () => {
  return `/api-arvore/v1/tts/generate`
}

export const ttsControllerGenerate = async (
  generateTtsRequestDto: GenerateTtsRequestDto,
  options?: RequestInit
): Promise<ttsControllerGenerateResponse> => {
  return customInstance<ttsControllerGenerateResponse>(
    getTtsControllerGenerateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateTtsRequestDto)
    }
  )
}

/**
 * @summary Generate speech from text with character-level timestamps
 */
export type ttsControllerGenerateWithTimestampsResponse201 = {
  data: GenerateTtsWithTimestampsResponseDto
  status: 201
}

export type ttsControllerGenerateWithTimestampsResponse400 = {
  data: void
  status: 400
}

export type ttsControllerGenerateWithTimestampsResponse401 = {
  data: void
  status: 401
}

export type ttsControllerGenerateWithTimestampsResponseSuccess =
  ttsControllerGenerateWithTimestampsResponse201 & {
    headers: Headers
  }
export type ttsControllerGenerateWithTimestampsResponseError = (
  | ttsControllerGenerateWithTimestampsResponse400
  | ttsControllerGenerateWithTimestampsResponse401
) & {
  headers: Headers
}

export type ttsControllerGenerateWithTimestampsResponse =
  | ttsControllerGenerateWithTimestampsResponseSuccess
  | ttsControllerGenerateWithTimestampsResponseError

export const getTtsControllerGenerateWithTimestampsUrl = () => {
  return `/api-arvore/v1/tts/generate-with-timestamps`
}

export const ttsControllerGenerateWithTimestamps = async (
  generateTtsRequestDto: GenerateTtsRequestDto,
  options?: RequestInit
): Promise<ttsControllerGenerateWithTimestampsResponse> => {
  return customInstance<ttsControllerGenerateWithTimestampsResponse>(
    getTtsControllerGenerateWithTimestampsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateTtsRequestDto)
    }
  )
}

/**
 * @summary Transcribe audio to text with timestamps using ElevenLabs
 */
export type sttControllerTranscribeResponse201 = {
  data: TranscribeSttResponseDto
  status: 201
}

export type sttControllerTranscribeResponse400 = {
  data: void
  status: 400
}

export type sttControllerTranscribeResponse401 = {
  data: void
  status: 401
}

export type sttControllerTranscribeResponse404 = {
  data: void
  status: 404
}

export type sttControllerTranscribeResponseSuccess =
  sttControllerTranscribeResponse201 & {
    headers: Headers
  }
export type sttControllerTranscribeResponseError = (
  | sttControllerTranscribeResponse400
  | sttControllerTranscribeResponse401
  | sttControllerTranscribeResponse404
) & {
  headers: Headers
}

export type sttControllerTranscribeResponse =
  | sttControllerTranscribeResponseSuccess
  | sttControllerTranscribeResponseError

export const getSttControllerTranscribeUrl = () => {
  return `/api-arvore/v1/stt/transcribe`
}

export const sttControllerTranscribe = async (
  transcribeSttRequestDto: TranscribeSttRequestDto,
  options?: RequestInit
): Promise<sttControllerTranscribeResponse> => {
  return customInstance<sttControllerTranscribeResponse>(
    getSttControllerTranscribeUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(transcribeSttRequestDto)
    }
  )
}

/**
 * @summary Generate a single-use token for the ElevenLabs Scribe realtime WebSocket
 */
export type sttControllerCreateRealtimeTokenResponse201 = {
  data: CreateScribeRealtimeTokenResponseDto
  status: 201
}

export type sttControllerCreateRealtimeTokenResponse401 = {
  data: void
  status: 401
}

export type sttControllerCreateRealtimeTokenResponse429 = {
  data: void
  status: 429
}

export type sttControllerCreateRealtimeTokenResponseSuccess =
  sttControllerCreateRealtimeTokenResponse201 & {
    headers: Headers
  }
export type sttControllerCreateRealtimeTokenResponseError = (
  | sttControllerCreateRealtimeTokenResponse401
  | sttControllerCreateRealtimeTokenResponse429
) & {
  headers: Headers
}

export type sttControllerCreateRealtimeTokenResponse =
  | sttControllerCreateRealtimeTokenResponseSuccess
  | sttControllerCreateRealtimeTokenResponseError

export const getSttControllerCreateRealtimeTokenUrl = () => {
  return `/api-arvore/v1/stt/realtime-token`
}

export const sttControllerCreateRealtimeToken = async (
  options?: RequestInit
): Promise<sttControllerCreateRealtimeTokenResponse> => {
  return customInstance<sttControllerCreateRealtimeTokenResponse>(
    getSttControllerCreateRealtimeTokenUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Ingest chat messages (raw tier, ADD/UPDATE/NOOP server-side)
 */
export type piMemoryControllerIngestResponse201 = {
  data: void
  status: 201
}

export type piMemoryControllerIngestResponseSuccess =
  piMemoryControllerIngestResponse201 & {
    headers: Headers
  }
export type piMemoryControllerIngestResponse =
  piMemoryControllerIngestResponseSuccess

export const getPiMemoryControllerIngestUrl = () => {
  return `/api-arvore/pi-memory/ingest`
}

export const piMemoryControllerIngest = async (
  ingestDto: IngestDto,
  options?: RequestInit
): Promise<piMemoryControllerIngestResponse> => {
  return customInstance<piMemoryControllerIngestResponse>(
    getPiMemoryControllerIngestUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(ingestDto)
    }
  )
}

/**
 * @summary Semantic search over team memory (org pool)
 */
export type piMemoryControllerSearchResponse201 = {
  data: void
  status: 201
}

export type piMemoryControllerSearchResponseSuccess =
  piMemoryControllerSearchResponse201 & {
    headers: Headers
  }
export type piMemoryControllerSearchResponse =
  piMemoryControllerSearchResponseSuccess

export const getPiMemoryControllerSearchUrl = () => {
  return `/api-arvore/pi-memory/search`
}

export const piMemoryControllerSearch = async (
  searchDto: SearchDto,
  options?: RequestInit
): Promise<piMemoryControllerSearchResponse> => {
  return customInstance<piMemoryControllerSearchResponse>(
    getPiMemoryControllerSearchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(searchDto)
    }
  )
}

/**
 * @summary Register usefulness feedback for a memory (adjusts relevance_score)
 */
export type piMemoryControllerFeedbackResponse201 = {
  data: void
  status: 201
}

export type piMemoryControllerFeedbackResponseSuccess =
  piMemoryControllerFeedbackResponse201 & {
    headers: Headers
  }
export type piMemoryControllerFeedbackResponse =
  piMemoryControllerFeedbackResponseSuccess

export const getPiMemoryControllerFeedbackUrl = () => {
  return `/api-arvore/pi-memory/feedback`
}

export const piMemoryControllerFeedback = async (
  feedbackDto: FeedbackDto,
  options?: RequestInit
): Promise<piMemoryControllerFeedbackResponse> => {
  return customInstance<piMemoryControllerFeedbackResponse>(
    getPiMemoryControllerFeedbackUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(feedbackDto)
    }
  )
}

/**
 * @summary Create or update a curated memory
 */
export type piMemoryControllerCuratedResponse201 = {
  data: void
  status: 201
}

export type piMemoryControllerCuratedResponseSuccess =
  piMemoryControllerCuratedResponse201 & {
    headers: Headers
  }
export type piMemoryControllerCuratedResponse =
  piMemoryControllerCuratedResponseSuccess

export const getPiMemoryControllerCuratedUrl = () => {
  return `/api-arvore/pi-memory/curated`
}

export const piMemoryControllerCurated = async (
  curatedDto: CuratedDto,
  options?: RequestInit
): Promise<piMemoryControllerCuratedResponse> => {
  return customInstance<piMemoryControllerCuratedResponse>(
    getPiMemoryControllerCuratedUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(curatedDto)
    }
  )
}

/**
 * @summary List raw memories eligible for promotion
 */
export type piMemoryControllerCandidatesResponse200 = {
  data: void
  status: 200
}

export type piMemoryControllerCandidatesResponseSuccess =
  piMemoryControllerCandidatesResponse200 & {
    headers: Headers
  }
export type piMemoryControllerCandidatesResponse =
  piMemoryControllerCandidatesResponseSuccess

export const getPiMemoryControllerCandidatesUrl = (
  params: PiMemoryControllerCandidatesParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/pi-memory/candidates?${stringifiedParams}`
    : `/api-arvore/pi-memory/candidates`
}

export const piMemoryControllerCandidates = async (
  params: PiMemoryControllerCandidatesParams,
  options?: RequestInit
): Promise<piMemoryControllerCandidatesResponse> => {
  return customInstance<piMemoryControllerCandidatesResponse>(
    getPiMemoryControllerCandidatesUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Promote raw memories to curated
 */
export type piMemoryControllerPromoteResponse201 = {
  data: void
  status: 201
}

export type piMemoryControllerPromoteResponseSuccess =
  piMemoryControllerPromoteResponse201 & {
    headers: Headers
  }
export type piMemoryControllerPromoteResponse =
  piMemoryControllerPromoteResponseSuccess

export const getPiMemoryControllerPromoteUrl = () => {
  return `/api-arvore/pi-memory/promote`
}

export const piMemoryControllerPromote = async (
  promoteDto: PromoteDto,
  options?: RequestInit
): Promise<piMemoryControllerPromoteResponse> => {
  return customInstance<piMemoryControllerPromoteResponse>(
    getPiMemoryControllerPromoteUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(promoteDto)
    }
  )
}

/**
 * @summary Delete all raw chunks from a session (retroactive incognito)
 */
export type piMemoryControllerDeleteSessionResponse200 = {
  data: void
  status: 200
}

export type piMemoryControllerDeleteSessionResponseSuccess =
  piMemoryControllerDeleteSessionResponse200 & {
    headers: Headers
  }
export type piMemoryControllerDeleteSessionResponse =
  piMemoryControllerDeleteSessionResponseSuccess

export const getPiMemoryControllerDeleteSessionUrl = (sessionId: string) => {
  return `/api-arvore/pi-memory/session/${sessionId}`
}

export const piMemoryControllerDeleteSession = async (
  sessionId: string,
  options?: RequestInit
): Promise<piMemoryControllerDeleteSessionResponse> => {
  return customInstance<piMemoryControllerDeleteSessionResponse>(
    getPiMemoryControllerDeleteSessionUrl(sessionId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Delete a single memory by id (own author only)
 */
export type piMemoryControllerDeleteByIdResponse200 = {
  data: void
  status: 200
}

export type piMemoryControllerDeleteByIdResponseSuccess =
  piMemoryControllerDeleteByIdResponse200 & {
    headers: Headers
  }
export type piMemoryControllerDeleteByIdResponse =
  piMemoryControllerDeleteByIdResponseSuccess

export const getPiMemoryControllerDeleteByIdUrl = (id: string) => {
  return `/api-arvore/pi-memory/${id}`
}

export const piMemoryControllerDeleteById = async (
  id: string,
  options?: RequestInit
): Promise<piMemoryControllerDeleteByIdResponse> => {
  return customInstance<piMemoryControllerDeleteByIdResponse>(
    getPiMemoryControllerDeleteByIdUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Diff repo Merkle roots, return files to (re)index
 */
export type codebaseIndexControllerSyncResponse201 = {
  data: void
  status: 201
}

export type codebaseIndexControllerSyncResponseSuccess =
  codebaseIndexControllerSyncResponse201 & {
    headers: Headers
  }
export type codebaseIndexControllerSyncResponse =
  codebaseIndexControllerSyncResponseSuccess

export const getCodebaseIndexControllerSyncUrl = () => {
  return `/api-arvore/codebase-index/sync`
}

export const codebaseIndexControllerSync = async (
  syncDto: SyncDto,
  options?: RequestInit
): Promise<codebaseIndexControllerSyncResponse> => {
  return customInstance<codebaseIndexControllerSyncResponse>(
    getCodebaseIndexControllerSyncUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(syncDto)
    }
  )
}

/**
 * @summary Embed and store code chunks
 */
export type codebaseIndexControllerIndexResponse201 = {
  data: void
  status: 201
}

export type codebaseIndexControllerIndexResponseSuccess =
  codebaseIndexControllerIndexResponse201 & {
    headers: Headers
  }
export type codebaseIndexControllerIndexResponse =
  codebaseIndexControllerIndexResponseSuccess

export const getCodebaseIndexControllerIndexUrl = () => {
  return `/api-arvore/codebase-index/index`
}

export const codebaseIndexControllerIndex = async (
  indexDto: IndexDto,
  options?: RequestInit
): Promise<codebaseIndexControllerIndexResponse> => {
  return customInstance<codebaseIndexControllerIndexResponse>(
    getCodebaseIndexControllerIndexUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(indexDto)
    }
  )
}

/**
 * @summary Semantic code search across the org index
 */
export type codebaseIndexControllerSearchResponse201 = {
  data: void
  status: 201
}

export type codebaseIndexControllerSearchResponseSuccess =
  codebaseIndexControllerSearchResponse201 & {
    headers: Headers
  }
export type codebaseIndexControllerSearchResponse =
  codebaseIndexControllerSearchResponseSuccess

export const getCodebaseIndexControllerSearchUrl = () => {
  return `/api-arvore/codebase-index/search`
}

export const codebaseIndexControllerSearch = async (
  searchDto: SearchDto,
  options?: RequestInit
): Promise<codebaseIndexControllerSearchResponse> => {
  return customInstance<codebaseIndexControllerSearchResponse>(
    getCodebaseIndexControllerSearchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(searchDto)
    }
  )
}

/**
 * @summary Initialize widget session with partner token
 */
export type widgetControllerInitResponse201 = {
  data: void
  status: 201
}

export type widgetControllerInitResponseSuccess =
  widgetControllerInitResponse201 & {
    headers: Headers
  }
export type widgetControllerInitResponse = widgetControllerInitResponseSuccess

export const getWidgetControllerInitUrl = () => {
  return `/api-arvore/widget/init`
}

export const widgetControllerInit = async (
  widgetInitDto: WidgetInitDto,
  options?: RequestInit
): Promise<widgetControllerInitResponse> => {
  return customInstance<widgetControllerInitResponse>(
    getWidgetControllerInitUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(widgetInitDto)
    }
  )
}

/**
 * @summary Get AI feedback on student writing
 */
export type widgetControllerReviewResponse201 = {
  data: void
  status: 201
}

export type widgetControllerReviewResponseSuccess =
  widgetControllerReviewResponse201 & {
    headers: Headers
  }
export type widgetControllerReviewResponse =
  widgetControllerReviewResponseSuccess

export const getWidgetControllerReviewUrl = () => {
  return `/api-arvore/widget/ai/review`
}

export const widgetControllerReview = async (
  aiReviewDto: AiReviewDto,
  options?: RequestInit
): Promise<widgetControllerReviewResponse> => {
  return customInstance<widgetControllerReviewResponse>(
    getWidgetControllerReviewUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(aiReviewDto)
    }
  )
}

/**
 * @summary Get AI writing suggestions for a new page
 */
export type widgetControllerHintResponse201 = {
  data: void
  status: 201
}

export type widgetControllerHintResponseSuccess =
  widgetControllerHintResponse201 & {
    headers: Headers
  }
export type widgetControllerHintResponse = widgetControllerHintResponseSuccess

export const getWidgetControllerHintUrl = () => {
  return `/api-arvore/widget/ai/hint`
}

export const widgetControllerHint = async (
  aiHintDto: AiHintDto,
  options?: RequestInit
): Promise<widgetControllerHintResponse> => {
  return customInstance<widgetControllerHintResponse>(
    getWidgetControllerHintUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(aiHintDto)
    }
  )
}

/**
 * @summary Execute a predefined action button
 */
export type widgetControllerActionResponse201 = {
  data: void
  status: 201
}

export type widgetControllerActionResponseSuccess =
  widgetControllerActionResponse201 & {
    headers: Headers
  }
export type widgetControllerActionResponse =
  widgetControllerActionResponseSuccess

export const getWidgetControllerActionUrl = () => {
  return `/api-arvore/widget/ai/action`
}

export const widgetControllerAction = async (
  aiActionDto: AiActionDto,
  options?: RequestInit
): Promise<widgetControllerActionResponse> => {
  return customInstance<widgetControllerActionResponse>(
    getWidgetControllerActionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(aiActionDto)
    }
  )
}

/**
 * @summary List available action buttons
 */
export type widgetControllerGetActionsResponse200 = {
  data: void
  status: 200
}

export type widgetControllerGetActionsResponseSuccess =
  widgetControllerGetActionsResponse200 & {
    headers: Headers
  }
export type widgetControllerGetActionsResponse =
  widgetControllerGetActionsResponseSuccess

export const getWidgetControllerGetActionsUrl = (
  params?: WidgetControllerGetActionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/widget/ai/actions?${stringifiedParams}`
    : `/api-arvore/widget/ai/actions`
}

export const widgetControllerGetActions = async (
  params?: WidgetControllerGetActionsParams,
  options?: RequestInit
): Promise<widgetControllerGetActionsResponse> => {
  return customInstance<widgetControllerGetActionsResponse>(
    getWidgetControllerGetActionsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns reading statistics for the year 2025 (January 1 to November 19)
 * @summary Get rewind data for 2025
 */
export type wrappedControllerGetRewindResponse200 = {
  data: RewindResponseDto
  status: 200
}

export type wrappedControllerGetRewindResponseSuccess =
  wrappedControllerGetRewindResponse200 & {
    headers: Headers
  }
export type wrappedControllerGetRewindResponse =
  wrappedControllerGetRewindResponseSuccess

export const getWrappedControllerGetRewindUrl = () => {
  return `/api-arvore/wrapped/rewind`
}

export const wrappedControllerGetRewind = async (
  options?: RequestInit
): Promise<wrappedControllerGetRewindResponse> => {
  return customInstance<wrappedControllerGetRewindResponse>(
    getWrappedControllerGetRewindUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Students can submit reviews with ratings and comments for books
 * @summary Submit a book review
 */
export type wrappedControllerCreateBookReviewResponse201 = {
  data: BookReviewResponseDto
  status: 201
}

export type wrappedControllerCreateBookReviewResponse400 = {
  data: void
  status: 400
}

export type wrappedControllerCreateBookReviewResponseSuccess =
  wrappedControllerCreateBookReviewResponse201 & {
    headers: Headers
  }
export type wrappedControllerCreateBookReviewResponseError =
  wrappedControllerCreateBookReviewResponse400 & {
    headers: Headers
  }

export type wrappedControllerCreateBookReviewResponse =
  | wrappedControllerCreateBookReviewResponseSuccess
  | wrappedControllerCreateBookReviewResponseError

export const getWrappedControllerCreateBookReviewUrl = () => {
  return `/api-arvore/wrapped/book-reviews`
}

export const wrappedControllerCreateBookReview = async (
  createBookReviewDto: CreateBookReviewDto,
  options?: RequestInit
): Promise<wrappedControllerCreateBookReviewResponse> => {
  return customInstance<wrappedControllerCreateBookReviewResponse>(
    getWrappedControllerCreateBookReviewUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createBookReviewDto)
    }
  )
}

/**
 * Generates a PressReader Gifted Access Token and redirects the user to PressReader activation page
 * @summary Activate PressReader gifted access
 */
export type pressReaderControllerActivateResponse302 = {
  data: void
  status: 302
}

export type pressReaderControllerActivateResponse401 = {
  data: void
  status: 401
}

export type pressReaderControllerActivateResponse403 = {
  data: void
  status: 403
}
export type pressReaderControllerActivateResponseError = (
  | pressReaderControllerActivateResponse302
  | pressReaderControllerActivateResponse401
  | pressReaderControllerActivateResponse403
) & {
  headers: Headers
}

export type pressReaderControllerActivateResponse =
  pressReaderControllerActivateResponseError

export const getPressReaderControllerActivateUrl = (
  params?: PressReaderControllerActivateParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/press-reader/activate?${stringifiedParams}`
    : `/api-arvore/press-reader/activate`
}

export const pressReaderControllerActivate = async (
  params?: PressReaderControllerActivateParams,
  options?: RequestInit
): Promise<pressReaderControllerActivateResponse> => {
  return customInstance<pressReaderControllerActivateResponse>(
    getPressReaderControllerActivateUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a list of publications from PressReader catalog
 * @summary List publications
 */
export type pressReaderControllerListPublicationsResponse200 = {
  data: ListPublicationsResponseDto
  status: 200
}

export type pressReaderControllerListPublicationsResponse401 = {
  data: void
  status: 401
}

export type pressReaderControllerListPublicationsResponse403 = {
  data: void
  status: 403
}

export type pressReaderControllerListPublicationsResponseSuccess =
  pressReaderControllerListPublicationsResponse200 & {
    headers: Headers
  }
export type pressReaderControllerListPublicationsResponseError = (
  | pressReaderControllerListPublicationsResponse401
  | pressReaderControllerListPublicationsResponse403
) & {
  headers: Headers
}

export type pressReaderControllerListPublicationsResponse =
  | pressReaderControllerListPublicationsResponseSuccess
  | pressReaderControllerListPublicationsResponseError

export const getPressReaderControllerListPublicationsUrl = (
  params?: PressReaderControllerListPublicationsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['cid']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach(v => {
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/press-reader/publications?${stringifiedParams}`
    : `/api-arvore/press-reader/publications`
}

export const pressReaderControllerListPublications = async (
  params?: PressReaderControllerListPublicationsParams,
  options?: RequestInit
): Promise<pressReaderControllerListPublicationsResponse> => {
  return customInstance<pressReaderControllerListPublicationsResponse>(
    getPressReaderControllerListPublicationsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns navigation groups/filters for publications catalog
 * @summary List navigation filters
 */
export type pressReaderControllerListFiltersResponse200 = {
  data: ListFiltersResponseDto
  status: 200
}

export type pressReaderControllerListFiltersResponse401 = {
  data: void
  status: 401
}

export type pressReaderControllerListFiltersResponse403 = {
  data: void
  status: 403
}

export type pressReaderControllerListFiltersResponseSuccess =
  pressReaderControllerListFiltersResponse200 & {
    headers: Headers
  }
export type pressReaderControllerListFiltersResponseError = (
  | pressReaderControllerListFiltersResponse401
  | pressReaderControllerListFiltersResponse403
) & {
  headers: Headers
}

export type pressReaderControllerListFiltersResponse =
  | pressReaderControllerListFiltersResponseSuccess
  | pressReaderControllerListFiltersResponseError

export const getPressReaderControllerListFiltersUrl = () => {
  return `/api-arvore/press-reader/filters`
}

export const pressReaderControllerListFilters = async (
  options?: RequestInit
): Promise<pressReaderControllerListFiltersResponse> => {
  return customInstance<pressReaderControllerListFiltersResponse>(
    getPressReaderControllerListFiltersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a curated list of newspapers for shelf/carousel display
 * @summary List newspapers for shelf display
 */
export type pressReaderControllerListNewspapersResponse200 = {
  data: ListPublicationsShelfResponseDto
  status: 200
}

export type pressReaderControllerListNewspapersResponse401 = {
  data: void
  status: 401
}

export type pressReaderControllerListNewspapersResponse403 = {
  data: void
  status: 403
}

export type pressReaderControllerListNewspapersResponseSuccess =
  pressReaderControllerListNewspapersResponse200 & {
    headers: Headers
  }
export type pressReaderControllerListNewspapersResponseError = (
  | pressReaderControllerListNewspapersResponse401
  | pressReaderControllerListNewspapersResponse403
) & {
  headers: Headers
}

export type pressReaderControllerListNewspapersResponse =
  | pressReaderControllerListNewspapersResponseSuccess
  | pressReaderControllerListNewspapersResponseError

export const getPressReaderControllerListNewspapersUrl = () => {
  return `/api-arvore/press-reader/newspapers`
}

export const pressReaderControllerListNewspapers = async (
  options?: RequestInit
): Promise<pressReaderControllerListNewspapersResponse> => {
  return customInstance<pressReaderControllerListNewspapersResponse>(
    getPressReaderControllerListNewspapersUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * Returns a curated list of magazines for shelf/carousel display
 * @summary List magazines for shelf display
 */
export type pressReaderControllerListMagazinesResponse200 = {
  data: ListPublicationsShelfResponseDto
  status: 200
}

export type pressReaderControllerListMagazinesResponse401 = {
  data: void
  status: 401
}

export type pressReaderControllerListMagazinesResponse403 = {
  data: void
  status: 403
}

export type pressReaderControllerListMagazinesResponseSuccess =
  pressReaderControllerListMagazinesResponse200 & {
    headers: Headers
  }
export type pressReaderControllerListMagazinesResponseError = (
  | pressReaderControllerListMagazinesResponse401
  | pressReaderControllerListMagazinesResponse403
) & {
  headers: Headers
}

export type pressReaderControllerListMagazinesResponse =
  | pressReaderControllerListMagazinesResponseSuccess
  | pressReaderControllerListMagazinesResponseError

export const getPressReaderControllerListMagazinesUrl = () => {
  return `/api-arvore/press-reader/magazines`
}

export const pressReaderControllerListMagazines = async (
  options?: RequestInit
): Promise<pressReaderControllerListMagazinesResponse> => {
  return customInstance<pressReaderControllerListMagazinesResponse>(
    getPressReaderControllerListMagazinesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete a partner entity by reference ID
 */
export type partnerEntitiesControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type partnerEntitiesControllerDeleteResponse401 = {
  data: void
  status: 401
}

export type partnerEntitiesControllerDeleteResponse404 = {
  data: void
  status: 404
}

export type partnerEntitiesControllerDeleteResponse422 = {
  data: void
  status: 422
}

export type partnerEntitiesControllerDeleteResponseSuccess =
  partnerEntitiesControllerDeleteResponse204 & {
    headers: Headers
  }
export type partnerEntitiesControllerDeleteResponseError = (
  | partnerEntitiesControllerDeleteResponse401
  | partnerEntitiesControllerDeleteResponse404
  | partnerEntitiesControllerDeleteResponse422
) & {
  headers: Headers
}

export type partnerEntitiesControllerDeleteResponse =
  | partnerEntitiesControllerDeleteResponseSuccess
  | partnerEntitiesControllerDeleteResponseError

export const getPartnerEntitiesControllerDeleteUrl = (referenceId: string) => {
  return `/api-arvore/api/v2/partners/entities/${referenceId}`
}

export const partnerEntitiesControllerDelete = async (
  referenceId: string,
  options?: RequestInit
): Promise<partnerEntitiesControllerDeleteResponse> => {
  return customInstance<partnerEntitiesControllerDeleteResponse>(
    getPartnerEntitiesControllerDeleteUrl(referenceId),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Trigger Hub Educacional sync manually (Admin only)
 */
export type partnershipSyncControllerRunHubEducacionalSyncResponse201 = {
  data: void
  status: 201
}

export type partnershipSyncControllerRunHubEducacionalSyncResponseSuccess =
  partnershipSyncControllerRunHubEducacionalSyncResponse201 & {
    headers: Headers
  }
export type partnershipSyncControllerRunHubEducacionalSyncResponse =
  partnershipSyncControllerRunHubEducacionalSyncResponseSuccess

export const getPartnershipSyncControllerRunHubEducacionalSyncUrl = () => {
  return `/api-arvore/partnership-sync/hub-educacional/run`
}

export const partnershipSyncControllerRunHubEducacionalSync = async (
  options?: RequestInit
): Promise<partnershipSyncControllerRunHubEducacionalSyncResponse> => {
  return customInstance<partnershipSyncControllerRunHubEducacionalSyncResponse>(
    getPartnershipSyncControllerRunHubEducacionalSyncUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Trigger Hub Educacional sync for specific schools (Admin only)
 */
export type partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponse201 =
  {
    data: void
    status: 201
  }

export type partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponseSuccess =
  partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponse201 & {
    headers: Headers
  }
export type partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponse =
  partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponseSuccess

export const getPartnershipSyncControllerRunHubEducacionalSyncForSchoolsUrl =
  () => {
    return `/api-arvore/partnership-sync/hub-educacional/run/schools`
  }

export const partnershipSyncControllerRunHubEducacionalSyncForSchools = async (
  runSchoolsSyncBodyDto: RunSchoolsSyncBodyDto,
  options?: RequestInit
): Promise<partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponse> => {
  return customInstance<partnershipSyncControllerRunHubEducacionalSyncForSchoolsResponse>(
    getPartnershipSyncControllerRunHubEducacionalSyncForSchoolsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(runSchoolsSyncBodyDto)
    }
  )
}

/**
 * @summary Trigger LEX sync manually (Admin only)
 */
export type partnershipSyncControllerRunLexSyncResponse201 = {
  data: void
  status: 201
}

export type partnershipSyncControllerRunLexSyncResponseSuccess =
  partnershipSyncControllerRunLexSyncResponse201 & {
    headers: Headers
  }
export type partnershipSyncControllerRunLexSyncResponse =
  partnershipSyncControllerRunLexSyncResponseSuccess

export const getPartnershipSyncControllerRunLexSyncUrl = () => {
  return `/api-arvore/partnership-sync/lex/run`
}

export const partnershipSyncControllerRunLexSync = async (
  options?: RequestInit
): Promise<partnershipSyncControllerRunLexSyncResponse> => {
  return customInstance<partnershipSyncControllerRunLexSyncResponse>(
    getPartnershipSyncControllerRunLexSyncUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Trigger LEX sync for specific tenants (Admin only)
 */
export type partnershipSyncControllerRunLexSyncForTenantsResponse201 = {
  data: void
  status: 201
}

export type partnershipSyncControllerRunLexSyncForTenantsResponseSuccess =
  partnershipSyncControllerRunLexSyncForTenantsResponse201 & {
    headers: Headers
  }
export type partnershipSyncControllerRunLexSyncForTenantsResponse =
  partnershipSyncControllerRunLexSyncForTenantsResponseSuccess

export const getPartnershipSyncControllerRunLexSyncForTenantsUrl = () => {
  return `/api-arvore/partnership-sync/lex/run/tenants`
}

export const partnershipSyncControllerRunLexSyncForTenants = async (
  runLexSyncBodyDto: RunLexSyncBodyDto,
  options?: RequestInit
): Promise<partnershipSyncControllerRunLexSyncForTenantsResponse> => {
  return customInstance<partnershipSyncControllerRunLexSyncForTenantsResponse>(
    getPartnershipSyncControllerRunLexSyncForTenantsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(runLexSyncBodyDto)
    }
  )
}

/**
 * @summary Trigger ClassLink sync for a tenant synchronously (Admin only)
 */
export type partnershipSyncControllerRunClassLinkSyncResponse201 = {
  data: void
  status: 201
}

export type partnershipSyncControllerRunClassLinkSyncResponseSuccess =
  partnershipSyncControllerRunClassLinkSyncResponse201 & {
    headers: Headers
  }
export type partnershipSyncControllerRunClassLinkSyncResponse =
  partnershipSyncControllerRunClassLinkSyncResponseSuccess

export const getPartnershipSyncControllerRunClassLinkSyncUrl = () => {
  return `/api-arvore/partnership-sync/classlink/run`
}

export const partnershipSyncControllerRunClassLinkSync = async (
  options?: RequestInit
): Promise<partnershipSyncControllerRunClassLinkSyncResponse> => {
  return customInstance<partnershipSyncControllerRunClassLinkSyncResponse>(
    getPartnershipSyncControllerRunClassLinkSyncUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * Returns definitions for a word in the book language, optionally translated
 * @summary Look up a word definition
 */
export type dictionaryControllerDefinitionResponse200 = {
  data: GetDefinitionResponseDto
  status: 200
}

export type dictionaryControllerDefinitionResponseSuccess =
  dictionaryControllerDefinitionResponse200 & {
    headers: Headers
  }
export type dictionaryControllerDefinitionResponse =
  dictionaryControllerDefinitionResponseSuccess

export const getDictionaryControllerDefinitionUrl = () => {
  return `/api-arvore/dictionaries`
}

export const dictionaryControllerDefinition = async (
  getDefinitionBodyDto: GetDefinitionBodyDto,
  options?: RequestInit
): Promise<dictionaryControllerDefinitionResponse> => {
  return customInstance<dictionaryControllerDefinitionResponse>(
    getDictionaryControllerDefinitionUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(getDefinitionBodyDto)
    }
  )
}

/**
 * @summary Remove background from an image using remove.bg API
 */
export type personalAssetsControllerRemoveBackgroundHandlerResponse200 = {
  data: void
  status: 200
}

export type personalAssetsControllerRemoveBackgroundHandlerResponse400 = {
  data: void
  status: 400
}

export type personalAssetsControllerRemoveBackgroundHandlerResponse403 = {
  data: void
  status: 403
}

export type personalAssetsControllerRemoveBackgroundHandlerResponseSuccess =
  personalAssetsControllerRemoveBackgroundHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerRemoveBackgroundHandlerResponseError = (
  | personalAssetsControllerRemoveBackgroundHandlerResponse400
  | personalAssetsControllerRemoveBackgroundHandlerResponse403
) & {
  headers: Headers
}

export type personalAssetsControllerRemoveBackgroundHandlerResponse =
  | personalAssetsControllerRemoveBackgroundHandlerResponseSuccess
  | personalAssetsControllerRemoveBackgroundHandlerResponseError

export const getPersonalAssetsControllerRemoveBackgroundHandlerUrl = () => {
  return `/api-arvore/personal-assets/remove-bg`
}

export const personalAssetsControllerRemoveBackgroundHandler = async (
  personalAssetsControllerRemoveBackgroundHandlerBody: PersonalAssetsControllerRemoveBackgroundHandlerBody,
  options?: RequestInit
): Promise<personalAssetsControllerRemoveBackgroundHandlerResponse> => {
  const formData = new FormData()
  formData.append(
    `image`,
    personalAssetsControllerRemoveBackgroundHandlerBody.image
  )

  return customInstance<personalAssetsControllerRemoveBackgroundHandlerResponse>(
    getPersonalAssetsControllerRemoveBackgroundHandlerUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Submit photo and signature for approval
 */
export type personalAssetsControllerSubmitAssetRequestHandlerResponse201 = {
  data: AssetRequestResponseDto
  status: 201
}

export type personalAssetsControllerSubmitAssetRequestHandlerResponseSuccess =
  personalAssetsControllerSubmitAssetRequestHandlerResponse201 & {
    headers: Headers
  }
export type personalAssetsControllerSubmitAssetRequestHandlerResponse =
  personalAssetsControllerSubmitAssetRequestHandlerResponseSuccess

export const getPersonalAssetsControllerSubmitAssetRequestHandlerUrl = () => {
  return `/api-arvore/personal-assets/requests`
}

export const personalAssetsControllerSubmitAssetRequestHandler = async (
  personalAssetsControllerSubmitAssetRequestHandlerBody: PersonalAssetsControllerSubmitAssetRequestHandlerBody,
  options?: RequestInit
): Promise<personalAssetsControllerSubmitAssetRequestHandlerResponse> => {
  const formData = new FormData()
  formData.append(
    `photo`,
    personalAssetsControllerSubmitAssetRequestHandlerBody.photo
  )
  formData.append(
    `signature`,
    personalAssetsControllerSubmitAssetRequestHandlerBody.signature
  )
  formData.append(
    `name`,
    personalAssetsControllerSubmitAssetRequestHandlerBody.name
  )
  formData.append(
    `role`,
    personalAssetsControllerSubmitAssetRequestHandlerBody.role
  )
  formData.append(
    `area`,
    personalAssetsControllerSubmitAssetRequestHandlerBody.area
  )

  return customInstance<personalAssetsControllerSubmitAssetRequestHandlerResponse>(
    getPersonalAssetsControllerSubmitAssetRequestHandlerUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary List all asset requests (for approvers)
 */
export type personalAssetsControllerListAssetRequestsHandlerResponse200 = {
  data: PaginatedAssetRequestsResponseDto
  status: 200
}

export type personalAssetsControllerListAssetRequestsHandlerResponseSuccess =
  personalAssetsControllerListAssetRequestsHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerListAssetRequestsHandlerResponse =
  personalAssetsControllerListAssetRequestsHandlerResponseSuccess

export const getPersonalAssetsControllerListAssetRequestsHandlerUrl = (
  params?: PersonalAssetsControllerListAssetRequestsHandlerParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/personal-assets/requests?${stringifiedParams}`
    : `/api-arvore/personal-assets/requests`
}

export const personalAssetsControllerListAssetRequestsHandler = async (
  params?: PersonalAssetsControllerListAssetRequestsHandlerParams,
  options?: RequestInit
): Promise<personalAssetsControllerListAssetRequestsHandlerResponse> => {
  return customInstance<personalAssetsControllerListAssetRequestsHandlerResponse>(
    getPersonalAssetsControllerListAssetRequestsHandlerUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get current user asset requests
 */
export type personalAssetsControllerGetMyAssetRequestsHandlerResponse200 = {
  data: AssetRequestResponseDto[]
  status: 200
}

export type personalAssetsControllerGetMyAssetRequestsHandlerResponseSuccess =
  personalAssetsControllerGetMyAssetRequestsHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerGetMyAssetRequestsHandlerResponse =
  personalAssetsControllerGetMyAssetRequestsHandlerResponseSuccess

export const getPersonalAssetsControllerGetMyAssetRequestsHandlerUrl = () => {
  return `/api-arvore/personal-assets/requests/me`
}

export const personalAssetsControllerGetMyAssetRequestsHandler = async (
  options?: RequestInit
): Promise<personalAssetsControllerGetMyAssetRequestsHandlerResponse> => {
  return customInstance<personalAssetsControllerGetMyAssetRequestsHandlerResponse>(
    getPersonalAssetsControllerGetMyAssetRequestsHandlerUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Approve an asset request
 */
export type personalAssetsControllerApproveAssetRequestHandlerResponse200 = {
  data: AssetRequestResponseDto
  status: 200
}

export type personalAssetsControllerApproveAssetRequestHandlerResponseSuccess =
  personalAssetsControllerApproveAssetRequestHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerApproveAssetRequestHandlerResponse =
  personalAssetsControllerApproveAssetRequestHandlerResponseSuccess

export const getPersonalAssetsControllerApproveAssetRequestHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/approve`
}

export const personalAssetsControllerApproveAssetRequestHandler = async (
  id: string,
  options?: RequestInit
): Promise<personalAssetsControllerApproveAssetRequestHandlerResponse> => {
  return customInstance<personalAssetsControllerApproveAssetRequestHandlerResponse>(
    getPersonalAssetsControllerApproveAssetRequestHandlerUrl(id),
    {
      ...options,
      method: 'PATCH'
    }
  )
}

/**
 * @summary Reject an asset request
 */
export type personalAssetsControllerRejectAssetRequestHandlerResponse200 = {
  data: AssetRequestResponseDto
  status: 200
}

export type personalAssetsControllerRejectAssetRequestHandlerResponseSuccess =
  personalAssetsControllerRejectAssetRequestHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerRejectAssetRequestHandlerResponse =
  personalAssetsControllerRejectAssetRequestHandlerResponseSuccess

export const getPersonalAssetsControllerRejectAssetRequestHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/reject`
}

export const personalAssetsControllerRejectAssetRequestHandler = async (
  id: string,
  rejectAssetRequestDto: RejectAssetRequestDto,
  options?: RequestInit
): Promise<personalAssetsControllerRejectAssetRequestHandlerResponse> => {
  return customInstance<personalAssetsControllerRejectAssetRequestHandlerResponse>(
    getPersonalAssetsControllerRejectAssetRequestHandlerUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(rejectAssetRequestDto)
    }
  )
}

/**
 * @summary Get signed download URLs for approved assets
 */
export type personalAssetsControllerGetAssetDownloadUrlsHandlerResponse200 = {
  data: AssetDownloadUrlsResponseDto
  status: 200
}

export type personalAssetsControllerGetAssetDownloadUrlsHandlerResponseSuccess =
  personalAssetsControllerGetAssetDownloadUrlsHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerGetAssetDownloadUrlsHandlerResponse =
  personalAssetsControllerGetAssetDownloadUrlsHandlerResponseSuccess

export const getPersonalAssetsControllerGetAssetDownloadUrlsHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/download`
}

export const personalAssetsControllerGetAssetDownloadUrlsHandler = async (
  id: string,
  options?: RequestInit
): Promise<personalAssetsControllerGetAssetDownloadUrlsHandlerResponse> => {
  return customInstance<personalAssetsControllerGetAssetDownloadUrlsHandlerResponse>(
    getPersonalAssetsControllerGetAssetDownloadUrlsHandlerUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Get signed preview URLs for asset request (admin only, no ownership check)
 */
export type personalAssetsControllerGetAssetPreviewUrlsHandlerResponse200 = {
  data: AssetDownloadUrlsResponseDto
  status: 200
}

export type personalAssetsControllerGetAssetPreviewUrlsHandlerResponseSuccess =
  personalAssetsControllerGetAssetPreviewUrlsHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerGetAssetPreviewUrlsHandlerResponse =
  personalAssetsControllerGetAssetPreviewUrlsHandlerResponseSuccess

export const getPersonalAssetsControllerGetAssetPreviewUrlsHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/preview`
}

export const personalAssetsControllerGetAssetPreviewUrlsHandler = async (
  id: string,
  options?: RequestInit
): Promise<personalAssetsControllerGetAssetPreviewUrlsHandlerResponse> => {
  return customInstance<personalAssetsControllerGetAssetPreviewUrlsHandlerResponse>(
    getPersonalAssetsControllerGetAssetPreviewUrlsHandlerUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Batch submit assets for multiple people
 */
export type personalAssetsControllerBatchSubmitHandlerResponse201 = {
  data: void
  status: 201
}

export type personalAssetsControllerBatchSubmitHandlerResponseSuccess =
  personalAssetsControllerBatchSubmitHandlerResponse201 & {
    headers: Headers
  }
export type personalAssetsControllerBatchSubmitHandlerResponse =
  personalAssetsControllerBatchSubmitHandlerResponseSuccess

export const getPersonalAssetsControllerBatchSubmitHandlerUrl = () => {
  return `/api-arvore/personal-assets/requests/batch`
}

export const personalAssetsControllerBatchSubmitHandler = async (
  personalAssetsControllerBatchSubmitHandlerBody: PersonalAssetsControllerBatchSubmitHandlerBody,
  options?: RequestInit
): Promise<personalAssetsControllerBatchSubmitHandlerResponse> => {
  const formData = new FormData()
  formData.append(`items`, personalAssetsControllerBatchSubmitHandlerBody.items)

  return customInstance<personalAssetsControllerBatchSubmitHandlerResponse>(
    getPersonalAssetsControllerBatchSubmitHandlerUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary Download profile photo with area background color
 */
export type personalAssetsControllerGetAreaColoredPhotoHandlerResponse200 = {
  data: void
  status: 200
}

export type personalAssetsControllerGetAreaColoredPhotoHandlerResponseSuccess =
  personalAssetsControllerGetAreaColoredPhotoHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerGetAreaColoredPhotoHandlerResponse =
  personalAssetsControllerGetAreaColoredPhotoHandlerResponseSuccess

export const getPersonalAssetsControllerGetAreaColoredPhotoHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/colored-photo`
}

export const personalAssetsControllerGetAreaColoredPhotoHandler = async (
  id: string,
  options?: RequestInit
): Promise<personalAssetsControllerGetAreaColoredPhotoHandlerResponse> => {
  return customInstance<personalAssetsControllerGetAreaColoredPhotoHandlerResponse>(
    getPersonalAssetsControllerGetAreaColoredPhotoHandlerUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Download profile photo with institutional background color
 */
export type personalAssetsControllerGetInstitutionalPhotoHandlerResponse200 = {
  data: void
  status: 200
}

export type personalAssetsControllerGetInstitutionalPhotoHandlerResponseSuccess =
  personalAssetsControllerGetInstitutionalPhotoHandlerResponse200 & {
    headers: Headers
  }
export type personalAssetsControllerGetInstitutionalPhotoHandlerResponse =
  personalAssetsControllerGetInstitutionalPhotoHandlerResponseSuccess

export const getPersonalAssetsControllerGetInstitutionalPhotoHandlerUrl = (
  id: string
) => {
  return `/api-arvore/personal-assets/requests/${id}/institutional-photo`
}

export const personalAssetsControllerGetInstitutionalPhotoHandler = async (
  id: string,
  options?: RequestInit
): Promise<personalAssetsControllerGetInstitutionalPhotoHandlerResponse> => {
  return customInstance<personalAssetsControllerGetInstitutionalPhotoHandlerResponse>(
    getPersonalAssetsControllerGetInstitutionalPhotoHandlerUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update price for a single book or audiobook by ISBN
 */
export type priceUpdateControllerSingleResponse201 = {
  data: void
  status: 201
}

export type priceUpdateControllerSingleResponseSuccess =
  priceUpdateControllerSingleResponse201 & {
    headers: Headers
  }
export type priceUpdateControllerSingleResponse =
  priceUpdateControllerSingleResponseSuccess

export const getPriceUpdateControllerSingleUrl = () => {
  return `/api-arvore/backoffice/price-update/single`
}

export const priceUpdateControllerSingle = async (
  updatePriceEntryDto: UpdatePriceEntryDto,
  options?: RequestInit
): Promise<priceUpdateControllerSingleResponse> => {
  return customInstance<priceUpdateControllerSingleResponse>(
    getPriceUpdateControllerSingleUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updatePriceEntryDto)
    }
  )
}

/**
 * @summary Update prices for multiple books/audiobooks by ISBN
 */
export type priceUpdateControllerBatchResponse201 = {
  data: void
  status: 201
}

export type priceUpdateControllerBatchResponseSuccess =
  priceUpdateControllerBatchResponse201 & {
    headers: Headers
  }
export type priceUpdateControllerBatchResponse =
  priceUpdateControllerBatchResponseSuccess

export const getPriceUpdateControllerBatchUrl = () => {
  return `/api-arvore/backoffice/price-update/batch`
}

export const priceUpdateControllerBatch = async (
  updatePriceBatchDto: UpdatePriceBatchDto,
  options?: RequestInit
): Promise<priceUpdateControllerBatchResponse> => {
  return customInstance<priceUpdateControllerBatchResponse>(
    getPriceUpdateControllerBatchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updatePriceBatchDto)
    }
  )
}

/**
 * @summary Generate announcement text using AI
 */
export type launchAnnouncerControllerGenerateTextHandlerResponse201 = {
  data: void
  status: 201
}

export type launchAnnouncerControllerGenerateTextHandlerResponseSuccess =
  launchAnnouncerControllerGenerateTextHandlerResponse201 & {
    headers: Headers
  }
export type launchAnnouncerControllerGenerateTextHandlerResponse =
  launchAnnouncerControllerGenerateTextHandlerResponseSuccess

export const getLaunchAnnouncerControllerGenerateTextHandlerUrl = () => {
  return `/api-arvore/launch-announcer/generate-text`
}

export const launchAnnouncerControllerGenerateTextHandler = async (
  generateTextDto: GenerateTextDto,
  options?: RequestInit
): Promise<launchAnnouncerControllerGenerateTextHandlerResponse> => {
  return customInstance<launchAnnouncerControllerGenerateTextHandlerResponse>(
    getLaunchAnnouncerControllerGenerateTextHandlerUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(generateTextDto)
    }
  )
}

/**
 * @summary Create a draft announcement
 */
export type launchAnnouncerControllerCreateHandlerResponse201 = {
  data: void
  status: 201
}

export type launchAnnouncerControllerCreateHandlerResponseSuccess =
  launchAnnouncerControllerCreateHandlerResponse201 & {
    headers: Headers
  }
export type launchAnnouncerControllerCreateHandlerResponse =
  launchAnnouncerControllerCreateHandlerResponseSuccess

export const getLaunchAnnouncerControllerCreateHandlerUrl = () => {
  return `/api-arvore/launch-announcer`
}

export const launchAnnouncerControllerCreateHandler = async (
  createAnnouncementDto: CreateAnnouncementDto,
  options?: RequestInit
): Promise<launchAnnouncerControllerCreateHandlerResponse> => {
  return customInstance<launchAnnouncerControllerCreateHandlerResponse>(
    getLaunchAnnouncerControllerCreateHandlerUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createAnnouncementDto)
    }
  )
}

/**
 * @summary List announcements with pagination and status filter
 */
export type launchAnnouncerControllerListHandlerResponse200 = {
  data: void
  status: 200
}

export type launchAnnouncerControllerListHandlerResponseSuccess =
  launchAnnouncerControllerListHandlerResponse200 & {
    headers: Headers
  }
export type launchAnnouncerControllerListHandlerResponse =
  launchAnnouncerControllerListHandlerResponseSuccess

export const getLaunchAnnouncerControllerListHandlerUrl = (
  params?: LaunchAnnouncerControllerListHandlerParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/launch-announcer?${stringifiedParams}`
    : `/api-arvore/launch-announcer`
}

export const launchAnnouncerControllerListHandler = async (
  params?: LaunchAnnouncerControllerListHandlerParams,
  options?: RequestInit
): Promise<launchAnnouncerControllerListHandlerResponse> => {
  return customInstance<launchAnnouncerControllerListHandlerResponse>(
    getLaunchAnnouncerControllerListHandlerUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update a draft announcement
 */
export type launchAnnouncerControllerUpdateHandlerResponse200 = {
  data: void
  status: 200
}

export type launchAnnouncerControllerUpdateHandlerResponseSuccess =
  launchAnnouncerControllerUpdateHandlerResponse200 & {
    headers: Headers
  }
export type launchAnnouncerControllerUpdateHandlerResponse =
  launchAnnouncerControllerUpdateHandlerResponseSuccess

export const getLaunchAnnouncerControllerUpdateHandlerUrl = (id: string) => {
  return `/api-arvore/launch-announcer/${id}`
}

export const launchAnnouncerControllerUpdateHandler = async (
  id: string,
  updateAnnouncementDto: UpdateAnnouncementDto,
  options?: RequestInit
): Promise<launchAnnouncerControllerUpdateHandlerResponse> => {
  return customInstance<launchAnnouncerControllerUpdateHandlerResponse>(
    getLaunchAnnouncerControllerUpdateHandlerUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateAnnouncementDto)
    }
  )
}

/**
 * @summary Get a single announcement
 */
export type launchAnnouncerControllerGetHandlerResponse200 = {
  data: void
  status: 200
}

export type launchAnnouncerControllerGetHandlerResponseSuccess =
  launchAnnouncerControllerGetHandlerResponse200 & {
    headers: Headers
  }
export type launchAnnouncerControllerGetHandlerResponse =
  launchAnnouncerControllerGetHandlerResponseSuccess

export const getLaunchAnnouncerControllerGetHandlerUrl = (id: string) => {
  return `/api-arvore/launch-announcer/${id}`
}

export const launchAnnouncerControllerGetHandler = async (
  id: string,
  options?: RequestInit
): Promise<launchAnnouncerControllerGetHandlerResponse> => {
  return customInstance<launchAnnouncerControllerGetHandlerResponse>(
    getLaunchAnnouncerControllerGetHandlerUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Delete a draft announcement
 */
export type launchAnnouncerControllerDeleteHandlerResponse200 = {
  data: void
  status: 200
}

export type launchAnnouncerControllerDeleteHandlerResponseSuccess =
  launchAnnouncerControllerDeleteHandlerResponse200 & {
    headers: Headers
  }
export type launchAnnouncerControllerDeleteHandlerResponse =
  launchAnnouncerControllerDeleteHandlerResponseSuccess

export const getLaunchAnnouncerControllerDeleteHandlerUrl = (id: string) => {
  return `/api-arvore/launch-announcer/${id}`
}

export const launchAnnouncerControllerDeleteHandler = async (
  id: string,
  options?: RequestInit
): Promise<launchAnnouncerControllerDeleteHandlerResponse> => {
  return customInstance<launchAnnouncerControllerDeleteHandlerResponse>(
    getLaunchAnnouncerControllerDeleteHandlerUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * @summary Publish announcement to Slack
 */
export type launchAnnouncerControllerPublishHandlerResponse201 = {
  data: void
  status: 201
}

export type launchAnnouncerControllerPublishHandlerResponseSuccess =
  launchAnnouncerControllerPublishHandlerResponse201 & {
    headers: Headers
  }
export type launchAnnouncerControllerPublishHandlerResponse =
  launchAnnouncerControllerPublishHandlerResponseSuccess

export const getLaunchAnnouncerControllerPublishHandlerUrl = (id: string) => {
  return `/api-arvore/launch-announcer/${id}/publish`
}

export const launchAnnouncerControllerPublishHandler = async (
  id: string,
  options?: RequestInit
): Promise<launchAnnouncerControllerPublishHandlerResponse> => {
  return customInstance<launchAnnouncerControllerPublishHandlerResponse>(
    getLaunchAnnouncerControllerPublishHandlerUrl(id),
    {
      ...options,
      method: 'POST'
    }
  )
}

/**
 * @summary Upload media file to S3
 */
export type launchAnnouncerControllerUploadHandlerResponse201 = {
  data: void
  status: 201
}

export type launchAnnouncerControllerUploadHandlerResponseSuccess =
  launchAnnouncerControllerUploadHandlerResponse201 & {
    headers: Headers
  }
export type launchAnnouncerControllerUploadHandlerResponse =
  launchAnnouncerControllerUploadHandlerResponseSuccess

export const getLaunchAnnouncerControllerUploadHandlerUrl = () => {
  return `/api-arvore/launch-announcer/upload`
}

export const launchAnnouncerControllerUploadHandler = async (
  launchAnnouncerControllerUploadHandlerBody: LaunchAnnouncerControllerUploadHandlerBody,
  options?: RequestInit
): Promise<launchAnnouncerControllerUploadHandlerResponse> => {
  const formData = new FormData()
  formData.append(`file`, launchAnnouncerControllerUploadHandlerBody.file)

  return customInstance<launchAnnouncerControllerUploadHandlerResponse>(
    getLaunchAnnouncerControllerUploadHandlerUrl(),
    {
      ...options,
      method: 'POST',
      body: formData
    }
  )
}

/**
 * @summary JWKS endpoint with the public keys used to sign LTI tool requests
 */
export type ltiJwksControllerJwksResponse200 = {
  data: void
  status: 200
}

export type ltiJwksControllerJwksResponseSuccess =
  ltiJwksControllerJwksResponse200 & {
    headers: Headers
  }
export type ltiJwksControllerJwksResponse = ltiJwksControllerJwksResponseSuccess

export const getLtiJwksControllerJwksUrl = () => {
  return `/api-arvore/lti/.well-known/jwks.json`
}

export const ltiJwksControllerJwks = async (
  options?: RequestInit
): Promise<ltiJwksControllerJwksResponse> => {
  return customInstance<ltiJwksControllerJwksResponse>(
    getLtiJwksControllerJwksUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary OIDC Login Initiation (GET form, used by some LMS Platforms)
 */
export type ltiLoginControllerLoginGetResponse302 = {
  data: void
  status: 302
}

export type ltiLoginControllerLoginGetResponse400 = {
  data: void
  status: 400
}

export type ltiLoginControllerLoginGetResponse404 = {
  data: void
  status: 404
}
export type ltiLoginControllerLoginGetResponseError = (
  | ltiLoginControllerLoginGetResponse302
  | ltiLoginControllerLoginGetResponse400
  | ltiLoginControllerLoginGetResponse404
) & {
  headers: Headers
}

export type ltiLoginControllerLoginGetResponse =
  ltiLoginControllerLoginGetResponseError

export const getLtiLoginControllerLoginGetUrl = (
  params: LtiLoginControllerLoginGetParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/lti/login?${stringifiedParams}`
    : `/api-arvore/lti/login`
}

export const ltiLoginControllerLoginGet = async (
  params: LtiLoginControllerLoginGetParams,
  options?: RequestInit
): Promise<ltiLoginControllerLoginGetResponse> => {
  return customInstance<ltiLoginControllerLoginGetResponse>(
    getLtiLoginControllerLoginGetUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary OIDC Login Initiation (POST form, used by most LMS Platforms)
 */
export type ltiLoginControllerLoginPostResponse302 = {
  data: void
  status: 302
}

export type ltiLoginControllerLoginPostResponse400 = {
  data: void
  status: 400
}

export type ltiLoginControllerLoginPostResponse404 = {
  data: void
  status: 404
}
export type ltiLoginControllerLoginPostResponseError = (
  | ltiLoginControllerLoginPostResponse302
  | ltiLoginControllerLoginPostResponse400
  | ltiLoginControllerLoginPostResponse404
) & {
  headers: Headers
}

export type ltiLoginControllerLoginPostResponse =
  ltiLoginControllerLoginPostResponseError

export const getLtiLoginControllerLoginPostUrl = () => {
  return `/api-arvore/lti/login`
}

export const ltiLoginControllerLoginPost = async (
  ltiLoginQueryDto: LtiLoginQueryDto,
  options?: RequestInit
): Promise<ltiLoginControllerLoginPostResponse> => {
  return customInstance<ltiLoginControllerLoginPostResponse>(
    getLtiLoginControllerLoginPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(ltiLoginQueryDto)
    }
  )
}

/**
 * @summary LTI 1.3 Resource Link Launch endpoint. Validates the id_token and exchanges it for an Árvore session redirect.
 */
export type ltiLaunchControllerLaunchResponse302 = {
  data: void
  status: 302
}

export type ltiLaunchControllerLaunchResponse400 = {
  data: void
  status: 400
}

export type ltiLaunchControllerLaunchResponse401 = {
  data: void
  status: 401
}

export type ltiLaunchControllerLaunchResponse404 = {
  data: void
  status: 404
}
export type ltiLaunchControllerLaunchResponseError = (
  | ltiLaunchControllerLaunchResponse302
  | ltiLaunchControllerLaunchResponse400
  | ltiLaunchControllerLaunchResponse401
  | ltiLaunchControllerLaunchResponse404
) & {
  headers: Headers
}

export type ltiLaunchControllerLaunchResponse =
  ltiLaunchControllerLaunchResponseError

export const getLtiLaunchControllerLaunchUrl = () => {
  return `/api-arvore/lti/launch`
}

export const ltiLaunchControllerLaunch = async (
  ltiLaunchBodyDto: LtiLaunchBodyDto,
  options?: RequestInit
): Promise<ltiLaunchControllerLaunchResponse> => {
  return customInstance<ltiLaunchControllerLaunchResponse>(
    getLtiLaunchControllerLaunchUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(ltiLaunchBodyDto)
    }
  )
}

/**
 * @summary List all LTI platforms
 */
export type ltiPlatformsBackofficeControllerListResponse200 = {
  data: LtiPlatformResponseDto[]
  status: 200
}

export type ltiPlatformsBackofficeControllerListResponseSuccess =
  ltiPlatformsBackofficeControllerListResponse200 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerListResponse =
  ltiPlatformsBackofficeControllerListResponseSuccess

export const getLtiPlatformsBackofficeControllerListUrl = () => {
  return `/api-arvore/backoffice/lti-platforms`
}

export const ltiPlatformsBackofficeControllerList = async (
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerListResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerListResponse>(
    getLtiPlatformsBackofficeControllerListUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Register a new LTI platform
 */
export type ltiPlatformsBackofficeControllerCreateResponse201 = {
  data: LtiPlatformResponseDto
  status: 201
}

export type ltiPlatformsBackofficeControllerCreateResponseSuccess =
  ltiPlatformsBackofficeControllerCreateResponse201 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerCreateResponse =
  ltiPlatformsBackofficeControllerCreateResponseSuccess

export const getLtiPlatformsBackofficeControllerCreateUrl = () => {
  return `/api-arvore/backoffice/lti-platforms`
}

export const ltiPlatformsBackofficeControllerCreate = async (
  createLtiPlatformDto: CreateLtiPlatformDto,
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerCreateResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerCreateResponse>(
    getLtiPlatformsBackofficeControllerCreateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createLtiPlatformDto)
    }
  )
}

/**
 * @summary Get a single LTI platform by ID
 */
export type ltiPlatformsBackofficeControllerGetResponse200 = {
  data: LtiPlatformResponseDto
  status: 200
}

export type ltiPlatformsBackofficeControllerGetResponseSuccess =
  ltiPlatformsBackofficeControllerGetResponse200 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerGetResponse =
  ltiPlatformsBackofficeControllerGetResponseSuccess

export const getLtiPlatformsBackofficeControllerGetUrl = (id: number) => {
  return `/api-arvore/backoffice/lti-platforms/${id}`
}

export const ltiPlatformsBackofficeControllerGet = async (
  id: number,
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerGetResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerGetResponse>(
    getLtiPlatformsBackofficeControllerGetUrl(id),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Update an LTI platform
 */
export type ltiPlatformsBackofficeControllerUpdateResponse200 = {
  data: LtiPlatformResponseDto
  status: 200
}

export type ltiPlatformsBackofficeControllerUpdateResponseSuccess =
  ltiPlatformsBackofficeControllerUpdateResponse200 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerUpdateResponse =
  ltiPlatformsBackofficeControllerUpdateResponseSuccess

export const getLtiPlatformsBackofficeControllerUpdateUrl = (id: number) => {
  return `/api-arvore/backoffice/lti-platforms/${id}`
}

export const ltiPlatformsBackofficeControllerUpdate = async (
  id: number,
  updateLtiPlatformDto: UpdateLtiPlatformDto,
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerUpdateResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerUpdateResponse>(
    getLtiPlatformsBackofficeControllerUpdateUrl(id),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateLtiPlatformDto)
    }
  )
}

/**
 * @summary Delete an LTI platform
 */
export type ltiPlatformsBackofficeControllerRemoveResponse204 = {
  data: void
  status: 204
}

export type ltiPlatformsBackofficeControllerRemoveResponseSuccess =
  ltiPlatformsBackofficeControllerRemoveResponse204 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerRemoveResponse =
  ltiPlatformsBackofficeControllerRemoveResponseSuccess

export const getLtiPlatformsBackofficeControllerRemoveUrl = (id: number) => {
  return `/api-arvore/backoffice/lti-platforms/${id}`
}

export const ltiPlatformsBackofficeControllerRemove = async (
  id: number,
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerRemoveResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerRemoveResponse>(
    getLtiPlatformsBackofficeControllerRemoveUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

/**
 * CSV must have header row with columns: name, issuer, client_id, deployment_id, auth_login_url, auth_token_url, jwks_url, b2b_subscription_account_id, school_entity_id. Existing platforms (matching issuer/client_id/deployment_id) are skipped.
 * @summary Bulk register LTI platforms from a CSV payload
 */
export type ltiPlatformsBackofficeControllerImportResponse200 = {
  data: ImportLtiPlatformsResultDto
  status: 200
}

export type ltiPlatformsBackofficeControllerImportResponseSuccess =
  ltiPlatformsBackofficeControllerImportResponse200 & {
    headers: Headers
  }
export type ltiPlatformsBackofficeControllerImportResponse =
  ltiPlatformsBackofficeControllerImportResponseSuccess

export const getLtiPlatformsBackofficeControllerImportUrl = () => {
  return `/api-arvore/backoffice/lti-platforms/import`
}

export const ltiPlatformsBackofficeControllerImport = async (
  importLtiPlatformsDto: ImportLtiPlatformsDto,
  options?: RequestInit
): Promise<ltiPlatformsBackofficeControllerImportResponse> => {
  return customInstance<ltiPlatformsBackofficeControllerImportResponse>(
    getLtiPlatformsBackofficeControllerImportUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(importLtiPlatformsDto)
    }
  )
}

export type totpControllerSendCodeResponse201 = {
  data: void
  status: 201
}

export type totpControllerSendCodeResponseSuccess =
  totpControllerSendCodeResponse201 & {
    headers: Headers
  }
export type totpControllerSendCodeResponse =
  totpControllerSendCodeResponseSuccess

export const getTotpControllerSendCodeUrl = () => {
  return `/api-arvore/totp/send-code`
}

export const totpControllerSendCode = async (
  options?: RequestInit
): Promise<totpControllerSendCodeResponse> => {
  return customInstance<totpControllerSendCodeResponse>(
    getTotpControllerSendCodeUrl(),
    {
      ...options,
      method: 'POST'
    }
  )
}

export type totpControllerVerifyCodeResponse201 = {
  data: void
  status: 201
}

export type totpControllerVerifyCodeResponseSuccess =
  totpControllerVerifyCodeResponse201 & {
    headers: Headers
  }
export type totpControllerVerifyCodeResponse =
  totpControllerVerifyCodeResponseSuccess

export const getTotpControllerVerifyCodeUrl = () => {
  return `/api-arvore/totp/verify-code`
}

export const totpControllerVerifyCode = async (
  verifyCodeDto: VerifyCodeDto,
  options?: RequestInit
): Promise<totpControllerVerifyCodeResponse> => {
  return customInstance<totpControllerVerifyCodeResponse>(
    getTotpControllerVerifyCodeUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(verifyCodeDto)
    }
  )
}

export type totpControllerGetStatusResponse200 = {
  data: void
  status: 200
}

export type totpControllerGetStatusResponseSuccess =
  totpControllerGetStatusResponse200 & {
    headers: Headers
  }
export type totpControllerGetStatusResponse =
  totpControllerGetStatusResponseSuccess

export const getTotpControllerGetStatusUrl = () => {
  return `/api-arvore/totp/status`
}

export const totpControllerGetStatus = async (
  options?: RequestInit
): Promise<totpControllerGetStatusResponse> => {
  return customInstance<totpControllerGetStatusResponse>(
    getTotpControllerGetStatusUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type totpControllerListDevicesResponse200 = {
  data: void
  status: 200
}

export type totpControllerListDevicesResponseSuccess =
  totpControllerListDevicesResponse200 & {
    headers: Headers
  }
export type totpControllerListDevicesResponse =
  totpControllerListDevicesResponseSuccess

export const getTotpControllerListDevicesUrl = () => {
  return `/api-arvore/totp/devices`
}

export const totpControllerListDevices = async (
  options?: RequestInit
): Promise<totpControllerListDevicesResponse> => {
  return customInstance<totpControllerListDevicesResponse>(
    getTotpControllerListDevicesUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

export type totpControllerSetupDeviceResponse201 = {
  data: void
  status: 201
}

export type totpControllerSetupDeviceResponseSuccess =
  totpControllerSetupDeviceResponse201 & {
    headers: Headers
  }
export type totpControllerSetupDeviceResponse =
  totpControllerSetupDeviceResponseSuccess

export const getTotpControllerSetupDeviceUrl = () => {
  return `/api-arvore/totp/devices/setup`
}

export const totpControllerSetupDevice = async (
  setupDeviceDto: SetupDeviceDto,
  options?: RequestInit
): Promise<totpControllerSetupDeviceResponse> => {
  return customInstance<totpControllerSetupDeviceResponse>(
    getTotpControllerSetupDeviceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setupDeviceDto)
    }
  )
}

export type totpControllerConfirmDeviceResponse201 = {
  data: void
  status: 201
}

export type totpControllerConfirmDeviceResponseSuccess =
  totpControllerConfirmDeviceResponse201 & {
    headers: Headers
  }
export type totpControllerConfirmDeviceResponse =
  totpControllerConfirmDeviceResponseSuccess

export const getTotpControllerConfirmDeviceUrl = (id: string) => {
  return `/api-arvore/totp/devices/${id}/confirm`
}

export const totpControllerConfirmDevice = async (
  id: string,
  confirmDeviceDto: ConfirmDeviceDto,
  options?: RequestInit
): Promise<totpControllerConfirmDeviceResponse> => {
  return customInstance<totpControllerConfirmDeviceResponse>(
    getTotpControllerConfirmDeviceUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(confirmDeviceDto)
    }
  )
}

export type totpControllerDeleteDeviceResponse204 = {
  data: void
  status: 204
}

export type totpControllerDeleteDeviceResponseSuccess =
  totpControllerDeleteDeviceResponse204 & {
    headers: Headers
  }
export type totpControllerDeleteDeviceResponse =
  totpControllerDeleteDeviceResponseSuccess

export const getTotpControllerDeleteDeviceUrl = (id: string) => {
  return `/api-arvore/totp/devices/${id}`
}

export const totpControllerDeleteDevice = async (
  id: string,
  options?: RequestInit
): Promise<totpControllerDeleteDeviceResponse> => {
  return customInstance<totpControllerDeleteDeviceResponse>(
    getTotpControllerDeleteDeviceUrl(id),
    {
      ...options,
      method: 'DELETE'
    }
  )
}

export type totpControllerGetSetupStatusResponse200 = {
  data: void
  status: 200
}

export type totpControllerGetSetupStatusResponseSuccess =
  totpControllerGetSetupStatusResponse200 & {
    headers: Headers
  }
export type totpControllerGetSetupStatusResponse =
  totpControllerGetSetupStatusResponseSuccess

export const getTotpControllerGetSetupStatusUrl = () => {
  return `/api-arvore/totp/setup-status`
}

export const totpControllerGetSetupStatus = async (
  options?: RequestInit
): Promise<totpControllerGetSetupStatusResponse> => {
  return customInstance<totpControllerGetSetupStatusResponse>(
    getTotpControllerGetSetupStatusUrl(),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Busca usuário por email, token, nome, escola ou turma
 */
export type supportControllerUserLookupResponse200 = {
  data: void
  status: 200
}

export type supportControllerUserLookupResponseSuccess =
  supportControllerUserLookupResponse200 & {
    headers: Headers
  }
export type supportControllerUserLookupResponse =
  supportControllerUserLookupResponseSuccess

export const getSupportControllerUserLookupUrl = (
  params?: SupportControllerUserLookupParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/support/user-lookup?${stringifiedParams}`
    : `/api-arvore/support/user-lookup`
}

export const supportControllerUserLookup = async (
  params?: SupportControllerUserLookupParams,
  options?: RequestInit
): Promise<supportControllerUserLookupResponse> => {
  return customInstance<supportControllerUserLookupResponse>(
    getSupportControllerUserLookupUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Verifica status completo do perfil de um usuário
 */
export type supportControllerProfileStatusResponse200 = {
  data: void
  status: 200
}

export type supportControllerProfileStatusResponseSuccess =
  supportControllerProfileStatusResponse200 & {
    headers: Headers
  }
export type supportControllerProfileStatusResponse =
  supportControllerProfileStatusResponseSuccess

export const getSupportControllerProfileStatusUrl = (
  params: SupportControllerProfileStatusParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/support/profile-status?${stringifiedParams}`
    : `/api-arvore/support/profile-status`
}

export const supportControllerProfileStatus = async (
  params: SupportControllerProfileStatusParams,
  options?: RequestInit
): Promise<supportControllerProfileStatusResponse> => {
  return customInstance<supportControllerProfileStatusResponse>(
    getSupportControllerProfileStatusUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Verifica se usuário/entidade usa integração com parceiro
 */
export type supportControllerDetectIntegrationResponse200 = {
  data: void
  status: 200
}

export type supportControllerDetectIntegrationResponseSuccess =
  supportControllerDetectIntegrationResponse200 & {
    headers: Headers
  }
export type supportControllerDetectIntegrationResponse =
  supportControllerDetectIntegrationResponseSuccess

export const getSupportControllerDetectIntegrationUrl = (
  params?: SupportControllerDetectIntegrationParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/support/detect-integration?${stringifiedParams}`
    : `/api-arvore/support/detect-integration`
}

export const supportControllerDetectIntegration = async (
  params?: SupportControllerDetectIntegrationParams,
  options?: RequestInit
): Promise<supportControllerDetectIntegrationResponse> => {
  return customInstance<supportControllerDetectIntegrationResponse>(
    getSupportControllerDetectIntegrationUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Retorna credenciais de acordo com login_type da entidade
 */
export type supportControllerGetCredentialsResponse200 = {
  data: void
  status: 200
}

export type supportControllerGetCredentialsResponseSuccess =
  supportControllerGetCredentialsResponse200 & {
    headers: Headers
  }
export type supportControllerGetCredentialsResponse =
  supportControllerGetCredentialsResponseSuccess

export const getSupportControllerGetCredentialsUrl = (
  params: SupportControllerGetCredentialsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api-arvore/support/get-credentials?${stringifiedParams}`
    : `/api-arvore/support/get-credentials`
}

export const supportControllerGetCredentials = async (
  params: SupportControllerGetCredentialsParams,
  options?: RequestInit
): Promise<supportControllerGetCredentialsResponse> => {
  return customInstance<supportControllerGetCredentialsResponse>(
    getSupportControllerGetCredentialsUrl(params),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Move perfil para outra entidade (mesmo nível, mesma rede)
 */
export type supportControllerMoveProfileResponse201 = {
  data: void
  status: 201
}

export type supportControllerMoveProfileResponseSuccess =
  supportControllerMoveProfileResponse201 & {
    headers: Headers
  }
export type supportControllerMoveProfileResponse =
  supportControllerMoveProfileResponseSuccess

export const getSupportControllerMoveProfileUrl = () => {
  return `/api-arvore/support/move-profile`
}

export const supportControllerMoveProfile = async (
  moveProfileBodyDto: MoveProfileBodyDto,
  options?: RequestInit
): Promise<supportControllerMoveProfileResponse> => {
  return customInstance<supportControllerMoveProfileResponse>(
    getSupportControllerMoveProfileUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(moveProfileBodyDto)
    }
  )
}

/**
 * @summary Reativa perfil desativado ou cria novo
 */
export type supportControllerReactivateProfileResponse201 = {
  data: void
  status: 201
}

export type supportControllerReactivateProfileResponseSuccess =
  supportControllerReactivateProfileResponse201 & {
    headers: Headers
  }
export type supportControllerReactivateProfileResponse =
  supportControllerReactivateProfileResponseSuccess

export const getSupportControllerReactivateProfileUrl = () => {
  return `/api-arvore/support/reactivate-profile`
}

export const supportControllerReactivateProfile = async (
  reactivateProfileBodyDto: ReactivateProfileBodyDto,
  options?: RequestInit
): Promise<supportControllerReactivateProfileResponse> => {
  return customInstance<supportControllerReactivateProfileResponse>(
    getSupportControllerReactivateProfileUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(reactivateProfileBodyDto)
    }
  )
}

/**
 * @summary Corrige email do usuário
 */
export type supportControllerFixEmailResponse201 = {
  data: void
  status: 201
}

export type supportControllerFixEmailResponseSuccess =
  supportControllerFixEmailResponse201 & {
    headers: Headers
  }
export type supportControllerFixEmailResponse =
  supportControllerFixEmailResponseSuccess

export const getSupportControllerFixEmailUrl = () => {
  return `/api-arvore/support/fix-email`
}

export const supportControllerFixEmail = async (
  fixEmailBodyDto: FixEmailBodyDto,
  options?: RequestInit
): Promise<supportControllerFixEmailResponse> => {
  return customInstance<supportControllerFixEmailResponse>(
    getSupportControllerFixEmailUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(fixEmailBodyDto)
    }
  )
}

/**
 * @summary Dispara email de redefinição de senha
 */
export type supportControllerPasswordResetResponse201 = {
  data: void
  status: 201
}

export type supportControllerPasswordResetResponseSuccess =
  supportControllerPasswordResetResponse201 & {
    headers: Headers
  }
export type supportControllerPasswordResetResponse =
  supportControllerPasswordResetResponseSuccess

export const getSupportControllerPasswordResetUrl = () => {
  return `/api-arvore/support/password-reset`
}

export const supportControllerPasswordReset = async (
  passwordResetBodyDto: PasswordResetBodyDto,
  options?: RequestInit
): Promise<supportControllerPasswordResetResponse> => {
  return customInstance<supportControllerPasswordResetResponse>(
    getSupportControllerPasswordResetUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(passwordResetBodyDto)
    }
  )
}

/**
 * @summary Força sync do user com o sistema identity
 */
export type supportControllerTriggerIdentitySyncResponse201 = {
  data: void
  status: 201
}

export type supportControllerTriggerIdentitySyncResponseSuccess =
  supportControllerTriggerIdentitySyncResponse201 & {
    headers: Headers
  }
export type supportControllerTriggerIdentitySyncResponse =
  supportControllerTriggerIdentitySyncResponseSuccess

export const getSupportControllerTriggerIdentitySyncUrl = () => {
  return `/api-arvore/support/trigger-identity-sync`
}

export const supportControllerTriggerIdentitySync = async (
  triggerIdentitySyncBodyDto: TriggerIdentitySyncBodyDto,
  options?: RequestInit
): Promise<supportControllerTriggerIdentitySyncResponse> => {
  return customInstance<supportControllerTriggerIdentitySyncResponse>(
    getSupportControllerTriggerIdentitySyncUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(triggerIdentitySyncBodyDto)
    }
  )
}

export interface TeachingMaterialMetadataDto {
  readingAgeShared?: number
  readingAgeFluent?: number
  bnccCodes: string[]
  themes: string[]
  category?: string
  sections: string[]
}

/**
 * @nullable
 */
export type TeachingMaterialItemDtoPageCount = number | null

/**
 * @nullable
 */
export type TeachingMaterialItemDtoMetadata = TeachingMaterialMetadataDto | null

/**
 * @nullable
 */
export type TeachingMaterialItemDtoPublishedAt = string | null

export interface TeachingMaterialItemDto {
  id: number
  title: string
  kind: string
  mimeType: string
  sizeBytes: number
  /** @nullable */
  pageCount?: TeachingMaterialItemDtoPageCount
  /** @nullable */
  metadata?: TeachingMaterialItemDtoMetadata
  /** @nullable */
  publishedAt?: TeachingMaterialItemDtoPublishedAt
}

export interface TeachingMaterialsResponseDto {
  items: TeachingMaterialItemDto[]
}

export interface DownloadTeachingMaterialDto {
  /** Quando verdadeiro, registra visualização e abre inline */
  inline?: boolean
}

export interface TeachingMaterialDownloadResponseDto {
  url: string
  expiresInSeconds: number
}

/**
 * @summary Lista os materiais de apoio publicados do livro para o professor
 */
export type teachingMaterialsControllerListResponse200 = {
  data: TeachingMaterialsResponseDto
  status: 200
}

export type teachingMaterialsControllerListResponseSuccess =
  teachingMaterialsControllerListResponse200 & {
    headers: Headers
  }
export type teachingMaterialsControllerListResponse =
  teachingMaterialsControllerListResponseSuccess

export const getTeachingMaterialsControllerListUrl = (slug: string) => {
  return `/api-arvore/books/${slug}/teaching-materials`
}

export const teachingMaterialsControllerList = async (
  slug: string,
  options?: RequestInit
): Promise<teachingMaterialsControllerListResponse> => {
  return customInstance<teachingMaterialsControllerListResponse>(
    getTeachingMaterialsControllerListUrl(slug),
    {
      ...options,
      method: 'GET'
    }
  )
}

/**
 * @summary Gera URL assinada de 300 s do material e registra o evento
 */
export type teachingMaterialsControllerDownloadResponse201 = {
  data: TeachingMaterialDownloadResponseDto
  status: 201
}

export type teachingMaterialsControllerDownloadResponseSuccess =
  teachingMaterialsControllerDownloadResponse201 & {
    headers: Headers
  }
export type teachingMaterialsControllerDownloadResponse =
  teachingMaterialsControllerDownloadResponseSuccess

export const getTeachingMaterialsControllerDownloadUrl = (id: number) => {
  return `/api-arvore/teaching-materials/${id}/download`
}

export const teachingMaterialsControllerDownload = async (
  id: number,
  downloadTeachingMaterialDto: DownloadTeachingMaterialDto,
  options?: RequestInit
): Promise<teachingMaterialsControllerDownloadResponse> => {
  return customInstance<teachingMaterialsControllerDownloadResponse>(
    getTeachingMaterialsControllerDownloadUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(downloadTeachingMaterialDto)
    }
  )
}
